// Generated by scripts/generate_wikdict_pairs.py
export const WIKDICT_PRELOAD_LIMIT = 2500;
export const WIKDICT_EXTRA_CHUNK_SIZE = 2500;
export const WIKDICT_SUPPORTED_LANGUAGE_CODES = ["de", "es", "fr", "it", "ja", "nl", "pt", "ru", "tr", "zh"];
export const WIKDICT_ENGLISH_PAIRS_BY_LANGUAGE = {
  "de": [
    [
      "the",
      "das"
    ],
    [
      "of",
      "von"
    ],
    [
      "and",
      "und"
    ],
    [
      "to",
      "zu"
    ],
    [
      "a",
      "eine"
    ],
    [
      "in",
      "in"
    ],
    [
      "for",
      "für"
    ],
    [
      "on",
      "an"
    ],
    [
      "that",
      "jene"
    ],
    [
      "by",
      "bei"
    ],
    [
      "this",
      "diese"
    ],
    [
      "with",
      "mit"
    ],
    [
      "you",
      "du"
    ],
    [
      "it",
      "er"
    ],
    [
      "be",
      "sein"
    ],
    [
      "from",
      "aus"
    ],
    [
      "at",
      "zu"
    ],
    [
      "as",
      "As"
    ],
    [
      "your",
      "Ihr"
    ],
    [
      "all",
      "all"
    ],
    [
      "have",
      "haben"
    ],
    [
      "an",
      "den"
    ],
    [
      "will",
      "Wim"
    ],
    [
      "home",
      "Heim"
    ],
    [
      "can",
      "Blechdose"
    ],
    [
      "us",
      "mir"
    ],
    [
      "about",
      "etwa"
    ],
    [
      "if",
      "ob"
    ],
    [
      "page",
      "Seite"
    ],
    [
      "my",
      "meine"
    ],
    [
      "search",
      "suchen"
    ],
    [
      "free",
      "frei"
    ],
    [
      "but",
      "aber"
    ],
    [
      "our",
      "unsere"
    ],
    [
      "one",
      "ein"
    ],
    [
      "other",
      "sonstig"
    ],
    [
      "do",
      "machen"
    ],
    [
      "no",
      "nein"
    ],
    [
      "information",
      "Auskunft"
    ],
    [
      "time",
      "Zeit"
    ],
    [
      "they",
      "man"
    ],
    [
      "site",
      "Website"
    ],
    [
      "up",
      "auf"
    ],
    [
      "may",
      "mögen"
    ],
    [
      "what",
      "was"
    ],
    [
      "which",
      "welcher"
    ],
    [
      "their",
      "ihre"
    ],
    [
      "news",
      "Nachrichten"
    ],
    [
      "out",
      "heraus"
    ],
    [
      "use",
      "ausnutzen"
    ],
    [
      "any",
      "irgendwelche"
    ],
    [
      "there",
      "da"
    ],
    [
      "see",
      "sehen"
    ],
    [
      "only",
      "lediglich"
    ],
    [
      "so",
      "so"
    ],
    [
      "his",
      "seine"
    ],
    [
      "when",
      "wenn"
    ],
    [
      "contact",
      "Kontakt"
    ],
    [
      "here",
      "her"
    ],
    [
      "business",
      "Geschäft"
    ],
    [
      "who",
      "das"
    ],
    [
      "now",
      "jetzt"
    ],
    [
      "help",
      "Hilfe"
    ],
    [
      "get",
      "kriegen"
    ],
    [
      "view",
      "Sicht"
    ],
    [
      "online",
      "online"
    ],
    [
      "first",
      "Novum"
    ],
    [
      "me",
      "mir"
    ],
    [
      "s",
      "e"
    ],
    [
      "some",
      "etwas"
    ],
    [
      "click",
      "Klick"
    ],
    [
      "its",
      "sein"
    ],
    [
      "like",
      "wie"
    ],
    [
      "service",
      "Service"
    ],
    [
      "find",
      "Finden"
    ],
    [
      "price",
      "Wert"
    ],
    [
      "date",
      "Verabredung"
    ],
    [
      "back",
      "Fond"
    ],
    [
      "top",
      "Oberteil"
    ],
    [
      "people",
      "Volk"
    ],
    [
      "list",
      "neigen"
    ],
    [
      "name",
      "benennen"
    ],
    [
      "just",
      "einfach"
    ],
    [
      "over",
      "durch"
    ],
    [
      "state",
      "Staat"
    ],
    [
      "year",
      "Jahr"
    ],
    [
      "into",
      "in"
    ],
    [
      "email",
      "Mail"
    ],
    [
      "two",
      "zwo"
    ],
    [
      "world",
      "Erde"
    ],
    [
      "next",
      "nächst"
    ],
    [
      "used",
      "Second-Hand"
    ],
    [
      "go",
      "sein"
    ],
    [
      "work",
      "Werk"
    ],
    [
      "last",
      "letzte"
    ],
    [
      "most",
      "-ster"
    ],
    [
      "music",
      "Musik"
    ],
    [
      "buy",
      "abkaufen"
    ],
    [
      "data",
      "Informationseinheiten"
    ],
    [
      "make",
      "bauen"
    ],
    [
      "them",
      "ihnen"
    ],
    [
      "should",
      "dürfen"
    ],
    [
      "product",
      "Produkt"
    ],
    [
      "system",
      "System"
    ],
    [
      "post",
      "Posten"
    ],
    [
      "her",
      "es"
    ],
    [
      "city",
      "Großstadt"
    ],
    [
      "add",
      "addieren"
    ],
    [
      "policy",
      "Politik"
    ],
    [
      "number",
      "Zahl"
    ],
    [
      "such",
      "derartig"
    ],
    [
      "please",
      "bitte"
    ],
    [
      "available",
      "verfügbar"
    ],
    [
      "support",
      "unterstützen"
    ],
    [
      "message",
      "Botschaft"
    ],
    [
      "after",
      "nach"
    ],
    [
      "best",
      "Beste"
    ],
    [
      "software",
      "Programm"
    ],
    [
      "then",
      "dann"
    ],
    [
      "good",
      "gut"
    ],
    [
      "video",
      "Videokassette"
    ],
    [
      "well",
      "Quelle"
    ],
    [
      "where",
      "wo"
    ],
    [
      "public",
      "öffentlich"
    ],
    [
      "high",
      "hoch"
    ],
    [
      "school",
      "Schule"
    ],
    [
      "each",
      "alle"
    ],
    [
      "she",
      "es"
    ],
    [
      "review",
      "Rezension"
    ],
    [
      "order",
      "Ordnung"
    ],
    [
      "very",
      "wahrlich"
    ],
    [
      "privacy",
      "Privatsphäre"
    ],
    [
      "book",
      "Buch"
    ],
    [
      "company",
      "Gesellschaft"
    ],
    [
      "read",
      "lesen"
    ],
    [
      "group",
      "Gruppe"
    ],
    [
      "sex",
      "Sex haben"
    ],
    [
      "need",
      "brauchen"
    ],
    [
      "user",
      "Benutzer"
    ],
    [
      "de",
      "DGl"
    ],
    [
      "set",
      "Set"
    ],
    [
      "under",
      "als"
    ],
    [
      "general",
      "generell"
    ],
    [
      "research",
      "erforschen"
    ],
    [
      "university",
      "Uni"
    ],
    [
      "january",
      "Jänner"
    ],
    [
      "mail",
      "Post"
    ],
    [
      "full",
      "ganz"
    ],
    [
      "map",
      "abbilden"
    ],
    [
      "program",
      "Sendung"
    ],
    [
      "life",
      "Leben"
    ],
    [
      "know",
      "kennen"
    ],
    [
      "way",
      "Art"
    ],
    [
      "days",
      "tags"
    ],
    [
      "management",
      "Regie"
    ],
    [
      "part",
      "teilen"
    ],
    [
      "great",
      "groß"
    ],
    [
      "united",
      "vereint"
    ],
    [
      "hotel",
      "Gasthof"
    ],
    [
      "real",
      "echt"
    ],
    [
      "item",
      "Gegenstand"
    ],
    [
      "international",
      "zwischenstaatlich"
    ],
    [
      "center",
      "Mitte"
    ],
    [
      "must",
      "Most"
    ],
    [
      "store",
      "Vorrat"
    ],
    [
      "travel",
      "Reise"
    ],
    [
      "report",
      "berichten"
    ],
    [
      "off",
      "aus"
    ],
    [
      "member",
      "Glied"
    ],
    [
      "line",
      "Linie"
    ],
    [
      "before",
      "vor"
    ],
    [
      "send",
      "senden"
    ],
    [
      "right",
      "rechts"
    ],
    [
      "type",
      "Typ"
    ],
    [
      "because",
      "denn"
    ],
    [
      "local",
      "örtlich"
    ],
    [
      "office",
      "Amt"
    ],
    [
      "education",
      "Schulung"
    ],
    [
      "national",
      "Staats-"
    ],
    [
      "car",
      "PKW"
    ],
    [
      "design",
      "Entwurf"
    ],
    [
      "take",
      "nehmen"
    ],
    [
      "internet",
      "Netz"
    ],
    [
      "address",
      "Adresse"
    ],
    [
      "community",
      "Gemeinschaft"
    ],
    [
      "within",
      "in"
    ],
    [
      "area",
      "Gebiet"
    ],
    [
      "want",
      "Mangel"
    ],
    [
      "phone",
      "telefonieren"
    ],
    [
      "shipping",
      "Versandkosten"
    ],
    [
      "subject",
      "Fach"
    ],
    [
      "family",
      "Sippe"
    ],
    [
      "long",
      "lange"
    ],
    [
      "based",
      "basiert"
    ],
    [
      "code",
      "Kodex"
    ],
    [
      "show",
      "Schau"
    ],
    [
      "even",
      "mal"
    ],
    [
      "black",
      "schwarz"
    ],
    [
      "check",
      "Marke"
    ],
    [
      "special",
      "Sonder-"
    ],
    [
      "website",
      "Webangebot"
    ],
    [
      "index",
      "Verzeichnis"
    ],
    [
      "being",
      "Sein"
    ],
    [
      "sign",
      "Zeichen"
    ],
    [
      "file",
      "Datei"
    ],
    [
      "link",
      "Glied"
    ],
    [
      "open",
      "offen"
    ],
    [
      "today",
      "heute"
    ],
    [
      "technology",
      "Technik"
    ],
    [
      "south",
      "Süd"
    ],
    [
      "case",
      "Fall"
    ],
    [
      "project",
      "darstellen"
    ],
    [
      "same",
      "gleich"
    ],
    [
      "version",
      "Ausgabe"
    ],
    [
      "section",
      "Schnitt"
    ],
    [
      "own",
      "haben"
    ],
    [
      "found",
      "gründen"
    ],
    [
      "house",
      "Haus"
    ],
    [
      "related",
      "erzählt"
    ],
    [
      "security",
      "Schutz"
    ],
    [
      "county",
      "Qark"
    ],
    [
      "american",
      "Amerikaner"
    ],
    [
      "game",
      "Wild"
    ],
    [
      "power",
      "Kraft"
    ],
    [
      "while",
      "solange"
    ],
    [
      "care",
      "Pflege"
    ],
    [
      "network",
      "Netzwerk"
    ],
    [
      "down",
      "trinken"
    ],
    [
      "computer",
      "Rechner"
    ],
    [
      "three",
      "Drei"
    ],
    [
      "total",
      "Summe"
    ],
    [
      "place",
      "Platz"
    ],
    [
      "end",
      "Tod"
    ],
    [
      "following",
      "folgend"
    ],
    [
      "download",
      "downloaden"
    ],
    [
      "him",
      "ihn"
    ],
    [
      "per",
      "pro"
    ],
    [
      "access",
      "Zugang"
    ],
    [
      "think",
      "denken"
    ],
    [
      "north",
      "Nord"
    ],
    [
      "current",
      "Strom"
    ],
    [
      "media",
      "Medium"
    ],
    [
      "law",
      "Recht"
    ],
    [
      "control",
      "Regeln"
    ],
    [
      "water",
      "Wasser"
    ],
    [
      "history",
      "Geschichte"
    ],
    [
      "size",
      "Größe"
    ],
    [
      "art",
      "Kunst"
    ],
    [
      "personal",
      "Personal"
    ],
    [
      "since",
      "da"
    ],
    [
      "including",
      "inklusive"
    ],
    [
      "guide",
      "Führer"
    ],
    [
      "shop",
      "Laden"
    ],
    [
      "directory",
      "Ordner"
    ],
    [
      "board",
      "Rat"
    ],
    [
      "location",
      "Lage"
    ],
    [
      "change",
      "umziehen"
    ],
    [
      "white",
      "weiß"
    ],
    [
      "text",
      "SMS"
    ],
    [
      "small",
      "jung"
    ],
    [
      "rate",
      "Rate"
    ],
    [
      "government",
      "Rektion"
    ],
    [
      "during",
      "unter"
    ],
    [
      "return",
      "Bericht"
    ],
    [
      "shopping",
      "Einkäufe"
    ],
    [
      "account",
      "Konto"
    ],
    [
      "level",
      "Ebene"
    ],
    [
      "digital",
      "Finger"
    ],
    [
      "profile",
      "Profil"
    ],
    [
      "form",
      "bilden"
    ],
    [
      "love",
      "lieben"
    ],
    [
      "john",
      "Hans"
    ],
    [
      "main",
      "haupt-"
    ],
    [
      "call",
      "Ruf"
    ],
    [
      "image",
      "Bild"
    ],
    [
      "title",
      "Titel"
    ],
    [
      "description",
      "Deskription"
    ],
    [
      "y",
      "i"
    ],
    [
      "another",
      "andere"
    ],
    [
      "why",
      "nanu"
    ],
    [
      "shall",
      "sollen"
    ],
    [
      "property",
      "Eigenschaft"
    ],
    [
      "class",
      "Klasse"
    ],
    [
      "still",
      "noch"
    ],
    [
      "money",
      "Geld"
    ],
    [
      "quality",
      "Qualität"
    ],
    [
      "content",
      "Inhalt"
    ],
    [
      "country",
      "Land"
    ],
    [
      "private",
      "Gemeiner"
    ],
    [
      "little",
      "klein"
    ],
    [
      "visit",
      "Visite"
    ],
    [
      "save",
      "speichern"
    ],
    [
      "low",
      "niedrig"
    ],
    [
      "reply",
      "Antwort"
    ],
    [
      "customer",
      "Kunde"
    ],
    [
      "december",
      "Julmond"
    ],
    [
      "compare",
      "steigern"
    ],
    [
      "include",
      "mit einbeziehen"
    ],
    [
      "college",
      "Berufskolleg"
    ],
    [
      "value",
      "Wert"
    ],
    [
      "article",
      "Artikel"
    ],
    [
      "man",
      "Herr"
    ],
    [
      "card",
      "krempeln"
    ],
    [
      "provide",
      "versorgen"
    ],
    [
      "food",
      "Speise"
    ],
    [
      "source",
      "Quelle"
    ],
    [
      "author",
      "Autorin"
    ],
    [
      "different",
      "anders"
    ],
    [
      "press",
      "Presse"
    ],
    [
      "learn",
      "lernen"
    ],
    [
      "sale",
      "Auktion"
    ],
    [
      "around",
      "herum"
    ],
    [
      "print",
      "Abzug"
    ],
    [
      "course",
      "Kurs"
    ],
    [
      "job",
      "Job"
    ],
    [
      "process",
      "Verlauf"
    ],
    [
      "room",
      "Raum"
    ],
    [
      "stock",
      "Vorrat"
    ],
    [
      "training",
      "Ausbildung"
    ],
    [
      "too",
      "zu"
    ],
    [
      "credit",
      "Anerkennung"
    ],
    [
      "point",
      "Punkt"
    ],
    [
      "join",
      "anschließen"
    ],
    [
      "science",
      "Wissen"
    ],
    [
      "men",
      "Menschen"
    ],
    [
      "west",
      "Westen"
    ],
    [
      "look",
      "Blick"
    ],
    [
      "english",
      "Englisch"
    ],
    [
      "left",
      "links"
    ],
    [
      "team",
      "Mannschaft"
    ],
    [
      "estate",
      "Gut"
    ],
    [
      "box",
      "Loge"
    ],
    [
      "gay",
      "schwul"
    ],
    [
      "thread",
      "bahnen"
    ],
    [
      "note",
      "Notiz"
    ],
    [
      "live",
      "Live-"
    ],
    [
      "large",
      "weit"
    ],
    [
      "table",
      "Tabelle"
    ],
    [
      "register",
      "Stilebene"
    ],
    [
      "however",
      "allerdings"
    ],
    [
      "june",
      "Brachet"
    ],
    [
      "october",
      "Gilbhart"
    ],
    [
      "november",
      "Nebelung"
    ],
    [
      "market",
      "Markt"
    ],
    [
      "library",
      "Bücherei"
    ],
    [
      "really",
      "echt"
    ],
    [
      "action",
      "Aktion"
    ],
    [
      "start",
      "beginnen"
    ],
    [
      "series",
      "Reihe"
    ],
    [
      "model",
      "Modell"
    ],
    [
      "air",
      "Arie"
    ],
    [
      "industry",
      "Industrie"
    ],
    [
      "plan",
      "planen"
    ],
    [
      "human",
      "menschliches Wesen"
    ],
    [
      "tv",
      "Transe"
    ],
    [
      "yes",
      "ja"
    ],
    [
      "second",
      "Sekunde"
    ],
    [
      "hot",
      "heiß"
    ],
    [
      "cost",
      "Verlust"
    ],
    [
      "movie",
      "Spielfilm"
    ],
    [
      "march",
      "Marsch"
    ],
    [
      "september",
      "Scheiding"
    ],
    [
      "say",
      "sagen"
    ],
    [
      "july",
      "Heuert"
    ],
    [
      "yahoo",
      "Rüpel"
    ],
    [
      "going",
      "Weiterkommen"
    ],
    [
      "medical",
      "ärztlich"
    ],
    [
      "test",
      "prüfen"
    ],
    [
      "friend",
      "Freund"
    ],
    [
      "come",
      "kommen"
    ],
    [
      "server",
      "Diener"
    ],
    [
      "study",
      "Studie"
    ],
    [
      "application",
      "App"
    ],
    [
      "cart",
      "Kart"
    ],
    [
      "staff",
      "Stab"
    ],
    [
      "feedback",
      "Rückkopplung"
    ],
    [
      "again",
      "nochmal"
    ],
    [
      "play",
      "Zug"
    ],
    [
      "april",
      "Ostermond"
    ],
    [
      "never",
      "nimmer"
    ],
    [
      "complete",
      "ganz"
    ],
    [
      "street",
      "Strasse"
    ],
    [
      "comment",
      "kommentieren"
    ],
    [
      "against",
      "mit"
    ],
    [
      "standard",
      "Banner"
    ],
    [
      "tax",
      "belasten"
    ],
    [
      "person",
      "Person"
    ],
    [
      "below",
      "darunter"
    ],
    [
      "mobile",
      "beweglich"
    ],
    [
      "less",
      "weniger"
    ],
    [
      "blog",
      "Internetblog"
    ],
    [
      "party",
      "Partie"
    ],
    [
      "payment",
      "Zahlung"
    ],
    [
      "equipment",
      "Zubehör"
    ],
    [
      "login",
      "Anmeldung"
    ],
    [
      "student",
      "Studentin"
    ],
    [
      "let",
      "lassen"
    ],
    [
      "legal",
      "rechtlich"
    ],
    [
      "above",
      "oben"
    ],
    [
      "recent",
      "neu"
    ],
    [
      "park",
      "Anlage"
    ],
    [
      "act",
      "Akt"
    ],
    [
      "problem",
      "Übung"
    ],
    [
      "red",
      "rot"
    ],
    [
      "give",
      "abgeben"
    ],
    [
      "memory",
      "Speicher"
    ],
    [
      "performance",
      "Leistung"
    ],
    [
      "social",
      "sozial"
    ],
    [
      "august",
      "Ernting"
    ],
    [
      "quote",
      "anbieten"
    ],
    [
      "language",
      "Sprache"
    ],
    [
      "story",
      "Erzählung"
    ],
    [
      "sell",
      "verkaufen"
    ],
    [
      "experience",
      "Erlebnis"
    ],
    [
      "create",
      "schaffen"
    ],
    [
      "key",
      "Taste"
    ],
    [
      "body",
      "Körper"
    ],
    [
      "young",
      "jung"
    ],
    [
      "field",
      "Feld"
    ],
    [
      "few",
      "wenige"
    ],
    [
      "east",
      "Ost"
    ],
    [
      "paper",
      "Papier"
    ],
    [
      "single",
      "einzig"
    ],
    [
      "age",
      "Alter"
    ],
    [
      "club",
      "Keule"
    ],
    [
      "example",
      "Exempel"
    ],
    [
      "password",
      "Kennwort"
    ],
    [
      "something",
      "klein"
    ],
    [
      "road",
      "Weg"
    ],
    [
      "gift",
      "Gabe"
    ],
    [
      "question",
      "Frage"
    ],
    [
      "night",
      "Nacht"
    ],
    [
      "hard",
      "hart"
    ],
    [
      "pay",
      "lohnen"
    ],
    [
      "four",
      "Vier"
    ],
    [
      "poker",
      "Schüreisen"
    ],
    [
      "status",
      "Stand"
    ],
    [
      "browse",
      "äsen"
    ],
    [
      "issue",
      "Nachkomme"
    ],
    [
      "range",
      "Umfang"
    ],
    [
      "building",
      "Bau"
    ],
    [
      "seller",
      "Verkäuferin"
    ],
    [
      "court",
      "Hof"
    ],
    [
      "february",
      "Feber"
    ],
    [
      "always",
      "stets"
    ],
    [
      "result",
      "Resultat"
    ],
    [
      "light",
      "Licht"
    ],
    [
      "write",
      "schreiben"
    ],
    [
      "war",
      "kriegen"
    ],
    [
      "offer",
      "Angebot"
    ],
    [
      "blue",
      "blau"
    ],
    [
      "easy",
      "einfach"
    ],
    [
      "event",
      "Ereignis"
    ],
    [
      "release",
      "freisetzen"
    ],
    [
      "analysis",
      "Analyse"
    ],
    [
      "request",
      "Gesuch"
    ],
    [
      "fax",
      "Faxgerät"
    ],
    [
      "making",
      "Anfertigung"
    ],
    [
      "picture",
      "Bild"
    ],
    [
      "might",
      "Kraft"
    ],
    [
      "professional",
      "Profi"
    ],
    [
      "yet",
      "noch"
    ],
    [
      "major",
      "Dur"
    ],
    [
      "star",
      "Star"
    ],
    [
      "future",
      "Futur"
    ],
    [
      "space",
      "Raum"
    ],
    [
      "committee",
      "Ausschuss"
    ],
    [
      "hand",
      "Hand"
    ],
    [
      "sun",
      "Son."
    ],
    [
      "london",
      "Londoner"
    ],
    [
      "meeting",
      "Zusammenkunft"
    ],
    [
      "become",
      "werden"
    ],
    [
      "interest",
      "Zins"
    ],
    [
      "keep",
      "halten"
    ],
    [
      "enter",
      "betreten"
    ],
    [
      "porn",
      "Porno"
    ],
    [
      "share",
      "Teil"
    ],
    [
      "garden",
      "Garten"
    ],
    [
      "reference",
      "Quelle"
    ],
    [
      "baby",
      "süß"
    ],
    [
      "learning",
      "Kenntnis"
    ],
    [
      "run",
      "laufen"
    ],
    [
      "delivery",
      "Geburt"
    ],
    [
      "net",
      "Netto"
    ],
    [
      "popular",
      "Volk"
    ],
    [
      "term",
      "Begriff"
    ],
    [
      "film",
      "drehen"
    ],
    [
      "put",
      "tun"
    ],
    [
      "journal",
      "Revue"
    ],
    [
      "try",
      "Probe"
    ],
    [
      "welcome",
      "begrüßen"
    ],
    [
      "central",
      "mittig"
    ],
    [
      "president",
      "Vorsitzer"
    ],
    [
      "notice",
      "merken"
    ],
    [
      "god",
      "Gott"
    ],
    [
      "original",
      "originell"
    ],
    [
      "head",
      "Kopf"
    ],
    [
      "radio",
      "Funk"
    ],
    [
      "until",
      "bis an"
    ],
    [
      "cell",
      "Zelle"
    ],
    [
      "color",
      "Fahne"
    ],
    [
      "council",
      "Sitzung"
    ],
    [
      "away",
      "weg"
    ],
    [
      "track",
      "Bahn"
    ],
    [
      "discussion",
      "Erörterung"
    ],
    [
      "once",
      "einmal"
    ],
    [
      "others",
      "Andere"
    ],
    [
      "agreement",
      "Vertrag"
    ],
    [
      "format",
      "Struktur"
    ],
    [
      "least",
      "kleinst"
    ],
    [
      "society",
      "Gemeinschaft"
    ],
    [
      "log",
      "Kurzholz"
    ],
    [
      "safety",
      "Griffsicherung"
    ],
    [
      "sure",
      "sicher"
    ],
    [
      "faq",
      "HGF"
    ],
    [
      "trade",
      "Handel"
    ],
    [
      "edition",
      "Auflage"
    ],
    [
      "marketing",
      "Vertrieb"
    ],
    [
      "tell",
      "sagen"
    ],
    [
      "further",
      "ferner"
    ],
    [
      "association",
      "Assoziation"
    ],
    [
      "able",
      "abel"
    ],
    [
      "fun",
      "Spaß"
    ],
    [
      "already",
      "schon"
    ],
    [
      "green",
      "grün"
    ],
    [
      "close",
      "schließen"
    ],
    [
      "common",
      "gewöhnlich"
    ],
    [
      "drive",
      "treiben"
    ],
    [
      "specific",
      "Spezifik"
    ],
    [
      "several",
      "einige"
    ],
    [
      "gold",
      "gülden"
    ],
    [
      "living",
      "Leben"
    ],
    [
      "collection",
      "Sammlung"
    ],
    [
      "short",
      "kurz"
    ],
    [
      "lot",
      "Los"
    ],
    [
      "ask",
      "bitten"
    ],
    [
      "display",
      "Display"
    ],
    [
      "limited",
      "begrenzt"
    ],
    [
      "powered",
      "betrieben"
    ],
    [
      "director",
      "Regisseur"
    ],
    [
      "daily",
      "jeden Tag"
    ],
    [
      "beach",
      "Sandstrand"
    ],
    [
      "past",
      "Vergangenheit"
    ],
    [
      "natural",
      "natürlich"
    ],
    [
      "five",
      "Fünf"
    ],
    [
      "upon",
      "mit"
    ],
    [
      "period",
      "Periode"
    ],
    [
      "planning",
      "Planen"
    ],
    [
      "official",
      "amtlich"
    ],
    [
      "weather",
      "Wetter"
    ],
    [
      "mar",
      "stören"
    ],
    [
      "land",
      "Land"
    ],
    [
      "average",
      "Mittelwert"
    ],
    [
      "done",
      "gar"
    ],
    [
      "technical",
      "technisch"
    ],
    [
      "window",
      "Luke"
    ],
    [
      "region",
      "Gau"
    ],
    [
      "island",
      "Insel"
    ],
    [
      "record",
      "CD"
    ],
    [
      "direct",
      "befehlen"
    ],
    [
      "conference",
      "Tagung"
    ],
    [
      "environment",
      "Umwelt"
    ],
    [
      "st",
      "St."
    ],
    [
      "district",
      "Kreis"
    ],
    [
      "style",
      "Stil"
    ],
    [
      "front",
      "Front"
    ],
    [
      "statement",
      "Erklärung"
    ],
    [
      "update",
      "aufdatieren"
    ],
    [
      "ever",
      "je"
    ],
    [
      "early",
      "früh"
    ],
    [
      "sound",
      "Klang"
    ],
    [
      "resource",
      "Mittel"
    ],
    [
      "present",
      "anwesend"
    ],
    [
      "either",
      "ebenso"
    ],
    [
      "ago",
      "her"
    ],
    [
      "document",
      "Aktenstück"
    ],
    [
      "word",
      "Wort"
    ],
    [
      "material",
      "Material"
    ],
    [
      "bill",
      "Plakat"
    ],
    [
      "written",
      "schriftlich"
    ],
    [
      "talk",
      "reden"
    ],
    [
      "federal",
      "Bund"
    ],
    [
      "final",
      "End"
    ],
    [
      "adult",
      "erwachsen"
    ],
    [
      "thing",
      "Sache"
    ],
    [
      "via",
      "durch"
    ],
    [
      "cheap",
      "geizig"
    ],
    [
      "nude",
      "bloß"
    ],
    [
      "finance",
      "Finanzen"
    ],
    [
      "true",
      "echt"
    ],
    [
      "minutes",
      "Mitschrift"
    ],
    [
      "else",
      "sonst"
    ],
    [
      "mark",
      "markieren"
    ],
    [
      "third",
      "dritte"
    ],
    [
      "rock",
      "Fels"
    ],
    [
      "reading",
      "Lesung"
    ],
    [
      "bad",
      "böse"
    ],
    [
      "individual",
      "individuell"
    ],
    [
      "plus",
      "positiv"
    ],
    [
      "cover",
      "abdecken"
    ],
    [
      "edit",
      "Änderung"
    ],
    [
      "together",
      "zusammen"
    ],
    [
      "percent",
      "Perzent"
    ],
    [
      "fast",
      "schnell"
    ],
    [
      "function",
      "Funktion"
    ],
    [
      "fact",
      "Fakt"
    ],
    [
      "getting",
      "Erwerb"
    ],
    [
      "global",
      "Kugel"
    ],
    [
      "meet",
      "treffen"
    ],
    [
      "far",
      "entfernt"
    ],
    [
      "economic",
      "Wirtschaft"
    ],
    [
      "player",
      "Spieler"
    ],
    [
      "lyrics",
      "Text"
    ],
    [
      "often",
      "häufig"
    ],
    [
      "submit",
      "fügen"
    ],
    [
      "amount",
      "Menge"
    ],
    [
      "watch",
      "wachen"
    ],
    [
      "feel",
      "fühlen"
    ],
    [
      "though",
      "obwohl"
    ],
    [
      "bank",
      "Sparschwein"
    ],
    [
      "risk",
      "riskieren"
    ],
    [
      "thanks",
      "Dank"
    ],
    [
      "production",
      "Produktion"
    ],
    [
      "commercial",
      "Werbespot"
    ],
    [
      "james",
      "Jakob"
    ],
    [
      "weight",
      "gewichten"
    ],
    [
      "town",
      "Ort"
    ],
    [
      "heart",
      "Herz"
    ],
    [
      "choose",
      "auswählen"
    ],
    [
      "treatment",
      "Umgang"
    ],
    [
      "newsletter",
      "Mitteilungsblatt"
    ],
    [
      "knowledge",
      "Kenntnis"
    ],
    [
      "magazine",
      "Magazin"
    ],
    [
      "error",
      "Irrtum"
    ],
    [
      "camera",
      "Fotoapparat"
    ],
    [
      "girl",
      "Frau"
    ],
    [
      "currently",
      "aktuell"
    ],
    [
      "construction",
      "Bauwerk"
    ],
    [
      "registered",
      "registriert"
    ],
    [
      "clear",
      "klar"
    ],
    [
      "receive",
      "empfangen"
    ],
    [
      "domain",
      "Domäne"
    ],
    [
      "chapter",
      "Sektion"
    ],
    [
      "loan",
      "Kredit"
    ],
    [
      "wide",
      "weit"
    ],
    [
      "beauty",
      "Schönheit"
    ],
    [
      "manager",
      "Direktor"
    ],
    [
      "position",
      "Position"
    ],
    [
      "taken",
      "vergeben"
    ],
    [
      "sort",
      "Art"
    ],
    [
      "half",
      "halb"
    ],
    [
      "step",
      "treten"
    ],
    [
      "engineering",
      "Ingenieurwesen"
    ],
    [
      "simple",
      "simpel"
    ],
    [
      "quick",
      "rasch"
    ],
    [
      "none",
      "niemand"
    ],
    [
      "wireless",
      "Funk"
    ],
    [
      "license",
      "Lizenz"
    ],
    [
      "paul",
      "Paul"
    ],
    [
      "friday",
      "freitags"
    ],
    [
      "lake",
      "See"
    ],
    [
      "whole",
      "Ganze"
    ],
    [
      "annual",
      "alljährlich"
    ],
    [
      "later",
      "später"
    ],
    [
      "basic",
      "elementar"
    ],
    [
      "corporate",
      "Unternehmens-"
    ],
    [
      "google",
      "googlen"
    ],
    [
      "church",
      "Messe"
    ],
    [
      "method",
      "Methode"
    ],
    [
      "purchase",
      "Anschaffung"
    ],
    [
      "active",
      "tätig"
    ],
    [
      "response",
      "Entgegnung"
    ],
    [
      "practice",
      "Praxis"
    ],
    [
      "hardware",
      "Hardware"
    ],
    [
      "figure",
      "Form"
    ],
    [
      "fire",
      "feuern"
    ],
    [
      "holiday",
      "Ferien"
    ],
    [
      "chat",
      "klönen"
    ],
    [
      "enough",
      "genügend"
    ],
    [
      "along",
      "längs"
    ],
    [
      "among",
      "zwischen"
    ],
    [
      "death",
      "Tod"
    ],
    [
      "writing",
      "Schrift"
    ],
    [
      "speed",
      "Pep"
    ],
    [
      "loss",
      "Verlust"
    ],
    [
      "face",
      "Gesicht"
    ],
    [
      "brand",
      "Marke"
    ],
    [
      "discount",
      "abtun"
    ],
    [
      "remember",
      "grüßen"
    ],
    [
      "oil",
      "Öl"
    ],
    [
      "bit",
      "Bit"
    ],
    [
      "yellow",
      "Gelb"
    ],
    [
      "increase",
      "Anstieg"
    ],
    [
      "advertise",
      "werben"
    ],
    [
      "kingdom",
      "Reich"
    ],
    [
      "base",
      "Basis"
    ],
    [
      "near",
      "nah"
    ],
    [
      "environmental",
      "Umwelt-"
    ],
    [
      "stuff",
      "Kram"
    ],
    [
      "french",
      "französisch"
    ],
    [
      "storage",
      "Lager"
    ],
    [
      "oh",
      "oh"
    ],
    [
      "entry",
      "Eintrag"
    ],
    [
      "stay",
      "Strebe"
    ],
    [
      "nature",
      "Art"
    ],
    [
      "availability",
      "Vorhandensein"
    ],
    [
      "summary",
      "standrechtlich"
    ],
    [
      "turn",
      "drehen"
    ],
    [
      "mean",
      "gemein"
    ],
    [
      "growth",
      "Wuchs"
    ],
    [
      "agency",
      "Agentur"
    ],
    [
      "king",
      "Dame"
    ],
    [
      "monday",
      "am Montag"
    ],
    [
      "european",
      "Europäer"
    ],
    [
      "activity",
      "Aktivität"
    ],
    [
      "copy",
      "Kopie"
    ],
    [
      "although",
      "obwohl"
    ],
    [
      "drug",
      "Droge"
    ],
    [
      "western",
      "West-"
    ],
    [
      "force",
      "Kraft"
    ],
    [
      "cash",
      "Bares"
    ],
    [
      "employment",
      "Arbeit"
    ],
    [
      "overall",
      "Latzhose"
    ],
    [
      "bay",
      "Golf"
    ],
    [
      "river",
      "Fluss"
    ],
    [
      "commission",
      "Begehung"
    ],
    [
      "ad",
      "nach Christo"
    ],
    [
      "package",
      "Paket"
    ],
    [
      "engine",
      "Motor"
    ],
    [
      "port",
      "Port"
    ],
    [
      "stop",
      "stoppen"
    ],
    [
      "administration",
      "Verabreichung"
    ],
    [
      "bar",
      "Bar"
    ],
    [
      "institute",
      "einführen"
    ],
    [
      "double",
      "doubeln"
    ],
    [
      "dog",
      "verfolgen"
    ],
    [
      "build",
      "Bau"
    ],
    [
      "screen",
      "Bildschirm"
    ],
    [
      "exchange",
      "Börse"
    ],
    [
      "continue",
      "weitermachen"
    ],
    [
      "across",
      "über"
    ],
    [
      "season",
      "Saison"
    ],
    [
      "apply",
      "gelten"
    ],
    [
      "someone",
      "einer"
    ],
    [
      "anything",
      "irgendetwas"
    ],
    [
      "printer",
      "Drucker"
    ],
    [
      "condition",
      "Bedingung"
    ],
    [
      "effective",
      "effektiv"
    ],
    [
      "believe",
      "glauben"
    ],
    [
      "organization",
      "Ordnung"
    ],
    [
      "effect",
      "Effekt"
    ],
    [
      "mind",
      "Lust"
    ],
    [
      "sunday",
      "Sonntag"
    ],
    [
      "selection",
      "Auswahl"
    ],
    [
      "casino",
      "Spielbank"
    ],
    [
      "lost",
      "verirrt"
    ],
    [
      "tour",
      "Tour"
    ],
    [
      "menu",
      "Speisekarte"
    ],
    [
      "volume",
      "Volumen"
    ],
    [
      "cross",
      "kreuzen"
    ],
    [
      "anyone",
      "wer"
    ],
    [
      "mortgage",
      "Grundpfand"
    ],
    [
      "hope",
      "Hoffnung"
    ],
    [
      "silver",
      "Silber"
    ],
    [
      "corporation",
      "Korporation"
    ],
    [
      "inside",
      "in"
    ],
    [
      "mature",
      "gereift"
    ],
    [
      "role",
      "Rolle"
    ],
    [
      "rather",
      "eher"
    ],
    [
      "addition",
      "Addition"
    ],
    [
      "supply",
      "liefern"
    ],
    [
      "nothing",
      "gar nichts"
    ],
    [
      "certain",
      "gewiss"
    ],
    [
      "running",
      "Laufen"
    ],
    [
      "necessary",
      "geboten"
    ],
    [
      "union",
      "Vereinigung"
    ],
    [
      "mon",
      "Mon."
    ],
    [
      "particular",
      "genau"
    ],
    [
      "fine",
      "fein"
    ],
    [
      "robert",
      "Rupprecht"
    ],
    [
      "hour",
      "Uhr"
    ],
    [
      "gas",
      "Gas"
    ],
    [
      "six",
      "sechs"
    ],
    [
      "bush",
      "Busch"
    ],
    [
      "advice",
      "Ratschlag"
    ],
    [
      "career",
      "Laufbahn"
    ],
    [
      "military",
      "Krieg"
    ],
    [
      "decision",
      "Beschluß"
    ],
    [
      "leave",
      "lassen"
    ],
    [
      "british",
      "Briten"
    ],
    [
      "woman",
      "Weib"
    ],
    [
      "bid",
      "melden"
    ],
    [
      "kind",
      "lieb"
    ],
    [
      "middle",
      "Mitte"
    ],
    [
      "move",
      "Zug"
    ],
    [
      "cable",
      "Tau"
    ],
    [
      "taking",
      "Nahme"
    ],
    [
      "division",
      "Division"
    ],
    [
      "coming",
      "Aufkommen"
    ],
    [
      "tuesday",
      "Dienstag"
    ],
    [
      "object",
      "Gegenstand"
    ],
    [
      "lesbian",
      "Lesbierin"
    ],
    [
      "appropriate",
      "angebracht"
    ],
    [
      "machine",
      "bearbeiten"
    ],
    [
      "length",
      "Längenmaß"
    ],
    [
      "actually",
      "wirklich"
    ],
    [
      "nice",
      "lieb"
    ],
    [
      "score",
      "Stiege"
    ],
    [
      "client",
      "Klient"
    ],
    [
      "ok",
      "OK"
    ],
    [
      "capital",
      "Haupt-"
    ],
    [
      "follow",
      "folgen"
    ],
    [
      "sample",
      "Probe"
    ],
    [
      "investment",
      "Anlage"
    ],
    [
      "saturday",
      "Sabbat"
    ],
    [
      "band",
      "Band"
    ],
    [
      "flash",
      "Nu"
    ],
    [
      "lead",
      "führen"
    ],
    [
      "george",
      "Jürgen"
    ],
    [
      "choice",
      "Auswahl"
    ],
    [
      "registration",
      "Anmeldung"
    ],
    [
      "fri",
      "Fre."
    ],
    [
      "thursday",
      "Donnerstag"
    ],
    [
      "consumer",
      "Konsumentin"
    ],
    [
      "hi",
      "'n Tag"
    ],
    [
      "airport",
      "Flugplatz"
    ],
    [
      "foreign",
      "ausländisch"
    ],
    [
      "artist",
      "Künstlerin"
    ],
    [
      "outside",
      "draußen"
    ],
    [
      "furniture",
      "Beschlag"
    ],
    [
      "channel",
      "Kanal"
    ],
    [
      "letter",
      "Brief"
    ],
    [
      "mode",
      "Art"
    ],
    [
      "wednesday",
      "Wodanstag"
    ],
    [
      "structure",
      "Struktur"
    ],
    [
      "fund",
      "Kapital"
    ],
    [
      "summer",
      "Sommerzeit"
    ],
    [
      "allow",
      "erlauben"
    ],
    [
      "degree",
      "Grad"
    ],
    [
      "contract",
      "kontrahieren"
    ],
    [
      "button",
      "Knopf"
    ],
    [
      "wed",
      "Mit."
    ],
    [
      "male",
      "Männchen"
    ],
    [
      "matter",
      "Stoff"
    ],
    [
      "custom",
      "Sitte"
    ],
    [
      "virginia",
      "Virginien"
    ],
    [
      "almost",
      "fast"
    ],
    [
      "multiple",
      "mehrfach"
    ],
    [
      "asian",
      "Asiat"
    ],
    [
      "distribution",
      "Aufteilung"
    ],
    [
      "editor",
      "Editor"
    ],
    [
      "inn",
      "Wirtshaus"
    ],
    [
      "industrial",
      "Industrie"
    ],
    [
      "cause",
      "Grund"
    ],
    [
      "potential",
      "möglich"
    ],
    [
      "song",
      "Gesang"
    ],
    [
      "focus",
      "Fokus"
    ],
    [
      "late",
      "selig"
    ],
    [
      "fall",
      "fallen"
    ],
    [
      "idea",
      "Ahnung"
    ],
    [
      "female",
      "Weib"
    ],
    [
      "responsible",
      "verantwortlich"
    ],
    [
      "win",
      "Erfolg"
    ],
    [
      "associated",
      "zugehörig"
    ],
    [
      "primary",
      "Handschwinge"
    ],
    [
      "reason",
      "Grund"
    ],
    [
      "tool",
      "Werkzeug"
    ],
    [
      "spring",
      "Lenz"
    ],
    [
      "foundation",
      "Stiftung"
    ],
    [
      "answer",
      "Antwort"
    ],
    [
      "voice",
      "Stimme"
    ],
    [
      "schedule",
      "Termin"
    ],
    [
      "communication",
      "Kommunikation"
    ],
    [
      "purpose",
      "Ziel"
    ],
    [
      "feature",
      "Merkmal"
    ],
    [
      "bed",
      "Bett"
    ],
    [
      "everyone",
      "alle"
    ],
    [
      "independent",
      "unabhängig"
    ],
    [
      "approach",
      "Anflug"
    ],
    [
      "brown",
      "bräunen"
    ],
    [
      "physical",
      "körperlich"
    ],
    [
      "hill",
      "Anstieg"
    ],
    [
      "medicine",
      "Arznei"
    ],
    [
      "deal",
      "austeilen"
    ],
    [
      "hold",
      "gelten"
    ],
    [
      "chicago",
      "Chikago"
    ],
    [
      "happy",
      "glücklich"
    ],
    [
      "tue",
      "Die."
    ],
    [
      "smith",
      "Schmid"
    ],
    [
      "wanted",
      "erwünscht"
    ],
    [
      "thank",
      "bedanken"
    ],
    [
      "safe",
      "sicher"
    ],
    [
      "unique",
      "einzig"
    ],
    [
      "survey",
      "abschätzen"
    ],
    [
      "prior",
      "vorherig"
    ],
    [
      "telephone",
      "anrufen"
    ],
    [
      "sport",
      "tragen"
    ],
    [
      "ready",
      "gar"
    ],
    [
      "feed",
      "füttern"
    ],
    [
      "animal",
      "Tier"
    ],
    [
      "population",
      "Population"
    ],
    [
      "pa",
      "Opa"
    ],
    [
      "regular",
      "normal"
    ],
    [
      "secure",
      "sicher"
    ],
    [
      "navigation",
      "Schifffahrt"
    ],
    [
      "therefore",
      "also"
    ],
    [
      "ass",
      "Po"
    ],
    [
      "evidence",
      "Indiz"
    ],
    [
      "station",
      "Bahnhof"
    ],
    [
      "christian",
      "Christ"
    ],
    [
      "round",
      "rund"
    ],
    [
      "understand",
      "glauben"
    ],
    [
      "option",
      "Wahl"
    ],
    [
      "master",
      "Meister"
    ],
    [
      "valley",
      "Senke"
    ],
    [
      "recently",
      "vor kurzem"
    ],
    [
      "probably",
      "glaublich"
    ],
    [
      "thu",
      "Don."
    ],
    [
      "sea",
      "See"
    ],
    [
      "blood",
      "Blut"
    ],
    [
      "cut",
      "schneiden"
    ],
    [
      "connection",
      "Anschluss"
    ],
    [
      "publisher",
      "Verlag"
    ],
    [
      "hall",
      "Saal"
    ],
    [
      "earth",
      "Erde"
    ],
    [
      "impact",
      "Stoß"
    ],
    [
      "transfer",
      "versetzen"
    ],
    [
      "introduction",
      "Einleitung"
    ],
    [
      "strong",
      "stark"
    ],
    [
      "wedding",
      "Trauung"
    ],
    [
      "hospital",
      "Spital"
    ],
    [
      "ground",
      "Erde"
    ],
    [
      "overview",
      "Übersicht"
    ],
    [
      "ship",
      "versenden"
    ],
    [
      "accommodation",
      "Anpassung"
    ],
    [
      "disease",
      "Seuche"
    ],
    [
      "excellent",
      "großartig"
    ],
    [
      "perfect",
      "vollenden"
    ],
    [
      "hair",
      "Haar"
    ],
    [
      "opportunity",
      "Chance"
    ],
    [
      "kit",
      "Satz"
    ],
    [
      "basis",
      "Basis"
    ],
    [
      "command",
      "Befehl"
    ],
    [
      "express",
      "äußern"
    ],
    [
      "anal",
      "eigen"
    ],
    [
      "award",
      "Preis"
    ],
    [
      "distance",
      "Ferne"
    ],
    [
      "tree",
      "Gras"
    ],
    [
      "peter",
      "Peter"
    ],
    [
      "assessment",
      "Schätzung"
    ],
    [
      "ensure",
      "sicherstellen"
    ],
    [
      "thus",
      "also"
    ],
    [
      "wall",
      "Mauer"
    ],
    [
      "involved",
      "betroffen"
    ],
    [
      "especially",
      "extra"
    ],
    [
      "interface",
      "Grenzfläche"
    ],
    [
      "pussy",
      "Möse"
    ],
    [
      "budget",
      "Etat"
    ],
    [
      "maximum",
      "höchstmöglich"
    ],
    [
      "ma",
      "Mutter"
    ],
    [
      "operation",
      "Operation"
    ],
    [
      "existing",
      "existierend"
    ],
    [
      "quite",
      "recht"
    ],
    [
      "selected",
      "selektiert"
    ],
    [
      "boy",
      "Junge"
    ],
    [
      "beautiful",
      "toll"
    ],
    [
      "warning",
      "Achtung"
    ],
    [
      "wine",
      "weinrot"
    ],
    [
      "horse",
      "Pferd"
    ],
    [
      "vote",
      "Votum"
    ],
    [
      "forward",
      "weiter"
    ],
    [
      "significant",
      "bedeutend"
    ],
    [
      "owner",
      "Inhaber"
    ],
    [
      "retail",
      "Kleinverkauf"
    ],
    [
      "useful",
      "anwendbar"
    ],
    [
      "directly",
      "gerade"
    ],
    [
      "manufacturer",
      "Erzeuger"
    ],
    [
      "est",
      "st"
    ],
    [
      "son",
      "Sohn"
    ],
    [
      "rule",
      "Regel"
    ],
    [
      "bring",
      "holen"
    ],
    [
      "mother",
      "Mama"
    ],
    [
      "authority",
      "Behörde"
    ],
    [
      "traffic",
      "Verkehr"
    ],
    [
      "input",
      "Input"
    ],
    [
      "agent",
      "Agens"
    ],
    [
      "bin",
      "Mülltonne"
    ],
    [
      "teaching",
      "Lehren"
    ],
    [
      "door",
      "Türe"
    ],
    [
      "grand",
      "groß"
    ],
    [
      "trial",
      "Probe"
    ],
    [
      "charge",
      "laden"
    ],
    [
      "instead",
      "anstatt"
    ],
    [
      "canadian",
      "Kanadierin"
    ],
    [
      "cool",
      "cool"
    ],
    [
      "normal",
      "normal"
    ],
    [
      "enterprise",
      "Vorhaben"
    ],
    [
      "entire",
      "gesamt"
    ],
    [
      "educational",
      "edukativ"
    ],
    [
      "leading",
      "führend"
    ],
    [
      "metal",
      "Metall"
    ],
    [
      "positive",
      "Positiv"
    ],
    [
      "fitness",
      "Tauglichkeit"
    ],
    [
      "chinese",
      "Chinesisch"
    ],
    [
      "opinion",
      "Ansicht"
    ],
    [
      "football",
      "Fussball"
    ],
    [
      "abstract",
      "Auszug"
    ],
    [
      "output",
      "Ausgang"
    ],
    [
      "funds",
      "Geldmittel"
    ],
    [
      "likely",
      "glaubhaft"
    ],
    [
      "alternative",
      "alternativ"
    ],
    [
      "responsibility",
      "Pflicht"
    ],
    [
      "resolution",
      "Auflösung"
    ],
    [
      "publication",
      "Publikation"
    ],
    [
      "pass",
      "gehen"
    ],
    [
      "trust",
      "Hoffnung"
    ],
    [
      "van",
      "Transporter"
    ],
    [
      "session",
      "Session"
    ],
    [
      "photography",
      "Fotografie"
    ],
    [
      "republic",
      "Republik"
    ],
    [
      "vacation",
      "Ferien"
    ],
    [
      "century",
      "Zenturie"
    ],
    [
      "academic",
      "intellektuell"
    ],
    [
      "skin",
      "Haut"
    ],
    [
      "indian",
      "Inderin"
    ],
    [
      "ring",
      "läuten"
    ],
    [
      "grade",
      "Grad"
    ],
    [
      "dating",
      "Datierung"
    ],
    [
      "pacific",
      "still"
    ],
    [
      "mountain",
      "Berg"
    ],
    [
      "pop",
      "einwerfen"
    ],
    [
      "filter",
      "filtrieren"
    ],
    [
      "vehicle",
      "Vehikel"
    ],
    [
      "consider",
      "in Betracht ziehen"
    ],
    [
      "northern",
      "Nord"
    ],
    [
      "behind",
      "hinter"
    ],
    [
      "panel",
      "Blech"
    ],
    [
      "floor",
      "Boden"
    ],
    [
      "german",
      "Deutsche"
    ],
    [
      "match",
      "ebenbürtig"
    ],
    [
      "default",
      "Säumnis"
    ],
    [
      "require",
      "brauchen"
    ],
    [
      "outdoor",
      "Freiluft-"
    ],
    [
      "deep",
      "tief"
    ],
    [
      "morning",
      "Vormittag"
    ],
    [
      "otherwise",
      "sonst"
    ],
    [
      "rest",
      "Ruhe"
    ],
    [
      "protein",
      "Eiweiß"
    ],
    [
      "plant",
      "Gewächs"
    ],
    [
      "hit",
      "Treffer"
    ],
    [
      "transportation",
      "Beförderung"
    ],
    [
      "pool",
      "Becken"
    ],
    [
      "partner",
      "Partner"
    ],
    [
      "disclaimer",
      "Widerruf"
    ],
    [
      "faculty",
      "Begabung"
    ],
    [
      "fish",
      "Fischzug"
    ],
    [
      "membership",
      "Zugehörigkeit"
    ],
    [
      "mission",
      "Mission"
    ],
    [
      "eye",
      "Auge"
    ],
    [
      "string",
      "Saite"
    ],
    [
      "sense",
      "Sinn"
    ],
    [
      "pack",
      "packen"
    ],
    [
      "stage",
      "Bühne"
    ],
    [
      "internal",
      "inner"
    ],
    [
      "goods",
      "Ware"
    ],
    [
      "unless",
      "wenn nicht"
    ],
    [
      "richard",
      "Rikard"
    ],
    [
      "detailed",
      "umfassend"
    ],
    [
      "japanese",
      "Japanerin"
    ],
    [
      "race",
      "Rasse"
    ],
    [
      "approved",
      "bewilligt"
    ],
    [
      "background",
      "Hintergrund"
    ],
    [
      "target",
      "Ziel"
    ],
    [
      "except",
      "ausklammern"
    ],
    [
      "character",
      "Zeichen"
    ],
    [
      "maintenance",
      "Wartung"
    ],
    [
      "maybe",
      "womöglich"
    ],
    [
      "moving",
      "rührend"
    ],
    [
      "pretty",
      "schön"
    ],
    [
      "southern",
      "Süd"
    ],
    [
      "yourself",
      "dich"
    ],
    [
      "winter",
      "Winterzeit"
    ],
    [
      "rape",
      "schänden"
    ],
    [
      "battery",
      "Akku"
    ],
    [
      "youth",
      "Jugend"
    ],
    [
      "incest",
      "Blutschande"
    ],
    [
      "debt",
      "Schulden"
    ],
    [
      "television",
      "Glotze"
    ],
    [
      "core",
      "Kern"
    ],
    [
      "break",
      "brechen"
    ],
    [
      "wood",
      "Holz"
    ],
    [
      "itself",
      "von allein"
    ],
    [
      "studio",
      "Studio"
    ],
    [
      "reader",
      "Leser"
    ],
    [
      "virtual",
      "fast"
    ],
    [
      "device",
      "Emblem"
    ],
    [
      "rent",
      "Riss"
    ],
    [
      "remote",
      "abgelegen"
    ],
    [
      "dark",
      "dunkel"
    ],
    [
      "programming",
      "Programmieren"
    ],
    [
      "external",
      "außen-"
    ],
    [
      "regarding",
      "mit Bezug auf"
    ],
    [
      "enjoy",
      "erfreuen"
    ],
    [
      "remove",
      "umziehen"
    ],
    [
      "aid",
      "Hilfe"
    ],
    [
      "surface",
      "Fläche"
    ],
    [
      "minimum",
      "Mindestmaß"
    ],
    [
      "host",
      "Wirt"
    ],
    [
      "variety",
      "Varietät"
    ],
    [
      "manual",
      "Handbuch"
    ],
    [
      "block",
      "Block"
    ],
    [
      "repair",
      "begeben"
    ],
    [
      "fair",
      "Messe"
    ],
    [
      "civil",
      "bürgerlich"
    ],
    [
      "understanding",
      "Einigung"
    ],
    [
      "fixed",
      "fixiert"
    ],
    [
      "wrong",
      "falsch"
    ],
    [
      "beginning",
      "Beginn"
    ],
    [
      "finally",
      "endlich"
    ],
    [
      "desktop",
      "Desktop-Computer"
    ],
    [
      "capacity",
      "Befugnis"
    ],
    [
      "jersey",
      "Trikot"
    ],
    [
      "un",
      "UNO"
    ],
    [
      "fat",
      "fett"
    ],
    [
      "father",
      "Pater"
    ],
    [
      "electric",
      "elektrisch"
    ],
    [
      "saw",
      "Spruch"
    ],
    [
      "officer",
      "Offizier"
    ],
    [
      "driver",
      "Treiber"
    ],
    [
      "dead",
      "aus"
    ],
    [
      "respect",
      "Achtung"
    ],
    [
      "unknown",
      "Unbekannter"
    ],
    [
      "restaurant",
      "Gaststätte"
    ],
    [
      "trip",
      "Trip"
    ],
    [
      "worth",
      "Wert"
    ],
    [
      "poor",
      "arm"
    ],
    [
      "teacher",
      "Lehrerin"
    ],
    [
      "relationship",
      "Verwandtschaft"
    ],
    [
      "farm",
      "Farm"
    ],
    [
      "fucking",
      "Scheiß"
    ],
    [
      "georgia",
      "Grusien"
    ],
    [
      "peace",
      "Friede"
    ],
    [
      "traditional",
      "altmodisch"
    ],
    [
      "campus",
      "Unigelände"
    ],
    [
      "tom",
      "Männchen"
    ],
    [
      "creative",
      "kreativ"
    ],
    [
      "coast",
      "segeln"
    ],
    [
      "benefit",
      "Nutzen"
    ],
    [
      "lord",
      "Herr"
    ],
    [
      "grant",
      "gewähren"
    ],
    [
      "sub",
      "Atom-U-Boot"
    ],
    [
      "agree",
      "annehmen"
    ],
    [
      "fiction",
      "Erfindung"
    ],
    [
      "sometimes",
      "ab und zu"
    ],
    [
      "themselves",
      "sich"
    ],
    [
      "fan",
      "Lüfter"
    ],
    [
      "transport",
      "Spedition"
    ],
    [
      "interesting",
      "reizvoll"
    ],
    [
      "wife",
      "Frau"
    ],
    [
      "evaluation",
      "Auswertung"
    ],
    [
      "accepted",
      "anerkannt"
    ],
    [
      "former",
      "alt"
    ],
    [
      "ten",
      "zehn"
    ],
    [
      "zone",
      "Gebiet"
    ],
    [
      "complex",
      "komplex"
    ],
    [
      "th",
      "te"
    ],
    [
      "cat",
      "Felinae"
    ],
    [
      "die",
      "umkommen"
    ],
    [
      "jack",
      "Buchse"
    ],
    [
      "flat",
      "flach"
    ],
    [
      "flow",
      "Flut"
    ],
    [
      "parent",
      "Elter"
    ],
    [
      "spanish",
      "Spanisch"
    ],
    [
      "setting",
      "Kontext"
    ],
    [
      "scale",
      "Skala"
    ],
    [
      "stand",
      "stehen"
    ],
    [
      "economy",
      "Ökonomie"
    ],
    [
      "critical",
      "kritisch"
    ],
    [
      "frame",
      "Rahmen"
    ],
    [
      "musical",
      "Musik"
    ],
    [
      "definition",
      "Definierung"
    ],
    [
      "secretary",
      "Sekretär"
    ],
    [
      "networking",
      "Networking"
    ],
    [
      "path",
      "Weg"
    ],
    [
      "australian",
      "Australierin"
    ],
    [
      "employee",
      "Angestellte"
    ],
    [
      "chief",
      "Boss"
    ],
    [
      "bottom",
      "Boden"
    ],
    [
      "detail",
      "Einzelheit"
    ],
    [
      "pet",
      "Liebling"
    ],
    [
      "begin",
      "anheben"
    ],
    [
      "royal",
      "Royalsegel"
    ],
    [
      "clean",
      "sauber"
    ],
    [
      "switch",
      "Weiche"
    ],
    [
      "russian",
      "Russisch"
    ],
    [
      "african",
      "Afrikaner"
    ],
    [
      "guy",
      "Typ"
    ],
    [
      "justice",
      "Justiz"
    ],
    [
      "connect",
      "anschließen"
    ],
    [
      "cup",
      "Pokal"
    ],
    [
      "weekly",
      "Wochenblatt"
    ],
    [
      "installation",
      "Anlage"
    ],
    [
      "demand",
      "Bedarf"
    ],
    [
      "square",
      "Quadrat"
    ],
    [
      "attention",
      "Achtung"
    ],
    [
      "advance",
      "erheben"
    ],
    [
      "skip",
      "hüpfen"
    ],
    [
      "diet",
      "Tag"
    ],
    [
      "army",
      "Armee"
    ],
    [
      "auction",
      "Auktion"
    ],
    [
      "gear",
      "Gang"
    ],
    [
      "difference",
      "Differenz"
    ],
    [
      "correct",
      "einwandfrei"
    ],
    [
      "nation",
      "Nation"
    ],
    [
      "selling",
      "Verkäufe"
    ],
    [
      "piece",
      "Figur"
    ],
    [
      "sheet",
      "Lage"
    ],
    [
      "firm",
      "fest"
    ],
    [
      "seven",
      "Sieben"
    ],
    [
      "species",
      "Spezies"
    ],
    [
      "jump",
      "hüpfen"
    ],
    [
      "resort",
      "Ausweg"
    ],
    [
      "facility",
      "Anlage"
    ],
    [
      "random",
      "Durchschnitts-"
    ],
    [
      "certificate",
      "Zeugnis"
    ],
    [
      "minister",
      "sorgen"
    ],
    [
      "motion",
      "Antrag"
    ],
    [
      "fashion",
      "Stil"
    ],
    [
      "monitor",
      "Tutor"
    ],
    [
      "forest",
      "Hain"
    ],
    [
      "whose",
      "deren"
    ],
    [
      "couple",
      "einige"
    ],
    [
      "chance",
      "Los"
    ],
    [
      "vision",
      "Vision"
    ],
    [
      "ball",
      "Kugel"
    ],
    [
      "ending",
      "Ende"
    ],
    [
      "listen",
      "hören"
    ],
    [
      "discuss",
      "erörtern"
    ],
    [
      "accept",
      "abnehmen"
    ],
    [
      "naked",
      "nackt"
    ],
    [
      "goal",
      "Tor"
    ],
    [
      "wind",
      "blasen"
    ],
    [
      "situation",
      "Lage"
    ],
    [
      "highly",
      "sehr"
    ],
    [
      "appear",
      "erscheinen"
    ],
    [
      "emergency",
      "Notfall"
    ],
    [
      "developing",
      "entwickelnd"
    ],
    [
      "currency",
      "Valuta"
    ],
    [
      "leather",
      "Leder-"
    ],
    [
      "determine",
      "festlegen"
    ],
    [
      "temperature",
      "Fieber"
    ],
    [
      "palm",
      "Handteller"
    ],
    [
      "patient",
      "Kranke"
    ],
    [
      "actual",
      "aktuell"
    ],
    [
      "historical",
      "geschichtlich"
    ],
    [
      "stone",
      "Stein"
    ],
    [
      "commerce",
      "Kommerz"
    ],
    [
      "perhaps",
      "wohl"
    ],
    [
      "difficult",
      "schwierig"
    ],
    [
      "satellite",
      "Begleiter"
    ],
    [
      "fit",
      "heiß"
    ],
    [
      "village",
      "Kirchdorf"
    ],
    [
      "amateur",
      "Laiin"
    ],
    [
      "ex",
      "Ix"
    ],
    [
      "xbox",
      "Xbox"
    ],
    [
      "coffee",
      "Kaffee"
    ],
    [
      "cum",
      "Sperma"
    ],
    [
      "buyer",
      "Käuferin"
    ],
    [
      "cultural",
      "Kultur"
    ],
    [
      "oral",
      "mündlich"
    ],
    [
      "ford",
      "Fjord"
    ],
    [
      "poster",
      "Plakat"
    ],
    [
      "edge",
      "Rand"
    ],
    [
      "functional",
      "funktional"
    ],
    [
      "root",
      "Wurzel"
    ],
    [
      "closed",
      "zu"
    ],
    [
      "ice",
      "einfrieren"
    ],
    [
      "pink",
      "Rosa"
    ],
    [
      "balance",
      "Rest"
    ],
    [
      "graduate",
      "graduieren"
    ],
    [
      "shot",
      "Schuss"
    ],
    [
      "architecture",
      "Baustil"
    ],
    [
      "initial",
      "Initiale"
    ],
    [
      "label",
      "Etikette"
    ],
    [
      "thinking",
      "Ansicht"
    ],
    [
      "canon",
      "Kanon"
    ],
    [
      "league",
      "Bund"
    ],
    [
      "waste",
      "Verfall"
    ],
    [
      "minute",
      "Moment"
    ],
    [
      "bus",
      "Omnibus"
    ],
    [
      "provider",
      "Versorger"
    ],
    [
      "optional",
      "wahlfrei"
    ],
    [
      "dictionary",
      "Diktionär"
    ],
    [
      "cold",
      "kalt"
    ],
    [
      "manufacturing",
      "Produktion"
    ],
    [
      "chair",
      "Vorsitz"
    ],
    [
      "fishing",
      "Fischfang"
    ],
    [
      "effort",
      "Aufwand"
    ],
    [
      "bag",
      "Tasche"
    ],
    [
      "fantasy",
      "Fantastik"
    ],
    [
      "motor",
      "Antrieb"
    ],
    [
      "professor",
      "Bekenner"
    ],
    [
      "context",
      "Kontext"
    ],
    [
      "shirt",
      "Oberhemd"
    ],
    [
      "generally",
      "allgemein"
    ],
    [
      "continued",
      "fortgeführt"
    ],
    [
      "foot",
      "Fuß"
    ],
    [
      "mass",
      "Messe"
    ],
    [
      "crime",
      "Kriminalität"
    ],
    [
      "count",
      "zählen"
    ],
    [
      "breast",
      "Brust"
    ],
    [
      "quickly",
      "rasch"
    ],
    [
      "religion",
      "Glaube"
    ],
    [
      "claim",
      "Anspruch"
    ],
    [
      "driving",
      "Lenkung"
    ],
    [
      "permission",
      "Gestattung"
    ],
    [
      "surgery",
      "Ordinationsraum"
    ],
    [
      "patch",
      "Lappen"
    ],
    [
      "heat",
      "Hitze"
    ],
    [
      "generation",
      "Geschlecht"
    ],
    [
      "miss",
      "verpassen"
    ],
    [
      "doctor",
      "Doktorin"
    ],
    [
      "task",
      "Pflicht"
    ],
    [
      "reduce",
      "reduzieren"
    ],
    [
      "himself",
      "er selbst"
    ],
    [
      "enable",
      "anordnen"
    ],
    [
      "exercise",
      "üben"
    ],
    [
      "bug",
      "Wanze"
    ],
    [
      "guarantee",
      "Garant"
    ],
    [
      "leader",
      "Chef"
    ],
    [
      "diamond",
      "Karo"
    ],
    [
      "soft",
      "sanft"
    ],
    [
      "alone",
      "nur"
    ],
    [
      "jones",
      "lechzen"
    ],
    [
      "keyword",
      "Stichwort"
    ],
    [
      "flight",
      "Flucht"
    ],
    [
      "congress",
      "Tagung"
    ],
    [
      "fuel",
      "schüren"
    ],
    [
      "walk",
      "laufen"
    ],
    [
      "fuck",
      "ficken"
    ],
    [
      "italian",
      "italienisch"
    ],
    [
      "paperback",
      "Taschenbuch"
    ],
    [
      "wait",
      "bedienen"
    ],
    [
      "supported",
      "abgestützt"
    ],
    [
      "saint",
      "Heilige"
    ],
    [
      "rose",
      "pink"
    ],
    [
      "argument",
      "Argument"
    ],
    [
      "competition",
      "Wettbewerb"
    ],
    [
      "joint",
      "fügen"
    ],
    [
      "premium",
      "Bonus"
    ],
    [
      "fresh",
      "frech"
    ],
    [
      "upgrade",
      "upgraden"
    ],
    [
      "factor",
      "Agent"
    ],
    [
      "growing",
      "Wachstums-"
    ],
    [
      "stream",
      "Strom"
    ],
    [
      "pick",
      "Hacke"
    ],
    [
      "hearing",
      "Hören"
    ],
    [
      "eastern",
      "Ost"
    ],
    [
      "upper",
      "ober"
    ],
    [
      "administrative",
      "behördlich"
    ],
    [
      "serious",
      "ernst"
    ],
    [
      "prime",
      "prim-"
    ],
    [
      "limit",
      "Grenzwert"
    ],
    [
      "bondage",
      "Pflicht"
    ],
    [
      "ac",
      "Wechselspannung"
    ],
    [
      "creek",
      "Bach"
    ],
    [
      "quantity",
      "Menge"
    ],
    [
      "urban",
      "Stadt"
    ],
    [
      "sorted",
      "sortiert"
    ],
    [
      "reporting",
      "Berichtswesen"
    ],
    [
      "essential",
      "unverzichtbar"
    ],
    [
      "myself",
      "mir"
    ],
    [
      "platform",
      "Plattform"
    ],
    [
      "load",
      "Belastung"
    ],
    [
      "affiliate",
      "Tochter"
    ],
    [
      "immediately",
      "alsbald"
    ],
    [
      "admin",
      "Papierkram"
    ],
    [
      "defense",
      "Wehr"
    ],
    [
      "heavy",
      "schwer"
    ],
    [
      "covered",
      "überlagert"
    ],
    [
      "recovery",
      "Erholung"
    ],
    [
      "cock",
      "Hahn"
    ],
    [
      "merchant",
      "Kauffrau"
    ],
    [
      "comprehensive",
      "umfangreich"
    ],
    [
      "expert",
      "Fachfrau"
    ],
    [
      "universal",
      "universell"
    ],
    [
      "protect",
      "beschützen"
    ],
    [
      "drop",
      "tropfen"
    ],
    [
      "solid",
      "fest"
    ],
    [
      "presentation",
      "Vortrag"
    ],
    [
      "orange",
      "Orange"
    ],
    [
      "compliance",
      "Compliance"
    ],
    [
      "prevent",
      "vorbeugen"
    ],
    [
      "theme",
      "Motiv"
    ],
    [
      "campaign",
      "Einsatz"
    ],
    [
      "marine",
      "See"
    ],
    [
      "finding",
      "Fund"
    ],
    [
      "pennsylvania",
      "Pennsylvanien"
    ],
    [
      "saying",
      "Redensart"
    ],
    [
      "spirit",
      "Geist"
    ],
    [
      "porno",
      "Pornografie"
    ],
    [
      "challenge",
      "Herausforderung"
    ],
    [
      "acceptance",
      "Annahme"
    ],
    [
      "seem",
      "dünken"
    ],
    [
      "touch",
      "anfassen"
    ],
    [
      "hire",
      "anheuern"
    ],
    [
      "suggest",
      "vorschlagen"
    ],
    [
      "branch",
      "Zweig"
    ],
    [
      "serve",
      "bedienen"
    ],
    [
      "magic",
      "Magie"
    ],
    [
      "mount",
      "besteigen"
    ],
    [
      "smart",
      "gescheit"
    ],
    [
      "latin",
      "römisch"
    ],
    [
      "avoid",
      "vermeiden"
    ],
    [
      "manage",
      "schaffen"
    ],
    [
      "corner",
      "Ecke"
    ],
    [
      "rank",
      "Dienstgrad"
    ],
    [
      "computing",
      "Computerei"
    ],
    [
      "element",
      "Element"
    ],
    [
      "virus",
      "Computervirus"
    ],
    [
      "abuse",
      "beleidigen"
    ],
    [
      "interactive",
      "wechselwirkend"
    ],
    [
      "separate",
      "getrennt"
    ],
    [
      "quarter",
      "Viertel"
    ],
    [
      "procedure",
      "Prozedur"
    ],
    [
      "leadership",
      "Führung"
    ],
    [
      "define",
      "definieren"
    ],
    [
      "religious",
      "gläubig"
    ],
    [
      "breakfast",
      "Zmorgen"
    ],
    [
      "column",
      "Kolumne"
    ],
    [
      "faith",
      "Glaube"
    ],
    [
      "chain",
      "ketten"
    ],
    [
      "developer",
      "Entwickler"
    ],
    [
      "identify",
      "identifizieren"
    ],
    [
      "avenue",
      "Avenue"
    ],
    [
      "approximately",
      "etwa"
    ],
    [
      "domestic",
      "Haus"
    ],
    [
      "moved",
      "gerührt"
    ],
    [
      "reach",
      "drankommen"
    ],
    [
      "comparison",
      "Abgleich"
    ],
    [
      "mental",
      "geistig"
    ],
    [
      "moment",
      "Zeitpunkt"
    ],
    [
      "extended",
      "ausgedehnt"
    ],
    [
      "sequence",
      "Sequenz"
    ],
    [
      "attack",
      "Anfall"
    ],
    [
      "sorry",
      "wie?"
    ],
    [
      "opening",
      "Eröffnung"
    ],
    [
      "reserve",
      "reservieren"
    ],
    [
      "plastic",
      "Plastik"
    ],
    [
      "produce",
      "Ertrag"
    ],
    [
      "snow",
      "Schnee"
    ],
    [
      "truth",
      "Treue"
    ],
    [
      "counter",
      "Theke"
    ],
    [
      "failure",
      "Ausfall"
    ],
    [
      "weekend",
      "Weekend"
    ],
    [
      "camp",
      "Lager"
    ],
    [
      "automatically",
      "von selbst"
    ],
    [
      "bridge",
      "Brücke"
    ],
    [
      "native",
      "gebürtig"
    ],
    [
      "fill",
      "füllen"
    ],
    [
      "movement",
      "Satz"
    ],
    [
      "printing",
      "Druck"
    ],
    [
      "approval",
      "Billigung"
    ],
    [
      "draft",
      "Zug"
    ],
    [
      "chart",
      "Diagramm"
    ],
    [
      "clubs",
      "Treff"
    ],
    [
      "equal",
      "Gleichgestellter"
    ],
    [
      "adventure",
      "Wagnis"
    ],
    [
      "offering",
      "Opfer"
    ],
    [
      "profit",
      "gewinnen"
    ],
    [
      "assistant",
      "Helfer"
    ],
    [
      "variable",
      "Variable"
    ],
    [
      "advertisement",
      "Annonce"
    ],
    [
      "parking",
      "Parkieren"
    ],
    [
      "yesterday",
      "gestriger Tag"
    ],
    [
      "determined",
      "beherzt"
    ],
    [
      "workshop",
      "Workshop"
    ],
    [
      "gone",
      "alle"
    ],
    [
      "extension",
      "Strecken"
    ],
    [
      "golden",
      "gülden"
    ],
    [
      "completely",
      "ganz"
    ],
    [
      "fort",
      "Festung"
    ],
    [
      "lighting",
      "Anzünden"
    ],
    [
      "forces",
      "Truppe"
    ],
    [
      "funny",
      "komisch"
    ],
    [
      "portable",
      "portabel"
    ],
    [
      "applicable",
      "relevant"
    ],
    [
      "pattern",
      "Modell"
    ],
    [
      "boat",
      "Schiff"
    ],
    [
      "sponsor",
      "Sponsorin"
    ],
    [
      "icon",
      "Ikone"
    ],
    [
      "dedicated",
      "dediziert"
    ],
    [
      "direction",
      "Führung"
    ],
    [
      "delete",
      "streichen"
    ],
    [
      "evening",
      "Dämmerung"
    ],
    [
      "assembly",
      "Versammlung"
    ],
    [
      "nuclear",
      "Kern"
    ],
    [
      "mouse",
      "Maus"
    ],
    [
      "signal",
      "Zeichen"
    ],
    [
      "criminal",
      "Kriminelle"
    ],
    [
      "brain",
      "Hirn"
    ],
    [
      "dream",
      "Traum"
    ],
    [
      "false",
      "falsch"
    ],
    [
      "cast",
      "wegwerfen"
    ],
    [
      "flower",
      "Blume"
    ],
    [
      "felt",
      "Filz"
    ],
    [
      "falls",
      "-fälle"
    ],
    [
      "soul",
      "Geist"
    ],
    [
      "aids",
      "Aids"
    ],
    [
      "promote",
      "umwandeln"
    ],
    [
      "carry",
      "führen"
    ],
    [
      "flag",
      "markieren"
    ],
    [
      "advantage",
      "Vorzug"
    ],
    [
      "hello",
      "hallo"
    ],
    [
      "maintain",
      "warten"
    ],
    [
      "tourism",
      "Tourismus"
    ],
    [
      "priority",
      "Vorrang"
    ],
    [
      "graphic",
      "Bild"
    ],
    [
      "brief",
      "briefen"
    ],
    [
      "eight",
      "Acht"
    ],
    [
      "anonymous",
      "anonym"
    ],
    [
      "iron",
      "Eisen"
    ],
    [
      "straight",
      "direkt"
    ],
    [
      "script",
      "Skript"
    ],
    [
      "miscellaneous",
      "vermischt"
    ],
    [
      "void",
      "nichtig"
    ],
    [
      "alert",
      "aufmerksam"
    ],
    [
      "tag",
      "Marke"
    ],
    [
      "interview",
      "Bewerbungsgespräch"
    ],
    [
      "mix",
      "mixen"
    ],
    [
      "framework",
      "Gefüge"
    ],
    [
      "disk",
      "Platte"
    ],
    [
      "queen",
      "Dame"
    ],
    [
      "clearly",
      "deutlich"
    ],
    [
      "fix",
      "fixieren"
    ],
    [
      "handle",
      "umgehen mit"
    ],
    [
      "sweet",
      "süß"
    ],
    [
      "desk",
      "Ressort"
    ],
    [
      "vice",
      "Untugend"
    ],
    [
      "associate",
      "zuordnen"
    ],
    [
      "truck",
      "LKW"
    ],
    [
      "behavior",
      "Führung"
    ],
    [
      "ray",
      "Strahl"
    ],
    [
      "revenue",
      "Erlös"
    ],
    [
      "measure",
      "Maß"
    ],
    [
      "duty",
      "Zoll"
    ],
    [
      "bear",
      "ertragen"
    ],
    [
      "gain",
      "Ertrag"
    ],
    [
      "festival",
      "Fest"
    ],
    [
      "laboratory",
      "Laboratorium"
    ],
    [
      "ocean",
      "Weltmeer"
    ],
    [
      "lack",
      "mangeln"
    ],
    [
      "whatever",
      "naja"
    ],
    [
      "laptop",
      "Klapprechner"
    ],
    [
      "vintage",
      "Lese"
    ],
    [
      "train",
      "trainieren"
    ],
    [
      "dry",
      "abtrocknen"
    ],
    [
      "explore",
      "erkunden"
    ],
    [
      "maryland",
      "Marieland"
    ],
    [
      "spa",
      "Bad"
    ],
    [
      "concept",
      "Konzept"
    ],
    [
      "nearly",
      "beinahe"
    ],
    [
      "eligible",
      "begehrt"
    ],
    [
      "checkout",
      "Supermarktkasse"
    ],
    [
      "reality",
      "Realität"
    ],
    [
      "handling",
      "Umgang"
    ],
    [
      "origin",
      "Ursprung"
    ],
    [
      "billion",
      "Billion"
    ],
    [
      "destination",
      "Bestimmung"
    ],
    [
      "intelligence",
      "Klugheit"
    ],
    [
      "con",
      "reinlegen"
    ],
    [
      "route",
      "Weg"
    ],
    [
      "broken",
      "gebrochen"
    ],
    [
      "frank",
      "offen"
    ],
    [
      "zoom",
      "surren"
    ],
    [
      "blow",
      "blasen"
    ],
    [
      "battle",
      "Kampf"
    ],
    [
      "residential",
      "wohn-"
    ],
    [
      "speak",
      "reden"
    ],
    [
      "query",
      "Abfrage"
    ],
    [
      "clip",
      "klammern"
    ],
    [
      "partnership",
      "Personengesellschaft"
    ],
    [
      "editorial",
      "editorisch"
    ],
    [
      "expression",
      "Ausdruck"
    ],
    [
      "equity",
      "Aktienkapital"
    ],
    [
      "speech",
      "Rede"
    ],
    [
      "wire",
      "Ader"
    ],
    [
      "rural",
      "dörflich"
    ],
    [
      "shared",
      "geteilt"
    ],
    [
      "replacement",
      "Ersatz"
    ],
    [
      "judge",
      "beurteilen"
    ],
    [
      "spam",
      "Frühstücksfleisch"
    ],
    [
      "economics",
      "Ökonomie"
    ],
    [
      "acid",
      "Säure"
    ],
    [
      "compatible",
      "verträglich"
    ],
    [
      "fight",
      "mit"
    ],
    [
      "apartment",
      "Appartement"
    ],
    [
      "height",
      "Höhe"
    ],
    [
      "zero",
      "Null"
    ],
    [
      "speaker",
      "Referent"
    ],
    [
      "netherlands",
      "Holland"
    ],
    [
      "obtain",
      "bestehen"
    ],
    [
      "bc",
      "vor Christo"
    ],
    [
      "recreation",
      "Unterhaltung"
    ],
    [
      "designer",
      "Designerin"
    ],
    [
      "remain",
      "bleiben"
    ],
    [
      "marriage",
      "Ehe"
    ],
    [
      "roll",
      "Rolle"
    ],
    [
      "secret",
      "geheim"
    ],
    [
      "bath",
      "Bad"
    ],
    [
      "aa",
      "Brockenlava"
    ],
    [
      "negative",
      "negativ"
    ],
    [
      "theater",
      "Theaterhaus"
    ],
    [
      "missouri",
      "Missuri"
    ],
    [
      "perform",
      "bringen"
    ],
    [
      "healthy",
      "gesund"
    ],
    [
      "translation",
      "Übersetzung"
    ],
    [
      "font",
      "Schriftart"
    ],
    [
      "assets",
      "Vermögen"
    ],
    [
      "injury",
      "Wunde"
    ],
    [
      "joseph",
      "Josef von Arimathäa"
    ],
    [
      "lawyer",
      "Anwältin"
    ],
    [
      "married",
      "Verheiratete"
    ],
    [
      "proposal",
      "Vorschlag"
    ],
    [
      "sharing",
      "Teilung"
    ],
    [
      "birthday",
      "Geburtstag"
    ],
    [
      "fail",
      "Erfolg"
    ],
    [
      "toward",
      "zu"
    ],
    [
      "slightly",
      "leicht"
    ],
    [
      "assist",
      "helfen"
    ],
    [
      "conduct",
      "leiten"
    ],
    [
      "lingerie",
      "Dessous"
    ],
    [
      "legislation",
      "Gesetz"
    ],
    [
      "serving",
      "Gang"
    ],
    [
      "postal",
      "Post-"
    ],
    [
      "wear",
      "Mode"
    ],
    [
      "ultimate",
      "ultimativ"
    ],
    [
      "representative",
      "Vertreter"
    ],
    [
      "frequency",
      "Häufigkeit"
    ],
    [
      "minor",
      "Moll"
    ],
    [
      "finish",
      "Lack"
    ],
    [
      "reduced",
      "reduziert"
    ],
    [
      "rare",
      "rar"
    ],
    [
      "spent",
      "leer"
    ],
    [
      "extreme",
      "extrem"
    ],
    [
      "row",
      "Krach"
    ],
    [
      "forecast",
      "Prognose"
    ],
    [
      "administrator",
      "Verwalter"
    ],
    [
      "cycle",
      "Kreis"
    ],
    [
      "contain",
      "enthalten"
    ],
    [
      "accuracy",
      "Sorgfalt"
    ],
    [
      "dual",
      "Zweizahl"
    ],
    [
      "rise",
      "Zunahme"
    ],
    [
      "sleep",
      "Schlaf"
    ],
    [
      "bird",
      "Vogel"
    ],
    [
      "pharmacy",
      "Apotheke"
    ],
    [
      "creation",
      "Kreation"
    ],
    [
      "hunter",
      "Jäger"
    ],
    [
      "lady",
      "Dame"
    ],
    [
      "crystal",
      "Kristall"
    ],
    [
      "famous",
      "bekannt"
    ],
    [
      "writer",
      "Autor"
    ],
    [
      "chairman",
      "Vorsitzender"
    ],
    [
      "violence",
      "Gewalt"
    ],
    [
      "drink",
      "Trank"
    ],
    [
      "academy",
      "Akademie"
    ],
    [
      "dynamic",
      "dynamisch"
    ],
    [
      "gender",
      "Genus"
    ],
    [
      "eat",
      "essen"
    ],
    [
      "permanent",
      "ständig"
    ],
    [
      "agriculture",
      "Ackerbau"
    ],
    [
      "portfolio",
      "Portefeuille"
    ],
    [
      "exclusive",
      "exklusiv"
    ],
    [
      "seat",
      "Sitzplatz"
    ],
    [
      "vendor",
      "Automat"
    ],
    [
      "regulation",
      "Regeln"
    ],
    [
      "reduction",
      "Reduktion"
    ],
    [
      "aim",
      "Ziel"
    ],
    [
      "nutrition",
      "Nahrung"
    ],
    [
      "recording",
      "Aufnehmen"
    ],
    [
      "toll",
      "Abgabe"
    ],
    [
      "cape",
      "Umhang"
    ],
    [
      "meaning",
      "Sinn"
    ],
    [
      "tip",
      "Tipp"
    ],
    [
      "wonderful",
      "wundervoll"
    ],
    [
      "mine",
      "Mine"
    ],
    [
      "henry",
      "Heinz"
    ],
    [
      "ticket",
      "Ticket"
    ],
    [
      "guess",
      "denken"
    ],
    [
      "whom",
      "den"
    ],
    [
      "ski",
      "Schi"
    ],
    [
      "soccer",
      "Fuppes"
    ],
    [
      "import",
      "Einfuhr"
    ],
    [
      "presence",
      "Gegenwart"
    ],
    [
      "instant",
      "hujus"
    ],
    [
      "automatic",
      "Maschine"
    ],
    [
      "majority",
      "Mehrheit"
    ],
    [
      "ahead",
      "voraus"
    ],
    [
      "moon",
      "Mond"
    ],
    [
      "participation",
      "Beteiligung"
    ],
    [
      "scheme",
      "Schema"
    ],
    [
      "utility",
      "Grundversorgung"
    ],
    [
      "preview",
      "Vorschau"
    ],
    [
      "fly",
      "smart"
    ],
    [
      "manner",
      "Manier"
    ],
    [
      "matrix",
      "Matrize"
    ],
    [
      "combination",
      "Kombination"
    ],
    [
      "amendment",
      "Novelle"
    ],
    [
      "strength",
      "Stärke"
    ],
    [
      "turkey",
      "Pute"
    ],
    [
      "proper",
      "richtig"
    ],
    [
      "fear",
      "Angst"
    ],
    [
      "phoenix",
      "Phönix"
    ],
    [
      "convention",
      "Sitte"
    ],
    [
      "principal",
      "Täter"
    ],
    [
      "standing",
      "vertikal"
    ],
    [
      "voyeur",
      "Voyeurin"
    ],
    [
      "comfort",
      "Trost"
    ],
    [
      "appeal",
      "Reiz"
    ],
    [
      "cruise",
      "Seereise"
    ],
    [
      "bonus",
      "Prämie"
    ],
    [
      "previously",
      "zuvor"
    ],
    [
      "hey",
      "he"
    ],
    [
      "bookmark",
      "Lesezeichen"
    ],
    [
      "beat",
      "Takt"
    ],
    [
      "adobe",
      "Adobe"
    ],
    [
      "tea",
      "Tee"
    ],
    [
      "achieve",
      "erlangen"
    ],
    [
      "dress",
      "anziehen"
    ],
    [
      "subscription",
      "Bezug"
    ],
    [
      "dealer",
      "Geber"
    ],
    [
      "contemporary",
      "modern"
    ],
    [
      "nearby",
      "nah"
    ],
    [
      "rom",
      "Roma"
    ],
    [
      "happen",
      "passieren"
    ],
    [
      "exposure",
      "Lage"
    ],
    [
      "hide",
      "Fell"
    ],
    [
      "signature",
      "Signatur"
    ],
    [
      "refer",
      "beziehen"
    ],
    [
      "miller",
      "Mueller"
    ],
    [
      "provision",
      "Vorkehrung"
    ],
    [
      "outdoors",
      "im Freien"
    ],
    [
      "clothes",
      "Kleider"
    ],
    [
      "certainly",
      "gewiss"
    ],
    [
      "indeed",
      "genau"
    ],
    [
      "newspaper",
      "Tageszeitung"
    ],
    [
      "toy",
      "herumspielen"
    ],
    [
      "circuit",
      "Bezirk"
    ],
    [
      "layer",
      "Lage"
    ],
    [
      "slow",
      "dumm"
    ],
    [
      "removal",
      "Umzug"
    ],
    [
      "liability",
      "Schuld"
    ],
    [
      "trademark",
      "Marke"
    ],
    [
      "hip",
      "Hüfte"
    ],
    [
      "nine",
      "neun"
    ],
    [
      "mostly",
      "weitgehend"
    ],
    [
      "spot",
      "Fleck"
    ],
    [
      "taylor",
      "Schneidermann"
    ],
    [
      "spend",
      "ausgeben"
    ],
    [
      "factory",
      "Werk"
    ],
    [
      "interior",
      "Inneres"
    ],
    [
      "grow",
      "ziehen"
    ],
    [
      "promotion",
      "Werbung"
    ],
    [
      "relative",
      "Angehörige"
    ],
    [
      "amazing",
      "unglaublich"
    ],
    [
      "clock",
      "Uhr"
    ],
    [
      "hiv",
      "HI-Virus"
    ],
    [
      "identity",
      "Gleichheit"
    ],
    [
      "feeling",
      "Gefühl"
    ],
    [
      "reasonable",
      "anständig"
    ],
    [
      "victoria",
      "Victoria"
    ],
    [
      "serial",
      "Serien-"
    ],
    [
      "relief",
      "Hilfe"
    ],
    [
      "revision",
      "Überarbeitung"
    ],
    [
      "influence",
      "Einfluss"
    ],
    [
      "importance",
      "Belang"
    ],
    [
      "planet",
      "Wandelstern"
    ],
    [
      "recipe",
      "Kochrezept"
    ],
    [
      "permit",
      "zulassen"
    ],
    [
      "proof",
      "sicher"
    ],
    [
      "dna",
      "DNA"
    ],
    [
      "bass",
      "Baß"
    ],
    [
      "prescription",
      "Verjährung"
    ],
    [
      "bedroom",
      "Schlafstube"
    ],
    [
      "empty",
      "ausleeren"
    ],
    [
      "instance",
      "Fall"
    ],
    [
      "hole",
      "Loch"
    ],
    [
      "ride",
      "fahren"
    ],
    [
      "bureau",
      "Büro"
    ],
    [
      "represent",
      "darstellen"
    ],
    [
      "conservation",
      "Erhalt"
    ],
    [
      "pair",
      "Paar"
    ],
    [
      "ideal",
      "ideal"
    ],
    [
      "dinner",
      "Dinner"
    ],
    [
      "stress",
      "betonen"
    ],
    [
      "cream",
      "Creme"
    ],
    [
      "yeah",
      "jo"
    ],
    [
      "discover",
      "erleben"
    ],
    [
      "fourth",
      "vierte"
    ],
    [
      "advisor",
      "Berater"
    ],
    [
      "evil",
      "Übel"
    ],
    [
      "aware",
      "gewahr"
    ],
    [
      "shape",
      "Form"
    ],
    [
      "irish",
      "Ire"
    ],
    [
      "op",
      "Themenersteller"
    ],
    [
      "remains",
      "Ruinen"
    ],
    [
      "concerned",
      "beteiligt"
    ],
    [
      "operator",
      "Betreiber"
    ],
    [
      "generic",
      "generisch"
    ],
    [
      "encyclopedia",
      "Lexikon"
    ],
    [
      "usage",
      "Brauch"
    ],
    [
      "cap",
      "Hut"
    ],
    [
      "mixed",
      "gemischt"
    ],
    [
      "census",
      "Zensus"
    ],
    [
      "peak",
      "Gipfel"
    ],
    [
      "competitive",
      "konkurrenzfähig"
    ],
    [
      "exist",
      "bestehen"
    ],
    [
      "wheel",
      "Felge"
    ],
    [
      "transit",
      "Durchgang"
    ],
    [
      "dick",
      "Schwanz"
    ],
    [
      "salt",
      "Salz"
    ],
    [
      "compact",
      "Pakt"
    ],
    [
      "poetry",
      "Poesie"
    ],
    [
      "bell",
      "Klingel"
    ],
    [
      "preparation",
      "Präparat"
    ],
    [
      "attempt",
      "Anschlag"
    ],
    [
      "width",
      "Weite"
    ],
    [
      "noise",
      "Rauschen"
    ],
    [
      "forget",
      "vergessen"
    ],
    [
      "array",
      "Feld"
    ],
    [
      "accurate",
      "exakt"
    ],
    [
      "stephen",
      "Stefan"
    ],
    [
      "pin",
      "Pin"
    ],
    [
      "alcohol",
      "Alkohol"
    ],
    [
      "greek",
      "Griechisch"
    ],
    [
      "instruction",
      "Anweisung"
    ],
    [
      "annotation",
      "Anmerkung"
    ],
    [
      "sister",
      "Schwester"
    ],
    [
      "raw",
      "rau"
    ],
    [
      "walking",
      "Gang"
    ],
    [
      "explain",
      "erklären"
    ],
    [
      "establish",
      "etablieren"
    ],
    [
      "extent",
      "Grad"
    ],
    [
      "sharp",
      "scharf"
    ],
    [
      "lane",
      "Bahn"
    ],
    [
      "paragraph",
      "Paragraph"
    ],
    [
      "kill",
      "abtöten"
    ],
    [
      "compensation",
      "Ausgleich"
    ],
    [
      "export",
      "Ausfuhr"
    ],
    [
      "aircraft",
      "Flugzeug"
    ],
    [
      "conflict",
      "Streit"
    ],
    [
      "employer",
      "Arbeitgeberin"
    ],
    [
      "occur",
      "vorkommen"
    ],
    [
      "percentage",
      "Hundertsatz"
    ],
    [
      "concern",
      "Sorge"
    ],
    [
      "backup",
      "Hilfe"
    ],
    [
      "heritage",
      "Erbe"
    ],
    [
      "immediate",
      "sofort"
    ],
    [
      "trouble",
      "Mühe"
    ],
    [
      "spread",
      "ausbreiten"
    ],
    [
      "coach",
      "Bus"
    ],
    [
      "agricultural",
      "agrarisch"
    ],
    [
      "expand",
      "vergrößern"
    ],
    [
      "audience",
      "Audienz"
    ],
    [
      "jordan",
      "Jordana"
    ],
    [
      "participate",
      "teilnehmen (an)"
    ],
    [
      "plug",
      "Dübel"
    ],
    [
      "specialist",
      "Experte"
    ],
    [
      "cook",
      "sein"
    ],
    [
      "affect",
      "mögen"
    ],
    [
      "virgin",
      "Jungfrau"
    ],
    [
      "experienced",
      "sattelfest"
    ],
    [
      "hat",
      "Kappe"
    ],
    [
      "affected",
      "betroffen"
    ],
    [
      "bike",
      "Rad"
    ],
    [
      "totally",
      "völlig"
    ],
    [
      "plate",
      "Tafel"
    ],
    [
      "indicate",
      "andeuten"
    ],
    [
      "favourite",
      "liebst"
    ],
    [
      "transmission",
      "Getriebe"
    ],
    [
      "lose",
      "abnehmen"
    ],
    [
      "organic",
      "organisch"
    ],
    [
      "extremely",
      "krass"
    ],
    [
      "concerning",
      "bezüglich"
    ],
    [
      "equivalent",
      "äquivalent"
    ],
    [
      "tony",
      "schick"
    ],
    [
      "neighborhood",
      "Viertel"
    ],
    [
      "agenda",
      "Agenda"
    ],
    [
      "anyway",
      "ohnehin"
    ],
    [
      "advisory",
      "beratend"
    ],
    [
      "curriculum",
      "Studienplan"
    ],
    [
      "template",
      "Vorlage"
    ],
    [
      "prince",
      "Prinz"
    ],
    [
      "circle",
      "einkreisen"
    ],
    [
      "soil",
      "Grund"
    ],
    [
      "anywhere",
      "überall"
    ],
    [
      "psychology",
      "Psychologie"
    ],
    [
      "wet",
      "nass"
    ],
    [
      "investor",
      "Anleger"
    ],
    [
      "identification",
      "Identifizierung"
    ],
    [
      "ram",
      "Hammel"
    ],
    [
      "wildlife",
      "Tierwelt"
    ],
    [
      "cooking",
      "Küche"
    ],
    [
      "speaking",
      "Sprech-"
    ],
    [
      "fox",
      "Fähe"
    ],
    [
      "unlimited",
      "unbegrenzt"
    ],
    [
      "respond",
      "reagieren"
    ],
    [
      "plain",
      "Natur"
    ],
    [
      "exit",
      "Ausgang"
    ],
    [
      "arm",
      "Waffe"
    ],
    [
      "launch",
      "öffnen"
    ],
    [
      "wave",
      "Welle"
    ],
    [
      "printable",
      "druckbar"
    ],
    [
      "guidance",
      "Lenkung"
    ],
    [
      "mesh",
      "Netz"
    ],
    [
      "trail",
      "Weg"
    ],
    [
      "enforcement",
      "Vollstreckung"
    ],
    [
      "symbol",
      "Zeichen"
    ],
    [
      "highway",
      "Chaussee"
    ],
    [
      "buddy",
      "Kollege"
    ],
    [
      "hardcover",
      "gebundenes Buch"
    ],
    [
      "dean",
      "Dekan"
    ],
    [
      "setup",
      "Falle"
    ],
    [
      "poll",
      "Umfrage"
    ],
    [
      "booking",
      "Reservierung"
    ],
    [
      "celebrity",
      "Bekanntheit"
    ],
    [
      "filled",
      "voll"
    ],
    [
      "bond",
      "Obligation"
    ],
    [
      "appendix",
      "Beiheft"
    ],
    [
      "notify",
      "benachrichtigen"
    ],
    [
      "chocolate",
      "Schokolade"
    ],
    [
      "pub",
      "Bar"
    ],
    [
      "portion",
      "Portion"
    ],
    [
      "scope",
      "Anwendungsbereich"
    ],
    [
      "supplier",
      "Versorger"
    ],
    [
      "cotton",
      "Baumwoll-"
    ],
    [
      "bluetooth",
      "Bluetooth"
    ],
    [
      "controlled",
      "beherrscht"
    ],
    [
      "dental",
      "dental"
    ],
    [
      "border",
      "Beet"
    ],
    [
      "ancient",
      "alt"
    ],
    [
      "debate",
      "Debatte"
    ],
    [
      "biography",
      "Biographie"
    ],
    [
      "leisure",
      "Muße"
    ],
    [
      "learned",
      "belehrt"
    ],
    [
      "notebook",
      "Laptop"
    ],
    [
      "explorer",
      "Entdecker"
    ],
    [
      "historic",
      "geschichtsträchtig"
    ],
    [
      "husband",
      "Mann"
    ],
    [
      "disabled",
      "gesperrt"
    ],
    [
      "retirement",
      "Rente"
    ],
    [
      "efficiency",
      "Wirkungsgrad"
    ],
    [
      "comedy",
      "Lustspiel"
    ],
    [
      "linear",
      "lineal"
    ],
    [
      "commitment",
      "Engagement"
    ],
    [
      "specialty",
      "Arteigenschaft"
    ],
    [
      "carrier",
      "Träger"
    ],
    [
      "constant",
      "konstant"
    ],
    [
      "mouth",
      "Maul"
    ],
    [
      "meter",
      "Metrum"
    ],
    [
      "gun",
      "Kanone"
    ],
    [
      "reflect",
      "reflektieren"
    ],
    [
      "pure",
      "rein"
    ],
    [
      "deliver",
      "erlösen"
    ],
    [
      "wonder",
      "fragen"
    ],
    [
      "hell",
      "Brand"
    ],
    [
      "fruit",
      "Obst"
    ],
    [
      "qualified",
      "eingeschränkt"
    ],
    [
      "draw",
      "ziehen"
    ],
    [
      "assume",
      "annehmen"
    ],
    [
      "confidence",
      "Zuversicht"
    ],
    [
      "alliance",
      "Bündnis"
    ],
    [
      "confirm",
      "bestätigen"
    ],
    [
      "warm",
      "warmherzig"
    ],
    [
      "neither",
      "keine"
    ],
    [
      "engineer",
      "Ingenieur"
    ],
    [
      "lifestyle",
      "Lebensweise"
    ],
    [
      "consistent",
      "konsistent"
    ],
    [
      "replace",
      "zurückstellen"
    ],
    [
      "clearance",
      "Freigabe"
    ],
    [
      "inventory",
      "Inventar"
    ],
    [
      "suck",
      "Blasen"
    ],
    [
      "babe",
      "Puppe"
    ],
    [
      "becoming",
      "passend"
    ],
    [
      "blowjob",
      "Blasen"
    ],
    [
      "objective",
      "objektiv"
    ],
    [
      "sugar",
      "versüßen"
    ],
    [
      "crew",
      "Haufen"
    ],
    [
      "stick",
      "Stock"
    ],
    [
      "relation",
      "Angehörige"
    ],
    [
      "genre",
      "Gattung"
    ],
    [
      "slide",
      "Dia"
    ],
    [
      "volunteer",
      "anbieten"
    ],
    [
      "rear",
      "steigen"
    ],
    [
      "enhance",
      "erhöhen"
    ],
    [
      "exact",
      "exakt"
    ],
    [
      "bound",
      "Sprung"
    ],
    [
      "adapter",
      "Steckerleiste"
    ],
    [
      "node",
      "Ecke"
    ],
    [
      "formal",
      "Form-"
    ],
    [
      "contribute",
      "beisteuern"
    ],
    [
      "lock",
      "Schleuse"
    ],
    [
      "hockey",
      "Eishockey"
    ],
    [
      "mile",
      "Knoten"
    ],
    [
      "bowl",
      "Schale"
    ],
    [
      "supreme",
      "oberster"
    ],
    [
      "recognition",
      "Erkennung"
    ],
    [
      "tank",
      "Panzer"
    ],
    [
      "submission",
      "Versand"
    ],
    [
      "estimate",
      "Schätzung"
    ],
    [
      "encourage",
      "empfehlen"
    ],
    [
      "navy",
      "Flotte"
    ],
    [
      "kid",
      "veräppeln"
    ],
    [
      "regulatory",
      "regulatorisch"
    ],
    [
      "inspection",
      "Prüfung"
    ],
    [
      "cancel",
      "canceln"
    ],
    [
      "territory",
      "Gebiet"
    ],
    [
      "transaction",
      "Geschäft"
    ],
    [
      "paint",
      "malen"
    ],
    [
      "delay",
      "vertagen"
    ],
    [
      "pilot",
      "lotsen"
    ],
    [
      "outlet",
      "Auslass"
    ],
    [
      "continuous",
      "stetig"
    ],
    [
      "czech",
      "Tschechisch"
    ],
    [
      "novel",
      "Novelle"
    ],
    [
      "execution",
      "Ausführung"
    ],
    [
      "disability",
      "Invalidität"
    ],
    [
      "winner",
      "Sieger"
    ],
    [
      "contractor",
      "Firma"
    ],
    [
      "episode",
      "Folge"
    ],
    [
      "examination",
      "Prüfung"
    ],
    [
      "potter",
      "Töpferin"
    ],
    [
      "dish",
      "Gericht"
    ],
    [
      "bulletin",
      "Mitteilungsblatt"
    ],
    [
      "modify",
      "ändern"
    ],
    [
      "oxford",
      "Ochsenfurt"
    ],
    [
      "truly",
      "echt"
    ],
    [
      "painting",
      "Malerei"
    ],
    [
      "universe",
      "Weltall"
    ],
    [
      "candidate",
      "Kandidatin"
    ],
    [
      "patent",
      "patentieren lassen"
    ],
    [
      "slot",
      "Nut"
    ],
    [
      "outstanding",
      "ausstehend"
    ],
    [
      "perspective",
      "Perspektive"
    ],
    [
      "lodge",
      "Loge"
    ],
    [
      "messenger",
      "Kurier"
    ],
    [
      "mirror",
      "Kopie"
    ],
    [
      "consideration",
      "Überlegung"
    ],
    [
      "kernel",
      "Betriebssystemkern"
    ],
    [
      "stocks",
      "Pranger"
    ],
    [
      "gray",
      "grau"
    ],
    [
      "catalogue",
      "Liste"
    ],
    [
      "broad",
      "Weib"
    ],
    [
      "taiwan",
      "Formosa"
    ],
    [
      "chosen",
      "erwählt"
    ],
    [
      "swiss",
      "Schweizer"
    ],
    [
      "sarah",
      "Sarah"
    ],
    [
      "labour",
      "Wehen"
    ],
    [
      "terminal",
      "Bahnhof"
    ],
    [
      "behalf",
      "Nutzen"
    ],
    [
      "liquid",
      "flüssig"
    ],
    [
      "loop",
      "Schleife"
    ],
    [
      "salary",
      "Lohn"
    ],
    [
      "reservation",
      "Vorbehalt"
    ],
    [
      "gourmet",
      "Genießer"
    ],
    [
      "guard",
      "Schutz"
    ],
    [
      "properly",
      "richtig"
    ],
    [
      "orleans",
      "Orléans"
    ],
    [
      "empire",
      "Imperium"
    ],
    [
      "resume",
      "fortsetzen"
    ],
    [
      "raise",
      "erheben"
    ],
    [
      "prepare",
      "vorbereiten"
    ],
    [
      "avatar",
      "Avatara"
    ],
    [
      "illegal",
      "rechtswidrig"
    ],
    [
      "expansion",
      "Ausdehnung"
    ],
    [
      "vary",
      "variieren"
    ],
    [
      "arab",
      "Araber"
    ],
    [
      "tomorrow",
      "Morgen"
    ],
    [
      "milk",
      "melken"
    ],
    [
      "decide",
      "beschließen"
    ],
    [
      "consent",
      "Konsens"
    ],
    [
      "drama",
      "Schauspiel"
    ],
    [
      "downtown",
      "City"
    ],
    [
      "keyboard",
      "Tastatur"
    ],
    [
      "contest",
      "Debatte"
    ],
    [
      "collected",
      "gelassen"
    ],
    [
      "boot",
      "laden"
    ],
    [
      "suitable",
      "passend"
    ],
    [
      "absolutely",
      "gar"
    ],
    [
      "lunch",
      "soupieren"
    ],
    [
      "dildo",
      "Plastikschwanz"
    ],
    [
      "audit",
      "prüfen"
    ],
    [
      "push",
      "drücken"
    ],
    [
      "chamber",
      "Kammer"
    ],
    [
      "implement",
      "umsetzen"
    ],
    [
      "typical",
      "typisch"
    ],
    [
      "tower",
      "Turm"
    ],
    [
      "yours",
      "Ihres"
    ],
    [
      "calculator",
      "Rechner"
    ],
    [
      "significantly",
      "beträchtlich"
    ],
    [
      "chicken",
      "Huhn"
    ],
    [
      "temporary",
      "temporär"
    ],
    [
      "attend",
      "kümmern"
    ],
    [
      "shower",
      "Fälle"
    ],
    [
      "tonight",
      "heute Nacht"
    ],
    [
      "dear",
      "lieb"
    ],
    [
      "sufficient",
      "genügend"
    ],
    [
      "shell",
      "Schale"
    ],
    [
      "province",
      "Land"
    ],
    [
      "catholic",
      "Katholik"
    ],
    [
      "oak",
      "Eiche"
    ],
    [
      "vat",
      "Trog"
    ],
    [
      "awareness",
      "Achtsamkeit"
    ],
    [
      "governor",
      "Regler"
    ],
    [
      "contribution",
      "Beitrag"
    ],
    [
      "measurement",
      "Maß"
    ],
    [
      "spyware",
      "Spyware"
    ],
    [
      "formula",
      "Rezept"
    ],
    [
      "constitution",
      "Verfassung"
    ],
    [
      "packaging",
      "Verpackung"
    ],
    [
      "solar",
      "Sonne"
    ],
    [
      "catch",
      "fangen"
    ],
    [
      "ps",
      "PS"
    ],
    [
      "reliable",
      "verlässlich"
    ],
    [
      "consultation",
      "Beratung"
    ],
    [
      "northwest",
      "Nordwest"
    ],
    [
      "sir",
      "mein Herr"
    ],
    [
      "doubt",
      "bezweifeln"
    ],
    [
      "unable",
      "außerstanden"
    ],
    [
      "classroom",
      "Klassenraum"
    ],
    [
      "democracy",
      "Demokratie"
    ],
    [
      "wallpaper",
      "Hintergrundbild"
    ],
    [
      "merchandise",
      "Gut"
    ],
    [
      "memorial",
      "Mahnmal"
    ],
    [
      "visitor",
      "Besucherin"
    ],
    [
      "twin",
      "Zwilling"
    ],
    [
      "insert",
      "einfügen"
    ],
    [
      "gateway",
      "Tor"
    ],
    [
      "drawing",
      "Bild"
    ],
    [
      "biological",
      "leiblich"
    ],
    [
      "transition",
      "transitionieren"
    ],
    [
      "spy",
      "Spionin"
    ],
    [
      "romance",
      "Romanze"
    ],
    [
      "instrument",
      "Instrument"
    ],
    [
      "split",
      "Spalt"
    ],
    [
      "heaven",
      "Himmel"
    ],
    [
      "pregnant",
      "trächtig"
    ],
    [
      "twice",
      "doppelt"
    ],
    [
      "classification",
      "Klassifizierung"
    ],
    [
      "focused",
      "konzentriert"
    ],
    [
      "egypt",
      "Altägypten"
    ],
    [
      "physician",
      "Doktorin"
    ],
    [
      "bargain",
      "Zukauf"
    ],
    [
      "cellular",
      "Zelle"
    ],
    [
      "normally",
      "normal"
    ],
    [
      "lo",
      "sehen"
    ],
    [
      "spiritual",
      "geistlich"
    ],
    [
      "hunting",
      "Aalen"
    ],
    [
      "diabetes",
      "Zucker"
    ],
    [
      "suit",
      "Anzug"
    ],
    [
      "shift",
      "Schicht"
    ],
    [
      "chip",
      "Chip"
    ],
    [
      "sit",
      "liegen"
    ],
    [
      "cutting",
      "Ableger"
    ],
    [
      "wow",
      "boah"
    ],
    [
      "flexible",
      "fügsam"
    ],
    [
      "numerous",
      "vielzählig"
    ],
    [
      "relatively",
      "relativ"
    ],
    [
      "satisfaction",
      "Zufriedenheit"
    ],
    [
      "char",
      "Putzfrau"
    ],
    [
      "superior",
      "höher"
    ],
    [
      "cartoon",
      "Karikatur"
    ],
    [
      "intellectual",
      "Intellektuelle"
    ],
    [
      "granted",
      "zugegebenermaßen"
    ],
    [
      "carbon",
      "Kohle"
    ],
    [
      "comfortable",
      "komfortabel"
    ],
    [
      "magnetic",
      "anziehend"
    ],
    [
      "interaction",
      "Interaktion"
    ],
    [
      "effectively",
      "wirksam"
    ],
    [
      "registry",
      "Register"
    ],
    [
      "outlook",
      "Ausblick"
    ],
    [
      "bright",
      "heiter"
    ],
    [
      "treat",
      "heilen"
    ],
    [
      "header",
      "Kopfball"
    ],
    [
      "piano",
      "Piano"
    ],
    [
      "echo",
      "Widerhall"
    ],
    [
      "grid",
      "Gatter"
    ],
    [
      "revolution",
      "Umdrehung"
    ],
    [
      "earnings",
      "Lohn"
    ],
    [
      "mystery",
      "Rätsel"
    ],
    [
      "landscape",
      "Querformat"
    ],
    [
      "dependent",
      "Abhängiger"
    ],
    [
      "journey",
      "Weg"
    ],
    [
      "delaware",
      "Lenape"
    ],
    [
      "banner",
      "Fahne"
    ],
    [
      "applicant",
      "Bewerber"
    ],
    [
      "fig",
      "Feige"
    ],
    [
      "cooperation",
      "Mitarbeit"
    ],
    [
      "acquisition",
      "Erwerb"
    ],
    [
      "blogger",
      "Bloggerin"
    ],
    [
      "notification",
      "Nachricht"
    ],
    [
      "teach",
      "lehren"
    ],
    [
      "hairy",
      "haarig"
    ],
    [
      "diversity",
      "Diversität"
    ],
    [
      "reverse",
      "umkehren"
    ],
    [
      "deposit",
      "Depot"
    ],
    [
      "seminar",
      "Kolloquium"
    ],
    [
      "accessibility",
      "Barrierefreiheit"
    ],
    [
      "dutch",
      "Holländer"
    ],
    [
      "sensitive",
      "sensibel"
    ],
    [
      "tab",
      "Reiter"
    ],
    [
      "concrete",
      "konkret"
    ],
    [
      "folder",
      "Mappe"
    ],
    [
      "completion",
      "Vollendung"
    ],
    [
      "upload",
      "uploaden"
    ],
    [
      "pulse",
      "Hülsenfrucht"
    ],
    [
      "calculate",
      "berechnen"
    ],
    [
      "broadcast",
      "übertragen"
    ],
    [
      "anniversary",
      "Jahrestag"
    ],
    [
      "strip",
      "abisolieren"
    ],
    [
      "pearl",
      "Perl"
    ],
    [
      "accident",
      "Unfall"
    ],
    [
      "nick",
      "klemmen"
    ],
    [
      "accessible",
      "barrierefrei"
    ],
    [
      "accessory",
      "Gehilfe"
    ],
    [
      "resident",
      "Einwohner"
    ],
    [
      "plot",
      "planen"
    ],
    [
      "possibly",
      "eventuell"
    ],
    [
      "airline",
      "Airline"
    ],
    [
      "representation",
      "Darstellung"
    ],
    [
      "regard",
      "betreffen"
    ],
    [
      "pump",
      "Pumps"
    ],
    [
      "smooth",
      "glatt"
    ],
    [
      "strike",
      "scheinen"
    ],
    [
      "consumption",
      "Konsum"
    ],
    [
      "flashing",
      "Blinken"
    ],
    [
      "narrow",
      "verengen"
    ],
    [
      "threat",
      "Bedrohung"
    ],
    [
      "sitting",
      "Brüten"
    ],
    [
      "consultant",
      "Beraterin"
    ],
    [
      "controller",
      "Controller"
    ],
    [
      "ownership",
      "Verantwortung"
    ],
    [
      "penis",
      "Teil"
    ],
    [
      "trailer",
      "Trailer"
    ],
    [
      "castle",
      "Festung"
    ],
    [
      "malaysia",
      "Malaysien"
    ],
    [
      "unsubscribe",
      "abmelden"
    ],
    [
      "willing",
      "willig"
    ],
    [
      "acting",
      "amtierend"
    ],
    [
      "residence",
      "Sitz"
    ],
    [
      "density",
      "Dichte"
    ],
    [
      "hundred",
      "Hundert"
    ],
    [
      "strange",
      "fremd"
    ],
    [
      "sustainable",
      "nachhaltig"
    ],
    [
      "mention",
      "nennen"
    ],
    [
      "innovation",
      "Novität"
    ],
    [
      "parallel",
      "parallel"
    ],
    [
      "operate",
      "betreiben"
    ],
    [
      "bold",
      "fett"
    ],
    [
      "bathroom",
      "Bad"
    ],
    [
      "stable",
      "Kuhstall"
    ],
    [
      "opera",
      "Oper"
    ],
    [
      "lesson",
      "Lektion"
    ],
    [
      "cinema",
      "Kino"
    ],
    [
      "asset",
      "Gut"
    ],
    [
      "scan",
      "Scan"
    ],
    [
      "blank",
      "Lücke"
    ],
    [
      "enhanced",
      "unterstützt"
    ],
    [
      "entitled",
      "befugt"
    ],
    [
      "generate",
      "generieren"
    ],
    [
      "deluxe",
      "Luxus-"
    ],
    [
      "aged",
      "alt"
    ],
    [
      "exception",
      "Ausnahme"
    ],
    [
      "fabric",
      "Struktur"
    ],
    [
      "primarily",
      "in erster Linie"
    ],
    [
      "tight",
      "dicht"
    ],
    [
      "contrast",
      "Kontrast"
    ],
    [
      "recruitment",
      "Anwerbung"
    ],
    [
      "berlin",
      "berlinisch"
    ],
    [
      "cute",
      "süß"
    ],
    [
      "expensive",
      "kostspielig"
    ],
    [
      "capture",
      "Fang"
    ],
    [
      "buffalo",
      "Wisent"
    ],
    [
      "plane",
      "Ebene"
    ],
    [
      "seed",
      "Saat"
    ],
    [
      "desire",
      "Wunsch"
    ],
    [
      "expertise",
      "Fachkenntnis"
    ],
    [
      "camping",
      "Zelten"
    ],
    [
      "ee",
      "e-"
    ],
    [
      "welfare",
      "Sozialhilfe"
    ],
    [
      "peer",
      "illern"
    ],
    [
      "eventually",
      "letztendlich"
    ],
    [
      "measured",
      "gemessen"
    ],
    [
      "bottle",
      "Buddel"
    ],
    [
      "massage",
      "schönen"
    ],
    [
      "rubber",
      "Gummi"
    ],
    [
      "conclusion",
      "Schlussfolgerung"
    ],
    [
      "thousand",
      "eintausend"
    ],
    [
      "meat",
      "Fleisch"
    ],
    [
      "grace",
      "Huld"
    ],
    [
      "ing",
      "u"
    ],
    [
      "python",
      "Pythonschlange"
    ],
    [
      "monster",
      "Ungeheuer"
    ],
    [
      "bang",
      "Hieb"
    ],
    [
      "villa",
      "Anwesen"
    ],
    [
      "bone",
      "Bein"
    ],
    [
      "collaboration",
      "Kollaboration"
    ],
    [
      "tutorial",
      "Übung"
    ],
    [
      "entity",
      "Entität"
    ],
    [
      "gate",
      "Flugsteig"
    ],
    [
      "holder",
      "Halter"
    ],
    [
      "moderator",
      "Moderatorin"
    ],
    [
      "settlement",
      "Siedlung"
    ],
    [
      "roman",
      "Römer"
    ],
    [
      "valuable",
      "Wertsache"
    ],
    [
      "tone",
      "Ton"
    ],
    [
      "ethics",
      "Ethik"
    ],
    [
      "forever",
      "unaufhörlich"
    ],
    [
      "dragon",
      "Wurm"
    ],
    [
      "busy",
      "besetzt"
    ],
    [
      "captain",
      "Hauptmann"
    ],
    [
      "fantastic",
      "phantasievoll"
    ],
    [
      "imagine",
      "einbilden"
    ],
    [
      "leg",
      "Kathete"
    ],
    [
      "neck",
      "Hals"
    ],
    [
      "wing",
      "Flügel"
    ],
    [
      "abc",
      "Abc-Buch"
    ],
    [
      "taste",
      "kosten"
    ],
    [
      "commit",
      "engagieren"
    ],
    [
      "operational",
      "Operation"
    ],
    [
      "rail",
      "Gleis"
    ],
    [
      "liberal",
      "liberal"
    ],
    [
      "jay",
      "Häher"
    ],
    [
      "gap",
      "Lücke"
    ],
    [
      "tube",
      "Rohr"
    ],
    [
      "cache",
      "Geocache"
    ],
    [
      "belt",
      "Gürtel"
    ],
    [
      "jacket",
      "Jacke"
    ],
    [
      "determination",
      "Entschluss"
    ],
    [
      "animation",
      "Vitalisierung"
    ],
    [
      "oracle",
      "Orakel"
    ],
    [
      "matthew",
      "Matthias"
    ],
    [
      "aviation",
      "Fliegerei"
    ],
    [
      "proud",
      "stolz"
    ],
    [
      "excess",
      "Übermaß"
    ],
    [
      "disaster",
      "Unheil"
    ],
    [
      "console",
      "Konsole"
    ],
    [
      "instructor",
      "Dozentin"
    ],
    [
      "giant",
      "Riese"
    ],
    [
      "bestiality",
      "Zoophilie"
    ],
    [
      "alarm",
      "in Alarmstimmung versetzen"
    ],
    [
      "anthony",
      "Antonius"
    ],
    [
      "usual",
      "üblich"
    ],
    [
      "loading",
      "Ladung"
    ],
    [
      "angle",
      "Ecke"
    ],
    [
      "vinyl",
      "Schallplatte"
    ],
    [
      "ongoing",
      "laufend"
    ],
    [
      "worst",
      "schlimmste"
    ],
    [
      "blackjack",
      "Totschläger"
    ],
    [
      "era",
      "Epoche"
    ],
    [
      "convert",
      "umwandeln"
    ],
    [
      "possibility",
      "Gelegenheit"
    ],
    [
      "analyst",
      "Analytikerin"
    ],
    [
      "commissioner",
      "Kommissar"
    ],
    [
      "garage",
      "Werkstatt"
    ],
    [
      "exciting",
      "aufregend"
    ],
    [
      "reliability",
      "belastbar"
    ],
    [
      "unfortunately",
      "bedauerlicherweise"
    ],
    [
      "respectively",
      "jeweils"
    ],
    [
      "attachment",
      "Anhang"
    ],
    [
      "pleasure",
      "Spaß"
    ],
    [
      "asp",
      "Rapfen"
    ],
    [
      "eagle",
      "Aar"
    ],
    [
      "pants",
      "Schlüpfer"
    ],
    [
      "columbus",
      "Christoph Colon"
    ],
    [
      "nurse",
      "hegen"
    ],
    [
      "prayer",
      "Gebet"
    ],
    [
      "appointment",
      "Berufung"
    ],
    [
      "hurricane",
      "Orkan"
    ],
    [
      "quiet",
      "still"
    ],
    [
      "postage",
      "Frankierung"
    ],
    [
      "producer",
      "Produzent"
    ],
    [
      "dial",
      "Wählscheibe"
    ],
    [
      "cheese",
      "Käse"
    ],
    [
      "comic",
      "Strip"
    ],
    [
      "jet",
      "Jett"
    ],
    [
      "productivity",
      "Leistungsfähigkeit"
    ],
    [
      "crown",
      "Krone"
    ],
    [
      "underground",
      "Untergrund"
    ],
    [
      "maker",
      "Macher"
    ],
    [
      "crack",
      "Ritze"
    ],
    [
      "principle",
      "Prinzip"
    ],
    [
      "gang",
      "Gang"
    ],
    [
      "semester",
      "Halbjahr"
    ],
    [
      "appearance",
      "Schein"
    ],
    [
      "smoke",
      "räuchern"
    ],
    [
      "apache",
      "Apachin"
    ],
    [
      "craft",
      "Handwerk"
    ],
    [
      "cake",
      "Stück"
    ],
    [
      "apart",
      "entzwei"
    ],
    [
      "fellow",
      "Paar"
    ],
    [
      "blind",
      "Blind"
    ],
    [
      "lounge",
      "Foyer"
    ],
    [
      "mad",
      "böse"
    ],
    [
      "gross",
      "grob"
    ],
    [
      "valentine",
      "Valentinsgruß"
    ],
    [
      "horror",
      "Angst"
    ],
    [
      "familiar",
      "familiär"
    ],
    [
      "till",
      "bauen"
    ],
    [
      "pen",
      "Feder"
    ],
    [
      "christopher",
      "Christof"
    ],
    [
      "admission",
      "Einlass"
    ],
    [
      "shoe",
      "Schuh"
    ],
    [
      "sand",
      "Sand"
    ],
    [
      "ethnic",
      "Fremder"
    ],
    [
      "parliament",
      "Eulenschwarm"
    ],
    [
      "actor",
      "Akteur"
    ],
    [
      "seal",
      "Siegel"
    ],
    [
      "fifth",
      "fünfte"
    ],
    [
      "citizen",
      "Bürgerin"
    ],
    [
      "vertical",
      "vertikal"
    ],
    [
      "structural",
      "konstruktiv"
    ],
    [
      "municipal",
      "Stadt"
    ],
    [
      "prize",
      "Preis"
    ],
    [
      "absolute",
      "rein"
    ],
    [
      "anytime",
      "jederzeit"
    ],
    [
      "substance",
      "Stoff"
    ],
    [
      "pipe",
      "Rohr"
    ],
    [
      "guardian",
      "Wache"
    ],
    [
      "lecture",
      "Vortrag"
    ],
    [
      "simulation",
      "Schwalbe"
    ],
    [
      "layout",
      "Struktur"
    ],
    [
      "ill",
      "übel"
    ],
    [
      "lay",
      "legen"
    ],
    [
      "interpretation",
      "Interpretation"
    ],
    [
      "dirty",
      "dreckig"
    ],
    [
      "deck",
      "Terrasse"
    ],
    [
      "donate",
      "spenden"
    ],
    [
      "bankruptcy",
      "Pleite"
    ],
    [
      "mp",
      "MdB"
    ],
    [
      "worker",
      "Arbeiterin"
    ],
    [
      "temple",
      "Schläfe"
    ],
    [
      "prove",
      "prüfen"
    ],
    [
      "promise",
      "zusagen"
    ],
    [
      "thin",
      "dünn"
    ],
    [
      "prefer",
      "vorziehen"
    ],
    [
      "ridge",
      "Grat"
    ],
    [
      "cabinet",
      "Kabinett"
    ],
    [
      "sick",
      "krank"
    ],
    [
      "evaluate",
      "ergeben"
    ],
    [
      "collect",
      "sammeln"
    ],
    [
      "bet",
      "Wahrscheinlichkeit"
    ],
    [
      "composition",
      "Komposition"
    ],
    [
      "definitely",
      "bestimmt"
    ],
    [
      "buffer",
      "Puffer"
    ],
    [
      "purple",
      "lila"
    ],
    [
      "existence",
      "Sein"
    ],
    [
      "larry",
      "Lenz"
    ],
    [
      "immigration",
      "Immigration"
    ],
    [
      "mutual",
      "gegenseitig"
    ],
    [
      "pipeline",
      "Pipeline"
    ],
    [
      "necessarily",
      "unbedingt"
    ],
    [
      "syntax",
      "Satzbau"
    ],
    [
      "attribute",
      "Attribut"
    ],
    [
      "prison",
      "Haft"
    ],
    [
      "skill",
      "Fähigkeit"
    ],
    [
      "everyday",
      "gemein"
    ],
    [
      "apparently",
      "anscheinend"
    ],
    [
      "popularity",
      "Beliebtheit"
    ],
    [
      "inquiry",
      "Anfrage"
    ],
    [
      "exhibit",
      "zeigen"
    ],
    [
      "throw",
      "schmeißen"
    ],
    [
      "trend",
      "wenden"
    ],
    [
      "desert",
      "Wüste"
    ],
    [
      "coordinator",
      "Koordinatorin"
    ],
    [
      "obviously",
      "sichtlich"
    ],
    [
      "mercury",
      "Bingelkraut"
    ],
    [
      "navigate",
      "surfen"
    ],
    [
      "worse",
      "schlimmer"
    ],
    [
      "summit",
      "Gipfeltreffen"
    ],
    [
      "fundamental",
      "grundsätzlich"
    ],
    [
      "escape",
      "fliehen"
    ],
    [
      "somewhat",
      "etwas"
    ],
    [
      "receiver",
      "Hörer"
    ],
    [
      "substantial",
      "essenziell"
    ],
    [
      "progressive",
      "fortschrittlich"
    ],
    [
      "glance",
      "einen Blick darauf werfen"
    ],
    [
      "scottish",
      "schottisch"
    ],
    [
      "arcade",
      "Laube"
    ],
    [
      "obvious",
      "evident"
    ],
    [
      "depression",
      "Depression"
    ],
    [
      "graph",
      "Funktionsgraph"
    ],
    [
      "judgment",
      "Urteil"
    ],
    [
      "foster",
      "nähren"
    ],
    [
      "passing",
      "Pass"
    ],
    [
      "tissue",
      "Tuch"
    ],
    [
      "memorabilia",
      "Memorabilien"
    ],
    [
      "cartridge",
      "Kartusche"
    ],
    [
      "explanation",
      "Ausführung"
    ],
    [
      "folk",
      "Folk"
    ]
  ],
  "es": [
    [
      "the",
      "el"
    ],
    [
      "of",
      "de"
    ],
    [
      "and",
      "e"
    ],
    [
      "to",
      "para"
    ],
    [
      "a",
      "una"
    ],
    [
      "in",
      "en"
    ],
    [
      "for",
      "por"
    ],
    [
      "on",
      "en"
    ],
    [
      "that",
      "que"
    ],
    [
      "by",
      "por"
    ],
    [
      "this",
      "esta"
    ],
    [
      "with",
      "con"
    ],
    [
      "i",
      "i latina"
    ],
    [
      "you",
      "tú"
    ],
    [
      "it",
      "eso"
    ],
    [
      "or",
      "u"
    ],
    [
      "be",
      "ser"
    ],
    [
      "from",
      "desde"
    ],
    [
      "at",
      "a"
    ],
    [
      "as",
      "como"
    ],
    [
      "your",
      "su"
    ],
    [
      "all",
      "todo"
    ],
    [
      "have",
      "tener"
    ],
    [
      "new",
      "nueva"
    ],
    [
      "an",
      "una"
    ],
    [
      "we",
      "nosotras"
    ],
    [
      "will",
      "legar"
    ],
    [
      "home",
      "hogar"
    ],
    [
      "can",
      "lata"
    ],
    [
      "us",
      "EU"
    ],
    [
      "about",
      "por"
    ],
    [
      "if",
      "aunque"
    ],
    [
      "page",
      "paje"
    ],
    [
      "my",
      "mis"
    ],
    [
      "search",
      "buscar"
    ],
    [
      "free",
      "libre"
    ],
    [
      "but",
      "mas"
    ],
    [
      "our",
      "nuestra"
    ],
    [
      "one",
      "uno"
    ],
    [
      "other",
      "otra"
    ],
    [
      "do",
      "valer"
    ],
    [
      "no",
      "nada de"
    ],
    [
      "time",
      "tiempo"
    ],
    [
      "they",
      "se"
    ],
    [
      "site",
      "sitio"
    ],
    [
      "up",
      "arriba"
    ],
    [
      "may",
      "que"
    ],
    [
      "what",
      "qué"
    ],
    [
      "which",
      "cuáles"
    ],
    [
      "their",
      "su"
    ],
    [
      "news",
      "noticia"
    ],
    [
      "out",
      "fuera"
    ],
    [
      "use",
      "soler"
    ],
    [
      "any",
      "cualquiera"
    ],
    [
      "there",
      "ahí"
    ],
    [
      "see",
      "veer"
    ],
    [
      "only",
      "solo"
    ],
    [
      "so",
      "tan"
    ],
    [
      "his",
      "su"
    ],
    [
      "when",
      "cuándo"
    ],
    [
      "contact",
      "contacto"
    ],
    [
      "here",
      "acá"
    ],
    [
      "business",
      "bisnes"
    ],
    [
      "who",
      "quien"
    ],
    [
      "web",
      "red"
    ],
    [
      "also",
      "además"
    ],
    [
      "now",
      "ya"
    ],
    [
      "help",
      "auxilio"
    ],
    [
      "get",
      "ponerse"
    ],
    [
      "view",
      "visión"
    ],
    [
      "online",
      "online"
    ],
    [
      "first",
      "primero"
    ],
    [
      "how",
      "cómo"
    ],
    [
      "me",
      "mí"
    ],
    [
      "s",
      "s"
    ],
    [
      "some",
      "algo"
    ],
    [
      "these",
      "estos"
    ],
    [
      "click",
      "congeniar"
    ],
    [
      "its",
      "sus"
    ],
    [
      "like",
      "como"
    ],
    [
      "service",
      "saque"
    ],
    [
      "find",
      "creer"
    ],
    [
      "price",
      "tasar"
    ],
    [
      "date",
      "fecha"
    ],
    [
      "back",
      "atrás"
    ],
    [
      "top",
      "cofa"
    ],
    [
      "people",
      "pueblo"
    ],
    [
      "list",
      "tira"
    ],
    [
      "name",
      "nombrar"
    ],
    [
      "just",
      "apenas"
    ],
    [
      "over",
      "sobre"
    ],
    [
      "state",
      "Estado"
    ],
    [
      "year",
      "año"
    ],
    [
      "day",
      "día"
    ],
    [
      "into",
      "dentro"
    ],
    [
      "email",
      "correo"
    ],
    [
      "health",
      "salud"
    ],
    [
      "world",
      "globo"
    ],
    [
      "next",
      "siguiente"
    ],
    [
      "go",
      "ir"
    ],
    [
      "work",
      "trabajo"
    ],
    [
      "last",
      "último"
    ],
    [
      "most",
      "muchos"
    ],
    [
      "buy",
      "creer"
    ],
    [
      "make",
      "obrar"
    ],
    [
      "them",
      "le"
    ],
    [
      "should",
      "deber"
    ],
    [
      "post",
      "poste"
    ],
    [
      "her",
      "la"
    ],
    [
      "city",
      "urbe"
    ],
    [
      "add",
      "añidir"
    ],
    [
      "policy",
      "póliza"
    ],
    [
      "number",
      "número"
    ],
    [
      "such",
      "así"
    ],
    [
      "please",
      "porfa"
    ],
    [
      "copyright",
      "derecho de copia"
    ],
    [
      "support",
      "apoyo"
    ],
    [
      "message",
      "recado"
    ],
    [
      "after",
      "tras"
    ],
    [
      "best",
      "nata"
    ],
    [
      "software",
      "sóftwer"
    ],
    [
      "then",
      "entonces"
    ],
    [
      "good",
      "bueno"
    ],
    [
      "video",
      "vídeo"
    ],
    [
      "well",
      "bien"
    ],
    [
      "where",
      "dónde"
    ],
    [
      "high",
      "alto"
    ],
    [
      "school",
      "escuela"
    ],
    [
      "through",
      "a través de"
    ],
    [
      "each",
      "sendos"
    ],
    [
      "review",
      "reseña"
    ],
    [
      "order",
      "orden"
    ],
    [
      "very",
      "asaz"
    ],
    [
      "privacy",
      "privacidad"
    ],
    [
      "book",
      "libro"
    ],
    [
      "company",
      "compaña"
    ],
    [
      "read",
      "decir"
    ],
    [
      "group",
      "grupo"
    ],
    [
      "sex",
      "sexo"
    ],
    [
      "need",
      "necesidad"
    ],
    [
      "many",
      "muchos"
    ],
    [
      "user",
      "usuaria"
    ],
    [
      "set",
      "juego"
    ],
    [
      "under",
      "bajo"
    ],
    [
      "general",
      "serasquier"
    ],
    [
      "research",
      "indagar"
    ],
    [
      "mail",
      "correo"
    ],
    [
      "full",
      "ful"
    ],
    [
      "map",
      "carta"
    ],
    [
      "life",
      "vida"
    ],
    [
      "know",
      "saber"
    ],
    [
      "way",
      "vía"
    ],
    [
      "management",
      "administración"
    ],
    [
      "part",
      "partir"
    ],
    [
      "great",
      "fetén"
    ],
    [
      "hotel",
      "albergue"
    ],
    [
      "real",
      "gran"
    ],
    [
      "item",
      "ítem"
    ],
    [
      "center",
      "pívot"
    ],
    [
      "must",
      "deber de"
    ],
    [
      "store",
      "bodega"
    ],
    [
      "travel",
      "rolear"
    ],
    [
      "development",
      "cambio"
    ],
    [
      "report",
      "informar"
    ],
    [
      "off",
      "apagado"
    ],
    [
      "member",
      "miembro"
    ],
    [
      "line",
      "línea"
    ],
    [
      "before",
      "ante"
    ],
    [
      "send",
      "mandar"
    ],
    [
      "right",
      "derecho"
    ],
    [
      "type",
      "tipear"
    ],
    [
      "because",
      "ya que"
    ],
    [
      "local",
      "vecina"
    ],
    [
      "those",
      "esas"
    ],
    [
      "office",
      "oficina"
    ],
    [
      "education",
      "educación"
    ],
    [
      "car",
      "auto"
    ],
    [
      "design",
      "modelo"
    ],
    [
      "take",
      "tomar"
    ],
    [
      "internet",
      "red"
    ],
    [
      "address",
      "dirigir"
    ],
    [
      "community",
      "comuna"
    ],
    [
      "area",
      "área"
    ],
    [
      "want",
      "afán"
    ],
    [
      "phone",
      "timbrar"
    ],
    [
      "dvd",
      "dvd"
    ],
    [
      "shipping",
      "transporte"
    ],
    [
      "subject",
      "ramo"
    ],
    [
      "forum",
      "foro"
    ],
    [
      "family",
      "familiar"
    ],
    [
      "long",
      "longo"
    ],
    [
      "based",
      "basado"
    ],
    [
      "code",
      "clave"
    ],
    [
      "show",
      "enseñar"
    ],
    [
      "o",
      "oy"
    ],
    [
      "even",
      "parejo"
    ],
    [
      "black",
      "negra"
    ],
    [
      "check",
      "comprobar"
    ],
    [
      "website",
      "web"
    ],
    [
      "index",
      "indizar"
    ],
    [
      "being",
      "ente"
    ],
    [
      "sign",
      "signo"
    ],
    [
      "file",
      "archivo"
    ],
    [
      "link",
      "enlace"
    ],
    [
      "today",
      "hoy día"
    ],
    [
      "technology",
      "técnica"
    ],
    [
      "south",
      "sud"
    ],
    [
      "case",
      "caja"
    ],
    [
      "same",
      "ídem"
    ],
    [
      "uk",
      "RU"
    ],
    [
      "section",
      "pelotón"
    ],
    [
      "own",
      "tener"
    ],
    [
      "found",
      "condir"
    ],
    [
      "house",
      "casa"
    ],
    [
      "related",
      "afín"
    ],
    [
      "security",
      "prenda"
    ],
    [
      "both",
      "entrambos"
    ],
    [
      "american",
      "americano"
    ],
    [
      "game",
      "caza"
    ],
    [
      "power",
      "poder"
    ],
    [
      "while",
      "mientras"
    ],
    [
      "care",
      "cuidar"
    ],
    [
      "network",
      "red"
    ],
    [
      "down",
      "abajo"
    ],
    [
      "computer",
      "ordenador"
    ],
    [
      "three",
      "trío"
    ],
    [
      "total",
      "suma"
    ],
    [
      "place",
      "lugar"
    ],
    [
      "end",
      "fin"
    ],
    [
      "following",
      "próximo"
    ],
    [
      "download",
      "bajar"
    ],
    [
      "him",
      "le"
    ],
    [
      "without",
      "sen"
    ],
    [
      "per",
      "por"
    ],
    [
      "access",
      "acceder"
    ],
    [
      "think",
      "pensar"
    ],
    [
      "north",
      "norteño"
    ],
    [
      "current",
      "actual"
    ],
    [
      "big",
      "mayor"
    ],
    [
      "media",
      "medios"
    ],
    [
      "law",
      "ley"
    ],
    [
      "control",
      "control"
    ],
    [
      "water",
      "agua"
    ],
    [
      "history",
      "historial"
    ],
    [
      "size",
      "cola"
    ],
    [
      "since",
      "desde"
    ],
    [
      "including",
      "inclusive"
    ],
    [
      "guide",
      "guía"
    ],
    [
      "shop",
      "taller"
    ],
    [
      "board",
      "abordar"
    ],
    [
      "location",
      "lugar"
    ],
    [
      "change",
      "cambiar"
    ],
    [
      "white",
      "blanca"
    ],
    [
      "text",
      "textear"
    ],
    [
      "small",
      "pequeño"
    ],
    [
      "rating",
      "calificación"
    ],
    [
      "rate",
      "tasa"
    ],
    [
      "government",
      "rección"
    ],
    [
      "during",
      "a lo largo de"
    ],
    [
      "return",
      "volver"
    ],
    [
      "shopping",
      "compras"
    ],
    [
      "account",
      "cuenta"
    ],
    [
      "level",
      "nivelado"
    ],
    [
      "digital",
      "dactilar"
    ],
    [
      "profile",
      "perfil"
    ],
    [
      "previous",
      "previo"
    ],
    [
      "form",
      "forma"
    ],
    [
      "love",
      "amor"
    ],
    [
      "old",
      "viejo"
    ],
    [
      "john",
      "Juan"
    ],
    [
      "main",
      "troncal"
    ],
    [
      "call",
      "llamar"
    ],
    [
      "image",
      "imagen"
    ],
    [
      "department",
      "sección"
    ],
    [
      "title",
      "tutela"
    ],
    [
      "description",
      "señalamiento"
    ],
    [
      "y",
      "ia"
    ],
    [
      "insurance",
      "aseguración"
    ],
    [
      "why",
      "por qué"
    ],
    [
      "property",
      "propiedad"
    ],
    [
      "class",
      "clase"
    ],
    [
      "still",
      "aún"
    ],
    [
      "money",
      "pecunia"
    ],
    [
      "quality",
      "calidad"
    ],
    [
      "content",
      "tenor"
    ],
    [
      "country",
      "campo"
    ],
    [
      "private",
      "cabo"
    ],
    [
      "little",
      "poco"
    ],
    [
      "visit",
      "consulta"
    ],
    [
      "save",
      "salvar"
    ],
    [
      "low",
      "abatido"
    ],
    [
      "reply",
      "repetir"
    ],
    [
      "customer",
      "vecero"
    ],
    [
      "compare",
      "carear"
    ],
    [
      "college",
      "facultad"
    ],
    [
      "value",
      "valor"
    ],
    [
      "york",
      "Yórk"
    ],
    [
      "man",
      "peón"
    ],
    [
      "card",
      "carta"
    ],
    [
      "provide",
      "brindar"
    ],
    [
      "food",
      "jama"
    ],
    [
      "source",
      "origen"
    ],
    [
      "author",
      "autora"
    ],
    [
      "different",
      "distinto"
    ],
    [
      "press",
      "pres"
    ],
    [
      "learn",
      "aprender"
    ],
    [
      "sale",
      "rebaja"
    ],
    [
      "around",
      "por"
    ],
    [
      "print",
      "emprimir"
    ],
    [
      "course",
      "curso"
    ],
    [
      "job",
      "pega"
    ],
    [
      "process",
      "tratar"
    ],
    [
      "teen",
      "ieci-"
    ],
    [
      "room",
      "cabida"
    ],
    [
      "stock",
      "alelí"
    ],
    [
      "training",
      "formación"
    ],
    [
      "too",
      "muy"
    ],
    [
      "credit",
      "crédito"
    ],
    [
      "point",
      "punto"
    ],
    [
      "join",
      "unirse"
    ],
    [
      "science",
      "ciencia"
    ],
    [
      "advanced",
      "avanzado"
    ],
    [
      "west",
      "poniente"
    ],
    [
      "look",
      "dar"
    ],
    [
      "english",
      "inglesa"
    ],
    [
      "left",
      "izquierdo"
    ],
    [
      "team",
      "yunta"
    ],
    [
      "estate",
      "heredad"
    ],
    [
      "box",
      "marco"
    ],
    [
      "select",
      "cribar"
    ],
    [
      "windows",
      "ventanaje"
    ],
    [
      "gay",
      "alegre"
    ],
    [
      "thread",
      "hilo"
    ],
    [
      "note",
      "nota"
    ],
    [
      "live",
      "en vivo"
    ],
    [
      "table",
      "tabla"
    ],
    [
      "register",
      "inscribir"
    ],
    [
      "however",
      "mas"
    ],
    [
      "market",
      "zoco"
    ],
    [
      "library",
      "librería"
    ],
    [
      "really",
      "realmente"
    ],
    [
      "start",
      "inicio"
    ],
    [
      "series",
      "serie"
    ],
    [
      "model",
      "modelar"
    ],
    [
      "air",
      "aire"
    ],
    [
      "plan",
      "plan"
    ],
    [
      "human",
      "hombre"
    ],
    [
      "provided",
      "con tal que"
    ],
    [
      "tv",
      "tv"
    ],
    [
      "yes",
      "dí"
    ],
    [
      "second",
      "secundar"
    ],
    [
      "hot",
      "caliente"
    ],
    [
      "cost",
      "costa"
    ],
    [
      "movie",
      "filme"
    ],
    [
      "march",
      "marca"
    ],
    [
      "september",
      "setiembre"
    ],
    [
      "better",
      "mejores"
    ],
    [
      "say",
      "decir"
    ],
    [
      "test",
      "probar"
    ],
    [
      "friend",
      "mijo"
    ],
    [
      "come",
      "acabar"
    ],
    [
      "server",
      "servidor"
    ],
    [
      "study",
      "estudiar"
    ],
    [
      "application",
      "solicitud"
    ],
    [
      "cart",
      "carreta"
    ],
    [
      "staff",
      "pauta"
    ],
    [
      "feedback",
      "retroalimentación"
    ],
    [
      "again",
      "nuevamente"
    ],
    [
      "play",
      "tocar"
    ],
    [
      "never",
      "jamás"
    ],
    [
      "complete",
      "cabalar"
    ],
    [
      "street",
      "lleca"
    ],
    [
      "topic",
      "bolá"
    ],
    [
      "working",
      "básico"
    ],
    [
      "against",
      "contra"
    ],
    [
      "standard",
      "estándard"
    ],
    [
      "tax",
      "mita"
    ],
    [
      "person",
      "persona"
    ],
    [
      "below",
      "so"
    ],
    [
      "mobile",
      "movible"
    ],
    [
      "less",
      "es-"
    ],
    [
      "blog",
      "bitácora"
    ],
    [
      "party",
      "parte"
    ],
    [
      "payment",
      "pago"
    ],
    [
      "equipment",
      "equipamiento"
    ],
    [
      "login",
      "credenciales"
    ],
    [
      "student",
      "alumna"
    ],
    [
      "let",
      "alquilar"
    ],
    [
      "legal",
      "legal"
    ],
    [
      "above",
      "suso"
    ],
    [
      "park",
      "parque"
    ],
    [
      "side",
      "lado"
    ],
    [
      "act",
      "comportar"
    ],
    [
      "problem",
      "problema"
    ],
    [
      "red",
      "rojo"
    ],
    [
      "give",
      "dar"
    ],
    [
      "memory",
      "memoria"
    ],
    [
      "performance",
      "desempeño"
    ],
    [
      "august",
      "noble"
    ],
    [
      "quote",
      "cita"
    ],
    [
      "language",
      "lenguaje"
    ],
    [
      "story",
      "cuento"
    ],
    [
      "sell",
      "salir"
    ],
    [
      "experience",
      "vivir"
    ],
    [
      "create",
      "crear"
    ],
    [
      "key",
      "clave"
    ],
    [
      "body",
      "carcasa"
    ],
    [
      "field",
      "campo"
    ],
    [
      "few",
      "pocas"
    ],
    [
      "east",
      "oriente"
    ],
    [
      "paper",
      "papel"
    ],
    [
      "single",
      "soltero"
    ],
    [
      "age",
      "edad"
    ],
    [
      "club",
      "palo"
    ],
    [
      "example",
      "ejemplo"
    ],
    [
      "additional",
      "extra"
    ],
    [
      "password",
      "contraseña"
    ],
    [
      "something",
      "alguna cosa"
    ],
    [
      "road",
      "camino"
    ],
    [
      "gift",
      "dar"
    ],
    [
      "question",
      "cuestión"
    ],
    [
      "night",
      "noche"
    ],
    [
      "hard",
      "duro"
    ],
    [
      "texas",
      "Tejas"
    ],
    [
      "pay",
      "pago"
    ],
    [
      "poker",
      "póker"
    ],
    [
      "status",
      "status"
    ],
    [
      "browse",
      "ojear"
    ],
    [
      "issue",
      "expedir"
    ],
    [
      "range",
      "rango"
    ],
    [
      "building",
      "edificación"
    ],
    [
      "seller",
      "vendedora"
    ],
    [
      "court",
      "corte"
    ],
    [
      "result",
      "acarrear"
    ],
    [
      "audio",
      "de sonido"
    ],
    [
      "light",
      "ligero"
    ],
    [
      "write",
      "anotar"
    ],
    [
      "war",
      "hacer la guerra"
    ],
    [
      "offer",
      "convite"
    ],
    [
      "blue",
      "celeste"
    ],
    [
      "easy",
      "fácil"
    ],
    [
      "given",
      "postulado"
    ],
    [
      "event",
      "suceso"
    ],
    [
      "release",
      "liberar"
    ],
    [
      "request",
      "pedido"
    ],
    [
      "fax",
      "telefax"
    ],
    [
      "china",
      "Catay"
    ],
    [
      "picture",
      "cine"
    ],
    [
      "might",
      "potencia"
    ],
    [
      "professional",
      "profesional"
    ],
    [
      "yet",
      "aún"
    ],
    [
      "major",
      "mayor"
    ],
    [
      "star",
      "estrella"
    ],
    [
      "future",
      "porvenir"
    ],
    [
      "committee",
      "comisión"
    ],
    [
      "hand",
      "dar"
    ],
    [
      "sun",
      "solearse"
    ],
    [
      "london",
      "Londres"
    ],
    [
      "meeting",
      "junta"
    ],
    [
      "become",
      "hacer"
    ],
    [
      "interest",
      "aras"
    ],
    [
      "id",
      "ido"
    ],
    [
      "child",
      "niña"
    ],
    [
      "keep",
      "mantener"
    ],
    [
      "enter",
      "poner"
    ],
    [
      "share",
      "compartir"
    ],
    [
      "similar",
      "semejante"
    ],
    [
      "garden",
      "jardín"
    ],
    [
      "baby",
      "nene"
    ],
    [
      "learning",
      "conocimiento"
    ],
    [
      "run",
      "andar"
    ],
    [
      "delivery",
      "parto"
    ],
    [
      "net",
      "red"
    ],
    [
      "term",
      "término"
    ],
    [
      "film",
      "film"
    ],
    [
      "put",
      "sestar"
    ],
    [
      "journal",
      "muñón"
    ],
    [
      "try",
      "judgar"
    ],
    [
      "welcome",
      "bienvenida"
    ],
    [
      "president",
      "presidenta"
    ],
    [
      "notice",
      "aviso"
    ],
    [
      "god",
      "deificar"
    ],
    [
      "original",
      "único"
    ],
    [
      "head",
      "cabeza"
    ],
    [
      "radio",
      "radio"
    ],
    [
      "until",
      "antes"
    ],
    [
      "cell",
      "celda"
    ],
    [
      "color",
      "teñir"
    ],
    [
      "council",
      "consejo"
    ],
    [
      "away",
      "fuera"
    ],
    [
      "track",
      "vía"
    ],
    [
      "discussion",
      "interlocución"
    ],
    [
      "once",
      "antes"
    ],
    [
      "others",
      "otros"
    ],
    [
      "entertainment",
      "trebejo"
    ],
    [
      "agreement",
      "acuerdo"
    ],
    [
      "least",
      "lo más mínimo"
    ],
    [
      "society",
      "sociedad"
    ],
    [
      "log",
      "leño"
    ],
    [
      "safety",
      "seguro"
    ],
    [
      "sure",
      "cierto"
    ],
    [
      "faq",
      "PUF"
    ],
    [
      "trade",
      "gremio"
    ],
    [
      "edition",
      "tiraje"
    ],
    [
      "marketing",
      "marketeo"
    ],
    [
      "tell",
      "notar"
    ],
    [
      "further",
      "extra"
    ],
    [
      "able",
      "ible"
    ],
    [
      "fun",
      "gracia"
    ],
    [
      "close",
      "cerrar"
    ],
    [
      "common",
      "común"
    ],
    [
      "drive",
      "conducir"
    ],
    [
      "several",
      "varias"
    ],
    [
      "gold",
      "áureo"
    ],
    [
      "living",
      "vivo"
    ],
    [
      "collection",
      "colección"
    ],
    [
      "short",
      "bajo"
    ],
    [
      "lot",
      "loteo"
    ],
    [
      "ask",
      "pedir"
    ],
    [
      "display",
      "exhibir"
    ],
    [
      "means",
      "medios"
    ],
    [
      "director",
      "directora"
    ],
    [
      "daily",
      "diario"
    ],
    [
      "beach",
      "varar"
    ],
    [
      "past",
      "pretérito"
    ],
    [
      "whether",
      "si"
    ],
    [
      "due",
      "ser para"
    ],
    [
      "upon",
      "tras"
    ],
    [
      "period",
      "periodo"
    ],
    [
      "planning",
      "planeamiento"
    ],
    [
      "database",
      "base de datos"
    ],
    [
      "weather",
      "cariz"
    ],
    [
      "mar",
      "dañar"
    ],
    [
      "land",
      "patria"
    ],
    [
      "average",
      "común"
    ],
    [
      "done",
      "acabado"
    ],
    [
      "window",
      "ventana"
    ],
    [
      "pro",
      "experto"
    ],
    [
      "island",
      "isla"
    ],
    [
      "record",
      "anotar"
    ],
    [
      "environment",
      "ambiente"
    ],
    [
      "st",
      "Sta."
    ],
    [
      "calendar",
      "agenda"
    ],
    [
      "style",
      "estilo"
    ],
    [
      "front",
      "fingir"
    ],
    [
      "statement",
      "resumen"
    ],
    [
      "parts",
      "partes"
    ],
    [
      "ever",
      "jamás"
    ],
    [
      "early",
      "temprano"
    ],
    [
      "sound",
      "son"
    ],
    [
      "resource",
      "dotar"
    ],
    [
      "present",
      "actual"
    ],
    [
      "ago",
      "ha"
    ],
    [
      "document",
      "anotar"
    ],
    [
      "word",
      "palabra"
    ],
    [
      "material",
      "menaje"
    ],
    [
      "bill",
      "nota"
    ],
    [
      "written",
      "escripto"
    ],
    [
      "talk",
      "fablar"
    ],
    [
      "final",
      "último"
    ],
    [
      "adult",
      "adulta"
    ],
    [
      "thing",
      "objeto"
    ],
    [
      "via",
      "por"
    ],
    [
      "cheap",
      "chafa"
    ],
    [
      "nude",
      "pack"
    ],
    [
      "true",
      "verdadero"
    ],
    [
      "else",
      "más"
    ],
    [
      "mark",
      "marca"
    ],
    [
      "third",
      "tercera"
    ],
    [
      "rock",
      "roca"
    ],
    [
      "reading",
      "leída"
    ],
    [
      "bad",
      "desagradable"
    ],
    [
      "individual",
      "propio"
    ],
    [
      "plus",
      "más"
    ],
    [
      "cover",
      "cubrir"
    ],
    [
      "usually",
      "normalmente"
    ],
    [
      "edit",
      "redactar"
    ],
    [
      "together",
      "yunto"
    ],
    [
      "fast",
      "veloz"
    ],
    [
      "function",
      "servir"
    ],
    [
      "fact",
      "hecho"
    ],
    [
      "global",
      "mundial"
    ],
    [
      "meet",
      "encontrarse"
    ],
    [
      "far",
      "lueñe"
    ],
    [
      "player",
      "reproductor"
    ],
    [
      "lyrics",
      "lírica"
    ],
    [
      "often",
      "seguido"
    ],
    [
      "subscribe",
      "abonar"
    ],
    [
      "submit",
      "cursar"
    ],
    [
      "amount",
      "monto"
    ],
    [
      "watch",
      "aguaitar"
    ],
    [
      "feel",
      "sentir"
    ],
    [
      "though",
      "maguer"
    ],
    [
      "bank",
      "banco"
    ],
    [
      "risk",
      "risco"
    ],
    [
      "thanks",
      "agradecimiento"
    ],
    [
      "various",
      "varios"
    ],
    [
      "production",
      "producción"
    ],
    [
      "commercial",
      "spot"
    ],
    [
      "james",
      "Yago"
    ],
    [
      "weight",
      "peso"
    ],
    [
      "town",
      "villa"
    ],
    [
      "heart",
      "corazón"
    ],
    [
      "choose",
      "desear"
    ],
    [
      "treatment",
      "tratamiento"
    ],
    [
      "newsletter",
      "boletín de noticias"
    ],
    [
      "points",
      "suiche"
    ],
    [
      "knowledge",
      "conocencia"
    ],
    [
      "magazine",
      "magacín"
    ],
    [
      "error",
      "yerro"
    ],
    [
      "camera",
      "kodak"
    ],
    [
      "girl",
      "niña"
    ],
    [
      "currently",
      "hoy"
    ],
    [
      "construction",
      "cimentación"
    ],
    [
      "clear",
      "claro"
    ],
    [
      "domain",
      "esfera"
    ],
    [
      "chapter",
      "sede"
    ],
    [
      "loan",
      "empréstito"
    ],
    [
      "wide",
      "amplio"
    ],
    [
      "beauty",
      "belleza"
    ],
    [
      "manager",
      "jefe"
    ],
    [
      "position",
      "cargo"
    ],
    [
      "sort",
      "jaez"
    ],
    [
      "michael",
      "Misel"
    ],
    [
      "known",
      "sabido"
    ],
    [
      "half",
      "mitad"
    ],
    [
      "step",
      "paso"
    ],
    [
      "engineering",
      "sala de máquinas"
    ],
    [
      "simple",
      "sencillo"
    ],
    [
      "quick",
      "célere"
    ],
    [
      "none",
      "nadie"
    ],
    [
      "license",
      "licencia"
    ],
    [
      "lake",
      "lago"
    ],
    [
      "whole",
      "todo"
    ],
    [
      "annual",
      "anuo"
    ],
    [
      "later",
      "más tarde"
    ],
    [
      "basic",
      "chapi"
    ],
    [
      "corporate",
      "incorporado"
    ],
    [
      "google",
      "guglear"
    ],
    [
      "church",
      "misa"
    ],
    [
      "method",
      "method"
    ],
    [
      "purchase",
      "adquisición"
    ],
    [
      "response",
      "respuesta"
    ],
    [
      "practice",
      "práctica"
    ],
    [
      "hardware",
      "hárdwer"
    ],
    [
      "figure",
      "cifra"
    ],
    [
      "fire",
      "fuego"
    ],
    [
      "holiday",
      "vacaciones"
    ],
    [
      "chat",
      "lata"
    ],
    [
      "enough",
      "bastante"
    ],
    [
      "along",
      "por"
    ],
    [
      "death",
      "muerte"
    ],
    [
      "writing",
      "escriptura"
    ],
    [
      "speed",
      "rapidez"
    ],
    [
      "loss",
      "derrota"
    ],
    [
      "face",
      "faz"
    ],
    [
      "brand",
      "marca"
    ],
    [
      "discount",
      "rebaja"
    ],
    [
      "remember",
      "memorar"
    ],
    [
      "oil",
      "engrasar"
    ],
    [
      "bit",
      "binio"
    ],
    [
      "yellow",
      "cobarde"
    ],
    [
      "increase",
      "subir"
    ],
    [
      "advertise",
      "publicitar"
    ],
    [
      "base",
      "sede"
    ],
    [
      "near",
      "casi"
    ],
    [
      "environmental",
      "medioambiental"
    ],
    [
      "stuff",
      "cosas"
    ],
    [
      "french",
      "francés"
    ],
    [
      "storage",
      "bodega"
    ],
    [
      "oh",
      "ay"
    ],
    [
      "japan",
      "Cipango"
    ],
    [
      "entry",
      "entrada"
    ],
    [
      "stay",
      "quedar"
    ],
    [
      "nature",
      "natura"
    ],
    [
      "summary",
      "sumario"
    ],
    [
      "turn",
      "virar"
    ],
    [
      "mean",
      "malo"
    ],
    [
      "agency",
      "agencia"
    ],
    [
      "king",
      "dama"
    ],
    [
      "european",
      "europea"
    ],
    [
      "copy",
      "copiar"
    ],
    [
      "although",
      "aunque"
    ],
    [
      "drug",
      "droga"
    ],
    [
      "western",
      "oesteño"
    ],
    [
      "income",
      "ingresos"
    ],
    [
      "force",
      "obligar"
    ],
    [
      "cash",
      "guita"
    ],
    [
      "overall",
      "mono"
    ],
    [
      "bay",
      "alazán"
    ],
    [
      "river",
      "río"
    ],
    [
      "commission",
      "comisión"
    ],
    [
      "package",
      "paquete"
    ],
    [
      "port",
      "babor"
    ],
    [
      "stop",
      "parar"
    ],
    [
      "bar",
      "barra"
    ],
    [
      "double",
      "duplicar"
    ],
    [
      "dog",
      "can"
    ],
    [
      "build",
      "compilar"
    ],
    [
      "screen",
      "filtrar"
    ],
    [
      "exchange",
      "intercambiar"
    ],
    [
      "soon",
      "aína"
    ],
    [
      "electronic",
      "electrónica"
    ],
    [
      "continue",
      "seguir"
    ],
    [
      "across",
      "cruzando"
    ],
    [
      "season",
      "época"
    ],
    [
      "apply",
      "aplicar"
    ],
    [
      "someone",
      "alguno"
    ],
    [
      "printer",
      "impresora"
    ],
    [
      "condition",
      "condición"
    ],
    [
      "effective",
      "efectivo"
    ],
    [
      "believe",
      "creer"
    ],
    [
      "effect",
      "vigor"
    ],
    [
      "mind",
      "cuidar"
    ],
    [
      "tour",
      "tour"
    ],
    [
      "menu",
      "menú"
    ],
    [
      "volume",
      "volumen"
    ],
    [
      "cross",
      "cruz"
    ],
    [
      "anyone",
      "quien"
    ],
    [
      "hope",
      "desear"
    ],
    [
      "silver",
      "luna"
    ],
    [
      "corporation",
      "sociedad anónima"
    ],
    [
      "wish",
      "gana"
    ],
    [
      "inside",
      "dentro"
    ],
    [
      "solution",
      "solución"
    ],
    [
      "mature",
      "curado"
    ],
    [
      "role",
      "rol"
    ],
    [
      "rather",
      "más bien"
    ],
    [
      "addition",
      "adición"
    ],
    [
      "supply",
      "abasto"
    ],
    [
      "nothing",
      "naranjas"
    ],
    [
      "certain",
      "cierto"
    ],
    [
      "running",
      "manejo"
    ],
    [
      "lower",
      "abajar"
    ],
    [
      "necessary",
      "preciso"
    ],
    [
      "clothing",
      "ropa"
    ],
    [
      "fine",
      "fino"
    ],
    [
      "gas",
      "nafta"
    ],
    [
      "bush",
      "pendejos"
    ],
    [
      "advice",
      "aviso"
    ],
    [
      "military",
      "militar"
    ],
    [
      "leave",
      "dejar"
    ],
    [
      "british",
      "britano"
    ],
    [
      "huge",
      "grandote"
    ],
    [
      "woman",
      "jerma"
    ],
    [
      "zip",
      "subir el síper"
    ],
    [
      "bid",
      "pujar"
    ],
    [
      "kind",
      "clan"
    ],
    [
      "middle",
      "centro"
    ],
    [
      "move",
      "mover"
    ],
    [
      "cable",
      "cuerda"
    ],
    [
      "division",
      "parte"
    ],
    [
      "coming",
      "viniente"
    ],
    [
      "object",
      "objeto"
    ],
    [
      "lesbian",
      "lésbico"
    ],
    [
      "appropriate",
      "adecuado"
    ],
    [
      "machine",
      "coche"
    ],
    [
      "logo",
      "logotipo"
    ],
    [
      "length",
      "largo"
    ],
    [
      "actually",
      "de vero"
    ],
    [
      "nice",
      "majo"
    ],
    [
      "score",
      "mojar"
    ],
    [
      "ok",
      "okey"
    ],
    [
      "capital",
      "excelente"
    ],
    [
      "sample",
      "muestra"
    ],
    [
      "investment",
      "cerco"
    ],
    [
      "christmas",
      "Crismes"
    ],
    [
      "culture",
      "cultivo"
    ],
    [
      "band",
      "banda"
    ],
    [
      "flash",
      "tris"
    ],
    [
      "ms",
      "Señora"
    ],
    [
      "lead",
      "llevar"
    ],
    [
      "choice",
      "opción"
    ],
    [
      "registration",
      "registro"
    ],
    [
      "thursday",
      "jueves"
    ],
    [
      "foreign",
      "extranjero"
    ],
    [
      "outside",
      "fuera"
    ],
    [
      "furniture",
      "enseres"
    ],
    [
      "channel",
      "canal"
    ],
    [
      "letter",
      "carta"
    ],
    [
      "mode",
      "moda"
    ],
    [
      "fund",
      "fondo"
    ],
    [
      "summer",
      "estío"
    ],
    [
      "allow",
      "dejar"
    ],
    [
      "degree",
      "grado"
    ],
    [
      "contract",
      "contraer"
    ],
    [
      "button",
      "botón"
    ],
    [
      "wed",
      "casarse"
    ],
    [
      "super",
      "requete-"
    ],
    [
      "male",
      "macho"
    ],
    [
      "matter",
      "materia"
    ],
    [
      "custom",
      "usanza"
    ],
    [
      "almost",
      "cuasi"
    ],
    [
      "multiple",
      "múltiple"
    ],
    [
      "asian",
      "asiano"
    ],
    [
      "distribution",
      "cabezaje"
    ],
    [
      "editor",
      "editora"
    ],
    [
      "inn",
      "fonda"
    ],
    [
      "industrial",
      "fabril"
    ],
    [
      "potential",
      "posible"
    ],
    [
      "song",
      "rola"
    ],
    [
      "focus",
      "foco"
    ],
    [
      "late",
      "largo"
    ],
    [
      "fall",
      "caer"
    ],
    [
      "idea",
      "plano"
    ],
    [
      "female",
      "hembra"
    ],
    [
      "responsible",
      "de responsabilidad"
    ],
    [
      "win",
      "vencer"
    ],
    [
      "primary",
      "básico"
    ],
    [
      "cancer",
      "cancro"
    ],
    [
      "numbers",
      "Los Números"
    ],
    [
      "reason",
      "causa"
    ],
    [
      "tool",
      "utensilio"
    ],
    [
      "spring",
      "esprín"
    ],
    [
      "foundation",
      "cimiento"
    ],
    [
      "answer",
      "contestar"
    ],
    [
      "voice",
      "voz"
    ],
    [
      "friendly",
      "amical"
    ],
    [
      "schedule",
      "adiar"
    ],
    [
      "communication",
      "comunicado"
    ],
    [
      "purpose",
      "objeto"
    ],
    [
      "feature",
      "cualidad"
    ],
    [
      "bed",
      "cama"
    ],
    [
      "police",
      "tombería"
    ],
    [
      "everyone",
      "todo quisqui"
    ],
    [
      "approach",
      "plantear"
    ],
    [
      "brown",
      "café"
    ],
    [
      "hill",
      "loma"
    ],
    [
      "medicine",
      "fármaco"
    ],
    [
      "deal",
      "repartir"
    ],
    [
      "hold",
      "sostener"
    ],
    [
      "glass",
      "vaso"
    ],
    [
      "happy",
      "feliz"
    ],
    [
      "smith",
      "Herrera"
    ],
    [
      "wanted",
      "buscado"
    ],
    [
      "safe",
      "sano"
    ],
    [
      "unique",
      "señero"
    ],
    [
      "survey",
      "sondeo"
    ],
    [
      "prior",
      "priora"
    ],
    [
      "telephone",
      "llamar"
    ],
    [
      "sport",
      "burla"
    ],
    [
      "ready",
      "listoco"
    ],
    [
      "feed",
      "cebar"
    ],
    [
      "animal",
      "bestia"
    ],
    [
      "mexico",
      "Méjico"
    ],
    [
      "pa",
      "abuelo"
    ],
    [
      "regular",
      "asiduo"
    ],
    [
      "secure",
      "seguro"
    ],
    [
      "navigation",
      "náutica"
    ],
    [
      "therefore",
      "por eso"
    ],
    [
      "ass",
      "burro"
    ],
    [
      "simply",
      "simplemente"
    ],
    [
      "evidence",
      "prueba"
    ],
    [
      "christian",
      "cristiana"
    ],
    [
      "round",
      "ronda"
    ],
    [
      "understand",
      "comprender"
    ],
    [
      "option",
      "opciones"
    ],
    [
      "master",
      "maestro"
    ],
    [
      "recently",
      "recién"
    ],
    [
      "probably",
      "seguro"
    ],
    [
      "sea",
      "ponto"
    ],
    [
      "built",
      "trepado"
    ],
    [
      "blood",
      "sangre"
    ],
    [
      "cut",
      "cortar"
    ],
    [
      "improve",
      "embonar"
    ],
    [
      "connection",
      "conexión"
    ],
    [
      "publisher",
      "editorial"
    ],
    [
      "hall",
      "jol"
    ],
    [
      "earth",
      "tierra"
    ],
    [
      "impact",
      "efecto"
    ],
    [
      "transfer",
      "calco"
    ],
    [
      "introduction",
      "introducción"
    ],
    [
      "strong",
      "fuerte"
    ],
    [
      "wedding",
      "casorio"
    ],
    [
      "hospital",
      "nosocomio"
    ],
    [
      "ground",
      "fondo"
    ],
    [
      "overview",
      "descripción general"
    ],
    [
      "ship",
      "dad"
    ],
    [
      "accommodation",
      "acomodación"
    ],
    [
      "disease",
      "dolencia"
    ],
    [
      "excellent",
      "groso"
    ],
    [
      "hair",
      "pelo"
    ],
    [
      "kit",
      "juego"
    ],
    [
      "basis",
      "basa"
    ],
    [
      "command",
      "mando"
    ],
    [
      "express",
      "expremir"
    ],
    [
      "anal",
      "fastidioso"
    ],
    [
      "award",
      "fallar"
    ],
    [
      "distance",
      "lejanía"
    ],
    [
      "tree",
      "fuste"
    ],
    [
      "assessment",
      "evaluación"
    ],
    [
      "ensure",
      "velar"
    ],
    [
      "thus",
      "así"
    ],
    [
      "wall",
      "muro"
    ],
    [
      "extra",
      "exceso"
    ],
    [
      "especially",
      "máxime"
    ],
    [
      "interface",
      "interfase"
    ],
    [
      "pussy",
      "coño"
    ],
    [
      "success",
      "acierto"
    ],
    [
      "maximum",
      "máximum"
    ],
    [
      "quite",
      "bastante"
    ],
    [
      "selected",
      "seleccionado"
    ],
    [
      "boy",
      "muchacho"
    ],
    [
      "beautiful",
      "bravo"
    ],
    [
      "warning",
      "aviso"
    ],
    [
      "wine",
      "oporto"
    ],
    [
      "horse",
      "caballo"
    ],
    [
      "forward",
      "avante"
    ],
    [
      "significant",
      "importante"
    ],
    [
      "owner",
      "dueño"
    ],
    [
      "retail",
      "al por menor"
    ],
    [
      "directly",
      "directe"
    ],
    [
      "manufacturer",
      "fabriquero"
    ],
    [
      "est",
      "as"
    ],
    [
      "son",
      "hijo"
    ],
    [
      "rule",
      "molar"
    ],
    [
      "housing",
      "vivienda"
    ],
    [
      "bring",
      "traer"
    ],
    [
      "trying",
      "riguroso"
    ],
    [
      "authority",
      "autoridad"
    ],
    [
      "traffic",
      "trata"
    ],
    [
      "input",
      "input"
    ],
    [
      "valid",
      "válido"
    ],
    [
      "bin",
      "caneca"
    ],
    [
      "senior",
      "experimentado"
    ],
    [
      "sexy",
      "sexi"
    ],
    [
      "teaching",
      "docencia"
    ],
    [
      "door",
      "postigo"
    ],
    [
      "grand",
      "majestuoso"
    ],
    [
      "trial",
      "cotejo"
    ],
    [
      "charge",
      "cargar"
    ],
    [
      "instead",
      "mejor"
    ],
    [
      "cool",
      "guay"
    ],
    [
      "normal",
      "bien"
    ],
    [
      "enterprise",
      "empuje"
    ],
    [
      "educational",
      "educativo"
    ],
    [
      "positive",
      "positivo"
    ],
    [
      "fitness",
      "ámbito"
    ],
    [
      "chinese",
      "china"
    ],
    [
      "opinion",
      "juicio"
    ],
    [
      "football",
      "futbol"
    ],
    [
      "abstract",
      "extraer"
    ],
    [
      "output",
      "egreso"
    ],
    [
      "greater",
      "más grande / importante / grandioso"
    ],
    [
      "likely",
      "creíble"
    ],
    [
      "develop",
      "revelar"
    ],
    [
      "alternative",
      "alternativa"
    ],
    [
      "guest",
      "visita"
    ],
    [
      "pass",
      "pasar"
    ],
    [
      "trust",
      "fiar"
    ],
    [
      "van",
      "combi"
    ],
    [
      "vacation",
      "vacación"
    ],
    [
      "century",
      "centuria"
    ],
    [
      "academic",
      "escolar"
    ],
    [
      "completed",
      "terminado"
    ],
    [
      "skin",
      "piel"
    ],
    [
      "indian",
      "indo"
    ],
    [
      "ring",
      "anillo"
    ],
    [
      "grade",
      "grado"
    ],
    [
      "dating",
      "datación"
    ],
    [
      "mountain",
      "monte"
    ],
    [
      "filter",
      "colador"
    ],
    [
      "vehicle",
      "vehículo"
    ],
    [
      "consider",
      "barajar"
    ],
    [
      "northern",
      "boreal"
    ],
    [
      "behind",
      "atrás"
    ],
    [
      "panel",
      "painel"
    ],
    [
      "floor",
      "piso"
    ],
    [
      "german",
      "alemana"
    ],
    [
      "match",
      "pareja"
    ],
    [
      "default",
      "no pagar"
    ],
    [
      "require",
      "requerir"
    ],
    [
      "iraq",
      "Iraq"
    ],
    [
      "outdoor",
      "al fresco"
    ],
    [
      "deep",
      "profundo"
    ],
    [
      "morning",
      "matina"
    ],
    [
      "otherwise",
      "otramente"
    ],
    [
      "rest",
      "descanso"
    ],
    [
      "protein",
      "albúmina"
    ],
    [
      "plant",
      "colocar"
    ],
    [
      "hit",
      "éxito"
    ],
    [
      "pool",
      "poza"
    ],
    [
      "partner",
      "compañero"
    ],
    [
      "disclaimer",
      "advertencia"
    ],
    [
      "faculty",
      "facultad"
    ],
    [
      "fish",
      "pez"
    ],
    [
      "eye",
      "ojo"
    ],
    [
      "string",
      "cuerda"
    ],
    [
      "sense",
      "sensar"
    ],
    [
      "pack",
      "baraja"
    ],
    [
      "stage",
      "plató"
    ],
    [
      "internal",
      "interno"
    ],
    [
      "goods",
      "bienes"
    ],
    [
      "born",
      "nato"
    ],
    [
      "unless",
      "salvo"
    ],
    [
      "detailed",
      "detenido"
    ],
    [
      "japanese",
      "nipón"
    ],
    [
      "race",
      "raza"
    ],
    [
      "background",
      "fondo"
    ],
    [
      "target",
      "objetivo"
    ],
    [
      "except",
      "menos"
    ],
    [
      "character",
      "carácter"
    ],
    [
      "maintenance",
      "manutención"
    ],
    [
      "ability",
      "capacidad"
    ],
    [
      "maybe",
      "acaso"
    ],
    [
      "moving",
      "enternecedor"
    ],
    [
      "pretty",
      "bonito"
    ],
    [
      "southern",
      "sureño"
    ],
    [
      "yourself",
      "se"
    ],
    [
      "rape",
      "forzar"
    ],
    [
      "battery",
      "batería"
    ],
    [
      "youth",
      "mozo"
    ],
    [
      "pressure",
      "presión"
    ],
    [
      "debt",
      "pufo"
    ],
    [
      "medium",
      "medio"
    ],
    [
      "television",
      "tele"
    ],
    [
      "core",
      "núcleo"
    ],
    [
      "break",
      "romper"
    ],
    [
      "throughout",
      "todo"
    ],
    [
      "dance",
      "danza"
    ],
    [
      "wood",
      "leña"
    ],
    [
      "itself",
      "solo"
    ],
    [
      "fee",
      "cuota"
    ],
    [
      "studio",
      "estudio"
    ],
    [
      "reader",
      "lector"
    ],
    [
      "device",
      "aparejo"
    ],
    [
      "rent",
      "logar"
    ],
    [
      "remote",
      "mando"
    ],
    [
      "dark",
      "oscuro"
    ],
    [
      "apple",
      "poma"
    ],
    [
      "regarding",
      "atañendo"
    ],
    [
      "enjoy",
      "fruir"
    ],
    [
      "remove",
      "detraer"
    ],
    [
      "aid",
      "auxilio"
    ],
    [
      "minimum",
      "mínimum"
    ],
    [
      "host",
      "alojar"
    ],
    [
      "isbn",
      "Número Internacional Normalizado del Libro"
    ],
    [
      "manual",
      "vademécum"
    ],
    [
      "block",
      "bloquear"
    ],
    [
      "repair",
      "apañar"
    ],
    [
      "fair",
      "feria"
    ],
    [
      "steel",
      "chaira"
    ],
    [
      "understanding",
      "compromiso"
    ],
    [
      "wrong",
      "falso"
    ],
    [
      "beginning",
      "inicio"
    ],
    [
      "finally",
      "finalmente"
    ],
    [
      "paris",
      "París"
    ],
    [
      "sector",
      "rubro"
    ],
    [
      "capacity",
      "cupo"
    ],
    [
      "jersey",
      "camiseta"
    ],
    [
      "fat",
      "grueso"
    ],
    [
      "fully",
      "completamente"
    ],
    [
      "father",
      "producir"
    ],
    [
      "electric",
      "eléctrico"
    ],
    [
      "saw",
      "dicho"
    ],
    [
      "officer",
      "oficial"
    ],
    [
      "driver",
      "conductora"
    ],
    [
      "dead",
      "muerto"
    ],
    [
      "unknown",
      "ignoto"
    ],
    [
      "restaurant",
      "restorán"
    ],
    [
      "mike",
      "Migue"
    ],
    [
      "trip",
      "flipe"
    ],
    [
      "worth",
      "valer"
    ],
    [
      "poor",
      "pobre"
    ],
    [
      "teacher",
      "docente"
    ],
    [
      "eyes",
      "lumbreras"
    ],
    [
      "relationship",
      "noviazgo"
    ],
    [
      "farm",
      "finca"
    ],
    [
      "fucking",
      "puto"
    ],
    [
      "peace",
      "paz"
    ],
    [
      "traditional",
      "tradicionalista"
    ],
    [
      "tom",
      "macho"
    ],
    [
      "showing",
      "tanda"
    ],
    [
      "creative",
      "creativa"
    ],
    [
      "coast",
      "costear"
    ],
    [
      "benefit",
      "ventaja"
    ],
    [
      "funding",
      "fondos"
    ],
    [
      "lord",
      "señor"
    ],
    [
      "grant",
      "otorgar"
    ],
    [
      "sub",
      "ictíneo"
    ],
    [
      "agree",
      "concordar"
    ],
    [
      "hear",
      "escuchar"
    ],
    [
      "sometimes",
      "algunas veces"
    ],
    [
      "beyond",
      "allende"
    ],
    [
      "themselves",
      "se"
    ],
    [
      "fan",
      "abano"
    ],
    [
      "transport",
      "exiliar"
    ],
    [
      "interesting",
      "que tiene interés"
    ],
    [
      "wife",
      "jerma"
    ],
    [
      "former",
      "aquel"
    ],
    [
      "implementation",
      "implementación"
    ],
    [
      "ten",
      "diez"
    ],
    [
      "zone",
      "declarar"
    ],
    [
      "complex",
      "complejo"
    ],
    [
      "th",
      "to"
    ],
    [
      "cat",
      "gato"
    ],
    [
      "die",
      "matriz"
    ],
    [
      "jack",
      "clavija"
    ],
    [
      "flat",
      "soso"
    ],
    [
      "flow",
      "manar"
    ],
    [
      "parent",
      "madre"
    ],
    [
      "spanish",
      "castellano"
    ],
    [
      "michigan",
      "Michigan"
    ],
    [
      "setting",
      "configuración"
    ],
    [
      "dr",
      "Dra."
    ],
    [
      "scale",
      "escala"
    ],
    [
      "stand",
      "atril"
    ],
    [
      "helpful",
      "ayudador"
    ],
    [
      "monthly",
      "mensil"
    ],
    [
      "critical",
      "crítico"
    ],
    [
      "frame",
      "cuadro"
    ],
    [
      "secretary",
      "secretario"
    ],
    [
      "networking",
      "hacer red"
    ],
    [
      "path",
      "camino"
    ],
    [
      "australian",
      "australiana"
    ],
    [
      "employee",
      "empleada"
    ],
    [
      "chief",
      "jefe"
    ],
    [
      "bottom",
      "culo"
    ],
    [
      "detail",
      "detalle"
    ],
    [
      "pet",
      "popar"
    ],
    [
      "begin",
      "empezar"
    ],
    [
      "royal",
      "regio"
    ],
    [
      "clean",
      "limpio"
    ],
    [
      "switch",
      "suiche"
    ],
    [
      "russian",
      "rusa"
    ],
    [
      "african",
      "africana"
    ],
    [
      "guy",
      "güey"
    ],
    [
      "relevant",
      "pertinente"
    ],
    [
      "justice",
      "gura"
    ],
    [
      "connect",
      "conectar"
    ],
    [
      "cup",
      "copa"
    ],
    [
      "basket",
      "canasta"
    ],
    [
      "weekly",
      "todas las semanas"
    ],
    [
      "demand",
      "demandar"
    ],
    [
      "square",
      "cuadrado"
    ],
    [
      "advance",
      "avance"
    ],
    [
      "skip",
      "saltar"
    ],
    [
      "diet",
      "régimen"
    ],
    [
      "army",
      "ejército"
    ],
    [
      "auction",
      "remate"
    ],
    [
      "gear",
      "marcha"
    ],
    [
      "lee",
      "socaire"
    ],
    [
      "difference",
      "diferencia"
    ],
    [
      "nation",
      "nación"
    ],
    [
      "piece",
      "pieza"
    ],
    [
      "sheet",
      "capa"
    ],
    [
      "firm",
      "firma"
    ],
    [
      "elements",
      "rasa"
    ],
    [
      "jump",
      "saltar"
    ],
    [
      "resort",
      "acudir"
    ],
    [
      "facility",
      "instalación"
    ],
    [
      "random",
      "azaroso"
    ],
    [
      "certificate",
      "certificación"
    ],
    [
      "minister",
      "ministra"
    ],
    [
      "motion",
      "moción"
    ],
    [
      "fashion",
      "modo"
    ],
    [
      "directions",
      "instrucciones"
    ],
    [
      "monitor",
      "pantalla"
    ],
    [
      "forest",
      "selva"
    ],
    [
      "whose",
      "cuya"
    ],
    [
      "couple",
      "pareja"
    ],
    [
      "chance",
      "azar"
    ],
    [
      "vision",
      "vista"
    ],
    [
      "ball",
      "bola"
    ],
    [
      "ending",
      "final"
    ],
    [
      "listen",
      "oír"
    ],
    [
      "discuss",
      "debatir"
    ],
    [
      "accept",
      "adir"
    ],
    [
      "automotive",
      "automotor"
    ],
    [
      "naked",
      "bichi"
    ],
    [
      "goal",
      "gol"
    ],
    [
      "successful",
      "exitoso"
    ],
    [
      "wind",
      "viento"
    ],
    [
      "situation",
      "estado"
    ],
    [
      "appear",
      "aparecer"
    ],
    [
      "emergency",
      "urgencia"
    ],
    [
      "currency",
      "divisa"
    ],
    [
      "leather",
      "antelina"
    ],
    [
      "milf",
      "madurita"
    ],
    [
      "temperature",
      "fiebre"
    ],
    [
      "palm",
      "palma de la mano"
    ],
    [
      "actual",
      "real"
    ],
    [
      "stone",
      "piedra"
    ],
    [
      "bob",
      "Bob"
    ],
    [
      "perhaps",
      "acaso"
    ],
    [
      "difficult",
      "chungo"
    ],
    [
      "fit",
      "arrebato"
    ],
    [
      "village",
      "aldea"
    ],
    [
      "amateur",
      "aficionado"
    ],
    [
      "ex",
      "ex"
    ],
    [
      "pain",
      "pena"
    ],
    [
      "coffee",
      "café"
    ],
    [
      "cum",
      "irse"
    ],
    [
      "buyer",
      "clienta"
    ],
    [
      "oral",
      "bocal"
    ],
    [
      "poster",
      "afiche"
    ],
    [
      "edge",
      "borde"
    ],
    [
      "functional",
      "funcional"
    ],
    [
      "root",
      "raíz"
    ],
    [
      "holidays",
      "fiestas"
    ],
    [
      "ice",
      "hielo"
    ],
    [
      "pink",
      "rosa"
    ],
    [
      "balance",
      "saldo"
    ],
    [
      "graduate",
      "graduada"
    ],
    [
      "shot",
      "tiro"
    ],
    [
      "initial",
      "inicial"
    ],
    [
      "label",
      "etiquetar"
    ],
    [
      "recommend",
      "aconsejar"
    ],
    [
      "canon",
      "canon"
    ],
    [
      "hardcore",
      "duro"
    ],
    [
      "league",
      "lazo"
    ],
    [
      "waste",
      "erial"
    ],
    [
      "minute",
      "acta"
    ],
    [
      "bus",
      "bus"
    ],
    [
      "provider",
      "suministrador"
    ],
    [
      "dictionary",
      "vocabulario"
    ],
    [
      "cold",
      "frío"
    ],
    [
      "manufacturing",
      "producción"
    ],
    [
      "chair",
      "butaca"
    ],
    [
      "fishing",
      "pesquería"
    ],
    [
      "bag",
      "jaba"
    ],
    [
      "fantasy",
      "ficción"
    ],
    [
      "professor",
      "profesora"
    ],
    [
      "context",
      "marco"
    ],
    [
      "shirt",
      "chema"
    ],
    [
      "apparel",
      "ropa"
    ],
    [
      "generally",
      "generalmente"
    ],
    [
      "continued",
      "continuado"
    ],
    [
      "foot",
      "pie"
    ],
    [
      "mass",
      "masa"
    ],
    [
      "crime",
      "delincuencia"
    ],
    [
      "count",
      "cargo"
    ],
    [
      "breast",
      "corazón"
    ],
    [
      "quickly",
      "rápido"
    ],
    [
      "claim",
      "asumir"
    ],
    [
      "driving",
      "motor"
    ],
    [
      "permission",
      "permiso"
    ],
    [
      "surgery",
      "consulta"
    ],
    [
      "patch",
      "lote"
    ],
    [
      "heat",
      "calor"
    ],
    [
      "wild",
      "fiero"
    ],
    [
      "generation",
      "linaje"
    ],
    [
      "miss",
      "fallar"
    ],
    [
      "chemical",
      "química"
    ],
    [
      "doctor",
      "doctora"
    ],
    [
      "task",
      "faena"
    ],
    [
      "reduce",
      "mermar"
    ],
    [
      "himself",
      "él mismo"
    ],
    [
      "enable",
      "activar"
    ],
    [
      "exercise",
      "ejercer"
    ],
    [
      "bug",
      "micrófono oculto"
    ],
    [
      "mid",
      "medio"
    ],
    [
      "guarantee",
      "garantir"
    ],
    [
      "leader",
      "jefe"
    ],
    [
      "diamond",
      "gema"
    ],
    [
      "soft",
      "lene"
    ],
    [
      "alone",
      "a solas"
    ],
    [
      "keyword",
      "clave"
    ],
    [
      "flight",
      "fuga"
    ],
    [
      "fuel",
      "lumbre"
    ],
    [
      "walk",
      "andar"
    ],
    [
      "fuck",
      "joder"
    ],
    [
      "italian",
      "italiana"
    ],
    [
      "paperback",
      "libro de tapa blanda"
    ],
    [
      "wait",
      "bancar"
    ],
    [
      "pocket",
      "bolsa"
    ],
    [
      "saint",
      "Santa"
    ],
    [
      "rose",
      "rosa"
    ],
    [
      "argument",
      "argumento"
    ],
    [
      "competition",
      "concurso"
    ],
    [
      "jim",
      "Yago"
    ],
    [
      "joint",
      "juntura"
    ],
    [
      "premium",
      "prima"
    ],
    [
      "fresh",
      "fresco"
    ],
    [
      "attorney",
      "abogada"
    ],
    [
      "upgrade",
      "mejorar"
    ],
    [
      "stream",
      "flujo"
    ],
    [
      "pick",
      "sacho"
    ],
    [
      "hearing",
      "audición"
    ],
    [
      "eastern",
      "esteño"
    ],
    [
      "therapy",
      "terapia"
    ],
    [
      "serious",
      "grave"
    ],
    [
      "prime",
      "primo"
    ],
    [
      "bondage",
      "sujeción"
    ],
    [
      "ac",
      "aco"
    ],
    [
      "creek",
      "arroyo"
    ],
    [
      "quantity",
      "cuantía"
    ],
    [
      "myself",
      "me"
    ],
    [
      "platform",
      "plataforma"
    ],
    [
      "load",
      "carga"
    ],
    [
      "affiliate",
      "filial"
    ],
    [
      "immediately",
      "altiro"
    ],
    [
      "admin",
      "trámites"
    ],
    [
      "defense",
      "descargo"
    ],
    [
      "heavy",
      "onusto"
    ],
    [
      "recovery",
      "repunte"
    ],
    [
      "joe",
      "Pepe"
    ],
    [
      "cock",
      "minga"
    ],
    [
      "merchant",
      "mercador"
    ],
    [
      "comprehensive",
      "abarcador"
    ],
    [
      "expert",
      "perito"
    ],
    [
      "protect",
      "captener"
    ],
    [
      "drop",
      "caer"
    ],
    [
      "solid",
      "sólido"
    ],
    [
      "presentation",
      "ponencia"
    ],
    [
      "orange",
      "naranja"
    ],
    [
      "compliance",
      "asonancia"
    ],
    [
      "prevent",
      "prevenir"
    ],
    [
      "theme",
      "tema"
    ],
    [
      "rich",
      "pesudo"
    ],
    [
      "campaign",
      "campañear"
    ],
    [
      "marine",
      "marino"
    ],
    [
      "improvement",
      "mejoría"
    ],
    [
      "guitar",
      "jarana"
    ],
    [
      "saying",
      "adagio"
    ],
    [
      "spirit",
      "espíritu"
    ],
    [
      "porno",
      "nopor"
    ],
    [
      "challenge",
      "reto"
    ],
    [
      "touch",
      "toque"
    ],
    [
      "hire",
      "emplear"
    ],
    [
      "election",
      "elección"
    ],
    [
      "suggest",
      "sugerir"
    ],
    [
      "branch",
      "rama"
    ],
    [
      "serve",
      "servir"
    ],
    [
      "mount",
      "montar"
    ],
    [
      "smart",
      "vivo"
    ],
    [
      "latin",
      "latino"
    ],
    [
      "avoid",
      "evitar"
    ],
    [
      "manage",
      "lograr"
    ],
    [
      "corner",
      "esquina"
    ],
    [
      "rank",
      "grado"
    ],
    [
      "computing",
      "computación"
    ],
    [
      "birth",
      "nascimiento"
    ],
    [
      "abuse",
      "violar"
    ],
    [
      "separate",
      "separar"
    ],
    [
      "quarter",
      "cuarto"
    ],
    [
      "procedure",
      "trámite"
    ],
    [
      "leadership",
      "jefatura"
    ],
    [
      "define",
      "definir"
    ],
    [
      "breakfast",
      "parva"
    ],
    [
      "column",
      "columna"
    ],
    [
      "faith",
      "fe"
    ],
    [
      "developer",
      "promotor"
    ],
    [
      "identify",
      "funar"
    ],
    [
      "avenue",
      "vía"
    ],
    [
      "missing",
      "ausente"
    ],
    [
      "approximately",
      "a eso de"
    ],
    [
      "domestic",
      "doméstico"
    ],
    [
      "reach",
      "conseguir"
    ],
    [
      "comparison",
      "comparanza"
    ],
    [
      "moment",
      "ratito"
    ],
    [
      "sequence",
      "sucesión"
    ],
    [
      "sorry",
      "discúlpame"
    ],
    [
      "opening",
      "abertura"
    ],
    [
      "damage",
      "daño"
    ],
    [
      "gamma",
      "gamma"
    ],
    [
      "plastic",
      "plástico"
    ],
    [
      "produce",
      "cosecha"
    ],
    [
      "snow",
      "nieve"
    ],
    [
      "truth",
      "fetén"
    ],
    [
      "counter",
      "rebatir"
    ],
    [
      "failure",
      "fracaso"
    ],
    [
      "weekend",
      "finde"
    ],
    [
      "camp",
      "acampar"
    ],
    [
      "automatically",
      "solo"
    ],
    [
      "bridge",
      "puente"
    ],
    [
      "native",
      "nativo"
    ],
    [
      "fill",
      "cubrir"
    ],
    [
      "movement",
      "muebda"
    ],
    [
      "printing",
      "tirada"
    ],
    [
      "baseball",
      "beisbol"
    ],
    [
      "approval",
      "venia"
    ],
    [
      "draft",
      "leva"
    ],
    [
      "jesus",
      "avemaría"
    ],
    [
      "clubs",
      "tréboles"
    ],
    [
      "equal",
      "par"
    ],
    [
      "offering",
      "ofrenda"
    ],
    [
      "profit",
      "lucro"
    ],
    [
      "assistant",
      "ayudante"
    ],
    [
      "advertisement",
      "spot"
    ],
    [
      "expect",
      "exigir"
    ],
    [
      "parking",
      "aparcamiento"
    ],
    [
      "determined",
      "denodado"
    ],
    [
      "wholesale",
      "por junto"
    ],
    [
      "extension",
      "extendimiento"
    ],
    [
      "golden",
      "dorado"
    ],
    [
      "completely",
      "totalmente"
    ],
    [
      "fort",
      "fortín"
    ],
    [
      "lighting",
      "alumbrado"
    ],
    [
      "senate",
      "Senado"
    ],
    [
      "funny",
      "raro"
    ],
    [
      "gene",
      "gene"
    ],
    [
      "portable",
      "portable"
    ],
    [
      "applicable",
      "aplicadero"
    ],
    [
      "pattern",
      "forma"
    ],
    [
      "boat",
      "bote"
    ],
    [
      "sponsor",
      "mecenas"
    ],
    [
      "icon",
      "ícono"
    ],
    [
      "warranty",
      "garantía"
    ],
    [
      "dedicated",
      "dedicado"
    ],
    [
      "basketball",
      "básquet"
    ],
    [
      "delete",
      "elidir"
    ],
    [
      "evening",
      "véspero"
    ],
    [
      "assembly",
      "montaje"
    ],
    [
      "mouse",
      "laucha"
    ],
    [
      "criminal",
      "delincuente"
    ],
    [
      "brain",
      "seso"
    ],
    [
      "powerful",
      "pudiente"
    ],
    [
      "dream",
      "ensoñar"
    ],
    [
      "false",
      "ful"
    ],
    [
      "cast",
      "lanzar"
    ],
    [
      "flower",
      "florescer"
    ],
    [
      "felt",
      "hieltro"
    ],
    [
      "personnel",
      "plantel"
    ],
    [
      "soul",
      "alma"
    ],
    [
      "aids",
      "sida"
    ],
    [
      "promote",
      "ascender"
    ],
    [
      "carry",
      "tener"
    ],
    [
      "flag",
      "losa"
    ],
    [
      "em",
      "cuadratín"
    ],
    [
      "advantage",
      "provecho"
    ],
    [
      "hello",
      "aló"
    ],
    [
      "maintain",
      "mantener"
    ],
    [
      "graphic",
      "crudo"
    ],
    [
      "binding",
      "unión"
    ],
    [
      "brief",
      "corto"
    ],
    [
      "iron",
      "fierro"
    ],
    [
      "straight",
      "convencional"
    ],
    [
      "script",
      "guion"
    ],
    [
      "miscellaneous",
      "varios"
    ],
    [
      "void",
      "nulo"
    ],
    [
      "alert",
      "alarma"
    ],
    [
      "tag",
      "chapa"
    ],
    [
      "interview",
      "interviú"
    ],
    [
      "mix",
      "mezcla"
    ],
    [
      "framework",
      "armazón"
    ],
    [
      "disk",
      "círculo"
    ],
    [
      "queen",
      "dama"
    ],
    [
      "vhs",
      "videocinta"
    ],
    [
      "clearly",
      "claramente"
    ],
    [
      "fix",
      "apañar"
    ],
    [
      "handle",
      "manija"
    ],
    [
      "sweet",
      "dulce"
    ],
    [
      "desk",
      "carpeta"
    ],
    [
      "vice",
      "resabio"
    ],
    [
      "associate",
      "tratar"
    ],
    [
      "truck",
      "camioneta"
    ],
    [
      "behavior",
      "conducta"
    ],
    [
      "enlarge",
      "ampliar"
    ],
    [
      "ray",
      "rayo"
    ],
    [
      "revenue",
      "renta"
    ],
    [
      "measure",
      "medida"
    ],
    [
      "duty",
      "arancel"
    ],
    [
      "bear",
      "aguantar"
    ],
    [
      "gain",
      "ganar"
    ],
    [
      "festival",
      "fiesta"
    ],
    [
      "lack",
      "carecer"
    ],
    [
      "depth",
      "calo"
    ],
    [
      "whatever",
      "quequier"
    ],
    [
      "laptop",
      "portátil"
    ],
    [
      "vintage",
      "data"
    ],
    [
      "train",
      "entrenar"
    ],
    [
      "exactly",
      "exacto"
    ],
    [
      "dry",
      "enjugar"
    ],
    [
      "spa",
      "balneario"
    ],
    [
      "eligible",
      "apto"
    ],
    [
      "handling",
      "conducción"
    ],
    [
      "billion",
      "billón"
    ],
    [
      "destination",
      "destinación"
    ],
    [
      "faster",
      "ayunadora"
    ],
    [
      "intelligence",
      "sabiola"
    ],
    [
      "con",
      "engañar"
    ],
    [
      "route",
      "enrutar"
    ],
    [
      "broken",
      "roto"
    ],
    [
      "zoom",
      "sum"
    ],
    [
      "blow",
      "cagar"
    ],
    [
      "battle",
      "lucha"
    ],
    [
      "anime",
      "animé"
    ],
    [
      "speak",
      "hablar"
    ],
    [
      "query",
      "consulta"
    ],
    [
      "partnership",
      "alianza"
    ],
    [
      "expression",
      "locución"
    ],
    [
      "equity",
      "acciones"
    ],
    [
      "speech",
      "fabla"
    ],
    [
      "wire",
      "hilo"
    ],
    [
      "replacement",
      "reemplazo"
    ],
    [
      "tape",
      "grabar"
    ],
    [
      "judge",
      "juez"
    ],
    [
      "spam",
      "spam"
    ],
    [
      "acid",
      "ácido"
    ],
    [
      "cent",
      "centavo"
    ],
    [
      "fight",
      "luchar"
    ],
    [
      "apartment",
      "depa"
    ],
    [
      "height",
      "cima"
    ],
    [
      "zero",
      "cero"
    ],
    [
      "speaker",
      "parlante"
    ],
    [
      "netherlands",
      "Holanda"
    ],
    [
      "obtain",
      "coger"
    ],
    [
      "bc",
      "antes de Jesucristo"
    ],
    [
      "designer",
      "diseñadora"
    ],
    [
      "remain",
      "sobrar"
    ],
    [
      "failed",
      "fracasado"
    ],
    [
      "marriage",
      "matrimonio"
    ],
    [
      "roll",
      "rodar"
    ],
    [
      "secret",
      "arcano"
    ],
    [
      "bath",
      "baño"
    ],
    [
      "negative",
      "negación"
    ],
    [
      "theater",
      "zona"
    ],
    [
      "perform",
      "bordar"
    ],
    [
      "healthy",
      "sano"
    ],
    [
      "translation",
      "traslación"
    ],
    [
      "font",
      "fuente"
    ],
    [
      "assets",
      "partida del activo"
    ],
    [
      "injury",
      "lesión"
    ],
    [
      "joseph",
      "José de Arimetea"
    ],
    [
      "ministry",
      "cartera"
    ],
    [
      "lawyer",
      "rábula"
    ],
    [
      "married",
      "casada"
    ],
    [
      "portal",
      "portal"
    ],
    [
      "birthday",
      "natalicio"
    ],
    [
      "fail",
      "negar"
    ],
    [
      "toward",
      "para"
    ],
    [
      "slightly",
      "levemente"
    ],
    [
      "assist",
      "ayudar"
    ],
    [
      "conduct",
      "conducir"
    ],
    [
      "lingerie",
      "ropa blanca"
    ],
    [
      "calling",
      "vocación"
    ],
    [
      "serving",
      "ración"
    ],
    [
      "tennessee",
      "Tenesí"
    ],
    [
      "wear",
      "usar"
    ],
    [
      "ultimate",
      "final"
    ],
    [
      "wales",
      "País de Gales"
    ],
    [
      "representative",
      "representante"
    ],
    [
      "minor",
      "menor de edad"
    ],
    [
      "finish",
      "meta"
    ],
    [
      "rare",
      "ralo"
    ],
    [
      "row",
      "remo"
    ],
    [
      "forecast",
      "previsión"
    ],
    [
      "administrator",
      "albacea"
    ],
    [
      "contain",
      "dominar"
    ],
    [
      "accuracy",
      "acierto"
    ],
    [
      "rise",
      "alza"
    ],
    [
      "sleep",
      "chele"
    ],
    [
      "bird",
      "ave"
    ],
    [
      "pharmacy",
      "botica"
    ],
    [
      "static",
      "nieve"
    ],
    [
      "scene",
      "escena"
    ],
    [
      "hunter",
      "buscador"
    ],
    [
      "lady",
      "señora"
    ],
    [
      "famous",
      "afamado"
    ],
    [
      "writer",
      "escriptor"
    ],
    [
      "chairman",
      "presidente"
    ],
    [
      "drink",
      "beber"
    ],
    [
      "academy",
      "cantera"
    ],
    [
      "gender",
      "género"
    ],
    [
      "eat",
      "manyar"
    ],
    [
      "portfolio",
      "cartera"
    ],
    [
      "exclusive",
      "tubazo"
    ],
    [
      "seat",
      "asiento"
    ],
    [
      "vendor",
      "vendedora"
    ],
    [
      "originally",
      "originalmente"
    ],
    [
      "regulation",
      "regulación"
    ],
    [
      "reduction",
      "reducción"
    ],
    [
      "aim",
      "abocar"
    ],
    [
      "toll",
      "pontaje"
    ],
    [
      "cape",
      "capa"
    ],
    [
      "meaning",
      "significación"
    ],
    [
      "tip",
      "consejo"
    ],
    [
      "secondary",
      "suplente"
    ],
    [
      "wonderful",
      "estupendo"
    ],
    [
      "mine",
      "extraer"
    ],
    [
      "henry",
      "Henrio"
    ],
    [
      "ticket",
      "tique"
    ],
    [
      "guess",
      "cábala"
    ],
    [
      "agreed",
      "concordar"
    ],
    [
      "whom",
      "cuyo"
    ],
    [
      "soccer",
      "futbol"
    ],
    [
      "math",
      "mate"
    ],
    [
      "import",
      "importancia"
    ],
    [
      "instant",
      "momento"
    ],
    [
      "automatic",
      "semi-automática"
    ],
    [
      "viewing",
      "visivo"
    ],
    [
      "majority",
      "mayoría"
    ],
    [
      "connected",
      "conexo"
    ],
    [
      "christ",
      "Cristo"
    ],
    [
      "ahead",
      "delante de"
    ],
    [
      "moon",
      "mes"
    ],
    [
      "participation",
      "colaboración"
    ],
    [
      "scheme",
      "ardid"
    ],
    [
      "utility",
      "utíliti"
    ],
    [
      "preview",
      "visionar"
    ],
    [
      "fly",
      "funcar"
    ],
    [
      "manner",
      "modo"
    ],
    [
      "amendment",
      "enmienda"
    ],
    [
      "despite",
      "maguer"
    ],
    [
      "strength",
      "ñeque"
    ],
    [
      "turkey",
      "chumpe"
    ],
    [
      "proper",
      "proprio"
    ],
    [
      "fear",
      "pavor"
    ],
    [
      "phoenix",
      "fénice"
    ],
    [
      "convention",
      "convención"
    ],
    [
      "principal",
      "rector"
    ],
    [
      "standing",
      "parado"
    ],
    [
      "voyeur",
      "voyerista"
    ],
    [
      "comfort",
      "confort"
    ],
    [
      "appeal",
      "atraer"
    ],
    [
      "bonus",
      "plus"
    ],
    [
      "previously",
      "previamente"
    ],
    [
      "hey",
      "ey"
    ],
    [
      "bookmark",
      "favorito"
    ],
    [
      "beat",
      "batir"
    ],
    [
      "household",
      "hogar"
    ],
    [
      "adobe",
      "casa de adobe"
    ],
    [
      "smoking",
      "fumar"
    ],
    [
      "bbc",
      "CBR"
    ],
    [
      "tea",
      "té"
    ],
    [
      "achieve",
      "conseguir"
    ],
    [
      "dress",
      "vestirse"
    ],
    [
      "subscription",
      "suscripción"
    ],
    [
      "dealer",
      "díler"
    ],
    [
      "contemporary",
      "contemporario"
    ],
    [
      "sky",
      "cielo"
    ],
    [
      "nearby",
      "próximo"
    ],
    [
      "rom",
      "gitano"
    ],
    [
      "happen",
      "pasar"
    ],
    [
      "exposure",
      "exposición"
    ],
    [
      "hide",
      "cuero"
    ],
    [
      "signature",
      "pliego"
    ],
    [
      "gambling",
      "timbeo"
    ],
    [
      "refer",
      "remitir"
    ],
    [
      "miller",
      "Molina"
    ],
    [
      "provision",
      "avituallar"
    ],
    [
      "outdoors",
      "intemperie"
    ],
    [
      "clothes",
      "trapos"
    ],
    [
      "luxury",
      "lujo"
    ],
    [
      "certainly",
      "ciertamente"
    ],
    [
      "indeed",
      "de hecho"
    ],
    [
      "newspaper",
      "diario"
    ],
    [
      "toy",
      "darle vueltas a una idea"
    ],
    [
      "layer",
      "tanda"
    ],
    [
      "slow",
      "lerdo"
    ],
    [
      "removal",
      "mudanza"
    ],
    [
      "liability",
      "lastre"
    ],
    [
      "trademark",
      "marca"
    ],
    [
      "hip",
      "cadera"
    ],
    [
      "mostly",
      "principalmente"
    ],
    [
      "spot",
      "zona"
    ],
    [
      "spend",
      "pasar"
    ],
    [
      "factory",
      "planta"
    ],
    [
      "interior",
      "interiano"
    ],
    [
      "grow",
      "crecer"
    ],
    [
      "promotion",
      "promoción"
    ],
    [
      "relative",
      "deudo"
    ],
    [
      "amazing",
      "asombroso"
    ],
    [
      "clock",
      "cronometrar"
    ],
    [
      "feeling",
      "sentimientos"
    ],
    [
      "hidden",
      "oculto"
    ],
    [
      "reasonable",
      "módico"
    ],
    [
      "serial",
      "serial"
    ],
    [
      "relief",
      "alivio"
    ],
    [
      "revision",
      "edición"
    ],
    [
      "influence",
      "influjo"
    ],
    [
      "ratio",
      "razón"
    ],
    [
      "importance",
      "relevancia"
    ],
    [
      "rain",
      "lluvia"
    ],
    [
      "proof",
      "prueba"
    ],
    [
      "bass",
      "lubina"
    ],
    [
      "prescription",
      "prescripción"
    ],
    [
      "bedroom",
      "pieza"
    ],
    [
      "instance",
      "caso"
    ],
    [
      "hole",
      "agujero"
    ],
    [
      "ride",
      "rai"
    ],
    [
      "bureau",
      "buró"
    ],
    [
      "pair",
      "par"
    ],
    [
      "ideal",
      "idóneo"
    ],
    [
      "don",
      "ponerse"
    ],
    [
      "finished",
      "hecho"
    ],
    [
      "dinner",
      "cena"
    ],
    [
      "stress",
      "enfatizar"
    ],
    [
      "cream",
      "nata"
    ],
    [
      "yeah",
      "aa"
    ],
    [
      "discover",
      "destapar"
    ],
    [
      "advisor",
      "consejero"
    ],
    [
      "evil",
      "malvado"
    ],
    [
      "aware",
      "consciente"
    ],
    [
      "shape",
      "forma"
    ],
    [
      "irish",
      "irlandeses"
    ],
    [
      "usage",
      "uso"
    ],
    [
      "cap",
      "cofia"
    ],
    [
      "ink",
      "firmar"
    ],
    [
      "mixed",
      "mixto"
    ],
    [
      "peak",
      "cima"
    ],
    [
      "wheel",
      "llanta"
    ],
    [
      "transit",
      "girar"
    ],
    [
      "dick",
      "pico"
    ],
    [
      "salt",
      "sal"
    ],
    [
      "compact",
      "compactar"
    ],
    [
      "poetry",
      "poesía"
    ],
    [
      "tracking",
      "interletraje"
    ],
    [
      "bell",
      "pabellón"
    ],
    [
      "preparation",
      "preparado"
    ],
    [
      "attempt",
      "conato"
    ],
    [
      "accordance",
      "acuerdo"
    ],
    [
      "width",
      "anchor"
    ],
    [
      "noise",
      "ruido"
    ],
    [
      "forget",
      "olvidarse"
    ],
    [
      "array",
      "gama"
    ],
    [
      "accurate",
      "justo"
    ],
    [
      "stephen",
      "Esteban"
    ],
    [
      "pin",
      "pin"
    ],
    [
      "greek",
      "griega"
    ],
    [
      "annotation",
      "anotación"
    ],
    [
      "sister",
      "sor"
    ],
    [
      "raw",
      "en carne viva"
    ],
    [
      "walking",
      "andar"
    ],
    [
      "establish",
      "instaurar"
    ],
    [
      "sharp",
      "agrio"
    ],
    [
      "lane",
      "calle"
    ],
    [
      "paragraph",
      "acápite"
    ],
    [
      "kill",
      "piliar"
    ],
    [
      "mathematics",
      "matemática"
    ],
    [
      "compensation",
      "compensación"
    ],
    [
      "export",
      "exportador"
    ],
    [
      "conflict",
      "confligir"
    ],
    [
      "employer",
      "empleadora"
    ],
    [
      "occur",
      "ocurrir"
    ],
    [
      "mississippi",
      "Misisipí"
    ],
    [
      "concern",
      "tocar"
    ],
    [
      "backup",
      "respaldo"
    ],
    [
      "heritage",
      "acervo"
    ],
    [
      "trouble",
      "problema"
    ],
    [
      "spread",
      "esparcir"
    ],
    [
      "coach",
      "couch"
    ],
    [
      "expand",
      "expandir"
    ],
    [
      "audience",
      "audiencia"
    ],
    [
      "jordan",
      "Jordán"
    ],
    [
      "plug",
      "plag"
    ],
    [
      "cook",
      "cocer"
    ],
    [
      "affect",
      "fingir"
    ],
    [
      "virgin",
      "virgen"
    ],
    [
      "experienced",
      "ducho"
    ],
    [
      "investigation",
      "pesquisa"
    ],
    [
      "raised",
      "saledizo"
    ],
    [
      "affected",
      "afectado"
    ],
    [
      "bike",
      "moto"
    ],
    [
      "totally",
      "de todo punto"
    ],
    [
      "plate",
      "placa"
    ],
    [
      "indicate",
      "señalizar"
    ],
    [
      "favourite",
      "ganchito"
    ],
    [
      "transmission",
      "caja de cambios"
    ],
    [
      "lose",
      "perder"
    ],
    [
      "organic",
      "orgánico"
    ],
    [
      "seek",
      "pedir"
    ],
    [
      "extremely",
      "harto"
    ],
    [
      "concerning",
      "concerniendo"
    ],
    [
      "neighborhood",
      "barrio"
    ],
    [
      "agenda",
      "agenda"
    ],
    [
      "anyway",
      "comoquiera"
    ],
    [
      "advisory",
      "aviso"
    ],
    [
      "template",
      "plantilla"
    ],
    [
      "prince",
      "conde"
    ],
    [
      "circle",
      "circulo"
    ],
    [
      "soil",
      "tierra"
    ],
    [
      "anywhere",
      "en cualquier parte"
    ],
    [
      "psychology",
      "sicología"
    ],
    [
      "wet",
      "mearse"
    ],
    [
      "investor",
      "inversionista"
    ],
    [
      "ram",
      "topar"
    ],
    [
      "wildlife",
      "vida silvestre"
    ],
    [
      "elementary",
      "básico"
    ],
    [
      "cooking",
      "cocina"
    ],
    [
      "speaking",
      "habla"
    ],
    [
      "fox",
      "zorra"
    ],
    [
      "unlimited",
      "sin límite"
    ],
    [
      "respond",
      "responder"
    ],
    [
      "plain",
      "mondo"
    ],
    [
      "exit",
      "salida"
    ],
    [
      "arm",
      "arma"
    ],
    [
      "launch",
      "lancear"
    ],
    [
      "wave",
      "ola"
    ],
    [
      "holy",
      "santo"
    ],
    [
      "guidance",
      "guiamiento"
    ],
    [
      "mesh",
      "malla"
    ],
    [
      "trail",
      "senda"
    ],
    [
      "enforcement",
      "ejecución"
    ],
    [
      "highway",
      "carretera"
    ],
    [
      "buddy",
      "acere"
    ],
    [
      "hardcover",
      "tapa dura"
    ],
    [
      "dean",
      "deán"
    ],
    [
      "setup",
      "instalador"
    ],
    [
      "poll",
      "encuesta"
    ],
    [
      "booking",
      "amonestación"
    ],
    [
      "fiscal",
      "financiero"
    ],
    [
      "celebrity",
      "celebridad"
    ],
    [
      "bond",
      "lazo"
    ],
    [
      "chocolate",
      "chocolate"
    ],
    [
      "pub",
      "taberna"
    ],
    [
      "scope",
      "ámbito"
    ],
    [
      "supplier",
      "proveedora"
    ],
    [
      "requirement",
      "exigencia"
    ],
    [
      "border",
      "orla"
    ],
    [
      "ancient",
      "antiguo"
    ],
    [
      "pregnancy",
      "preñez"
    ],
    [
      "leisure",
      "ocio"
    ],
    [
      "learned",
      "leído"
    ],
    [
      "notebook",
      "libreta"
    ],
    [
      "explorer",
      "explorador"
    ],
    [
      "attached",
      "unido"
    ],
    [
      "tm",
      "symboltrademarkMR"
    ],
    [
      "husband",
      "esposo"
    ],
    [
      "disabled",
      "minusválido"
    ],
    [
      "crazy",
      "creisi"
    ],
    [
      "upcoming",
      "venturo"
    ],
    [
      "britain",
      "Britania"
    ],
    [
      "concert",
      "concierto"
    ],
    [
      "retirement",
      "retirada"
    ],
    [
      "efficient",
      "eficaz"
    ],
    [
      "linear",
      "unidimensional"
    ],
    [
      "commitment",
      "acuerdo"
    ],
    [
      "hop",
      "lúpulo"
    ],
    [
      "carrier",
      "portador"
    ],
    [
      "constant",
      "constable"
    ],
    [
      "visa",
      "visa"
    ],
    [
      "mouth",
      "desembocadura"
    ],
    [
      "meter",
      "metro"
    ],
    [
      "gun",
      "cañón"
    ],
    [
      "reflect",
      "cavilar"
    ],
    [
      "deliver",
      "dar"
    ],
    [
      "wonder",
      "maravilla"
    ],
    [
      "hell",
      "mierda!"
    ],
    [
      "fruit",
      "fruto"
    ],
    [
      "qualified",
      "clasificado"
    ],
    [
      "lens",
      "luna"
    ],
    [
      "discovery",
      "hallazgo"
    ],
    [
      "draw",
      "sacar"
    ],
    [
      "classified",
      "secreto"
    ],
    [
      "assume",
      "asumir"
    ],
    [
      "confidence",
      "confidencia"
    ],
    [
      "warm",
      "alegrar"
    ],
    [
      "neither",
      "ningún"
    ],
    [
      "offline",
      "offline"
    ],
    [
      "engineer",
      "ingeniera"
    ],
    [
      "lifestyle",
      "vivienda"
    ],
    [
      "consistent",
      "coherente"
    ],
    [
      "replace",
      "banquillo"
    ],
    [
      "clearance",
      "claro"
    ],
    [
      "suck",
      "mamar"
    ],
    [
      "blowjob",
      "pete"
    ],
    [
      "sugar",
      "endulzar"
    ],
    [
      "crew",
      "grupo"
    ],
    [
      "stick",
      "palo"
    ],
    [
      "relation",
      "pariente"
    ],
    [
      "slide",
      "resbalar"
    ],
    [
      "volunteer",
      "comedirse"
    ],
    [
      "rear",
      "criar"
    ],
    [
      "enhance",
      "embonar"
    ],
    [
      "exact",
      "exaccionar"
    ],
    [
      "bound",
      "límite"
    ],
    [
      "node",
      "nodo"
    ],
    [
      "formal",
      "protocolario"
    ],
    [
      "lock",
      "chapa"
    ],
    [
      "storm",
      "temporal"
    ],
    [
      "bowl",
      "bol"
    ],
    [
      "tank",
      "tanque"
    ],
    [
      "estimate",
      "presupuesto"
    ],
    [
      "encourage",
      "alentar"
    ],
    [
      "navy",
      "armada"
    ],
    [
      "kid",
      "chango"
    ],
    [
      "regulatory",
      "regulatorio"
    ],
    [
      "cancel",
      "cancelar"
    ],
    [
      "delay",
      "demorar"
    ],
    [
      "pilot",
      "piloto"
    ],
    [
      "outlet",
      "desahogo"
    ],
    [
      "continuous",
      "contino"
    ],
    [
      "czech",
      "checa"
    ],
    [
      "novel",
      "romance"
    ],
    [
      "pan",
      "destrozar"
    ],
    [
      "execution",
      "suplicio"
    ],
    [
      "winner",
      "ganadora"
    ],
    [
      "contractor",
      "constructor"
    ],
    [
      "episode",
      "capítulo"
    ],
    [
      "examination",
      "examinación"
    ],
    [
      "potter",
      "alfarera"
    ],
    [
      "dish",
      "plato"
    ],
    [
      "bulletin",
      "boletín"
    ],
    [
      "adam",
      "Adán"
    ],
    [
      "truly",
      "veramente"
    ],
    [
      "painting",
      "cuadro"
    ],
    [
      "committed",
      "empeñado"
    ],
    [
      "extensive",
      "extensivo"
    ],
    [
      "affordable",
      "económico"
    ],
    [
      "universe",
      "cosmos"
    ],
    [
      "candidate",
      "candidata"
    ],
    [
      "outstanding",
      "pendiente"
    ],
    [
      "lodge",
      "logia"
    ],
    [
      "messenger",
      "emisario"
    ],
    [
      "mirror",
      "espejar"
    ],
    [
      "tournament",
      "justa"
    ],
    [
      "kernel",
      "núcleo"
    ],
    [
      "stocks",
      "picota"
    ],
    [
      "gray",
      "grises"
    ],
    [
      "catalogue",
      "catálogo"
    ],
    [
      "broad",
      "pava"
    ],
    [
      "swiss",
      "suiza"
    ],
    [
      "labour",
      "parto"
    ],
    [
      "hate",
      "aborrecer"
    ],
    [
      "terminal",
      "borna"
    ],
    [
      "caribbean",
      "Caribe"
    ],
    [
      "liquid",
      "líquida"
    ],
    [
      "loop",
      "bucle"
    ],
    [
      "salary",
      "sueldo"
    ],
    [
      "reservation",
      "reserva"
    ],
    [
      "gourmet",
      "goloso"
    ],
    [
      "guard",
      "guarda"
    ],
    [
      "properly",
      "como toca"
    ],
    [
      "saving",
      "hucha"
    ],
    [
      "remaining",
      "remanente"
    ],
    [
      "empire",
      "Imperio"
    ],
    [
      "resume",
      "retomar"
    ],
    [
      "raise",
      "alzar"
    ],
    [
      "prepare",
      "preparar"
    ],
    [
      "avatar",
      "emblema"
    ],
    [
      "illegal",
      "ilegal"
    ],
    [
      "expansion",
      "expansión"
    ],
    [
      "premier",
      "fénix"
    ],
    [
      "tomorrow",
      "cras"
    ],
    [
      "milk",
      "muir"
    ],
    [
      "decide",
      "decidir"
    ],
    [
      "consent",
      "venia"
    ],
    [
      "drama",
      "obra teatral"
    ],
    [
      "downtown",
      "núcleo urbano"
    ],
    [
      "contest",
      "concurso"
    ],
    [
      "nw",
      "NW"
    ],
    [
      "suitable",
      "apto"
    ],
    [
      "absolutely",
      "totalmente"
    ],
    [
      "lunch",
      "lonch"
    ],
    [
      "dildo",
      "dildo"
    ],
    [
      "audit",
      "auditaje"
    ],
    [
      "push",
      "pujo"
    ],
    [
      "chamber",
      "cámara"
    ],
    [
      "muscle",
      "músculo"
    ],
    [
      "implement",
      "implemento"
    ],
    [
      "scheduled",
      "previsto"
    ],
    [
      "tower",
      "torre"
    ],
    [
      "yours",
      "suyo"
    ],
    [
      "sum",
      "suma"
    ],
    [
      "calculator",
      "calculador"
    ],
    [
      "chicken",
      "gallina"
    ],
    [
      "temporary",
      "temporero"
    ],
    [
      "attend",
      "ir"
    ],
    [
      "shower",
      "ducha"
    ],
    [
      "alan",
      "Alán"
    ],
    [
      "jason",
      "Jasón"
    ],
    [
      "tonight",
      "esta tarde"
    ],
    [
      "dear",
      "querido"
    ],
    [
      "shell",
      "caparazón"
    ],
    [
      "catholic",
      "católica"
    ],
    [
      "oak",
      "roble"
    ],
    [
      "vat",
      "IGV"
    ],
    [
      "awareness",
      "consciencia"
    ],
    [
      "governor",
      "gobernadora"
    ],
    [
      "beer",
      "caña"
    ],
    [
      "contribution",
      "aporte"
    ],
    [
      "measurement",
      "medida"
    ],
    [
      "swimming",
      "nadadura"
    ],
    [
      "spyware",
      "software espía"
    ],
    [
      "formula",
      "fórmula infantil"
    ],
    [
      "constitution",
      "constitución"
    ],
    [
      "packaging",
      "envoltura"
    ],
    [
      "catch",
      "coger"
    ],
    [
      "pakistan",
      "Paquistán"
    ],
    [
      "ps",
      "PD"
    ],
    [
      "reliable",
      "fiable"
    ],
    [
      "consultation",
      "consultación"
    ],
    [
      "doubt",
      "duda"
    ],
    [
      "earn",
      "ganar"
    ],
    [
      "unable",
      "impotente"
    ],
    [
      "classroom",
      "clase"
    ],
    [
      "wallpaper",
      "decomural"
    ],
    [
      "resistance",
      "oposición"
    ],
    [
      "memorial",
      "conmemoración"
    ],
    [
      "visitor",
      "visitante"
    ],
    [
      "twin",
      "chacho"
    ],
    [
      "insert",
      "meter"
    ],
    [
      "gateway",
      "verja"
    ],
    [
      "drawing",
      "rifa"
    ],
    [
      "biological",
      "biológico"
    ],
    [
      "spy",
      "avistar"
    ],
    [
      "romance",
      "románico"
    ],
    [
      "instrument",
      "herramienta"
    ],
    [
      "split",
      "partir"
    ],
    [
      "heaven",
      "cielo"
    ],
    [
      "pregnant",
      "encinta"
    ],
    [
      "twice",
      "doblemente"
    ],
    [
      "physician",
      "doctora"
    ],
    [
      "bargain",
      "momio"
    ],
    [
      "normally",
      "de costumbre"
    ],
    [
      "lo",
      "ve"
    ],
    [
      "hunting",
      "caza"
    ],
    [
      "suit",
      "flux"
    ],
    [
      "shift",
      "moverse"
    ],
    [
      "chip",
      "cepa"
    ],
    [
      "sit",
      "seer"
    ],
    [
      "cutting",
      "esqueje"
    ],
    [
      "wow",
      "guao"
    ],
    [
      "flexible",
      "doblegable"
    ],
    [
      "cartoon",
      "boceto"
    ],
    [
      "carbon",
      "carbón"
    ],
    [
      "comfortable",
      "cómodo"
    ],
    [
      "interaction",
      "coacción"
    ],
    [
      "outlook",
      "visión"
    ],
    [
      "massive",
      "enorme"
    ],
    [
      "employed",
      "usado"
    ],
    [
      "bright",
      "brillante"
    ],
    [
      "treat",
      "tratar"
    ],
    [
      "header",
      "cabecera"
    ],
    [
      "poverty",
      "pobreza"
    ],
    [
      "echo",
      "repetir"
    ],
    [
      "grid",
      "red"
    ],
    [
      "revolution",
      "giro"
    ],
    [
      "earnings",
      "devengo"
    ],
    [
      "mystery",
      "arcano"
    ],
    [
      "landscape",
      "apaisado"
    ],
    [
      "journey",
      "jornada"
    ],
    [
      "bidding",
      "puja"
    ],
    [
      "banner",
      "estandarte"
    ],
    [
      "applicant",
      "candidato"
    ],
    [
      "charter",
      "carta"
    ],
    [
      "fig",
      "figo"
    ],
    [
      "blogger",
      "bloguera"
    ],
    [
      "rapid",
      "raudo"
    ],
    [
      "pull",
      "halar"
    ],
    [
      "hairy",
      "peloso"
    ],
    [
      "reverse",
      "ciar"
    ],
    [
      "deposit",
      "empeño"
    ],
    [
      "specify",
      "detallar"
    ],
    [
      "dutch",
      "neerlandés"
    ],
    [
      "sensitive",
      "sensible"
    ],
    [
      "tab",
      "pestaña"
    ],
    [
      "router",
      "rúter"
    ],
    [
      "concrete",
      "garujo"
    ],
    [
      "editing",
      "editaje"
    ],
    [
      "folder",
      "fólder"
    ],
    [
      "completion",
      "compleción"
    ],
    [
      "upload",
      "colgar"
    ],
    [
      "alexander",
      "Alexandro"
    ],
    [
      "broadcast",
      "emisión"
    ],
    [
      "strip",
      "tira"
    ],
    [
      "pearl",
      "perla"
    ],
    [
      "accessible",
      "abordable"
    ],
    [
      "accessory",
      "cómplice"
    ],
    [
      "resident",
      "munícipe"
    ],
    [
      "plot",
      "lote"
    ],
    [
      "airline",
      "compañía aérea"
    ],
    [
      "regard",
      "tratar"
    ],
    [
      "pump",
      "bomba"
    ],
    [
      "smooth",
      "suave"
    ],
    [
      "strike",
      "parecer"
    ],
    [
      "consumption",
      "consumo"
    ],
    [
      "flashing",
      "flaseo"
    ],
    [
      "narrow",
      "angosto"
    ],
    [
      "threat",
      "amenaza"
    ],
    [
      "controller",
      "mando"
    ],
    [
      "ownership",
      "dueñesco"
    ],
    [
      "penis",
      "chota"
    ],
    [
      "trailer",
      "tráiler"
    ],
    [
      "castle",
      "castro"
    ],
    [
      "unsubscribe",
      "desuscribirse"
    ],
    [
      "willing",
      "listo"
    ],
    [
      "acting",
      "suplente"
    ],
    [
      "hundred",
      "ciento"
    ],
    [
      "strange",
      "extraño"
    ],
    [
      "sustainable",
      "sustentable"
    ],
    [
      "mention",
      "mentar"
    ],
    [
      "operate",
      "controlar"
    ],
    [
      "bold",
      "negrita"
    ],
    [
      "bathroom",
      "baño"
    ],
    [
      "stable",
      "cija"
    ],
    [
      "cinema",
      "cine"
    ],
    [
      "asset",
      "bien"
    ],
    [
      "scan",
      "revisar"
    ],
    [
      "blank",
      "vacío"
    ],
    [
      "enhanced",
      "amplificado"
    ],
    [
      "entitled",
      "engreído"
    ],
    [
      "severe",
      "severo"
    ],
    [
      "generate",
      "generar"
    ],
    [
      "aged",
      "viejo"
    ],
    [
      "exception",
      "ofensa"
    ],
    [
      "bulk",
      "mole"
    ],
    [
      "pursuant",
      "según"
    ],
    [
      "fabric",
      "tela"
    ],
    [
      "tight",
      "tenso"
    ],
    [
      "flying",
      "volante"
    ],
    [
      "berlin",
      "berlinés"
    ],
    [
      "cute",
      "monono"
    ],
    [
      "expensive",
      "costoso"
    ],
    [
      "plane",
      "avión"
    ],
    [
      "seed",
      "simiente"
    ],
    [
      "desire",
      "gana"
    ],
    [
      "expertise",
      "peritaje"
    ],
    [
      "camping",
      "acampada"
    ],
    [
      "ee",
      "ado"
    ],
    [
      "jewellery",
      "joyas"
    ],
    [
      "welfare",
      "seguridad social"
    ],
    [
      "peer",
      "par"
    ],
    [
      "eventually",
      "al final"
    ],
    [
      "driven",
      "impelido"
    ],
    [
      "bottle",
      "bórol"
    ],
    [
      "innovative",
      "pionero"
    ],
    [
      "rubber",
      "goma"
    ],
    [
      "closing",
      "cierre"
    ],
    [
      "legend",
      "leyenda"
    ],
    [
      "grace",
      "gracia"
    ],
    [
      "ing",
      "iendo"
    ],
    [
      "monster",
      "fiera"
    ],
    [
      "bang",
      "golpe"
    ],
    [
      "villa",
      "quinta"
    ],
    [
      "bone",
      "coger"
    ],
    [
      "inner",
      "interno"
    ],
    [
      "tutorial",
      "cursillo"
    ],
    [
      "gate",
      "puerta"
    ],
    [
      "holder",
      "tenedor"
    ],
    [
      "moderator",
      "moderadora"
    ],
    [
      "settlement",
      "acuerdo"
    ],
    [
      "roman",
      "romana"
    ],
    [
      "forever",
      "por siempre"
    ],
    [
      "dragon",
      "guiverno"
    ],
    [
      "busy",
      "bisi"
    ],
    [
      "captain",
      "pilotar"
    ],
    [
      "imagine",
      "flashear"
    ],
    [
      "heating",
      "calentamiento"
    ],
    [
      "leg",
      "pata"
    ],
    [
      "neck",
      "cuello"
    ],
    [
      "wing",
      "ala"
    ],
    [
      "abc",
      "abc"
    ],
    [
      "stereo",
      "estereográfico"
    ],
    [
      "taste",
      "probar"
    ],
    [
      "commit",
      "empalabrar"
    ],
    [
      "tiny",
      "diminuto"
    ],
    [
      "operational",
      "operatorio"
    ],
    [
      "rail",
      "raíl"
    ],
    [
      "liberal",
      "libertaria"
    ],
    [
      "jay",
      "urraca"
    ],
    [
      "gap",
      "hueco"
    ],
    [
      "tube",
      "tubo"
    ],
    [
      "cache",
      "memoria caché"
    ],
    [
      "belt",
      "correa"
    ],
    [
      "jacket",
      "saco"
    ],
    [
      "determination",
      "ahínco"
    ],
    [
      "animation",
      "animación"
    ],
    [
      "er",
      "era"
    ],
    [
      "matthew",
      "Mateo"
    ],
    [
      "lease",
      "arrendamiento"
    ],
    [
      "aviation",
      "aeronáutica"
    ],
    [
      "proud",
      "soberbio"
    ],
    [
      "excess",
      "exceso"
    ],
    [
      "instructor",
      "instructora"
    ],
    [
      "giant",
      "gigante"
    ],
    [
      "bestiality",
      "bestialidad"
    ],
    [
      "alarm",
      "alarma"
    ],
    [
      "voltage",
      "tensión"
    ],
    [
      "usual",
      "habitual"
    ],
    [
      "loading",
      "fletamento"
    ],
    [
      "angle",
      "rincón"
    ],
    [
      "rob",
      "robar"
    ],
    [
      "ongoing",
      "actual"
    ],
    [
      "betting",
      "envidada"
    ],
    [
      "blackjack",
      "bandera pirata"
    ],
    [
      "era",
      "evo"
    ],
    [
      "analyst",
      "psicoanalista"
    ],
    [
      "commissioner",
      "notaria"
    ],
    [
      "dangerous",
      "brígido"
    ],
    [
      "garage",
      "garaje"
    ],
    [
      "reliability",
      "fiabilidad"
    ],
    [
      "unfortunately",
      "lamentablemente"
    ],
    [
      "respectively",
      "respective"
    ],
    [
      "attachment",
      "anejo"
    ],
    [
      "ringtone",
      "ringtone"
    ],
    [
      "pleasure",
      "voluptuosidad"
    ],
    [
      "honor",
      "aras"
    ],
    [
      "pants",
      "braga"
    ],
    [
      "columbus",
      "Cristóbal Colón"
    ],
    [
      "nurse",
      "atetar"
    ],
    [
      "prayer",
      "rezo"
    ],
    [
      "appointment",
      "cita"
    ],
    [
      "quiet",
      "calmo"
    ],
    [
      "producer",
      "productora"
    ],
    [
      "dial",
      "marcar"
    ],
    [
      "cheese",
      "queso"
    ],
    [
      "comic",
      "cómica"
    ],
    [
      "carefully",
      "minuciosamente"
    ],
    [
      "jet",
      "chorro"
    ],
    [
      "crown",
      "corona"
    ],
    [
      "underground",
      "organización clandestina"
    ],
    [
      "diagnosis",
      "diagnosis"
    ],
    [
      "maker",
      "hacedor"
    ],
    [
      "crack",
      "raja"
    ],
    [
      "principle",
      "canon"
    ],
    [
      "gang",
      "mara"
    ],
    [
      "semester",
      "ciclo"
    ],
    [
      "cumshot",
      "corrida"
    ],
    [
      "appearance",
      "aire"
    ],
    [
      "smoke",
      "humear"
    ],
    [
      "craft",
      "nave"
    ],
    [
      "cake",
      "tarta"
    ],
    [
      "apart",
      "aparte"
    ],
    [
      "fellow",
      "tipo"
    ],
    [
      "blind",
      "ciega"
    ],
    [
      "lounge",
      "estancia"
    ],
    [
      "mad",
      "loco"
    ],
    [
      "gross",
      "asco"
    ],
    [
      "familiar",
      "espíritu familiar"
    ],
    [
      "till",
      "roturar"
    ],
    [
      "pen",
      "pluma"
    ],
    [
      "admission",
      "admisión"
    ],
    [
      "shoe",
      "taba"
    ],
    [
      "victory",
      "triunfo"
    ],
    [
      "sand",
      "arena"
    ],
    [
      "joy",
      "gozo"
    ],
    [
      "actor",
      "actriz"
    ],
    [
      "seal",
      "sello"
    ],
    [
      "citizen",
      "ciudadana"
    ],
    [
      "prize",
      "premio"
    ],
    [
      "absolute",
      "pleno"
    ],
    [
      "anytime",
      "siempre"
    ],
    [
      "substance",
      "enjundia"
    ],
    [
      "pipe",
      "tubería"
    ],
    [
      "guardian",
      "apoderado"
    ],
    [
      "lecture",
      "clase"
    ],
    [
      "simulation",
      "piscinazo"
    ],
    [
      "layout",
      "diseño"
    ],
    [
      "ill",
      "mareado"
    ],
    [
      "lay",
      "poner"
    ],
    [
      "lol",
      "reva"
    ],
    [
      "dirty",
      "sucio"
    ],
    [
      "deck",
      "piso"
    ],
    [
      "donate",
      "delejar"
    ],
    [
      "bankruptcy",
      "quiebra"
    ],
    [
      "worker",
      "obrera"
    ],
    [
      "alive",
      "viviente"
    ],
    [
      "temple",
      "gafa"
    ],
    [
      "prove",
      "probar"
    ],
    [
      "thin",
      "delgado"
    ],
    [
      "exhibition",
      "beca"
    ],
    [
      "prefer",
      "anteponer"
    ],
    [
      "ridge",
      "arista"
    ],
    [
      "cabinet",
      "gabinete"
    ],
    [
      "collect",
      "recabar"
    ],
    [
      "bet",
      "apostar"
    ],
    [
      "definitely",
      "indudablemente"
    ],
    [
      "buffer",
      "búfer"
    ],
    [
      "purple",
      "morado"
    ],
    [
      "commentary",
      "comentarios"
    ],
    [
      "mutual",
      "mutual"
    ],
    [
      "pipeline",
      "oleoducto"
    ],
    [
      "prison",
      "prisión"
    ],
    [
      "skill",
      "maña"
    ],
    [
      "everyday",
      "común"
    ],
    [
      "apparently",
      "aparentemente"
    ],
    [
      "surrounding",
      "rededor"
    ],
    [
      "moves",
      "flou"
    ],
    [
      "inquiry",
      "pesquisa"
    ],
    [
      "exhibit",
      "exponer"
    ],
    [
      "throw",
      "tirar"
    ],
    [
      "trend",
      "moda"
    ],
    [
      "desert",
      "abandonar"
    ],
    [
      "busty",
      "tetona"
    ],
    [
      "coordinator",
      "coordinador"
    ],
    [
      "obviously",
      "a ojos vistas"
    ],
    [
      "mercury",
      "azogue"
    ],
    [
      "handbook",
      "vademécum"
    ],
    [
      "summit",
      "cima"
    ],
    [
      "burning",
      "quemamiento"
    ],
    [
      "escape",
      "escapar"
    ],
    [
      "somewhat",
      "un poco"
    ],
    [
      "receiver",
      "receptor"
    ],
    [
      "substantial",
      "cuantioso"
    ],
    [
      "progressive",
      "progresista"
    ],
    [
      "glance",
      "mirar"
    ],
    [
      "scottish",
      "escocesa"
    ],
    [
      "arcade",
      "galería"
    ],
    [
      "impossible",
      "imposible"
    ],
    [
      "obvious",
      "evidente"
    ],
    [
      "depression",
      "depresión"
    ],
    [
      "graph",
      "grafo"
    ],
    [
      "judgment",
      "laudo"
    ],
    [
      "foster",
      "criar"
    ],
    [
      "passing",
      "pase"
    ],
    [
      "tissue",
      "clínex"
    ],
    [
      "cartridge",
      "cartucho"
    ],
    [
      "folk",
      "gente"
    ],
    [
      "commons",
      "procomún"
    ],
    [
      "fraud",
      "dolo"
    ],
    [
      "arrival",
      "arribo"
    ],
    [
      "pottery",
      "loza"
    ],
    [
      "emphasis",
      "énfasis"
    ],
    [
      "roger",
      "entendido"
    ],
    [
      "workplace",
      "tajo"
    ],
    [
      "awesome",
      "paja"
    ],
    [
      "mexican",
      "mejicano"
    ],
    [
      "crash",
      "crashear"
    ],
    [
      "lift",
      "subir"
    ],
    [
      "infection",
      "infición"
    ],
    [
      "expense",
      "expendio"
    ],
    [
      "grove",
      "bosquecillo"
    ],
    [
      "venture",
      "arriesgar"
    ],
    [
      "korean",
      "coreana"
    ],
    [
      "princess",
      "coya"
    ],
    [
      "mall",
      "shopping"
    ],
    [
      "spray",
      "esprey"
    ],
    [
      "involvement",
      "involucramiento"
    ],
    [
      "placement",
      "emplazamiento"
    ],
    [
      "extend",
      "ampliar"
    ],
    [
      "subsequent",
      "subsecuente"
    ],
    [
      "pat",
      "palmadita"
    ],
    [
      "rolling",
      "rolar"
    ],
    [
      "fell",
      "cortar"
    ],
    [
      "motorcycle",
      "moto"
    ],
    [
      "yard",
      "vara"
    ],
    [
      "disclosure",
      "destape"
    ],
    [
      "establishment",
      "establishment"
    ],
    [
      "tourist",
      "guiri"
    ],
    [
      "mayor",
      "regente"
    ],
    [
      "murder",
      "devorar"
    ],
    [
      "senator",
      "senadora"
    ],
    [
      "yield",
      "dar"
    ],
    [
      "pour",
      "echar"
    ],
    [
      "lodging",
      "encamado"
    ],
    [
      "tion",
      "xión"
    ],
    [
      "dust",
      "espolvorear"
    ],
    [
      "hence",
      "de ahí"
    ],
    [
      "entirely",
      "enteramente"
    ],
    [
      "rescue",
      "acorrer"
    ],
    [
      "undergraduate",
      "pregraduado"
    ],
    [
      "combat",
      "acción"
    ],
    [
      "occupation",
      "ocupación"
    ],
    [
      "butt",
      "gol"
    ],
    [
      "diary",
      "diario personal"
    ],
    [
      "seriously",
      "seriamente"
    ],
    [
      "shooting",
      "tiro"
    ],
    [
      "ear",
      "arar"
    ],
    [
      "baker",
      "panadera"
    ],
    [
      "pollution",
      "polución"
    ],
    [
      "conservative",
      "conservador"
    ],
    [
      "shock",
      "choque"
    ],
    [
      "effectiveness",
      "eficacia"
    ],
    [
      "abroad",
      "extranjis"
    ],
    [
      "tie",
      "atar"
    ],
    [
      "ward",
      "guardia"
    ],
    [
      "ian",
      "Juan"
    ],
    [
      "roof",
      "tejado"
    ],
    [
      "walker",
      "tacatá"
    ],
    [
      "demonstrate",
      "demostrar"
    ],
    [
      "atmosphere",
      "clima"
    ],
    [
      "kiss",
      "beso"
    ],
    [
      "beast",
      "fiera"
    ],
    [
      "experiment",
      "ensayo"
    ],
    [
      "overseas",
      "ultramar"
    ],
    [
      "dodge",
      "evadir"
    ],
    [
      "counsel",
      "abogado"
    ],
    [
      "pizza",
      "pizza"
    ],
    [
      "assignment",
      "tarea"
    ],
    [
      "rush",
      "junco"
    ],
    [
      "absence",
      "absencia"
    ],
    [
      "cluster",
      "grupo"
    ],
    [
      "whereas",
      "considerando"
    ],
    [
      "lamp",
      "candil"
    ],
    [
      "partial",
      "parcial"
    ],
    [
      "everybody",
      "todo el mundo"
    ],
    [
      "ranking",
      "rankeo"
    ],
    [
      "sublime",
      "portentoso"
    ],
    [
      "acceptable",
      "asumible"
    ],
    [
      "glad",
      "alegre"
    ],
    [
      "verify",
      "verificar"
    ],
    [
      "globe",
      "globo"
    ],
    [
      "copper",
      "paco"
    ],
    [
      "rack",
      "potro"
    ],
    [
      "medication",
      "medicación"
    ],
    [
      "warehouse",
      "magacén"
    ],
    [
      "receipt",
      "receta"
    ],
    [
      "ordinary",
      "del montón"
    ],
    [
      "nobody",
      "pelagatos"
    ],
    [
      "ghost",
      "sombra"
    ],
    [
      "violation",
      "vulneración"
    ],
    [
      "southwest",
      "suroeste"
    ],
    [
      "boss",
      "jefa"
    ],
    [
      "pride",
      "manada"
    ],
    [
      "independence",
      "autonomía"
    ],
    [
      "knowing",
      "sabedor"
    ],
    [
      "reporter",
      "reportera"
    ],
    [
      "champion",
      "adalid"
    ],
    [
      "cloudy",
      "nublo"
    ],
    [
      "solo",
      "aria"
    ],
    [
      "sentence",
      "condena"
    ],
    [
      "throat",
      "gorja"
    ],
    [
      "ignore",
      "desoír"
    ],
    [
      "excellence",
      "prestancia"
    ],
    [
      "wealth",
      "prosperidad"
    ],
    [
      "somewhere",
      "a alguna parte"
    ],
    [
      "recognize",
      "reconocer"
    ],
    [
      "brass",
      "varo"
    ],
    [
      "plaza",
      "azogue"
    ],
    [
      "survival",
      "pervivencia"
    ],
    [
      "quest",
      "misión"
    ],
    [
      "publish",
      "placear"
    ],
    [
      "screening",
      "tamizado"
    ],
    [
      "toe",
      "dedo"
    ],
    [
      "thumbnail",
      "miniatura"
    ],
    [
      "whenever",
      "cuandoquiera"
    ],
    [
      "lifetime",
      "eternidad"
    ],
    [
      "pioneer",
      "pionerear"
    ],
    [
      "booty",
      "bagayo"
    ],
    [
      "acrobat",
      "equilibrista"
    ],
    [
      "venue",
      "cancha"
    ],
    [
      "thermal",
      "térmico"
    ],
    [
      "telling",
      "indicante"
    ],
    [
      "fairly",
      "bastante"
    ],
    [
      "coastal",
      "costero"
    ],
    [
      "charity",
      "caridad"
    ],
    [
      "excel",
      "bordar"
    ],
    [
      "obligation",
      "obligación"
    ],
    [
      "wake",
      "velorio"
    ],
    [
      "stupid",
      "gilí"
    ],
    [
      "harbor",
      "puerto"
    ],
    [
      "realize",
      "captar"
    ],
    [
      "regardless",
      "independientemente"
    ],
    [
      "enemy",
      "enemigo"
    ],
    [
      "puzzle",
      "puzle"
    ],
    [
      "rising",
      "ascenso"
    ],
    [
      "insight",
      "agudeza"
    ],
    [
      "shit",
      "mierda"
    ],
    [
      "restricted",
      "restricto"
    ],
    [
      "republican",
      "republicana"
    ],
    [
      "lucky",
      "lechero"
    ],
    [
      "latter",
      "último"
    ],
    [
      "thick",
      "espeso"
    ],
    [
      "repeat",
      "menudear"
    ],
    [
      "attendance",
      "asistencia"
    ],
    [
      "penalty",
      "castigo"
    ],
    [
      "drum",
      "bidón"
    ],
    [
      "builder",
      "constructora"
    ],
    [
      "jessica",
      "Jésica"
    ],
    [
      "flood",
      "riada"
    ],
    [
      "ease",
      "soltura"
    ],
    [
      "amsterdam",
      "Ámsterdam"
    ],
    [
      "arena",
      "liza"
    ],
    [
      "announcement",
      "anuncio"
    ],
    [
      "outcome",
      "desenlace"
    ],
    [
      "appreciate",
      "valorar"
    ],
    [
      "casual",
      "ocasional"
    ],
    [
      "polish",
      "acicalar"
    ],
    [
      "lovely",
      "bello"
    ],
    [
      "clause",
      "cláusula"
    ],
    [
      "smile",
      "sonreir"
    ],
    [
      "troops",
      "soldados"
    ],
    [
      "indoor",
      "interno"
    ],
    [
      "armed",
      "armífero"
    ],
    [
      "broker",
      "bróker"
    ],
    [
      "regularly",
      "comúnmente"
    ],
    [
      "pine",
      "ansia"
    ],
    [
      "tend",
      "tender"
    ],
    [
      "divorce",
      "divorciarse"
    ],
    [
      "shopper",
      "compradora"
    ],
    [
      "tokyo",
      "Tokío"
    ],
    [
      "partly",
      "en cierto modo"
    ],
    [
      "customize",
      "entallar"
    ],
    [
      "candy",
      "chuche"
    ],
    [
      "exposed",
      "expósito"
    ],
    [
      "hunt",
      "cazar"
    ],
    [
      "deputy",
      "adjunto"
    ],
    [
      "sealed",
      "sellado"
    ],
    [
      "loaded",
      "presuncioso"
    ],
    [
      "complaint",
      "denuncia"
    ],
    [
      "balls",
      "bolas"
    ],
    [
      "boost",
      "empujón"
    ],
    [
      "spanking",
      "nalgada"
    ],
    [
      "scholarship",
      "erudición"
    ],
    [
      "mill",
      "fábrica"
    ],
    [
      "tranny",
      "travelo"
    ],
    [
      "den",
      "guarida"
    ],
    [
      "catering",
      "banquete"
    ],
    [
      "finger",
      "dedo"
    ],
    [
      "pound",
      "libra"
    ],
    [
      "locate",
      "localizar"
    ],
    [
      "burn",
      "quemar"
    ],
    [
      "ourselves",
      "nosotros"
    ],
    [
      "bread",
      "lana"
    ],
    [
      "wooden",
      "acartonado"
    ],
    [
      "tough",
      "rudo"
    ],
    [
      "incident",
      "insuceso"
    ],
    [
      "lie",
      "yacer"
    ],
    [
      "decrease",
      "merma"
    ],
    [
      "chest",
      "tórax"
    ],
    [
      "pension",
      "jubilación"
    ],
    [
      "worship",
      "culto"
    ],
    [
      "bukkake",
      "bucake"
    ],
    [
      "herself",
      "se"
    ],
    [
      "precision",
      "exactitud"
    ],
    [
      "solve",
      "solver"
    ],
    [
      "minority",
      "minoría"
    ]
  ],
  "fr": [
    [
      "the",
      "le"
    ],
    [
      "of",
      "de"
    ],
    [
      "and",
      "ET"
    ],
    [
      "to",
      "à"
    ],
    [
      "a",
      "une"
    ],
    [
      "in",
      "en"
    ],
    [
      "for",
      "pour"
    ],
    [
      "on",
      "sur"
    ],
    [
      "that",
      "que"
    ],
    [
      "by",
      "par"
    ],
    [
      "this",
      "ce"
    ],
    [
      "with",
      "avec"
    ],
    [
      "i",
      "moi"
    ],
    [
      "you",
      "tu"
    ],
    [
      "it",
      "ça"
    ],
    [
      "not",
      "pas"
    ],
    [
      "be",
      "être"
    ],
    [
      "from",
      "sur"
    ],
    [
      "at",
      "à"
    ],
    [
      "as",
      "comme"
    ],
    [
      "your",
      "vos"
    ],
    [
      "all",
      "toute"
    ],
    [
      "have",
      "avoir"
    ],
    [
      "new",
      "nouvel"
    ],
    [
      "more",
      "moré"
    ],
    [
      "an",
      "une"
    ],
    [
      "we",
      "on"
    ],
    [
      "will",
      "-erai"
    ],
    [
      "home",
      "maison"
    ],
    [
      "can",
      "WC"
    ],
    [
      "about",
      "de"
    ],
    [
      "if",
      "si"
    ],
    [
      "page",
      "biper"
    ],
    [
      "my",
      "ma"
    ],
    [
      "search",
      "chercher"
    ],
    [
      "free",
      "libre"
    ],
    [
      "but",
      "que"
    ],
    [
      "our",
      "nos"
    ],
    [
      "one",
      "une"
    ],
    [
      "other",
      "autrui"
    ],
    [
      "do",
      "aller"
    ],
    [
      "no",
      "interdit"
    ],
    [
      "information",
      "informations"
    ],
    [
      "time",
      "heure"
    ],
    [
      "they",
      "al"
    ],
    [
      "site",
      "site"
    ],
    [
      "he",
      "hê"
    ],
    [
      "up",
      "haut"
    ],
    [
      "may",
      "que"
    ],
    [
      "what",
      "que"
    ],
    [
      "which",
      "que"
    ],
    [
      "their",
      "leurs"
    ],
    [
      "news",
      "infos"
    ],
    [
      "out",
      "hors"
    ],
    [
      "use",
      "user"
    ],
    [
      "any",
      "tous"
    ],
    [
      "there",
      "y"
    ],
    [
      "see",
      "évêché"
    ],
    [
      "only",
      "que"
    ],
    [
      "so",
      "donc"
    ],
    [
      "his",
      "sa"
    ],
    [
      "when",
      "quand"
    ],
    [
      "contact",
      "lentille"
    ],
    [
      "here",
      "par ici"
    ],
    [
      "business",
      "firme"
    ],
    [
      "web",
      "bande"
    ],
    [
      "also",
      "également"
    ],
    [
      "now",
      "or"
    ],
    [
      "help",
      "aide"
    ],
    [
      "get",
      "arriver"
    ],
    [
      "view",
      "vue"
    ],
    [
      "online",
      "en ligne"
    ],
    [
      "c",
      "do"
    ],
    [
      "e",
      "E"
    ],
    [
      "first",
      "première"
    ],
    [
      "would",
      "vouloir"
    ],
    [
      "how",
      "comme"
    ],
    [
      "me",
      "moi"
    ],
    [
      "s",
      "x"
    ],
    [
      "some",
      "du"
    ],
    [
      "these",
      "ceux-ci"
    ],
    [
      "click",
      "clic"
    ],
    [
      "its",
      "sa"
    ],
    [
      "like",
      "aimer"
    ],
    [
      "service",
      "servir"
    ],
    [
      "date",
      "rencard"
    ],
    [
      "back",
      "derrière"
    ],
    [
      "top",
      "actif"
    ],
    [
      "people",
      "gens"
    ],
    [
      "list",
      "gîte"
    ],
    [
      "name",
      "élire"
    ],
    [
      "just",
      "juste"
    ],
    [
      "over",
      "re-"
    ],
    [
      "state",
      "État"
    ],
    [
      "year",
      "an"
    ],
    [
      "day",
      "journée"
    ],
    [
      "into",
      "dans"
    ],
    [
      "email",
      "courrieller"
    ],
    [
      "two",
      "billet de deux dollars"
    ],
    [
      "health",
      "PV"
    ],
    [
      "world",
      "Terre"
    ],
    [
      "next",
      "prochain"
    ],
    [
      "used",
      "seconde main"
    ],
    [
      "go",
      "faire"
    ],
    [
      "b",
      "o"
    ],
    [
      "work",
      "œuvre"
    ],
    [
      "last",
      "tenir"
    ],
    [
      "most",
      "très"
    ],
    [
      "music",
      "partition"
    ],
    [
      "buy",
      "gober"
    ],
    [
      "make",
      "créer"
    ],
    [
      "them",
      "eux"
    ],
    [
      "should",
      "devoir"
    ],
    [
      "post",
      "poster"
    ],
    [
      "her",
      "sa"
    ],
    [
      "city",
      "cité"
    ],
    [
      "add",
      "additionner"
    ],
    [
      "policy",
      "police"
    ],
    [
      "number",
      "numéro"
    ],
    [
      "such",
      "pareil"
    ],
    [
      "please",
      "allez"
    ],
    [
      "available",
      "accessible"
    ],
    [
      "copyright",
      "copyright"
    ],
    [
      "support",
      "appui"
    ],
    [
      "after",
      "après"
    ],
    [
      "best",
      "crème"
    ],
    [
      "then",
      "puis"
    ],
    [
      "good",
      "bon"
    ],
    [
      "video",
      "vidéo"
    ],
    [
      "well",
      "bah"
    ],
    [
      "where",
      "où"
    ],
    [
      "high",
      "gelé"
    ],
    [
      "school",
      "école"
    ],
    [
      "through",
      "à travers"
    ],
    [
      "each",
      "chacun"
    ],
    [
      "review",
      "revue"
    ],
    [
      "order",
      "ordre"
    ],
    [
      "very",
      "beaucoup"
    ],
    [
      "privacy",
      "intimité"
    ],
    [
      "book",
      "bouquin"
    ],
    [
      "company",
      "compagnie"
    ],
    [
      "read",
      "étudier"
    ],
    [
      "sex",
      "[[faire l'amour]]"
    ],
    [
      "need",
      "nécessiter"
    ],
    [
      "many",
      "nombreux"
    ],
    [
      "user",
      "consommateur"
    ],
    [
      "set",
      "série"
    ],
    [
      "under",
      "sous"
    ],
    [
      "general",
      "général"
    ],
    [
      "research",
      "examiner"
    ],
    [
      "university",
      "fac"
    ],
    [
      "mail",
      "poste"
    ],
    [
      "full",
      "plein"
    ],
    [
      "map",
      "plan"
    ],
    [
      "program",
      "programme"
    ],
    [
      "know",
      "connaître"
    ],
    [
      "way",
      "moyen"
    ],
    [
      "management",
      "gestion"
    ],
    [
      "part",
      "raie"
    ],
    [
      "great",
      "grand"
    ],
    [
      "united",
      "uni"
    ],
    [
      "real",
      "vrai"
    ],
    [
      "item",
      "truc"
    ],
    [
      "center",
      "centre"
    ],
    [
      "must",
      "mout"
    ],
    [
      "store",
      "stock"
    ],
    [
      "travel",
      "voyager"
    ],
    [
      "report",
      "rapporter"
    ],
    [
      "off",
      "fermé"
    ],
    [
      "line",
      "ligne"
    ],
    [
      "before",
      "avant"
    ],
    [
      "right",
      "droite"
    ],
    [
      "type",
      "genre"
    ],
    [
      "because",
      "à cause que"
    ],
    [
      "those",
      "ceux-là"
    ],
    [
      "office",
      "bureau"
    ],
    [
      "education",
      "éducation"
    ],
    [
      "national",
      "nationale"
    ],
    [
      "car",
      "auto"
    ],
    [
      "design",
      "modèle"
    ],
    [
      "take",
      "prendre"
    ],
    [
      "address",
      "langage"
    ],
    [
      "within",
      "avant"
    ],
    [
      "area",
      "aire"
    ],
    [
      "want",
      "désir"
    ],
    [
      "phone",
      "téléphoner"
    ],
    [
      "dvd",
      "dévédé"
    ],
    [
      "shipping",
      "transport"
    ],
    [
      "subject",
      "sujet"
    ],
    [
      "long",
      "temps"
    ],
    [
      "show",
      "montrer"
    ],
    [
      "even",
      "même"
    ],
    [
      "black",
      "Noir"
    ],
    [
      "check",
      "checker"
    ],
    [
      "special",
      "spécial"
    ],
    [
      "website",
      "site"
    ],
    [
      "index",
      "indice"
    ],
    [
      "being",
      "être"
    ],
    [
      "sign",
      "signe"
    ],
    [
      "file",
      "fichier"
    ],
    [
      "link",
      "lien"
    ],
    [
      "open",
      "faux contact"
    ],
    [
      "today",
      "aujourd'hui"
    ],
    [
      "technology",
      "technique"
    ],
    [
      "south",
      "midi"
    ],
    [
      "case",
      "cas"
    ],
    [
      "same",
      "pareil"
    ],
    [
      "uk",
      "RU"
    ],
    [
      "section",
      "article"
    ],
    [
      "own",
      "avoir"
    ],
    [
      "house",
      "loger"
    ],
    [
      "related",
      "apparenté"
    ],
    [
      "security",
      "sécurité"
    ],
    [
      "both",
      "tout deux"
    ],
    [
      "county",
      "comté"
    ],
    [
      "american",
      "Américain"
    ],
    [
      "game",
      "jeu"
    ],
    [
      "power",
      "puissance"
    ],
    [
      "while",
      "tandis que"
    ],
    [
      "care",
      "souci"
    ],
    [
      "network",
      "réseau"
    ],
    [
      "down",
      "HS"
    ],
    [
      "three",
      "trio"
    ],
    [
      "total",
      "somme"
    ],
    [
      "place",
      "lieu"
    ],
    [
      "end",
      "bout"
    ],
    [
      "following",
      "suivant"
    ],
    [
      "him",
      "lui"
    ],
    [
      "without",
      "hormis"
    ],
    [
      "per",
      "par"
    ],
    [
      "access",
      "accès"
    ],
    [
      "think",
      "croire"
    ],
    [
      "north",
      "boréal"
    ],
    [
      "current",
      "actuel"
    ],
    [
      "big",
      "gros"
    ],
    [
      "law",
      "loi"
    ],
    [
      "control",
      "contrôle"
    ],
    [
      "water",
      "eau"
    ],
    [
      "history",
      "histoire"
    ],
    [
      "size",
      "taille"
    ],
    [
      "art",
      "œuvre"
    ],
    [
      "personal",
      "personnel"
    ],
    [
      "since",
      "depuis"
    ],
    [
      "including",
      "dont"
    ],
    [
      "shop",
      "atelier"
    ],
    [
      "directory",
      "dossier"
    ],
    [
      "board",
      "bord"
    ],
    [
      "location",
      "lieu"
    ],
    [
      "change",
      "changer"
    ],
    [
      "white",
      "blanche"
    ],
    [
      "text",
      "SMS"
    ],
    [
      "small",
      "jeune"
    ],
    [
      "rating",
      "notation"
    ],
    [
      "rate",
      "coût"
    ],
    [
      "government",
      "rection"
    ],
    [
      "during",
      "pendant"
    ],
    [
      "usa",
      "ÉUA"
    ],
    [
      "return",
      "rendre"
    ],
    [
      "shopping",
      "achat"
    ],
    [
      "account",
      "récit"
    ],
    [
      "level",
      "constant"
    ],
    [
      "digital",
      "numérique"
    ],
    [
      "profile",
      "profil"
    ],
    [
      "form",
      "forme"
    ],
    [
      "love",
      "amour"
    ],
    [
      "old",
      "vieil"
    ],
    [
      "john",
      "1"
    ],
    [
      "call",
      "cri"
    ],
    [
      "department",
      "ministère"
    ],
    [
      "title",
      "titre"
    ],
    [
      "description",
      "signalement"
    ],
    [
      "y",
      "é"
    ],
    [
      "another",
      "autre"
    ],
    [
      "why",
      "ha"
    ],
    [
      "property",
      "propriété"
    ],
    [
      "class",
      "top"
    ],
    [
      "still",
      "encore"
    ],
    [
      "money",
      "argent"
    ],
    [
      "every",
      "tout"
    ],
    [
      "country",
      "contrée"
    ],
    [
      "private",
      "privé"
    ],
    [
      "little",
      "peu"
    ],
    [
      "visit",
      "séjour"
    ],
    [
      "save",
      "économiser"
    ],
    [
      "low",
      "bas"
    ],
    [
      "customer",
      "client"
    ],
    [
      "include",
      "comprendre"
    ],
    [
      "college",
      "université"
    ],
    [
      "value",
      "valoriser"
    ],
    [
      "york",
      "Yorck"
    ],
    [
      "man",
      "pion"
    ],
    [
      "card",
      "carde"
    ],
    [
      "provide",
      "pourvoir"
    ],
    [
      "food",
      "bouffe"
    ],
    [
      "author",
      "écrire"
    ],
    [
      "press",
      "presse"
    ],
    [
      "learn",
      "étudier"
    ],
    [
      "sale",
      "vente"
    ],
    [
      "around",
      "dans"
    ],
    [
      "print",
      "estampe"
    ],
    [
      "course",
      "plat"
    ],
    [
      "job",
      "boulot"
    ],
    [
      "process",
      "processus"
    ],
    [
      "teen",
      "ix-"
    ],
    [
      "room",
      "pièce"
    ],
    [
      "stock",
      "jas"
    ],
    [
      "training",
      "entrainement"
    ],
    [
      "too",
      "trop"
    ],
    [
      "credit",
      "crédit"
    ],
    [
      "point",
      "but"
    ],
    [
      "join",
      "joindre"
    ],
    [
      "men",
      "on"
    ],
    [
      "west",
      "Ouest"
    ],
    [
      "look",
      "air"
    ],
    [
      "english",
      "anglais"
    ],
    [
      "left",
      "gauche"
    ],
    [
      "estate",
      "biens"
    ],
    [
      "box",
      "boîte"
    ],
    [
      "select",
      "choisir"
    ],
    [
      "gay",
      "gai"
    ],
    [
      "thread",
      "fil"
    ],
    [
      "week",
      "huit jours"
    ],
    [
      "note",
      "noter"
    ],
    [
      "live",
      "vivre"
    ],
    [
      "gallery",
      "balcon"
    ],
    [
      "table",
      "tableau"
    ],
    [
      "register",
      "imprimer"
    ],
    [
      "however",
      "pourtant"
    ],
    [
      "market",
      "marché"
    ],
    [
      "library",
      "librairie"
    ],
    [
      "really",
      "vraiment ?"
    ],
    [
      "action",
      "action légale"
    ],
    [
      "start",
      "départ"
    ],
    [
      "series",
      "série"
    ],
    [
      "model",
      "modèle"
    ],
    [
      "air",
      "aria"
    ],
    [
      "plan",
      "plan"
    ],
    [
      "human",
      "homme"
    ],
    [
      "provided",
      "seulement si"
    ],
    [
      "yes",
      "si"
    ],
    [
      "second",
      "seconde"
    ],
    [
      "hot",
      "vif"
    ],
    [
      "cost",
      "couter"
    ],
    [
      "movie",
      "œuvre cinématographique"
    ],
    [
      "march",
      "défilé"
    ],
    [
      "better",
      "meilleur"
    ],
    [
      "say",
      "dire"
    ],
    [
      "test",
      "test"
    ],
    [
      "friend",
      "copain"
    ],
    [
      "come",
      "s’avérer"
    ],
    [
      "server",
      "servante"
    ],
    [
      "study",
      "étudier"
    ],
    [
      "application",
      "demande"
    ],
    [
      "cart",
      "charrette"
    ],
    [
      "staff",
      "canne"
    ],
    [
      "feedback",
      "retour"
    ],
    [
      "again",
      "encore"
    ],
    [
      "play",
      "jouer"
    ],
    [
      "complete",
      "complète"
    ],
    [
      "topic",
      "thème"
    ],
    [
      "against",
      "pour"
    ],
    [
      "standard",
      "étalon"
    ],
    [
      "tax",
      "taxe"
    ],
    [
      "below",
      "au-dessous"
    ],
    [
      "less",
      "moins"
    ],
    [
      "blog",
      "blogue"
    ],
    [
      "party",
      "parti"
    ],
    [
      "payment",
      "payement"
    ],
    [
      "login",
      "compte"
    ],
    [
      "student",
      "étudiante"
    ],
    [
      "let",
      "louer"
    ],
    [
      "legal",
      "légal"
    ],
    [
      "above",
      "au-dessus"
    ],
    [
      "park",
      "parquer"
    ],
    [
      "side",
      "côté"
    ],
    [
      "act",
      "se comporter"
    ],
    [
      "red",
      "rouge"
    ],
    [
      "give",
      "bailler"
    ],
    [
      "memory",
      "mémoire"
    ],
    [
      "performance",
      "exécution"
    ],
    [
      "august",
      "aout"
    ],
    [
      "quote",
      "coter"
    ],
    [
      "language",
      "langage"
    ],
    [
      "story",
      "conte"
    ],
    [
      "experience",
      "vivre"
    ],
    [
      "create",
      "nommer"
    ],
    [
      "key",
      "clef"
    ],
    [
      "body",
      "corps"
    ],
    [
      "field",
      "champ"
    ],
    [
      "few",
      "peu"
    ],
    [
      "east",
      "orient"
    ],
    [
      "paper",
      "article"
    ],
    [
      "single",
      "simple"
    ],
    [
      "age",
      "âge"
    ],
    [
      "club",
      "club"
    ],
    [
      "password",
      "mot d'ordre"
    ],
    [
      "road",
      "chemin"
    ],
    [
      "gift",
      "don"
    ],
    [
      "question",
      "question"
    ],
    [
      "night",
      "nuit"
    ],
    [
      "hard",
      "dur"
    ],
    [
      "pay",
      "payer"
    ],
    [
      "poker",
      "poker"
    ],
    [
      "status",
      "statut"
    ],
    [
      "browse",
      "parcourir"
    ],
    [
      "issue",
      "jaillir"
    ],
    [
      "range",
      "portée"
    ],
    [
      "building",
      "édifice"
    ],
    [
      "seller",
      "vendeuse"
    ],
    [
      "court",
      "tribunal"
    ],
    [
      "result",
      "effet"
    ],
    [
      "light",
      "léger"
    ],
    [
      "write",
      "écrire"
    ],
    [
      "war",
      "guerre"
    ],
    [
      "offer",
      "offre"
    ],
    [
      "blue",
      "bleu"
    ],
    [
      "easy",
      "aisé"
    ],
    [
      "given",
      "énoncé"
    ],
    [
      "event",
      "évènement"
    ],
    [
      "release",
      "lâcher"
    ],
    [
      "request",
      "demande"
    ],
    [
      "fax",
      "oïn"
    ],
    [
      "picture",
      "photo"
    ],
    [
      "possible",
      "faisable"
    ],
    [
      "might",
      "force"
    ],
    [
      "professional",
      "professionnelle"
    ],
    [
      "yet",
      "or"
    ],
    [
      "major",
      "majeur"
    ],
    [
      "star",
      "étoile"
    ],
    [
      "future",
      "futur"
    ],
    [
      "space",
      "blanc"
    ],
    [
      "committee",
      "commission"
    ],
    [
      "hand",
      "main"
    ],
    [
      "sun",
      "Soleil"
    ],
    [
      "london",
      "Londres"
    ],
    [
      "meeting",
      "réunion"
    ],
    [
      "become",
      "devenir"
    ],
    [
      "id",
      "idé"
    ],
    [
      "keep",
      "conserver"
    ],
    [
      "enter",
      "taper"
    ],
    [
      "share",
      "action"
    ],
    [
      "similar",
      "similaire"
    ],
    [
      "garden",
      "parc"
    ],
    [
      "reference",
      "référer"
    ],
    [
      "baby",
      "bébé"
    ],
    [
      "energy",
      "courage"
    ],
    [
      "run",
      "courir"
    ],
    [
      "delivery",
      "débit"
    ],
    [
      "net",
      "réseau"
    ],
    [
      "term",
      "terme"
    ],
    [
      "film",
      "tourner"
    ],
    [
      "put",
      "poser"
    ],
    [
      "journal",
      "journal"
    ],
    [
      "try",
      "essai"
    ],
    [
      "welcome",
      "bienvenu"
    ],
    [
      "president",
      "présidente"
    ],
    [
      "notice",
      "avis"
    ],
    [
      "god",
      "dieu"
    ],
    [
      "original",
      "originel"
    ],
    [
      "head",
      "tête"
    ],
    [
      "radio",
      "radiodiffusion"
    ],
    [
      "until",
      "avant"
    ],
    [
      "cell",
      "cellule"
    ],
    [
      "color",
      "rougir"
    ],
    [
      "track",
      "voie"
    ],
    [
      "once",
      "une fois"
    ],
    [
      "agreement",
      "pacte"
    ],
    [
      "least",
      "moins"
    ],
    [
      "log",
      "loch"
    ],
    [
      "safety",
      "sûreté"
    ],
    [
      "sure",
      "certain"
    ],
    [
      "trade",
      "négoce"
    ],
    [
      "marketing",
      "mercatique"
    ],
    [
      "tell",
      "se voir"
    ],
    [
      "further",
      "plus loin"
    ],
    [
      "able",
      "ible"
    ],
    [
      "already",
      "enfin"
    ],
    [
      "green",
      "vert"
    ],
    [
      "close",
      "clore"
    ],
    [
      "common",
      "commun"
    ],
    [
      "drive",
      "pousser"
    ],
    [
      "gold",
      "or"
    ],
    [
      "living",
      "vie"
    ],
    [
      "collection",
      "collection"
    ],
    [
      "short",
      "bref"
    ],
    [
      "lot",
      "lot"
    ],
    [
      "ask",
      "poser"
    ],
    [
      "display",
      "étaler"
    ],
    [
      "director",
      "régisseur"
    ],
    [
      "daily",
      "journalier"
    ],
    [
      "past",
      "passé"
    ],
    [
      "natural",
      "naturel"
    ],
    [
      "whether",
      "que"
    ],
    [
      "due",
      "plein"
    ],
    [
      "upon",
      "sur"
    ],
    [
      "period",
      "période"
    ],
    [
      "planning",
      "prévision"
    ],
    [
      "database",
      "banque de données"
    ],
    [
      "official",
      "juge"
    ],
    [
      "weather",
      "météo"
    ],
    [
      "land",
      "pays"
    ],
    [
      "done",
      "cuit"
    ],
    [
      "window",
      "fenêtre"
    ],
    [
      "pro",
      "expert"
    ],
    [
      "island",
      "ile"
    ],
    [
      "record",
      "disque"
    ],
    [
      "direct",
      "ordonner"
    ],
    [
      "environment",
      "milieu"
    ],
    [
      "st",
      "St."
    ],
    [
      "district",
      "district"
    ],
    [
      "calendar",
      "agenda"
    ],
    [
      "style",
      "style"
    ],
    [
      "front",
      "avant"
    ],
    [
      "statement",
      "relevé"
    ],
    [
      "update",
      "updater"
    ],
    [
      "ever",
      "jamais"
    ],
    [
      "early",
      "précoce"
    ],
    [
      "sound",
      "sonner"
    ],
    [
      "present",
      "actuel"
    ],
    [
      "either",
      "ou"
    ],
    [
      "document",
      "écrit"
    ],
    [
      "word",
      "parole"
    ],
    [
      "material",
      "matériel"
    ],
    [
      "bill",
      "bec"
    ],
    [
      "talk",
      "bavarder"
    ],
    [
      "federal",
      "fédérale"
    ],
    [
      "final",
      "examen"
    ],
    [
      "adult",
      "grand"
    ],
    [
      "thing",
      "truc"
    ],
    [
      "centre",
      "région Centre"
    ],
    [
      "via",
      "par"
    ],
    [
      "cheap",
      "radin"
    ],
    [
      "finance",
      "finance"
    ],
    [
      "true",
      "vrai"
    ],
    [
      "minutes",
      "acte"
    ],
    [
      "else",
      "autrement"
    ],
    [
      "mark",
      "marquer"
    ],
    [
      "third",
      "tiers"
    ],
    [
      "rock",
      "roche"
    ],
    [
      "bad",
      "méchant"
    ],
    [
      "individual",
      "individuel"
    ],
    [
      "plus",
      "positif"
    ],
    [
      "cover",
      "couverture"
    ],
    [
      "usually",
      "d'habitude"
    ],
    [
      "edit",
      "monter"
    ],
    [
      "percent",
      "pourcent"
    ],
    [
      "fast",
      "vite"
    ],
    [
      "function",
      "marcher"
    ],
    [
      "fact",
      "fait"
    ],
    [
      "global",
      "globulaire"
    ],
    [
      "meet",
      "rejoindre"
    ],
    [
      "far",
      "reculé"
    ],
    [
      "player",
      "joueur"
    ],
    [
      "often",
      "souventefois"
    ],
    [
      "subscribe",
      "abonner"
    ],
    [
      "submit",
      "présenter"
    ],
    [
      "amount",
      "somme"
    ],
    [
      "watch",
      "veiller"
    ],
    [
      "feel",
      "sentir"
    ],
    [
      "though",
      "cependant"
    ],
    [
      "bank",
      "banque"
    ],
    [
      "thanks",
      "merci"
    ],
    [
      "weight",
      "lest"
    ],
    [
      "town",
      "bourg"
    ],
    [
      "heart",
      "cœur"
    ],
    [
      "choose",
      "élire"
    ],
    [
      "newsletter",
      "bulletin"
    ],
    [
      "knowledge",
      "science"
    ],
    [
      "magazine",
      "revue"
    ],
    [
      "error",
      "vice"
    ],
    [
      "camera",
      "caméra"
    ],
    [
      "girl",
      "femme"
    ],
    [
      "currently",
      "maintenant"
    ],
    [
      "construction",
      "édification"
    ],
    [
      "registered",
      "inscrit"
    ],
    [
      "clear",
      "clair"
    ],
    [
      "domain",
      "domaine"
    ],
    [
      "chapter",
      "branche"
    ],
    [
      "loan",
      "prêt"
    ],
    [
      "wide",
      "ample"
    ],
    [
      "manager",
      "chef"
    ],
    [
      "position",
      "poste"
    ],
    [
      "sort",
      "tri"
    ],
    [
      "michael",
      "Michel"
    ],
    [
      "half",
      "demi"
    ],
    [
      "step",
      "pas"
    ],
    [
      "engineering",
      "génie"
    ],
    [
      "quick",
      "animé"
    ],
    [
      "none",
      "aucune"
    ],
    [
      "lake",
      "lac"
    ],
    [
      "whole",
      "tout"
    ],
    [
      "later",
      "plus en retard"
    ],
    [
      "google",
      "googliser"
    ],
    [
      "church",
      "église"
    ],
    [
      "method",
      "manière"
    ],
    [
      "purchase",
      "acheter"
    ],
    [
      "hardware",
      "matériel"
    ],
    [
      "figure",
      "silhouette"
    ],
    [
      "fire",
      "feu"
    ],
    [
      "holiday",
      "vacances"
    ],
    [
      "chat",
      "jaser"
    ],
    [
      "enough",
      "suffisamment"
    ],
    [
      "death",
      "l'arcane sans nom"
    ],
    [
      "writing",
      "écriture"
    ],
    [
      "speed",
      "vitesse"
    ],
    [
      "loss",
      "perte"
    ],
    [
      "face",
      "face"
    ],
    [
      "brand",
      "style"
    ],
    [
      "discount",
      "discompte"
    ],
    [
      "remember",
      "retenir"
    ],
    [
      "oil",
      "huile"
    ],
    [
      "bit",
      "bit"
    ],
    [
      "yellow",
      "lâche"
    ],
    [
      "increase",
      "croître"
    ],
    [
      "advertise",
      "publier"
    ],
    [
      "kingdom",
      "règne"
    ],
    [
      "base",
      "base"
    ],
    [
      "near",
      "proche"
    ],
    [
      "thought",
      "idée"
    ],
    [
      "stuff",
      "péter"
    ],
    [
      "french",
      "langue française"
    ],
    [
      "storage",
      "entrepôt"
    ],
    [
      "oh",
      "ô"
    ],
    [
      "entry",
      "entrée"
    ],
    [
      "stay",
      "rester"
    ],
    [
      "africa",
      "l’Afrique"
    ],
    [
      "summary",
      "sommaire"
    ],
    [
      "turn",
      "tour"
    ],
    [
      "mean",
      "moyen"
    ],
    [
      "agency",
      "agence"
    ],
    [
      "king",
      "dame"
    ],
    [
      "european",
      "Européen"
    ],
    [
      "copy",
      "copie"
    ],
    [
      "although",
      "mais"
    ],
    [
      "income",
      "recette"
    ],
    [
      "force",
      "force"
    ],
    [
      "cash",
      "espèces"
    ],
    [
      "employment",
      "emploi"
    ],
    [
      "overall",
      "total"
    ],
    [
      "bay",
      "baie"
    ],
    [
      "river",
      "fleuve"
    ],
    [
      "commission",
      "courtage"
    ],
    [
      "ad",
      "en l'an de grâce"
    ],
    [
      "package",
      "paquet"
    ],
    [
      "port",
      "babord"
    ],
    [
      "stop",
      "arrêter"
    ],
    [
      "bar",
      "barre"
    ],
    [
      "institute",
      "fonder"
    ],
    [
      "double",
      "double"
    ],
    [
      "dog",
      "thon"
    ],
    [
      "build",
      "monter"
    ],
    [
      "screen",
      "écran"
    ],
    [
      "exchange",
      "troc"
    ],
    [
      "season",
      "temps"
    ],
    [
      "apply",
      "postuler"
    ],
    [
      "anything",
      "rien"
    ],
    [
      "printer",
      "imprimeur"
    ],
    [
      "effective",
      "efficace"
    ],
    [
      "believe",
      "croire"
    ],
    [
      "effect",
      "effets"
    ],
    [
      "mind",
      "génie"
    ],
    [
      "sunday",
      "presse dominicale"
    ],
    [
      "tour",
      "tour"
    ],
    [
      "menu",
      "carte"
    ],
    [
      "volume",
      "tome"
    ],
    [
      "cross",
      "croiser"
    ],
    [
      "anyone",
      "personne"
    ],
    [
      "hope",
      "Nadine"
    ],
    [
      "silver",
      "argenté"
    ],
    [
      "corporation",
      "corporation"
    ],
    [
      "wish",
      "désir"
    ],
    [
      "inside",
      "dans"
    ],
    [
      "mature",
      "mûr"
    ],
    [
      "role",
      "rôle"
    ],
    [
      "rather",
      "au contraire"
    ],
    [
      "addition",
      "ajout"
    ],
    [
      "supply",
      "vivres"
    ],
    [
      "nothing",
      "nulle chose"
    ],
    [
      "certain",
      "quelconque"
    ],
    [
      "executive",
      "cadre"
    ],
    [
      "running",
      "course"
    ],
    [
      "lower",
      "baisser"
    ],
    [
      "union",
      "union"
    ],
    [
      "clothing",
      "habits"
    ],
    [
      "fine",
      "fin"
    ],
    [
      "hour",
      "heure"
    ],
    [
      "gas",
      "boulet"
    ],
    [
      "bush",
      "maquis"
    ],
    [
      "advice",
      "avis"
    ],
    [
      "military",
      "troupes"
    ],
    [
      "decision",
      "arrêt"
    ],
    [
      "leave",
      "congé"
    ],
    [
      "zip",
      "zipper"
    ],
    [
      "bid",
      "dire"
    ],
    [
      "kind",
      "genre"
    ],
    [
      "middle",
      "central"
    ],
    [
      "move",
      "bouger"
    ],
    [
      "cable",
      "câble"
    ],
    [
      "coming",
      "arrivée"
    ],
    [
      "object",
      "chose"
    ],
    [
      "lesbian",
      "gouine"
    ],
    [
      "appropriate",
      "idoine"
    ],
    [
      "logo",
      "logotype"
    ],
    [
      "length",
      "durée"
    ],
    [
      "actually",
      "effectivement"
    ],
    [
      "nice",
      "bon"
    ],
    [
      "score",
      "marquer"
    ],
    [
      "statistics",
      "statistique"
    ],
    [
      "client",
      "cliente"
    ],
    [
      "ok",
      "OK"
    ],
    [
      "capital",
      "excellent"
    ],
    [
      "follow",
      "suivre"
    ],
    [
      "sample",
      "exemple"
    ],
    [
      "band",
      "bande"
    ],
    [
      "flash",
      "s'exhiber"
    ],
    [
      "lead",
      "mener"
    ],
    [
      "george",
      "Jore"
    ],
    [
      "choice",
      "morceau de choix"
    ],
    [
      "thursday",
      "jeudi"
    ],
    [
      "consumer",
      "consommatrice"
    ],
    [
      "foreign",
      "étrangère"
    ],
    [
      "artist",
      "peintre"
    ],
    [
      "outside",
      "dehors"
    ],
    [
      "furniture",
      "meuble"
    ],
    [
      "channel",
      "chenal"
    ],
    [
      "letter",
      "lettre"
    ],
    [
      "mode",
      "mode"
    ],
    [
      "allow",
      "laisser"
    ],
    [
      "degree",
      "degré"
    ],
    [
      "contract",
      "rétracter"
    ],
    [
      "button",
      "bouton"
    ],
    [
      "wed",
      "épouser"
    ],
    [
      "male",
      "mâle"
    ],
    [
      "matter",
      "matière"
    ],
    [
      "custom",
      "us"
    ],
    [
      "almost",
      "quasiment"
    ],
    [
      "asian",
      "asiatique"
    ],
    [
      "editor",
      "éditeur"
    ],
    [
      "cause",
      "raison"
    ],
    [
      "potential",
      "possibilité"
    ],
    [
      "song",
      "chant"
    ],
    [
      "hp",
      "cv"
    ],
    [
      "focus",
      "mettre au point"
    ],
    [
      "late",
      "en retard"
    ],
    [
      "fall",
      "tomber"
    ],
    [
      "idea",
      "idée"
    ],
    [
      "female",
      "femelle"
    ],
    [
      "win",
      "gain"
    ],
    [
      "primary",
      "primaire"
    ],
    [
      "reason",
      "cause"
    ],
    [
      "tool",
      "engin"
    ],
    [
      "spring",
      "source"
    ],
    [
      "foundation",
      "fondation"
    ],
    [
      "answer",
      "réponse"
    ],
    [
      "voice",
      "voix"
    ],
    [
      "friendly",
      "allié"
    ],
    [
      "schedule",
      "horaire"
    ],
    [
      "communication",
      "message"
    ],
    [
      "purpose",
      "sujet"
    ],
    [
      "feature",
      "trait"
    ],
    [
      "bed",
      "lit"
    ],
    [
      "police",
      "gendarmerie"
    ],
    [
      "everyone",
      "tous"
    ],
    [
      "approach",
      "approcher"
    ],
    [
      "brown",
      "marron"
    ],
    [
      "physical",
      "physiologique"
    ],
    [
      "hill",
      "côte"
    ],
    [
      "medicine",
      "remède"
    ],
    [
      "deal",
      "pli"
    ],
    [
      "hold",
      "détenir"
    ],
    [
      "glass",
      "verre"
    ],
    [
      "happy",
      "content"
    ],
    [
      "smith",
      "Lefebvre"
    ],
    [
      "safe",
      "sauf"
    ],
    [
      "survey",
      "enquête"
    ],
    [
      "prior",
      "prieur"
    ],
    [
      "telephone",
      "appeler"
    ],
    [
      "sport",
      "flirt"
    ],
    [
      "ready",
      "prête"
    ],
    [
      "feed",
      "flux"
    ],
    [
      "animal",
      "bête"
    ],
    [
      "pa",
      "pépé"
    ],
    [
      "regular",
      "régulier"
    ],
    [
      "therefore",
      "pour ça"
    ],
    [
      "ass",
      "cul"
    ],
    [
      "evidence",
      "prouver"
    ],
    [
      "station",
      "gare"
    ],
    [
      "christian",
      "chrétienne"
    ],
    [
      "round",
      "rond"
    ],
    [
      "option",
      "choix"
    ],
    [
      "valley",
      "val"
    ],
    [
      "recently",
      "dernièrement"
    ],
    [
      "probably",
      "sûrement"
    ],
    [
      "cut",
      "coupe"
    ],
    [
      "worldwide",
      "mondialement"
    ],
    [
      "improve",
      "amender"
    ],
    [
      "connection",
      "connexion"
    ],
    [
      "publisher",
      "maison d’édition"
    ],
    [
      "hall",
      "salle"
    ],
    [
      "earth",
      "terre"
    ],
    [
      "impact",
      "choc"
    ],
    [
      "introduction",
      "présentation"
    ],
    [
      "strong",
      "fort"
    ],
    [
      "wedding",
      "noces"
    ],
    [
      "ground",
      "terre"
    ],
    [
      "overview",
      "aperçu"
    ],
    [
      "ship",
      "eur"
    ],
    [
      "accommodation",
      "logement"
    ],
    [
      "disease",
      "mal"
    ],
    [
      "perfect",
      "parfaire"
    ],
    [
      "hair",
      "cheveu"
    ],
    [
      "opportunity",
      "opportunité"
    ],
    [
      "kit",
      "jeu"
    ],
    [
      "command",
      "commandement"
    ],
    [
      "william",
      "William"
    ],
    [
      "express",
      "énoncer"
    ],
    [
      "award",
      "trophée"
    ],
    [
      "distance",
      "s'éloigner"
    ],
    [
      "tree",
      "arçon"
    ],
    [
      "peter",
      "P"
    ],
    [
      "assessment",
      "estimation"
    ],
    [
      "ensure",
      "garantir"
    ],
    [
      "thus",
      "donc"
    ],
    [
      "wall",
      "mur"
    ],
    [
      "ie",
      "ette"
    ],
    [
      "extra",
      "extra"
    ],
    [
      "especially",
      "surtout"
    ],
    [
      "pussy",
      "minou"
    ],
    [
      "budget",
      "budget"
    ],
    [
      "success",
      "réussite"
    ],
    [
      "maximum",
      "maxima"
    ],
    [
      "operation",
      "gestion"
    ],
    [
      "quite",
      "assez"
    ],
    [
      "boy",
      "garçon"
    ],
    [
      "amazon",
      "Amazone"
    ],
    [
      "beautiful",
      "beau"
    ],
    [
      "warning",
      "avertissement"
    ],
    [
      "wine",
      "lie-de-vin"
    ],
    [
      "horse",
      "cheval"
    ],
    [
      "vote",
      "vote"
    ],
    [
      "forward",
      "osé"
    ],
    [
      "directly",
      "directement"
    ],
    [
      "manufacturer",
      "fabricante"
    ],
    [
      "est",
      "s"
    ],
    [
      "rule",
      "régler"
    ],
    [
      "housing",
      "logement"
    ],
    [
      "bring",
      "amener"
    ],
    [
      "mother",
      "mycoderme"
    ],
    [
      "traffic",
      "trafic"
    ],
    [
      "input",
      "intrant"
    ],
    [
      "agent",
      "agent"
    ],
    [
      "valid",
      "valable"
    ],
    [
      "bin",
      "poubelle"
    ],
    [
      "senior",
      "ancien"
    ],
    [
      "teaching",
      "doctrine"
    ],
    [
      "door",
      "huis"
    ],
    [
      "trial",
      "essai"
    ],
    [
      "charge",
      "charger"
    ],
    [
      "instead",
      "plutôt"
    ],
    [
      "canadian",
      "canadien"
    ],
    [
      "cool",
      "cool"
    ],
    [
      "normal",
      "normal"
    ],
    [
      "enterprise",
      "venture"
    ],
    [
      "entire",
      "entière"
    ],
    [
      "metal",
      "métal"
    ],
    [
      "positive",
      "positif"
    ],
    [
      "fitness",
      "fitness"
    ],
    [
      "chinese",
      "chinois"
    ],
    [
      "opinion",
      "avis"
    ],
    [
      "football",
      "foot"
    ],
    [
      "abstract",
      "abstrait"
    ],
    [
      "output",
      "exporter"
    ],
    [
      "develop",
      "développer"
    ],
    [
      "alternative",
      "autre"
    ],
    [
      "resolution",
      "résolution"
    ],
    [
      "guest",
      "invitée"
    ],
    [
      "pass",
      "passer"
    ],
    [
      "trust",
      "faire confiance"
    ],
    [
      "van",
      "fourgon"
    ],
    [
      "session",
      "session"
    ],
    [
      "century",
      "centurie"
    ],
    [
      "academic",
      "académique"
    ],
    [
      "completed",
      "terminé"
    ],
    [
      "skin",
      "peler"
    ],
    [
      "graphics",
      "graphisme"
    ],
    [
      "indian",
      "indien"
    ],
    [
      "ring",
      "anneau"
    ],
    [
      "grade",
      "année"
    ],
    [
      "mountain",
      "mont"
    ],
    [
      "vehicle",
      "moyen de transport"
    ],
    [
      "consider",
      "songer"
    ],
    [
      "northern",
      "bise"
    ],
    [
      "behind",
      "derrière"
    ],
    [
      "panel",
      "case"
    ],
    [
      "floor",
      "sol"
    ],
    [
      "german",
      "Allemand"
    ],
    [
      "match",
      "metche"
    ],
    [
      "default",
      "non-respect"
    ],
    [
      "require",
      "nécessiter"
    ],
    [
      "iraq",
      "Iraq"
    ],
    [
      "outdoor",
      "découvert"
    ],
    [
      "deep",
      "profond"
    ],
    [
      "morning",
      "matinée"
    ],
    [
      "otherwise",
      "sinon"
    ],
    [
      "rest",
      "reposer"
    ],
    [
      "protein",
      "protide"
    ],
    [
      "plant",
      "matériel"
    ],
    [
      "hit",
      "hit"
    ],
    [
      "transportation",
      "transportation"
    ],
    [
      "pool",
      "pool"
    ],
    [
      "partner",
      "associé"
    ],
    [
      "faculty",
      "faculté"
    ],
    [
      "fish",
      "pêche"
    ],
    [
      "membership",
      "adhésion"
    ],
    [
      "eye",
      "œil"
    ],
    [
      "string",
      "suite"
    ],
    [
      "sense",
      "sens"
    ],
    [
      "pack",
      "meute"
    ],
    [
      "stage",
      "scène"
    ],
    [
      "goods",
      "produit"
    ],
    [
      "unless",
      "sauf si"
    ],
    [
      "japanese",
      "Nippon"
    ],
    [
      "race",
      "course"
    ],
    [
      "background",
      "arrière-plan"
    ],
    [
      "target",
      "objectif"
    ],
    [
      "except",
      "faire une exception"
    ],
    [
      "character",
      "caractère"
    ],
    [
      "maintenance",
      "entretien"
    ],
    [
      "ability",
      "pouvoir"
    ],
    [
      "maybe",
      "il se peut"
    ],
    [
      "moving",
      "émouvant"
    ],
    [
      "pretty",
      "plutôt"
    ],
    [
      "southern",
      "sud"
    ],
    [
      "yourself",
      "vous"
    ],
    [
      "rape",
      "violer"
    ],
    [
      "battery",
      "batterie"
    ],
    [
      "youth",
      "jeune"
    ],
    [
      "medium",
      "médium"
    ],
    [
      "television",
      "télé"
    ],
    [
      "interested",
      "intéressée"
    ],
    [
      "core",
      "cœur"
    ],
    [
      "break",
      "casser"
    ],
    [
      "throughout",
      "durant"
    ],
    [
      "wood",
      "bois"
    ],
    [
      "itself",
      "se"
    ],
    [
      "fee",
      "honoraires"
    ],
    [
      "studio",
      "atelier"
    ],
    [
      "reader",
      "lectrice"
    ],
    [
      "virtual",
      "pratiquement"
    ],
    [
      "device",
      "ruse"
    ],
    [
      "rent",
      "loyer"
    ],
    [
      "remote",
      "loin"
    ],
    [
      "dark",
      "sombre"
    ],
    [
      "regarding",
      "concernant"
    ],
    [
      "enjoy",
      "jouir de"
    ],
    [
      "surface",
      "superficie"
    ],
    [
      "minimum",
      "minima"
    ],
    [
      "host",
      "ost"
    ],
    [
      "block",
      "bloc"
    ],
    [
      "fair",
      "joli"
    ],
    [
      "steel",
      "fusil"
    ],
    [
      "fixed",
      "fixe"
    ],
    [
      "wrong",
      "tort"
    ],
    [
      "beginning",
      "début"
    ],
    [
      "finally",
      "finalement"
    ],
    [
      "paris",
      "Pâris"
    ],
    [
      "capacity",
      "qualité"
    ],
    [
      "jersey",
      "tricot"
    ],
    [
      "fat",
      "gras"
    ],
    [
      "fully",
      "entièrement"
    ],
    [
      "father",
      "papa"
    ],
    [
      "officer",
      "fonctionnaire"
    ],
    [
      "driver",
      "conducteur"
    ],
    [
      "dead",
      "mdr"
    ],
    [
      "unknown",
      "inconnu"
    ],
    [
      "trip",
      "faux pas"
    ],
    [
      "worth",
      "méritant"
    ],
    [
      "poor",
      "pauvre"
    ],
    [
      "teacher",
      "maîtresse"
    ],
    [
      "relationship",
      "relation"
    ],
    [
      "farm",
      "domaine"
    ],
    [
      "fucking",
      "foutu"
    ],
    [
      "peace",
      "paix"
    ],
    [
      "tom",
      "mâle"
    ],
    [
      "creative",
      "créative"
    ],
    [
      "coast",
      "rivage"
    ],
    [
      "benefit",
      "avantage"
    ],
    [
      "progress",
      "progrès"
    ],
    [
      "lord",
      "monsieur"
    ],
    [
      "grant",
      "bourse"
    ],
    [
      "agree",
      "accorder"
    ],
    [
      "fiction",
      "belles-lettres"
    ],
    [
      "hear",
      "entendre"
    ],
    [
      "sometimes",
      "tantôt"
    ],
    [
      "beyond",
      "au-delà"
    ],
    [
      "led",
      "DEL"
    ],
    [
      "museum",
      "muséum"
    ],
    [
      "themselves",
      "se"
    ],
    [
      "fan",
      "mordu"
    ],
    [
      "transport",
      "reporter"
    ],
    [
      "wife",
      "épouse"
    ],
    [
      "former",
      "premier"
    ],
    [
      "implementation",
      "implémentation"
    ],
    [
      "ten",
      "dix"
    ],
    [
      "complex",
      "complexe"
    ],
    [
      "cat",
      "féliné"
    ],
    [
      "die",
      "claquer"
    ],
    [
      "jack",
      "connecteur"
    ],
    [
      "flat",
      "à plat"
    ],
    [
      "flow",
      "flux"
    ],
    [
      "parent",
      "géniteur"
    ],
    [
      "spanish",
      "Espagnol"
    ],
    [
      "setting",
      "réglage"
    ],
    [
      "scale",
      "squame"
    ],
    [
      "stand",
      "être debout"
    ],
    [
      "helpful",
      "utile"
    ],
    [
      "monthly",
      "mensuellement"
    ],
    [
      "frame",
      "cadre"
    ],
    [
      "musical",
      "musicien"
    ],
    [
      "secretary",
      "secrétaire"
    ],
    [
      "networking",
      "réseautage"
    ],
    [
      "path",
      "chemin"
    ],
    [
      "australian",
      "Australien"
    ],
    [
      "employee",
      "salarié"
    ],
    [
      "bottom",
      "bas"
    ],
    [
      "detail",
      "détail"
    ],
    [
      "pet",
      "peloter"
    ],
    [
      "begin",
      "mettre"
    ],
    [
      "royal",
      "royale"
    ],
    [
      "clean",
      "propre"
    ],
    [
      "switch",
      "badine"
    ],
    [
      "russian",
      "Russe"
    ],
    [
      "african",
      "Africain"
    ],
    [
      "guy",
      "gars"
    ],
    [
      "justice",
      "juge"
    ],
    [
      "connect",
      "brancher"
    ],
    [
      "bible",
      "bible"
    ],
    [
      "cup",
      "coupe"
    ],
    [
      "basket",
      "corbeille"
    ],
    [
      "weekly",
      "une fois par semaine"
    ],
    [
      "demand",
      "exigence"
    ],
    [
      "square",
      "carré"
    ],
    [
      "attention",
      "attention"
    ],
    [
      "advance",
      "avance"
    ],
    [
      "skip",
      "sauter"
    ],
    [
      "diet",
      "régime"
    ],
    [
      "auction",
      "enchère"
    ],
    [
      "gear",
      "vitesse"
    ],
    [
      "lee",
      "côté sous le vent"
    ],
    [
      "difference",
      "différend"
    ],
    [
      "nation",
      "Etat"
    ],
    [
      "piece",
      "pièce"
    ],
    [
      "sheet",
      "plaque"
    ],
    [
      "jump",
      "sauter"
    ],
    [
      "resort",
      "sortie"
    ],
    [
      "facility",
      "pôle"
    ],
    [
      "random",
      "moyen"
    ],
    [
      "certificate",
      "diplôme"
    ],
    [
      "minister",
      "prêtre"
    ],
    [
      "motion",
      "motion"
    ],
    [
      "fashion",
      "façon"
    ],
    [
      "monitor",
      "écran"
    ],
    [
      "forest",
      "bois"
    ],
    [
      "whose",
      "dont"
    ],
    [
      "couple",
      "couple"
    ],
    [
      "chance",
      "hasard"
    ],
    [
      "vision",
      "vision"
    ],
    [
      "ball",
      "balle"
    ],
    [
      "listen",
      "guetter"
    ],
    [
      "discuss",
      "débattre"
    ],
    [
      "accept",
      "accueillir"
    ],
    [
      "naked",
      "nu"
    ],
    [
      "goal",
      "but"
    ],
    [
      "successful",
      "ayant du succès"
    ],
    [
      "wind",
      "souffle"
    ],
    [
      "situation",
      "lieu"
    ],
    [
      "appear",
      "paraître"
    ],
    [
      "emergency",
      "crise"
    ],
    [
      "currency",
      "devise"
    ],
    [
      "leather",
      "cuir"
    ],
    [
      "temperature",
      "fièvre"
    ],
    [
      "palm",
      "empaumure"
    ],
    [
      "patient",
      "malade"
    ],
    [
      "actual",
      "réel"
    ],
    [
      "stone",
      "roche"
    ],
    [
      "bob",
      "poids"
    ],
    [
      "commerce",
      "rapports"
    ],
    [
      "perhaps",
      "possiblement"
    ],
    [
      "fit",
      "être adapté"
    ],
    [
      "amateur",
      "amateuse"
    ],
    [
      "ex",
      "ex"
    ],
    [
      "pain",
      "mal"
    ],
    [
      "coffee",
      "caféier"
    ],
    [
      "cum",
      "jute"
    ],
    [
      "buyer",
      "acheteuse"
    ],
    [
      "easily",
      "aisément"
    ],
    [
      "oral",
      "buccal"
    ],
    [
      "poster",
      "poster"
    ],
    [
      "edge",
      "bord"
    ],
    [
      "root",
      "racine"
    ],
    [
      "closed",
      "fermé"
    ],
    [
      "ice",
      "glace"
    ],
    [
      "pink",
      "œillet"
    ],
    [
      "zealand",
      "L'île de Sjælland"
    ],
    [
      "balance",
      "solde"
    ],
    [
      "monitoring",
      "monitoring"
    ],
    [
      "graduate",
      "diplômée"
    ],
    [
      "shot",
      "tir"
    ],
    [
      "initial",
      "initiale"
    ],
    [
      "label",
      "étiquette"
    ],
    [
      "recommend",
      "conseiller"
    ],
    [
      "canon",
      "anses"
    ],
    [
      "league",
      "lieue"
    ],
    [
      "waste",
      "fèces"
    ],
    [
      "minute",
      "moment"
    ],
    [
      "bus",
      "autobus"
    ],
    [
      "provider",
      "fournisseuse"
    ],
    [
      "optional",
      "optionnel"
    ],
    [
      "dictionary",
      "dico"
    ],
    [
      "cold",
      "froid"
    ],
    [
      "chair",
      "chaire"
    ],
    [
      "bag",
      "choper"
    ],
    [
      "fantasy",
      "fantasme"
    ],
    [
      "professor",
      "prof"
    ],
    [
      "generally",
      "généralement"
    ],
    [
      "foot",
      "patte"
    ],
    [
      "mass",
      "messe"
    ],
    [
      "crime",
      "délit"
    ],
    [
      "count",
      "décompte"
    ],
    [
      "breast",
      "poitrine"
    ],
    [
      "quickly",
      "vite"
    ],
    [
      "claim",
      "réclamation"
    ],
    [
      "permission",
      "permis"
    ],
    [
      "surgery",
      "cabinet"
    ],
    [
      "patch",
      "lopin"
    ],
    [
      "heat",
      "chaleur"
    ],
    [
      "wild",
      "déchaîné"
    ],
    [
      "generation",
      "génération"
    ],
    [
      "miss",
      "manquer"
    ],
    [
      "doctor",
      "docteure"
    ],
    [
      "task",
      "tâche"
    ],
    [
      "reduce",
      "réduire"
    ],
    [
      "himself",
      "lui-même"
    ],
    [
      "enable",
      "activer"
    ],
    [
      "bug",
      "mouchard"
    ],
    [
      "guarantee",
      "garant"
    ],
    [
      "leader",
      "dirigeant"
    ],
    [
      "diamond",
      "carreau"
    ],
    [
      "soft",
      "doux"
    ],
    [
      "flight",
      "fuite"
    ],
    [
      "fuel",
      "attiser"
    ],
    [
      "username",
      "identifiant"
    ],
    [
      "walk",
      "marcher"
    ],
    [
      "fuck",
      "foutre"
    ],
    [
      "italian",
      "italien"
    ],
    [
      "classifieds",
      "petites annonces"
    ],
    [
      "wait",
      "servir"
    ],
    [
      "saint",
      "sainte"
    ],
    [
      "rose",
      "rose"
    ],
    [
      "argument",
      "argumentation"
    ],
    [
      "competition",
      "concours"
    ],
    [
      "joint",
      "jointure"
    ],
    [
      "premium",
      "prime"
    ],
    [
      "fresh",
      "frais"
    ],
    [
      "attorney",
      "avocate"
    ],
    [
      "upgrade",
      "upgrade"
    ],
    [
      "factor",
      "agent"
    ],
    [
      "stream",
      "courant"
    ],
    [
      "pick",
      "cueillir"
    ],
    [
      "hearing",
      "audition"
    ],
    [
      "prime",
      "amorcer"
    ],
    [
      "louis",
      "Ludovic"
    ],
    [
      "bondage",
      "esclavage"
    ],
    [
      "creek",
      "ruisseau"
    ],
    [
      "urban",
      "citadin"
    ],
    [
      "essential",
      "essentiel"
    ],
    [
      "myself",
      "m'"
    ],
    [
      "platform",
      "plate-forme"
    ],
    [
      "load",
      "tas"
    ],
    [
      "immediately",
      "aussitôt"
    ],
    [
      "heavy",
      "lourd"
    ],
    [
      "covered",
      "recouvert"
    ],
    [
      "recovery",
      "rétablissement"
    ],
    [
      "integrated",
      "integré"
    ],
    [
      "cock",
      "con"
    ],
    [
      "merchant",
      "marchande"
    ],
    [
      "comprehensive",
      "exhaustif"
    ],
    [
      "drop",
      "vide"
    ],
    [
      "solid",
      "plein"
    ],
    [
      "presentation",
      "exposé"
    ],
    [
      "orange",
      "orange"
    ],
    [
      "compliance",
      "conformité"
    ],
    [
      "prevent",
      "prévenir"
    ],
    [
      "campaign",
      "mener une campagne"
    ],
    [
      "marine",
      "maritime"
    ],
    [
      "finding",
      "résultat"
    ],
    [
      "spirit",
      "esprit"
    ],
    [
      "challenge",
      "chalenge"
    ],
    [
      "acceptance",
      "adhésion"
    ],
    [
      "seem",
      "sembler"
    ],
    [
      "touch",
      "contact"
    ],
    [
      "intended",
      "voulu"
    ],
    [
      "hire",
      "engager"
    ],
    [
      "suggest",
      "proposer"
    ],
    [
      "branch",
      "rameau"
    ],
    [
      "serve",
      "servir"
    ],
    [
      "magic",
      "magie"
    ],
    [
      "mount",
      "monter"
    ],
    [
      "smart",
      "malin"
    ],
    [
      "avoid",
      "fuir"
    ],
    [
      "manage",
      "manier"
    ],
    [
      "corner",
      "coin"
    ],
    [
      "rank",
      "rang"
    ],
    [
      "computing",
      "informatique"
    ],
    [
      "oregon",
      "Orégon"
    ],
    [
      "element",
      "élément"
    ],
    [
      "birth",
      "naissance"
    ],
    [
      "virus",
      "virus informatique"
    ],
    [
      "abuse",
      "abus"
    ],
    [
      "separate",
      "séparée"
    ],
    [
      "quarter",
      "quartier"
    ],
    [
      "procedure",
      "procédure"
    ],
    [
      "leadership",
      "autorité"
    ],
    [
      "define",
      "définir"
    ],
    [
      "religious",
      "religieux"
    ],
    [
      "breakfast",
      "déjeuner"
    ],
    [
      "column",
      "colonne"
    ],
    [
      "faith",
      "foi"
    ],
    [
      "chain",
      "chaîner"
    ],
    [
      "developer",
      "créateur"
    ],
    [
      "identify",
      "identifier"
    ],
    [
      "avenue",
      "allée"
    ],
    [
      "missing",
      "manquant"
    ],
    [
      "approximately",
      "environ"
    ],
    [
      "domestic",
      "conjugal"
    ],
    [
      "reach",
      "atteindre"
    ],
    [
      "comparison",
      "comparaison"
    ],
    [
      "moment",
      "instant"
    ],
    [
      "sequence",
      "suite"
    ],
    [
      "inch",
      "poil"
    ],
    [
      "attack",
      "assaut"
    ],
    [
      "sorry",
      "désolé"
    ],
    [
      "opening",
      "trou"
    ],
    [
      "damage",
      "dommage"
    ],
    [
      "reserve",
      "réserve"
    ],
    [
      "gamma",
      "gamma"
    ],
    [
      "plastic",
      "matière plastique"
    ],
    [
      "snow",
      "neige"
    ],
    [
      "counter",
      "guichet"
    ],
    [
      "failure",
      "échec"
    ],
    [
      "weekend",
      "fin de semaine"
    ],
    [
      "camp",
      "camper"
    ],
    [
      "bridge",
      "pont"
    ],
    [
      "native",
      "natif"
    ],
    [
      "fill",
      "remplir"
    ],
    [
      "printing",
      "tirage"
    ],
    [
      "baseball",
      "base-ball"
    ],
    [
      "approval",
      "agrément"
    ],
    [
      "draft",
      "prise"
    ],
    [
      "chart",
      "graphe"
    ],
    [
      "equal",
      "égale"
    ],
    [
      "matching",
      "semblable"
    ],
    [
      "offering",
      "offre"
    ],
    [
      "profit",
      "profit"
    ],
    [
      "assistant",
      "aide"
    ],
    [
      "variable",
      "paramètre"
    ],
    [
      "advertisement",
      "annonce"
    ],
    [
      "expect",
      "prédire"
    ],
    [
      "parking",
      "stationnement"
    ],
    [
      "yesterday",
      "veille"
    ],
    [
      "determined",
      "résolu"
    ],
    [
      "golden",
      "doré"
    ],
    [
      "lighting",
      "illumination"
    ],
    [
      "senate",
      "Sénat"
    ],
    [
      "funny",
      "marrant"
    ],
    [
      "brother",
      "pair"
    ],
    [
      "portable",
      "portatif"
    ],
    [
      "pattern",
      "motif"
    ],
    [
      "boat",
      "barque"
    ],
    [
      "sponsor",
      "financer"
    ],
    [
      "dedicated",
      "dédié"
    ],
    [
      "direction",
      "régie"
    ],
    [
      "basketball",
      "ballon-panier"
    ],
    [
      "evening",
      "soirée"
    ],
    [
      "assembly",
      "assemblée"
    ],
    [
      "mouse",
      "œil au beurre noir"
    ],
    [
      "criminal",
      "criminelle"
    ],
    [
      "brain",
      "cervelle"
    ],
    [
      "dream",
      "rêve"
    ],
    [
      "false",
      "faux"
    ],
    [
      "cast",
      "jeter"
    ],
    [
      "flower",
      "s'épanouir"
    ],
    [
      "felt",
      "feutre"
    ],
    [
      "soul",
      "soul"
    ],
    [
      "promote",
      "promouvoir"
    ],
    [
      "hawaii",
      "les îles Hawaï"
    ],
    [
      "carry",
      "retenir"
    ],
    [
      "flag",
      "drapeau"
    ],
    [
      "em",
      "cadratin"
    ],
    [
      "advantage",
      "favoriser"
    ],
    [
      "hello",
      "allô"
    ],
    [
      "maintain",
      "maintenir"
    ],
    [
      "graphic",
      "cru"
    ],
    [
      "binding",
      "liaison"
    ],
    [
      "brief",
      "court"
    ],
    [
      "iron",
      "de fer"
    ],
    [
      "straight",
      "pur"
    ],
    [
      "script",
      "script"
    ],
    [
      "miscellaneous",
      "varié"
    ],
    [
      "void",
      "vide"
    ],
    [
      "dakota",
      "dakota"
    ],
    [
      "tag",
      "chat"
    ],
    [
      "interview",
      "entrevue"
    ],
    [
      "mix",
      "mixer"
    ],
    [
      "framework",
      "carcasse"
    ],
    [
      "queen",
      "dame"
    ],
    [
      "fix",
      "fixer"
    ],
    [
      "handle",
      "traiter"
    ],
    [
      "sweet",
      "doux"
    ],
    [
      "desk",
      "pupitre"
    ],
    [
      "vice",
      "affaire de mœurs"
    ],
    [
      "associate",
      "fréquenter"
    ],
    [
      "behavior",
      "conduite"
    ],
    [
      "enlarge",
      "élargir"
    ],
    [
      "ray",
      "rayon"
    ],
    [
      "revenue",
      "revenu"
    ],
    [
      "duty",
      "service"
    ],
    [
      "bear",
      "supporter"
    ],
    [
      "festival",
      "fête"
    ],
    [
      "lack",
      "défaut"
    ],
    [
      "depth",
      "épaisseur"
    ],
    [
      "whatever",
      "peu importe"
    ],
    [
      "laptop",
      "ordinateur portable"
    ],
    [
      "vintage",
      "cru"
    ],
    [
      "train",
      "exercer"
    ],
    [
      "dry",
      "sec"
    ],
    [
      "concept",
      "notion"
    ],
    [
      "eligible",
      "admissible"
    ],
    [
      "reality",
      "vérité"
    ],
    [
      "handling",
      "maniement"
    ],
    [
      "origin",
      "source"
    ],
    [
      "billion",
      "millions"
    ],
    [
      "destination",
      "arrivée"
    ],
    [
      "faster",
      "jeûneuse"
    ],
    [
      "intelligence",
      "renseignements"
    ],
    [
      "con",
      "duper"
    ],
    [
      "ups",
      "ASSC"
    ],
    [
      "route",
      "itinéraire"
    ],
    [
      "broken",
      "brisé"
    ],
    [
      "frank",
      "Franque"
    ],
    [
      "zoom",
      "vrombissement"
    ],
    [
      "blow",
      "pipe"
    ],
    [
      "battle",
      "lutte"
    ],
    [
      "anime",
      "anime"
    ],
    [
      "speak",
      "parler"
    ],
    [
      "query",
      "requête"
    ],
    [
      "clip",
      "taper"
    ],
    [
      "partnership",
      "société"
    ],
    [
      "editorial",
      "rédactionnel"
    ],
    [
      "equity",
      "action"
    ],
    [
      "speech",
      "parole"
    ],
    [
      "replacement",
      "substitut"
    ],
    [
      "tape",
      "ruban"
    ],
    [
      "judge",
      "juger"
    ],
    [
      "spam",
      "pourrieller"
    ],
    [
      "economics",
      "science économique"
    ],
    [
      "acid",
      "aigre"
    ],
    [
      "cent",
      "cent"
    ],
    [
      "fight",
      "combat"
    ],
    [
      "apartment",
      "appartements"
    ],
    [
      "height",
      "haut"
    ],
    [
      "zero",
      "zéro"
    ],
    [
      "speaker",
      "locutrice"
    ],
    [
      "netherlands",
      "Hollande"
    ],
    [
      "obtain",
      "avoir"
    ],
    [
      "bc",
      "av. JC"
    ],
    [
      "designer",
      "styliste"
    ],
    [
      "remain",
      "demeurer"
    ],
    [
      "marriage",
      "mariage"
    ],
    [
      "roll",
      "rouler"
    ],
    [
      "bath",
      "bain"
    ],
    [
      "negative",
      "négatif"
    ],
    [
      "perform",
      "faire"
    ],
    [
      "healthy",
      "sain"
    ],
    [
      "translation",
      "traduction"
    ],
    [
      "font",
      "police"
    ],
    [
      "joseph",
      "José"
    ],
    [
      "ministry",
      "ministère"
    ],
    [
      "lawyer",
      "avocate"
    ],
    [
      "married",
      "mariée"
    ],
    [
      "proposal",
      "proposition"
    ],
    [
      "portal",
      "portail"
    ],
    [
      "birthday",
      "fête"
    ],
    [
      "fail",
      "rater"
    ],
    [
      "toward",
      "pour"
    ],
    [
      "slightly",
      "finement"
    ],
    [
      "assist",
      "aider"
    ],
    [
      "conduct",
      "mener"
    ],
    [
      "legislation",
      "loi"
    ],
    [
      "comics",
      "BD"
    ],
    [
      "wear",
      "user"
    ],
    [
      "ultimate",
      "dernier"
    ],
    [
      "wales",
      "Pays de Galles"
    ],
    [
      "representative",
      "représentant"
    ],
    [
      "finish",
      "fini"
    ],
    [
      "reduced",
      "soldé"
    ],
    [
      "rare",
      "saignant"
    ],
    [
      "spent",
      "épuisé"
    ],
    [
      "extreme",
      "extrême"
    ],
    [
      "row",
      "rang"
    ],
    [
      "forecast",
      "prévoir"
    ],
    [
      "administrator",
      "gestionnaire"
    ],
    [
      "cycle",
      "cycle"
    ],
    [
      "accuracy",
      "exactitude"
    ],
    [
      "dual",
      "duel"
    ],
    [
      "rise",
      "monter"
    ],
    [
      "sleep",
      "chassie"
    ],
    [
      "bird",
      "meuf"
    ],
    [
      "pharmacy",
      "officine"
    ],
    [
      "static",
      "parasites"
    ],
    [
      "scene",
      "scène"
    ],
    [
      "hunter",
      "chercheur"
    ],
    [
      "lady",
      "madame"
    ],
    [
      "crystal",
      "cristal"
    ],
    [
      "famous",
      "célèbre"
    ],
    [
      "writer",
      "auteur"
    ],
    [
      "chairman",
      "secrétaire général"
    ],
    [
      "drink",
      "boisson"
    ],
    [
      "gender",
      "genre"
    ],
    [
      "eat",
      "bouffer"
    ],
    [
      "permanent",
      "permanent"
    ],
    [
      "portfolio",
      "portefeuille"
    ],
    [
      "seat",
      "siège"
    ],
    [
      "vendor",
      "marchand"
    ],
    [
      "originally",
      "au départ"
    ],
    [
      "regulation",
      "règlement"
    ],
    [
      "aim",
      "but"
    ],
    [
      "junior",
      "junior"
    ],
    [
      "toll",
      "perte"
    ],
    [
      "cape",
      "cape"
    ],
    [
      "meaning",
      "sens"
    ],
    [
      "tip",
      "bout"
    ],
    [
      "mine",
      "miner"
    ],
    [
      "ticket",
      "ticket"
    ],
    [
      "guess",
      "deviner"
    ],
    [
      "whom",
      "qui"
    ],
    [
      "soccer",
      "soccer"
    ],
    [
      "import",
      "compter"
    ],
    [
      "instant",
      "moment"
    ],
    [
      "majority",
      "plupart"
    ],
    [
      "christ",
      "Messie"
    ],
    [
      "moon",
      "lune"
    ],
    [
      "scheme",
      "plan"
    ],
    [
      "utility",
      "utilitaire"
    ],
    [
      "preview",
      "aperçu"
    ],
    [
      "fly",
      "cool"
    ],
    [
      "manner",
      "mode"
    ],
    [
      "combination",
      "side-car"
    ],
    [
      "amendment",
      "avenant"
    ],
    [
      "despite",
      "en dépit de"
    ],
    [
      "strength",
      "force"
    ],
    [
      "turkey",
      "dinde"
    ],
    [
      "proper",
      "propre"
    ],
    [
      "fear",
      "crainte"
    ],
    [
      "phoenix",
      "phénix"
    ],
    [
      "principal",
      "principal"
    ],
    [
      "comfort",
      "commodité"
    ],
    [
      "appeal",
      "plaire"
    ],
    [
      "bonus",
      "prime"
    ],
    [
      "certification",
      "homologation"
    ],
    [
      "previously",
      "autrefois"
    ],
    [
      "hey",
      "hé"
    ],
    [
      "bookmark",
      "signet"
    ],
    [
      "beat",
      "battre"
    ],
    [
      "household",
      "foyer"
    ],
    [
      "adobe",
      "argile"
    ],
    [
      "bbc",
      "SBR"
    ],
    [
      "tea",
      "thé"
    ],
    [
      "achieve",
      "réaliser"
    ],
    [
      "dress",
      "s'habiller"
    ],
    [
      "dealer",
      "donneur"
    ],
    [
      "contemporary",
      "contemporaine"
    ],
    [
      "rom",
      "Rrom"
    ],
    [
      "happen",
      "advenir"
    ],
    [
      "hide",
      "cuir"
    ],
    [
      "signature",
      "cahier"
    ],
    [
      "gambling",
      "pari"
    ],
    [
      "refer",
      "renvoyer"
    ],
    [
      "miller",
      "Moulin"
    ],
    [
      "outdoors",
      "à l'extérieur"
    ],
    [
      "clothes",
      "fringues"
    ],
    [
      "certainly",
      "certainement"
    ],
    [
      "indeed",
      "certes"
    ],
    [
      "newspaper",
      "papier journal"
    ],
    [
      "toy",
      "amuser"
    ],
    [
      "layer",
      "calque"
    ],
    [
      "slow",
      "lent"
    ],
    [
      "removal",
      "déménagement"
    ],
    [
      "liability",
      "dette"
    ],
    [
      "hip",
      "hanche"
    ],
    [
      "mostly",
      "surtout"
    ],
    [
      "spot",
      "peu"
    ],
    [
      "taylor",
      "Thayer"
    ],
    [
      "spend",
      "passer"
    ],
    [
      "factory",
      "fabrique"
    ],
    [
      "grow",
      "croître"
    ],
    [
      "promotion",
      "avancement"
    ],
    [
      "amazing",
      "super"
    ],
    [
      "clock",
      "berloqe"
    ],
    [
      "feeling",
      "sentiment"
    ],
    [
      "reasonable",
      "juste"
    ],
    [
      "victoria",
      "Victoria"
    ],
    [
      "relief",
      "relève"
    ],
    [
      "revision",
      "modification"
    ],
    [
      "influence",
      "influer"
    ],
    [
      "ratio",
      "raison"
    ],
    [
      "rain",
      "royer"
    ],
    [
      "webmaster",
      "webmaster"
    ],
    [
      "permit",
      "permission"
    ],
    [
      "proof",
      "preuve"
    ],
    [
      "bass",
      "bar"
    ],
    [
      "prescription",
      "prescription"
    ],
    [
      "bedroom",
      "piaule"
    ],
    [
      "hole",
      "trou"
    ],
    [
      "ride",
      "monter"
    ],
    [
      "bureau",
      "bureau"
    ],
    [
      "represent",
      "jouer"
    ],
    [
      "conservation",
      "défense"
    ],
    [
      "pair",
      "paire"
    ],
    [
      "ideal",
      "idéal"
    ],
    [
      "don",
      "mettre"
    ],
    [
      "finished",
      "terminé"
    ],
    [
      "dinner",
      "souper"
    ],
    [
      "stress",
      "souligner"
    ],
    [
      "cream",
      "crème"
    ],
    [
      "runs",
      "courante"
    ],
    [
      "discover",
      "dévoiler"
    ],
    [
      "fourth",
      "quarte"
    ],
    [
      "advisor",
      "conseillère"
    ],
    [
      "marketplace",
      "marché"
    ],
    [
      "evil",
      "infâme"
    ],
    [
      "aware",
      "attentif"
    ],
    [
      "shape",
      "donner une forme"
    ],
    [
      "irish",
      "gaélique"
    ],
    [
      "remains",
      "restes"
    ],
    [
      "concerned",
      "impliqué"
    ],
    [
      "operator",
      "opérateur"
    ],
    [
      "generic",
      "générique"
    ],
    [
      "usage",
      "usage"
    ],
    [
      "cap",
      "cime"
    ],
    [
      "mixed",
      "mêlé"
    ],
    [
      "census",
      "recensement de la population"
    ],
    [
      "peak",
      "pic"
    ],
    [
      "wheel",
      "barre"
    ],
    [
      "dick",
      "paf"
    ],
    [
      "salt",
      "sel"
    ],
    [
      "bell",
      "sonnerie"
    ],
    [
      "preparation",
      "préparation"
    ],
    [
      "attempt",
      "essayer"
    ],
    [
      "width",
      "largeur"
    ],
    [
      "noise",
      "bruit"
    ],
    [
      "forget",
      "oublier"
    ],
    [
      "array",
      "tableau"
    ],
    [
      "accurate",
      "juste"
    ],
    [
      "stephen",
      "Étienne"
    ],
    [
      "elizabeth",
      "Lisa"
    ],
    [
      "pin",
      "NIP"
    ],
    [
      "alcohol",
      "alcool"
    ],
    [
      "greek",
      "grecque"
    ],
    [
      "annotation",
      "commentaire"
    ],
    [
      "sister",
      "sœur"
    ],
    [
      "raw",
      "brut"
    ],
    [
      "walking",
      "randonnée"
    ],
    [
      "explain",
      "expliquer"
    ],
    [
      "establish",
      "établir"
    ],
    [
      "extent",
      "mesure"
    ],
    [
      "sharp",
      "aigu"
    ],
    [
      "lane",
      "voie"
    ],
    [
      "paragraph",
      "alinéa"
    ],
    [
      "kill",
      "arrêter"
    ],
    [
      "mathematics",
      "mathématique"
    ],
    [
      "compensation",
      "émolument"
    ],
    [
      "export",
      "export"
    ],
    [
      "conflict",
      "conflit"
    ],
    [
      "employer",
      "employeuse"
    ],
    [
      "occur",
      "produire"
    ],
    [
      "concern",
      "soin"
    ],
    [
      "backup",
      "sauvegarde"
    ],
    [
      "immediate",
      "proche"
    ],
    [
      "trouble",
      "mal"
    ],
    [
      "spread",
      "répandre"
    ],
    [
      "coach",
      "autocar"
    ],
    [
      "kevin",
      "Kévin"
    ],
    [
      "expand",
      "élaborer"
    ],
    [
      "audience",
      "lectorat"
    ],
    [
      "jordan",
      "Jourdain"
    ],
    [
      "participate",
      "participer"
    ],
    [
      "plug",
      "fermer"
    ],
    [
      "cook",
      "cuire"
    ],
    [
      "affect",
      "affecter"
    ],
    [
      "virgin",
      "puceau"
    ],
    [
      "hat",
      "casquette"
    ],
    [
      "bike",
      "pute"
    ],
    [
      "plate",
      "plat"
    ],
    [
      "indicate",
      "indiquer"
    ],
    [
      "favourite",
      "préféré"
    ],
    [
      "transmission",
      "boite de vitesses"
    ],
    [
      "lose",
      "perdre"
    ],
    [
      "organic",
      "bio"
    ],
    [
      "seek",
      "chercher"
    ],
    [
      "extremely",
      "vachement"
    ],
    [
      "concerning",
      "concernant"
    ],
    [
      "neighborhood",
      "environs"
    ],
    [
      "agenda",
      "agenda"
    ],
    [
      "anyway",
      "d'ailleurs"
    ],
    [
      "advisory",
      "bulletin d'alerte"
    ],
    [
      "template",
      "modèle"
    ],
    [
      "circle",
      "encercler"
    ],
    [
      "soil",
      "terre"
    ],
    [
      "anywhere",
      "nulle part"
    ],
    [
      "wet",
      "humide"
    ],
    [
      "investor",
      "investisseuse"
    ],
    [
      "identification",
      "pièce d'identité"
    ],
    [
      "ram",
      "éperonner"
    ],
    [
      "wildlife",
      "faune"
    ],
    [
      "cooking",
      "cuisson"
    ],
    [
      "fox",
      "renard"
    ],
    [
      "plain",
      "uni"
    ],
    [
      "exit",
      "issue"
    ],
    [
      "arm",
      "arme"
    ],
    [
      "wave",
      "onde"
    ],
    [
      "holy",
      "saint"
    ],
    [
      "guidance",
      "conseils"
    ],
    [
      "mesh",
      "maille"
    ],
    [
      "trail",
      "piste"
    ],
    [
      "highway",
      "chaussée"
    ],
    [
      "buddy",
      "mec"
    ],
    [
      "dean",
      "doyen"
    ],
    [
      "setup",
      "coup monté"
    ],
    [
      "booking",
      "réserve"
    ],
    [
      "celebrity",
      "people"
    ],
    [
      "filled",
      "plein"
    ],
    [
      "bond",
      "lien"
    ],
    [
      "appendix",
      "annexe"
    ],
    [
      "chocolate",
      "chocolat"
    ],
    [
      "pub",
      "bar"
    ],
    [
      "portion",
      "part"
    ],
    [
      "supplier",
      "fournisseuse"
    ],
    [
      "cotton",
      "coton"
    ],
    [
      "requirement",
      "besoin"
    ],
    [
      "dental",
      "dentaire"
    ],
    [
      "border",
      "bordure"
    ],
    [
      "ancient",
      "ancien"
    ],
    [
      "debate",
      "débat"
    ],
    [
      "pregnancy",
      "gestation"
    ],
    [
      "leisure",
      "loisir"
    ],
    [
      "learned",
      "instruit"
    ],
    [
      "notebook",
      "laptop"
    ],
    [
      "explorer",
      "sonde"
    ],
    [
      "attached",
      "pris"
    ],
    [
      "husband",
      "époux"
    ],
    [
      "disabled",
      "infirme"
    ],
    [
      "crazy",
      "fou"
    ],
    [
      "upcoming",
      "à venir"
    ],
    [
      "efficiency",
      "rendement"
    ],
    [
      "efficient",
      "efficace"
    ],
    [
      "constant",
      "constante"
    ],
    [
      "mouth",
      "embouchure"
    ],
    [
      "meter",
      "compteur"
    ],
    [
      "gun",
      "canon"
    ],
    [
      "reflect",
      "refléter"
    ],
    [
      "deliver",
      "livrer"
    ],
    [
      "wonder",
      "étonné"
    ],
    [
      "fruit",
      "pédé"
    ],
    [
      "lens",
      "lentille"
    ],
    [
      "draw",
      "tirer"
    ],
    [
      "assume",
      "assumer"
    ],
    [
      "confidence",
      "confiance"
    ],
    [
      "warm",
      "chaude"
    ],
    [
      "neither",
      "aucun"
    ],
    [
      "offline",
      "offline"
    ],
    [
      "engineer",
      "ingénieur"
    ],
    [
      "lifestyle",
      "hygiène de vie"
    ],
    [
      "consistent",
      "cohérent"
    ],
    [
      "clearance",
      "espace"
    ],
    [
      "suck",
      "aspirer"
    ],
    [
      "becoming",
      "respectable"
    ],
    [
      "blowjob",
      "pompier"
    ],
    [
      "objective",
      "objectif"
    ],
    [
      "sugar",
      "zut"
    ],
    [
      "crew",
      "équipe"
    ],
    [
      "stick",
      "bâton"
    ],
    [
      "relation",
      "parent"
    ],
    [
      "slide",
      "coulisse"
    ],
    [
      "volunteer",
      "bénévole"
    ],
    [
      "rear",
      "derrière"
    ],
    [
      "enhance",
      "améliorer"
    ],
    [
      "exact",
      "précis"
    ],
    [
      "bound",
      "borne"
    ],
    [
      "processor",
      "processeur"
    ],
    [
      "formal",
      "formel"
    ],
    [
      "contribute",
      "donner"
    ],
    [
      "lock",
      "sas"
    ],
    [
      "hockey",
      "hockey sur gazon"
    ],
    [
      "storm",
      "tempête"
    ],
    [
      "mile",
      "nœud"
    ],
    [
      "tank",
      "réservoir"
    ],
    [
      "submission",
      "soumission"
    ],
    [
      "estimate",
      "estimation"
    ],
    [
      "navy",
      "force navale"
    ],
    [
      "kid",
      "gamin"
    ],
    [
      "regulatory",
      "régulateur"
    ],
    [
      "cancel",
      "annuler"
    ],
    [
      "paint",
      "peindre"
    ],
    [
      "delay",
      "délai"
    ],
    [
      "pilot",
      "pilote"
    ],
    [
      "outlet",
      "exutoire"
    ],
    [
      "continuous",
      "continu"
    ],
    [
      "czech",
      "Tchèque"
    ],
    [
      "cambridge",
      "l'université de Cambridge"
    ],
    [
      "novel",
      "nouvelle"
    ],
    [
      "pan",
      "cuvette"
    ],
    [
      "disability",
      "pension d'invalidité"
    ],
    [
      "winner",
      "gagnante"
    ],
    [
      "contractor",
      "contractant"
    ],
    [
      "potter",
      "potière"
    ],
    [
      "dish",
      "plat"
    ],
    [
      "painting",
      "peinture"
    ],
    [
      "affordable",
      "pas trop cher"
    ],
    [
      "universe",
      "Univers"
    ],
    [
      "candidate",
      "candidat"
    ],
    [
      "patent",
      "patente"
    ],
    [
      "slot",
      "barre"
    ],
    [
      "outstanding",
      "débiteur"
    ],
    [
      "ha",
      "ah"
    ],
    [
      "eating",
      "manger"
    ],
    [
      "lodge",
      "loge"
    ],
    [
      "messenger",
      "coursier"
    ],
    [
      "mirror",
      "copie"
    ],
    [
      "consideration",
      "raison"
    ],
    [
      "kernel",
      "noyau"
    ],
    [
      "gray",
      "Gris"
    ],
    [
      "catalogue",
      "inventaire"
    ],
    [
      "broad",
      "fort"
    ],
    [
      "taiwan",
      "Formose"
    ],
    [
      "demo",
      "démonstration"
    ],
    [
      "swiss",
      "suisse"
    ],
    [
      "sarah",
      "Sarah"
    ],
    [
      "labour",
      "besogne"
    ],
    [
      "hate",
      "détester"
    ],
    [
      "terminal",
      "gare"
    ],
    [
      "caribbean",
      "Caraïbe"
    ],
    [
      "loop",
      "circuit fermé"
    ],
    [
      "reservation",
      "réserve"
    ],
    [
      "gourmet",
      "gourmand"
    ],
    [
      "guard",
      "garde"
    ],
    [
      "properly",
      "correctement"
    ],
    [
      "saving",
      "épargne"
    ],
    [
      "remaining",
      "qui reste"
    ],
    [
      "resume",
      "continuer"
    ],
    [
      "newly",
      "récemment"
    ],
    [
      "raise",
      "élever"
    ],
    [
      "prepare",
      "préparer"
    ],
    [
      "avatar",
      "emblème"
    ],
    [
      "arab",
      "Arabe"
    ],
    [
      "premier",
      "première"
    ],
    [
      "tomorrow",
      "lendemain"
    ],
    [
      "consent",
      "agréer"
    ],
    [
      "downtown",
      "quartier d'affaires"
    ],
    [
      "keyboard",
      "clavier"
    ],
    [
      "contest",
      "compétition"
    ],
    [
      "boot",
      "vomir"
    ],
    [
      "suitable",
      "idoine"
    ],
    [
      "absolutely",
      "mets-en"
    ],
    [
      "lunch",
      "dîner"
    ],
    [
      "dildo",
      "gode"
    ],
    [
      "audit",
      "audit"
    ],
    [
      "chamber",
      "chambre"
    ],
    [
      "implement",
      "établir"
    ],
    [
      "typical",
      "représentatif"
    ],
    [
      "tower",
      "tour"
    ],
    [
      "yours",
      "le tien"
    ],
    [
      "sum",
      "somme"
    ],
    [
      "calculator",
      "calculette"
    ],
    [
      "chicken",
      "poule"
    ],
    [
      "temporary",
      "provisoire"
    ],
    [
      "attend",
      "aller"
    ],
    [
      "shower",
      "bande"
    ],
    [
      "tonight",
      "à soir"
    ],
    [
      "dear",
      "cher"
    ],
    [
      "shell",
      "coque"
    ],
    [
      "province",
      "état"
    ],
    [
      "oak",
      "chênes"
    ],
    [
      "awareness",
      "conscience"
    ],
    [
      "governor",
      "gouverneure"
    ],
    [
      "beer",
      "demi"
    ],
    [
      "contribution",
      "contribution"
    ],
    [
      "swimming",
      "nage"
    ],
    [
      "spyware",
      "logiciel espion"
    ],
    [
      "formula",
      "lait maternisé"
    ],
    [
      "catch",
      "prise"
    ],
    [
      "reliable",
      "sûr"
    ],
    [
      "sir",
      "monsieur"
    ],
    [
      "earn",
      "gagner"
    ],
    [
      "classroom",
      "classe"
    ],
    [
      "wallpaper",
      "tapisserie"
    ],
    [
      "merchandise",
      "bien"
    ],
    [
      "visitor",
      "invité"
    ],
    [
      "twin",
      "jumelle"
    ],
    [
      "insert",
      "encart"
    ],
    [
      "gateway",
      "passerelle"
    ],
    [
      "drawing",
      "pige"
    ],
    [
      "transition",
      "faire une transition"
    ],
    [
      "spy",
      "épier"
    ],
    [
      "romance",
      "idylle"
    ],
    [
      "instrument",
      "acte"
    ],
    [
      "split",
      "grand écart"
    ],
    [
      "heaven",
      "paradis"
    ],
    [
      "pregnant",
      "pleine"
    ],
    [
      "physician",
      "doctoresse"
    ],
    [
      "bargain",
      "affaire"
    ],
    [
      "cellular",
      "celluleux"
    ],
    [
      "lo",
      "voilà"
    ],
    [
      "hunting",
      "chasse"
    ],
    [
      "suit",
      "suite"
    ],
    [
      "shift",
      "poste"
    ],
    [
      "chip",
      "puce"
    ],
    [
      "sit",
      "siéger"
    ],
    [
      "cutting",
      "bouture"
    ],
    [
      "wow",
      "oh"
    ],
    [
      "flexible",
      "flexible"
    ],
    [
      "loved",
      "aimé"
    ],
    [
      "mapping",
      "mappage"
    ],
    [
      "char",
      "bonne"
    ],
    [
      "cartoon",
      "caricature"
    ],
    [
      "intellectual",
      "intello"
    ],
    [
      "carbon",
      "carbone"
    ],
    [
      "comfortable",
      "agréable"
    ],
    [
      "registry",
      "registre"
    ],
    [
      "outlook",
      "point de vue"
    ],
    [
      "massive",
      "géant"
    ],
    [
      "bright",
      "brillant"
    ],
    [
      "treat",
      "soigner"
    ],
    [
      "header",
      "tête"
    ],
    [
      "grid",
      "réseau"
    ],
    [
      "patrick",
      "Patrick"
    ],
    [
      "revolution",
      "révolution"
    ],
    [
      "dependent",
      "dépendante"
    ],
    [
      "mechanical",
      "machinal"
    ],
    [
      "banner",
      "banière"
    ],
    [
      "applicant",
      "demandeur"
    ],
    [
      "fig",
      "figue"
    ],
    [
      "barbara",
      "Barbe"
    ],
    [
      "cooperation",
      "coopérative"
    ],
    [
      "blogger",
      "blogueuse"
    ],
    [
      "teach",
      "guider"
    ],
    [
      "rapid",
      "rapide"
    ],
    [
      "pull",
      "retirer"
    ],
    [
      "reverse",
      "revers"
    ],
    [
      "deposit",
      "dépôt"
    ],
    [
      "dutch",
      "hollandais"
    ],
    [
      "tab",
      "onglet"
    ],
    [
      "concrete",
      "béton"
    ],
    [
      "folder",
      "plieur"
    ],
    [
      "completion",
      "exécution"
    ],
    [
      "upload",
      "envoi"
    ],
    [
      "pulse",
      "légumineuse"
    ],
    [
      "broadcast",
      "radiodiffuser"
    ],
    [
      "anniversary",
      "anniversaire de mariage"
    ],
    [
      "strip",
      "dénuder"
    ],
    [
      "pearl",
      "joyau"
    ],
    [
      "nick",
      "trou"
    ],
    [
      "resident",
      "interne"
    ],
    [
      "plot",
      "lopin"
    ],
    [
      "possibly",
      "possiblement"
    ],
    [
      "airline",
      "ligne aérienne"
    ],
    [
      "typically",
      "ordinairement"
    ],
    [
      "regard",
      "regarder"
    ],
    [
      "smooth",
      "lisse"
    ],
    [
      "strike",
      "frapper"
    ],
    [
      "consumption",
      "consomption"
    ],
    [
      "narrow",
      "réduire"
    ],
    [
      "consultant",
      "consultante"
    ],
    [
      "controller",
      "manette"
    ],
    [
      "penis",
      "bite"
    ],
    [
      "vietnam",
      "Viêtnam"
    ],
    [
      "trailer",
      "caravane"
    ],
    [
      "castle",
      "château-fort"
    ],
    [
      "unsubscribe",
      "désinscrire"
    ],
    [
      "antique",
      "ancien"
    ],
    [
      "acting",
      "par intérim"
    ],
    [
      "residence",
      "siège social"
    ],
    [
      "density",
      "masse volumique"
    ],
    [
      "ryan",
      "Ryan"
    ],
    [
      "strange",
      "anormal"
    ],
    [
      "sustainable",
      "durable"
    ],
    [
      "parallel",
      "parallèle"
    ],
    [
      "operate",
      "opérer"
    ],
    [
      "bold",
      "gras"
    ],
    [
      "stable",
      "étable"
    ],
    [
      "lesson",
      "leçon"
    ],
    [
      "asset",
      "actif"
    ],
    [
      "scan",
      "scanner"
    ],
    [
      "blank",
      "blanc"
    ],
    [
      "enhanced",
      "amplifié"
    ],
    [
      "entitled",
      "autorisé"
    ],
    [
      "severe",
      "grave"
    ],
    [
      "generate",
      "engendrer"
    ],
    [
      "bulk",
      "gros"
    ],
    [
      "fabric",
      "tissu"
    ],
    [
      "primarily",
      "surtout"
    ],
    [
      "tight",
      "tendu"
    ],
    [
      "flying",
      "volante"
    ],
    [
      "berlin",
      "berlinois"
    ],
    [
      "cute",
      "chou"
    ],
    [
      "expensive",
      "coûteux"
    ],
    [
      "capture",
      "capturer"
    ],
    [
      "buffalo",
      "être"
    ],
    [
      "plane",
      "plat"
    ],
    [
      "seed",
      "semence"
    ],
    [
      "expertise",
      "compétence"
    ],
    [
      "mechanism",
      "mécanique"
    ],
    [
      "camping",
      "campisme"
    ],
    [
      "ee",
      "ée"
    ],
    [
      "jewellery",
      "bijoux"
    ],
    [
      "welfare",
      "aide sociale"
    ],
    [
      "peer",
      "pair"
    ],
    [
      "eventually",
      "à terme"
    ],
    [
      "bottle",
      "cran"
    ],
    [
      "considering",
      "vu"
    ],
    [
      "innovative",
      "novateur"
    ],
    [
      "rubber",
      "gomme"
    ],
    [
      "conclusion",
      "fin"
    ],
    [
      "meat",
      "chair"
    ],
    [
      "grace",
      "grâce"
    ],
    [
      "ing",
      "age"
    ],
    [
      "monster",
      "bête"
    ],
    [
      "bang",
      "cogner"
    ],
    [
      "bone",
      "os"
    ],
    [
      "inner",
      "interne"
    ],
    [
      "tutorial",
      "TD"
    ],
    [
      "gate",
      "porte"
    ],
    [
      "holder",
      "étui"
    ],
    [
      "moderator",
      "modératrice"
    ],
    [
      "settlement",
      "colonie"
    ],
    [
      "roman",
      "Romaine"
    ],
    [
      "forever",
      "éternellement"
    ],
    [
      "dragon",
      "dragon"
    ],
    [
      "captain",
      "piloter"
    ],
    [
      "leg",
      "jambe"
    ],
    [
      "neck",
      "cou"
    ],
    [
      "wing",
      "ailier"
    ],
    [
      "taste",
      "goût"
    ],
    [
      "commit",
      "engager"
    ],
    [
      "rail",
      "rail"
    ],
    [
      "liberal",
      "libéral"
    ],
    [
      "jay",
      "geai"
    ],
    [
      "gap",
      "col"
    ],
    [
      "tube",
      "tuyau"
    ],
    [
      "cache",
      "mémoire cache"
    ],
    [
      "belt",
      "ceinture"
    ],
    [
      "jacket",
      "jaquette"
    ],
    [
      "animation",
      "invigoration"
    ],
    [
      "er",
      "lus"
    ],
    [
      "matthew",
      "Mathieu"
    ],
    [
      "lease",
      "loyer"
    ],
    [
      "proud",
      "orgueilleux"
    ],
    [
      "excess",
      "excès"
    ],
    [
      "disaster",
      "désastre"
    ],
    [
      "console",
      "console de jeu"
    ],
    [
      "instructor",
      "instructrice"
    ],
    [
      "bestiality",
      "zoophilie"
    ],
    [
      "alarm",
      "réveil"
    ],
    [
      "voltage",
      "tension"
    ],
    [
      "usual",
      "habituelle"
    ],
    [
      "loading",
      "chargement"
    ],
    [
      "angle",
      "angle"
    ],
    [
      "rob",
      "cambrioler"
    ],
    [
      "vinyl",
      "vinyle"
    ],
    [
      "highlights",
      "résumé"
    ],
    [
      "mining",
      "extraction minière"
    ],
    [
      "ongoing",
      "actuel"
    ],
    [
      "worst",
      "mauvais"
    ],
    [
      "blackjack",
      "matraque"
    ],
    [
      "era",
      "époque"
    ],
    [
      "analyst",
      "analyste"
    ],
    [
      "dangerous",
      "dangereux"
    ],
    [
      "unfortunately",
      "malencontreusement"
    ],
    [
      "attachment",
      "saisie"
    ],
    [
      "ringtone",
      "sonnerie de téléphone"
    ],
    [
      "morgan",
      "Morgane"
    ],
    [
      "pleasure",
      "désir"
    ],
    [
      "asp",
      "aspe"
    ],
    [
      "eagle",
      "eagle"
    ],
    [
      "pants",
      "slip"
    ],
    [
      "columbus",
      "Christophe Colomb"
    ],
    [
      "nurse",
      "soigner"
    ],
    [
      "prayer",
      "prière"
    ],
    [
      "appointment",
      "rencard"
    ],
    [
      "quiet",
      "calme"
    ],
    [
      "luck",
      "bol"
    ],
    [
      "producer",
      "productrice"
    ],
    [
      "dial",
      "bouille"
    ],
    [
      "cheese",
      "fric"
    ],
    [
      "comic",
      "BD"
    ],
    [
      "jet",
      "jais"
    ],
    [
      "crown",
      "sommet"
    ],
    [
      "underground",
      "underground"
    ],
    [
      "diagnosis",
      "diagnose"
    ],
    [
      "maker",
      "faiseur"
    ],
    [
      "crack",
      "craquer"
    ],
    [
      "gang",
      "bande"
    ],
    [
      "semester",
      "trimestre"
    ],
    [
      "appearance",
      "apparence"
    ],
    [
      "smoke",
      "clope"
    ],
    [
      "apache",
      "Apache"
    ],
    [
      "craft",
      "nef"
    ],
    [
      "cake",
      "pâtisserie"
    ],
    [
      "apart",
      "séparément"
    ],
    [
      "fellow",
      "ami"
    ],
    [
      "blind",
      "persienne"
    ],
    [
      "lounge",
      "salle d'attente"
    ],
    [
      "mad",
      "fâché"
    ],
    [
      "algorithm",
      "algorithmique"
    ],
    [
      "gross",
      "brut"
    ],
    [
      "strongly",
      "fort"
    ],
    [
      "valentine",
      "Valentine"
    ],
    [
      "horror",
      "dégoût"
    ],
    [
      "familiar",
      "esprit familier"
    ],
    [
      "till",
      "caisse"
    ],
    [
      "pen",
      "plume"
    ],
    [
      "shoe",
      "soulier"
    ],
    [
      "sand",
      "sable"
    ],
    [
      "cpu",
      "UCT"
    ],
    [
      "mainly",
      "surtout"
    ],
    [
      "ethnic",
      "ethnique"
    ],
    [
      "parliament",
      "pain d'épices"
    ],
    [
      "actor",
      "actrice"
    ],
    [
      "seal",
      "sceau"
    ],
    [
      "fifth",
      "quinte"
    ],
    [
      "citizen",
      "citoyenne"
    ],
    [
      "structural",
      "structural"
    ],
    [
      "anytime",
      "toujours"
    ],
    [
      "substance",
      "substance"
    ],
    [
      "pipe",
      "tuyau"
    ],
    [
      "guardian",
      "tuteur"
    ],
    [
      "lecture",
      "gronder"
    ],
    [
      "simulation",
      "simulation"
    ],
    [
      "layout",
      "plan"
    ],
    [
      "ill",
      "écœuré"
    ],
    [
      "lay",
      "coup"
    ],
    [
      "lol",
      "mdr"
    ],
    [
      "dirty",
      "salir"
    ],
    [
      "deck",
      "jeu"
    ],
    [
      "donate",
      "faire un don"
    ],
    [
      "bankruptcy",
      "faillite"
    ],
    [
      "worker",
      "ouvrière"
    ],
    [
      "alive",
      "en vie"
    ],
    [
      "temple",
      "tempe"
    ],
    [
      "prove",
      "s’avérer"
    ],
    [
      "promise",
      "vœu"
    ],
    [
      "thin",
      "fin"
    ],
    [
      "ridge",
      "faîte"
    ],
    [
      "cabinet",
      "cabinet"
    ],
    [
      "sick",
      "malade"
    ],
    [
      "tiffany",
      "Tiphaine"
    ],
    [
      "collect",
      "recueillir"
    ],
    [
      "composition",
      "œuvre"
    ],
    [
      "definitely",
      "décidément"
    ],
    [
      "buffer",
      "tampon"
    ],
    [
      "purple",
      "violet"
    ],
    [
      "necessarily",
      "absolument"
    ],
    [
      "attribute",
      "attribut"
    ],
    [
      "prison",
      "geôle"
    ],
    [
      "skill",
      "don"
    ],
    [
      "apparently",
      "apparemment"
    ],
    [
      "exhibit",
      "pièce à conviction"
    ],
    [
      "throw",
      "lancer"
    ],
    [
      "trend",
      "penchant"
    ],
    [
      "desert",
      "abandonner"
    ],
    [
      "busty",
      "pulpeux"
    ],
    [
      "coordinator",
      "coordinatrice"
    ],
    [
      "obviously",
      "clairement"
    ],
    [
      "mercury",
      "mercure"
    ],
    [
      "worse",
      "pire"
    ],
    [
      "burning",
      "ardent"
    ],
    [
      "escape",
      "fuir"
    ],
    [
      "somewhat",
      "assez"
    ],
    [
      "receiver",
      "récepteur"
    ],
    [
      "progressive",
      "progressiste"
    ],
    [
      "glance",
      "lancer un regard"
    ],
    [
      "scottish",
      "écossais"
    ],
    [
      "championship",
      "champion"
    ],
    [
      "arcade",
      "salle d'arcade"
    ],
    [
      "impossible",
      "insupportable"
    ],
    [
      "graph",
      "graphe"
    ],
    [
      "judgment",
      "verdict"
    ],
    [
      "foster",
      "élever"
    ],
    [
      "modeling",
      "mannequinat"
    ],
    [
      "passing",
      "mort"
    ],
    [
      "tissue",
      "kleenex"
    ],
    [
      "memorabilia",
      "souvenirs"
    ],
    [
      "subsection",
      "alinéa"
    ],
    [
      "fraud",
      "fraudeur"
    ],
    [
      "arrival",
      "arrivant"
    ],
    [
      "emphasis",
      "accent"
    ],
    [
      "roger",
      "reçu"
    ],
    [
      "workplace",
      "travail"
    ],
    [
      "awesome",
      "génial"
    ],
    [
      "mexican",
      "Mexicain"
    ],
    [
      "crash",
      "s'incruster"
    ],
    [
      "lift",
      "lever"
    ],
    [
      "shadow",
      "prendre en filature"
    ],
    [
      "riding",
      "comté"
    ],
    [
      "grove",
      "bois"
    ],
    [
      "eligibility",
      "admissibilité"
    ],
    [
      "venture",
      "oser"
    ],
    [
      "korean",
      "coréen"
    ],
    [
      "mall",
      "mail"
    ],
    [
      "packet",
      "colis"
    ],
    [
      "spray",
      "gerbe"
    ],
    [
      "extend",
      "prolonger"
    ],
    [
      "subsequent",
      "prochain"
    ],
    [
      "pat",
      "banal"
    ],
    [
      "fell",
      "faire tomber"
    ],
    [
      "motorcycle",
      "motocycle"
    ],
    [
      "yard",
      "verge"
    ],
    [
      "disclosure",
      "divulgation"
    ],
    [
      "establishment",
      "système"
    ],
    [
      "mayor",
      "mairesse"
    ],
    [
      "murder",
      "occire"
    ],
    [
      "senator",
      "sénatrice"
    ],
    [
      "yield",
      "céder"
    ],
    [
      "pour",
      "se déverser"
    ],
    [
      "digest",
      "revue"
    ],
    [
      "lodging",
      "verse"
    ],
    [
      "dust",
      "pulvériser"
    ],
    [
      "hence",
      "d'où"
    ],
    [
      "rescue",
      "secours"
    ],
    [
      "combat",
      "lutte"
    ],
    [
      "occupation",
      "métier"
    ],
    [
      "butt",
      "cul"
    ],
    [
      "closely",
      "étroitement"
    ],
    [
      "radiation",
      "rayonnement"
    ],
    [
      "diary",
      "journal"
    ],
    [
      "seriously",
      "sérieux"
    ],
    [
      "shooting",
      "fusillade"
    ],
    [
      "ear",
      "indic"
    ],
    [
      "baker",
      "boulangère"
    ],
    [
      "pollution",
      "défilement"
    ],
    [
      "conservative",
      "conservateur"
    ],
    [
      "shock",
      "choc"
    ],
    [
      "abroad",
      "dehors"
    ],
    [
      "ebony",
      "ébène"
    ],
    [
      "tie",
      "remise"
    ],
    [
      "ward",
      "garde"
    ],
    [
      "walker",
      "déambulateur"
    ],
    [
      "demonstrate",
      "manifester"
    ],
    [
      "atmosphere",
      "ambiance"
    ],
    [
      "kiss",
      "bec"
    ],
    [
      "beast",
      "bête"
    ],
    [
      "ra",
      "Râ"
    ],
    [
      "experiment",
      "expérimentation"
    ],
    [
      "overseas",
      "outre-mer"
    ],
    [
      "dodge",
      "éluder"
    ],
    [
      "counsel",
      "conseil"
    ],
    [
      "assignment",
      "tâche"
    ],
    [
      "rush",
      "hâte"
    ],
    [
      "absence",
      "absence"
    ],
    [
      "cluster",
      "grappe"
    ],
    [
      "whereas",
      "alors que"
    ],
    [
      "surprise",
      "étonner"
    ],
    [
      "partial",
      "attiré"
    ],
    [
      "everybody",
      "tous"
    ],
    [
      "ranking",
      "supérieur"
    ],
    [
      "acceptable",
      "admissible"
    ],
    [
      "glad",
      "content"
    ],
    [
      "globe",
      "terre"
    ],
    [
      "copper",
      "flic"
    ],
    [
      "rack",
      "carré"
    ],
    [
      "warehouse",
      "dépôt"
    ],
    [
      "shareware",
      "contributiel"
    ],
    [
      "receipt",
      "reçu"
    ],
    [
      "ordinary",
      "ordinaire"
    ],
    [
      "nobody",
      "nul"
    ],
    [
      "ghost",
      "esprit"
    ],
    [
      "violation",
      "violation"
    ],
    [
      "boss",
      "chef"
    ],
    [
      "pride",
      "fierté"
    ],
    [
      "reporter",
      "rapporteur"
    ],
    [
      "champion",
      "championne"
    ],
    [
      "cloudy",
      "opaque"
    ],
    [
      "solo",
      "solitaire"
    ],
    [
      "sentence",
      "peine"
    ],
    [
      "throat",
      "goulot"
    ],
    [
      "ignore",
      "tenir compte"
    ],
    [
      "uniform",
      "homogène"
    ],
    [
      "wealth",
      "richesse"
    ],
    [
      "tall",
      "haut"
    ],
    [
      "vacuum",
      "vacuum"
    ],
    [
      "brass",
      "cuivres"
    ],
    [
      "quest",
      "recherche"
    ],
    [
      "screening",
      "dépistage"
    ],
    [
      "toe",
      "doigt de pied"
    ],
    [
      "thumbnail",
      "aperçu"
    ],
    [
      "whenever",
      "chaque fois que"
    ],
    [
      "lifetime",
      "vie"
    ],
    [
      "pioneer",
      "pionnier"
    ],
    [
      "booty",
      "cul"
    ],
    [
      "venue",
      "salle"
    ],
    [
      "athletic",
      "sportif"
    ],
    [
      "thermal",
      "thermique"
    ],
    [
      "fairly",
      "assez"
    ],
    [
      "charity",
      "charité"
    ],
    [
      "excel",
      "briller"
    ],
    [
      "wake",
      "se réveiller"
    ],
    [
      "stupid",
      "bête"
    ],
    [
      "harbor",
      "port"
    ],
    [
      "segment",
      "quartier"
    ],
    [
      "realize",
      "réaliser"
    ],
    [
      "enemy",
      "ennemi"
    ],
    [
      "puzzle",
      "énigme"
    ],
    [
      "insight",
      "aperçu"
    ],
    [
      "sms",
      "texto"
    ],
    [
      "shit",
      "merde"
    ],
    [
      "restricted",
      "réservé"
    ],
    [
      "republican",
      "républicaine"
    ],
    [
      "lucky",
      "fortuné"
    ],
    [
      "thick",
      "épais"
    ],
    [
      "repeat",
      "refaire"
    ],
    [
      "penalty",
      "peine"
    ],
    [
      "drum",
      "baril"
    ],
    [
      "iraqi",
      "irakien"
    ],
    [
      "builder",
      "bâtisseur"
    ],
    [
      "vista",
      "point de vue"
    ],
    [
      "flood",
      "noyer"
    ],
    [
      "ease",
      "repos"
    ],
    [
      "orgy",
      "orgie"
    ],
    [
      "arena",
      "arène"
    ],
    [
      "announcement",
      "annonce"
    ],
    [
      "outcome",
      "résultat"
    ],
    [
      "appreciate",
      "apprécier"
    ],
    [
      "casual",
      "sport"
    ],
    [
      "lovely",
      "magnifique"
    ],
    [
      "clause",
      "clause"
    ],
    [
      "indoor",
      "salle"
    ],
    [
      "broker",
      "démarcheur"
    ],
    [
      "regularly",
      "fréquemment"
    ],
    [
      "tend",
      "tendre"
    ],
    [
      "laura",
      "Laure"
    ],
    [
      "shopper",
      "client"
    ],
    [
      "tokyo",
      "Tōkyō"
    ],
    [
      "candy",
      "dragée"
    ],
    [
      "tiger",
      "tigresse"
    ],
    [
      "sensor",
      "détecteur"
    ],
    [
      "hunt",
      "chasser"
    ],
    [
      "deputy",
      "adjoint"
    ],
    [
      "thai",
      "thaï"
    ],
    [
      "loaded",
      "pété de thunes"
    ],
    [
      "complaint",
      "réclamation"
    ],
    [
      "balls",
      "burnes"
    ],
    [
      "scholarship",
      "érudition"
    ],
    [
      "governance",
      "direction"
    ],
    [
      "mill",
      "manufacture"
    ],
    [
      "moral",
      "morale"
    ],
    [
      "den",
      "antre"
    ],
    [
      "catering",
      "traiteur"
    ],
    [
      "finger",
      "doigter"
    ],
    [
      "pound",
      "bief"
    ],
    [
      "locate",
      "situer"
    ],
    [
      "camcorder",
      "caméscope"
    ],
    [
      "burn",
      "brûler"
    ],
    [
      "bread",
      "blé"
    ],
    [
      "wooden",
      "boisé"
    ],
    [
      "incident",
      "fait-divers"
    ],
    [
      "lie",
      "couché"
    ],
    [
      "decrease",
      "réduire"
    ],
    [
      "chest",
      "coffre"
    ],
    [
      "pension",
      "retraite"
    ],
    [
      "worship",
      "culte"
    ],
    [
      "solve",
      "régler"
    ],
    [
      "minority",
      "minorité"
    ],
    [
      "diverse",
      "diversifié"
    ],
    [
      "sole",
      "plante du pied"
    ],
    [
      "franchise",
      "concession"
    ],
    [
      "recorder",
      "flûte à bec"
    ],
    [
      "passion",
      "Passion"
    ],
    [
      "sight",
      "mire"
    ],
    [
      "clay",
      "argile"
    ],
    [
      "weak",
      "débile"
    ],
    [
      "reception",
      "accueil"
    ],
    [
      "worry",
      "angoisse"
    ],
    [
      "legacy",
      "legs"
    ],
    [
      "pleased",
      "content"
    ],
    [
      "danger",
      "péril"
    ],
    [
      "widely",
      "largement"
    ],
    [
      "phrase",
      "phrase"
    ],
    [
      "genuine",
      "véritable"
    ],
    [
      "paradise",
      "paradis"
    ],
    [
      "emotional",
      "émotif"
    ],
    [
      "leaf",
      "battant"
    ],
    [
      "pad",
      "coussinet"
    ],
    [
      "diesel",
      "diésel"
    ],
    [
      "versus",
      "face à"
    ],
    [
      "exceed",
      "excéder"
    ],
    [
      "rod",
      "paf"
    ],
    [
      "saudi",
      "saoudi"
    ],
    [
      "fault",
      "faute"
    ],
    [
      "introduce",
      "introduire"
    ],
    [
      "promotional",
      "publicitaire"
    ],
    [
      "karen",
      "Karin"
    ],
    [
      "generator",
      "générateur électrique"
    ],
    [
      "examine",
      "examiner"
    ],
    [
      "correction",
      "rectification"
    ],
    [
      "wolf",
      "loup"
    ],
    [
      "slowly",
      "doucement"
    ],
    [
      "authentication",
      "authentification"
    ],
    [
      "communicate",
      "communier"
    ],
    [
      "infant",
      "poupon"
    ],
    [
      "fluid",
      "liquide"
    ],
    [
      "grounds",
      "marc"
    ],
    [
      "kick",
      "botter"
    ],
    [
      "regards",
      "respects"
    ],
    [
      "meal",
      "mouture"
    ],
    [
      "hurt",
      "faire mal"
    ],
    [
      "machinery",
      "machinerie"
    ],
    [
      "bandwidth",
      "débit"
    ],
    [
      "unlike",
      "contrairement à"
    ],
    [
      "pot",
      "pot"
    ],
    [
      "slip",
      "fiche"
    ],
    [
      "reviewer",
      "réviseur"
    ],
    [
      "quarterly",
      "écartelé"
    ],
    [
      "devil",
      "diable"
    ],
    [
      "grass",
      "gazon"
    ],
    [
      "comply",
      "acquiescer"
    ],
    [
      "cherry",
      "cerise"
    ],
    [
      "alternate",
      "alternative"
    ],
    [
      "achievement",
      "succès"
    ],
    [
      "webcam",
      "cam"
    ],
    [
      "funeral",
      "obsèques"
    ],
    [
      "pee",
      "pé"
    ],
    [
      "passenger",
      "passagère"
    ],
    [
      "convenient",
      "commode"
    ],
    [
      "francis",
      "Francis"
    ],
    [
      "socket",
      "cavité"
    ],
    [
      "silent",
      "muet"
    ],
    [
      "egg",
      "œuf"
    ],
    [
      "pill",
      "balle"
    ],
    [
      "swing",
      "osciller"
    ],
    [
      "dated",
      "démodé"
    ],
    [
      "flexibility",
      "souplesse"
    ],
    [
      "shoot",
      "zut"
    ],
    [
      "boundary",
      "limite"
    ],
    [
      "mint",
      "menthe"
    ],
    [
      "offset",
      "offset"
    ],
    [
      "elite",
      "d'élite"
    ],
    [
      "spin",
      "effet"
    ],
    [
      "deadline",
      "échéance"
    ],
    [
      "witness",
      "témoin"
    ],
    [
      "powder",
      "poudrer"
    ],
    [
      "assess",
      "évaluer"
    ],
    [
      "wash",
      "oeud"
    ],
    [
      "entrance",
      "ravir"
    ],
    [
      "roots",
      "sources"
    ],
    [
      "noble",
      "nobliau"
    ],
    [
      "glasgow",
      "Glasgovie"
    ],
    [
      "automation",
      "automation"
    ],
    [
      "rev",
      "faire tourner à plein régime"
    ],
    [
      "shore",
      "rive"
    ],
    [
      "knight",
      "cavalier"
    ],
    [
      "loose",
      "mal fixé"
    ],
    [
      "recipient",
      "receveur"
    ],
    [
      "triple",
      "pour trois"
    ],
    [
      "jam",
      "bœuf"
    ],
    [
      "disorder",
      "trouble"
    ],
    [
      "routine",
      "numéro"
    ],
    [
      "basically",
      "sommairement"
    ],
    [
      "firewall",
      "pare-feu"
    ],
    [
      "median",
      "médiane"
    ],
    [
      "scanner",
      "scanneur"
    ],
    [
      "horny",
      "chaud"
    ],
    [
      "adjustment",
      "arèglement"
    ],
    [
      "hero",
      "héroïne"
    ],
    [
      "integer",
      "entier"
    ],
    [
      "bachelor",
      "licence"
    ],
    [
      "attitude",
      "attitude"
    ],
    [
      "engaged",
      "engagé"
    ],
    [
      "carpet",
      "moquette"
    ],
    [
      "binary",
      "exécutable"
    ],
    [
      "punk",
      "vaurien"
    ],
    [
      "enrollment",
      "enrôlé"
    ],
    [
      "pace",
      "pas"
    ],
    [
      "besides",
      "de plus"
    ],
    [
      "collector",
      "collecteur"
    ],
    [
      "arc",
      "arc"
    ],
    [
      "dawn",
      "aurore"
    ],
    [
      "observation",
      "remarque"
    ],
    [
      "coat",
      "couche"
    ],
    [
      "mrs",
      "Mme."
    ],
    [
      "convenience",
      "avantage"
    ],
    [
      "container",
      "contenant"
    ],
    [
      "defendant",
      "inculpée"
    ],
    [
      "confirmation",
      "vérification"
    ],
    [
      "app",
      "programme"
    ],
    [
      "embedded",
      "inclus"
    ],
    [
      "wizard",
      "mage"
    ],
    [
      "recall",
      "rappeler"
    ],
    [
      "departure",
      "départ"
    ],
    [
      "belief",
      "croyance"
    ],
    [
      "bikini",
      "deux-pièces"
    ],
    [
      "shoulder",
      "epaule"
    ],
    [
      "harvard",
      "Harvarde"
    ],
    [
      "ottawa",
      "Ottawa"
    ],
    [
      "podcast",
      "balado"
    ],
    [
      "tit",
      "lolo"
    ],
    [
      "refine",
      "raffiner"
    ],
    [
      "bidder",
      "enchérisseuse"
    ],
    [
      "singer",
      "chanteuse"
    ],
    [
      "herald",
      "héraldesse"
    ],
    [
      "literacy",
      "littératie"
    ],
    [
      "aging",
      "sénescence"
    ],
    [
      "attraction",
      "attirance"
    ],
    [
      "diving",
      "plongeon"
    ],
    [
      "invite",
      "convier"
    ],
    [
      "suppose",
      "imaginer"
    ],
    [
      "reed",
      "jonc"
    ],
    [
      "involve",
      "involver"
    ],
    [
      "terror",
      "effroi"
    ],
    [
      "opposite",
      "inverse"
    ],
    [
      "ban",
      "bannir"
    ],
    [
      "temp",
      "intérimaire"
    ],
    [
      "mercedes",
      "Merco"
    ],
    [
      "assurance",
      "culot"
    ],
    [
      "clerk",
      "greffière"
    ],
    [
      "vast",
      "immense"
    ],
    [
      "outline",
      "aperçu"
    ],
    [
      "jeans",
      "jean"
    ],
    [
      "metropolitan",
      "urbain"
    ],
    [
      "odd",
      "impair"
    ],
    [
      "wrap",
      "crêpe"
    ],
    [
      "mood",
      "humeur"
    ],
    [
      "attractive",
      "attachant"
    ],
    [
      "careful",
      "attentif"
    ],
    [
      "beam",
      "poutre"
    ],
    [
      "gardening",
      "horticulture"
    ],
    [
      "arrive",
      "percer"
    ],
    [
      "sunset",
      "coucher de soleil"
    ],
    [
      "moreover",
      "de plus"
    ],
    [
      "minimal",
      "minimaliste"
    ],
    [
      "aside",
      "en passant"
    ],
    [
      "outsourcing",
      "impartition"
    ],
    [
      "adjustable",
      "réglable"
    ],
    [
      "essay",
      "rédaction"
    ],
    [
      "discipline",
      "discipline"
    ],
    [
      "dialogue",
      "conversation"
    ],
    [
      "alphabetical",
      "abécédaire"
    ],
    [
      "trace",
      "trait"
    ],
    [
      "disposal",
      "élimination"
    ],
    [
      "voluntary",
      "bénévole"
    ],
    [
      "consult",
      "concerter"
    ],
    [
      "ng",
      "NG"
    ],
    [
      "pe",
      "pe"
    ],
    [
      "photographer",
      "photoseur"
    ],
    [
      "inform",
      "dénoncer"
    ],
    [
      "turkish",
      "turque"
    ],
    [
      "coal",
      "charbon"
    ],
    [
      "cry",
      "crier"
    ],
    [
      "quantum",
      "quantité"
    ],
    [
      "intent",
      "résolu"
    ],
    [
      "largely",
      "largement"
    ],
    [
      "pleasant",
      "plaisant"
    ],
    [
      "sampling",
      "échantillonnage"
    ],
    [
      "rough",
      "brut"
    ],
    [
      "weird",
      "bizarre"
    ],
    [
      "lion",
      "lion"
    ],
    [
      "suddenly",
      "soudain"
    ],
    [
      "cookie",
      "motte"
    ],
    [
      "canyon",
      "gorge"
    ],
    [
      "merely",
      "seulement"
    ],
    [
      "arrangement",
      "accord"
    ],
    [
      "bibliography",
      "habbo"
    ],
    [
      "pointer",
      "pointeur"
    ],
    [
      "stretch",
      "étendre"
    ],
    [
      "furthermore",
      "de plus"
    ],
    [
      "muslim",
      "musulmane"
    ],
    [
      "sleeve",
      "boîtier"
    ],
    [
      "cleaner",
      "pressing"
    ],
    [
      "cricket",
      "cri-cri"
    ],
    [
      "stroke",
      "course"
    ],
    [
      "robin",
      "grive"
    ],
    [
      "strap",
      "sangle"
    ],
    [
      "headquarters",
      "siège"
    ],
    [
      "crowd",
      "monceau"
    ],
    [
      "customs",
      "douanes"
    ],
    [
      "rainbow",
      "multicolore"
    ],
    [
      "hook",
      "croc"
    ],
    [
      "decline",
      "refuser"
    ],
    [
      "israeli",
      "Israélienne"
    ],
    [
      "cord",
      "corde"
    ],
    [
      "cloud",
      "nuage"
    ]
  ],
  "it": [
    [
      "the",
      "il"
    ],
    [
      "of",
      "di"
    ],
    [
      "and",
      "ed"
    ],
    [
      "to",
      "per"
    ],
    [
      "a",
      "un'"
    ],
    [
      "in",
      "in"
    ],
    [
      "for",
      "per"
    ],
    [
      "on",
      "su"
    ],
    [
      "that",
      "che"
    ],
    [
      "by",
      "per"
    ],
    [
      "this",
      "questa"
    ],
    [
      "you",
      "si"
    ],
    [
      "it",
      "lo"
    ],
    [
      "not",
      "mica"
    ],
    [
      "or",
      "od"
    ],
    [
      "be",
      "essere"
    ],
    [
      "from",
      "di"
    ],
    [
      "at",
      "a"
    ],
    [
      "as",
      "come"
    ],
    [
      "your",
      "tua"
    ],
    [
      "all",
      "tutta"
    ],
    [
      "have",
      "avere"
    ],
    [
      "new",
      "nuovo"
    ],
    [
      "more",
      "vieppiù"
    ],
    [
      "an",
      "un'"
    ],
    [
      "we",
      "noialtri"
    ],
    [
      "will",
      "-erò"
    ],
    [
      "home",
      "meta"
    ],
    [
      "can",
      "tacere"
    ],
    [
      "us",
      "noi"
    ],
    [
      "about",
      "su"
    ],
    [
      "page",
      "paggio"
    ],
    [
      "my",
      "mia"
    ],
    [
      "search",
      "cerca"
    ],
    [
      "free",
      "libero"
    ],
    [
      "but",
      "però"
    ],
    [
      "our",
      "nostra"
    ],
    [
      "one",
      "una"
    ],
    [
      "do",
      "fare"
    ],
    [
      "no",
      "non"
    ],
    [
      "time",
      "ora"
    ],
    [
      "they",
      "si"
    ],
    [
      "site",
      "sito"
    ],
    [
      "he",
      "egli"
    ],
    [
      "up",
      "su"
    ],
    [
      "may",
      "forse"
    ],
    [
      "what",
      "che"
    ],
    [
      "which",
      "che"
    ],
    [
      "their",
      "i loro"
    ],
    [
      "news",
      "notizie"
    ],
    [
      "use",
      "utilizzare"
    ],
    [
      "any",
      "qualsiasi"
    ],
    [
      "there",
      "ci"
    ],
    [
      "see",
      "sede"
    ],
    [
      "only",
      "solo"
    ],
    [
      "so",
      "tanto"
    ],
    [
      "his",
      "sua"
    ],
    [
      "contact",
      "aggancio"
    ],
    [
      "here",
      "qua"
    ],
    [
      "business",
      "affare"
    ],
    [
      "who",
      "che"
    ],
    [
      "web",
      "vela"
    ],
    [
      "also",
      "altresì"
    ],
    [
      "now",
      "mo"
    ],
    [
      "help",
      "aiuto"
    ],
    [
      "get",
      "diventare"
    ],
    [
      "view",
      "vista"
    ],
    [
      "online",
      "online"
    ],
    [
      "first",
      "prima"
    ],
    [
      "how",
      "come"
    ],
    [
      "me",
      "me"
    ],
    [
      "s",
      "i"
    ],
    [
      "some",
      "che"
    ],
    [
      "click",
      "clicca"
    ],
    [
      "like",
      "come"
    ],
    [
      "service",
      "notifica"
    ],
    [
      "than",
      "che"
    ],
    [
      "find",
      "trovare"
    ],
    [
      "price",
      "costo"
    ],
    [
      "date",
      "data"
    ],
    [
      "back",
      "dietro"
    ],
    [
      "top",
      "coffa"
    ],
    [
      "people",
      "popolo"
    ],
    [
      "list",
      "lista"
    ],
    [
      "name",
      "nominare"
    ],
    [
      "just",
      "appena"
    ],
    [
      "over",
      "sopra"
    ],
    [
      "state",
      "esporre"
    ],
    [
      "day",
      "giornata"
    ],
    [
      "into",
      "di"
    ],
    [
      "email",
      "mail"
    ],
    [
      "two",
      "paio"
    ],
    [
      "health",
      "salute"
    ],
    [
      "next",
      "vicino"
    ],
    [
      "go",
      "diventare"
    ],
    [
      "work",
      "lavoro"
    ],
    [
      "last",
      "scorso"
    ],
    [
      "most",
      "il più"
    ],
    [
      "music",
      "spartito"
    ],
    [
      "buy",
      "acquistare"
    ],
    [
      "data",
      "dato"
    ],
    [
      "make",
      "rendere"
    ],
    [
      "them",
      "le"
    ],
    [
      "product",
      "prodotto"
    ],
    [
      "post",
      "posta"
    ],
    [
      "her",
      "la"
    ],
    [
      "add",
      "sommare"
    ],
    [
      "policy",
      "prassi"
    ],
    [
      "number",
      "numero"
    ],
    [
      "such",
      "così"
    ],
    [
      "please",
      "per piacere"
    ],
    [
      "available",
      "disponibile"
    ],
    [
      "copyright",
      "tutelare i copyright"
    ],
    [
      "support",
      "sostegno"
    ],
    [
      "message",
      "tema"
    ],
    [
      "after",
      "dopo"
    ],
    [
      "best",
      "battere"
    ],
    [
      "software",
      "programma"
    ],
    [
      "then",
      "poi"
    ],
    [
      "good",
      "buono"
    ],
    [
      "video",
      "videofilm"
    ],
    [
      "well",
      "beh"
    ],
    [
      "where",
      "laddove"
    ],
    [
      "high",
      "fuso"
    ],
    [
      "school",
      "scuola"
    ],
    [
      "through",
      "per"
    ],
    [
      "each",
      "ogni"
    ],
    [
      "she",
      "ella"
    ],
    [
      "review",
      "rivista"
    ],
    [
      "order",
      "ordine"
    ],
    [
      "very",
      "mero"
    ],
    [
      "privacy",
      "privatezza"
    ],
    [
      "book",
      "libro"
    ],
    [
      "company",
      "azienda"
    ],
    [
      "read",
      "leggere"
    ],
    [
      "group",
      "formazione"
    ],
    [
      "need",
      "esigenza"
    ],
    [
      "many",
      "un gran numero di"
    ],
    [
      "user",
      "utilizzatore"
    ],
    [
      "set",
      "stabilire"
    ],
    [
      "research",
      "ricerca"
    ],
    [
      "university",
      "ateneo"
    ],
    [
      "mail",
      "poste"
    ],
    [
      "full",
      "completo"
    ],
    [
      "map",
      "carta"
    ],
    [
      "program",
      "scaletta"
    ],
    [
      "life",
      "vita"
    ],
    [
      "know",
      "conoscere"
    ],
    [
      "way",
      "via"
    ],
    [
      "management",
      "direzione"
    ],
    [
      "part",
      "parte"
    ],
    [
      "great",
      "grande"
    ],
    [
      "hotel",
      "hotel"
    ],
    [
      "real",
      "vero"
    ],
    [
      "item",
      "punto"
    ],
    [
      "center",
      "pivot"
    ],
    [
      "must",
      "mosto"
    ],
    [
      "store",
      "scorta"
    ],
    [
      "development",
      "sviluppo"
    ],
    [
      "report",
      "riferire"
    ],
    [
      "off",
      "putrido"
    ],
    [
      "member",
      "membra"
    ],
    [
      "line",
      "linea"
    ],
    [
      "before",
      "innanzi"
    ],
    [
      "send",
      "mandare"
    ],
    [
      "right",
      "destra"
    ],
    [
      "type",
      "digitare"
    ],
    [
      "because",
      "perché"
    ],
    [
      "those",
      "quei"
    ],
    [
      "office",
      "ufficio"
    ],
    [
      "education",
      "educazione"
    ],
    [
      "car",
      "auto"
    ],
    [
      "design",
      "design"
    ],
    [
      "take",
      "portare"
    ],
    [
      "address",
      "mirare"
    ],
    [
      "community",
      "comunità"
    ],
    [
      "within",
      "entro"
    ],
    [
      "area",
      "zona"
    ],
    [
      "want",
      "volere"
    ],
    [
      "phone",
      "suffixA type of sound.fono"
    ],
    [
      "subject",
      "corso"
    ],
    [
      "between",
      "tra"
    ],
    [
      "forum",
      "foro"
    ],
    [
      "long",
      "tempo"
    ],
    [
      "code",
      "norma"
    ],
    [
      "show",
      "mostra"
    ],
    [
      "o",
      "oh"
    ],
    [
      "even",
      "pari"
    ],
    [
      "black",
      "nera"
    ],
    [
      "check",
      "scacco"
    ],
    [
      "special",
      "speciale"
    ],
    [
      "website",
      "sito"
    ],
    [
      "being",
      "creatura"
    ],
    [
      "sign",
      "segno"
    ],
    [
      "file",
      "file"
    ],
    [
      "link",
      "lega"
    ],
    [
      "open",
      "aprire"
    ],
    [
      "today",
      "oggi"
    ],
    [
      "technology",
      "tecnica"
    ],
    [
      "south",
      "sud"
    ],
    [
      "case",
      "caso"
    ],
    [
      "project",
      "studio"
    ],
    [
      "same",
      "medesimo"
    ],
    [
      "section",
      "sezione"
    ],
    [
      "house",
      "casa"
    ],
    [
      "related",
      "inerente"
    ],
    [
      "security",
      "cartevalori"
    ],
    [
      "both",
      "sia"
    ],
    [
      "county",
      "contea"
    ],
    [
      "american",
      "americana"
    ],
    [
      "game",
      "selvaggina"
    ],
    [
      "power",
      "potere"
    ],
    [
      "while",
      "benché"
    ],
    [
      "care",
      "curare"
    ],
    [
      "network",
      "rete"
    ],
    [
      "down",
      "giù"
    ],
    [
      "computer",
      "computiere"
    ],
    [
      "three",
      "trio"
    ],
    [
      "total",
      "somma"
    ],
    [
      "place",
      "posto"
    ],
    [
      "end",
      "estremità"
    ],
    [
      "download",
      "download"
    ],
    [
      "him",
      "lo"
    ],
    [
      "per",
      "al"
    ],
    [
      "think",
      "credere"
    ],
    [
      "north",
      "mezzanotte"
    ],
    [
      "current",
      "corrente"
    ],
    [
      "big",
      "grande"
    ],
    [
      "media",
      "media"
    ],
    [
      "law",
      "legge"
    ],
    [
      "control",
      "comandi"
    ],
    [
      "water",
      "abbeverare"
    ],
    [
      "history",
      "storia"
    ],
    [
      "size",
      "taglia"
    ],
    [
      "art",
      "arte"
    ],
    [
      "since",
      "dacché"
    ],
    [
      "shop",
      "bottega"
    ],
    [
      "directory",
      "lista"
    ],
    [
      "board",
      "bordo"
    ],
    [
      "location",
      "ubicazione"
    ],
    [
      "change",
      "cambiare"
    ],
    [
      "white",
      "bianca"
    ],
    [
      "text",
      "sms"
    ],
    [
      "small",
      "giovane"
    ],
    [
      "rating",
      "valutazione"
    ],
    [
      "rate",
      "costo"
    ],
    [
      "government",
      "reggenza"
    ],
    [
      "usa",
      "SUA"
    ],
    [
      "return",
      "ritornare"
    ],
    [
      "shopping",
      "shopping"
    ],
    [
      "account",
      "conto"
    ],
    [
      "level",
      "livello"
    ],
    [
      "digital",
      "digitale"
    ],
    [
      "profile",
      "sagoma"
    ],
    [
      "form",
      "modulo"
    ],
    [
      "love",
      "amore"
    ],
    [
      "old",
      "avere"
    ],
    [
      "john",
      "Giovanni"
    ],
    [
      "call",
      "chiamata"
    ],
    [
      "department",
      "facoltà"
    ],
    [
      "y",
      "à"
    ],
    [
      "another",
      "un'altra"
    ],
    [
      "property",
      "proprietà"
    ],
    [
      "class",
      "classe"
    ],
    [
      "still",
      "ancora"
    ],
    [
      "money",
      "grano"
    ],
    [
      "quality",
      "pregiato"
    ],
    [
      "country",
      "landa"
    ],
    [
      "private",
      "privato"
    ],
    [
      "little",
      "poco"
    ],
    [
      "visit",
      "visita"
    ],
    [
      "save",
      "salvare"
    ],
    [
      "reply",
      "replica"
    ],
    [
      "customer",
      "cliente"
    ],
    [
      "compare",
      "comparare"
    ],
    [
      "include",
      "inserire"
    ],
    [
      "college",
      "scuola universitaria"
    ],
    [
      "value",
      "apprezzare"
    ],
    [
      "article",
      "articolo"
    ],
    [
      "york",
      "Iorca"
    ],
    [
      "man",
      "umano"
    ],
    [
      "card",
      "carta"
    ],
    [
      "provide",
      "erogare"
    ],
    [
      "food",
      "alimento"
    ],
    [
      "source",
      "fonte"
    ],
    [
      "author",
      "autrice"
    ],
    [
      "different",
      "differente"
    ],
    [
      "press",
      "stampa"
    ],
    [
      "learn",
      "imparare"
    ],
    [
      "sale",
      "saldo"
    ],
    [
      "around",
      "verso"
    ],
    [
      "print",
      "impronta"
    ],
    [
      "course",
      "corso"
    ],
    [
      "job",
      "lavoro"
    ],
    [
      "process",
      "processo"
    ],
    [
      "teen",
      "ici-"
    ],
    [
      "room",
      "posto"
    ],
    [
      "stock",
      "partita"
    ],
    [
      "training",
      "stage"
    ],
    [
      "too",
      "pure"
    ],
    [
      "credit",
      "avvalorare"
    ],
    [
      "point",
      "puntare"
    ],
    [
      "join",
      "aderire"
    ],
    [
      "science",
      "scienza"
    ],
    [
      "advanced",
      "avanzato"
    ],
    [
      "west",
      "ponente"
    ],
    [
      "look",
      "aspetto"
    ],
    [
      "english",
      "silvio"
    ],
    [
      "left",
      "sinistro"
    ],
    [
      "team",
      "équipe"
    ],
    [
      "estate",
      "beni"
    ],
    [
      "box",
      "cornice"
    ],
    [
      "select",
      "scegliere"
    ],
    [
      "gay",
      "gaio"
    ],
    [
      "thread",
      "filo"
    ],
    [
      "note",
      "nota"
    ],
    [
      "live",
      "in tempo reale"
    ],
    [
      "large",
      "ampio"
    ],
    [
      "gallery",
      "galleria"
    ],
    [
      "table",
      "tavola"
    ],
    [
      "however",
      "tuttavia"
    ],
    [
      "library",
      "libreria"
    ],
    [
      "really",
      "veramente"
    ],
    [
      "action",
      "azione"
    ],
    [
      "start",
      "avvio"
    ],
    [
      "model",
      "modello"
    ],
    [
      "air",
      "ventilare"
    ],
    [
      "industry",
      "industria"
    ],
    [
      "plan",
      "pianificare"
    ],
    [
      "human",
      "uomo"
    ],
    [
      "provided",
      "purché"
    ],
    [
      "tv",
      "tivù"
    ],
    [
      "yes",
      "sì"
    ],
    [
      "second",
      "attimo"
    ],
    [
      "hot",
      "figa"
    ],
    [
      "cost",
      "spesa"
    ],
    [
      "movie",
      "pellicola"
    ],
    [
      "march",
      "marca"
    ],
    [
      "better",
      "meglio"
    ],
    [
      "say",
      "dire"
    ],
    [
      "test",
      "testare"
    ],
    [
      "friend",
      "amica"
    ],
    [
      "come",
      "venire"
    ],
    [
      "server",
      "servente"
    ],
    [
      "study",
      "studio"
    ],
    [
      "application",
      "impiego"
    ],
    [
      "cart",
      "carrello"
    ],
    [
      "staff",
      "asta"
    ],
    [
      "feedback",
      "ritorno"
    ],
    [
      "again",
      "ancora"
    ],
    [
      "play",
      "suonare"
    ],
    [
      "never",
      "giammai"
    ],
    [
      "complete",
      "portare a termine"
    ],
    [
      "street",
      "strada"
    ],
    [
      "topic",
      "soggetto"
    ],
    [
      "comment",
      "commento"
    ],
    [
      "financial",
      "monetario"
    ],
    [
      "working",
      "lavorativo"
    ],
    [
      "against",
      "contro"
    ],
    [
      "standard",
      "tipo"
    ],
    [
      "tax",
      "tassa"
    ],
    [
      "below",
      "sotto zero"
    ],
    [
      "less",
      "-"
    ],
    [
      "blog",
      "diario in rete"
    ],
    [
      "party",
      "festa"
    ],
    [
      "equipment",
      "apparecchiatura"
    ],
    [
      "student",
      "studentessa"
    ],
    [
      "let",
      "affittare"
    ],
    [
      "legal",
      "legale"
    ],
    [
      "above",
      "sopra"
    ],
    [
      "park",
      "sostare"
    ],
    [
      "side",
      "lato"
    ],
    [
      "act",
      "fare"
    ],
    [
      "red",
      "rosso"
    ],
    [
      "memory",
      "memoria"
    ],
    [
      "performance",
      "prestazione"
    ],
    [
      "social",
      "mondano"
    ],
    [
      "quote",
      "aliquota"
    ],
    [
      "language",
      "linguaggio"
    ],
    [
      "story",
      "vicenda"
    ],
    [
      "sell",
      "circuire"
    ],
    [
      "experience",
      "sperimentare"
    ],
    [
      "key",
      "chiave"
    ],
    [
      "body",
      "ente"
    ],
    [
      "young",
      "prole"
    ],
    [
      "field",
      "campo"
    ],
    [
      "few",
      "pochi"
    ],
    [
      "east",
      "levante"
    ],
    [
      "paper",
      "saggio"
    ],
    [
      "single",
      "celibe"
    ],
    [
      "age",
      "età"
    ],
    [
      "club",
      "clava"
    ],
    [
      "password",
      "parola chiave"
    ],
    [
      "something",
      "qualche cosa"
    ],
    [
      "road",
      "via"
    ],
    [
      "gift",
      "dono"
    ],
    [
      "question",
      "questione"
    ],
    [
      "hard",
      "duro"
    ],
    [
      "four",
      "quaterna"
    ],
    [
      "poker",
      "poker"
    ],
    [
      "browse",
      "navigare"
    ],
    [
      "issue",
      "esito"
    ],
    [
      "range",
      "gamma"
    ],
    [
      "building",
      "palazzo"
    ],
    [
      "seller",
      "venditrice"
    ],
    [
      "court",
      "corte"
    ],
    [
      "result",
      "esito"
    ],
    [
      "light",
      "leggero"
    ],
    [
      "write",
      "scrivere"
    ],
    [
      "offer",
      "offrire"
    ],
    [
      "blue",
      "azzurro"
    ],
    [
      "given",
      "presupposto"
    ],
    [
      "event",
      "fatto"
    ],
    [
      "release",
      "scaricare"
    ],
    [
      "request",
      "domanda"
    ],
    [
      "fax",
      "telefax"
    ],
    [
      "picture",
      "foto"
    ],
    [
      "might",
      "forza"
    ],
    [
      "professional",
      "qualificato"
    ],
    [
      "yet",
      "già"
    ],
    [
      "major",
      "grande"
    ],
    [
      "star",
      "stella"
    ],
    [
      "future",
      "avvenire"
    ],
    [
      "committee",
      "commissione"
    ],
    [
      "hand",
      "passare"
    ],
    [
      "sun",
      "Sole"
    ],
    [
      "london",
      "Londra"
    ],
    [
      "meeting",
      "incrocio"
    ],
    [
      "become",
      "divenire"
    ],
    [
      "interest",
      "interesse"
    ],
    [
      "child",
      "bambina"
    ],
    [
      "keep",
      "tenere"
    ],
    [
      "enter",
      "digitare"
    ],
    [
      "porn",
      "pornografia"
    ],
    [
      "share",
      "azione"
    ],
    [
      "similar",
      "simile"
    ],
    [
      "garden",
      "orto"
    ],
    [
      "baby",
      "bella"
    ],
    [
      "learning",
      "conoscenza"
    ],
    [
      "energy",
      "forza"
    ],
    [
      "run",
      "correre"
    ],
    [
      "delivery",
      "parto"
    ],
    [
      "net",
      "rete"
    ],
    [
      "term",
      "scadenza"
    ],
    [
      "film",
      "girare"
    ],
    [
      "put",
      "porre"
    ],
    [
      "journal",
      "rivista"
    ],
    [
      "try",
      "cercare"
    ],
    [
      "welcome",
      "libero"
    ],
    [
      "central",
      "centrale"
    ],
    [
      "president",
      "dirigente"
    ],
    [
      "notice",
      "avviso"
    ],
    [
      "god",
      "dio"
    ],
    [
      "original",
      "originale"
    ],
    [
      "head",
      "testa"
    ],
    [
      "until",
      "fino a"
    ],
    [
      "cell",
      "cella"
    ],
    [
      "color",
      "colorire"
    ],
    [
      "away",
      "via"
    ],
    [
      "track",
      "scia"
    ],
    [
      "archive",
      "banca dati"
    ],
    [
      "once",
      "un tempo"
    ],
    [
      "entertainment",
      "intrattenimento"
    ],
    [
      "agreement",
      "accordo"
    ],
    [
      "format",
      "formato"
    ],
    [
      "society",
      "società"
    ],
    [
      "log",
      "ceppo"
    ],
    [
      "sure",
      "certa"
    ],
    [
      "trade",
      "mestiere"
    ],
    [
      "marketing",
      "vendistica"
    ],
    [
      "tell",
      "dire"
    ],
    [
      "further",
      "accrescere"
    ],
    [
      "able",
      "abile"
    ],
    [
      "fun",
      "svago"
    ],
    [
      "already",
      "già"
    ],
    [
      "green",
      "verde"
    ],
    [
      "close",
      "chiudere"
    ],
    [
      "common",
      "comune"
    ],
    [
      "drive",
      "condurre"
    ],
    [
      "specific",
      "peculiare"
    ],
    [
      "several",
      "vari"
    ],
    [
      "gold",
      "dorato"
    ],
    [
      "collection",
      "colletta"
    ],
    [
      "short",
      "basso"
    ],
    [
      "lot",
      "destino"
    ],
    [
      "ask",
      "chiedere"
    ],
    [
      "display",
      "video"
    ],
    [
      "powered",
      "spinto"
    ],
    [
      "director",
      "capo"
    ],
    [
      "daily",
      "quotidiano"
    ],
    [
      "beach",
      "lido"
    ],
    [
      "whether",
      "se"
    ],
    [
      "period",
      "punto"
    ],
    [
      "database",
      "base di dati"
    ],
    [
      "weather",
      "tempo"
    ],
    [
      "land",
      "terra"
    ],
    [
      "average",
      "medio"
    ],
    [
      "technical",
      "tennico"
    ],
    [
      "pro",
      "in favore di"
    ],
    [
      "island",
      "isolare"
    ],
    [
      "record",
      "record"
    ],
    [
      "district",
      "distretto"
    ],
    [
      "style",
      "stile"
    ],
    [
      "front",
      "facciata"
    ],
    [
      "statement",
      "rendiconto"
    ],
    [
      "update",
      "aggiornare"
    ],
    [
      "early",
      "precoce"
    ],
    [
      "sound",
      "sicuro"
    ],
    [
      "resource",
      "dotare"
    ],
    [
      "present",
      "esporre"
    ],
    [
      "either",
      "ogni"
    ],
    [
      "document",
      "carta"
    ],
    [
      "word",
      "parola"
    ],
    [
      "bill",
      "manifesto"
    ],
    [
      "talk",
      "discorso"
    ],
    [
      "final",
      "finale"
    ],
    [
      "adult",
      "adulta"
    ],
    [
      "thing",
      "coso"
    ],
    [
      "centre",
      "regione Centro"
    ],
    [
      "via",
      "per"
    ],
    [
      "cheap",
      "scadente"
    ],
    [
      "nude",
      "nudità"
    ],
    [
      "finance",
      "finanze"
    ],
    [
      "mark",
      "marcare"
    ],
    [
      "third",
      "terza"
    ],
    [
      "rock",
      "cullare"
    ],
    [
      "reading",
      "lettura"
    ],
    [
      "bad",
      "malvagio"
    ],
    [
      "individual",
      "soggetto"
    ],
    [
      "plus",
      "positivo"
    ],
    [
      "cover",
      "copertura"
    ],
    [
      "usually",
      "generalmente"
    ],
    [
      "edit",
      "elaborare"
    ],
    [
      "together",
      "insieme"
    ],
    [
      "fast",
      "avanti"
    ],
    [
      "function",
      "fungere"
    ],
    [
      "fact",
      "fatto"
    ],
    [
      "global",
      "mondiale"
    ],
    [
      "meet",
      "incontrare"
    ],
    [
      "far",
      "lontano"
    ],
    [
      "economic",
      "economo"
    ],
    [
      "player",
      "attore"
    ],
    [
      "lyrics",
      "parole"
    ],
    [
      "often",
      "sovente"
    ],
    [
      "submit",
      "inviare"
    ],
    [
      "amount",
      "importo"
    ],
    [
      "watch",
      "guardia"
    ],
    [
      "feel",
      "sentire"
    ],
    [
      "though",
      "comunque"
    ],
    [
      "bank",
      "banca"
    ],
    [
      "thanks",
      "grazie"
    ],
    [
      "weight",
      "gravare"
    ],
    [
      "heart",
      "cuore"
    ],
    [
      "choose",
      "decidere"
    ],
    [
      "treatment",
      "cura"
    ],
    [
      "points",
      "scambio"
    ],
    [
      "knowledge",
      "sapere"
    ],
    [
      "magazine",
      "periodico"
    ],
    [
      "error",
      "vizio"
    ],
    [
      "camera",
      "macchina fotografica"
    ],
    [
      "girl",
      "bambina"
    ],
    [
      "currently",
      "ora"
    ],
    [
      "registered",
      "certificato"
    ],
    [
      "clear",
      "chiaro"
    ],
    [
      "domain",
      "campo"
    ],
    [
      "loan",
      "mutuo"
    ],
    [
      "wide",
      "ampio"
    ],
    [
      "beauty",
      "bella"
    ],
    [
      "manager",
      "gestore"
    ],
    [
      "position",
      "posto"
    ],
    [
      "taken",
      "coinvolto"
    ],
    [
      "sort",
      "tipo"
    ],
    [
      "known",
      "noto"
    ],
    [
      "half",
      "mezzo"
    ],
    [
      "step",
      "passo"
    ],
    [
      "engineering",
      "sala macchine"
    ],
    [
      "simple",
      "mero"
    ],
    [
      "quick",
      "svelto"
    ],
    [
      "none",
      "niente"
    ],
    [
      "license",
      "licenza"
    ],
    [
      "lake",
      "lago"
    ],
    [
      "whole",
      "tutto"
    ],
    [
      "later",
      "più tardi"
    ],
    [
      "basic",
      "basico"
    ],
    [
      "google",
      "ricerca"
    ],
    [
      "church",
      "Chiesa"
    ],
    [
      "method",
      "metodo"
    ],
    [
      "purchase",
      "compra"
    ],
    [
      "response",
      "risposta"
    ],
    [
      "hardware",
      "hardware"
    ],
    [
      "figure",
      "figura"
    ],
    [
      "fire",
      "fuoco"
    ],
    [
      "holiday",
      "vacanza"
    ],
    [
      "chat",
      "parlare"
    ],
    [
      "enough",
      "assai"
    ],
    [
      "among",
      "tra"
    ],
    [
      "death",
      "morte"
    ],
    [
      "speed",
      "celerità"
    ],
    [
      "loss",
      "perdita"
    ],
    [
      "face",
      "viso"
    ],
    [
      "brand",
      "marca"
    ],
    [
      "remember",
      "ricordare"
    ],
    [
      "oil",
      "oleare"
    ],
    [
      "bit",
      "poca"
    ],
    [
      "yellow",
      "gialla"
    ],
    [
      "increase",
      "aggravio"
    ],
    [
      "advertise",
      "divulgare"
    ],
    [
      "kingdom",
      "reame"
    ],
    [
      "base",
      "base"
    ],
    [
      "near",
      "vicino"
    ],
    [
      "thought",
      "idea"
    ],
    [
      "stuff",
      "roba"
    ],
    [
      "storage",
      "accumulo"
    ],
    [
      "entry",
      "entrata"
    ],
    [
      "stay",
      "stare"
    ],
    [
      "availability",
      "reperibilità"
    ],
    [
      "summary",
      "sommario"
    ],
    [
      "turn",
      "giro"
    ],
    [
      "mean",
      "intendere"
    ],
    [
      "growth",
      "crescita"
    ],
    [
      "agency",
      "agenzia"
    ],
    [
      "european",
      "europea"
    ],
    [
      "activity",
      "svago"
    ],
    [
      "copy",
      "copia"
    ],
    [
      "although",
      "benché"
    ],
    [
      "drug",
      "droga"
    ],
    [
      "income",
      "introiti"
    ],
    [
      "force",
      "forzare"
    ],
    [
      "cash",
      "liquidi"
    ],
    [
      "employment",
      "assunzione"
    ],
    [
      "overall",
      "blusa"
    ],
    [
      "bay",
      "vano"
    ],
    [
      "river",
      "rivo"
    ],
    [
      "commission",
      "commissionare"
    ],
    [
      "package",
      "pacchetto"
    ],
    [
      "port",
      "babordo"
    ],
    [
      "stop",
      "fermare"
    ],
    [
      "administration",
      "somministrazione"
    ],
    [
      "bar",
      "barra"
    ],
    [
      "double",
      "doppio"
    ],
    [
      "dog",
      "cane"
    ],
    [
      "build",
      "edificare"
    ],
    [
      "screen",
      "cernere"
    ],
    [
      "exchange",
      "borsa"
    ],
    [
      "soon",
      "a breve"
    ],
    [
      "across",
      "attraverso"
    ],
    [
      "season",
      "condire"
    ],
    [
      "apply",
      "candidarsi"
    ],
    [
      "anything",
      "niente"
    ],
    [
      "condition",
      "condizionare"
    ],
    [
      "effective",
      "effettivo"
    ],
    [
      "lost",
      "perso"
    ],
    [
      "tour",
      "giro"
    ],
    [
      "menu",
      "menu"
    ],
    [
      "volume",
      "rollo"
    ],
    [
      "cross",
      "croce"
    ],
    [
      "silver",
      "argento"
    ],
    [
      "corporation",
      "azienda"
    ],
    [
      "wish",
      "voglia"
    ],
    [
      "inside",
      "all'interno"
    ],
    [
      "solution",
      "pagamento"
    ],
    [
      "role",
      "parte"
    ],
    [
      "rather",
      "piuttosto"
    ],
    [
      "addition",
      "aggiunta"
    ],
    [
      "supply",
      "supplire"
    ],
    [
      "nothing",
      "nulla"
    ],
    [
      "certain",
      "tale"
    ],
    [
      "running",
      "corrente"
    ],
    [
      "clothing",
      "vestiti"
    ],
    [
      "particular",
      "proprio"
    ],
    [
      "fine",
      "bella"
    ],
    [
      "gas",
      "benzina"
    ],
    [
      "bush",
      "cespuglio"
    ],
    [
      "advice",
      "avviso"
    ],
    [
      "leave",
      "lasciare"
    ],
    [
      "huge",
      "gigante"
    ],
    [
      "zip",
      "tirare cerniera lampo"
    ],
    [
      "kind",
      "tipo"
    ],
    [
      "middle",
      "mezzo"
    ],
    [
      "move",
      "muovere"
    ],
    [
      "cable",
      "cavo"
    ],
    [
      "division",
      "divisione"
    ],
    [
      "object",
      "cosa"
    ],
    [
      "lesbian",
      "lesbica"
    ],
    [
      "appropriate",
      "apposito"
    ],
    [
      "machine",
      "macchina"
    ],
    [
      "logo",
      "logotipo"
    ],
    [
      "actually",
      "davvero"
    ],
    [
      "nice",
      "bello"
    ],
    [
      "score",
      "conto"
    ],
    [
      "ok",
      "intesi"
    ],
    [
      "capital",
      "ottimo"
    ],
    [
      "sample",
      "assaggio"
    ],
    [
      "culture",
      "coltura"
    ],
    [
      "band",
      "banda"
    ],
    [
      "flash",
      "baleno"
    ],
    [
      "lead",
      "condurre"
    ],
    [
      "george",
      "Iorio"
    ],
    [
      "choice",
      "ottima"
    ],
    [
      "consumer",
      "consumatrice"
    ],
    [
      "airport",
      "aerodromo"
    ],
    [
      "foreign",
      "estranea"
    ],
    [
      "outside",
      "esterno"
    ],
    [
      "furniture",
      "mobile"
    ],
    [
      "channel",
      "imitare"
    ],
    [
      "letter",
      "lettera"
    ],
    [
      "allow",
      "permettere"
    ],
    [
      "degree",
      "grado"
    ],
    [
      "contract",
      "contrarre"
    ],
    [
      "button",
      "bottone"
    ],
    [
      "super",
      "super"
    ],
    [
      "male",
      "maschio"
    ],
    [
      "matter",
      "causa"
    ],
    [
      "custom",
      "uso"
    ],
    [
      "asian",
      "asiatica"
    ],
    [
      "distribution",
      "diffusione"
    ],
    [
      "editor",
      "curatore"
    ],
    [
      "inn",
      "osteria"
    ],
    [
      "cause",
      "ottenere"
    ],
    [
      "song",
      "canto"
    ],
    [
      "focus",
      "su"
    ],
    [
      "late",
      "fu"
    ],
    [
      "fall",
      "cadere"
    ],
    [
      "featured",
      "definito"
    ],
    [
      "idea",
      "idea"
    ],
    [
      "female",
      "femmina"
    ],
    [
      "responsible",
      "colpevole"
    ],
    [
      "win",
      "guadagnare"
    ],
    [
      "reason",
      "ragione"
    ],
    [
      "tool",
      "strumento"
    ],
    [
      "spring",
      "molla"
    ],
    [
      "foundation",
      "fondamenta"
    ],
    [
      "voice",
      "voce"
    ],
    [
      "friendly",
      "gentile"
    ],
    [
      "schedule",
      "orario"
    ],
    [
      "communication",
      "comunicazione"
    ],
    [
      "purpose",
      "proposito"
    ],
    [
      "feature",
      "impersonare"
    ],
    [
      "bed",
      "letto"
    ],
    [
      "police",
      "forza pubblica"
    ],
    [
      "everyone",
      "ciascuno"
    ],
    [
      "approach",
      "approccio"
    ],
    [
      "brown",
      "bruno"
    ],
    [
      "hill",
      "colle"
    ],
    [
      "medicine",
      "clinica"
    ],
    [
      "deal",
      "tot"
    ],
    [
      "hold",
      "mantenere"
    ],
    [
      "glass",
      "bicchiere"
    ],
    [
      "happy",
      "felice"
    ],
    [
      "smith",
      "Ferri"
    ],
    [
      "safe",
      "sicuro"
    ],
    [
      "unique",
      "speciale"
    ],
    [
      "survey",
      "indagine"
    ],
    [
      "prior",
      "a priori"
    ],
    [
      "sport",
      "diporto"
    ],
    [
      "ready",
      "pronto"
    ],
    [
      "feed",
      "alimentare"
    ],
    [
      "animal",
      "bestia"
    ],
    [
      "population",
      "popolazione"
    ],
    [
      "pa",
      "papà"
    ],
    [
      "regular",
      "usuale"
    ],
    [
      "secure",
      "sicuro"
    ],
    [
      "navigation",
      "navigazione"
    ],
    [
      "therefore",
      "dunque"
    ],
    [
      "ass",
      "culo"
    ],
    [
      "simply",
      "in parole povere"
    ],
    [
      "evidence",
      "evidenza"
    ],
    [
      "station",
      "canale"
    ],
    [
      "christian",
      "cristiana"
    ],
    [
      "round",
      "salva"
    ],
    [
      "understand",
      "credere"
    ],
    [
      "master",
      "mastro"
    ],
    [
      "valley",
      "vallata"
    ],
    [
      "recently",
      "ultimamente"
    ],
    [
      "cut",
      "taglio"
    ],
    [
      "worldwide",
      "in tutto il mondo"
    ],
    [
      "improve",
      "migliorare"
    ],
    [
      "connection",
      "coincidenza"
    ],
    [
      "hall",
      "sala"
    ],
    [
      "earth",
      "terra"
    ],
    [
      "impact",
      "impatto"
    ],
    [
      "transfer",
      "trasferirsi"
    ],
    [
      "strong",
      "forte"
    ],
    [
      "wedding",
      "matrimonio"
    ],
    [
      "hospital",
      "nosocomio"
    ],
    [
      "ground",
      "terra"
    ],
    [
      "overview",
      "resoconto"
    ],
    [
      "ship",
      "ità"
    ],
    [
      "accommodation",
      "alloggio"
    ],
    [
      "disease",
      "morbo"
    ],
    [
      "excellent",
      "eccezionale"
    ],
    [
      "italy",
      "Stivale"
    ],
    [
      "hair",
      "capello"
    ],
    [
      "opportunity",
      "occasione"
    ],
    [
      "kit",
      "armamentario"
    ],
    [
      "basis",
      "base"
    ],
    [
      "command",
      "ordine"
    ],
    [
      "express",
      "dichiarare"
    ],
    [
      "award",
      "premio"
    ],
    [
      "peter",
      "pene"
    ],
    [
      "assessment",
      "valutazione"
    ],
    [
      "ensure",
      "garantire"
    ],
    [
      "thus",
      "dunque"
    ],
    [
      "wall",
      "muro"
    ],
    [
      "involved",
      "associato"
    ],
    [
      "extra",
      "straordinariamente"
    ],
    [
      "especially",
      "specie"
    ],
    [
      "interface",
      "interfaccia"
    ],
    [
      "pussy",
      "fica"
    ],
    [
      "budget",
      "budget"
    ],
    [
      "success",
      "riuscita"
    ],
    [
      "operation",
      "gestione"
    ],
    [
      "quite",
      "piuttosto"
    ],
    [
      "boy",
      "ragazzo"
    ],
    [
      "amazon",
      "Amazzoni"
    ],
    [
      "beautiful",
      "bel"
    ],
    [
      "warning",
      "monito"
    ],
    [
      "wine",
      "bere il vino"
    ],
    [
      "horse",
      "cavallo"
    ],
    [
      "forward",
      "diretto"
    ],
    [
      "significant",
      "significativo"
    ],
    [
      "owner",
      "proprietaria"
    ],
    [
      "son",
      "figliolo"
    ],
    [
      "rule",
      "sentenziare"
    ],
    [
      "housing",
      "scatola"
    ],
    [
      "trying",
      "difficile"
    ],
    [
      "mother",
      "mamma"
    ],
    [
      "traffic",
      "tratta"
    ],
    [
      "input",
      "ingresso"
    ],
    [
      "senior",
      "anziano"
    ],
    [
      "door",
      "anta"
    ],
    [
      "trial",
      "prova"
    ],
    [
      "charge",
      "carica"
    ],
    [
      "instead",
      "al posto di"
    ],
    [
      "cool",
      "figo"
    ],
    [
      "enterprise",
      "iniziativa"
    ],
    [
      "entire",
      "intera"
    ],
    [
      "educational",
      "istruttivo"
    ],
    [
      "leading",
      "primo"
    ],
    [
      "metal",
      "metallo"
    ],
    [
      "chinese",
      "cinese"
    ],
    [
      "opinion",
      "parere"
    ],
    [
      "football",
      "palla"
    ],
    [
      "abstract",
      "astratto"
    ],
    [
      "output",
      "uscita"
    ],
    [
      "likely",
      "adatto"
    ],
    [
      "develop",
      "sviluppare"
    ],
    [
      "resolution",
      "risolutezza"
    ],
    [
      "java",
      "Giava"
    ],
    [
      "guest",
      "ospite"
    ],
    [
      "publication",
      "rivista"
    ],
    [
      "pass",
      "approvare"
    ],
    [
      "trust",
      "credere"
    ],
    [
      "van",
      "vagone merci"
    ],
    [
      "session",
      "sessione"
    ],
    [
      "vacation",
      "feria"
    ],
    [
      "century",
      "centuria"
    ],
    [
      "skin",
      "interfaccia"
    ],
    [
      "indian",
      "indiana"
    ],
    [
      "ring",
      "anello"
    ],
    [
      "grade",
      "livello"
    ],
    [
      "mountain",
      "monte"
    ],
    [
      "vehicle",
      "mezzo"
    ],
    [
      "consider",
      "pensare"
    ],
    [
      "northern",
      "boreale"
    ],
    [
      "behind",
      "dopo"
    ],
    [
      "panel",
      "anta"
    ],
    [
      "floor",
      "stendere"
    ],
    [
      "german",
      "tedesca"
    ],
    [
      "match",
      "gara"
    ],
    [
      "default",
      "mora"
    ],
    [
      "require",
      "richiedere"
    ],
    [
      "outdoor",
      "fuori"
    ],
    [
      "deep",
      "spesso"
    ],
    [
      "morning",
      "mane"
    ],
    [
      "otherwise",
      "tuttavia"
    ],
    [
      "rest",
      "pace"
    ],
    [
      "hit",
      "valida"
    ],
    [
      "transportation",
      "mezzo"
    ],
    [
      "pool",
      "pozza"
    ],
    [
      "partner",
      "socio"
    ],
    [
      "fish",
      "pesca"
    ],
    [
      "membership",
      "iscrizione"
    ],
    [
      "eye",
      "cruna"
    ],
    [
      "string",
      "fila"
    ],
    [
      "sense",
      "senso"
    ],
    [
      "pack",
      "muta"
    ],
    [
      "stage",
      "fase"
    ],
    [
      "internal",
      "interno"
    ],
    [
      "goods",
      "beni"
    ],
    [
      "unless",
      "se non"
    ],
    [
      "japanese",
      "nipponico"
    ],
    [
      "race",
      "gara"
    ],
    [
      "background",
      "sfondo"
    ],
    [
      "target",
      "obiettivo"
    ],
    [
      "except",
      "salvo"
    ],
    [
      "character",
      "carattere"
    ],
    [
      "maintenance",
      "mantenimento"
    ],
    [
      "ability",
      "abilità"
    ],
    [
      "maybe",
      "chissà"
    ],
    [
      "pretty",
      "carino"
    ],
    [
      "yourself",
      "te stesso"
    ],
    [
      "rape",
      "violare"
    ],
    [
      "battery",
      "pila"
    ],
    [
      "youth",
      "giovane"
    ],
    [
      "pressure",
      "urgenza"
    ],
    [
      "debt",
      "buffo"
    ],
    [
      "medium",
      "mezzo"
    ],
    [
      "television",
      "tivù"
    ],
    [
      "core",
      "nucleo"
    ],
    [
      "break",
      "rompere"
    ],
    [
      "throughout",
      "in ogni parte"
    ],
    [
      "dance",
      "ballo"
    ],
    [
      "wood",
      "bosco"
    ],
    [
      "itself",
      "sé"
    ],
    [
      "fee",
      "quota"
    ],
    [
      "studio",
      "monolocale"
    ],
    [
      "reader",
      "lettrice"
    ],
    [
      "device",
      "beffa"
    ],
    [
      "established",
      "stabilito"
    ],
    [
      "rent",
      "pigione"
    ],
    [
      "dark",
      "oscuro"
    ],
    [
      "apple",
      "pomo"
    ],
    [
      "enjoy",
      "gioire"
    ],
    [
      "remove",
      "levare"
    ],
    [
      "aid",
      "aiuto"
    ],
    [
      "surface",
      "venire a galla"
    ],
    [
      "host",
      "ostia"
    ],
    [
      "manual",
      "guida"
    ],
    [
      "block",
      "blocco"
    ],
    [
      "fair",
      "equa"
    ],
    [
      "fixed",
      "castrato"
    ],
    [
      "wrong",
      "sbagliato"
    ],
    [
      "finally",
      "infine"
    ],
    [
      "desktop",
      "computer fisso"
    ],
    [
      "paris",
      "Paride"
    ],
    [
      "capacity",
      "resistenza"
    ],
    [
      "jersey",
      "maglia"
    ],
    [
      "fat",
      "obeso"
    ],
    [
      "fully",
      "appieno"
    ],
    [
      "father",
      "papà"
    ],
    [
      "electric",
      "elettronico"
    ],
    [
      "saw",
      "adagio"
    ],
    [
      "officer",
      "ufficiale"
    ],
    [
      "driver",
      "guidatore"
    ],
    [
      "respect",
      "materia"
    ],
    [
      "unknown",
      "ignoto"
    ],
    [
      "trip",
      "gita"
    ],
    [
      "worth",
      "degno"
    ],
    [
      "poor",
      "povero"
    ],
    [
      "teacher",
      "aio"
    ],
    [
      "relationship",
      "legame"
    ],
    [
      "farm",
      "podere"
    ],
    [
      "fucking",
      "cazzo di"
    ],
    [
      "georgia",
      "Giorgia"
    ],
    [
      "peace",
      "pace"
    ],
    [
      "traditional",
      "comune"
    ],
    [
      "tom",
      "maschio"
    ],
    [
      "creative",
      "creativa"
    ],
    [
      "coast",
      "costiera"
    ],
    [
      "benefit",
      "aiuto"
    ],
    [
      "progress",
      "progredire"
    ],
    [
      "lord",
      "nobile"
    ],
    [
      "grant",
      "concessione"
    ],
    [
      "agree",
      "concordare"
    ],
    [
      "hear",
      "udire"
    ],
    [
      "sometimes",
      "a volte"
    ],
    [
      "beyond",
      "oltre"
    ],
    [
      "fan",
      "tifo"
    ],
    [
      "transport",
      "porto"
    ],
    [
      "wife",
      "sposa"
    ],
    [
      "former",
      "ex"
    ],
    [
      "implementation",
      "attuazione"
    ],
    [
      "complex",
      "complesso"
    ],
    [
      "th",
      "to"
    ],
    [
      "cat",
      "gatto"
    ],
    [
      "die",
      "matrice"
    ],
    [
      "jack",
      "presa elettrica"
    ],
    [
      "flat",
      "piatto"
    ],
    [
      "flow",
      "flusso"
    ],
    [
      "parent",
      "genitrice"
    ],
    [
      "spanish",
      "castigliano"
    ],
    [
      "michigan",
      "Micigan"
    ],
    [
      "columbia",
      "Columbia"
    ],
    [
      "setting",
      "contesto"
    ],
    [
      "dr",
      "dr."
    ],
    [
      "scale",
      "gamma"
    ],
    [
      "stand",
      "sostare"
    ],
    [
      "economy",
      "economia"
    ],
    [
      "helpful",
      "d'aiuto"
    ],
    [
      "monthly",
      "mensile"
    ],
    [
      "critical",
      "critico"
    ],
    [
      "frame",
      "telaio"
    ],
    [
      "definition",
      "definizione"
    ],
    [
      "secretary",
      "segretario"
    ],
    [
      "path",
      "camino"
    ],
    [
      "australian",
      "australiana"
    ],
    [
      "chief",
      "capo"
    ],
    [
      "bottom",
      "sedere"
    ],
    [
      "detail",
      "minuzia"
    ],
    [
      "pet",
      "cocco"
    ],
    [
      "begin",
      "iniziare"
    ],
    [
      "royal",
      "regale"
    ],
    [
      "clean",
      "puro"
    ],
    [
      "switch",
      "verga"
    ],
    [
      "russian",
      "russa"
    ],
    [
      "african",
      "africana"
    ],
    [
      "guy",
      "Vito"
    ],
    [
      "relevant",
      "prevalente"
    ],
    [
      "connect",
      "cablare"
    ],
    [
      "cup",
      "coppa"
    ],
    [
      "basket",
      "canestro"
    ],
    [
      "installation",
      "insediamento"
    ],
    [
      "demand",
      "bisogno"
    ],
    [
      "square",
      "quadrato"
    ],
    [
      "attention",
      "allerta"
    ],
    [
      "advance",
      "avanzare"
    ],
    [
      "skip",
      "balzare"
    ],
    [
      "auction",
      "mettere all'asta"
    ],
    [
      "gear",
      "cambio"
    ],
    [
      "correct",
      "esatto"
    ],
    [
      "nation",
      "nazione"
    ],
    [
      "piece",
      "pezzo"
    ],
    [
      "sheet",
      "scotta"
    ],
    [
      "resort",
      "villagio turistico"
    ],
    [
      "random",
      "nullità"
    ],
    [
      "certificate",
      "attestato"
    ],
    [
      "motion",
      "mozione"
    ],
    [
      "fashion",
      "moda"
    ],
    [
      "monitor",
      "schermo"
    ],
    [
      "forest",
      "bosco"
    ],
    [
      "couple",
      "paio"
    ],
    [
      "chance",
      "caso"
    ],
    [
      "vision",
      "visione"
    ],
    [
      "ball",
      "palla"
    ],
    [
      "ending",
      "fine"
    ],
    [
      "listen",
      "dare"
    ],
    [
      "discuss",
      "dibattere"
    ],
    [
      "accept",
      "ammettere"
    ],
    [
      "naked",
      "ignudo"
    ],
    [
      "goal",
      "rete"
    ],
    [
      "successful",
      "di successo"
    ],
    [
      "wind",
      "peto"
    ],
    [
      "situation",
      "posizione"
    ],
    [
      "currency",
      "moneta"
    ],
    [
      "determine",
      "capire"
    ],
    [
      "temperature",
      "febbre"
    ],
    [
      "palm",
      "palma"
    ],
    [
      "actual",
      "reale"
    ],
    [
      "stone",
      "pietra"
    ],
    [
      "bob",
      "ondeggiare"
    ],
    [
      "fit",
      "andare bene"
    ],
    [
      "village",
      "borgo"
    ],
    [
      "amateur",
      "amatore"
    ],
    [
      "ex",
      "ex"
    ],
    [
      "pain",
      "pena"
    ],
    [
      "particularly",
      "in particolare"
    ],
    [
      "coffee",
      "caffè"
    ],
    [
      "cum",
      "sborrare"
    ],
    [
      "buyer",
      "cliente"
    ],
    [
      "easily",
      "facilmente"
    ],
    [
      "poster",
      "locandina"
    ],
    [
      "edge",
      "filo"
    ],
    [
      "functional",
      "funzionale"
    ],
    [
      "root",
      "scopare"
    ],
    [
      "ice",
      "freddare"
    ],
    [
      "pink",
      "rosa"
    ],
    [
      "balance",
      "saldo"
    ],
    [
      "graduate",
      "laureato"
    ],
    [
      "shot",
      "tiro"
    ],
    [
      "label",
      "bollare"
    ],
    [
      "recommend",
      "consigliare"
    ],
    [
      "canon",
      "canonico"
    ],
    [
      "waste",
      "scarto"
    ],
    [
      "minute",
      "attimo"
    ],
    [
      "bus",
      "autobus"
    ],
    [
      "optional",
      "opzionale"
    ],
    [
      "dictionary",
      "lessico"
    ],
    [
      "cold",
      "freddo"
    ],
    [
      "accounting",
      "bilancio"
    ],
    [
      "chair",
      "seggiola"
    ],
    [
      "effort",
      "fatica"
    ],
    [
      "phase",
      "fase"
    ],
    [
      "bag",
      "borsa"
    ],
    [
      "fantasy",
      "fantasia"
    ],
    [
      "motor",
      "auto"
    ],
    [
      "install",
      "istallare"
    ],
    [
      "shirt",
      "maglia"
    ],
    [
      "generally",
      "in genere"
    ],
    [
      "foot",
      "piede"
    ],
    [
      "mass",
      "messa"
    ],
    [
      "crime",
      "reato"
    ],
    [
      "count",
      "conte"
    ],
    [
      "breast",
      "seno"
    ],
    [
      "quickly",
      "velocemente"
    ],
    [
      "claim",
      "vantare"
    ],
    [
      "surgery",
      "ambulatorio"
    ],
    [
      "patch",
      "pezza"
    ],
    [
      "heat",
      "caldo"
    ],
    [
      "wild",
      "selvaggio"
    ],
    [
      "miss",
      "mancare"
    ],
    [
      "doctor",
      "Dottore"
    ],
    [
      "task",
      "attività"
    ],
    [
      "reduce",
      "ridurre"
    ],
    [
      "enable",
      "attivare"
    ],
    [
      "exercise",
      "allenarsi"
    ],
    [
      "bug",
      "microspia"
    ],
    [
      "guarantee",
      "garante"
    ],
    [
      "leader",
      "duce"
    ],
    [
      "diamond",
      "quadri"
    ],
    [
      "soft",
      "morbido"
    ],
    [
      "alone",
      "soltanto"
    ],
    [
      "flight",
      "fuga"
    ],
    [
      "fuel",
      "fomentare"
    ],
    [
      "walk",
      "sodare"
    ],
    [
      "fuck",
      "scopare"
    ],
    [
      "italian",
      "italiana"
    ],
    [
      "wait",
      "attendere"
    ],
    [
      "pocket",
      "sacca"
    ],
    [
      "saint",
      "Santa"
    ],
    [
      "rose",
      "rosa"
    ],
    [
      "argument",
      "argomento"
    ],
    [
      "competition",
      "gara"
    ],
    [
      "joint",
      "articolazione"
    ],
    [
      "fresh",
      "nuovo"
    ],
    [
      "factor",
      "scomporre"
    ],
    [
      "stream",
      "rivo"
    ],
    [
      "pick",
      "scelta"
    ],
    [
      "hearing",
      "udienza"
    ],
    [
      "serious",
      "grave"
    ],
    [
      "prime",
      "primo"
    ],
    [
      "limit",
      "limite"
    ],
    [
      "louis",
      "Ludovico"
    ],
    [
      "bondage",
      "bondage"
    ],
    [
      "creek",
      "rivo"
    ],
    [
      "quantity",
      "numero"
    ],
    [
      "essential",
      "essenziale"
    ],
    [
      "platform",
      "piattaforma"
    ],
    [
      "load",
      "sacco"
    ],
    [
      "immediately",
      "subito"
    ],
    [
      "heavy",
      "guardiano"
    ],
    [
      "recovery",
      "ricupero"
    ],
    [
      "joe",
      "Pino"
    ],
    [
      "cock",
      "cane"
    ],
    [
      "merchant",
      "mercante"
    ],
    [
      "comprehensive",
      "esaustivo"
    ],
    [
      "expert",
      "abile"
    ],
    [
      "drop",
      "salto"
    ],
    [
      "solid",
      "tinta unita"
    ],
    [
      "orange",
      "arancia"
    ],
    [
      "compliance",
      "arrendevolezza"
    ],
    [
      "prevent",
      "impedire"
    ],
    [
      "marine",
      "marittimo"
    ],
    [
      "improvement",
      "salto di qualità"
    ],
    [
      "finding",
      "riscontro"
    ],
    [
      "pennsylvania",
      "Pensilvania"
    ],
    [
      "saying",
      "massima"
    ],
    [
      "challenge",
      "sfida"
    ],
    [
      "seem",
      "parere"
    ],
    [
      "touch",
      "tatto"
    ],
    [
      "intended",
      "previsto"
    ],
    [
      "hire",
      "assumere"
    ],
    [
      "suggest",
      "proporre"
    ],
    [
      "branch",
      "ramo"
    ],
    [
      "serve",
      "servire"
    ],
    [
      "smart",
      "brillante"
    ],
    [
      "latin",
      "latino"
    ],
    [
      "avoid",
      "evitare"
    ],
    [
      "manage",
      "dirigere"
    ],
    [
      "corner",
      "sporgenza"
    ],
    [
      "rank",
      "rango"
    ],
    [
      "computing",
      "informatica"
    ],
    [
      "element",
      "elemento"
    ],
    [
      "birth",
      "parto"
    ],
    [
      "abuse",
      "insultare"
    ],
    [
      "separate",
      "dividere"
    ],
    [
      "quarter",
      "trimestre"
    ],
    [
      "procedure",
      "procedura"
    ],
    [
      "leadership",
      "carisma"
    ],
    [
      "define",
      "definire"
    ],
    [
      "breakfast",
      "asciolvere"
    ],
    [
      "column",
      "cronaca"
    ],
    [
      "faith",
      "fiducia"
    ],
    [
      "chain",
      "concatenare"
    ],
    [
      "developer",
      "sviluppatore"
    ],
    [
      "identify",
      "individuare"
    ],
    [
      "avenue",
      "corso"
    ],
    [
      "missing",
      "disperso"
    ],
    [
      "approximately",
      "circa"
    ],
    [
      "reach",
      "raggiungere"
    ],
    [
      "comparison",
      "paragone"
    ],
    [
      "mental",
      "pazzo"
    ],
    [
      "moment",
      "attimo"
    ],
    [
      "sequence",
      "sequenza"
    ],
    [
      "attack",
      "attaccare"
    ],
    [
      "sorry",
      "scusa"
    ],
    [
      "opening",
      "sigla"
    ],
    [
      "damage",
      "rovinare"
    ],
    [
      "plastic",
      "plastica"
    ],
    [
      "produce",
      "fornire"
    ],
    [
      "snow",
      "neve"
    ],
    [
      "truth",
      "verità"
    ],
    [
      "counter",
      "bancone"
    ],
    [
      "failure",
      "fiasco"
    ],
    [
      "weekend",
      "weekend"
    ],
    [
      "camp",
      "circolo"
    ],
    [
      "bridge",
      "ponte"
    ],
    [
      "native",
      "nativo"
    ],
    [
      "fill",
      "riempire"
    ],
    [
      "baseball",
      "pallabase"
    ],
    [
      "approval",
      "plauso"
    ],
    [
      "draft",
      "leva"
    ],
    [
      "chart",
      "carta nautica"
    ],
    [
      "equal",
      "pari"
    ],
    [
      "adventure",
      "rischio"
    ],
    [
      "profit",
      "guadagnare"
    ],
    [
      "variable",
      "variabile"
    ],
    [
      "advertisement",
      "annuncio"
    ],
    [
      "expect",
      "pensare"
    ],
    [
      "determined",
      "determinato"
    ],
    [
      "wholesale",
      "ingrosso"
    ],
    [
      "workshop",
      "workshop"
    ],
    [
      "extension",
      "proroga"
    ],
    [
      "golden",
      "dorato"
    ],
    [
      "completely",
      "pienamente"
    ],
    [
      "fort",
      "forte"
    ],
    [
      "funny",
      "buffa"
    ],
    [
      "brother",
      "fratello"
    ],
    [
      "pattern",
      "forma"
    ],
    [
      "boat",
      "full"
    ],
    [
      "dedicated",
      "apposito"
    ],
    [
      "direction",
      "direzione"
    ],
    [
      "basketball",
      "basket"
    ],
    [
      "delete",
      "cancellare"
    ],
    [
      "assembly",
      "assemblea"
    ],
    [
      "mouse",
      "mouse"
    ],
    [
      "signal",
      "campo"
    ],
    [
      "criminal",
      "criminale"
    ],
    [
      "brain",
      "cervella"
    ],
    [
      "powerful",
      "efficace"
    ],
    [
      "false",
      "falso"
    ],
    [
      "cast",
      "gettare"
    ],
    [
      "soul",
      "anima"
    ],
    [
      "aids",
      "SIDA"
    ],
    [
      "promote",
      "sostenere"
    ],
    [
      "hawaii",
      "Hawaii"
    ],
    [
      "flag",
      "bandiera"
    ],
    [
      "advantage",
      "beneficio"
    ],
    [
      "hello",
      "ciao"
    ],
    [
      "graphic",
      "crudo"
    ],
    [
      "binding",
      "legame"
    ],
    [
      "iron",
      "ferro"
    ],
    [
      "straight",
      "dritto"
    ],
    [
      "script",
      "scrittura"
    ],
    [
      "void",
      "vuoto"
    ],
    [
      "alert",
      "allerta"
    ],
    [
      "tag",
      "marcare"
    ],
    [
      "interview",
      "colloquio"
    ],
    [
      "mix",
      "mixare"
    ],
    [
      "framework",
      "struttura portante"
    ],
    [
      "queen",
      "donna"
    ],
    [
      "clearly",
      "certamente"
    ],
    [
      "fix",
      "dose"
    ],
    [
      "handle",
      "gestire"
    ],
    [
      "sweet",
      "dolce"
    ],
    [
      "vice",
      "pecca"
    ],
    [
      "truck",
      "camion"
    ],
    [
      "behavior",
      "condotta"
    ],
    [
      "ray",
      "raggio"
    ],
    [
      "frequently",
      "spesso"
    ],
    [
      "measure",
      "misura"
    ],
    [
      "duty",
      "dazio"
    ],
    [
      "bear",
      "portare"
    ],
    [
      "gain",
      "guadagno"
    ],
    [
      "festival",
      "sagra"
    ],
    [
      "lack",
      "carenza"
    ],
    [
      "whatever",
      "checché"
    ],
    [
      "train",
      "treno"
    ],
    [
      "dry",
      "secco"
    ],
    [
      "explore",
      "esplorare"
    ],
    [
      "concept",
      "ipotesi"
    ],
    [
      "nearly",
      "circa"
    ],
    [
      "eligible",
      "idoneo"
    ],
    [
      "handling",
      "gestione"
    ],
    [
      "origin",
      "origini"
    ],
    [
      "billion",
      "bilione"
    ],
    [
      "destination",
      "destinazione"
    ],
    [
      "faster",
      "digiunatrice"
    ],
    [
      "con",
      "carcerato"
    ],
    [
      "route",
      "via"
    ],
    [
      "broken",
      "rotto"
    ],
    [
      "frank",
      "franca"
    ],
    [
      "alaska",
      "Alasca"
    ],
    [
      "zoom",
      "ingrandimento"
    ],
    [
      "blow",
      "botta"
    ],
    [
      "battle",
      "lotta"
    ],
    [
      "speak",
      "parlare"
    ],
    [
      "query",
      "interrogarsi"
    ],
    [
      "partnership",
      "società"
    ],
    [
      "equity",
      "equità"
    ],
    [
      "speech",
      "discorso"
    ],
    [
      "wire",
      "cavo"
    ],
    [
      "replacement",
      "rimpiazzo"
    ],
    [
      "tape",
      "audiocassetta"
    ],
    [
      "judge",
      "arbitro"
    ],
    [
      "acid",
      "acido"
    ],
    [
      "cent",
      "soldino"
    ],
    [
      "fight",
      "lottare"
    ],
    [
      "apartment",
      "alloggio"
    ],
    [
      "height",
      "cima"
    ],
    [
      "zero",
      "senza"
    ],
    [
      "speaker",
      "relatore"
    ],
    [
      "netherlands",
      "Olanda"
    ],
    [
      "obtain",
      "avere"
    ],
    [
      "designer",
      "progettista"
    ],
    [
      "remain",
      "stare"
    ],
    [
      "marriage",
      "nozze"
    ],
    [
      "roll",
      "rotolo"
    ],
    [
      "bath",
      "bagno"
    ],
    [
      "negative",
      "negativa"
    ],
    [
      "perform",
      "recitare"
    ],
    [
      "healthy",
      "sano"
    ],
    [
      "translation",
      "traduzione"
    ],
    [
      "font",
      "pila"
    ],
    [
      "assets",
      "cespite"
    ],
    [
      "injury",
      "danno"
    ],
    [
      "lawyer",
      "legale"
    ],
    [
      "married",
      "sposata"
    ],
    [
      "proposal",
      "accordo"
    ],
    [
      "portal",
      "portale"
    ],
    [
      "waiting",
      "attesa"
    ],
    [
      "birthday",
      "compleanno"
    ],
    [
      "fail",
      "fallire"
    ],
    [
      "toward",
      "per"
    ],
    [
      "assist",
      "aiuto"
    ],
    [
      "conduct",
      "dirigere"
    ],
    [
      "lingerie",
      "biancheria"
    ],
    [
      "legislation",
      "leggi"
    ],
    [
      "calling",
      "vocazione"
    ],
    [
      "serving",
      "porzione"
    ],
    [
      "wear",
      "usura"
    ],
    [
      "ultimate",
      "finale"
    ],
    [
      "finish",
      "fine"
    ],
    [
      "rare",
      "al sangue"
    ],
    [
      "extreme",
      "estremo"
    ],
    [
      "row",
      "lite"
    ],
    [
      "forecast",
      "pronosticare"
    ],
    [
      "administrator",
      "amministratrice"
    ],
    [
      "cycle",
      "ciclo"
    ],
    [
      "accuracy",
      "acribia"
    ],
    [
      "dual",
      "doppio"
    ],
    [
      "rise",
      "salire"
    ],
    [
      "sleep",
      "cispa"
    ],
    [
      "bird",
      "uccello"
    ],
    [
      "creation",
      "creato"
    ],
    [
      "hunter",
      "cercatore"
    ],
    [
      "lady",
      "dama"
    ],
    [
      "famous",
      "celebre"
    ],
    [
      "writer",
      "autore"
    ],
    [
      "drink",
      "bere"
    ],
    [
      "academy",
      "seminario"
    ],
    [
      "gender",
      "genere"
    ],
    [
      "eat",
      "mangiare"
    ],
    [
      "permanent",
      "fisso"
    ],
    [
      "portfolio",
      "portafoglio"
    ],
    [
      "practical",
      "reale"
    ],
    [
      "exclusive",
      "esclusorio"
    ],
    [
      "seat",
      "seduta"
    ],
    [
      "vendor",
      "venditrice"
    ],
    [
      "originally",
      "originalmente"
    ],
    [
      "regulation",
      "regola"
    ],
    [
      "reduction",
      "sgravio"
    ],
    [
      "aim",
      "scopo"
    ],
    [
      "toll",
      "dazio"
    ],
    [
      "cape",
      "cappa"
    ],
    [
      "meaning",
      "senso"
    ],
    [
      "tip",
      "dritta"
    ],
    [
      "secondary",
      "secondaria"
    ],
    [
      "wonderful",
      "favoloso"
    ],
    [
      "mine",
      "mina"
    ],
    [
      "ticket",
      "multa"
    ],
    [
      "guess",
      "azzeccare"
    ],
    [
      "whom",
      "cui"
    ],
    [
      "import",
      "introdurre"
    ],
    [
      "presence",
      "cospetto"
    ],
    [
      "instant",
      "attimo"
    ],
    [
      "majority",
      "maggioranza"
    ],
    [
      "christ",
      "porcodio"
    ],
    [
      "ahead",
      "avanti"
    ],
    [
      "moon",
      "luna"
    ],
    [
      "scheme",
      "schema"
    ],
    [
      "utility",
      "attrezzo"
    ],
    [
      "preview",
      "assaggio"
    ],
    [
      "fly",
      "volare"
    ],
    [
      "manner",
      "maniera"
    ],
    [
      "amendment",
      "aggiunta"
    ],
    [
      "despite",
      "sebbene"
    ],
    [
      "strength",
      "forza"
    ],
    [
      "turkey",
      "tacchina"
    ],
    [
      "proper",
      "adatto"
    ],
    [
      "fear",
      "timore"
    ],
    [
      "principal",
      "preside"
    ],
    [
      "standing",
      "posizione"
    ],
    [
      "voyeur",
      "voyeur"
    ],
    [
      "comfort",
      "agio"
    ],
    [
      "appeal",
      "appello"
    ],
    [
      "bonus",
      "extra"
    ],
    [
      "previously",
      "precedentemente"
    ],
    [
      "hey",
      "ou"
    ],
    [
      "beat",
      "ritmo"
    ],
    [
      "disney",
      "Disneyland"
    ],
    [
      "household",
      "domestico"
    ],
    [
      "smoking",
      "fumare"
    ],
    [
      "bbc",
      "SBR"
    ],
    [
      "tea",
      "tè"
    ],
    [
      "achieve",
      "portare"
    ],
    [
      "dress",
      "vestirsi"
    ],
    [
      "subscription",
      "sottoscrizione"
    ],
    [
      "dealer",
      "piazzista"
    ],
    [
      "contemporary",
      "coevo"
    ],
    [
      "sky",
      "cielo"
    ],
    [
      "rom",
      "zingaro"
    ],
    [
      "happen",
      "accadere"
    ],
    [
      "exposure",
      "posa"
    ],
    [
      "hide",
      "nascondere"
    ],
    [
      "gambling",
      "giochi d'azzardo"
    ],
    [
      "refer",
      "fare capo"
    ],
    [
      "miller",
      "Mugnai"
    ],
    [
      "provision",
      "disposizione"
    ],
    [
      "outdoors",
      "all'aperto"
    ],
    [
      "clothes",
      "abbigliamento"
    ],
    [
      "certainly",
      "certamente"
    ],
    [
      "indeed",
      "già"
    ],
    [
      "newspaper",
      "quotidiano"
    ],
    [
      "toy",
      "giocherellare"
    ],
    [
      "slow",
      "lenta"
    ],
    [
      "removal",
      "eliminazione"
    ],
    [
      "hip",
      "fianco"
    ],
    [
      "mostly",
      "soprattutto"
    ],
    [
      "spot",
      "area"
    ],
    [
      "taylor",
      "Sarto"
    ],
    [
      "spend",
      "passare"
    ],
    [
      "factory",
      "impianto"
    ],
    [
      "interior",
      "interiore"
    ],
    [
      "grow",
      "crescere"
    ],
    [
      "promotion",
      "progresso"
    ],
    [
      "relative",
      "congiunta"
    ],
    [
      "amazing",
      "formidabile"
    ],
    [
      "clock",
      "odometro"
    ],
    [
      "dot",
      "punto"
    ],
    [
      "hiv",
      "VIU"
    ],
    [
      "feeling",
      "senso"
    ],
    [
      "hidden",
      "recondito"
    ],
    [
      "reasonable",
      "moderato"
    ],
    [
      "victoria",
      "Vittoria"
    ],
    [
      "relief",
      "rilievo"
    ],
    [
      "influence",
      "influire"
    ],
    [
      "ratio",
      "ragione"
    ],
    [
      "rain",
      "pioggia"
    ],
    [
      "permit",
      "autorizzare"
    ],
    [
      "proof",
      "dimostrazione"
    ],
    [
      "dna",
      "ADN"
    ],
    [
      "bass",
      "branzino"
    ],
    [
      "prescription",
      "norma"
    ],
    [
      "bedroom",
      "camera"
    ],
    [
      "empty",
      "svuotare"
    ],
    [
      "hole",
      "buco"
    ],
    [
      "ride",
      "guidare"
    ],
    [
      "specifically",
      "in modo particolare"
    ],
    [
      "bureau",
      "comò"
    ],
    [
      "represent",
      "ripresentare"
    ],
    [
      "pair",
      "coppia"
    ],
    [
      "don",
      "mettere"
    ],
    [
      "dinner",
      "cena"
    ],
    [
      "stress",
      "enfatizzare"
    ],
    [
      "cream",
      "panna"
    ],
    [
      "runs",
      "cagotto"
    ],
    [
      "yeah",
      "sì"
    ],
    [
      "discover",
      "discoprire"
    ],
    [
      "louisiana",
      "Luigiana"
    ],
    [
      "fourth",
      "quarta"
    ],
    [
      "advisor",
      "consigliera"
    ],
    [
      "evil",
      "malevolo"
    ],
    [
      "aware",
      "all'erta"
    ],
    [
      "shape",
      "forma"
    ],
    [
      "irish",
      "gaelico"
    ],
    [
      "remains",
      "resti"
    ],
    [
      "concerned",
      "interessato"
    ],
    [
      "usage",
      "usi"
    ],
    [
      "cap",
      "capsula"
    ],
    [
      "ink",
      "firmare"
    ],
    [
      "census",
      "censo"
    ],
    [
      "peak",
      "cima"
    ],
    [
      "wheel",
      "roteare"
    ],
    [
      "transit",
      "passaggio"
    ],
    [
      "dick",
      "cazzo"
    ],
    [
      "salt",
      "sale"
    ],
    [
      "bell",
      "campana"
    ],
    [
      "preparation",
      "preparativo"
    ],
    [
      "attempt",
      "sforzo"
    ],
    [
      "noise",
      "rumore"
    ],
    [
      "forget",
      "dimenticare"
    ],
    [
      "array",
      "gamma"
    ],
    [
      "accurate",
      "esatto"
    ],
    [
      "pin",
      "inchiodare"
    ],
    [
      "alcohol",
      "alcool"
    ],
    [
      "greek",
      "greca"
    ],
    [
      "instruction",
      "manuale"
    ],
    [
      "sister",
      "suor"
    ],
    [
      "raw",
      "aperta"
    ],
    [
      "explain",
      "chiosare"
    ],
    [
      "establish",
      "fondare"
    ],
    [
      "gnu",
      "kokoon"
    ],
    [
      "extent",
      "misura"
    ],
    [
      "sharp",
      "acuto"
    ],
    [
      "lane",
      "corsia"
    ],
    [
      "kill",
      "preda"
    ],
    [
      "compensation",
      "paga"
    ],
    [
      "conflict",
      "conflitto"
    ],
    [
      "employer",
      "datrice di lavoro"
    ],
    [
      "occur",
      "sovvenire"
    ],
    [
      "concern",
      "impresa"
    ],
    [
      "backup",
      "sostituto"
    ],
    [
      "heritage",
      "eredità"
    ],
    [
      "immediate",
      "diretto"
    ],
    [
      "trouble",
      "problema"
    ],
    [
      "spread",
      "diffondere"
    ],
    [
      "coach",
      "vettura"
    ],
    [
      "agricultural",
      "agrario"
    ],
    [
      "expand",
      "espandersi"
    ],
    [
      "audience",
      "udienza"
    ],
    [
      "jordan",
      "Giordano"
    ],
    [
      "participate",
      "partecipare"
    ],
    [
      "plug",
      "tappo"
    ],
    [
      "cook",
      "cuoca"
    ],
    [
      "affect",
      "colpire"
    ],
    [
      "affected",
      "lezioso"
    ],
    [
      "bike",
      "puttana"
    ],
    [
      "totally",
      "totalmente"
    ],
    [
      "plate",
      "placca"
    ],
    [
      "indicate",
      "mostrare"
    ],
    [
      "proceedings",
      "resoconto"
    ],
    [
      "favourite",
      "amato"
    ],
    [
      "lose",
      "perdere"
    ],
    [
      "organic",
      "organico"
    ],
    [
      "seek",
      "cercare"
    ],
    [
      "tony",
      "Tony"
    ],
    [
      "neighborhood",
      "quartiere"
    ],
    [
      "thailand",
      "Tailandia"
    ],
    [
      "agenda",
      "ordine del giorno"
    ],
    [
      "anyway",
      "comunque"
    ],
    [
      "logic",
      "logica"
    ],
    [
      "template",
      "sagoma"
    ],
    [
      "circle",
      "circolo"
    ],
    [
      "soil",
      "terra"
    ],
    [
      "anywhere",
      "ovunque"
    ],
    [
      "wet",
      "piovoso"
    ],
    [
      "edward",
      "Eduardo"
    ],
    [
      "investor",
      "investitrice"
    ],
    [
      "ram",
      "ariete"
    ],
    [
      "wildlife",
      "fauna selvatica"
    ],
    [
      "fox",
      "ingannare"
    ],
    [
      "respond",
      "corrispondere"
    ],
    [
      "plain",
      "in bianco"
    ],
    [
      "arm",
      "ramo"
    ],
    [
      "launch",
      "varare"
    ],
    [
      "wave",
      "gesto"
    ],
    [
      "holy",
      "santo"
    ],
    [
      "guidance",
      "guida"
    ],
    [
      "mesh",
      "maglia"
    ],
    [
      "trail",
      "pista"
    ],
    [
      "enforcement",
      "rispetto"
    ],
    [
      "highway",
      "via maestra"
    ],
    [
      "buddy",
      "capo"
    ],
    [
      "hardcover",
      "libro con copertina rigida"
    ],
    [
      "setup",
      "assetto"
    ],
    [
      "poll",
      "tagliare"
    ],
    [
      "bond",
      "legame"
    ],
    [
      "blues",
      "paturnie"
    ],
    [
      "chocolate",
      "cioccolata"
    ],
    [
      "pub",
      "pub"
    ],
    [
      "scope",
      "scopo"
    ],
    [
      "supplier",
      "venditore"
    ],
    [
      "cotton",
      "cotone"
    ],
    [
      "bluetooth",
      "bluetooth"
    ],
    [
      "requirement",
      "richiesta"
    ],
    [
      "dental",
      "dentale"
    ],
    [
      "border",
      "orlo"
    ],
    [
      "debate",
      "decidere"
    ],
    [
      "pregnancy",
      "gestazione"
    ],
    [
      "leisure",
      "agio"
    ],
    [
      "learned",
      "colto"
    ],
    [
      "notebook",
      "blocco"
    ],
    [
      "historic",
      "storica"
    ],
    [
      "husband",
      "sposo"
    ],
    [
      "disabled",
      "disabile"
    ],
    [
      "crazy",
      "folle"
    ],
    [
      "upcoming",
      "imminente"
    ],
    [
      "concert",
      "concertare"
    ],
    [
      "efficiency",
      "efficienza"
    ],
    [
      "efficient",
      "efficiente"
    ],
    [
      "commitment",
      "dedizione"
    ],
    [
      "hop",
      "luppolo"
    ],
    [
      "constant",
      "continuo"
    ],
    [
      "visa",
      "vista"
    ],
    [
      "mouth",
      "foce"
    ],
    [
      "jewish",
      "giudeo"
    ],
    [
      "meter",
      "metro"
    ],
    [
      "gun",
      "obice"
    ],
    [
      "reflect",
      "riflettere"
    ],
    [
      "pure",
      "mero"
    ],
    [
      "deliver",
      "consegnare"
    ],
    [
      "wonder",
      "chiedersi"
    ],
    [
      "fruit",
      "frutto"
    ],
    [
      "reform",
      "correggere"
    ],
    [
      "lens",
      "lente"
    ],
    [
      "discovery",
      "scoperta"
    ],
    [
      "draw",
      "estrarre"
    ],
    [
      "classified",
      "segreto"
    ],
    [
      "assume",
      "assumere"
    ],
    [
      "confidence",
      "fiducia"
    ],
    [
      "alliance",
      "alleanza"
    ],
    [
      "confirm",
      "cresimare"
    ],
    [
      "warm",
      "ardente"
    ],
    [
      "neither",
      "manco"
    ],
    [
      "engineer",
      "ingegnera"
    ],
    [
      "consistent",
      "coerente"
    ],
    [
      "replace",
      "riporre"
    ],
    [
      "clearance",
      "luce"
    ],
    [
      "inventory",
      "inventario"
    ],
    [
      "suck",
      "suggere"
    ],
    [
      "blowjob",
      "pompa"
    ],
    [
      "objective",
      "obiettivo"
    ],
    [
      "crew",
      "folla"
    ],
    [
      "stick",
      "barretta"
    ],
    [
      "relation",
      "parente"
    ],
    [
      "slide",
      "frana"
    ],
    [
      "volunteer",
      "volontaria"
    ],
    [
      "rear",
      "retro"
    ],
    [
      "enhance",
      "avanzare"
    ],
    [
      "exact",
      "preciso"
    ],
    [
      "bound",
      "diretto"
    ],
    [
      "lock",
      "chiusa"
    ],
    [
      "storm",
      "tempesta"
    ],
    [
      "bowl",
      "tazza"
    ],
    [
      "supreme",
      "suprema"
    ],
    [
      "tank",
      "serbatoio"
    ],
    [
      "submission",
      "resa"
    ],
    [
      "estimate",
      "stima"
    ],
    [
      "encourage",
      "esortare"
    ],
    [
      "navy",
      "flotta"
    ],
    [
      "kid",
      "bimbo"
    ],
    [
      "inspection",
      "esame"
    ],
    [
      "cancel",
      "annullare"
    ],
    [
      "manchester",
      "Mancestria"
    ],
    [
      "paint",
      "colore"
    ],
    [
      "delay",
      "differire"
    ],
    [
      "pilot",
      "pilota"
    ],
    [
      "czech",
      "ceca"
    ],
    [
      "initiative",
      "proposta"
    ],
    [
      "novel",
      "novella"
    ],
    [
      "pan",
      "padellata"
    ],
    [
      "ultra",
      "ultrà"
    ],
    [
      "winner",
      "vincitrice"
    ],
    [
      "contractor",
      "appaltatore"
    ],
    [
      "examination",
      "visita"
    ],
    [
      "potter",
      "vasaia"
    ],
    [
      "dish",
      "piatto"
    ],
    [
      "oxford",
      "Osfordia"
    ],
    [
      "truly",
      "veramente"
    ],
    [
      "painting",
      "dipinto"
    ],
    [
      "extensive",
      "molto"
    ],
    [
      "affordable",
      "vantaggioso"
    ],
    [
      "candidate",
      "candidata"
    ],
    [
      "slot",
      "orme"
    ],
    [
      "outstanding",
      "notevole"
    ],
    [
      "lodge",
      "loggia"
    ],
    [
      "messenger",
      "corriere"
    ],
    [
      "mirror",
      "copia speculare"
    ],
    [
      "tournament",
      "torneo"
    ],
    [
      "sterling",
      "argento sterlina"
    ],
    [
      "kernel",
      "nucleo"
    ],
    [
      "catalogue",
      "mettere in catalogo"
    ],
    [
      "demo",
      "dimostrazione"
    ],
    [
      "swiss",
      "elvetico"
    ],
    [
      "labour",
      "parto"
    ],
    [
      "terminal",
      "aerostazione"
    ],
    [
      "caribbean",
      "Caraibi"
    ],
    [
      "liquid",
      "liquida"
    ],
    [
      "loop",
      "ciclo"
    ],
    [
      "salary",
      "stipendio"
    ],
    [
      "guard",
      "guardia"
    ],
    [
      "properly",
      "ammodo"
    ],
    [
      "orleans",
      "Orléans"
    ],
    [
      "resume",
      "riprendere"
    ],
    [
      "raise",
      "alzare"
    ],
    [
      "prepare",
      "preparare"
    ],
    [
      "avatar",
      "emblema"
    ],
    [
      "rome",
      "Roma"
    ],
    [
      "arab",
      "araba"
    ],
    [
      "milk",
      "mungere"
    ],
    [
      "decide",
      "decretare"
    ],
    [
      "boot",
      "avvio"
    ],
    [
      "suitable",
      "adatto"
    ],
    [
      "lunch",
      "seconda colazione"
    ],
    [
      "dildo",
      "vibratore"
    ],
    [
      "audit",
      "udienza"
    ],
    [
      "push",
      "spingere"
    ],
    [
      "chamber",
      "camera"
    ],
    [
      "implement",
      "attuare"
    ],
    [
      "tower",
      "torre"
    ],
    [
      "yours",
      "Sua"
    ],
    [
      "sum",
      "somma"
    ],
    [
      "calculator",
      "calcolatore"
    ],
    [
      "significantly",
      "significativamente"
    ],
    [
      "chicken",
      "gallo"
    ],
    [
      "attend",
      "partecipare"
    ],
    [
      "shower",
      "doccia"
    ],
    [
      "tonight",
      "stasera"
    ],
    [
      "dear",
      "caro"
    ],
    [
      "sufficient",
      "idoneo"
    ],
    [
      "shell",
      "guscio"
    ],
    [
      "oak",
      "rovere"
    ],
    [
      "vat",
      "tinozza"
    ],
    [
      "awareness",
      "avviso"
    ],
    [
      "governor",
      "governatrice"
    ],
    [
      "beer",
      "birra"
    ],
    [
      "contribution",
      "contribuzione"
    ],
    [
      "measurement",
      "misura"
    ],
    [
      "formula",
      "latte artificiale"
    ],
    [
      "catch",
      "parata"
    ],
    [
      "pakistan",
      "Pachistania"
    ],
    [
      "reliable",
      "sicuro"
    ],
    [
      "northwest",
      "nord-ovest"
    ],
    [
      "doubt",
      "perplessità"
    ],
    [
      "classroom",
      "classe"
    ],
    [
      "wallpaper",
      "sfondo"
    ],
    [
      "merchandise",
      "mercanzia"
    ],
    [
      "visitor",
      "ospite"
    ],
    [
      "twin",
      "gemella"
    ],
    [
      "gateway",
      "varco"
    ],
    [
      "charlotte",
      "charlotte"
    ],
    [
      "biological",
      "biologico"
    ],
    [
      "transition",
      "passaggio"
    ],
    [
      "romance",
      "poesia"
    ],
    [
      "split",
      "fendere"
    ],
    [
      "heaven",
      "paradiso"
    ],
    [
      "pregnant",
      "pregna"
    ],
    [
      "focused",
      "concentrato"
    ],
    [
      "physician",
      "medico"
    ],
    [
      "bargain",
      "trattare"
    ],
    [
      "suit",
      "seme"
    ],
    [
      "shift",
      "spostarsi"
    ],
    [
      "chip",
      "chip"
    ],
    [
      "sit",
      "sedersi"
    ],
    [
      "cutting",
      "pungente"
    ],
    [
      "wow",
      "uao"
    ],
    [
      "flexible",
      "flessibile"
    ],
    [
      "char",
      "domestica"
    ],
    [
      "superior",
      "superiore"
    ],
    [
      "cartoon",
      "cartone"
    ],
    [
      "carbon",
      "carbone"
    ],
    [
      "comfortable",
      "comodo"
    ],
    [
      "magnetic",
      "magnetica"
    ],
    [
      "crisis",
      "crisi"
    ],
    [
      "outlook",
      "vista"
    ],
    [
      "massive",
      "vasto"
    ],
    [
      "bright",
      "allegro"
    ],
    [
      "treat",
      "offrire"
    ],
    [
      "header",
      "tuffo"
    ],
    [
      "piano",
      "pianoforte"
    ],
    [
      "grid",
      "griglia"
    ],
    [
      "consolidation",
      "potenziamento"
    ],
    [
      "mystery",
      "mistero"
    ],
    [
      "landscape",
      "panorama"
    ],
    [
      "journey",
      "avventura"
    ],
    [
      "banner",
      "stendardo"
    ],
    [
      "applicant",
      "candidato"
    ],
    [
      "blogger",
      "bloggista"
    ],
    [
      "rapid",
      "deciso"
    ],
    [
      "reverse",
      "opposto"
    ],
    [
      "deposit",
      "deposito"
    ],
    [
      "specify",
      "venire ai fatti"
    ],
    [
      "dutch",
      "olandesi"
    ],
    [
      "sensitive",
      "sensibile"
    ],
    [
      "tab",
      "scheda"
    ],
    [
      "router",
      "smistatore"
    ],
    [
      "concrete",
      "beton"
    ],
    [
      "editing",
      "redazione"
    ],
    [
      "folder",
      "cartella"
    ],
    [
      "upload",
      "upload"
    ],
    [
      "pulse",
      "ritmo"
    ],
    [
      "alexander",
      "Sandro"
    ],
    [
      "broadcast",
      "diffondere"
    ],
    [
      "strip",
      "spellare"
    ],
    [
      "specification",
      "specifica"
    ],
    [
      "pearl",
      "perla"
    ],
    [
      "accident",
      "incidente"
    ],
    [
      "plot",
      "ordito"
    ],
    [
      "airline",
      "aerolinea"
    ],
    [
      "typically",
      "solitamente"
    ],
    [
      "representation",
      "rappresentanza"
    ],
    [
      "regard",
      "riguardare"
    ],
    [
      "smooth",
      "dolce"
    ],
    [
      "strike",
      "sembrare"
    ],
    [
      "consumption",
      "consunzione"
    ],
    [
      "narrow",
      "angusto"
    ],
    [
      "threat",
      "minaccia"
    ],
    [
      "controller",
      "controllore"
    ],
    [
      "ownership",
      "padronanza"
    ],
    [
      "penis",
      "arnese"
    ],
    [
      "trailer",
      "caravan"
    ],
    [
      "malaysia",
      "Malaysia"
    ],
    [
      "antique",
      "obsoleto"
    ],
    [
      "willing",
      "volenteroso"
    ],
    [
      "strange",
      "strano"
    ],
    [
      "mention",
      "cenno"
    ],
    [
      "parallel",
      "omologo"
    ],
    [
      "operate",
      "operare"
    ],
    [
      "bold",
      "baldo"
    ],
    [
      "bathroom",
      "stanza da bagno"
    ],
    [
      "stable",
      "stalla"
    ],
    [
      "opera",
      "opera"
    ],
    [
      "cinema",
      "cinematografo"
    ],
    [
      "asset",
      "risorsa"
    ],
    [
      "scan",
      "scandire"
    ],
    [
      "blank",
      "cartuccia a salve"
    ],
    [
      "enhanced",
      "amplificato"
    ],
    [
      "entitled",
      "intitolato"
    ],
    [
      "severe",
      "rigido"
    ],
    [
      "generate",
      "generare"
    ],
    [
      "stainless",
      "inox"
    ],
    [
      "deluxe",
      "extralusso"
    ],
    [
      "bulk",
      "mole"
    ],
    [
      "pursuant",
      "in conformità"
    ],
    [
      "fabric",
      "tessuto"
    ],
    [
      "primarily",
      "primariamente"
    ],
    [
      "tight",
      "teso"
    ],
    [
      "contrast",
      "contrasto"
    ],
    [
      "recommendation",
      "proposta"
    ],
    [
      "sin",
      "colpa"
    ],
    [
      "berlin",
      "berlinese"
    ],
    [
      "cute",
      "carino"
    ],
    [
      "adoption",
      "adozione"
    ],
    [
      "expensive",
      "costoso"
    ],
    [
      "capture",
      "mangiare"
    ],
    [
      "plane",
      "aereo"
    ],
    [
      "seed",
      "seme"
    ],
    [
      "desire",
      "desiderio"
    ],
    [
      "expertise",
      "perizia"
    ],
    [
      "ee",
      "ato"
    ],
    [
      "jewellery",
      "gioielleria"
    ],
    [
      "peer",
      "pari"
    ],
    [
      "eventually",
      "alla fine"
    ],
    [
      "considering",
      "tutto considerato"
    ],
    [
      "rubber",
      "gomma"
    ],
    [
      "closing",
      "finale"
    ],
    [
      "meat",
      "carne"
    ],
    [
      "legend",
      "leggenda"
    ],
    [
      "grace",
      "grazia"
    ],
    [
      "ing",
      "ando"
    ],
    [
      "bang",
      "picchiare"
    ],
    [
      "bone",
      "osso"
    ],
    [
      "detection",
      "rilevamento"
    ],
    [
      "tutorial",
      "tutoriale"
    ],
    [
      "entity",
      "entità"
    ],
    [
      "gate",
      "porta"
    ],
    [
      "holder",
      "sostegno"
    ],
    [
      "moderator",
      "moderatrice"
    ],
    [
      "roman",
      "romana"
    ],
    [
      "dragon",
      "dragone"
    ],
    [
      "busy",
      "occupato"
    ],
    [
      "captain",
      "capitano"
    ],
    [
      "fantastic",
      "fantastica"
    ],
    [
      "imagine",
      "immaginare"
    ],
    [
      "heating",
      "scaldante"
    ],
    [
      "leg",
      "zampa"
    ],
    [
      "neck",
      "limonare"
    ],
    [
      "wing",
      "ala"
    ],
    [
      "taste",
      "gusto"
    ],
    [
      "commit",
      "compromettere"
    ],
    [
      "tiny",
      "minuto"
    ],
    [
      "rail",
      "barra"
    ],
    [
      "jay",
      "ghiandaia"
    ],
    [
      "gap",
      "breccia"
    ],
    [
      "tube",
      "tubo"
    ],
    [
      "corresponding",
      "analogo"
    ],
    [
      "cache",
      "ripostiglio"
    ],
    [
      "belt",
      "cintura"
    ],
    [
      "jacket",
      "giubbotto"
    ],
    [
      "animation",
      "animazione"
    ],
    [
      "oracle",
      "oracolo"
    ],
    [
      "er",
      "iù"
    ],
    [
      "matthew",
      "Matteo"
    ],
    [
      "proud",
      "orgoglioso"
    ],
    [
      "excess",
      "eccesso"
    ],
    [
      "console",
      "consolle"
    ],
    [
      "instructor",
      "insegnante"
    ],
    [
      "giant",
      "colosso"
    ],
    [
      "approaches",
      "avanzata"
    ],
    [
      "voltage",
      "tensione"
    ],
    [
      "usual",
      "solito"
    ],
    [
      "angle",
      "angolo"
    ],
    [
      "rob",
      "rubare"
    ],
    [
      "mining",
      "industria mineraria"
    ],
    [
      "ongoing",
      "attuale"
    ],
    [
      "worst",
      "pessimo"
    ],
    [
      "era",
      "epoca"
    ],
    [
      "convert",
      "convertirsi"
    ],
    [
      "possibility",
      "opportunità"
    ],
    [
      "analyst",
      "analista"
    ],
    [
      "dangerous",
      "nocivo"
    ],
    [
      "garage",
      "autorimessa"
    ],
    [
      "reliability",
      "attendibilità"
    ],
    [
      "unfortunately",
      "sfortunatamente"
    ],
    [
      "attachment",
      "allegato"
    ],
    [
      "morgan",
      "Morgan"
    ],
    [
      "pleasure",
      "piacimento"
    ],
    [
      "honor",
      "tenere fede a"
    ],
    [
      "asp",
      "aspio"
    ],
    [
      "eagle",
      "moneta di dieci dollari"
    ],
    [
      "pants",
      "slip"
    ],
    [
      "columbus",
      "Cristoforo Colombo"
    ],
    [
      "nurse",
      "balia"
    ],
    [
      "prayer",
      "prece"
    ],
    [
      "appointment",
      "nomina"
    ],
    [
      "quiet",
      "pace"
    ],
    [
      "luck",
      "sorte"
    ],
    [
      "producer",
      "produttore"
    ],
    [
      "cheese",
      "cacio"
    ],
    [
      "comic",
      "comico"
    ],
    [
      "carefully",
      "attentamente"
    ],
    [
      "jet",
      "getto"
    ],
    [
      "crown",
      "corona"
    ],
    [
      "underground",
      "resistenza"
    ],
    [
      "maker",
      "fattore"
    ],
    [
      "crack",
      "eludere"
    ],
    [
      "principle",
      "principio"
    ],
    [
      "gang",
      "banda"
    ],
    [
      "calculated",
      "studiato a tavolino"
    ],
    [
      "fetish",
      "feticismo"
    ],
    [
      "appearance",
      "aria"
    ],
    [
      "smoke",
      "fumare"
    ],
    [
      "craft",
      "creare"
    ],
    [
      "cake",
      "dolce"
    ],
    [
      "apart",
      "a pezzi"
    ],
    [
      "fellow",
      "tipo"
    ],
    [
      "blind",
      "orbo"
    ],
    [
      "lounge",
      "oziare"
    ],
    [
      "mad",
      "folle"
    ],
    [
      "gross",
      "lordo"
    ],
    [
      "strongly",
      "ampiamente"
    ],
    [
      "ken",
      "intendere"
    ],
    [
      "familiar",
      "spirito famigliare"
    ],
    [
      "till",
      "fino a che"
    ],
    [
      "pen",
      "ovile"
    ],
    [
      "shoe",
      "scarpa"
    ],
    [
      "victory",
      "vincita"
    ],
    [
      "sand",
      "rena"
    ],
    [
      "joy",
      "piacere"
    ],
    [
      "mainly",
      "sostanzialmente"
    ],
    [
      "actor",
      "attrice"
    ],
    [
      "seal",
      "sigillo"
    ],
    [
      "fifth",
      "quinta"
    ],
    [
      "citizen",
      "cittadina"
    ],
    [
      "municipal",
      "comunale"
    ],
    [
      "prize",
      "premio"
    ],
    [
      "anytime",
      "in qualunque momento"
    ],
    [
      "pipe",
      "tubo"
    ],
    [
      "guardian",
      "guardiano"
    ],
    [
      "lecture",
      "lezione"
    ],
    [
      "lay",
      "posare"
    ],
    [
      "dirty",
      "sporco"
    ],
    [
      "deck",
      "mazzo"
    ],
    [
      "worker",
      "operaio"
    ],
    [
      "alive",
      "attivo"
    ],
    [
      "temple",
      "tempia"
    ],
    [
      "prove",
      "provare"
    ],
    [
      "promise",
      "voto"
    ],
    [
      "thin",
      "sottile"
    ],
    [
      "exhibition",
      "mostra"
    ],
    [
      "prefer",
      "favorire"
    ],
    [
      "ridge",
      "colmo"
    ],
    [
      "cabinet",
      "pensile"
    ],
    [
      "sick",
      "stufo"
    ],
    [
      "collect",
      "raccogliere"
    ],
    [
      "bet",
      "stare sicuro"
    ],
    [
      "composition",
      "componimento"
    ],
    [
      "definitely",
      "non ci piove"
    ],
    [
      "purple",
      "porpora"
    ],
    [
      "larry",
      "Loris"
    ],
    [
      "mutual",
      "vicendevole"
    ],
    [
      "necessarily",
      "per forza"
    ],
    [
      "attribute",
      "attributo"
    ],
    [
      "prison",
      "carcere"
    ],
    [
      "skill",
      "capacità"
    ],
    [
      "everyday",
      "comune"
    ],
    [
      "apparently",
      "chiaramente"
    ],
    [
      "inquiry",
      "domanda"
    ],
    [
      "exhibit",
      "dimostrare"
    ],
    [
      "throw",
      "tirare"
    ],
    [
      "trend",
      "moda"
    ],
    [
      "coordinator",
      "coordinatrice"
    ],
    [
      "mercury",
      "mercorella"
    ],
    [
      "handbook",
      "guida"
    ],
    [
      "navigate",
      "seguire"
    ],
    [
      "worse",
      "peggio"
    ],
    [
      "summit",
      "summit"
    ],
    [
      "escape",
      "eludere"
    ],
    [
      "somewhat",
      "piuttosto"
    ],
    [
      "receiver",
      "cornetta"
    ],
    [
      "substantial",
      "sostanzioso"
    ],
    [
      "progressive",
      "progressista"
    ],
    [
      "glance",
      "scorsa"
    ],
    [
      "arcade",
      "porticato"
    ],
    [
      "impossible",
      "impossibile"
    ],
    [
      "obvious",
      "evidente"
    ],
    [
      "graph",
      "grafo"
    ],
    [
      "judgment",
      "giudizio"
    ],
    [
      "filing",
      "polvere"
    ],
    [
      "foster",
      "curare"
    ],
    [
      "passing",
      "scomparsa"
    ],
    [
      "explanation",
      "esegesi"
    ],
    [
      "folk",
      "gente"
    ],
    [
      "subsection",
      "comma"
    ],
    [
      "fraud",
      "frodi"
    ],
    [
      "pottery",
      "ceramica"
    ],
    [
      "emphasis",
      "risalto"
    ],
    [
      "awesome",
      "magnifico"
    ],
    [
      "mexican",
      "messicana"
    ],
    [
      "confirmed",
      "confermato"
    ],
    [
      "crash",
      "imbucarsi"
    ],
    [
      "lift",
      "ascensore"
    ],
    [
      "inter",
      "inumare"
    ],
    [
      "expense",
      "perdita"
    ],
    [
      "grove",
      "piantagione"
    ],
    [
      "venture",
      "osare"
    ],
    [
      "korean",
      "coreana"
    ],
    [
      "packet",
      "pacchetto"
    ],
    [
      "dad",
      "pà"
    ],
    [
      "placement",
      "collocamento"
    ],
    [
      "subsequent",
      "ulteriore"
    ],
    [
      "motorcycle",
      "moto"
    ],
    [
      "yard",
      "iarda"
    ],
    [
      "disclosure",
      "asserzione"
    ],
    [
      "establishment",
      "organico"
    ],
    [
      "mayor",
      "sindaca"
    ],
    [
      "murder",
      "omicidio"
    ],
    [
      "senator",
      "senatrice"
    ],
    [
      "yield",
      "cedere"
    ],
    [
      "pour",
      "diluviare"
    ],
    [
      "lodging",
      "alloggio"
    ],
    [
      "hence",
      "dunque"
    ],
    [
      "entirely",
      "pienamente"
    ],
    [
      "radar",
      "radiotelemetro"
    ],
    [
      "rescue",
      "soccorso"
    ],
    [
      "occupation",
      "occupazione"
    ],
    [
      "butt",
      "cicca"
    ],
    [
      "closely",
      "da vicino"
    ],
    [
      "radiation",
      "irraggiamento"
    ],
    [
      "diary",
      "diario intimo"
    ],
    [
      "seriously",
      "seriamente"
    ],
    [
      "ear",
      "amento"
    ],
    [
      "baker",
      "fornaia"
    ],
    [
      "pollution",
      "inquinante"
    ],
    [
      "conservative",
      "conservatore"
    ],
    [
      "shock",
      "scossa"
    ],
    [
      "tie",
      "legame"
    ],
    [
      "ward",
      "rione"
    ],
    [
      "ian",
      "iano"
    ],
    [
      "walker",
      "deambulatore"
    ],
    [
      "demonstrate",
      "manifestare"
    ],
    [
      "kiss",
      "baciare"
    ],
    [
      "beast",
      "belva"
    ],
    [
      "experiment",
      "sperimentare"
    ],
    [
      "overseas",
      "oltremare"
    ],
    [
      "dodge",
      "eludere"
    ],
    [
      "counsel",
      "avvocato"
    ],
    [
      "assignment",
      "atto di cessione"
    ],
    [
      "rush",
      "fretta"
    ],
    [
      "absence",
      "mancanza"
    ],
    [
      "cluster",
      "gruppo"
    ],
    [
      "whereas",
      "laddove"
    ],
    [
      "surprise",
      "stupire"
    ],
    [
      "lamp",
      "lampada"
    ],
    [
      "everybody",
      "tutti"
    ],
    [
      "satisfied",
      "contento"
    ],
    [
      "glad",
      "appagato"
    ],
    [
      "copper",
      "poliziotto"
    ],
    [
      "rack",
      "eculeo"
    ],
    [
      "receipt",
      "incasso"
    ],
    [
      "ordinary",
      "ordinaria"
    ],
    [
      "nobody",
      "nullità"
    ],
    [
      "ghost",
      "anima"
    ],
    [
      "southwest",
      "sud-ovest"
    ],
    [
      "boss",
      "capo"
    ],
    [
      "pride",
      "fierezza"
    ],
    [
      "reporter",
      "inviato"
    ],
    [
      "metabolism",
      "ricambio"
    ],
    [
      "champion",
      "campionessa"
    ],
    [
      "cloudy",
      "nuvolo"
    ],
    [
      "personally",
      "come persona"
    ],
    [
      "plenty",
      "cuccagna"
    ],
    [
      "solo",
      "solitario"
    ],
    [
      "sentence",
      "pena"
    ],
    [
      "uniform",
      "divisa"
    ],
    [
      "wealth",
      "abbondanza"
    ],
    [
      "somewhere",
      "da qualche parte"
    ],
    [
      "recognize",
      "premiare"
    ],
    [
      "brass",
      "bronzo"
    ],
    [
      "quest",
      "ricerca"
    ],
    [
      "publish",
      "divulgare"
    ],
    [
      "toe",
      "dito"
    ],
    [
      "thumbnail",
      "miniatura"
    ],
    [
      "jonathan",
      "Gionatan"
    ],
    [
      "whenever",
      "ogni volta che"
    ],
    [
      "lifetime",
      "vita"
    ],
    [
      "pioneer",
      "pioniera"
    ],
    [
      "booty",
      "sacco"
    ],
    [
      "venue",
      "arena"
    ],
    [
      "athletic",
      "atletico"
    ],
    [
      "vital",
      "vitale"
    ],
    [
      "coastal",
      "litoraneo"
    ],
    [
      "charity",
      "carità"
    ],
    [
      "excel",
      "brillare"
    ],
    [
      "obligation",
      "obbligo"
    ],
    [
      "wake",
      "veglia"
    ],
    [
      "stupid",
      "scemo"
    ],
    [
      "realize",
      "realizzare"
    ],
    [
      "regardless",
      "nonostante"
    ],
    [
      "enemy",
      "nemica"
    ],
    [
      "puzzle",
      "mistero"
    ],
    [
      "insight",
      "intuizione"
    ],
    [
      "shit",
      "merda"
    ],
    [
      "republican",
      "repubblicana"
    ],
    [
      "latter",
      "secondo"
    ],
    [
      "thick",
      "folto"
    ],
    [
      "attendance",
      "presenza"
    ],
    [
      "drum",
      "bidone"
    ],
    [
      "iraqi",
      "irachena"
    ],
    [
      "builder",
      "costruttrice"
    ],
    [
      "vista",
      "prospettiva"
    ],
    [
      "flood",
      "allagare"
    ],
    [
      "ease",
      "riposo"
    ],
    [
      "orgy",
      "orgia"
    ],
    [
      "arena",
      "teatro"
    ],
    [
      "outcome",
      "obiettivo"
    ],
    [
      "appreciate",
      "capire"
    ],
    [
      "casual",
      "casuale"
    ],
    [
      "polish",
      "levigare"
    ],
    [
      "lovely",
      "stupendo"
    ],
    [
      "clause",
      "clausola"
    ],
    [
      "charger",
      "corsiero"
    ],
    [
      "tend",
      "accudire"
    ],
    [
      "laura",
      "lavra"
    ],
    [
      "tokyo",
      "Tokio"
    ],
    [
      "customize",
      "personalizzare"
    ],
    [
      "candy",
      "confetto"
    ],
    [
      "hunt",
      "cacciare"
    ],
    [
      "deputy",
      "vice"
    ],
    [
      "thai",
      "thailandese"
    ],
    [
      "complaint",
      "denuncia"
    ],
    [
      "balls",
      "balle"
    ],
    [
      "afghanistan",
      "Afgania"
    ],
    [
      "boost",
      "potenziare"
    ],
    [
      "spanking",
      "totò"
    ],
    [
      "governance",
      "governo"
    ],
    [
      "mill",
      "macinatoio"
    ],
    [
      "den",
      "tana"
    ],
    [
      "finger",
      "dita"
    ],
    [
      "pound",
      "lira"
    ],
    [
      "burn",
      "bruciare"
    ],
    [
      "ourselves",
      "noi stesse"
    ],
    [
      "bread",
      "panare"
    ],
    [
      "wooden",
      "ligneo"
    ],
    [
      "tough",
      "duro"
    ],
    [
      "incident",
      "incidente"
    ],
    [
      "lie",
      "balla"
    ],
    [
      "conversation",
      "dialogo"
    ],
    [
      "decrease",
      "calo"
    ],
    [
      "chest",
      "torace"
    ],
    [
      "pension",
      "assegno"
    ],
    [
      "worship",
      "culto"
    ],
    [
      "capability",
      "possibilità"
    ],
    [
      "reproduction",
      "duplicato"
    ],
    [
      "minority",
      "minorità"
    ],
    [
      "diverse",
      "vario"
    ],
    [
      "sole",
      "unico"
    ],
    [
      "recorder",
      "flauto"
    ],
    [
      "sight",
      "mirare"
    ],
    [
      "clay",
      "creta"
    ],
    [
      "refund",
      "ripagare"
    ],
    [
      "reception",
      "accoglienza"
    ],
    [
      "odds",
      "probabilità"
    ],
    [
      "insider",
      "basista"
    ],
    [
      "worry",
      "disturbare"
    ],
    [
      "legacy",
      "eredità"
    ],
    [
      "marc",
      "vinaccia"
    ],
    [
      "pleased",
      "lieto"
    ],
    [
      "widely",
      "comunemente"
    ],
    [
      "phrase",
      "frase"
    ],
    [
      "paradise",
      "Paradiso terrestre"
    ],
    [
      "hybrid",
      "ibrido"
    ],
    [
      "emotional",
      "emotivo"
    ],
    [
      "leaf",
      "foglia"
    ],
    [
      "pad",
      "blocco"
    ],
    [
      "diesel",
      "diesel"
    ],
    [
      "combine",
      "unire"
    ],
    [
      "overnight",
      "di colpo"
    ],
    [
      "exceed",
      "superare"
    ],
    [
      "rod",
      "bacchetta"
    ],
    [
      "saudi",
      "saudita"
    ],
    [
      "fault",
      "colpa"
    ],
    [
      "introduce",
      "introdurre"
    ],
    [
      "suspension",
      "balestra"
    ],
    [
      "wolf",
      "donnaiolo"
    ],
    [
      "slowly",
      "adagio"
    ],
    [
      "communicate",
      "comunicare"
    ],
    [
      "infant",
      "minore"
    ],
    [
      "fluid",
      "liquido"
    ],
    [
      "kick",
      "pedata"
    ],
    [
      "meal",
      "mangime"
    ],
    [
      "hurt",
      "dolere"
    ],
    [
      "pot",
      "erba"
    ],
    [
      "dimension",
      "dimensione"
    ],
    [
      "wright",
      "esperta"
    ],
    [
      "proven",
      "provato"
    ],
    [
      "slip",
      "calare"
    ],
    [
      "quarterly",
      "inquartato"
    ],
    [
      "devil",
      "demonio"
    ],
    [
      "grass",
      "erba"
    ],
    [
      "comply",
      "attuare"
    ],
    [
      "florist",
      "fioraia"
    ],
    [
      "cherry",
      "ciliegia"
    ],
    [
      "alternate",
      "alterno"
    ],
    [
      "achievement",
      "risultato"
    ],
    [
      "kenya",
      "Kenia"
    ],
    [
      "passenger",
      "passeggera"
    ],
    [
      "convenient",
      "comodo"
    ],
    [
      "mars",
      "Marte"
    ],
    [
      "socket",
      "zoccolo"
    ],
    [
      "silent",
      "muto"
    ],
    [
      "orientation",
      "posizione"
    ],
    [
      "pill",
      "fuffa"
    ],
    [
      "swing",
      "altalenare"
    ],
    [
      "talent",
      "talenti"
    ],
    [
      "wisdom",
      "saggezza"
    ],
    [
      "shoot",
      "getto"
    ],
    [
      "boundary",
      "confine"
    ],
    [
      "mint",
      "menta"
    ],
    [
      "offset",
      "inizio"
    ],
    [
      "spin",
      "filare"
    ],
    [
      "deadline",
      "limite"
    ],
    [
      "robot",
      "automa"
    ],
    [
      "witness",
      "prova"
    ],
    [
      "assess",
      "tassare"
    ],
    [
      "wash",
      "lavarsi"
    ],
    [
      "entrance",
      "accesso"
    ],
    [
      "roots",
      "radici"
    ],
    [
      "declaration",
      "voto"
    ],
    [
      "noble",
      "nobile"
    ],
    [
      "glasgow",
      "Glasgovia"
    ],
    [
      "automation",
      "automazione"
    ],
    [
      "knight",
      "cavallo"
    ],
    [
      "loose",
      "sciolto"
    ],
    [
      "recipient",
      "ricevente"
    ],
    [
      "southeast",
      "sud-est"
    ],
    [
      "soap",
      "insaponarsi"
    ],
    [
      "jam",
      "guaio"
    ],
    [
      "unusual",
      "inusuale"
    ],
    [
      "increasingly",
      "progressivamente"
    ],
    [
      "disorder",
      "disturbo"
    ],
    [
      "routine",
      "routine"
    ],
    [
      "toolbar",
      "toolbar"
    ],
    [
      "basically",
      "praticamente"
    ],
    [
      "axis",
      "epistrofeo"
    ],
    [
      "median",
      "mediana"
    ],
    [
      "scanner",
      "scansore"
    ],
    [
      "horny",
      "cornuto"
    ],
    [
      "judicial",
      "giudiziario"
    ],
    [
      "adjustment",
      "inserimento"
    ],
    [
      "hero",
      "eroina"
    ],
    [
      "integer",
      "numero intero"
    ],
    [
      "bachelor",
      "zito"
    ],
    [
      "attitude",
      "postura"
    ],
    [
      "engaged",
      "fidanzato"
    ],
    [
      "carpet",
      "moquette"
    ],
    [
      "punk",
      "teppista"
    ],
    [
      "collective",
      "comune"
    ],
    [
      "coalition",
      "blocco"
    ],
    [
      "pi",
      "pasticcio"
    ],
    [
      "enrollment",
      "aruolate"
    ],
    [
      "pace",
      "passo"
    ],
    [
      "besides",
      "inoltre"
    ],
    [
      "wage",
      "paga"
    ],
    [
      "collector",
      "esattore"
    ],
    [
      "arc",
      "curva in forma parametrica"
    ],
    [
      "dawn",
      "albori"
    ],
    [
      "coat",
      "giacca"
    ],
    [
      "restoration",
      "restaurazione"
    ],
    [
      "convenience",
      "comodità"
    ],
    [
      "container",
      "recipiente"
    ],
    [
      "defendant",
      "accusata"
    ],
    [
      "warner",
      "Irnerio"
    ],
    [
      "confirmation",
      "cresima"
    ],
    [
      "app",
      "programma"
    ],
    [
      "wizard",
      "assistente"
    ],
    [
      "corps",
      "corpo"
    ],
    [
      "liable",
      "punibile"
    ],
    [
      "recall",
      "ritirare"
    ],
    [
      "departure",
      "morte"
    ],
    [
      "belief",
      "credenza"
    ],
    [
      "killing",
      "omicidio"
    ],
    [
      "bikini",
      "bichini"
    ],
    [
      "shoulder",
      "dorso"
    ],
    [
      "tit",
      "tetta"
    ],
    [
      "refine",
      "migliorare"
    ],
    [
      "herald",
      "messo"
    ],
    [
      "literacy",
      "alfabetizzazione"
    ],
    [
      "attraction",
      "attrattiva"
    ],
    [
      "diving",
      "tuffo"
    ],
    [
      "suppose",
      "supporre"
    ],
    [
      "reed",
      "ancia"
    ],
    [
      "involve",
      "elevare"
    ],
    [
      "moderate",
      "modesto"
    ],
    [
      "opposite",
      "opposto"
    ],
    [
      "ban",
      "bano"
    ],
    [
      "clerk",
      "impiegato"
    ],
    [
      "vast",
      "ampio"
    ],
    [
      "outline",
      "sunto"
    ],
    [
      "jeans",
      "ginsi"
    ],
    [
      "compilation",
      "insieme"
    ],
    [
      "odd",
      "caffo"
    ],
    [
      "wrap",
      "rotolo"
    ],
    [
      "mood",
      "cattivo umore"
    ],
    [
      "favor",
      "preferire"
    ],
    [
      "attractive",
      "procace"
    ],
    [
      "occasion",
      "motivo"
    ],
    [
      "careful",
      "cauto"
    ],
    [
      "beam",
      "bure"
    ],
    [
      "arrive",
      "giungere"
    ],
    [
      "sunset",
      "crepuscolo"
    ],
    [
      "minimal",
      "minimale"
    ],
    [
      "aside",
      "in disparte"
    ],
    [
      "outsourcing",
      "subappalto"
    ],
    [
      "adjustable",
      "modificabile"
    ],
    [
      "essay",
      "studio"
    ],
    [
      "dialogue",
      "discorso"
    ],
    [
      "trace",
      "tirante"
    ],
    [
      "shut",
      "serrare"
    ],
    [
      "voluntary",
      "voluto"
    ],
    [
      "consult",
      "consultare"
    ],
    [
      "greatly",
      "assai"
    ],
    [
      "mask",
      "maschera"
    ],
    [
      "commonly",
      "spesso"
    ],
    [
      "photographer",
      "fotografa"
    ],
    [
      "turkish",
      "turchesco"
    ],
    [
      "coal",
      "carbone"
    ],
    [
      "cry",
      "urlo"
    ],
    [
      "quantum",
      "quantico"
    ],
    [
      "largely",
      "ampiamente"
    ],
    [
      "pleasant",
      "gradito"
    ],
    [
      "announce",
      "segnalare"
    ],
    [
      "spoke",
      "razzo"
    ],
    [
      "engagement",
      "adesione"
    ],
    [
      "rough",
      "rude"
    ],
    [
      "weird",
      "bizzarro"
    ],
    [
      "blade",
      "lama"
    ],
    [
      "suddenly",
      "all'improvviso"
    ],
    [
      "merely",
      "meramente"
    ],
    [
      "arrangement",
      "disposizione"
    ],
    [
      "pointer",
      "puntatore"
    ],
    [
      "stretch",
      "stendere"
    ],
    [
      "cooperative",
      "società cooperativa"
    ],
    [
      "muslim",
      "musulmana"
    ],
    [
      "sleeve",
      "fodera"
    ],
    [
      "cleaner",
      "addetto alle pulizie"
    ],
    [
      "cricket",
      "fair play"
    ],
    [
      "beef",
      "carne bovina"
    ],
    [
      "stroke",
      "colpo"
    ],
    [
      "strap",
      "fascetta"
    ],
    [
      "headquarters",
      "sede centrale"
    ],
    [
      "crowd",
      "massa"
    ],
    [
      "surf",
      "surfare"
    ],
    [
      "customs",
      "dazio"
    ],
    [
      "rainbow",
      "iride"
    ],
    [
      "hook",
      "agganciare"
    ],
    [
      "roulette",
      "rulletta"
    ],
    [
      "decline",
      "declinare"
    ],
    [
      "israeli",
      "israeliana"
    ],
    [
      "cloud",
      "nube"
    ],
    [
      "facilitate",
      "facilitare"
    ],
    [
      "subscriber",
      "iscritto"
    ],
    [
      "knife",
      "lama"
    ],
    [
      "shelf",
      "mensola"
    ],
    [
      "timing",
      "cadenza"
    ],
    [
      "crop",
      "raccolto"
    ],
    [
      "workforce",
      "manodopera"
    ],
    [
      "hub",
      "mira"
    ],
    [
      "founder",
      "creatore"
    ],
    [
      "decade",
      "decina"
    ],
    [
      "dispute",
      "bega"
    ],
    [
      "tired",
      "fatto"
    ],
    [
      "adverse",
      "avverso"
    ],
    [
      "everywhere",
      "dappertutto"
    ],
    [
      "discharge",
      "portata"
    ],
    [
      "halloween",
      "vigilia di Ognissanti"
    ],
    [
      "hazardous",
      "azzardato"
    ],
    [
      "restore",
      "rimettere"
    ],
    [
      "stack",
      "bica"
    ],
    [
      "sue",
      "citare in giudizio"
    ],
    [
      "reputation",
      "rumore"
    ],
    [
      "recycling",
      "riciclaggio"
    ],
    [
      "hang",
      "appendere"
    ],
    [
      "creator",
      "creatore"
    ],
    [
      "amber",
      "ambra"
    ],
    [
      "coding",
      "programmazione"
    ],
    [
      "slideshow",
      "filmino"
    ],
    [
      "variation",
      "variante"
    ],
    [
      "passage",
      "corridoio"
    ],
    [
      "trunk",
      "baule"
    ],
    [
      "damn",
      "tubo"
    ],
    [
      "photograph",
      "foto"
    ],
    [
      "camel",
      "cammella"
    ],
    [
      "underlying",
      "basilare"
    ],
    [
      "hood",
      "cappa"
    ],
    [
      "suicide",
      "suicida"
    ],
    [
      "gathering",
      "gruppo"
    ],
    [
      "juice",
      "succo"
    ],
    [
      "chase",
      "cacciare"
    ],
    [
      "panama",
      "Panamá"
    ],
    [
      "automobile",
      "auto"
    ],
    [
      "confidential",
      "riservato"
    ],
    [
      "northeast",
      "nord-est"
    ],
    [
      "railway",
      "rotaia"
    ],
    [
      "cassette",
      "pacco pignoni"
    ],
    [
      "pointed",
      "puntuto"
    ],
    [
      "mistake",
      "sbaglio"
    ],
    [
      "beads",
      "conterie"
    ],
    [
      "fortune",
      "fortuna"
    ],
    [
      "canvas",
      "tela"
    ],
    [
      "threshold",
      "uscio"
    ],
    [
      "parish",
      "parrocchia"
    ],
    [
      "stem",
      "gambo"
    ],
    [
      "proxy",
      "delega"
    ],
    [
      "translate",
      "riversare"
    ],
    [
      "killer",
      "uccisora"
    ],
    [
      "tune",
      "affinare"
    ],
    [
      "bishop",
      "alfiere"
    ],
    [
      "corn",
      "callo"
    ],
    [
      "farmer",
      "fattore"
    ],
    [
      "perfectly",
      "totalmente"
    ],
    [
      "tin",
      "teglia"
    ],
    [
      "slave",
      "schiava"
    ],
    [
      "litigation",
      "controversia"
    ],
    [
      "broadcasting",
      "trasmissione"
    ],
    [
      "artwork",
      "immagine"
    ],
    [
      "ethical",
      "etico"
    ],
    [
      "floral",
      "florale"
    ],
    [
      "neutral",
      "neutro"
    ],
    [
      "rat",
      "spia"
    ],
    [
      "prospective",
      "probabile"
    ],
    [
      "bedding",
      "lenzuola"
    ],
    [
      "ultimately",
      "per ultimo"
    ],
    [
      "equally",
      "parimenti"
    ],
    [
      "artificial",
      "artefatto"
    ],
    [
      "bearing",
      "postura"
    ],
    [
      "tail",
      "coda"
    ],
    [
      "charm",
      "amuleto"
    ],
    [
      "lawn",
      "radura"
    ],
    [
      "underwear",
      "intimo"
    ],
    [
      "basin",
      "conca"
    ],
    [
      "soup",
      "brodo"
    ],
    [
      "crossing",
      "traversata"
    ],
    [
      "inclusive",
      "incluso"
    ],
    [
      "cottage",
      "rustico"
    ],
    [
      "drunk",
      "ebbro"
    ],
    [
      "byte",
      "ottetto"
    ],
    [
      "nose",
      "muso"
    ],
    [
      "latex",
      "latice"
    ],
    [
      "alien",
      "alieno"
    ],
    [
      "broke",
      "fallito"
    ],
    [
      "constantly",
      "costantemente"
    ],
    [
      "resolve",
      "risolvere"
    ],
    [
      "moscow",
      "Moscow"
    ],
    [
      "thesis",
      "tema"
    ],
    [
      "nylon",
      "nylon"
    ],
    [
      "rocky",
      "petroso"
    ],
    [
      "frequent",
      "assiduo"
    ],
    [
      "trim",
      "orientamento"
    ],
    [
      "gen",
      "suffixA producer of something, or an agent in the production of something.geno"
    ],
    [
      "procurement",
      "appalto"
    ],
    [
      "bunch",
      "mucchio"
    ],
    [
      "quit",
      "lasciare"
    ],
    [
      "distinct",
      "diverso"
    ],
    [
      "highlight",
      "chicca"
    ],
    [
      "substitute",
      "rimpiazzo"
    ],
    [
      "inclusion",
      "aggiunta"
    ],
    [
      "hopefully",
      "speranzosamente"
    ],
    [
      "brilliant",
      "brillante"
    ]
  ],
  "ja": [
    [
      "the",
      "ザ"
    ],
    [
      "of",
      "の"
    ],
    [
      "and",
      "や"
    ],
    [
      "to",
      "に"
    ],
    [
      "in",
      "で"
    ],
    [
      "for",
      "で"
    ],
    [
      "on",
      "に"
    ],
    [
      "that",
      "それ"
    ],
    [
      "by",
      "に"
    ],
    [
      "this",
      "この"
    ],
    [
      "with",
      "と"
    ],
    [
      "i",
      "俺"
    ],
    [
      "you",
      "お前"
    ],
    [
      "it",
      "あれ"
    ],
    [
      "not",
      "ない"
    ],
    [
      "or",
      "又は"
    ],
    [
      "be",
      "だ"
    ],
    [
      "from",
      "より"
    ],
    [
      "at",
      "に"
    ],
    [
      "as",
      "アス"
    ],
    [
      "your",
      "きみ"
    ],
    [
      "all",
      "全"
    ],
    [
      "have",
      "ある"
    ],
    [
      "new",
      "新しい"
    ],
    [
      "more",
      "もう"
    ],
    [
      "we",
      "俺達"
    ],
    [
      "will",
      "望む"
    ],
    [
      "home",
      "故郷"
    ],
    [
      "can",
      "れる"
    ],
    [
      "us",
      "ユー・エス・エー"
    ],
    [
      "about",
      "について"
    ],
    [
      "if",
      "と"
    ],
    [
      "page",
      "面"
    ],
    [
      "my",
      "僕"
    ],
    [
      "search",
      "捜す"
    ],
    [
      "free",
      "そのままの"
    ],
    [
      "but",
      "が"
    ],
    [
      "our",
      "我ら"
    ],
    [
      "one",
      "一"
    ],
    [
      "other",
      "他"
    ],
    [
      "do",
      "やる"
    ],
    [
      "no",
      "いいえ"
    ],
    [
      "information",
      "案内"
    ],
    [
      "time",
      "時間"
    ],
    [
      "they",
      "氏"
    ],
    [
      "he",
      "奴"
    ],
    [
      "up",
      "北"
    ],
    [
      "may",
      "多分"
    ],
    [
      "what",
      "の"
    ],
    [
      "which",
      "の"
    ],
    [
      "news",
      "報道"
    ],
    [
      "out",
      "外"
    ],
    [
      "use",
      "為"
    ],
    [
      "any",
      "どれも"
    ],
    [
      "there",
      "あそこ"
    ],
    [
      "see",
      "理解"
    ],
    [
      "only",
      "だけ"
    ],
    [
      "so",
      "そう"
    ],
    [
      "when",
      "何時"
    ],
    [
      "contact",
      "接触"
    ],
    [
      "here",
      "ここで"
    ],
    [
      "business",
      "企業"
    ],
    [
      "who",
      "だれ"
    ],
    [
      "also",
      "にも"
    ],
    [
      "now",
      "いざ"
    ],
    [
      "help",
      "ヘルプ"
    ],
    [
      "get",
      "到達"
    ],
    [
      "view",
      "観点"
    ],
    [
      "online",
      "起動"
    ],
    [
      "c",
      "ハ"
    ],
    [
      "first",
      "最初"
    ],
    [
      "how",
      "どうやって"
    ],
    [
      "me",
      "私"
    ],
    [
      "some",
      "ある"
    ],
    [
      "these",
      "これら"
    ],
    [
      "like",
      "よう"
    ],
    [
      "service",
      "兵役"
    ],
    [
      "find",
      "見つける"
    ],
    [
      "price",
      "値段"
    ],
    [
      "date",
      "日付"
    ],
    [
      "back",
      "裏"
    ],
    [
      "top",
      "凸"
    ],
    [
      "people",
      "人"
    ],
    [
      "list",
      "表"
    ],
    [
      "name",
      "名"
    ],
    [
      "just",
      "只"
    ],
    [
      "over",
      "割る"
    ],
    [
      "state",
      "状態"
    ],
    [
      "year",
      "年"
    ],
    [
      "day",
      "日"
    ],
    [
      "email",
      "メアド"
    ],
    [
      "two",
      "ツー"
    ],
    [
      "health",
      "体"
    ],
    [
      "world",
      "世界"
    ],
    [
      "next",
      "次"
    ],
    [
      "go",
      "なる"
    ],
    [
      "work",
      "仕事"
    ],
    [
      "last",
      "最終的"
    ],
    [
      "most",
      "最も"
    ],
    [
      "music",
      "楽譜"
    ],
    [
      "buy",
      "購入"
    ],
    [
      "data",
      "情報"
    ],
    [
      "make",
      "製"
    ],
    [
      "product",
      "積"
    ],
    [
      "system",
      "系"
    ],
    [
      "post",
      "郵便"
    ],
    [
      "city",
      "市"
    ],
    [
      "add",
      "足す"
    ],
    [
      "policy",
      "政策"
    ],
    [
      "number",
      "番号"
    ],
    [
      "such",
      "こんな"
    ],
    [
      "please",
      "どうぞ"
    ],
    [
      "copyright",
      "版権"
    ],
    [
      "support",
      "支援"
    ],
    [
      "message",
      "短信"
    ],
    [
      "after",
      "後"
    ],
    [
      "software",
      "ソフト"
    ],
    [
      "then",
      "その後"
    ],
    [
      "good",
      "良い"
    ],
    [
      "video",
      "動画"
    ],
    [
      "well",
      "あのう"
    ],
    [
      "where",
      "どこ"
    ],
    [
      "public",
      "公衆"
    ],
    [
      "school",
      "学校"
    ],
    [
      "through",
      "から"
    ],
    [
      "she",
      "奴"
    ],
    [
      "review",
      "感想文"
    ],
    [
      "order",
      "目"
    ],
    [
      "very",
      "大変"
    ],
    [
      "privacy",
      "プライヴァシー"
    ],
    [
      "book",
      "巻"
    ],
    [
      "company",
      "会社"
    ],
    [
      "read",
      "読む"
    ],
    [
      "group",
      "組"
    ],
    [
      "sex",
      "性交"
    ],
    [
      "need",
      "要る"
    ],
    [
      "many",
      "多い"
    ],
    [
      "user",
      "ユーザ"
    ],
    [
      "said",
      "該"
    ],
    [
      "set",
      "用意"
    ],
    [
      "under",
      "下"
    ],
    [
      "general",
      "全般"
    ],
    [
      "research",
      "調査"
    ],
    [
      "university",
      "大学校"
    ],
    [
      "january",
      "睦月"
    ],
    [
      "mail",
      "郵便"
    ],
    [
      "full",
      "完全"
    ],
    [
      "map",
      "写像"
    ],
    [
      "program",
      "プログラム"
    ],
    [
      "life",
      "生命"
    ],
    [
      "know",
      "知る"
    ],
    [
      "way",
      "仕方"
    ],
    [
      "part",
      "役"
    ],
    [
      "great",
      "偉大"
    ],
    [
      "hotel",
      "宿"
    ],
    [
      "real",
      "実"
    ],
    [
      "item",
      "品物"
    ],
    [
      "international",
      "国際"
    ],
    [
      "center",
      "センター"
    ],
    [
      "must",
      "駄目"
    ],
    [
      "store",
      "蓄える"
    ],
    [
      "travel",
      "旅行する"
    ],
    [
      "development",
      "開発"
    ],
    [
      "report",
      "報告"
    ],
    [
      "member",
      "会員"
    ],
    [
      "line",
      "ライン"
    ],
    [
      "before",
      "以前"
    ],
    [
      "send",
      "送信"
    ],
    [
      "right",
      "右"
    ],
    [
      "type",
      "タイプ"
    ],
    [
      "because",
      "から"
    ],
    [
      "local",
      "現地"
    ],
    [
      "office",
      "職務"
    ],
    [
      "education",
      "教育"
    ],
    [
      "national",
      "国家"
    ],
    [
      "car",
      "自動車"
    ],
    [
      "design",
      "デザイン"
    ],
    [
      "take",
      "取る"
    ],
    [
      "internet",
      "ネット"
    ],
    [
      "address",
      "宛名"
    ],
    [
      "community",
      "共同体"
    ],
    [
      "within",
      "以内"
    ],
    [
      "area",
      "地区"
    ],
    [
      "want",
      "望む"
    ],
    [
      "phone",
      "音価"
    ],
    [
      "dvd",
      "ディーブイディー"
    ],
    [
      "subject",
      "学科"
    ],
    [
      "forum",
      "討論"
    ],
    [
      "family",
      "家族"
    ],
    [
      "code",
      "暗号"
    ],
    [
      "show",
      "示す"
    ],
    [
      "o",
      "よ"
    ],
    [
      "even",
      "も"
    ],
    [
      "black",
      "黒い"
    ],
    [
      "check",
      "勘定"
    ],
    [
      "special",
      "特殊"
    ],
    [
      "website",
      "サイト"
    ],
    [
      "index",
      "表題"
    ],
    [
      "being",
      "存在"
    ],
    [
      "much",
      "多い"
    ],
    [
      "sign",
      "合図"
    ],
    [
      "file",
      "列"
    ],
    [
      "link",
      "リンク"
    ],
    [
      "open",
      "開く"
    ],
    [
      "today",
      "本日"
    ],
    [
      "technology",
      "技術"
    ],
    [
      "south",
      "南方"
    ],
    [
      "case",
      "場合"
    ],
    [
      "project",
      "事業"
    ],
    [
      "same",
      "同じひと"
    ],
    [
      "version",
      "バージョン"
    ],
    [
      "section",
      "部分"
    ],
    [
      "found",
      "基礎"
    ],
    [
      "house",
      "家"
    ],
    [
      "security",
      "保証"
    ],
    [
      "both",
      "両-"
    ],
    [
      "american",
      "南北アメリカ"
    ],
    [
      "game",
      "体育"
    ],
    [
      "power",
      "勢力"
    ],
    [
      "while",
      "時"
    ],
    [
      "care",
      "気にかける"
    ],
    [
      "network",
      "網"
    ],
    [
      "down",
      "南"
    ],
    [
      "computer",
      "電算"
    ],
    [
      "three",
      "三"
    ],
    [
      "total",
      "和"
    ],
    [
      "place",
      "場所"
    ],
    [
      "end",
      "終了"
    ],
    [
      "download",
      "ダウンロードする"
    ],
    [
      "without",
      "無し"
    ],
    [
      "think",
      "考える"
    ],
    [
      "north",
      "北方"
    ],
    [
      "current",
      "電流"
    ],
    [
      "big",
      "大人"
    ],
    [
      "media",
      "媒体"
    ],
    [
      "law",
      "法則"
    ],
    [
      "control",
      "制御"
    ],
    [
      "water",
      "みず"
    ],
    [
      "history",
      "歴史"
    ],
    [
      "size",
      "寸尺"
    ],
    [
      "art",
      "技術"
    ],
    [
      "since",
      "より"
    ],
    [
      "guide",
      "指導"
    ],
    [
      "shop",
      "商店"
    ],
    [
      "directory",
      "ディレクトリ"
    ],
    [
      "board",
      "黒板"
    ],
    [
      "location",
      "地点"
    ],
    [
      "change",
      "変化"
    ],
    [
      "white",
      "白い"
    ],
    [
      "text",
      "文"
    ],
    [
      "small",
      "狭い"
    ],
    [
      "rating",
      "等級"
    ],
    [
      "rate",
      "割合"
    ],
    [
      "government",
      "支配"
    ],
    [
      "during",
      "間"
    ],
    [
      "usa",
      "ユー・エス・エー"
    ],
    [
      "return",
      "返す"
    ],
    [
      "shopping",
      "ショッピング"
    ],
    [
      "account",
      "アカウント"
    ],
    [
      "level",
      "程"
    ],
    [
      "profile",
      "横顔"
    ],
    [
      "form",
      "形状"
    ],
    [
      "love",
      "愛"
    ],
    [
      "old",
      "才"
    ],
    [
      "john",
      "ジョン"
    ],
    [
      "main",
      "主要"
    ],
    [
      "call",
      "訪問"
    ],
    [
      "image",
      "像"
    ],
    [
      "department",
      "局"
    ],
    [
      "title",
      "題"
    ],
    [
      "description",
      "描写"
    ],
    [
      "y",
      "き"
    ],
    [
      "insurance",
      "保険"
    ],
    [
      "another",
      "他の"
    ],
    [
      "why",
      "どうして"
    ],
    [
      "shall",
      "ようか"
    ],
    [
      "property",
      "資産"
    ],
    [
      "class",
      "クラス"
    ],
    [
      "cd",
      "ＣＤ"
    ],
    [
      "still",
      "まだ"
    ],
    [
      "money",
      "貨幣"
    ],
    [
      "quality",
      "品"
    ],
    [
      "every",
      "毎"
    ],
    [
      "content",
      "内容"
    ],
    [
      "country",
      "国家"
    ],
    [
      "private",
      "兵卒"
    ],
    [
      "little",
      "ちょっと"
    ],
    [
      "visit",
      "往訪"
    ],
    [
      "save",
      "保存する"
    ],
    [
      "low",
      "低い"
    ],
    [
      "reply",
      "返事"
    ],
    [
      "customer",
      "顧客"
    ],
    [
      "december",
      "師走"
    ],
    [
      "compare",
      "比較"
    ],
    [
      "college",
      "大学"
    ],
    [
      "value",
      "価値"
    ],
    [
      "article",
      "冠詞"
    ],
    [
      "york",
      "ヨーク家"
    ],
    [
      "man",
      "人間"
    ],
    [
      "card",
      "札"
    ],
    [
      "food",
      "食物"
    ],
    [
      "source",
      "泉"
    ],
    [
      "author",
      "作家"
    ],
    [
      "different",
      "特異"
    ],
    [
      "press",
      "棚"
    ],
    [
      "learn",
      "勉強"
    ],
    [
      "sale",
      "廉売"
    ],
    [
      "course",
      "コース"
    ],
    [
      "job",
      "ヨブ"
    ],
    [
      "canada",
      "加奈陀"
    ],
    [
      "process",
      "工程"
    ],
    [
      "room",
      "間"
    ],
    [
      "stock",
      "株"
    ],
    [
      "training",
      "訓練"
    ],
    [
      "too",
      "過ぎる"
    ],
    [
      "credit",
      "クレジット"
    ],
    [
      "point",
      "点"
    ],
    [
      "join",
      "合流"
    ],
    [
      "science",
      "科学"
    ],
    [
      "advanced",
      "上級"
    ],
    [
      "west",
      "西洋"
    ],
    [
      "look",
      "ご覧"
    ],
    [
      "english",
      "英語"
    ],
    [
      "left",
      "左翼"
    ],
    [
      "team",
      "隊"
    ],
    [
      "box",
      "入れ物"
    ],
    [
      "windows",
      "ウィンドウズ"
    ],
    [
      "gay",
      "派手"
    ],
    [
      "thread",
      "スレッド"
    ],
    [
      "week",
      "週間"
    ],
    [
      "category",
      "圏"
    ],
    [
      "note",
      "メモ"
    ],
    [
      "live",
      "住む"
    ],
    [
      "gallery",
      "桟敷"
    ],
    [
      "table",
      "テーブル"
    ],
    [
      "however",
      "けど"
    ],
    [
      "june",
      "水無月"
    ],
    [
      "october",
      "神無月"
    ],
    [
      "november",
      "霜月"
    ],
    [
      "market",
      "マーケット"
    ],
    [
      "library",
      "図書館"
    ],
    [
      "really",
      "へえ"
    ],
    [
      "action",
      "行為"
    ],
    [
      "start",
      "初め"
    ],
    [
      "series",
      "系列"
    ],
    [
      "model",
      "模型"
    ],
    [
      "air",
      "天空"
    ],
    [
      "industry",
      "工業"
    ],
    [
      "plan",
      "計画"
    ],
    [
      "human",
      "人"
    ],
    [
      "tv",
      "テレビジョン"
    ],
    [
      "yes",
      "はい"
    ],
    [
      "second",
      "秒"
    ],
    [
      "hot",
      "熱い"
    ],
    [
      "cost",
      "代償"
    ],
    [
      "march",
      "弥生"
    ],
    [
      "september",
      "長月"
    ],
    [
      "better",
      "より良い"
    ],
    [
      "say",
      "語る"
    ],
    [
      "july",
      "文月"
    ],
    [
      "test",
      "テスト"
    ],
    [
      "friend",
      "仲間"
    ],
    [
      "come",
      "成る"
    ],
    [
      "server",
      "サーバ"
    ],
    [
      "pc",
      "PC"
    ],
    [
      "study",
      "勉強"
    ],
    [
      "application",
      "出願"
    ],
    [
      "cart",
      "カート"
    ],
    [
      "staff",
      "棒"
    ],
    [
      "feedback",
      "フィードバック"
    ],
    [
      "again",
      "又"
    ],
    [
      "play",
      "遊ぶ"
    ],
    [
      "april",
      "卯月"
    ],
    [
      "never",
      "万々"
    ],
    [
      "complete",
      "全い"
    ],
    [
      "street",
      "街路"
    ],
    [
      "topic",
      "話題"
    ],
    [
      "comment",
      "コメント"
    ],
    [
      "against",
      "反して"
    ],
    [
      "standard",
      "規"
    ],
    [
      "tax",
      "税"
    ],
    [
      "person",
      "人"
    ],
    [
      "less",
      "-"
    ],
    [
      "party",
      "会合"
    ],
    [
      "payment",
      "入金"
    ],
    [
      "equipment",
      "装備"
    ],
    [
      "login",
      "ログイン"
    ],
    [
      "student",
      "大学生"
    ],
    [
      "let",
      "貸す"
    ],
    [
      "legal",
      "合法"
    ],
    [
      "park",
      "公園"
    ],
    [
      "side",
      "側"
    ],
    [
      "act",
      "行動"
    ],
    [
      "problem",
      "問題"
    ],
    [
      "red",
      "赤い"
    ],
    [
      "give",
      "くれる"
    ],
    [
      "memory",
      "記憶"
    ],
    [
      "performance",
      "公演"
    ],
    [
      "august",
      "葉月"
    ],
    [
      "quote",
      "「"
    ],
    [
      "language",
      "言語"
    ],
    [
      "story",
      "話"
    ],
    [
      "sell",
      "うる"
    ],
    [
      "experience",
      "経験"
    ],
    [
      "create",
      "創造"
    ],
    [
      "key",
      "キー"
    ],
    [
      "body",
      "身体"
    ],
    [
      "important",
      "大切"
    ],
    [
      "field",
      "畑"
    ],
    [
      "few",
      "少し"
    ],
    [
      "east",
      "東方"
    ],
    [
      "paper",
      "紙"
    ],
    [
      "single",
      "独身"
    ],
    [
      "age",
      "年齢"
    ],
    [
      "club",
      "クラブ"
    ],
    [
      "example",
      "例"
    ],
    [
      "password",
      "合言葉"
    ],
    [
      "something",
      "最高"
    ],
    [
      "road",
      "道路"
    ],
    [
      "gift",
      "天分"
    ],
    [
      "question",
      "問い"
    ],
    [
      "night",
      "夜"
    ],
    [
      "hard",
      "困難"
    ],
    [
      "texas",
      "テキサス"
    ],
    [
      "pay",
      "支払う"
    ],
    [
      "four",
      "フォー"
    ],
    [
      "poker",
      "ポーカー"
    ],
    [
      "status",
      "有様"
    ],
    [
      "range",
      "音域"
    ],
    [
      "building",
      "ビル"
    ],
    [
      "seller",
      "販売者"
    ],
    [
      "court",
      "法廷"
    ],
    [
      "february",
      "如月"
    ],
    [
      "always",
      "常に"
    ],
    [
      "result",
      "成果"
    ],
    [
      "light",
      "光"
    ],
    [
      "write",
      "書く"
    ],
    [
      "war",
      "戦"
    ],
    [
      "offer",
      "提供"
    ],
    [
      "blue",
      "青い"
    ],
    [
      "easy",
      "容易"
    ],
    [
      "event",
      "イベント"
    ],
    [
      "release",
      "リリース"
    ],
    [
      "analysis",
      "解析"
    ],
    [
      "request",
      "要望"
    ],
    [
      "fax",
      "ファックス"
    ],
    [
      "china",
      "中国"
    ],
    [
      "picture",
      "写真"
    ],
    [
      "possible",
      "可能"
    ],
    [
      "professional",
      "プロフェッショナル"
    ],
    [
      "yet",
      "まだ"
    ],
    [
      "month",
      "月間"
    ],
    [
      "major",
      "専攻"
    ],
    [
      "star",
      "星"
    ],
    [
      "future",
      "将来"
    ],
    [
      "space",
      "空間"
    ],
    [
      "hand",
      "手"
    ],
    [
      "sun",
      "日"
    ],
    [
      "london",
      "倫敦"
    ],
    [
      "washington",
      "ワシントン"
    ],
    [
      "meeting",
      "会"
    ],
    [
      "become",
      "なる"
    ],
    [
      "interest",
      "関心"
    ],
    [
      "child",
      "子"
    ],
    [
      "keep",
      "保持"
    ],
    [
      "enter",
      "入力"
    ],
    [
      "california",
      "加州"
    ],
    [
      "porn",
      "AV"
    ],
    [
      "share",
      "株"
    ],
    [
      "similar",
      "相似"
    ],
    [
      "garden",
      "庭"
    ],
    [
      "reference",
      "出典"
    ],
    [
      "baby",
      "嬰児"
    ],
    [
      "energy",
      "熱"
    ],
    [
      "run",
      "作動"
    ],
    [
      "delivery",
      "お産"
    ],
    [
      "net",
      "網"
    ],
    [
      "popular",
      "受けのよい"
    ],
    [
      "term",
      "項"
    ],
    [
      "film",
      "映画"
    ],
    [
      "put",
      "据える"
    ],
    [
      "journal",
      "日誌"
    ],
    [
      "try",
      "裁判に掛ける"
    ],
    [
      "welcome",
      "挨拶"
    ],
    [
      "central",
      "中心"
    ],
    [
      "president",
      "社長"
    ],
    [
      "notice",
      "注目"
    ],
    [
      "god",
      "神"
    ],
    [
      "original",
      "原作"
    ],
    [
      "head",
      "頭"
    ],
    [
      "radio",
      "無線"
    ],
    [
      "cell",
      "細胞"
    ],
    [
      "color",
      "幟"
    ],
    [
      "self",
      "自我"
    ],
    [
      "council",
      "評議会"
    ],
    [
      "away",
      "遠方に"
    ],
    [
      "track",
      "痕跡"
    ],
    [
      "australia",
      "濠"
    ],
    [
      "discussion",
      "討論"
    ],
    [
      "archive",
      "書庫"
    ],
    [
      "once",
      "一回"
    ],
    [
      "entertainment",
      "エンタメ"
    ],
    [
      "agreement",
      "合意"
    ],
    [
      "format",
      "形式"
    ],
    [
      "society",
      "協会"
    ],
    [
      "log",
      "薪"
    ],
    [
      "safety",
      "安全性"
    ],
    [
      "sure",
      "確信"
    ],
    [
      "trade",
      "貿易"
    ],
    [
      "tell",
      "判る"
    ],
    [
      "association",
      "協会"
    ],
    [
      "able",
      "有能"
    ],
    [
      "david",
      "ダビド"
    ],
    [
      "fun",
      "遊び"
    ],
    [
      "already",
      "もう"
    ],
    [
      "green",
      "緑"
    ],
    [
      "close",
      "閉じる"
    ],
    [
      "common",
      "ざら"
    ],
    [
      "drive",
      "ドライブ"
    ],
    [
      "specific",
      "特定"
    ],
    [
      "several",
      "個別"
    ],
    [
      "gold",
      "黄金色"
    ],
    [
      "living",
      "生活"
    ],
    [
      "collection",
      "募金"
    ],
    [
      "short",
      "低い"
    ],
    [
      "ask",
      "伺う"
    ],
    [
      "limited",
      "限る"
    ],
    [
      "means",
      "方法"
    ],
    [
      "director",
      "指揮者"
    ],
    [
      "daily",
      "日々"
    ],
    [
      "beach",
      "海岸"
    ],
    [
      "past",
      "過去形"
    ],
    [
      "natural",
      "当然"
    ],
    [
      "whether",
      "か"
    ],
    [
      "electronics",
      "電子機器"
    ],
    [
      "five",
      "ファイブ"
    ],
    [
      "period",
      "周期"
    ],
    [
      "official",
      "公"
    ],
    [
      "weather",
      "天候"
    ],
    [
      "mar",
      "台無し"
    ],
    [
      "land",
      "上陸"
    ],
    [
      "average",
      "平凡"
    ],
    [
      "done",
      "済む"
    ],
    [
      "window",
      "窓"
    ],
    [
      "france",
      "仏蘭西"
    ],
    [
      "region",
      "県"
    ],
    [
      "record",
      "収録"
    ],
    [
      "district",
      "郭"
    ],
    [
      "calendar",
      "暦"
    ],
    [
      "style",
      "様式"
    ],
    [
      "front",
      "前線"
    ],
    [
      "statement",
      "文"
    ],
    [
      "update",
      "更新"
    ],
    [
      "ever",
      "いつか"
    ],
    [
      "early",
      "初期"
    ],
    [
      "sound",
      "音"
    ],
    [
      "resource",
      "資産"
    ],
    [
      "present",
      "出席"
    ],
    [
      "either",
      "…か…か"
    ],
    [
      "ago",
      "以前"
    ],
    [
      "document",
      "文書"
    ],
    [
      "word",
      "言葉"
    ],
    [
      "material",
      "資料"
    ],
    [
      "bill",
      "勘定"
    ],
    [
      "talk",
      "話し"
    ],
    [
      "final",
      "終声"
    ],
    [
      "adult",
      "成人"
    ],
    [
      "thing",
      "物"
    ],
    [
      "via",
      "…で"
    ],
    [
      "cheap",
      "安価"
    ],
    [
      "finance",
      "財政"
    ],
    [
      "true",
      "真"
    ],
    [
      "minutes",
      "議事録"
    ],
    [
      "mark",
      "マルコ"
    ],
    [
      "third",
      "三度"
    ],
    [
      "rock",
      "岩石"
    ],
    [
      "europe",
      "欧州"
    ],
    [
      "reading",
      "読み"
    ],
    [
      "individual",
      "個々"
    ],
    [
      "plus",
      "プラス"
    ],
    [
      "cover",
      "カバー"
    ],
    [
      "usually",
      "通常"
    ],
    [
      "together",
      "一緒"
    ],
    [
      "fast",
      "速い"
    ],
    [
      "function",
      "機能"
    ],
    [
      "fact",
      "事実"
    ],
    [
      "unit",
      "一式"
    ],
    [
      "global",
      "万国"
    ],
    [
      "meet",
      "会う"
    ],
    [
      "far",
      "遠い"
    ],
    [
      "economic",
      "経済的"
    ],
    [
      "player",
      "選手"
    ],
    [
      "lyrics",
      "リリック"
    ],
    [
      "often",
      "度々"
    ],
    [
      "germany",
      "独逸"
    ],
    [
      "amount",
      "量"
    ],
    [
      "watch",
      "見張る"
    ],
    [
      "feel",
      "思う"
    ],
    [
      "though",
      "だけど"
    ],
    [
      "bank",
      "バンク"
    ],
    [
      "risk",
      "危険"
    ],
    [
      "thanks",
      "どうも"
    ],
    [
      "everything",
      "全部"
    ],
    [
      "various",
      "いろいろ"
    ],
    [
      "production",
      "製造"
    ],
    [
      "commercial",
      "ＣＭ"
    ],
    [
      "james",
      "ジェイムズ"
    ],
    [
      "weight",
      "重さ"
    ],
    [
      "town",
      "町"
    ],
    [
      "heart",
      "心臓"
    ],
    [
      "advertising",
      "アドバタイジング"
    ],
    [
      "treatment",
      "治療"
    ],
    [
      "knowledge",
      "学識"
    ],
    [
      "magazine",
      "弾倉"
    ],
    [
      "error",
      "エラー"
    ],
    [
      "camera",
      "写真機"
    ],
    [
      "girl",
      "女"
    ],
    [
      "construction",
      "ビル"
    ],
    [
      "clear",
      "晴れる"
    ],
    [
      "receive",
      "受け取る"
    ],
    [
      "domain",
      "始域"
    ],
    [
      "protection",
      "防護"
    ],
    [
      "loan",
      "融資"
    ],
    [
      "wide",
      "幅広い"
    ],
    [
      "beauty",
      "別嬪"
    ],
    [
      "manager",
      "店長"
    ],
    [
      "india",
      "印度"
    ],
    [
      "position",
      "配置"
    ],
    [
      "sort",
      "ソート"
    ],
    [
      "michael",
      "マイクル"
    ],
    [
      "half",
      "ハーフ"
    ],
    [
      "step",
      "行程"
    ],
    [
      "engineering",
      "工務"
    ],
    [
      "simple",
      "単純"
    ],
    [
      "quick",
      "早い"
    ],
    [
      "wireless",
      "ワイヤレス"
    ],
    [
      "license",
      "ライセンス"
    ],
    [
      "paul",
      "ポール"
    ],
    [
      "friday",
      "金曜"
    ],
    [
      "lake",
      "湖"
    ],
    [
      "later",
      "後"
    ],
    [
      "basic",
      "基礎"
    ],
    [
      "google",
      "グーグる"
    ],
    [
      "church",
      "教会"
    ],
    [
      "method",
      "方式"
    ],
    [
      "purchase",
      "購買"
    ],
    [
      "active",
      "能動的"
    ],
    [
      "response",
      "回答"
    ],
    [
      "practice",
      "儀式"
    ],
    [
      "hardware",
      "ハード"
    ],
    [
      "figure",
      "体型"
    ],
    [
      "fire",
      "火事"
    ],
    [
      "holiday",
      "休日"
    ],
    [
      "chat",
      "会話"
    ],
    [
      "enough",
      "充分"
    ],
    [
      "among",
      "間"
    ],
    [
      "death",
      "死神"
    ],
    [
      "writing",
      "執筆"
    ],
    [
      "speed",
      "速度"
    ],
    [
      "html",
      "エイチ・ティー・エム・エル"
    ],
    [
      "loss",
      "損益"
    ],
    [
      "face",
      "面"
    ],
    [
      "discount",
      "値引き"
    ],
    [
      "remember",
      "記憶"
    ],
    [
      "oil",
      "油"
    ],
    [
      "bit",
      "少々"
    ],
    [
      "yellow",
      "臆病"
    ],
    [
      "increase",
      "増大"
    ],
    [
      "advertise",
      "宣伝"
    ],
    [
      "kingdom",
      "界"
    ],
    [
      "base",
      "塁"
    ],
    [
      "thought",
      "思索"
    ],
    [
      "stuff",
      "もの"
    ],
    [
      "french",
      "フランス人"
    ],
    [
      "storage",
      "貯蔵"
    ],
    [
      "oh",
      "お"
    ],
    [
      "japan",
      "倭"
    ],
    [
      "doing",
      "仕業"
    ],
    [
      "entry",
      "入口"
    ],
    [
      "stay",
      "宿泊"
    ],
    [
      "nature",
      "性質"
    ],
    [
      "availability",
      "可用性"
    ],
    [
      "africa",
      "阿弗利加"
    ],
    [
      "summary",
      "大要"
    ],
    [
      "turn",
      "番"
    ],
    [
      "mean",
      "意味"
    ],
    [
      "growth",
      "生長"
    ],
    [
      "king",
      "国王"
    ],
    [
      "monday",
      "月曜"
    ],
    [
      "european",
      "欧州"
    ],
    [
      "activity",
      "活動"
    ],
    [
      "copy",
      "コピー"
    ],
    [
      "although",
      "でも"
    ],
    [
      "drug",
      "薬剤"
    ],
    [
      "western",
      "西方の"
    ],
    [
      "income",
      "所得"
    ],
    [
      "force",
      "勢力"
    ],
    [
      "cash",
      "キャッシュ"
    ],
    [
      "employment",
      "雇用"
    ],
    [
      "bay",
      "入江"
    ],
    [
      "river",
      "川"
    ],
    [
      "commission",
      "任務"
    ],
    [
      "ad",
      "西暦"
    ],
    [
      "package",
      "包み"
    ],
    [
      "contents",
      "内容"
    ],
    [
      "engine",
      "エンジン"
    ],
    [
      "port",
      "左舷"
    ],
    [
      "album",
      "写真帖"
    ],
    [
      "stop",
      "止める"
    ],
    [
      "administration",
      "官庁"
    ],
    [
      "bar",
      "棒"
    ],
    [
      "institute",
      "大学"
    ],
    [
      "double",
      "二倍"
    ],
    [
      "dog",
      "犬"
    ],
    [
      "build",
      "建設"
    ],
    [
      "screen",
      "スクリーン"
    ],
    [
      "exchange",
      "交流"
    ],
    [
      "soon",
      "近々"
    ],
    [
      "electronic",
      "電子"
    ],
    [
      "continue",
      "続く"
    ],
    [
      "across",
      "向こう"
    ],
    [
      "season",
      "旬"
    ],
    [
      "apply",
      "申し込む"
    ],
    [
      "someone",
      "或る人"
    ],
    [
      "printer",
      "印刷工"
    ],
    [
      "condition",
      "条件"
    ],
    [
      "believe",
      "思う"
    ],
    [
      "organization",
      "団体"
    ],
    [
      "effect",
      "作用"
    ],
    [
      "mind",
      "念頭"
    ],
    [
      "sunday",
      "日曜"
    ],
    [
      "casino",
      "賭場"
    ],
    [
      "tour",
      "旅"
    ],
    [
      "menu",
      "お品書き"
    ],
    [
      "volume",
      "ボリューム"
    ],
    [
      "cross",
      "十字"
    ],
    [
      "anyone",
      "誰も"
    ],
    [
      "mortgage",
      "抵当権"
    ],
    [
      "hope",
      "希望"
    ],
    [
      "silver",
      "銀"
    ],
    [
      "wish",
      "希望"
    ],
    [
      "inside",
      "に"
    ],
    [
      "solution",
      "解決"
    ],
    [
      "mature",
      "円熟"
    ],
    [
      "role",
      "役割"
    ],
    [
      "rather",
      "一層"
    ],
    [
      "addition",
      "建て増し"
    ],
    [
      "supply",
      "供給"
    ],
    [
      "nothing",
      "何でもない"
    ],
    [
      "certain",
      "某"
    ],
    [
      "running",
      "走り"
    ],
    [
      "lower",
      "下ろす"
    ],
    [
      "necessary",
      "当然"
    ],
    [
      "union",
      "同盟"
    ],
    [
      "clothing",
      "衣服"
    ],
    [
      "mon",
      "月曜"
    ],
    [
      "particular",
      "特有"
    ],
    [
      "fine",
      "平凡"
    ],
    [
      "hour",
      "時"
    ],
    [
      "gas",
      "気体"
    ],
    [
      "six",
      "シックス"
    ],
    [
      "bush",
      "灌木"
    ],
    [
      "advice",
      "忠告"
    ],
    [
      "career",
      "キャリア"
    ],
    [
      "military",
      "軍事的"
    ],
    [
      "rental",
      "賃貸し"
    ],
    [
      "decision",
      "決心"
    ],
    [
      "leave",
      "出発"
    ],
    [
      "british",
      "英国"
    ],
    [
      "sat",
      "土曜"
    ],
    [
      "woman",
      "女人"
    ],
    [
      "bid",
      "入札"
    ],
    [
      "kind",
      "優しい"
    ],
    [
      "middle",
      "中央"
    ],
    [
      "move",
      "動く"
    ],
    [
      "cable",
      "電線"
    ],
    [
      "division",
      "部"
    ],
    [
      "tuesday",
      "火曜"
    ],
    [
      "object",
      "物"
    ],
    [
      "lesbian",
      "レズ"
    ],
    [
      "appropriate",
      "私"
    ],
    [
      "machine",
      "器械"
    ],
    [
      "logo",
      "ロゴタイプ"
    ],
    [
      "length",
      "全長"
    ],
    [
      "actually",
      "本当"
    ],
    [
      "nice",
      "素敵"
    ],
    [
      "score",
      "得点"
    ],
    [
      "statistics",
      "統計"
    ],
    [
      "client",
      "クライアント"
    ],
    [
      "ok",
      "オーケー"
    ],
    [
      "capital",
      "主"
    ],
    [
      "follow",
      "追う"
    ],
    [
      "sample",
      "サンプル"
    ],
    [
      "saturday",
      "土曜"
    ],
    [
      "christmas",
      "聖誕祭"
    ],
    [
      "england",
      "英国"
    ],
    [
      "culture",
      "培養"
    ],
    [
      "band",
      "条片"
    ],
    [
      "flash",
      "閃光"
    ],
    [
      "lead",
      "率いる"
    ],
    [
      "choice",
      "最適"
    ],
    [
      "registration",
      "受付"
    ],
    [
      "fri",
      "金曜"
    ],
    [
      "thursday",
      "木曜"
    ],
    [
      "hi",
      "やあ"
    ],
    [
      "airport",
      "飛行場"
    ],
    [
      "foreign",
      "外国の"
    ],
    [
      "artist",
      "画家"
    ],
    [
      "channel",
      "海峡"
    ],
    [
      "letter",
      "字"
    ],
    [
      "wednesday",
      "水曜"
    ],
    [
      "structure",
      "構成"
    ],
    [
      "fund",
      "基金"
    ],
    [
      "summer",
      "夏季"
    ],
    [
      "allow",
      "許す"
    ],
    [
      "degree",
      "度"
    ],
    [
      "contract",
      "罹る"
    ],
    [
      "button",
      "バッジ"
    ],
    [
      "wed",
      "娶る"
    ],
    [
      "super",
      "超"
    ],
    [
      "male",
      "牡"
    ],
    [
      "matter",
      "物質"
    ],
    [
      "custom",
      "風俗"
    ],
    [
      "almost",
      "ほぼ"
    ],
    [
      "asian",
      "南アジア人"
    ],
    [
      "distribution",
      "配分"
    ],
    [
      "editor",
      "編集機"
    ],
    [
      "inn",
      "旅館"
    ],
    [
      "cause",
      "原因"
    ],
    [
      "potential",
      "電位"
    ],
    [
      "song",
      "歌曲"
    ],
    [
      "focus",
      "集中"
    ],
    [
      "late",
      "故"
    ],
    [
      "fall",
      "降る"
    ],
    [
      "idea",
      "主意"
    ],
    [
      "female",
      "女"
    ],
    [
      "win",
      "勝ち"
    ],
    [
      "thomas",
      "トマス"
    ],
    [
      "cancer",
      "かに座"
    ],
    [
      "reason",
      "原因"
    ],
    [
      "tool",
      "道具"
    ],
    [
      "spring",
      "泉"
    ],
    [
      "foundation",
      "礎"
    ],
    [
      "answer",
      "回答"
    ],
    [
      "voice",
      "声"
    ],
    [
      "friendly",
      "友好的"
    ],
    [
      "schedule",
      "予定"
    ],
    [
      "communication",
      "交流"
    ],
    [
      "purpose",
      "意向"
    ],
    [
      "bed",
      "寝台"
    ],
    [
      "everyone",
      "だれも"
    ],
    [
      "independent",
      "無所属"
    ],
    [
      "approach",
      "接近"
    ],
    [
      "brown",
      "褐色"
    ],
    [
      "physical",
      "肉体"
    ],
    [
      "hill",
      "傾き"
    ],
    [
      "medicine",
      "医学"
    ],
    [
      "deal",
      "得"
    ],
    [
      "hold",
      "保持する"
    ],
    [
      "glass",
      "玻璃"
    ],
    [
      "happy",
      "幸福"
    ],
    [
      "tue",
      "火曜"
    ],
    [
      "smith",
      "加治"
    ],
    [
      "developed",
      "開発"
    ],
    [
      "thank",
      "感謝"
    ],
    [
      "safe",
      "セーフ"
    ],
    [
      "unique",
      "唯一"
    ],
    [
      "survey",
      "見渡す"
    ],
    [
      "prior",
      "先"
    ],
    [
      "telephone",
      "電話をかける"
    ],
    [
      "sport",
      "運動"
    ],
    [
      "ready",
      "準備の出来た"
    ],
    [
      "feed",
      "飼う"
    ],
    [
      "animal",
      "動物"
    ],
    [
      "mexico",
      "墨西哥"
    ],
    [
      "population",
      "人口"
    ],
    [
      "regular",
      "規則"
    ],
    [
      "therefore",
      "故に"
    ],
    [
      "ass",
      "穴"
    ],
    [
      "station",
      "駅"
    ],
    [
      "christian",
      "クリスチャン"
    ],
    [
      "round",
      "円"
    ],
    [
      "understand",
      "理解"
    ],
    [
      "option",
      "選択"
    ],
    [
      "master",
      "匠"
    ],
    [
      "valley",
      "渓谷"
    ],
    [
      "recently",
      "先頃"
    ],
    [
      "probably",
      "多分"
    ],
    [
      "thu",
      "木曜"
    ],
    [
      "blood",
      "血液"
    ],
    [
      "cut",
      "休む"
    ],
    [
      "improve",
      "良い"
    ],
    [
      "connection",
      "結合"
    ],
    [
      "publisher",
      "発行者"
    ],
    [
      "hall",
      "寮"
    ],
    [
      "earth",
      "土"
    ],
    [
      "transfer",
      "移す"
    ],
    [
      "introduction",
      "序"
    ],
    [
      "kitchen",
      "勝手"
    ],
    [
      "strong",
      "強い"
    ],
    [
      "tel",
      "電番"
    ],
    [
      "wedding",
      "婚礼"
    ],
    [
      "hospital",
      "医院"
    ],
    [
      "ground",
      "土"
    ],
    [
      "ship",
      "船"
    ],
    [
      "accommodation",
      "設備"
    ],
    [
      "disease",
      "疾病"
    ],
    [
      "excellent",
      "秀でる"
    ],
    [
      "italy",
      "伊太利"
    ],
    [
      "perfect",
      "全い"
    ],
    [
      "hair",
      "毛"
    ],
    [
      "opportunity",
      "チャンス"
    ],
    [
      "kit",
      "設備"
    ],
    [
      "classic",
      "クラシック"
    ],
    [
      "basis",
      "基底"
    ],
    [
      "command",
      "驅使"
    ],
    [
      "william",
      "ウィレム"
    ],
    [
      "express",
      "明白"
    ],
    [
      "award",
      "表彰"
    ],
    [
      "distance",
      "遠方"
    ],
    [
      "tree",
      "木"
    ],
    [
      "peter",
      "ピーター"
    ],
    [
      "thus",
      "それ故"
    ],
    [
      "wall",
      "壁"
    ],
    [
      "especially",
      "とりわけ"
    ],
    [
      "pussy",
      "小猫"
    ],
    [
      "budget",
      "バジェット"
    ],
    [
      "maximum",
      "極大"
    ],
    [
      "ma",
      "馬"
    ],
    [
      "operation",
      "オペ"
    ],
    [
      "quite",
      "丸で"
    ],
    [
      "boy",
      "坊や"
    ],
    [
      "amazon",
      "アマゾン"
    ],
    [
      "beautiful",
      "素敵"
    ],
    [
      "wine",
      "果実酒"
    ],
    [
      "horse",
      "うま"
    ],
    [
      "vote",
      "投票する"
    ],
    [
      "forward",
      "前方"
    ],
    [
      "significant",
      "重要"
    ],
    [
      "owner",
      "主人"
    ],
    [
      "retail",
      "小売り"
    ],
    [
      "useful",
      "便利"
    ],
    [
      "manufacturer",
      "生産者"
    ],
    [
      "est",
      "も"
    ],
    [
      "son",
      "せがれ"
    ],
    [
      "rule",
      "掟"
    ],
    [
      "housing",
      "筐体"
    ],
    [
      "bring",
      "持って行く"
    ],
    [
      "mother",
      "元"
    ],
    [
      "authority",
      "強権"
    ],
    [
      "traffic",
      "交信"
    ],
    [
      "input",
      "入力"
    ],
    [
      "strategy",
      "戦術"
    ],
    [
      "modern",
      "現代"
    ],
    [
      "senior",
      "年上"
    ],
    [
      "ireland",
      "アイルランド島"
    ],
    [
      "sexy",
      "色っぽい"
    ],
    [
      "teaching",
      "教授"
    ],
    [
      "door",
      "扉"
    ],
    [
      "trial",
      "試し"
    ],
    [
      "charge",
      "充電"
    ],
    [
      "canadian",
      "カナダの"
    ],
    [
      "cool",
      "素敵"
    ],
    [
      "normal",
      "正常"
    ],
    [
      "enterprise",
      "事業"
    ],
    [
      "entire",
      "全部"
    ],
    [
      "educational",
      "教育的"
    ],
    [
      "metal",
      "金"
    ],
    [
      "positive",
      "正"
    ],
    [
      "fitness",
      "健康"
    ],
    [
      "chinese",
      "中国語"
    ],
    [
      "opinion",
      "見解"
    ],
    [
      "mb",
      "㎆"
    ],
    [
      "asia",
      "亜洲"
    ],
    [
      "football",
      "蹴球"
    ],
    [
      "abstract",
      "抽出"
    ],
    [
      "likely",
      "きっと"
    ],
    [
      "develop",
      "発達"
    ],
    [
      "resolution",
      "決心"
    ],
    [
      "java",
      "ジャバ"
    ],
    [
      "guest",
      "客"
    ],
    [
      "publication",
      "公表"
    ],
    [
      "pass",
      "パス"
    ],
    [
      "trust",
      "信任"
    ],
    [
      "van",
      "客車"
    ],
    [
      "session",
      "会議"
    ],
    [
      "photography",
      "撮影"
    ],
    [
      "republic",
      "民国"
    ],
    [
      "vacation",
      "休み"
    ],
    [
      "century",
      "せいき"
    ],
    [
      "academic",
      "大学"
    ],
    [
      "assistance",
      "助け"
    ],
    [
      "skin",
      "肌"
    ],
    [
      "indian",
      "インディアン"
    ],
    [
      "mary",
      "マリー"
    ],
    [
      "expected",
      "想定内"
    ],
    [
      "ring",
      "環"
    ],
    [
      "grade",
      "年"
    ],
    [
      "pacific",
      "穏やか"
    ],
    [
      "mountain",
      "山"
    ],
    [
      "pop",
      "ポップス"
    ],
    [
      "filter",
      "フィルター"
    ],
    [
      "vehicle",
      "車両"
    ],
    [
      "consider",
      "熟慮"
    ],
    [
      "floor",
      "床関数"
    ],
    [
      "german",
      "ドイツ語"
    ],
    [
      "match",
      "回戦"
    ],
    [
      "require",
      "必要"
    ],
    [
      "outdoor",
      "屋外"
    ],
    [
      "deep",
      "深い"
    ],
    [
      "morning",
      "午前"
    ],
    [
      "otherwise",
      "その他"
    ],
    [
      "rest",
      "休み"
    ],
    [
      "protein",
      "プロテイン"
    ],
    [
      "plant",
      "草"
    ],
    [
      "hit",
      "ヒット"
    ],
    [
      "transportation",
      "流罪"
    ],
    [
      "pool",
      "ポケットビリヤード"
    ],
    [
      "partner",
      "伴侶"
    ],
    [
      "faculty",
      "学部"
    ],
    [
      "fish",
      "魚"
    ],
    [
      "membership",
      "会員"
    ],
    [
      "mission",
      "伝道"
    ],
    [
      "eye",
      "目"
    ],
    [
      "string",
      "弦"
    ],
    [
      "sense",
      "感覚"
    ],
    [
      "pack",
      "包む"
    ],
    [
      "stage",
      "段"
    ],
    [
      "goods",
      "品"
    ],
    [
      "detailed",
      "詳細"
    ],
    [
      "japanese",
      "ジャパニーズ"
    ],
    [
      "race",
      "人種"
    ],
    [
      "background",
      "背景"
    ],
    [
      "target",
      "ターゲット"
    ],
    [
      "except",
      "除外"
    ],
    [
      "character",
      "記号"
    ],
    [
      "maintenance",
      "維持"
    ],
    [
      "ability",
      "才能"
    ],
    [
      "maybe",
      "若しや"
    ],
    [
      "ed",
      "味"
    ],
    [
      "pretty",
      "きれい"
    ],
    [
      "spain",
      "西班牙"
    ],
    [
      "yourself",
      "自分"
    ],
    [
      "winter",
      "ふゆ"
    ],
    [
      "rape",
      "レイプ"
    ],
    [
      "battery",
      "バッテリー"
    ],
    [
      "youth",
      "若者"
    ],
    [
      "pressure",
      "重圧"
    ],
    [
      "incest",
      "インセスト"
    ],
    [
      "debt",
      "負債"
    ],
    [
      "television",
      "電視"
    ],
    [
      "core",
      "芯"
    ],
    [
      "break",
      "休憩"
    ],
    [
      "dance",
      "舞踊"
    ],
    [
      "wood",
      "木材"
    ],
    [
      "fee",
      "費"
    ],
    [
      "studio",
      "工房"
    ],
    [
      "reader",
      "リーダー"
    ],
    [
      "virtual",
      "仮想の"
    ],
    [
      "device",
      "デバイス"
    ],
    [
      "rent",
      "貸す"
    ],
    [
      "remote",
      "遠い"
    ],
    [
      "dark",
      "暗い"
    ],
    [
      "external",
      "外部"
    ],
    [
      "apple",
      "苹果"
    ],
    [
      "regarding",
      "対する"
    ],
    [
      "theory",
      "学説"
    ],
    [
      "enjoy",
      "享受"
    ],
    [
      "remove",
      "移す"
    ],
    [
      "aid",
      "支援"
    ],
    [
      "minimum",
      "最低"
    ],
    [
      "host",
      "司会"
    ],
    [
      "manual",
      "手引き"
    ],
    [
      "block",
      "阻む"
    ],
    [
      "fair",
      "フェア"
    ],
    [
      "civil",
      "民事上"
    ],
    [
      "steel",
      "鋼"
    ],
    [
      "fixed",
      "安定的"
    ],
    [
      "wrong",
      "悪い"
    ],
    [
      "beginning",
      "到来"
    ],
    [
      "finally",
      "等々"
    ],
    [
      "desktop",
      "デスクトップ"
    ],
    [
      "paris",
      "パリ"
    ],
    [
      "ohio",
      "オハイオ"
    ],
    [
      "un",
      "UN"
    ],
    [
      "fat",
      "脂"
    ],
    [
      "father",
      "お父さん"
    ],
    [
      "electric",
      "電気的"
    ],
    [
      "saw",
      "挽く"
    ],
    [
      "officer",
      "士官"
    ],
    [
      "driver",
      "ドライバー"
    ],
    [
      "dead",
      "亡い"
    ],
    [
      "respect",
      "崇敬"
    ],
    [
      "unknown",
      "不明"
    ],
    [
      "restaurant",
      "食堂"
    ],
    [
      "trip",
      "旅"
    ],
    [
      "poor",
      "哀れ"
    ],
    [
      "teacher",
      "教師"
    ],
    [
      "relationship",
      "血縁"
    ],
    [
      "georgia",
      "ジョージア"
    ],
    [
      "peace",
      "平和"
    ],
    [
      "traditional",
      "伝統的な"
    ],
    [
      "campus",
      "学園"
    ],
    [
      "creative",
      "独創的"
    ],
    [
      "benefit",
      "利益"
    ],
    [
      "progress",
      "進歩"
    ],
    [
      "funding",
      "資金"
    ],
    [
      "lord",
      "主"
    ],
    [
      "grant",
      "授与"
    ],
    [
      "agree",
      "同意"
    ],
    [
      "fiction",
      "小説"
    ],
    [
      "hear",
      "伺う"
    ],
    [
      "sometimes",
      "まま"
    ],
    [
      "museum",
      "美術館"
    ],
    [
      "fan",
      "扇"
    ],
    [
      "transport",
      "輸送"
    ],
    [
      "interesting",
      "興味深い"
    ],
    [
      "wife",
      "夫人"
    ],
    [
      "former",
      "前者"
    ],
    [
      "implementation",
      "実装"
    ],
    [
      "ten",
      "とお"
    ],
    [
      "zone",
      "地区"
    ],
    [
      "complex",
      "複雑"
    ],
    [
      "th",
      "目"
    ],
    [
      "cat",
      "猫"
    ],
    [
      "die",
      "壊れる"
    ],
    [
      "jack",
      "ジャック"
    ],
    [
      "flat",
      "変"
    ],
    [
      "flow",
      "流れる"
    ],
    [
      "literature",
      "文学"
    ],
    [
      "parent",
      "親"
    ],
    [
      "spanish",
      "スペイン"
    ],
    [
      "dr",
      "博士"
    ],
    [
      "scale",
      "秤"
    ],
    [
      "stand",
      "立つ"
    ],
    [
      "helpful",
      "役に立つ"
    ],
    [
      "monthly",
      "月次"
    ],
    [
      "critical",
      "危殆"
    ],
    [
      "frame",
      "枠"
    ],
    [
      "musical",
      "音楽"
    ],
    [
      "definition",
      "語義"
    ],
    [
      "secretary",
      "大臣"
    ],
    [
      "path",
      "道"
    ],
    [
      "australian",
      "豪"
    ],
    [
      "employee",
      "職員"
    ],
    [
      "chief",
      "長"
    ],
    [
      "bottom",
      "凹"
    ],
    [
      "pet",
      "愛撫"
    ],
    [
      "begin",
      "開始"
    ],
    [
      "royal",
      "王室"
    ],
    [
      "clean",
      "整理"
    ],
    [
      "switch",
      "切り替える"
    ],
    [
      "russian",
      "露"
    ],
    [
      "guy",
      "奴"
    ],
    [
      "relevant",
      "関連"
    ],
    [
      "justice",
      "法官"
    ],
    [
      "connect",
      "繋げる"
    ],
    [
      "bible",
      "経典"
    ],
    [
      "cup",
      "カップ"
    ],
    [
      "basket",
      "バスケット"
    ],
    [
      "installation",
      "取り付け"
    ],
    [
      "demand",
      "要求"
    ],
    [
      "suite",
      "組曲"
    ],
    [
      "square",
      "正方形"
    ],
    [
      "attention",
      "注目"
    ],
    [
      "advance",
      "進む"
    ],
    [
      "skip",
      "飛ばす"
    ],
    [
      "diet",
      "国会"
    ],
    [
      "army",
      "軍隊"
    ],
    [
      "auction",
      "競"
    ],
    [
      "difference",
      "差"
    ],
    [
      "allowed",
      "許可"
    ],
    [
      "correct",
      "修正"
    ],
    [
      "charles",
      "チャールズ"
    ],
    [
      "nation",
      "国"
    ],
    [
      "piece",
      "一片"
    ],
    [
      "sheet",
      "枚"
    ],
    [
      "seven",
      "七つ"
    ],
    [
      "species",
      "種類"
    ],
    [
      "jump",
      "跳躍"
    ],
    [
      "random",
      "任意"
    ],
    [
      "pricing",
      "値付け"
    ],
    [
      "certificate",
      "証書"
    ],
    [
      "minister",
      "大臣"
    ],
    [
      "motion",
      "動議"
    ],
    [
      "looks",
      "容貌"
    ],
    [
      "fashion",
      "流行"
    ],
    [
      "documentation",
      "文書"
    ],
    [
      "forest",
      "林"
    ],
    [
      "whose",
      "誰"
    ],
    [
      "couple",
      "偶力"
    ],
    [
      "chance",
      "機"
    ],
    [
      "vision",
      "像"
    ],
    [
      "ball",
      "玉"
    ],
    [
      "ending",
      "結び"
    ],
    [
      "discuss",
      "商議"
    ],
    [
      "accept",
      "受理"
    ],
    [
      "goal",
      "ゴール"
    ],
    [
      "wind",
      "息"
    ],
    [
      "situation",
      "境遇"
    ],
    [
      "appear",
      "そう"
    ],
    [
      "emergency",
      "非常時"
    ],
    [
      "currency",
      "貨幣"
    ],
    [
      "leather",
      "革"
    ],
    [
      "determine",
      "決定"
    ],
    [
      "temperature",
      "熱"
    ],
    [
      "palm",
      "掌"
    ],
    [
      "patient",
      "我慢強い"
    ],
    [
      "actual",
      "実際"
    ],
    [
      "stone",
      "石"
    ],
    [
      "commerce",
      "交易"
    ],
    [
      "perhaps",
      "多分"
    ],
    [
      "difficult",
      "困難"
    ],
    [
      "satellite",
      "衛星"
    ],
    [
      "fit",
      "合う"
    ],
    [
      "village",
      "村落"
    ],
    [
      "amateur",
      "しろうと"
    ],
    [
      "ex",
      "元カノ"
    ],
    [
      "pain",
      "苦痛"
    ],
    [
      "coffee",
      "コーヒー"
    ],
    [
      "cum",
      "精液"
    ],
    [
      "buyer",
      "購買者"
    ],
    [
      "cultural",
      "文化的"
    ],
    [
      "easily",
      "易い"
    ],
    [
      "ford",
      "渡る"
    ],
    [
      "edge",
      "刃"
    ],
    [
      "functional",
      "関数オブジェクト"
    ],
    [
      "root",
      "根"
    ],
    [
      "closed",
      "準備中"
    ],
    [
      "ice",
      "アイス"
    ],
    [
      "pink",
      "桃色"
    ],
    [
      "balance",
      "残額"
    ],
    [
      "monitoring",
      "監視"
    ],
    [
      "graduate",
      "目盛る"
    ],
    [
      "shot",
      "散弾"
    ],
    [
      "architecture",
      "建築学"
    ],
    [
      "initial",
      "声母"
    ],
    [
      "label",
      "札"
    ],
    [
      "recommend",
      "推薦"
    ],
    [
      "canon",
      "カノン"
    ],
    [
      "league",
      "連盟"
    ],
    [
      "waste",
      "無駄"
    ],
    [
      "minute",
      "会議録"
    ],
    [
      "bus",
      "バス"
    ],
    [
      "dictionary",
      "字典"
    ],
    [
      "cold",
      "冷たい"
    ],
    [
      "accounting",
      "経理"
    ],
    [
      "chair",
      "ソファ"
    ],
    [
      "fishing",
      "漁"
    ],
    [
      "bag",
      "鞄"
    ],
    [
      "fantasy",
      "幻想"
    ],
    [
      "motor",
      "機械"
    ],
    [
      "professor",
      "先生"
    ],
    [
      "context",
      "文脈"
    ],
    [
      "install",
      "導入"
    ],
    [
      "shirt",
      "ワイシャツ"
    ],
    [
      "generally",
      "通常"
    ],
    [
      "foot",
      "フィート"
    ],
    [
      "mass",
      "ミサ"
    ],
    [
      "crime",
      "罪"
    ],
    [
      "breast",
      "胸"
    ],
    [
      "quickly",
      "はやい"
    ],
    [
      "claim",
      "請求"
    ],
    [
      "permission",
      "許可"
    ],
    [
      "surgery",
      "外科"
    ],
    [
      "heat",
      "熱"
    ],
    [
      "miss",
      "お嬢"
    ],
    [
      "chemical",
      "化学"
    ],
    [
      "task",
      "任務"
    ],
    [
      "reduce",
      "削減"
    ],
    [
      "nor",
      "否定論理和"
    ],
    [
      "exercise",
      "体操"
    ],
    [
      "bug",
      "熱"
    ],
    [
      "leader",
      "長"
    ],
    [
      "diamond",
      "ダイヤ"
    ],
    [
      "soft",
      "軟らかい"
    ],
    [
      "alone",
      "一人"
    ],
    [
      "arizona",
      "アリゾナ州"
    ],
    [
      "flight",
      "飛"
    ],
    [
      "congress",
      "議会"
    ],
    [
      "username",
      "ログイン"
    ],
    [
      "walk",
      "四球"
    ],
    [
      "fuck",
      "犯す"
    ],
    [
      "italian",
      "イタリア語"
    ],
    [
      "wait",
      "ウエイターをする"
    ],
    [
      "pocket",
      "懐中"
    ],
    [
      "saint",
      "聖"
    ],
    [
      "rose",
      "薔薇"
    ],
    [
      "argument",
      "項"
    ],
    [
      "competition",
      "コンペ"
    ],
    [
      "fresh",
      "新鮮"
    ],
    [
      "upgrade",
      "改善"
    ],
    [
      "factor",
      "因子"
    ],
    [
      "stream",
      "小川"
    ],
    [
      "hearing",
      "聴力"
    ],
    [
      "eastern",
      "東方"
    ],
    [
      "therapy",
      "治癒"
    ],
    [
      "serious",
      "真面目"
    ],
    [
      "prime",
      "素"
    ],
    [
      "samsung",
      "三星"
    ],
    [
      "limit",
      "限る"
    ],
    [
      "bondage",
      "緊縛"
    ],
    [
      "quantity",
      "分量"
    ],
    [
      "essential",
      "肝心"
    ],
    [
      "platform",
      "台"
    ],
    [
      "load",
      "多く"
    ],
    [
      "immediately",
      "直接"
    ],
    [
      "defense",
      "防禦"
    ],
    [
      "heavy",
      "多量"
    ],
    [
      "recovery",
      "回復"
    ],
    [
      "configuration",
      "構成"
    ],
    [
      "expert",
      "名人"
    ],
    [
      "universal",
      "万能"
    ],
    [
      "protect",
      "保護"
    ],
    [
      "drop",
      "雫"
    ],
    [
      "solid",
      "中実"
    ],
    [
      "presentation",
      "贈呈"
    ],
    [
      "orange",
      "橙"
    ],
    [
      "compliance",
      "順法"
    ],
    [
      "theme",
      "テーマ"
    ],
    [
      "rich",
      "富有"
    ],
    [
      "campaign",
      "戦役"
    ],
    [
      "marine",
      "海兵隊者"
    ],
    [
      "spirit",
      "酒"
    ],
    [
      "challenge",
      "挑戦"
    ],
    [
      "seem",
      "そう"
    ],
    [
      "touch",
      "接触"
    ],
    [
      "hire",
      "雇う"
    ],
    [
      "election",
      "選任"
    ],
    [
      "suggest",
      "提案"
    ],
    [
      "branch",
      "分局"
    ],
    [
      "serve",
      "勤務"
    ],
    [
      "magic",
      "手品"
    ],
    [
      "smart",
      "上品"
    ],
    [
      "latin",
      "ラテン"
    ],
    [
      "multimedia",
      "複合媒体"
    ],
    [
      "avoid",
      "斎む"
    ],
    [
      "corner",
      "コーナー"
    ],
    [
      "computing",
      "計算機科学"
    ],
    [
      "element",
      "要素"
    ],
    [
      "birth",
      "出生"
    ],
    [
      "virus",
      "病毒"
    ],
    [
      "abuse",
      "侮辱"
    ],
    [
      "separate",
      "別れる"
    ],
    [
      "quarter",
      "四半期"
    ],
    [
      "procedure",
      "手順"
    ],
    [
      "leadership",
      "指導力"
    ],
    [
      "religious",
      "宗教的"
    ],
    [
      "breakfast",
      "朝飯"
    ],
    [
      "kong",
      "槓"
    ],
    [
      "column",
      "コラム"
    ],
    [
      "faith",
      "信仰"
    ],
    [
      "chain",
      "チェーン"
    ],
    [
      "developer",
      "プログラマー"
    ],
    [
      "approximately",
      "約"
    ],
    [
      "domestic",
      "国内"
    ],
    [
      "reach",
      "伸ばす"
    ],
    [
      "mental",
      "精神的"
    ],
    [
      "moment",
      "一刻"
    ],
    [
      "sequence",
      "数列"
    ],
    [
      "inch",
      "吋"
    ],
    [
      "sorry",
      "残念"
    ],
    [
      "damage",
      "損傷"
    ],
    [
      "reserve",
      "予約"
    ],
    [
      "plastic",
      "プラ"
    ],
    [
      "produce",
      "製造する"
    ],
    [
      "snow",
      "雪"
    ],
    [
      "truth",
      "本当"
    ],
    [
      "counter",
      "カウンタ"
    ],
    [
      "failure",
      "失敗作"
    ],
    [
      "weekend",
      "土日"
    ],
    [
      "dollar",
      "弗"
    ],
    [
      "camp",
      "幕営"
    ],
    [
      "ontario",
      "オンタリオ湖"
    ],
    [
      "minnesota",
      "ミネソタ州"
    ],
    [
      "bridge",
      "橋"
    ],
    [
      "native",
      "自国"
    ],
    [
      "fill",
      "一杯"
    ],
    [
      "williams",
      "ウィリアムズ"
    ],
    [
      "movement",
      "楽章"
    ],
    [
      "baseball",
      "野球ボール"
    ],
    [
      "approval",
      "承認"
    ],
    [
      "draft",
      "生"
    ],
    [
      "chart",
      "チャート"
    ],
    [
      "jesus",
      "耶蘇"
    ],
    [
      "lcd",
      "液晶"
    ],
    [
      "equal",
      "同じ"
    ],
    [
      "adventure",
      "冒険"
    ],
    [
      "profit",
      "利潤"
    ],
    [
      "assistant",
      "手伝い"
    ],
    [
      "variable",
      "可変"
    ],
    [
      "advertisement",
      "CM"
    ],
    [
      "expect",
      "予期する"
    ],
    [
      "parking",
      "駐車場"
    ],
    [
      "workshop",
      "研修会"
    ],
    [
      "russia",
      "露国"
    ],
    [
      "extension",
      "延長"
    ],
    [
      "golden",
      "金"
    ],
    [
      "completely",
      "全く"
    ],
    [
      "senate",
      "元老院"
    ],
    [
      "funny",
      "変"
    ],
    [
      "brother",
      "ブラザー"
    ],
    [
      "pattern",
      "パターン"
    ],
    [
      "hentai",
      "エロ漫画"
    ],
    [
      "boat",
      "舟"
    ],
    [
      "classical",
      "古典的"
    ],
    [
      "icon",
      "聖像"
    ],
    [
      "direction",
      "指揮"
    ],
    [
      "basketball",
      "篭球"
    ],
    [
      "delete",
      "削除"
    ],
    [
      "evening",
      "夜"
    ],
    [
      "mouse",
      "マウス"
    ],
    [
      "signal",
      "信号"
    ],
    [
      "criminal",
      "犯罪人"
    ],
    [
      "brain",
      "脳髄"
    ],
    [
      "powerful",
      "強力"
    ],
    [
      "dream",
      "夢見る"
    ],
    [
      "false",
      "偽"
    ],
    [
      "cast",
      "鋳る"
    ],
    [
      "flower",
      "開花"
    ],
    [
      "felt",
      "毛氈"
    ],
    [
      "soul",
      "霊"
    ],
    [
      "hawaii",
      "布哇"
    ],
    [
      "carry",
      "運ぶ"
    ],
    [
      "flag",
      "旗"
    ],
    [
      "advantage",
      "得"
    ],
    [
      "hello",
      "マジ？"
    ],
    [
      "maintain",
      "維持"
    ],
    [
      "tourism",
      "旅行"
    ],
    [
      "priority",
      "優先権"
    ],
    [
      "graphic",
      "鮮明"
    ],
    [
      "atom",
      "原子"
    ],
    [
      "brief",
      "短い"
    ],
    [
      "eight",
      "八つ"
    ],
    [
      "anonymous",
      "無名"
    ],
    [
      "iron",
      "鉄"
    ],
    [
      "straight",
      "ストレート"
    ],
    [
      "script",
      "文字"
    ],
    [
      "alert",
      "警報"
    ],
    [
      "integration",
      "積分"
    ],
    [
      "tag",
      "鬼事"
    ],
    [
      "interview",
      "面接"
    ],
    [
      "framework",
      "構造"
    ],
    [
      "disk",
      "丸"
    ],
    [
      "queen",
      "クイーン"
    ],
    [
      "fix",
      "キメる"
    ],
    [
      "handle",
      "取っ手"
    ],
    [
      "sweet",
      "甘い"
    ],
    [
      "vice",
      "犯罪"
    ],
    [
      "associate",
      "同僚"
    ],
    [
      "truck",
      "貨物自動車"
    ],
    [
      "behavior",
      "反応"
    ],
    [
      "ray",
      "鱏"
    ],
    [
      "frequently",
      "頻繁"
    ],
    [
      "revenue",
      "収益"
    ],
    [
      "measure",
      "小節"
    ],
    [
      "duty",
      "勤め"
    ],
    [
      "bear",
      "クマ"
    ],
    [
      "gain",
      "利得"
    ],
    [
      "festival",
      "祝祭"
    ],
    [
      "laboratory",
      "ラボ"
    ],
    [
      "ocean",
      "海"
    ],
    [
      "lack",
      "欠乏"
    ],
    [
      "depth",
      "深い"
    ],
    [
      "whatever",
      "何でも"
    ],
    [
      "laptop",
      "ラップトップ"
    ],
    [
      "train",
      "列車"
    ],
    [
      "dry",
      "乾いた"
    ],
    [
      "explore",
      "探る"
    ],
    [
      "spa",
      "温泉"
    ],
    [
      "concept",
      "観念"
    ],
    [
      "nearly",
      "殆ど"
    ],
    [
      "eligible",
      "適任"
    ],
    [
      "reality",
      "実在"
    ],
    [
      "origin",
      "原初"
    ],
    [
      "billion",
      "兆"
    ],
    [
      "scotland",
      "蘇格蘭"
    ],
    [
      "intelligence",
      "情報"
    ],
    [
      "con",
      "騙す"
    ],
    [
      "route",
      "手段"
    ],
    [
      "broken",
      "壊れた"
    ],
    [
      "frank",
      "フランク族"
    ],
    [
      "blow",
      "爆発"
    ],
    [
      "battle",
      "戦"
    ],
    [
      "anime",
      "アニメーション"
    ],
    [
      "speak",
      "会話"
    ],
    [
      "protocol",
      "プロトコル"
    ],
    [
      "query",
      "クエリ"
    ],
    [
      "partnership",
      "協力関係"
    ],
    [
      "expression",
      "表現"
    ],
    [
      "equity",
      "自己資本"
    ],
    [
      "speech",
      "話"
    ],
    [
      "wire",
      "線"
    ],
    [
      "rural",
      "田舎"
    ],
    [
      "replacement",
      "交換"
    ],
    [
      "judge",
      "審判"
    ],
    [
      "spam",
      "スパム"
    ],
    [
      "acid",
      "酸"
    ],
    [
      "cent",
      "仙"
    ],
    [
      "fight",
      "闘う"
    ],
    [
      "apartment",
      "長屋"
    ],
    [
      "height",
      "体高"
    ],
    [
      "null",
      "無"
    ],
    [
      "zero",
      "零"
    ],
    [
      "speaker",
      "話者"
    ],
    [
      "netherlands",
      "蘭国"
    ],
    [
      "obtain",
      "持つ"
    ],
    [
      "designer",
      "設計士"
    ],
    [
      "remain",
      "残る"
    ],
    [
      "marriage",
      "結婚"
    ],
    [
      "roll",
      "巻く"
    ],
    [
      "korea",
      "韓国"
    ],
    [
      "secret",
      "密か"
    ],
    [
      "bath",
      "入浴"
    ],
    [
      "negative",
      "ネガフィルム"
    ],
    [
      "theater",
      "シアター"
    ],
    [
      "missouri",
      "ミズーリ"
    ],
    [
      "andrew",
      "アンデレ"
    ],
    [
      "perform",
      "演奏"
    ],
    [
      "healthy",
      "達者"
    ],
    [
      "translation",
      "訳"
    ],
    [
      "font",
      "字体"
    ],
    [
      "injury",
      "負傷"
    ],
    [
      "joseph",
      "ジョセフ"
    ],
    [
      "lawyer",
      "法曹"
    ],
    [
      "proposal",
      "求婚"
    ],
    [
      "portal",
      "正門"
    ],
    [
      "birthday",
      "生日"
    ],
    [
      "banking",
      "銀行業"
    ],
    [
      "toward",
      "に"
    ],
    [
      "assist",
      "アシスト"
    ],
    [
      "legislation",
      "法律"
    ],
    [
      "comics",
      "戯画"
    ],
    [
      "wear",
      "履く"
    ],
    [
      "combined",
      "合わさる"
    ],
    [
      "ultimate",
      "究極"
    ],
    [
      "representative",
      "衆議院議員"
    ],
    [
      "frequency",
      "周波数"
    ],
    [
      "finish",
      "全う"
    ],
    [
      "rare",
      "稀"
    ],
    [
      "extreme",
      "極端"
    ],
    [
      "daniel",
      "ダニエル"
    ],
    [
      "row",
      "行"
    ],
    [
      "forecast",
      "予報"
    ],
    [
      "administrator",
      "遺産管理人"
    ],
    [
      "accuracy",
      "正確"
    ],
    [
      "rise",
      "上昇"
    ],
    [
      "sleep",
      "眠り"
    ],
    [
      "bird",
      "鳥類"
    ],
    [
      "pharmacy",
      "薬剤師"
    ],
    [
      "brazil",
      "伯剌西爾"
    ],
    [
      "creation",
      "創造"
    ],
    [
      "static",
      "砂嵐"
    ],
    [
      "scene",
      "場面"
    ],
    [
      "hunter",
      "狩人"
    ],
    [
      "lady",
      "レディ"
    ],
    [
      "crystal",
      "水晶"
    ],
    [
      "famous",
      "高名"
    ],
    [
      "writer",
      "筆者"
    ],
    [
      "chairman",
      "委員長"
    ],
    [
      "violence",
      "暴力"
    ],
    [
      "drink",
      "お酒"
    ],
    [
      "academy",
      "学院"
    ],
    [
      "gender",
      "性"
    ],
    [
      "eat",
      "頂く"
    ],
    [
      "agriculture",
      "農事"
    ],
    [
      "portfolio",
      "作品集"
    ],
    [
      "practical",
      "実用的な"
    ],
    [
      "infrastructure",
      "インフラストラクチャ"
    ],
    [
      "seat",
      "席"
    ],
    [
      "vendor",
      "販売者"
    ],
    [
      "originally",
      "元来"
    ],
    [
      "philosophy",
      "主義"
    ],
    [
      "regulation",
      "規則"
    ],
    [
      "reduction",
      "簡約"
    ],
    [
      "aim",
      "狙う"
    ],
    [
      "nutrition",
      "営養"
    ],
    [
      "junior",
      "後輩"
    ],
    [
      "toll",
      "損失"
    ],
    [
      "cape",
      "崎"
    ],
    [
      "ann",
      "アン"
    ],
    [
      "meaning",
      "意味"
    ],
    [
      "tip",
      "先端"
    ],
    [
      "secondary",
      "二義的"
    ],
    [
      "mine",
      "地雷"
    ],
    [
      "ticket",
      "チケット"
    ],
    [
      "guess",
      "憶測"
    ],
    [
      "ski",
      "スキー"
    ],
    [
      "soccer",
      "蹴球"
    ],
    [
      "import",
      "輸入"
    ],
    [
      "presence",
      "気配"
    ],
    [
      "instant",
      "即席の"
    ],
    [
      "automatic",
      "自動的"
    ],
    [
      "christ",
      "基督"
    ],
    [
      "austria",
      "墺太利"
    ],
    [
      "moon",
      "文"
    ],
    [
      "scheme",
      "図"
    ],
    [
      "utility",
      "有用"
    ],
    [
      "fly",
      "蝿"
    ],
    [
      "manner",
      "マナー"
    ],
    [
      "combination",
      "結合"
    ],
    [
      "amendment",
      "修正案"
    ],
    [
      "turkey",
      "ターキー"
    ],
    [
      "proper",
      "固有"
    ],
    [
      "singapore",
      "昭南"
    ],
    [
      "delta",
      "三角州"
    ],
    [
      "fear",
      "怖る"
    ],
    [
      "phoenix",
      "鳳凰"
    ],
    [
      "rs",
      "ルビサファ"
    ],
    [
      "principal",
      "校長"
    ],
    [
      "daughter",
      "いと"
    ],
    [
      "voyeur",
      "覗き魔"
    ],
    [
      "comfort",
      "慰め"
    ],
    [
      "cruise",
      "クルーズ"
    ],
    [
      "bonus",
      "ボーナス"
    ],
    [
      "certification",
      "証明"
    ],
    [
      "previously",
      "予て"
    ],
    [
      "hey",
      "おい"
    ],
    [
      "bookmark",
      "ブクマ"
    ],
    [
      "beat",
      "勝つ"
    ],
    [
      "disney",
      "ウォルト・ディズニー・カンパニー"
    ],
    [
      "household",
      "家庭"
    ],
    [
      "tea",
      "お茶"
    ],
    [
      "achieve",
      "達成"
    ],
    [
      "dress",
      "服を着る"
    ],
    [
      "subscription",
      "購読"
    ],
    [
      "dealer",
      "ディーラー"
    ],
    [
      "contemporary",
      "モダン"
    ],
    [
      "sky",
      "天"
    ],
    [
      "rom",
      "ロマ"
    ],
    [
      "happen",
      "起る"
    ],
    [
      "panasonic",
      "松下"
    ],
    [
      "hide",
      "革"
    ],
    [
      "signature",
      "サイン"
    ],
    [
      "gambling",
      "博打"
    ],
    [
      "provision",
      "配給"
    ],
    [
      "outdoors",
      "屋外"
    ],
    [
      "clothes",
      "服"
    ],
    [
      "certainly",
      "全く"
    ],
    [
      "newspaper",
      "新聞紙"
    ],
    [
      "toy",
      "トイ"
    ],
    [
      "layer",
      "層"
    ],
    [
      "slow",
      "鈍足"
    ],
    [
      "removal",
      "左遷"
    ],
    [
      "liability",
      "負債"
    ],
    [
      "hip",
      "ヒップ"
    ],
    [
      "nine",
      "九つ"
    ],
    [
      "kentucky",
      "ケンタッキー州"
    ],
    [
      "mostly",
      "大方"
    ],
    [
      "spot",
      "場所"
    ],
    [
      "spend",
      "使う"
    ],
    [
      "interior",
      "内装"
    ],
    [
      "grow",
      "増大"
    ],
    [
      "promotion",
      "宣伝"
    ],
    [
      "relative",
      "身内"
    ],
    [
      "amazing",
      "凄い"
    ],
    [
      "clock",
      "時計"
    ],
    [
      "dot",
      "点"
    ],
    [
      "hiv",
      "人免疫不全ウイルス"
    ],
    [
      "identity",
      "身元"
    ],
    [
      "feeling",
      "恋"
    ],
    [
      "hidden",
      "秘密"
    ],
    [
      "victoria",
      "ビクトリア"
    ],
    [
      "relief",
      "救済"
    ],
    [
      "influence",
      "影響"
    ],
    [
      "pda",
      "携帯情報端末"
    ],
    [
      "importance",
      "大切さ"
    ],
    [
      "rain",
      "雨"
    ],
    [
      "planet",
      "星"
    ],
    [
      "recipe",
      "作り方"
    ],
    [
      "permit",
      "許可"
    ],
    [
      "proof",
      "-"
    ],
    [
      "dna",
      "ＤＮＡ"
    ],
    [
      "tennis",
      "庭球"
    ],
    [
      "bass",
      "バス"
    ],
    [
      "prescription",
      "処方"
    ],
    [
      "empty",
      "空っぽ"
    ],
    [
      "ride",
      "車に乗せてやること"
    ],
    [
      "bureau",
      "事務室"
    ],
    [
      "represent",
      "代表する"
    ],
    [
      "conservation",
      "保護"
    ],
    [
      "pair",
      "対"
    ],
    [
      "ideal",
      "理想"
    ],
    [
      "don",
      "履く"
    ],
    [
      "finished",
      "終わる"
    ],
    [
      "dinner",
      "夕食"
    ],
    [
      "stress",
      "力説"
    ],
    [
      "cream",
      "クリーム"
    ],
    [
      "yeah",
      "うん"
    ],
    [
      "discover",
      "見つける"
    ],
    [
      "louisiana",
      "ルイジアナ州"
    ],
    [
      "fourth",
      "四番目"
    ],
    [
      "advisor",
      "顧問"
    ],
    [
      "marketplace",
      "墟市"
    ],
    [
      "evil",
      "邪心"
    ],
    [
      "shape",
      "型"
    ],
    [
      "irish",
      "アイルランド語"
    ],
    [
      "op",
      "一"
    ],
    [
      "operator",
      "作用素"
    ],
    [
      "encyclopedia",
      "百科全書"
    ],
    [
      "usage",
      "使い方"
    ],
    [
      "cap",
      "蓋"
    ],
    [
      "ink",
      "墨"
    ],
    [
      "mixed",
      "混血"
    ],
    [
      "census",
      "人口調査"
    ],
    [
      "peak",
      "尖頭値"
    ],
    [
      "exist",
      "存在"
    ],
    [
      "wheel",
      "車"
    ],
    [
      "dick",
      "ちんぽ"
    ],
    [
      "salt",
      "塩"
    ],
    [
      "poetry",
      "詩"
    ],
    [
      "angel",
      "天使"
    ],
    [
      "bell",
      "ベル"
    ],
    [
      "preparation",
      "支度"
    ],
    [
      "attempt",
      "未遂"
    ],
    [
      "width",
      "幅"
    ],
    [
      "noise",
      "ノイズ"
    ],
    [
      "forget",
      "忘れる"
    ],
    [
      "accurate",
      "精密"
    ],
    [
      "stephen",
      "スティーブン"
    ],
    [
      "climate",
      "風土"
    ],
    [
      "pin",
      "鋲"
    ],
    [
      "alcohol",
      "酒"
    ],
    [
      "greek",
      "ギリシャ"
    ],
    [
      "instruction",
      "説明書"
    ],
    [
      "sister",
      "姉妹"
    ],
    [
      "walking",
      "歩く"
    ],
    [
      "explain",
      "教える"
    ],
    [
      "gnu",
      "牛氈鹿"
    ],
    [
      "sharp",
      "犀利"
    ],
    [
      "lane",
      "細道"
    ],
    [
      "kill",
      "殺害"
    ],
    [
      "export",
      "輸出"
    ],
    [
      "aircraft",
      "飛行機"
    ],
    [
      "sweden",
      "瑞典"
    ],
    [
      "conflict",
      "合わない"
    ],
    [
      "occur",
      "ある"
    ],
    [
      "percentage",
      "百分比"
    ],
    [
      "mississippi",
      "ミシシッピ川"
    ],
    [
      "describe",
      "記述"
    ],
    [
      "concern",
      "題目"
    ],
    [
      "backup",
      "控え"
    ],
    [
      "trouble",
      "問題"
    ],
    [
      "spread",
      "広げる"
    ],
    [
      "coach",
      "コーチ"
    ],
    [
      "kevin",
      "ケヴィン"
    ],
    [
      "expand",
      "拡大"
    ],
    [
      "audience",
      "観客"
    ],
    [
      "jordan",
      "ヨルダン川"
    ],
    [
      "plug",
      "栓"
    ],
    [
      "specialist",
      "専門医"
    ],
    [
      "cook",
      "作る"
    ],
    [
      "virgin",
      "処女"
    ],
    [
      "institution",
      "機構"
    ],
    [
      "bike",
      "ケッタ"
    ],
    [
      "indicate",
      "指摘"
    ],
    [
      "favourite",
      "大好きな"
    ],
    [
      "transmission",
      "転送"
    ],
    [
      "lose",
      "失う"
    ],
    [
      "seek",
      "探し回る"
    ],
    [
      "extremely",
      "随分"
    ],
    [
      "equivalent",
      "相当"
    ],
    [
      "chemistry",
      "かがく"
    ],
    [
      "neighborhood",
      "隣"
    ],
    [
      "thailand",
      "泰国"
    ],
    [
      "agenda",
      "議事"
    ],
    [
      "anyway",
      "どうせ"
    ],
    [
      "logic",
      "論理学"
    ],
    [
      "template",
      "型板"
    ],
    [
      "prince",
      "候"
    ],
    [
      "circle",
      "円"
    ],
    [
      "soil",
      "地"
    ],
    [
      "psychology",
      "心理"
    ],
    [
      "wet",
      "濡れる"
    ],
    [
      "investor",
      "投資家"
    ],
    [
      "identification",
      "識別"
    ],
    [
      "cooking",
      "クッキング"
    ],
    [
      "speaking",
      "言葉"
    ],
    [
      "fox",
      "キツネ"
    ],
    [
      "unlimited",
      "無限"
    ],
    [
      "plain",
      "平地"
    ],
    [
      "exit",
      "出かける"
    ],
    [
      "arm",
      "うで"
    ],
    [
      "wave",
      "周波"
    ],
    [
      "belgium",
      "白耳義"
    ],
    [
      "holy",
      "聖"
    ],
    [
      "trail",
      "跡"
    ],
    [
      "symbol",
      "符号"
    ],
    [
      "highway",
      "公道"
    ],
    [
      "buddy",
      "友達"
    ],
    [
      "glossary",
      "語彙"
    ],
    [
      "celebrity",
      "名士"
    ],
    [
      "unix",
      "ユニックス"
    ],
    [
      "notify",
      "通告"
    ],
    [
      "chocolate",
      "チョコ"
    ],
    [
      "pub",
      "バー"
    ],
    [
      "supplier",
      "供給者"
    ],
    [
      "cotton",
      "コットン"
    ],
    [
      "bluetooth",
      "青歯"
    ],
    [
      "biology",
      "せいぶつがく"
    ],
    [
      "border",
      "国界"
    ],
    [
      "ancient",
      "古い"
    ],
    [
      "debate",
      "討論"
    ],
    [
      "leisure",
      "余暇"
    ],
    [
      "learned",
      "学習"
    ],
    [
      "notebook",
      "帳面"
    ],
    [
      "attached",
      "所属の"
    ],
    [
      "husband",
      "ハズ"
    ],
    [
      "disabled",
      "障害者"
    ],
    [
      "crazy",
      "気が狂った"
    ],
    [
      "concert",
      "合奏"
    ],
    [
      "retirement",
      "退職"
    ],
    [
      "efficiency",
      "効率性"
    ],
    [
      "comedy",
      "コメディ"
    ],
    [
      "linear",
      "一次"
    ],
    [
      "commitment",
      "責任"
    ],
    [
      "visa",
      "ビザ"
    ],
    [
      "mouth",
      "河口"
    ],
    [
      "jewish",
      "ユダヤ"
    ],
    [
      "meter",
      "拍子"
    ],
    [
      "gun",
      "銃"
    ],
    [
      "reflect",
      "跳ね返す"
    ],
    [
      "pure",
      "純粋"
    ],
    [
      "deliver",
      "応じる"
    ],
    [
      "wonder",
      "驚嘆"
    ],
    [
      "hell",
      "糞"
    ],
    [
      "fruit",
      "フルーツ"
    ],
    [
      "qualified",
      "有資格"
    ],
    [
      "lens",
      "水晶体"
    ],
    [
      "draw",
      "引く"
    ],
    [
      "assume",
      "負う"
    ],
    [
      "confidence",
      "信任"
    ],
    [
      "alliance",
      "アライアンス"
    ],
    [
      "warm",
      "熱烈"
    ],
    [
      "howard",
      "ホワード"
    ],
    [
      "offline",
      "停止"
    ],
    [
      "engineer",
      "技師"
    ],
    [
      "lifestyle",
      "生活様式"
    ],
    [
      "inventory",
      "表"
    ],
    [
      "suck",
      "しゃぶる"
    ],
    [
      "blowjob",
      "フェラ"
    ],
    [
      "objective",
      "目標"
    ],
    [
      "sugar",
      "糖"
    ],
    [
      "crew",
      "乗組"
    ],
    [
      "stick",
      "スティック"
    ],
    [
      "relation",
      "関係"
    ],
    [
      "slide",
      "滑る"
    ],
    [
      "volunteer",
      "有志"
    ],
    [
      "rear",
      "後方"
    ],
    [
      "switzerland",
      "瑞西"
    ],
    [
      "exact",
      "精密"
    ],
    [
      "bound",
      "行き"
    ],
    [
      "parameter",
      "引数"
    ],
    [
      "adapter",
      "アダプター"
    ],
    [
      "processor",
      "演算機"
    ],
    [
      "node",
      "節点"
    ],
    [
      "formal",
      "公式"
    ],
    [
      "lock",
      "釘"
    ],
    [
      "storm",
      "暴風"
    ],
    [
      "mile",
      "ノット"
    ],
    [
      "bowl",
      "丼"
    ],
    [
      "supreme",
      "至高"
    ],
    [
      "tank",
      "缶"
    ],
    [
      "submission",
      "平伏"
    ],
    [
      "encourage",
      "奨励する"
    ],
    [
      "navy",
      "海軍"
    ],
    [
      "kid",
      "童"
    ],
    [
      "cancel",
      "破棄"
    ],
    [
      "territory",
      "準州"
    ],
    [
      "transaction",
      "取引"
    ],
    [
      "paint",
      "塗料"
    ],
    [
      "delay",
      "遅延"
    ],
    [
      "pilot",
      "パイロット"
    ],
    [
      "outlet",
      "捌け口"
    ],
    [
      "czech",
      "チェコ語"
    ],
    [
      "cambridge",
      "剣橋"
    ],
    [
      "novel",
      "新奇"
    ],
    [
      "execution",
      "実行"
    ],
    [
      "winner",
      "優勝者"
    ],
    [
      "episode",
      "エピソード"
    ],
    [
      "examination",
      "診察"
    ],
    [
      "dish",
      "ディッシュ"
    ],
    [
      "truly",
      "本当"
    ],
    [
      "painting",
      "絵"
    ],
    [
      "universe",
      "森羅万象"
    ],
    [
      "candidate",
      "候補"
    ],
    [
      "patent",
      "特許"
    ],
    [
      "outstanding",
      "顕著"
    ],
    [
      "ha",
      "はあ"
    ],
    [
      "messenger",
      "伻"
    ],
    [
      "mirror",
      "姿見"
    ],
    [
      "tournament",
      "大会"
    ],
    [
      "sterling",
      "純銀"
    ],
    [
      "kernel",
      "仁"
    ],
    [
      "gray",
      "鼠色"
    ],
    [
      "catalogue",
      "目録"
    ],
    [
      "broad",
      "女"
    ],
    [
      "taiwan",
      "高砂"
    ],
    [
      "greece",
      "希臘"
    ],
    [
      "swiss",
      "スイス人"
    ],
    [
      "labour",
      "出産"
    ],
    [
      "hate",
      "厭う"
    ],
    [
      "terminal",
      "ターミナル"
    ],
    [
      "liquid",
      "流体"
    ],
    [
      "rice",
      "米"
    ],
    [
      "loop",
      "輪"
    ],
    [
      "salary",
      "サラリー"
    ],
    [
      "reservation",
      "予約"
    ],
    [
      "gourmet",
      "グルメ"
    ],
    [
      "guard",
      "衛兵"
    ],
    [
      "saving",
      "貯蓄"
    ],
    [
      "empire",
      "帝国"
    ],
    [
      "twenty",
      "にじゅう"
    ],
    [
      "avatar",
      "化身"
    ],
    [
      "illegal",
      "不法"
    ],
    [
      "expansion",
      "展開"
    ],
    [
      "rome",
      "羅馬"
    ],
    [
      "tomorrow",
      "あす"
    ],
    [
      "milk",
      "乳"
    ],
    [
      "decide",
      "決定"
    ],
    [
      "consent",
      "承諾"
    ],
    [
      "drama",
      "演戯"
    ],
    [
      "downtown",
      "町"
    ],
    [
      "keyboard",
      "鍵盤"
    ],
    [
      "contest",
      "コンクール"
    ],
    [
      "boot",
      "長靴"
    ],
    [
      "suitable",
      "適切"
    ],
    [
      "lunch",
      "昼飯"
    ],
    [
      "dildo",
      "ディルド"
    ],
    [
      "chamber",
      "寝室"
    ],
    [
      "muscle",
      "筋"
    ],
    [
      "implement",
      "実行する"
    ],
    [
      "typical",
      "典型的な"
    ],
    [
      "tower",
      "塔"
    ],
    [
      "yours",
      "きみのもの"
    ],
    [
      "sum",
      "金額"
    ],
    [
      "calculator",
      "計算機"
    ],
    [
      "chicken",
      "臼辺鳥"
    ],
    [
      "temporary",
      "暫く"
    ],
    [
      "attend",
      "出席"
    ],
    [
      "shower",
      "雨下"
    ],
    [
      "jason",
      "ジェイソン"
    ],
    [
      "tonight",
      "今晩"
    ],
    [
      "dear",
      "親愛なる"
    ],
    [
      "sufficient",
      "足りる"
    ],
    [
      "shell",
      "殻"
    ],
    [
      "province",
      "州"
    ],
    [
      "catholic",
      "公教"
    ],
    [
      "oak",
      "楢"
    ],
    [
      "awareness",
      "意識"
    ],
    [
      "vancouver",
      "ヴァンクーヴァー"
    ],
    [
      "governor",
      "調整器"
    ],
    [
      "beer",
      "麦酒"
    ],
    [
      "measurement",
      "測定値"
    ],
    [
      "swimming",
      "泳ぎ"
    ],
    [
      "formula",
      "定式"
    ],
    [
      "constitution",
      "憲法"
    ],
    [
      "solar",
      "日の"
    ],
    [
      "catch",
      "捕まえる"
    ],
    [
      "consultation",
      "協議"
    ],
    [
      "northwest",
      "乾"
    ],
    [
      "sir",
      "僕"
    ],
    [
      "doubt",
      "不審"
    ],
    [
      "earn",
      "得る"
    ],
    [
      "classroom",
      "教場"
    ],
    [
      "democracy",
      "民主"
    ],
    [
      "kim",
      "金"
    ],
    [
      "merchandise",
      "品"
    ],
    [
      "resistance",
      "反抗"
    ],
    [
      "visitor",
      "客人"
    ],
    [
      "twin",
      "ツイン"
    ],
    [
      "insert",
      "挿入"
    ],
    [
      "baltimore",
      "ボルティモア"
    ],
    [
      "gateway",
      "通路"
    ],
    [
      "drawing",
      "図画"
    ],
    [
      "biological",
      "実の"
    ],
    [
      "transition",
      "推移"
    ],
    [
      "spy",
      "密使"
    ],
    [
      "romance",
      "ロマンス"
    ],
    [
      "instrument",
      "器具"
    ],
    [
      "split",
      "小瓶"
    ],
    [
      "heaven",
      "空"
    ],
    [
      "pregnant",
      "妊娠"
    ],
    [
      "twice",
      "二回"
    ],
    [
      "egypt",
      "埃及"
    ],
    [
      "physician",
      "先生"
    ],
    [
      "bargain",
      "廉価品"
    ],
    [
      "norway",
      "諾威"
    ],
    [
      "suit",
      "洋服"
    ],
    [
      "shift",
      "交代"
    ],
    [
      "chip",
      "チップ"
    ],
    [
      "sit",
      "ある"
    ],
    [
      "wow",
      "わあ"
    ],
    [
      "numerous",
      "多数"
    ],
    [
      "satisfaction",
      "償い"
    ],
    [
      "superior",
      "偉い"
    ],
    [
      "cartoon",
      "漫画"
    ],
    [
      "carbon",
      "炭"
    ],
    [
      "comfortable",
      "心地良い"
    ],
    [
      "magnetic",
      "引きつける"
    ],
    [
      "listening",
      "聞く"
    ],
    [
      "crisis",
      "危機"
    ],
    [
      "denmark",
      "丁抹"
    ],
    [
      "bright",
      "聡明"
    ],
    [
      "treat",
      "治療"
    ],
    [
      "header",
      "ヘッダ"
    ],
    [
      "poverty",
      "欠乏"
    ],
    [
      "piano",
      "鋼琴"
    ],
    [
      "echo",
      "こだま"
    ],
    [
      "grid",
      "グリッド"
    ],
    [
      "patrick",
      "パトリーツィオ"
    ],
    [
      "revolution",
      "革命"
    ],
    [
      "plasma",
      "血漿"
    ],
    [
      "earnings",
      "所得"
    ],
    [
      "mystery",
      "神秘"
    ],
    [
      "landscape",
      "横"
    ],
    [
      "dependent",
      "依存"
    ],
    [
      "journey",
      "旅"
    ],
    [
      "banner",
      "バナー"
    ],
    [
      "applicant",
      "応募者"
    ],
    [
      "charter",
      "チャーター"
    ],
    [
      "fig",
      "映日果"
    ],
    [
      "cooperation",
      "協調"
    ],
    [
      "rapid",
      "急"
    ],
    [
      "pull",
      "引っ張る"
    ],
    [
      "hairy",
      "毛深い"
    ],
    [
      "diversity",
      "変化"
    ],
    [
      "reverse",
      "逆"
    ],
    [
      "deposit",
      "供託"
    ],
    [
      "seminar",
      "ゼミ"
    ],
    [
      "nasa",
      "ナサ"
    ],
    [
      "dutch",
      "蘭"
    ],
    [
      "sensitive",
      "繊細"
    ],
    [
      "router",
      "ルータ"
    ],
    [
      "concrete",
      "具体的"
    ],
    [
      "poland",
      "ポーランド共和国"
    ],
    [
      "folder",
      "ファイル"
    ],
    [
      "completion",
      "完成"
    ],
    [
      "pulse",
      "脈搏"
    ],
    [
      "calculate",
      "算出"
    ],
    [
      "broadcast",
      "番組"
    ],
    [
      "anniversary",
      "周年"
    ],
    [
      "strip",
      "奪い取る"
    ],
    [
      "specification",
      "仕様"
    ],
    [
      "accident",
      "事故"
    ],
    [
      "accessory",
      "持ち物"
    ],
    [
      "resident",
      "居住者"
    ],
    [
      "plot",
      "筋"
    ],
    [
      "airline",
      "航空会社"
    ],
    [
      "regard",
      "留意"
    ],
    [
      "pump",
      "喞筒"
    ],
    [
      "smooth",
      "スムース"
    ],
    [
      "strike",
      "スト"
    ],
    [
      "birmingham",
      "バーミングハム"
    ],
    [
      "threat",
      "脅威"
    ],
    [
      "consultant",
      "相談役"
    ],
    [
      "penis",
      "玩具"
    ],
    [
      "vietnam",
      "越南"
    ],
    [
      "trailer",
      "予告編"
    ],
    [
      "castle",
      "城郭"
    ],
    [
      "antique",
      "古い"
    ],
    [
      "residence",
      "滞在"
    ],
    [
      "density",
      "濃度"
    ],
    [
      "strange",
      "奇妙"
    ],
    [
      "philippines",
      "比律賓"
    ],
    [
      "mention",
      "言及"
    ],
    [
      "innovation",
      "革新"
    ],
    [
      "pcs",
      "個"
    ],
    [
      "parallel",
      "並列"
    ],
    [
      "honda",
      "本田"
    ],
    [
      "operate",
      "操作"
    ],
    [
      "bold",
      "勇敢"
    ],
    [
      "bathroom",
      "風呂場"
    ],
    [
      "stable",
      "厩舎"
    ],
    [
      "opera",
      "歌劇"
    ],
    [
      "lesson",
      "課"
    ],
    [
      "cinema",
      "撮影"
    ],
    [
      "reaction",
      "反動"
    ],
    [
      "blank",
      "空包"
    ],
    [
      "severe",
      "渋い"
    ],
    [
      "generate",
      "生む"
    ],
    [
      "exception",
      "例外"
    ],
    [
      "duration",
      "期間"
    ],
    [
      "fabric",
      "布"
    ],
    [
      "recommendation",
      "推薦"
    ],
    [
      "recruitment",
      "求人"
    ],
    [
      "sin",
      "つみ"
    ],
    [
      "berlin",
      "伯林"
    ],
    [
      "cute",
      "キュート"
    ],
    [
      "capture",
      "とる"
    ],
    [
      "plane",
      "鉋"
    ],
    [
      "seed",
      "種子"
    ],
    [
      "desire",
      "欲する"
    ],
    [
      "mechanism",
      "仕組み"
    ],
    [
      "camping",
      "キャンプ"
    ],
    [
      "jewellery",
      "ジュエリー"
    ],
    [
      "welfare",
      "幸せ"
    ],
    [
      "peer",
      "タメ"
    ],
    [
      "eventually",
      "結局"
    ],
    [
      "massage",
      "按摩"
    ],
    [
      "rubber",
      "ゴム"
    ],
    [
      "conclusion",
      "終了"
    ],
    [
      "meat",
      "肉"
    ],
    [
      "legend",
      "伝説"
    ],
    [
      "grace",
      "優雅"
    ],
    [
      "ing",
      "と"
    ],
    [
      "python",
      "錦蛇"
    ],
    [
      "monster",
      "化け物"
    ],
    [
      "bang",
      "ドン"
    ],
    [
      "villa",
      "ビラ"
    ],
    [
      "bone",
      "ほね"
    ],
    [
      "collaboration",
      "合作"
    ],
    [
      "tutorial",
      "学習用"
    ],
    [
      "gate",
      "ゲート"
    ],
    [
      "settlement",
      "入植"
    ],
    [
      "portugal",
      "葡国"
    ],
    [
      "roman",
      "ローマ字"
    ],
    [
      "erotic",
      "エロい"
    ],
    [
      "tone",
      "トーン"
    ],
    [
      "ethics",
      "倫理学"
    ],
    [
      "forever",
      "永遠"
    ],
    [
      "dragon",
      "龍"
    ],
    [
      "busy",
      "繁華"
    ],
    [
      "captain",
      "大尉"
    ],
    [
      "fantastic",
      "素敵"
    ],
    [
      "leg",
      "足"
    ],
    [
      "neck",
      "棹"
    ],
    [
      "wing",
      "翼"
    ],
    [
      "taste",
      "味"
    ],
    [
      "commit",
      "任せる"
    ],
    [
      "tiny",
      "小さい"
    ],
    [
      "rail",
      "手摺"
    ],
    [
      "liberal",
      "豊富"
    ],
    [
      "jay",
      "鵥"
    ],
    [
      "gap",
      "隙"
    ],
    [
      "tube",
      "筒"
    ],
    [
      "belt",
      "地帯"
    ],
    [
      "animation",
      "アニメ"
    ],
    [
      "oracle",
      "神託"
    ],
    [
      "er",
      "り"
    ],
    [
      "matthew",
      "マタイ"
    ],
    [
      "aviation",
      "飛行"
    ],
    [
      "proud",
      "嬉しい"
    ],
    [
      "disaster",
      "天災"
    ],
    [
      "console",
      "労る"
    ],
    [
      "instructor",
      "インストラクター"
    ],
    [
      "alarm",
      "注意"
    ],
    [
      "anthony",
      "アントニオ"
    ],
    [
      "nintendo",
      "ニンテンドー"
    ],
    [
      "usual",
      "通常"
    ],
    [
      "angle",
      "角"
    ],
    [
      "rob",
      "奪う"
    ],
    [
      "vinyl",
      "ビニル"
    ],
    [
      "mining",
      "採鉱"
    ],
    [
      "worst",
      "最低"
    ],
    [
      "liberty",
      "呼吸点"
    ],
    [
      "wyoming",
      "ワイオミング州"
    ],
    [
      "argentina",
      "亜爾然丁"
    ],
    [
      "era",
      "紀元"
    ],
    [
      "analyst",
      "分析家"
    ],
    [
      "dangerous",
      "危険"
    ],
    [
      "garage",
      "車庫"
    ],
    [
      "unfortunately",
      "残念"
    ],
    [
      "respectively",
      "各々"
    ],
    [
      "ringtone",
      "着メロ"
    ],
    [
      "finland",
      "フィンランド共和国"
    ],
    [
      "pleasure",
      "快感"
    ],
    [
      "honor",
      "名誉"
    ],
    [
      "eagle",
      "鵰"
    ],
    [
      "pants",
      "パンツ"
    ],
    [
      "nurse",
      "保母"
    ],
    [
      "prayer",
      "祈り"
    ],
    [
      "appointment",
      "アポ"
    ],
    [
      "hurricane",
      "暴風"
    ],
    [
      "quiet",
      "平静"
    ],
    [
      "luck",
      "運勢"
    ],
    [
      "producer",
      "製作者"
    ],
    [
      "cheese",
      "酪"
    ],
    [
      "comic",
      "コミック"
    ],
    [
      "carefully",
      "慎重に"
    ],
    [
      "jet",
      "噴射"
    ],
    [
      "crown",
      "頭頂"
    ],
    [
      "underground",
      "アングラ"
    ],
    [
      "maker",
      "作者"
    ],
    [
      "crack",
      "亀裂"
    ],
    [
      "principle",
      "主義"
    ],
    [
      "gang",
      "ギャング"
    ],
    [
      "fetish",
      "フェティシズム"
    ],
    [
      "appearance",
      "体裁"
    ],
    [
      "smoke",
      "吸う"
    ],
    [
      "apart",
      "ばらばら"
    ],
    [
      "fellow",
      "やつ"
    ],
    [
      "blind",
      "失明"
    ],
    [
      "lounge",
      "休憩室"
    ],
    [
      "mad",
      "狂しい"
    ],
    [
      "algorithm",
      "算法"
    ],
    [
      "horror",
      "恐れ"
    ],
    [
      "pen",
      "ペン"
    ],
    [
      "admission",
      "入場料"
    ],
    [
      "shoe",
      "靴"
    ],
    [
      "victory",
      "勝ち"
    ],
    [
      "sand",
      "砂"
    ],
    [
      "terrorism",
      "テロ"
    ],
    [
      "mainly",
      "主"
    ],
    [
      "parliament",
      "国会"
    ],
    [
      "actor",
      "女優"
    ],
    [
      "seal",
      "印章"
    ],
    [
      "citizen",
      "民"
    ],
    [
      "vertical",
      "縦"
    ],
    [
      "municipal",
      "都市"
    ],
    [
      "prize",
      "梃"
    ],
    [
      "absolute",
      "絶対"
    ],
    [
      "substance",
      "物質"
    ],
    [
      "pipe",
      "笛"
    ],
    [
      "simulation",
      "真似"
    ],
    [
      "layout",
      "構造"
    ],
    [
      "concentration",
      "集中"
    ],
    [
      "lay",
      "産む"
    ],
    [
      "interpretation",
      "解釈"
    ],
    [
      "lol",
      "笑"
    ],
    [
      "dirty",
      "汚れている"
    ],
    [
      "deck",
      "甲板"
    ],
    [
      "wayne",
      "ウェーン"
    ],
    [
      "donate",
      "寄贈"
    ],
    [
      "bankruptcy",
      "倒産"
    ],
    [
      "worker",
      "働く"
    ],
    [
      "temple",
      "簇"
    ],
    [
      "promise",
      "約束する"
    ],
    [
      "thin",
      "薄い"
    ],
    [
      "exhibition",
      "展示会"
    ],
    [
      "prefer",
      "…の方を好む"
    ],
    [
      "cabinet",
      "内閣"
    ],
    [
      "tropical",
      "熱帯"
    ],
    [
      "collect",
      "収集"
    ],
    [
      "composition",
      "合成"
    ],
    [
      "toyota",
      "豊田"
    ],
    [
      "vector",
      "ベクター"
    ],
    [
      "definitely",
      "必ず"
    ],
    [
      "buffer",
      "バッファー"
    ],
    [
      "purple",
      "紫"
    ],
    [
      "existence",
      "実在"
    ],
    [
      "immigration",
      "入植"
    ],
    [
      "mutual",
      "相互"
    ],
    [
      "syntax",
      "シンタックス"
    ],
    [
      "attribute",
      "属性"
    ],
    [
      "prison",
      "牢"
    ],
    [
      "skill",
      "技"
    ],
    [
      "apparently",
      "そう"
    ],
    [
      "inquiry",
      "探究"
    ],
    [
      "exhibit",
      "展示品"
    ],
    [
      "throw",
      "投げる"
    ],
    [
      "trend",
      "傾向"
    ],
    [
      "visible",
      "顕在"
    ],
    [
      "desert",
      "変節"
    ],
    [
      "obviously",
      "当たり前"
    ],
    [
      "mercury",
      "マーキュリー"
    ],
    [
      "handbook",
      "便覧"
    ],
    [
      "worse",
      "より悪い"
    ],
    [
      "summit",
      "頂"
    ],
    [
      "escape",
      "免れる"
    ],
    [
      "somewhat",
      "やや"
    ],
    [
      "receiver",
      "受信機"
    ],
    [
      "substantial",
      "現実"
    ],
    [
      "glance",
      "一瞥"
    ],
    [
      "championship",
      "優勝"
    ],
    [
      "arcade",
      "商店街"
    ],
    [
      "impossible",
      "無理"
    ],
    [
      "obvious",
      "当たり前"
    ],
    [
      "depression",
      "不振"
    ],
    [
      "graph",
      "図表"
    ],
    [
      "platinum",
      "プラチナ"
    ],
    [
      "judgment",
      "審判"
    ],
    [
      "tissue",
      "塵紙"
    ],
    [
      "cartridge",
      "インクカートリッジ"
    ],
    [
      "alberta",
      "アルバータ州"
    ],
    [
      "fraud",
      "詐欺師"
    ],
    [
      "electricity",
      "電力"
    ],
    [
      "spectrum",
      "分光"
    ],
    [
      "pottery",
      "窯元"
    ],
    [
      "emphasis",
      "強勢"
    ],
    [
      "roger",
      "ラジャー"
    ],
    [
      "aspect",
      "相"
    ],
    [
      "workplace",
      "仕事場"
    ],
    [
      "awesome",
      "素敵"
    ],
    [
      "crash",
      "クラッシュ"
    ],
    [
      "lift",
      "昇降機"
    ],
    [
      "closer",
      "守護神"
    ],
    [
      "shadow",
      "影"
    ],
    [
      "infection",
      "感染"
    ],
    [
      "firefox",
      "火狐"
    ],
    [
      "expense",
      "費用"
    ],
    [
      "grove",
      "林"
    ],
    [
      "eligibility",
      "適任"
    ],
    [
      "clinic",
      "医院"
    ],
    [
      "korean",
      "コリアン"
    ],
    [
      "princess",
      "公主"
    ],
    [
      "mall",
      "モール"
    ],
    [
      "packet",
      "包み"
    ],
    [
      "spray",
      "小枝"
    ],
    [
      "dad",
      "父"
    ],
    [
      "pat",
      "撫でる"
    ],
    [
      "motorcycle",
      "単車"
    ],
    [
      "yard",
      "碼"
    ],
    [
      "establishment",
      "施設"
    ],
    [
      "tourist",
      "旅行者"
    ],
    [
      "murder",
      "殺す"
    ],
    [
      "adequate",
      "十分"
    ],
    [
      "yield",
      "収穫"
    ],
    [
      "pour",
      "流出"
    ],
    [
      "digest",
      "会得"
    ],
    [
      "tion",
      "化"
    ],
    [
      "dust",
      "ほこり"
    ],
    [
      "hence",
      "従って"
    ],
    [
      "wiki",
      "ウィキる"
    ],
    [
      "entirely",
      "全て"
    ],
    [
      "radar",
      "電波探知機"
    ],
    [
      "rescue",
      "救う"
    ],
    [
      "occupation",
      "仕事"
    ],
    [
      "butt",
      "吸殻"
    ],
    [
      "radiation",
      "放射"
    ],
    [
      "diary",
      "日記帳"
    ],
    [
      "seriously",
      "真剣"
    ],
    [
      "ear",
      "耳"
    ],
    [
      "baker",
      "パン屋さん"
    ],
    [
      "pollution",
      "公害"
    ],
    [
      "conservative",
      "保守的"
    ],
    [
      "shock",
      "衝撃"
    ],
    [
      "abroad",
      "国外"
    ],
    [
      "ebony",
      "コクタン材"
    ],
    [
      "tie",
      "縛る"
    ],
    [
      "ward",
      "区"
    ],
    [
      "atmosphere",
      "大気"
    ],
    [
      "kiss",
      "チュー"
    ],
    [
      "beast",
      "獣"
    ],
    [
      "overseas",
      "海外"
    ],
    [
      "dodge",
      "よける"
    ],
    [
      "federation",
      "同盟"
    ],
    [
      "pizza",
      "ピッツァ"
    ],
    [
      "assignment",
      "代入"
    ],
    [
      "rush",
      "駆け付ける"
    ],
    [
      "absence",
      "欠席"
    ],
    [
      "yoga",
      "ヨガ"
    ],
    [
      "surprise",
      "驚き"
    ],
    [
      "lamp",
      "明かり"
    ],
    [
      "partial",
      "偏る"
    ],
    [
      "everybody",
      "皆さん"
    ],
    [
      "nashville",
      "ナッシュヴィル"
    ],
    [
      "ranking",
      "番付"
    ],
    [
      "sublime",
      "高邁"
    ],
    [
      "palace",
      "宮闕"
    ],
    [
      "globe",
      "グローブ"
    ],
    [
      "copper",
      "カッパー"
    ],
    [
      "receipt",
      "受領書"
    ],
    [
      "ordinary",
      "平凡"
    ],
    [
      "ghost",
      "亡霊"
    ],
    [
      "stability",
      "安定性"
    ],
    [
      "southwest",
      "坤"
    ],
    [
      "boss",
      "ボス"
    ],
    [
      "pride",
      "自慢"
    ],
    [
      "reporter",
      "記者"
    ],
    [
      "metabolism",
      "新陳代謝"
    ],
    [
      "champion",
      "王者"
    ],
    [
      "cloudy",
      "濁り"
    ],
    [
      "plenty",
      "豊富"
    ],
    [
      "solo",
      "独唱"
    ],
    [
      "sentence",
      "宣告"
    ],
    [
      "ignore",
      "忽略"
    ],
    [
      "uniform",
      "統一された"
    ],
    [
      "wealth",
      "財"
    ],
    [
      "tall",
      "高い"
    ],
    [
      "recognize",
      "認める"
    ],
    [
      "brass",
      "真鍮"
    ],
    [
      "survival",
      "残存"
    ],
    [
      "quest",
      "捜索"
    ],
    [
      "publish",
      "出版"
    ],
    [
      "toe",
      "趾"
    ],
    [
      "lifetime",
      "生涯"
    ],
    [
      "pioneer",
      "先駆者"
    ],
    [
      "booty",
      "けつ"
    ],
    [
      "intelligent",
      "聡明"
    ],
    [
      "excel",
      "超える"
    ],
    [
      "obligation",
      "責任"
    ],
    [
      "wake",
      "通夜"
    ],
    [
      "stupid",
      "シブい"
    ],
    [
      "harbor",
      "ハーバー"
    ],
    [
      "realize",
      "悟る"
    ],
    [
      "enemy",
      "敵"
    ],
    [
      "puzzle",
      "パズル"
    ],
    [
      "sms",
      "伝言"
    ],
    [
      "shit",
      "糞"
    ],
    [
      "lucky",
      "ラッキー"
    ],
    [
      "thick",
      "濃い"
    ],
    [
      "repeat",
      "リピート"
    ],
    [
      "syndrome",
      "症候群"
    ],
    [
      "penalty",
      "罰"
    ],
    [
      "drum",
      "太鼓"
    ],
    [
      "flood",
      "大水"
    ],
    [
      "orgy",
      "乱交"
    ],
    [
      "arena",
      "土俵"
    ],
    [
      "announcement",
      "公告"
    ],
    [
      "appreciate",
      "理解"
    ],
    [
      "casual",
      "普段"
    ],
    [
      "polish",
      "つや"
    ],
    [
      "lovely",
      "良い"
    ],
    [
      "smile",
      "微笑"
    ],
    [
      "indoor",
      "屋内"
    ],
    [
      "broker",
      "仲立人"
    ],
    [
      "charger",
      "軍馬"
    ],
    [
      "pine",
      "ゴヨウ"
    ],
    [
      "partly",
      "部分的に"
    ],
    [
      "candy",
      "お菓子"
    ],
    [
      "tiger",
      "トラ"
    ],
    [
      "folks",
      "人々"
    ],
    [
      "sensor",
      "センサー"
    ],
    [
      "hunt",
      "狩り"
    ],
    [
      "deputy",
      "代理"
    ],
    [
      "thai",
      "泰"
    ],
    [
      "complaint",
      "不平"
    ],
    [
      "afghanistan",
      "アフガン"
    ],
    [
      "scholarship",
      "学識"
    ],
    [
      "mill",
      "ミル"
    ],
    [
      "finger",
      "ゆび"
    ],
    [
      "camcorder",
      "ビデオカメラ"
    ],
    [
      "burn",
      "焼く"
    ],
    [
      "tobacco",
      "煙草"
    ],
    [
      "wooden",
      "木製"
    ],
    [
      "tough",
      "辛い"
    ],
    [
      "incident",
      "事件"
    ],
    [
      "dynamics",
      "動力学"
    ],
    [
      "lie",
      "嘘"
    ],
    [
      "conversation",
      "話"
    ],
    [
      "decrease",
      "減少"
    ],
    [
      "chest",
      "胸郭"
    ],
    [
      "pension",
      "下宿屋"
    ],
    [
      "emerging",
      "発展途上"
    ],
    [
      "worship",
      "礼拝"
    ],
    [
      "bukkake",
      "打っ掛け"
    ],
    [
      "precision",
      "精度"
    ],
    [
      "shorts",
      "ショートパンツ"
    ],
    [
      "reproduction",
      "複製"
    ],
    [
      "ah",
      "あ"
    ],
    [
      "sole",
      "未婚"
    ],
    [
      "recorder",
      "竪笛"
    ],
    [
      "passion",
      "受難"
    ],
    [
      "sight",
      "見物"
    ],
    [
      "weak",
      "弱い"
    ],
    [
      "refund",
      "返金"
    ],
    [
      "divided",
      "分裂"
    ],
    [
      "reception",
      "受付"
    ],
    [
      "wise",
      "賢明"
    ],
    [
      "odds",
      "勝算"
    ],
    [
      "insider",
      "内部の人"
    ],
    [
      "geography",
      "地理"
    ],
    [
      "worry",
      "噛む"
    ],
    [
      "discrimination",
      "冷遇"
    ],
    [
      "eve",
      "イブ"
    ],
    [
      "phrase",
      "フレーズ"
    ],
    [
      "paradise",
      "楽園"
    ],
    [
      "leaf",
      "葉"
    ],
    [
      "pad",
      "肉球"
    ],
    [
      "glory",
      "名声"
    ],
    [
      "versus",
      "バーサス"
    ],
    [
      "combine",
      "合併"
    ],
    [
      "exceed",
      "越える"
    ],
    [
      "rod",
      "棒"
    ],
    [
      "fault",
      "せい"
    ],
    [
      "cuba",
      "玖馬"
    ],
    [
      "introduce",
      "紹介"
    ],
    [
      "silk",
      "絹地"
    ],
    [
      "romantic",
      "浪漫的"
    ],
    [
      "albert",
      "アルベルト"
    ],
    [
      "examine",
      "尋問"
    ],
    [
      "correction",
      "修正"
    ],
    [
      "wolf",
      "ウルフ"
    ],
    [
      "slowly",
      "そろそろ"
    ],
    [
      "communicate",
      "通じる"
    ],
    [
      "rugby",
      "闘球"
    ],
    [
      "infant",
      "乳児"
    ],
    [
      "samuel",
      "サムエル記"
    ],
    [
      "fluid",
      "液体"
    ],
    [
      "kick",
      "蹴る"
    ],
    [
      "regards",
      "よろしく"
    ],
    [
      "meal",
      "ご飯"
    ],
    [
      "hurt",
      "痛い"
    ],
    [
      "probability",
      "確率"
    ],
    [
      "dimension",
      "次元"
    ],
    [
      "quarterly",
      "季刊誌"
    ],
    [
      "devil",
      "鬼"
    ],
    [
      "grass",
      "草"
    ],
    [
      "comply",
      "従う"
    ],
    [
      "cherry",
      "桜ん坊"
    ],
    [
      "achievement",
      "到達"
    ],
    [
      "webcam",
      "ウェブカメラ"
    ],
    [
      "funeral",
      "葬式"
    ],
    [
      "pee",
      "ピー"
    ],
    [
      "quebec",
      "ケベック"
    ],
    [
      "passenger",
      "旅客"
    ],
    [
      "mars",
      "火星"
    ],
    [
      "francis",
      "フランソワ"
    ],
    [
      "manga",
      "マンガ"
    ]
  ],
  "nl": [
    [
      "the",
      "de"
    ],
    [
      "of",
      "-e-"
    ],
    [
      "to",
      "aan"
    ],
    [
      "in",
      "in"
    ],
    [
      "for",
      "voor"
    ],
    [
      "on",
      "op"
    ],
    [
      "that",
      "dat"
    ],
    [
      "by",
      "door"
    ],
    [
      "this",
      "dit"
    ],
    [
      "with",
      "met"
    ],
    [
      "i",
      "'k"
    ],
    [
      "you",
      "jullie"
    ],
    [
      "it",
      "het"
    ],
    [
      "not",
      "geen"
    ],
    [
      "or",
      "or"
    ],
    [
      "be",
      "zijn"
    ],
    [
      "from",
      "van"
    ],
    [
      "at",
      "op"
    ],
    [
      "as",
      "als"
    ],
    [
      "your",
      "uw"
    ],
    [
      "all",
      "elk"
    ],
    [
      "have",
      "zijn"
    ],
    [
      "new",
      "nieuw"
    ],
    [
      "more",
      "meer"
    ],
    [
      "we",
      "we"
    ],
    [
      "will",
      "Pim"
    ],
    [
      "home",
      "thuis"
    ],
    [
      "can",
      "kunnen"
    ],
    [
      "about",
      "bij"
    ],
    [
      "if",
      "indien"
    ],
    [
      "page",
      "pagina"
    ],
    [
      "search",
      "zoeken"
    ],
    [
      "free",
      "vrij"
    ],
    [
      "but",
      "maar"
    ],
    [
      "our",
      "onze"
    ],
    [
      "one",
      "ene"
    ],
    [
      "other",
      "ander"
    ],
    [
      "do",
      "doen"
    ],
    [
      "no",
      "neen"
    ],
    [
      "time",
      "keer"
    ],
    [
      "they",
      "ze"
    ],
    [
      "he",
      "ie"
    ],
    [
      "up",
      "omhoog"
    ],
    [
      "may",
      "misschien"
    ],
    [
      "what",
      "wat"
    ],
    [
      "which",
      "dewelke"
    ],
    [
      "news",
      "nieuws"
    ],
    [
      "out",
      "uit"
    ],
    [
      "use",
      "nut"
    ],
    [
      "any",
      "enkel"
    ],
    [
      "there",
      "er"
    ],
    [
      "see",
      "zien"
    ],
    [
      "only",
      "net"
    ],
    [
      "so",
      "zodanig"
    ],
    [
      "his",
      "de zijne"
    ],
    [
      "when",
      "wanneer"
    ],
    [
      "contact",
      "aanraking"
    ],
    [
      "here",
      "heden"
    ],
    [
      "business",
      "zaken"
    ],
    [
      "who",
      "dat"
    ],
    [
      "web",
      "net"
    ],
    [
      "also",
      "tevens"
    ],
    [
      "now",
      "nou"
    ],
    [
      "help",
      "hulp"
    ],
    [
      "get",
      "halen"
    ],
    [
      "view",
      "zicht"
    ],
    [
      "online",
      "online"
    ],
    [
      "first",
      "eerste"
    ],
    [
      "me",
      "ik"
    ],
    [
      "s",
      "s"
    ],
    [
      "some",
      "wat"
    ],
    [
      "these",
      "die"
    ],
    [
      "its",
      "zijn"
    ],
    [
      "like",
      "zoals"
    ],
    [
      "service",
      "dienst"
    ],
    [
      "find",
      "vinden"
    ],
    [
      "price",
      "schatten"
    ],
    [
      "date",
      "datum"
    ],
    [
      "back",
      "achter"
    ],
    [
      "top",
      "topje"
    ],
    [
      "people",
      "volk"
    ],
    [
      "list",
      "luisteren"
    ],
    [
      "name",
      "naam"
    ],
    [
      "just",
      "net"
    ],
    [
      "over",
      "op"
    ],
    [
      "state",
      "staat"
    ],
    [
      "day",
      "etmaal"
    ],
    [
      "email",
      "mail"
    ],
    [
      "two",
      "biljet van twee dollar"
    ],
    [
      "health",
      "welzijn"
    ],
    [
      "world",
      "aarde"
    ],
    [
      "re",
      "wat"
    ],
    [
      "next",
      "volgend"
    ],
    [
      "go",
      "weggaan"
    ],
    [
      "work",
      "werk"
    ],
    [
      "last",
      "laatst"
    ],
    [
      "most",
      "-st"
    ],
    [
      "music",
      "partituur"
    ],
    [
      "buy",
      "slikken"
    ],
    [
      "data",
      "gegevens"
    ],
    [
      "make",
      "doen"
    ],
    [
      "them",
      "hen"
    ],
    [
      "should",
      "moeten"
    ],
    [
      "product",
      "product"
    ],
    [
      "system",
      "systeem"
    ],
    [
      "post",
      "paal"
    ],
    [
      "add",
      "optellen"
    ],
    [
      "policy",
      "polis"
    ],
    [
      "number",
      "getal"
    ],
    [
      "such",
      "zo"
    ],
    [
      "please",
      "behagen"
    ],
    [
      "available",
      "vrij"
    ],
    [
      "support",
      "steun"
    ],
    [
      "message",
      "bericht"
    ],
    [
      "after",
      "na"
    ],
    [
      "best",
      "slaan"
    ],
    [
      "software",
      "programmatuur"
    ],
    [
      "then",
      "dan"
    ],
    [
      "good",
      "goed"
    ],
    [
      "video",
      "video"
    ],
    [
      "well",
      "bron"
    ],
    [
      "where",
      "waarvan"
    ],
    [
      "public",
      "publiek"
    ],
    [
      "high",
      "high"
    ],
    [
      "school",
      "universiteit"
    ],
    [
      "each",
      "ieder"
    ],
    [
      "she",
      "ze"
    ],
    [
      "review",
      "recensie"
    ],
    [
      "order",
      "order"
    ],
    [
      "very",
      "erg"
    ],
    [
      "privacy",
      "afzondering"
    ],
    [
      "book",
      "boeken"
    ],
    [
      "company",
      "bedrijf"
    ],
    [
      "read",
      "lezen"
    ],
    [
      "group",
      "verzameling"
    ],
    [
      "sex",
      "vrijen"
    ],
    [
      "need",
      "nood"
    ],
    [
      "many",
      "vele"
    ],
    [
      "user",
      "gebruiker"
    ],
    [
      "said",
      "in kwestie"
    ],
    [
      "set",
      "set"
    ],
    [
      "under",
      "onder"
    ],
    [
      "general",
      "algemeen"
    ],
    [
      "research",
      "onderzoeken"
    ],
    [
      "university",
      "unief"
    ],
    [
      "january",
      "louwmaand"
    ],
    [
      "mail",
      "post"
    ],
    [
      "full",
      "vol"
    ],
    [
      "map",
      "plan"
    ],
    [
      "program",
      "plannen"
    ],
    [
      "life",
      "leven"
    ],
    [
      "know",
      "kennen"
    ],
    [
      "way",
      "manier"
    ],
    [
      "management",
      "bestuur"
    ],
    [
      "great",
      "fijn"
    ],
    [
      "real",
      "echt"
    ],
    [
      "item",
      "stuk"
    ],
    [
      "center",
      "centrum"
    ],
    [
      "must",
      "most"
    ],
    [
      "store",
      "bewaren"
    ],
    [
      "travel",
      "reizen"
    ],
    [
      "report",
      "berichten"
    ],
    [
      "off",
      "uit"
    ],
    [
      "member",
      "lid"
    ],
    [
      "line",
      "lijn"
    ],
    [
      "before",
      "voor"
    ],
    [
      "send",
      "sturen"
    ],
    [
      "right",
      "rechts"
    ],
    [
      "type",
      "typen"
    ],
    [
      "because",
      "daar"
    ],
    [
      "local",
      "stamcafé"
    ],
    [
      "office",
      "bureau"
    ],
    [
      "education",
      "opvoeding"
    ],
    [
      "national",
      "rijk"
    ],
    [
      "car",
      "wagen"
    ],
    [
      "design",
      "dessin"
    ],
    [
      "take",
      "nemen"
    ],
    [
      "address",
      "adres"
    ],
    [
      "community",
      "commune"
    ],
    [
      "area",
      "regio"
    ],
    [
      "want",
      "tekort"
    ],
    [
      "phone",
      "opbellen"
    ],
    [
      "dvd",
      "dvd"
    ],
    [
      "subject",
      "vak"
    ],
    [
      "between",
      "onder"
    ],
    [
      "forum",
      "internetforum"
    ],
    [
      "family",
      "gezin"
    ],
    [
      "based",
      "gebaseerd"
    ],
    [
      "code",
      "coderen"
    ],
    [
      "show",
      "zien"
    ],
    [
      "even",
      "gelijk"
    ],
    [
      "black",
      "zwart"
    ],
    [
      "check",
      "controleren"
    ],
    [
      "website",
      "site"
    ],
    [
      "index",
      "inhoud"
    ],
    [
      "being",
      "bestaan"
    ],
    [
      "sign",
      "teken"
    ],
    [
      "file",
      "bestand"
    ],
    [
      "link",
      "link"
    ],
    [
      "open",
      "openen"
    ],
    [
      "today",
      "vandaag"
    ],
    [
      "technology",
      "techniek"
    ],
    [
      "south",
      "zuid"
    ],
    [
      "case",
      "tas"
    ],
    [
      "project",
      "uitstralen"
    ],
    [
      "same",
      "hetzelfde"
    ],
    [
      "section",
      "sectie"
    ],
    [
      "own",
      "hebben"
    ],
    [
      "house",
      "huis"
    ],
    [
      "related",
      "verwant"
    ],
    [
      "security",
      "onderpand"
    ],
    [
      "both",
      "beiden"
    ],
    [
      "american",
      "Amerikaan"
    ],
    [
      "game",
      "spel"
    ],
    [
      "power",
      "macht"
    ],
    [
      "while",
      "hoewel"
    ],
    [
      "down",
      "beneden"
    ],
    [
      "computer",
      "rekenaar"
    ],
    [
      "three",
      "trits"
    ],
    [
      "total",
      "geheel"
    ],
    [
      "place",
      "plaats"
    ],
    [
      "end",
      "einde"
    ],
    [
      "download",
      "afladen"
    ],
    [
      "access",
      "aanval"
    ],
    [
      "think",
      "denken"
    ],
    [
      "north",
      "noorden"
    ],
    [
      "current",
      "huidig"
    ],
    [
      "big",
      "groot"
    ],
    [
      "law",
      "wet"
    ],
    [
      "control",
      "besturen"
    ],
    [
      "water",
      "wateren"
    ],
    [
      "history",
      "historie"
    ],
    [
      "size",
      "maat"
    ],
    [
      "art",
      "kunst"
    ],
    [
      "since",
      "sedert"
    ],
    [
      "including",
      "inclusief"
    ],
    [
      "shop",
      "atelier"
    ],
    [
      "directory",
      "gids"
    ],
    [
      "board",
      "bord"
    ],
    [
      "location",
      "plaats"
    ],
    [
      "change",
      "vervangen"
    ],
    [
      "white",
      "wit"
    ],
    [
      "text",
      "sms"
    ],
    [
      "small",
      "klein"
    ],
    [
      "rate",
      "tarief"
    ],
    [
      "government",
      "rectie"
    ],
    [
      "during",
      "tijdens"
    ],
    [
      "return",
      "teruggaan"
    ],
    [
      "shopping",
      "winkelen"
    ],
    [
      "account",
      "rekening"
    ],
    [
      "times",
      "maal"
    ],
    [
      "level",
      "niveau"
    ],
    [
      "digital",
      "digitaal"
    ],
    [
      "previous",
      "voorbarig"
    ],
    [
      "form",
      "formulier"
    ],
    [
      "love",
      "liefde"
    ],
    [
      "old",
      "vorig"
    ],
    [
      "john",
      "Jan"
    ],
    [
      "main",
      "voornaam"
    ],
    [
      "call",
      "roepen"
    ],
    [
      "image",
      "beeld"
    ],
    [
      "department",
      "afdeling"
    ],
    [
      "title",
      "titel"
    ],
    [
      "description",
      "descriptie"
    ],
    [
      "y",
      "ie"
    ],
    [
      "insurance",
      "assurantie"
    ],
    [
      "another",
      "een andere"
    ],
    [
      "why",
      "wel"
    ],
    [
      "property",
      "goed"
    ],
    [
      "class",
      "klas"
    ],
    [
      "still",
      "nog"
    ],
    [
      "quality",
      "klasse"
    ],
    [
      "every",
      "ieder"
    ],
    [
      "content",
      "vergenoegen"
    ],
    [
      "country",
      "land-"
    ],
    [
      "private",
      "privé"
    ],
    [
      "little",
      "klein"
    ],
    [
      "visit",
      "bezoek"
    ],
    [
      "save",
      "sparen"
    ],
    [
      "low",
      "diep"
    ],
    [
      "reply",
      "respons"
    ],
    [
      "compare",
      "overeenstemmen"
    ],
    [
      "include",
      "invoegen"
    ],
    [
      "value",
      "waarde"
    ],
    [
      "article",
      "lidwoord"
    ],
    [
      "man",
      "heer"
    ],
    [
      "card",
      "kaart"
    ],
    [
      "provide",
      "voorzien"
    ],
    [
      "food",
      "eten"
    ],
    [
      "source",
      "bron"
    ],
    [
      "author",
      "schrijver"
    ],
    [
      "different",
      "anders"
    ],
    [
      "press",
      "duwen"
    ],
    [
      "learn",
      "leren"
    ],
    [
      "sale",
      "solden"
    ],
    [
      "around",
      "om"
    ],
    [
      "print",
      "printen"
    ],
    [
      "course",
      "koers"
    ],
    [
      "job",
      "baan"
    ],
    [
      "process",
      "verwerken"
    ],
    [
      "room",
      "kamer"
    ],
    [
      "stock",
      "voorraad"
    ],
    [
      "training",
      "training"
    ],
    [
      "too",
      "te"
    ],
    [
      "credit",
      "geloven"
    ],
    [
      "point",
      "punt"
    ],
    [
      "join",
      "toetreden"
    ],
    [
      "science",
      "wetenschap"
    ],
    [
      "advanced",
      "vergevorderd"
    ],
    [
      "west",
      "Westen"
    ],
    [
      "look",
      "op"
    ],
    [
      "english",
      "Engelse"
    ],
    [
      "left",
      "links"
    ],
    [
      "team",
      "ploeg"
    ],
    [
      "estate",
      "adel"
    ],
    [
      "box",
      "doos"
    ],
    [
      "select",
      "selecteer"
    ],
    [
      "gay",
      "homoseksueel"
    ],
    [
      "thread",
      "draad"
    ],
    [
      "note",
      "noteren"
    ],
    [
      "live",
      "leven"
    ],
    [
      "table",
      "tafel"
    ],
    [
      "register",
      "inschrijven"
    ],
    [
      "however",
      "echter"
    ],
    [
      "november",
      "slachtmaand"
    ],
    [
      "market",
      "markt"
    ],
    [
      "library",
      "archief"
    ],
    [
      "really",
      "werkelijk"
    ],
    [
      "action",
      "actie"
    ],
    [
      "start",
      "starten"
    ],
    [
      "series",
      "reeks"
    ],
    [
      "model",
      "modelleren"
    ],
    [
      "air",
      "leegte"
    ],
    [
      "industry",
      "industrie"
    ],
    [
      "plan",
      "plannen"
    ],
    [
      "human",
      "mens"
    ],
    [
      "provided",
      "op voorwaarde dat"
    ],
    [
      "tv",
      "travo"
    ],
    [
      "yes",
      "wel"
    ],
    [
      "second",
      "seconde"
    ],
    [
      "hot",
      "heet"
    ],
    [
      "march",
      "mark"
    ],
    [
      "september",
      "herfstmaand"
    ],
    [
      "say",
      "opgeven"
    ],
    [
      "july",
      "hooimaand"
    ],
    [
      "test",
      "test"
    ],
    [
      "friend",
      "vriendin"
    ],
    [
      "come",
      "komen"
    ],
    [
      "server",
      "dienblad"
    ],
    [
      "study",
      "leren"
    ],
    [
      "application",
      "toepassing"
    ],
    [
      "cart",
      "kart"
    ],
    [
      "staff",
      "balk"
    ],
    [
      "feedback",
      "rondzingen"
    ],
    [
      "again",
      "weer"
    ],
    [
      "play",
      "spelen"
    ],
    [
      "april",
      "grasmaand"
    ],
    [
      "never",
      "nimmer"
    ],
    [
      "complete",
      "algeheel"
    ],
    [
      "topic",
      "thema"
    ],
    [
      "comment",
      "commentariëren"
    ],
    [
      "financial",
      "betalend"
    ],
    [
      "against",
      "voor"
    ],
    [
      "standard",
      "maatstaf"
    ],
    [
      "tax",
      "taks"
    ],
    [
      "mobile",
      "mobiel"
    ],
    [
      "less",
      "loos"
    ],
    [
      "party",
      "fuif"
    ],
    [
      "payment",
      "betaling"
    ],
    [
      "equipment",
      "bepakking"
    ],
    [
      "login",
      "inloggen"
    ],
    [
      "student",
      "studente"
    ],
    [
      "let",
      "toestaan"
    ],
    [
      "legal",
      "recht"
    ],
    [
      "above",
      "over"
    ],
    [
      "park",
      "stationeren"
    ],
    [
      "side",
      "kant"
    ],
    [
      "act",
      "gedragen"
    ],
    [
      "problem",
      "oefening"
    ],
    [
      "red",
      "rood"
    ],
    [
      "give",
      "meegeven"
    ],
    [
      "memory",
      "herinnering"
    ],
    [
      "performance",
      "opvoering"
    ],
    [
      "social",
      "maatschappelijk"
    ],
    [
      "august",
      "oogstmaand"
    ],
    [
      "quote",
      "bestek"
    ],
    [
      "language",
      "taal"
    ],
    [
      "story",
      "vertelsel"
    ],
    [
      "experience",
      "ervaren"
    ],
    [
      "create",
      "creëren"
    ],
    [
      "key",
      "toets"
    ],
    [
      "body",
      "lijf"
    ],
    [
      "young",
      "jong"
    ],
    [
      "field",
      "veld"
    ],
    [
      "few",
      "enkele"
    ],
    [
      "east",
      "Oosten"
    ],
    [
      "paper",
      "papier"
    ],
    [
      "single",
      "vrijgezel"
    ],
    [
      "age",
      "era"
    ],
    [
      "club",
      "knuppel"
    ],
    [
      "additional",
      "bijkomend"
    ],
    [
      "latest",
      "nieuwst"
    ],
    [
      "gift",
      "gave"
    ],
    [
      "question",
      "vraag"
    ],
    [
      "night",
      "nacht"
    ],
    [
      "hard",
      "hard"
    ],
    [
      "pay",
      "lonen"
    ],
    [
      "poker",
      "poker"
    ],
    [
      "status",
      "aanzien"
    ],
    [
      "browse",
      "surfen"
    ],
    [
      "range",
      "bereik"
    ],
    [
      "building",
      "bouw"
    ],
    [
      "seller",
      "verkoopster"
    ],
    [
      "court",
      "hof"
    ],
    [
      "february",
      "regenmaand"
    ],
    [
      "always",
      "steeds"
    ],
    [
      "result",
      "vrucht"
    ],
    [
      "light",
      "licht"
    ],
    [
      "war",
      "krijg"
    ],
    [
      "offer",
      "bod"
    ],
    [
      "blue",
      "blauw"
    ],
    [
      "easy",
      "gemakkelijk"
    ],
    [
      "event",
      "evenement"
    ],
    [
      "release",
      "vrijlaten"
    ],
    [
      "analysis",
      "analyse"
    ],
    [
      "request",
      "vraag"
    ],
    [
      "china",
      "Volksrepubliek China"
    ],
    [
      "picture",
      "plaatje"
    ],
    [
      "possible",
      "mogelijk"
    ],
    [
      "might",
      "macht"
    ],
    [
      "professional",
      "expert"
    ],
    [
      "yet",
      "nog"
    ],
    [
      "major",
      "hoofdvak"
    ],
    [
      "star",
      "ster"
    ],
    [
      "future",
      "toekomst"
    ],
    [
      "space",
      "ruimte"
    ],
    [
      "committee",
      "commissie"
    ],
    [
      "hand",
      "kant"
    ],
    [
      "sun",
      "Zon"
    ],
    [
      "london",
      "Londen"
    ],
    [
      "meeting",
      "ontmoeting"
    ],
    [
      "interest",
      "interesse"
    ],
    [
      "id",
      "id"
    ],
    [
      "keep",
      "houden"
    ],
    [
      "enter",
      "invoeren"
    ],
    [
      "share",
      "deel"
    ],
    [
      "similar",
      "dergelijk"
    ],
    [
      "garden",
      "park"
    ],
    [
      "reference",
      "referent"
    ],
    [
      "baby",
      "jong"
    ],
    [
      "learning",
      "kennis"
    ],
    [
      "run",
      "rennen"
    ],
    [
      "delivery",
      "geboorte"
    ],
    [
      "net",
      "val"
    ],
    [
      "popular",
      "volks"
    ],
    [
      "term",
      "voet"
    ],
    [
      "film",
      "laagje"
    ],
    [
      "put",
      "stellen"
    ],
    [
      "journal",
      "logboek"
    ],
    [
      "try",
      "berechten"
    ],
    [
      "welcome",
      "welkom"
    ],
    [
      "notice",
      "inzien"
    ],
    [
      "god",
      "verafgoden"
    ],
    [
      "original",
      "origineel"
    ],
    [
      "head",
      "hoofd"
    ],
    [
      "until",
      "totdat"
    ],
    [
      "cell",
      "cel"
    ],
    [
      "color",
      "kleuren"
    ],
    [
      "track",
      "voetspoor"
    ],
    [
      "discussion",
      "discussie"
    ],
    [
      "once",
      "eens"
    ],
    [
      "entertainment",
      "vermaak"
    ],
    [
      "agreement",
      "afspraak"
    ],
    [
      "format",
      "formaat"
    ],
    [
      "society",
      "gezelschap"
    ],
    [
      "log",
      "houtblok"
    ],
    [
      "safety",
      "zekerheid"
    ],
    [
      "trade",
      "handel"
    ],
    [
      "edition",
      "druk"
    ],
    [
      "tell",
      "vertellen"
    ],
    [
      "further",
      "bevorderen"
    ],
    [
      "association",
      "associatie"
    ],
    [
      "able",
      "competent"
    ],
    [
      "fun",
      "pret"
    ],
    [
      "already",
      "al"
    ],
    [
      "green",
      "groen"
    ],
    [
      "close",
      "sluiten"
    ],
    [
      "common",
      "gewoon"
    ],
    [
      "drive",
      "drijven"
    ],
    [
      "several",
      "meerdere"
    ],
    [
      "gold",
      "goud"
    ],
    [
      "collection",
      "collectie"
    ],
    [
      "short",
      "klein"
    ],
    [
      "lot",
      "lood"
    ],
    [
      "display",
      "beeldscherm"
    ],
    [
      "limited",
      "beperkt"
    ],
    [
      "means",
      "middelen"
    ],
    [
      "director",
      "regisseur"
    ],
    [
      "past",
      "voorbij"
    ],
    [
      "natural",
      "normaal"
    ],
    [
      "upon",
      "bij"
    ],
    [
      "period",
      "punt"
    ],
    [
      "database",
      "databank"
    ],
    [
      "official",
      "beambte"
    ],
    [
      "weather",
      "doorstaan"
    ],
    [
      "mar",
      "verpesten"
    ],
    [
      "land",
      "grond"
    ],
    [
      "done",
      "op"
    ],
    [
      "window",
      "venster"
    ],
    [
      "region",
      "regio"
    ],
    [
      "island",
      "eiland"
    ],
    [
      "record",
      "plaat"
    ],
    [
      "environment",
      "milieu"
    ],
    [
      "district",
      "regio"
    ],
    [
      "calendar",
      "agenda"
    ],
    [
      "front",
      "front"
    ],
    [
      "statement",
      "verklaring"
    ],
    [
      "update",
      "bijwerking"
    ],
    [
      "ever",
      "ooit"
    ],
    [
      "sound",
      "klinken"
    ],
    [
      "resource",
      "bron"
    ],
    [
      "present",
      "heden"
    ],
    [
      "either",
      "of"
    ],
    [
      "word",
      "woordenwisseling"
    ],
    [
      "works",
      "werken"
    ],
    [
      "material",
      "materiaal"
    ],
    [
      "bill",
      "bek"
    ],
    [
      "talk",
      "praten"
    ],
    [
      "federal",
      "bond"
    ],
    [
      "final",
      "ultiem"
    ],
    [
      "adult",
      "volwassen"
    ],
    [
      "thing",
      "punt"
    ],
    [
      "via",
      "per"
    ],
    [
      "cheap",
      "gierig"
    ],
    [
      "nude",
      "bloot"
    ],
    [
      "true",
      "echt"
    ],
    [
      "else",
      "zoniet"
    ],
    [
      "mark",
      "punt"
    ],
    [
      "third",
      "terts"
    ],
    [
      "rock",
      "rots"
    ],
    [
      "reading",
      "lezing"
    ],
    [
      "bad",
      "naar"
    ],
    [
      "individual",
      "enkeling"
    ],
    [
      "plus",
      "plus"
    ],
    [
      "cover",
      "dekken"
    ],
    [
      "usually",
      "meestal"
    ],
    [
      "edit",
      "uitgeven"
    ],
    [
      "together",
      "samen"
    ],
    [
      "fast",
      "vlug"
    ],
    [
      "function",
      "fungeren"
    ],
    [
      "fact",
      "feit"
    ],
    [
      "global",
      "sferisch"
    ],
    [
      "meet",
      "treffen"
    ],
    [
      "player",
      "speler"
    ],
    [
      "lyrics",
      "songtekst"
    ],
    [
      "often",
      "dikwijls"
    ],
    [
      "submit",
      "indienen"
    ],
    [
      "amount",
      "saldo"
    ],
    [
      "watch",
      "opletten"
    ],
    [
      "feel",
      "voelen"
    ],
    [
      "bank",
      "bank"
    ],
    [
      "risk",
      "riskeren"
    ],
    [
      "thanks",
      "dank"
    ],
    [
      "various",
      "verscheiden"
    ],
    [
      "commercial",
      "commercieel"
    ],
    [
      "james",
      "Jaak"
    ],
    [
      "town",
      "tuin"
    ],
    [
      "heart",
      "hart"
    ],
    [
      "choose",
      "kiezen"
    ],
    [
      "knowledge",
      "weten"
    ],
    [
      "magazine",
      "magazijn"
    ],
    [
      "error",
      "fout"
    ],
    [
      "camera",
      "fotoapparaat"
    ],
    [
      "girl",
      "meid"
    ],
    [
      "currently",
      "huidig"
    ],
    [
      "construction",
      "aanbouw"
    ],
    [
      "clear",
      "helder"
    ],
    [
      "receive",
      "krijgen"
    ],
    [
      "chapter",
      "kapittel"
    ],
    [
      "loan",
      "uitlenen"
    ],
    [
      "wide",
      "breed"
    ],
    [
      "beauty",
      "mooi"
    ],
    [
      "manager",
      "beheer"
    ],
    [
      "india",
      "Indië"
    ],
    [
      "position",
      "positie"
    ],
    [
      "sort",
      "sorteren"
    ],
    [
      "michael",
      "Maikel"
    ],
    [
      "step",
      "gaan"
    ],
    [
      "simple",
      "simpel"
    ],
    [
      "quick",
      "snel"
    ],
    [
      "none",
      "niks"
    ],
    [
      "license",
      "toekennen"
    ],
    [
      "paul",
      "Pol"
    ],
    [
      "basic",
      "basis"
    ],
    [
      "church",
      "kerk"
    ],
    [
      "purchase",
      "aanschaf"
    ],
    [
      "response",
      "respons"
    ],
    [
      "practice",
      "praktijk"
    ],
    [
      "hardware",
      "hardware"
    ],
    [
      "figure",
      "vorm"
    ],
    [
      "fire",
      "vuur"
    ],
    [
      "holiday",
      "vakantie"
    ],
    [
      "chat",
      "babbelen"
    ],
    [
      "enough",
      "genoeg"
    ],
    [
      "along",
      "door"
    ],
    [
      "among",
      "tussen"
    ],
    [
      "death",
      "overlijden"
    ],
    [
      "writing",
      "schrijfsel"
    ],
    [
      "speed",
      "vaart"
    ],
    [
      "loss",
      "verlies"
    ],
    [
      "face",
      "gezicht"
    ],
    [
      "brand",
      "merk"
    ],
    [
      "remember",
      "gedenken"
    ],
    [
      "oil",
      "olie"
    ],
    [
      "bit",
      "bit"
    ],
    [
      "yellow",
      "laf"
    ],
    [
      "political",
      "politiek"
    ],
    [
      "increase",
      "groeien"
    ],
    [
      "kingdom",
      "rijk"
    ],
    [
      "base",
      "basis"
    ],
    [
      "near",
      "bij"
    ],
    [
      "thought",
      "idee"
    ],
    [
      "stuff",
      "spul"
    ],
    [
      "french",
      "fransozen"
    ],
    [
      "entry",
      "lemma"
    ],
    [
      "stay",
      "stag"
    ],
    [
      "nature",
      "aard"
    ],
    [
      "availability",
      "beschikbaarheid"
    ],
    [
      "summary",
      "opsomming"
    ],
    [
      "turn",
      "draaien"
    ],
    [
      "mean",
      "menen"
    ],
    [
      "growth",
      "groei"
    ],
    [
      "agency",
      "macht"
    ],
    [
      "king",
      "dam"
    ],
    [
      "european",
      "Europeaanse"
    ],
    [
      "activity",
      "actief"
    ],
    [
      "copy",
      "nadoen"
    ],
    [
      "although",
      "maar"
    ],
    [
      "drug",
      "medicijn"
    ],
    [
      "western",
      "westers"
    ],
    [
      "force",
      "macht"
    ],
    [
      "cash",
      "baar"
    ],
    [
      "employment",
      "emplooi"
    ],
    [
      "bay",
      "laurier"
    ],
    [
      "river",
      "stroom"
    ],
    [
      "commission",
      "courtage"
    ],
    [
      "package",
      "inpakken"
    ],
    [
      "engine",
      "aandrijving"
    ],
    [
      "port",
      "poort"
    ],
    [
      "regional",
      "gewestelijk"
    ],
    [
      "stop",
      "stoppen"
    ],
    [
      "administration",
      "toediening"
    ],
    [
      "bar",
      "bar"
    ],
    [
      "double",
      "contra"
    ],
    [
      "dog",
      "reu"
    ],
    [
      "build",
      "opbouwen"
    ],
    [
      "screen",
      "zaal"
    ],
    [
      "exchange",
      "ruil"
    ],
    [
      "soon",
      "zo"
    ],
    [
      "electronic",
      "elektronisch"
    ],
    [
      "continue",
      "verdergaan"
    ],
    [
      "across",
      "overheen"
    ],
    [
      "season",
      "rijpen"
    ],
    [
      "apply",
      "gelden"
    ],
    [
      "anything",
      "alles"
    ],
    [
      "printer",
      "printer"
    ],
    [
      "condition",
      "voorwaarde"
    ],
    [
      "effective",
      "werkzaam"
    ],
    [
      "believe",
      "geloven"
    ],
    [
      "organization",
      "organisatie"
    ],
    [
      "effect",
      "werking"
    ],
    [
      "mind",
      "passen op"
    ],
    [
      "casino",
      "casino"
    ],
    [
      "lost",
      "kwijt"
    ],
    [
      "tour",
      "reis"
    ],
    [
      "menu",
      "menukaart"
    ],
    [
      "volume",
      "inhoud"
    ],
    [
      "cross",
      "kruis"
    ],
    [
      "anyone",
      "eenieder"
    ],
    [
      "mortgage",
      "verpanden"
    ],
    [
      "hope",
      "uitzicht"
    ],
    [
      "silver",
      "zilver"
    ],
    [
      "corporation",
      "naamloze vennootschap"
    ],
    [
      "wish",
      "wensen"
    ],
    [
      "mature",
      "vervallen"
    ],
    [
      "rather",
      "meer"
    ],
    [
      "addition",
      "optellen"
    ],
    [
      "supply",
      "aanbod"
    ],
    [
      "nothing",
      "niks"
    ],
    [
      "certain",
      "zeker"
    ],
    [
      "necessary",
      "noodzakelijk"
    ],
    [
      "union",
      "vereniging"
    ],
    [
      "clothing",
      "kledij"
    ],
    [
      "particular",
      "precies"
    ],
    [
      "fine",
      "fijn"
    ],
    [
      "hour",
      "uur"
    ],
    [
      "gas",
      "pit"
    ],
    [
      "bush",
      "bosje"
    ],
    [
      "advice",
      "advies"
    ],
    [
      "career",
      "carrière"
    ],
    [
      "military",
      "krijgs-"
    ],
    [
      "decision",
      "besluit"
    ],
    [
      "leave",
      "laten"
    ],
    [
      "british",
      "Britse"
    ],
    [
      "huge",
      "gigantisch"
    ],
    [
      "bid",
      "bidden"
    ],
    [
      "kind",
      "ras"
    ],
    [
      "middle",
      "midden"
    ],
    [
      "move",
      "bewegen"
    ],
    [
      "cable",
      "kabel"
    ],
    [
      "division",
      "divisie"
    ],
    [
      "object",
      "object"
    ],
    [
      "lesbian",
      "lesbi"
    ],
    [
      "appropriate",
      "gepast"
    ],
    [
      "machine",
      "apparaat"
    ],
    [
      "actually",
      "feitelijk"
    ],
    [
      "nice",
      "fijn"
    ],
    [
      "score",
      "partituur"
    ],
    [
      "client",
      "cliënt"
    ],
    [
      "ok",
      "oké"
    ],
    [
      "capital",
      "dood"
    ],
    [
      "sample",
      "staal"
    ],
    [
      "saturday",
      "zaterdag"
    ],
    [
      "christmas",
      "kerst"
    ],
    [
      "band",
      "bende"
    ],
    [
      "lead",
      "leiden"
    ],
    [
      "george",
      "Goris"
    ],
    [
      "choice",
      "keuzemogelijkeheid"
    ],
    [
      "thursday",
      "donderdag"
    ],
    [
      "hi",
      "hallo"
    ],
    [
      "airport",
      "vlieghaven"
    ],
    [
      "foreign",
      "vreemd"
    ],
    [
      "artist",
      "artiest"
    ],
    [
      "outside",
      "buitenaf"
    ],
    [
      "furniture",
      "meubelstuk"
    ],
    [
      "channel",
      "kanaal"
    ],
    [
      "letter",
      "brief"
    ],
    [
      "mode",
      "modus"
    ],
    [
      "summer",
      "zomertijd"
    ],
    [
      "allow",
      "toestaan"
    ],
    [
      "degree",
      "graad"
    ],
    [
      "contract",
      "overeenkomst"
    ],
    [
      "button",
      "knop"
    ],
    [
      "male",
      "mannetje"
    ],
    [
      "matter",
      "stof"
    ],
    [
      "custom",
      "tol"
    ],
    [
      "almost",
      "vrijwel"
    ],
    [
      "asian",
      "Azische"
    ],
    [
      "distribution",
      "verdeling"
    ],
    [
      "editor",
      "redacteur"
    ],
    [
      "industrial",
      "industrie"
    ],
    [
      "cause",
      "doel"
    ],
    [
      "song",
      "lied"
    ],
    [
      "focus",
      "focus"
    ],
    [
      "late",
      "laat"
    ],
    [
      "fall",
      "val"
    ],
    [
      "idea",
      "idee"
    ],
    [
      "female",
      "wijfje"
    ],
    [
      "responsible",
      "verantwoordelijk"
    ],
    [
      "win",
      "overwinnen"
    ],
    [
      "reason",
      "reden"
    ],
    [
      "tool",
      "instrument"
    ],
    [
      "spring",
      "wel"
    ],
    [
      "foundation",
      "fundament"
    ],
    [
      "answer",
      "antwoorden"
    ],
    [
      "voice",
      "stemmen"
    ],
    [
      "friendly",
      "vriendschappelijk"
    ],
    [
      "schedule",
      "planning"
    ],
    [
      "purpose",
      "nut"
    ],
    [
      "feature",
      "met"
    ],
    [
      "bed",
      "bed"
    ],
    [
      "everyone",
      "allen"
    ],
    [
      "independent",
      "zelfstandig"
    ],
    [
      "approach",
      "benaderen"
    ],
    [
      "brown",
      "Bruin"
    ],
    [
      "physical",
      "ruw"
    ],
    [
      "medicine",
      "artsenij"
    ],
    [
      "deal",
      "delen"
    ],
    [
      "hold",
      "vasthouden"
    ],
    [
      "happy",
      "blij"
    ],
    [
      "smith",
      "Smid"
    ],
    [
      "thank",
      "danken"
    ],
    [
      "safe",
      "veilig"
    ],
    [
      "survey",
      "enquête"
    ],
    [
      "telephone",
      "bellen"
    ],
    [
      "ready",
      "gereed"
    ],
    [
      "feed",
      "voeden"
    ],
    [
      "animal",
      "dier"
    ],
    [
      "population",
      "populatie"
    ],
    [
      "pa",
      "opa"
    ],
    [
      "regular",
      "vast"
    ],
    [
      "navigation",
      "navigatie"
    ],
    [
      "therefore",
      "daardoor"
    ],
    [
      "ass",
      "kont"
    ],
    [
      "evidence",
      "bewijsmateriaal"
    ],
    [
      "station",
      "halte"
    ],
    [
      "christian",
      "christen"
    ],
    [
      "round",
      "rond"
    ],
    [
      "understand",
      "geloven"
    ],
    [
      "option",
      "keuze"
    ],
    [
      "master",
      "controleren"
    ],
    [
      "valley",
      "dal"
    ],
    [
      "recently",
      "laatst"
    ],
    [
      "cut",
      "knippen"
    ],
    [
      "worldwide",
      "wereldwijde"
    ],
    [
      "improve",
      "beteren"
    ],
    [
      "connection",
      "overstap"
    ],
    [
      "publisher",
      "uitgeverij"
    ],
    [
      "hall",
      "hal"
    ],
    [
      "earth",
      "aarde"
    ],
    [
      "impact",
      "inslag"
    ],
    [
      "transfer",
      "verplaatsen"
    ],
    [
      "introduction",
      "introductie"
    ],
    [
      "strong",
      "sterk"
    ],
    [
      "wedding",
      "trouw"
    ],
    [
      "hospital",
      "kliniek"
    ],
    [
      "ground",
      "bodem"
    ],
    [
      "ship",
      "opsturen"
    ],
    [
      "accommodation",
      "accommodatie"
    ],
    [
      "excellent",
      "uitmuntend"
    ],
    [
      "perfect",
      "volmaakt"
    ],
    [
      "opportunity",
      "gelegenheid"
    ],
    [
      "kit",
      "set"
    ],
    [
      "classic",
      "classicus"
    ],
    [
      "command",
      "opdracht"
    ],
    [
      "william",
      "Wim"
    ],
    [
      "express",
      "gedetailleerd"
    ],
    [
      "award",
      "beloning"
    ],
    [
      "distance",
      "eind"
    ],
    [
      "tree",
      "wiet"
    ],
    [
      "peter",
      "Pieter"
    ],
    [
      "assessment",
      "taxatie"
    ],
    [
      "thus",
      "aldus"
    ],
    [
      "wall",
      "muur"
    ],
    [
      "ie",
      "je"
    ],
    [
      "especially",
      "vooral"
    ],
    [
      "interface",
      "raakpunt"
    ],
    [
      "pussy",
      "kut"
    ],
    [
      "budget",
      "begroten"
    ],
    [
      "success",
      "welgang"
    ],
    [
      "quite",
      "best"
    ],
    [
      "boy",
      "boy"
    ],
    [
      "beautiful",
      "mooi"
    ],
    [
      "warning",
      "waarning"
    ],
    [
      "wine",
      "bordeauxrood"
    ],
    [
      "horse",
      "paard"
    ],
    [
      "vote",
      "stem"
    ],
    [
      "forward",
      "forwarden"
    ],
    [
      "significant",
      "voelbaar"
    ],
    [
      "owner",
      "bezitter"
    ],
    [
      "retail",
      "adviesprijs"
    ],
    [
      "useful",
      "dienstig"
    ],
    [
      "directly",
      "rechtuit"
    ],
    [
      "est",
      "t"
    ],
    [
      "rule",
      "heersen"
    ],
    [
      "mother",
      "koesteren"
    ],
    [
      "authority",
      "gezag"
    ],
    [
      "traffic",
      "handel"
    ],
    [
      "input",
      "ingang"
    ],
    [
      "agent",
      "bewerker"
    ],
    [
      "bin",
      "afvalbak"
    ],
    [
      "modern",
      "eigentijds"
    ],
    [
      "senior",
      "senior"
    ],
    [
      "teaching",
      "onderwijzing"
    ],
    [
      "door",
      "portier"
    ],
    [
      "grand",
      "groot"
    ],
    [
      "trial",
      "test"
    ],
    [
      "charge",
      "lading"
    ],
    [
      "canadian",
      "Canadese"
    ],
    [
      "cool",
      "afkoelen"
    ],
    [
      "normal",
      "gewone"
    ],
    [
      "entire",
      "hele"
    ],
    [
      "educational",
      "onderwijskundig"
    ],
    [
      "metal",
      "metaal"
    ],
    [
      "positive",
      "HIV positief"
    ],
    [
      "chinese",
      "Chinese"
    ],
    [
      "opinion",
      "visie"
    ],
    [
      "football",
      "voetballen"
    ],
    [
      "abstract",
      "abstract"
    ],
    [
      "output",
      "uitgang"
    ],
    [
      "develop",
      "ontwikkelen"
    ],
    [
      "resolution",
      "resolutie"
    ],
    [
      "pass",
      "voorbijgaan"
    ],
    [
      "trust",
      "vertrouwen"
    ],
    [
      "van",
      "busje"
    ],
    [
      "session",
      "sessie"
    ],
    [
      "republic",
      "republiek"
    ],
    [
      "century",
      "centurie"
    ],
    [
      "academic",
      "universitair"
    ],
    [
      "assistance",
      "assistentie"
    ],
    [
      "skin",
      "vel"
    ],
    [
      "indian",
      "bok"
    ],
    [
      "ring",
      "luiden"
    ],
    [
      "grade",
      "punt"
    ],
    [
      "pop",
      "pap"
    ],
    [
      "filter",
      "sijpelen"
    ],
    [
      "vehicle",
      "voertuig"
    ],
    [
      "consider",
      "beschouwen"
    ],
    [
      "behind",
      "na"
    ],
    [
      "panel",
      "forum"
    ],
    [
      "german",
      "Duitse"
    ],
    [
      "match",
      "gelijke"
    ],
    [
      "deep",
      "diep"
    ],
    [
      "morning",
      "ochtend"
    ],
    [
      "otherwise",
      "anders"
    ],
    [
      "rest",
      "rust"
    ],
    [
      "protein",
      "eiwit"
    ],
    [
      "plant",
      "site"
    ],
    [
      "hit",
      "treffen"
    ],
    [
      "pool",
      "poel"
    ],
    [
      "partner",
      "partner"
    ],
    [
      "fish",
      "snoeken"
    ],
    [
      "mission",
      "missie"
    ],
    [
      "eye",
      "oog"
    ],
    [
      "string",
      "koord"
    ],
    [
      "sense",
      "zin"
    ],
    [
      "stage",
      "fase"
    ],
    [
      "internal",
      "intern"
    ],
    [
      "goods",
      "waar"
    ],
    [
      "richard",
      "Rikkert"
    ],
    [
      "japanese",
      "Japanse"
    ],
    [
      "race",
      "ras"
    ],
    [
      "target",
      "doel"
    ],
    [
      "except",
      "uitsluiten"
    ],
    [
      "character",
      "karakter"
    ],
    [
      "maintenance",
      "handhaving"
    ],
    [
      "ability",
      "talent"
    ],
    [
      "maybe",
      "mogelijk"
    ],
    [
      "ed",
      "e-"
    ],
    [
      "moving",
      "bewegende"
    ],
    [
      "pretty",
      "aardig"
    ],
    [
      "southern",
      "zuid"
    ],
    [
      "yourself",
      "uzelf"
    ],
    [
      "rape",
      "schenden"
    ],
    [
      "battery",
      "legbatterij"
    ],
    [
      "youth",
      "jongeman"
    ],
    [
      "incest",
      "bloedschande"
    ],
    [
      "debt",
      "schulden"
    ],
    [
      "television",
      "kijkbuis"
    ],
    [
      "interested",
      "belanghebbend"
    ],
    [
      "core",
      "kern"
    ],
    [
      "break",
      "breken"
    ],
    [
      "wood",
      "hout"
    ],
    [
      "itself",
      "zelf"
    ],
    [
      "fee",
      "prijs"
    ],
    [
      "studio",
      "atelier"
    ],
    [
      "reader",
      "lezeres"
    ],
    [
      "device",
      "toestel"
    ],
    [
      "rent",
      "barst"
    ],
    [
      "remote",
      "veraf"
    ],
    [
      "dark",
      "donker"
    ],
    [
      "external",
      "uitwendig"
    ],
    [
      "enjoy",
      "genieten"
    ],
    [
      "remove",
      "weghalen"
    ],
    [
      "aid",
      "aide"
    ],
    [
      "surface",
      "oppervlak"
    ],
    [
      "host",
      "gastheer"
    ],
    [
      "variety",
      "verscheidenheid"
    ],
    [
      "isbn",
      "Internationaal Standaard Boeknummer"
    ],
    [
      "martin",
      "Martijn"
    ],
    [
      "manual",
      "manuaal"
    ],
    [
      "block",
      "kop"
    ],
    [
      "repair",
      "reparatie"
    ],
    [
      "fair",
      "beurs"
    ],
    [
      "civil",
      "beschaafd"
    ],
    [
      "understanding",
      "begrip"
    ],
    [
      "wrong",
      "fout"
    ],
    [
      "beginning",
      "begin"
    ],
    [
      "finally",
      "ten slotte"
    ],
    [
      "desktop",
      "bureaublad"
    ],
    [
      "capacity",
      "capaciteit"
    ],
    [
      "fat",
      "dik"
    ],
    [
      "father",
      "pa"
    ],
    [
      "saw",
      "spreuk"
    ],
    [
      "driver",
      "chauffeur"
    ],
    [
      "dead",
      "dode"
    ],
    [
      "respect",
      "achting"
    ],
    [
      "unknown",
      "ongekend"
    ],
    [
      "trip",
      "tocht"
    ],
    [
      "worth",
      "vermogen"
    ],
    [
      "poor",
      "arm"
    ],
    [
      "teacher",
      "docent"
    ],
    [
      "relationship",
      "relatie"
    ],
    [
      "farm",
      "hoeve"
    ],
    [
      "fucking",
      "kut"
    ],
    [
      "georgia",
      "Georgië"
    ],
    [
      "peace",
      "rust"
    ],
    [
      "tom",
      "mannetje"
    ],
    [
      "creative",
      "creatief"
    ],
    [
      "coast",
      "zeekant"
    ],
    [
      "benefit",
      "nut"
    ],
    [
      "progress",
      "vooruitgang"
    ],
    [
      "lord",
      "heer"
    ],
    [
      "grant",
      "toegeven"
    ],
    [
      "agree",
      "overeenstemmen"
    ],
    [
      "sometimes",
      "weleens"
    ],
    [
      "beyond",
      "voorbij"
    ],
    [
      "fan",
      "liefhebber"
    ],
    [
      "transport",
      "vervoeren"
    ],
    [
      "interesting",
      "belangwekkend"
    ],
    [
      "wife",
      "echtgenote"
    ],
    [
      "evaluation",
      "evaluatie"
    ],
    [
      "former",
      "deze"
    ],
    [
      "ten",
      "tientje"
    ],
    [
      "zone",
      "gebied"
    ],
    [
      "complex",
      "ingewikkeld"
    ],
    [
      "cat",
      "kat"
    ],
    [
      "die",
      "mal"
    ],
    [
      "jack",
      "stekker"
    ],
    [
      "flat",
      "lek"
    ],
    [
      "flow",
      "vloed"
    ],
    [
      "literature",
      "letterkunde"
    ],
    [
      "parent",
      "bron"
    ],
    [
      "columbia",
      "Colombia"
    ],
    [
      "scale",
      "schaal"
    ],
    [
      "stand",
      "standplaats"
    ],
    [
      "critical",
      "kritiek"
    ],
    [
      "frame",
      "frame"
    ],
    [
      "musical",
      "muziek"
    ],
    [
      "definition",
      "definitie"
    ],
    [
      "secretary",
      "secretaris"
    ],
    [
      "path",
      "pad"
    ],
    [
      "australian",
      "Australische"
    ],
    [
      "employee",
      "bediende"
    ],
    [
      "chief",
      "directie"
    ],
    [
      "bottom",
      "bil"
    ],
    [
      "detail",
      "detachement"
    ],
    [
      "pet",
      "aaien"
    ],
    [
      "begin",
      "aanvangen"
    ],
    [
      "clean",
      "schoon"
    ],
    [
      "switch",
      "twijg"
    ],
    [
      "russian",
      "Rus"
    ],
    [
      "african",
      "Afrikaanse"
    ],
    [
      "guy",
      "gast"
    ],
    [
      "justice",
      "recht"
    ],
    [
      "connect",
      "aansluiten"
    ],
    [
      "bible",
      "Schrift"
    ],
    [
      "cup",
      "beker"
    ],
    [
      "basket",
      "korf"
    ],
    [
      "applied",
      "toegepast"
    ],
    [
      "weekly",
      "wekelijks"
    ],
    [
      "demand",
      "eis"
    ],
    [
      "suite",
      "suite"
    ],
    [
      "square",
      "vierkant"
    ],
    [
      "attention",
      "attentie"
    ],
    [
      "advance",
      "avance"
    ],
    [
      "skip",
      "overslaan"
    ],
    [
      "diet",
      "landdag"
    ],
    [
      "army",
      "leger"
    ],
    [
      "gear",
      "schakelen"
    ],
    [
      "lee",
      "lij"
    ],
    [
      "difference",
      "verschil"
    ],
    [
      "correct",
      "juist"
    ],
    [
      "charles",
      "Charel"
    ],
    [
      "nation",
      "volk"
    ],
    [
      "piece",
      "deel"
    ],
    [
      "sheet",
      "laag"
    ],
    [
      "species",
      "soort"
    ],
    [
      "jump",
      "springen"
    ],
    [
      "resort",
      "uitweg"
    ],
    [
      "facility",
      "gemak"
    ],
    [
      "random",
      "lukraak"
    ],
    [
      "certificate",
      "attest"
    ],
    [
      "minister",
      "dienaar"
    ],
    [
      "motion",
      "motie"
    ],
    [
      "monitor",
      "beeldscherm"
    ],
    [
      "forest",
      "bos"
    ],
    [
      "whose",
      "wier"
    ],
    [
      "couple",
      "paar"
    ],
    [
      "chance",
      "kans"
    ],
    [
      "vision",
      "visioen"
    ],
    [
      "ball",
      "bal"
    ],
    [
      "listen",
      "horen"
    ],
    [
      "discuss",
      "bepraten"
    ],
    [
      "accept",
      "aannemen"
    ],
    [
      "naked",
      "bloot"
    ],
    [
      "goal",
      "doel"
    ],
    [
      "successful",
      "gelukt"
    ],
    [
      "wind",
      "blazen"
    ],
    [
      "situation",
      "situatie"
    ],
    [
      "highly",
      "zeer"
    ],
    [
      "appear",
      "optreden"
    ],
    [
      "emergency",
      "nood"
    ],
    [
      "currency",
      "valuta"
    ],
    [
      "leather",
      "leder"
    ],
    [
      "determine",
      "bepalen"
    ],
    [
      "temperature",
      "koorts"
    ],
    [
      "palm",
      "palm"
    ],
    [
      "patient",
      "patiënt"
    ],
    [
      "actual",
      "echt"
    ],
    [
      "historical",
      "geschiedkundig"
    ],
    [
      "stone",
      "steen"
    ],
    [
      "bob",
      "dobberen"
    ],
    [
      "commerce",
      "commercie"
    ],
    [
      "perhaps",
      "wellicht"
    ],
    [
      "satellite",
      "kunstmaan"
    ],
    [
      "fit",
      "aangepast"
    ],
    [
      "amateur",
      "amateur"
    ],
    [
      "coffee",
      "mokka"
    ],
    [
      "cum",
      "komen"
    ],
    [
      "buyer",
      "klant"
    ],
    [
      "oral",
      "oraal"
    ],
    [
      "ford",
      "doorwaardbare plaats"
    ],
    [
      "poster",
      "affiche"
    ],
    [
      "edge",
      "tak"
    ],
    [
      "functional",
      "werkend"
    ],
    [
      "root",
      "wortel"
    ],
    [
      "closed",
      "gesloten"
    ],
    [
      "ice",
      "koudmaken"
    ],
    [
      "pink",
      "roze"
    ],
    [
      "balance",
      "balans"
    ],
    [
      "monitoring",
      "volgen"
    ],
    [
      "graduate",
      "promoveren"
    ],
    [
      "shot",
      "hagel"
    ],
    [
      "architecture",
      "bouwstijl"
    ],
    [
      "initial",
      "begin"
    ],
    [
      "label",
      "etiket"
    ],
    [
      "recommend",
      "aanraden"
    ],
    [
      "canon",
      "oeuvre"
    ],
    [
      "league",
      "liga"
    ],
    [
      "waste",
      "vuil"
    ],
    [
      "minute",
      "moment"
    ],
    [
      "bus",
      "de"
    ],
    [
      "dictionary",
      "dictionaire"
    ],
    [
      "cold",
      "koel"
    ],
    [
      "chair",
      "zetel"
    ],
    [
      "fishing",
      "stek"
    ],
    [
      "bag",
      "tas"
    ],
    [
      "fantasy",
      "fantasie"
    ],
    [
      "motor",
      "motorrijtuig"
    ],
    [
      "professor",
      "prof"
    ],
    [
      "install",
      "opzetten"
    ],
    [
      "shirt",
      "overhemd"
    ],
    [
      "foot",
      "voet"
    ],
    [
      "mass",
      "mis"
    ],
    [
      "crime",
      "misdaad"
    ],
    [
      "count",
      "graaf"
    ],
    [
      "breast",
      "hart"
    ],
    [
      "johnson",
      "Johansen"
    ],
    [
      "quickly",
      "gauw"
    ],
    [
      "religion",
      "godsdienst"
    ],
    [
      "claim",
      "claimen"
    ],
    [
      "permission",
      "verlof"
    ],
    [
      "surgery",
      "chirurgie"
    ],
    [
      "heat",
      "hitte"
    ],
    [
      "miss",
      "missen"
    ],
    [
      "chemical",
      "scheikundig"
    ],
    [
      "doctor",
      "dokter"
    ],
    [
      "task",
      "taak"
    ],
    [
      "reduce",
      "verlagen"
    ],
    [
      "himself",
      "zelf"
    ],
    [
      "component",
      "onderdeel"
    ],
    [
      "enable",
      "inschakelen"
    ],
    [
      "exercise",
      "bewegen"
    ],
    [
      "bug",
      "insect"
    ],
    [
      "mid",
      "midden"
    ],
    [
      "guarantee",
      "garanderen"
    ],
    [
      "leader",
      "leidster"
    ],
    [
      "soft",
      "week"
    ],
    [
      "flight",
      "vlucht"
    ],
    [
      "congress",
      "congres"
    ],
    [
      "walk",
      "wandelen"
    ],
    [
      "fuck",
      "batsen"
    ],
    [
      "italian",
      "Italiaanse"
    ],
    [
      "wait",
      "bedienen"
    ],
    [
      "rose",
      "roos"
    ],
    [
      "freedom",
      "vrijdom"
    ],
    [
      "argument",
      "thema"
    ],
    [
      "competition",
      "competitie"
    ],
    [
      "joint",
      "bak"
    ],
    [
      "premium",
      "premie"
    ],
    [
      "fresh",
      "fris"
    ],
    [
      "factor",
      "factor"
    ],
    [
      "pick",
      "nemen"
    ],
    [
      "administrative",
      "bestuurlijk"
    ],
    [
      "serious",
      "serieus"
    ],
    [
      "prime",
      "voornaamste"
    ],
    [
      "limit",
      "limiet"
    ],
    [
      "ac",
      "wisselstroom"
    ],
    [
      "creek",
      "slenk"
    ],
    [
      "quantity",
      "kwantiteit"
    ],
    [
      "urban",
      "urbaan"
    ],
    [
      "essential",
      "wezenlijk"
    ],
    [
      "myself",
      "mezelf"
    ],
    [
      "platform",
      "podium"
    ],
    [
      "load",
      "laden"
    ],
    [
      "affiliate",
      "filiaal"
    ],
    [
      "immediately",
      "direct"
    ],
    [
      "defense",
      "verweer"
    ],
    [
      "heavy",
      "zwaar"
    ],
    [
      "recovery",
      "herstel"
    ],
    [
      "cock",
      "haan"
    ],
    [
      "merchant",
      "koopvrouw"
    ],
    [
      "comprehensive",
      "diepgaand"
    ],
    [
      "expert",
      "deskundige"
    ],
    [
      "universal",
      "universeel"
    ],
    [
      "protect",
      "beveiligen"
    ],
    [
      "drop",
      "val"
    ],
    [
      "solid",
      "effen"
    ],
    [
      "presentation",
      "voordracht"
    ],
    [
      "orange",
      "oranje"
    ],
    [
      "prevent",
      "verhinderen"
    ],
    [
      "campaign",
      "campagne"
    ],
    [
      "marine",
      "marien"
    ],
    [
      "pennsylvania",
      "Pennsylvanië"
    ],
    [
      "saying",
      "gezegde"
    ],
    [
      "porno",
      "pornografie"
    ],
    [
      "challenge",
      "tarten"
    ],
    [
      "acceptance",
      "acceptatie"
    ],
    [
      "seem",
      "schijnen"
    ],
    [
      "touch",
      "raken"
    ],
    [
      "hire",
      "verhuren"
    ],
    [
      "suggest",
      "voorstellen"
    ],
    [
      "branch",
      "arm"
    ],
    [
      "serve",
      "serveren"
    ],
    [
      "magic",
      "magisch"
    ],
    [
      "mount",
      "ruiter"
    ],
    [
      "smart",
      "slim"
    ],
    [
      "latin",
      "Latijns"
    ],
    [
      "manage",
      "leiden"
    ],
    [
      "rank",
      "rij"
    ],
    [
      "computing",
      "informatica"
    ],
    [
      "element",
      "element"
    ],
    [
      "birth",
      "afkomst"
    ],
    [
      "virus",
      "computervirus"
    ],
    [
      "abuse",
      "onteren"
    ],
    [
      "separate",
      "scheiden"
    ],
    [
      "quarter",
      "kwartaal"
    ],
    [
      "leadership",
      "voorzitterschap"
    ],
    [
      "define",
      "definiëren"
    ],
    [
      "religious",
      "religieus"
    ],
    [
      "breakfast",
      "inbeet"
    ],
    [
      "column",
      "kolom"
    ],
    [
      "faith",
      "vertrouwen"
    ],
    [
      "chain",
      "keten"
    ],
    [
      "developer",
      "promotor"
    ],
    [
      "identify",
      "determineren"
    ],
    [
      "avenue",
      "weg"
    ],
    [
      "approximately",
      "ruwweg"
    ],
    [
      "comparison",
      "gelijkenis"
    ],
    [
      "mental",
      "geestelijk"
    ],
    [
      "moment",
      "tijdstip"
    ],
    [
      "sequence",
      "rij"
    ],
    [
      "inch",
      "haarbreed"
    ],
    [
      "attack",
      "aanval"
    ],
    [
      "sorry",
      "pardon"
    ],
    [
      "opening",
      "première"
    ],
    [
      "reserve",
      "reserveren"
    ],
    [
      "plastic",
      "kunststof"
    ],
    [
      "produce",
      "waar"
    ],
    [
      "snow",
      "sneeuw"
    ],
    [
      "truth",
      "waarheid"
    ],
    [
      "counter",
      "aanrecht"
    ],
    [
      "failure",
      "mislukking"
    ],
    [
      "weekend",
      "weekend"
    ],
    [
      "ontario",
      "Ontariomeer"
    ],
    [
      "bridge",
      "brug"
    ],
    [
      "native",
      "inheems"
    ],
    [
      "fill",
      "vollopen"
    ],
    [
      "williams",
      "Willemse"
    ],
    [
      "movement",
      "deel"
    ],
    [
      "printing",
      "oplage"
    ],
    [
      "approval",
      "permissie"
    ],
    [
      "draft",
      "trek"
    ],
    [
      "equal",
      "gelijke"
    ],
    [
      "adventure",
      "wagen"
    ],
    [
      "profit",
      "profiteren"
    ],
    [
      "assistant",
      "assistente"
    ],
    [
      "variable",
      "veranderlijk"
    ],
    [
      "advertisement",
      "advertentie"
    ],
    [
      "yesterday",
      "gister"
    ],
    [
      "workshop",
      "atelier"
    ],
    [
      "gone",
      "op"
    ],
    [
      "extension",
      "extensie"
    ],
    [
      "golden",
      "gouden"
    ],
    [
      "completely",
      "compleet"
    ],
    [
      "fort",
      "fort"
    ],
    [
      "funny",
      "mop"
    ],
    [
      "brother",
      "broeder"
    ],
    [
      "pattern",
      "patroon"
    ],
    [
      "boat",
      "schip"
    ],
    [
      "icon",
      "icoon"
    ],
    [
      "evening",
      "avondfeest"
    ],
    [
      "assembly",
      "vergadering"
    ],
    [
      "nuclear",
      "nucleair"
    ],
    [
      "mouse",
      "muis"
    ],
    [
      "signal",
      "signaal"
    ],
    [
      "criminal",
      "misdadig"
    ],
    [
      "brain",
      "brein"
    ],
    [
      "sexual",
      "seksueel"
    ],
    [
      "dream",
      "hoop"
    ],
    [
      "false",
      "vals"
    ],
    [
      "cast",
      "casten"
    ],
    [
      "flower",
      "openbloeien"
    ],
    [
      "personnel",
      "medewerkers"
    ],
    [
      "soul",
      "geest"
    ],
    [
      "promote",
      "promoten"
    ],
    [
      "hawaii",
      "Hawaii"
    ],
    [
      "carry",
      "dragen"
    ],
    [
      "flag",
      "vlag"
    ],
    [
      "advantage",
      "overhand"
    ],
    [
      "hello",
      "dag"
    ],
    [
      "priority",
      "prioriteit"
    ],
    [
      "brief",
      "kort"
    ],
    [
      "anonymous",
      "anoniem"
    ],
    [
      "iron",
      "ijzer"
    ],
    [
      "straight",
      "pure"
    ],
    [
      "script",
      "schrift"
    ],
    [
      "miscellaneous",
      "veelzijdig"
    ],
    [
      "void",
      "leeg"
    ],
    [
      "alert",
      "waakzaam"
    ],
    [
      "integration",
      "integratie"
    ],
    [
      "tag",
      "tikkertje"
    ],
    [
      "interview",
      "vraaggesprek"
    ],
    [
      "mix",
      "mixen"
    ],
    [
      "framework",
      "kader"
    ],
    [
      "disk",
      "schijf"
    ],
    [
      "queen",
      "dame"
    ],
    [
      "clearly",
      "klaar"
    ],
    [
      "handle",
      "behandelen"
    ],
    [
      "sweet",
      "lief"
    ],
    [
      "desk",
      "bureau"
    ],
    [
      "vice",
      "zonde"
    ],
    [
      "associate",
      "associëren"
    ],
    [
      "truck",
      "camion"
    ],
    [
      "behavior",
      "gedragingen"
    ],
    [
      "enlarge",
      "uitvergroten"
    ],
    [
      "ray",
      "straal"
    ],
    [
      "frequently",
      "veelvuldig"
    ],
    [
      "revenue",
      "omzet"
    ],
    [
      "measure",
      "maat"
    ],
    [
      "duty",
      "taks"
    ],
    [
      "bear",
      "dragen"
    ],
    [
      "gain",
      "bekomen"
    ],
    [
      "festival",
      "feest"
    ],
    [
      "laboratory",
      "lab"
    ],
    [
      "ocean",
      "wereldzee"
    ],
    [
      "lack",
      "derven"
    ],
    [
      "whatever",
      "boeiend"
    ],
    [
      "laptop",
      "notebook"
    ],
    [
      "vintage",
      "cru"
    ],
    [
      "train",
      "trainen"
    ],
    [
      "exactly",
      "precies"
    ],
    [
      "dry",
      "afdrogen"
    ],
    [
      "explore",
      "exploreren"
    ],
    [
      "concept",
      "opvatting"
    ],
    [
      "reality",
      "realiteit"
    ],
    [
      "origin",
      "herkomst"
    ],
    [
      "billion",
      "biljoen"
    ],
    [
      "intelligence",
      "wezen"
    ],
    [
      "con",
      "fraude"
    ],
    [
      "route",
      "weg"
    ],
    [
      "broken",
      "gebroken"
    ],
    [
      "frank",
      "open"
    ],
    [
      "zoom",
      "zoeven"
    ],
    [
      "blow",
      "pijpen"
    ],
    [
      "battle",
      "gevecht"
    ],
    [
      "query",
      "verzoek"
    ],
    [
      "partnership",
      "maatschap"
    ],
    [
      "expression",
      "uitdrukking"
    ],
    [
      "equity",
      "aandeel"
    ],
    [
      "speech",
      "rede"
    ],
    [
      "wire",
      "ader"
    ],
    [
      "shared",
      "gedeeld"
    ],
    [
      "replacement",
      "vervanger"
    ],
    [
      "judge",
      "oordelen"
    ],
    [
      "spam",
      "spamboodschap"
    ],
    [
      "acid",
      "lsd"
    ],
    [
      "compatible",
      "compatibel"
    ],
    [
      "fight",
      "gevecht"
    ],
    [
      "apartment",
      "flat"
    ],
    [
      "height",
      "lengte"
    ],
    [
      "speaker",
      "box"
    ],
    [
      "netherlands",
      "Holland"
    ],
    [
      "recreation",
      "recreatie"
    ],
    [
      "designer",
      "ontwerper"
    ],
    [
      "remain",
      "resteren"
    ],
    [
      "marriage",
      "huwelijk"
    ],
    [
      "roll",
      "rol"
    ],
    [
      "secret",
      "geheimenis"
    ],
    [
      "bath",
      "bad"
    ],
    [
      "negative",
      "min"
    ],
    [
      "andrew",
      "Andreas"
    ],
    [
      "perform",
      "houden"
    ],
    [
      "healthy",
      "gezond"
    ],
    [
      "translation",
      "vertaling"
    ],
    [
      "font",
      "bron"
    ],
    [
      "injury",
      "letsel"
    ],
    [
      "joseph",
      "Josef"
    ],
    [
      "ministry",
      "departement"
    ],
    [
      "lawyer",
      "jurist"
    ],
    [
      "married",
      "gehuwd"
    ],
    [
      "proposal",
      "voorstel"
    ],
    [
      "waiting",
      "wachten"
    ],
    [
      "birthday",
      "geboortedag"
    ],
    [
      "fail",
      "buizen"
    ],
    [
      "toward",
      "naartoe"
    ],
    [
      "slightly",
      "lichtelijk"
    ],
    [
      "assist",
      "bijstaan"
    ],
    [
      "conduct",
      "leiden"
    ],
    [
      "legislation",
      "wet"
    ],
    [
      "wear",
      "sleet"
    ],
    [
      "ultimate",
      "ultiem"
    ],
    [
      "representative",
      "vertegenwoordiger"
    ],
    [
      "frequency",
      "regelmaat"
    ],
    [
      "minor",
      "licht"
    ],
    [
      "finish",
      "meet"
    ],
    [
      "reduced",
      "verkleind"
    ],
    [
      "physics",
      "natuurkunde"
    ],
    [
      "rare",
      "halfrauw"
    ],
    [
      "spent",
      "vermoeid"
    ],
    [
      "extreme",
      "extreem"
    ],
    [
      "daniel",
      "Daneel"
    ],
    [
      "row",
      "kabaal"
    ],
    [
      "forecast",
      "schatting"
    ],
    [
      "administrator",
      "administrateur"
    ],
    [
      "cycle",
      "cyclus"
    ],
    [
      "contain",
      "inhouden"
    ],
    [
      "accuracy",
      "precisie"
    ],
    [
      "dual",
      "tweevoud"
    ],
    [
      "rise",
      "rijzen"
    ],
    [
      "sleep",
      "slapen"
    ],
    [
      "bird",
      "vogel"
    ],
    [
      "pharmacy",
      "farmacie"
    ],
    [
      "creation",
      "creatie"
    ],
    [
      "hunter",
      "jachthond"
    ],
    [
      "lady",
      "damestoilet"
    ],
    [
      "crystal",
      "kristal"
    ],
    [
      "famous",
      "alom bekend"
    ],
    [
      "writer",
      "auteur"
    ],
    [
      "drink",
      "drinken"
    ],
    [
      "academy",
      "college"
    ],
    [
      "dynamic",
      "dynamisch"
    ],
    [
      "gender",
      "geslacht"
    ],
    [
      "eat",
      "vreten"
    ],
    [
      "permanent",
      "eeuwig"
    ],
    [
      "agriculture",
      "agricultuur"
    ],
    [
      "seat",
      "zitvlak"
    ],
    [
      "originally",
      "origineel"
    ],
    [
      "philosophy",
      "filosofie"
    ],
    [
      "regulation",
      "reglement"
    ],
    [
      "reduction",
      "reductie"
    ],
    [
      "aim",
      "oogmerk"
    ],
    [
      "cape",
      "mantel"
    ],
    [
      "ann",
      "Anne"
    ],
    [
      "meaning",
      "zin"
    ],
    [
      "tip",
      "tip"
    ],
    [
      "secondary",
      "plaatsvervangend"
    ],
    [
      "wonderful",
      "wonderbaar"
    ],
    [
      "mine",
      "mijn"
    ],
    [
      "henry",
      "Henk"
    ],
    [
      "ticket",
      "biljet"
    ],
    [
      "guess",
      "raden"
    ],
    [
      "whom",
      "die"
    ],
    [
      "import",
      "invoer"
    ],
    [
      "presence",
      "tegenwoordigheid"
    ],
    [
      "instant",
      "ogenblik"
    ],
    [
      "automatic",
      "mechanisch"
    ],
    [
      "majority",
      "merendeel"
    ],
    [
      "ahead",
      "voorop"
    ],
    [
      "moon",
      "maan"
    ],
    [
      "participation",
      "meedoen"
    ],
    [
      "scheme",
      "plan"
    ],
    [
      "utility",
      "hulpmiddel"
    ],
    [
      "preview",
      "voorproefje"
    ],
    [
      "fly",
      "lukken"
    ],
    [
      "manner",
      "wijze"
    ],
    [
      "combination",
      "combinatie"
    ],
    [
      "strength",
      "kracht"
    ],
    [
      "proper",
      "echt"
    ],
    [
      "fear",
      "angst"
    ],
    [
      "phoenix",
      "feniks"
    ],
    [
      "convention",
      "conventie"
    ],
    [
      "principal",
      "rector"
    ],
    [
      "comfort",
      "gemak"
    ],
    [
      "appeal",
      "appeleren"
    ],
    [
      "cruise",
      "cruisen"
    ],
    [
      "bonus",
      "premie"
    ],
    [
      "previously",
      "tevoren"
    ],
    [
      "hey",
      "hé"
    ],
    [
      "bookmark",
      "boekenlegger"
    ],
    [
      "beat",
      "mieters"
    ],
    [
      "household",
      "huishouden"
    ],
    [
      "adobe",
      "steenklei"
    ],
    [
      "achieve",
      "realiseren"
    ],
    [
      "dress",
      "zich kleden"
    ],
    [
      "dealer",
      "gever"
    ],
    [
      "contemporary",
      "eigentijds"
    ],
    [
      "sky",
      "hemel"
    ],
    [
      "nearby",
      "nabij"
    ],
    [
      "rom",
      "zigeunerin"
    ],
    [
      "exposure",
      "de"
    ],
    [
      "hide",
      "wegstoppen"
    ],
    [
      "signature",
      "katern"
    ],
    [
      "gambling",
      "kansspel"
    ],
    [
      "refer",
      "verwijzen"
    ],
    [
      "miller",
      "Mulder"
    ],
    [
      "provision",
      "bepaling"
    ],
    [
      "certainly",
      "zeker"
    ],
    [
      "indeed",
      "echt"
    ],
    [
      "newspaper",
      "gazet"
    ],
    [
      "circuit",
      "stroomkring"
    ],
    [
      "layer",
      "legster"
    ],
    [
      "slow",
      "sloom"
    ],
    [
      "hip",
      "heup"
    ],
    [
      "mostly",
      "meestal"
    ],
    [
      "spot",
      "plek"
    ],
    [
      "taylor",
      "Sneijder"
    ],
    [
      "spend",
      "spenderen"
    ],
    [
      "grow",
      "telen"
    ],
    [
      "promotion",
      "promotie"
    ],
    [
      "relative",
      "betrekkelijk"
    ],
    [
      "amazing",
      "wonderbaarlijk"
    ],
    [
      "clock",
      "teller"
    ],
    [
      "identity",
      "persoonlijkheid"
    ],
    [
      "conversion",
      "omzetting"
    ],
    [
      "feeling",
      "gevoel"
    ],
    [
      "hidden",
      "verscholen"
    ],
    [
      "victoria",
      "Victoriameer"
    ],
    [
      "relief",
      "reliëf"
    ],
    [
      "influence",
      "invloed"
    ],
    [
      "importance",
      "belangrijkheid"
    ],
    [
      "planet",
      "zwerfster"
    ],
    [
      "permit",
      "toestaan"
    ],
    [
      "dna",
      "DNZ"
    ],
    [
      "bass",
      "bas"
    ],
    [
      "prescription",
      "voorschrift"
    ],
    [
      "empty",
      "leegmaken"
    ],
    [
      "instance",
      "voorval"
    ],
    [
      "hole",
      "gat"
    ],
    [
      "ride",
      "kar"
    ],
    [
      "bureau",
      "kast"
    ],
    [
      "represent",
      "voorstellen"
    ],
    [
      "conservation",
      "conserveren"
    ],
    [
      "pair",
      "paar"
    ],
    [
      "ideal",
      "ideaal"
    ],
    [
      "don",
      "zich"
    ],
    [
      "dinner",
      "eten"
    ],
    [
      "stress",
      "zenuwen"
    ],
    [
      "cream",
      "crème"
    ],
    [
      "yeah",
      "yes"
    ],
    [
      "discover",
      "onthullen"
    ],
    [
      "advisor",
      "adviseuse"
    ],
    [
      "evil",
      "euvel"
    ],
    [
      "aware",
      "waakzaam"
    ],
    [
      "shape",
      "vorm"
    ],
    [
      "remains",
      "stoffelijk overschot"
    ],
    [
      "cap",
      "pet"
    ],
    [
      "mixed",
      "onzuiver"
    ],
    [
      "peak",
      "piek"
    ],
    [
      "wheel",
      "rad"
    ],
    [
      "transit",
      "overgang"
    ],
    [
      "dick",
      "lul"
    ],
    [
      "salt",
      "zout"
    ],
    [
      "compact",
      "samenpersen"
    ],
    [
      "poetry",
      "poëzie"
    ],
    [
      "bell",
      "bel"
    ],
    [
      "preparation",
      "preparaat"
    ],
    [
      "attempt",
      "pogen"
    ],
    [
      "noise",
      "ruis"
    ],
    [
      "forget",
      "nalaten"
    ],
    [
      "accurate",
      "exact"
    ],
    [
      "stephen",
      "Stefan"
    ],
    [
      "elizabeth",
      "Elizabeth"
    ],
    [
      "pin",
      "pin"
    ],
    [
      "alcohol",
      "sterke drank"
    ],
    [
      "greek",
      "Griekse"
    ],
    [
      "instruction",
      "instructie"
    ],
    [
      "sister",
      "zus"
    ],
    [
      "raw",
      "ruw"
    ],
    [
      "explain",
      "verklaren"
    ],
    [
      "establish",
      "stichten"
    ],
    [
      "extent",
      "bereik"
    ],
    [
      "sharp",
      "hoog"
    ],
    [
      "lane",
      "rijvak"
    ],
    [
      "paragraph",
      "alinea"
    ],
    [
      "kill",
      "vermoorden"
    ],
    [
      "mathematics",
      "mathesis"
    ],
    [
      "compensation",
      "compensatie"
    ],
    [
      "export",
      "uitvoer"
    ],
    [
      "conflict",
      "met"
    ],
    [
      "occur",
      "voorkomen"
    ],
    [
      "describe",
      "omschrijven"
    ],
    [
      "concern",
      "zaak"
    ],
    [
      "backup",
      "back-up"
    ],
    [
      "heritage",
      "erfenis"
    ],
    [
      "immediate",
      "onmiddellijk"
    ],
    [
      "trouble",
      "last"
    ],
    [
      "spread",
      "verspreiden"
    ],
    [
      "coach",
      "reisbus"
    ],
    [
      "expand",
      "uitdijen"
    ],
    [
      "audience",
      "gevolg"
    ],
    [
      "jordan",
      "Jordaan"
    ],
    [
      "participate",
      "meedoen"
    ],
    [
      "plug",
      "prop"
    ],
    [
      "specialist",
      "specialiste"
    ],
    [
      "cook",
      "bakken"
    ],
    [
      "affect",
      "veinzen"
    ],
    [
      "virgin",
      "maagdelijk"
    ],
    [
      "investigation",
      "nasporing"
    ],
    [
      "hat",
      "pet"
    ],
    [
      "affected",
      "getroffen"
    ],
    [
      "bike",
      "velo"
    ],
    [
      "totally",
      "totaal"
    ],
    [
      "plate",
      "dienblad"
    ],
    [
      "indicate",
      "aangeven"
    ],
    [
      "proceedings",
      "verslag"
    ],
    [
      "favourite",
      "geliefkoost"
    ],
    [
      "transmission",
      "transmissie"
    ],
    [
      "lose",
      "verliezen"
    ],
    [
      "organic",
      "organisch"
    ],
    [
      "seek",
      "nastreven"
    ],
    [
      "extremely",
      "uitermate"
    ],
    [
      "concerning",
      "omtrent"
    ],
    [
      "chemistry",
      "chemo-"
    ],
    [
      "neighborhood",
      "wijk"
    ],
    [
      "agenda",
      "schema"
    ],
    [
      "anyway",
      "hoe dan ook"
    ],
    [
      "template",
      "malplaatje"
    ],
    [
      "circle",
      "kring"
    ],
    [
      "soil",
      "grond"
    ],
    [
      "anywhere",
      "ergens"
    ],
    [
      "psychology",
      "zielkunde"
    ],
    [
      "wet",
      "plassen"
    ],
    [
      "edward",
      "Eduard"
    ],
    [
      "investor",
      "belegger"
    ],
    [
      "identification",
      "identificatie"
    ],
    [
      "wildlife",
      "wildleven"
    ],
    [
      "fox",
      "vos"
    ],
    [
      "plain",
      "kaal"
    ],
    [
      "exit",
      "afrit"
    ],
    [
      "arm",
      "wapen"
    ],
    [
      "launch",
      "lanceren"
    ],
    [
      "wave",
      "golf"
    ],
    [
      "holy",
      "heilig"
    ],
    [
      "mesh",
      "maas"
    ],
    [
      "trail",
      "pad"
    ],
    [
      "highway",
      "snelweg"
    ],
    [
      "buddy",
      "kerel"
    ],
    [
      "dean",
      "deken"
    ],
    [
      "booking",
      "boeken"
    ],
    [
      "glossary",
      "woordenlijst"
    ],
    [
      "filled",
      "vol"
    ],
    [
      "bond",
      "binding"
    ],
    [
      "appendix",
      "appendix"
    ],
    [
      "notify",
      "notificeren"
    ],
    [
      "chocolate",
      "chocolade"
    ],
    [
      "portion",
      "deel"
    ],
    [
      "scope",
      "scoop"
    ],
    [
      "cotton",
      "katoen"
    ],
    [
      "bluetooth",
      "Bluetooth"
    ],
    [
      "requirement",
      "voorwaarde"
    ],
    [
      "border",
      "rand"
    ],
    [
      "ancient",
      "oeroud"
    ],
    [
      "debate",
      "discussie"
    ],
    [
      "learned",
      "geleerd"
    ],
    [
      "notebook",
      "cahier"
    ],
    [
      "explorer",
      "ontdekker"
    ],
    [
      "husband",
      "man"
    ],
    [
      "disabled",
      "onklaar"
    ],
    [
      "crazy",
      "zot"
    ],
    [
      "retirement",
      "pensioen"
    ],
    [
      "efficiency",
      "rendement"
    ],
    [
      "comedy",
      "komedie"
    ],
    [
      "commitment",
      "engagement"
    ],
    [
      "specialty",
      "terrein"
    ],
    [
      "hop",
      "hoppen"
    ],
    [
      "carrier",
      "vervoerder"
    ],
    [
      "mouth",
      "bek"
    ],
    [
      "jewish",
      "joods"
    ],
    [
      "meter",
      "metrum"
    ],
    [
      "gun",
      "vuurwapen"
    ],
    [
      "reflect",
      "nadenken"
    ],
    [
      "pure",
      "puur"
    ],
    [
      "deliver",
      "baren"
    ],
    [
      "wonder",
      "zich afvragen"
    ],
    [
      "fruit",
      "ooft"
    ],
    [
      "qualified",
      "deskundig"
    ],
    [
      "lens",
      "linze"
    ],
    [
      "discovery",
      "vinding"
    ],
    [
      "draw",
      "trekken"
    ],
    [
      "assume",
      "aannemen"
    ],
    [
      "confidence",
      "vertrouwen"
    ],
    [
      "confirm",
      "beamen"
    ],
    [
      "warm",
      "opwarmen"
    ],
    [
      "neither",
      "ook niet"
    ],
    [
      "offline",
      "ontkoppeld"
    ],
    [
      "engineer",
      "ingenieur"
    ],
    [
      "consistent",
      "consequent"
    ],
    [
      "inventory",
      "voorraad"
    ],
    [
      "suck",
      "klote zijn"
    ],
    [
      "objective",
      "objectief"
    ],
    [
      "crew",
      "team"
    ],
    [
      "stick",
      "stok"
    ],
    [
      "relation",
      "relatie"
    ],
    [
      "slide",
      "glijden"
    ],
    [
      "volunteer",
      "vrijwilligster"
    ],
    [
      "rear",
      "achterste"
    ],
    [
      "enhance",
      "uitbreiden"
    ],
    [
      "exact",
      "precies"
    ],
    [
      "bound",
      "limiet"
    ],
    [
      "adapter",
      "reisstekker"
    ],
    [
      "processor",
      "CPU"
    ],
    [
      "contribute",
      "contribueren"
    ],
    [
      "lock",
      "sluis"
    ],
    [
      "storm",
      "onweer"
    ],
    [
      "bowl",
      "schaal"
    ],
    [
      "supreme",
      "opperst"
    ],
    [
      "recognition",
      "erkenning"
    ],
    [
      "tank",
      "tank"
    ],
    [
      "submission",
      "onderwerping"
    ],
    [
      "encourage",
      "steunen"
    ],
    [
      "navy",
      "zeemacht"
    ],
    [
      "kid",
      "geitje"
    ],
    [
      "inspection",
      "keuring"
    ],
    [
      "cancel",
      "annuleren"
    ],
    [
      "territory",
      "grondgebied"
    ],
    [
      "paint",
      "schilderen"
    ],
    [
      "delay",
      "verdagen"
    ],
    [
      "pilot",
      "test-"
    ],
    [
      "continuous",
      "continu"
    ],
    [
      "czech",
      "Tsjechische"
    ],
    [
      "novel",
      "novelle"
    ],
    [
      "pan",
      "kraken"
    ],
    [
      "execution",
      "uitvoering"
    ],
    [
      "winner",
      "winnares"
    ],
    [
      "contractor",
      "uitvoerder"
    ],
    [
      "episode",
      "aflevering"
    ],
    [
      "examination",
      "toets"
    ],
    [
      "potter",
      "pottenbakster"
    ],
    [
      "dish",
      "gerecht"
    ],
    [
      "modify",
      "veranderen"
    ],
    [
      "oxford",
      "Ossenvoord"
    ],
    [
      "truly",
      "oprecht"
    ],
    [
      "painting",
      "geschilder"
    ],
    [
      "universe",
      "heelal"
    ],
    [
      "candidate",
      "kandidaat"
    ],
    [
      "patent",
      "patent"
    ],
    [
      "outstanding",
      "openstaand"
    ],
    [
      "perspective",
      "perspectief"
    ],
    [
      "lodge",
      "loge"
    ],
    [
      "messenger",
      "bode"
    ],
    [
      "tournament",
      "tornooi"
    ],
    [
      "consideration",
      "beraad"
    ],
    [
      "kernel",
      "kern"
    ],
    [
      "stocks",
      "kaak"
    ],
    [
      "gray",
      "vergrijzen"
    ],
    [
      "catalogue",
      "cataloog"
    ],
    [
      "taiwan",
      "Formosa"
    ],
    [
      "demo",
      "demo"
    ],
    [
      "swiss",
      "Zwitser"
    ],
    [
      "sarah",
      "Sara"
    ],
    [
      "labour",
      "bevalling"
    ],
    [
      "caribbean",
      "Caribisch"
    ],
    [
      "liquid",
      "vloeibaar"
    ],
    [
      "loop",
      "lus"
    ],
    [
      "salary",
      "loon"
    ],
    [
      "reservation",
      "reservatie"
    ],
    [
      "gourmet",
      "gastronome"
    ],
    [
      "guard",
      "bewaker"
    ],
    [
      "empire",
      "imperium"
    ],
    [
      "resume",
      "voortzetten"
    ],
    [
      "raise",
      "opheffen"
    ],
    [
      "prepare",
      "klaarmaken"
    ],
    [
      "avatar",
      "ava"
    ],
    [
      "illegal",
      "onwettig"
    ],
    [
      "milk",
      "uitmelken"
    ],
    [
      "decide",
      "beslissen"
    ],
    [
      "consent",
      "instemmen"
    ],
    [
      "drama",
      "toneelstuk"
    ],
    [
      "downtown",
      "binnenstad"
    ],
    [
      "keyboard",
      "klavier"
    ],
    [
      "collected",
      "kalm"
    ],
    [
      "boot",
      "straffen"
    ],
    [
      "suitable",
      "passend"
    ],
    [
      "absolutely",
      "echt"
    ],
    [
      "lunch",
      "dineren"
    ],
    [
      "dildo",
      "vibrator"
    ],
    [
      "push",
      "stoten"
    ],
    [
      "chamber",
      "kamer"
    ],
    [
      "implement",
      "toepassen"
    ],
    [
      "yours",
      "de uwe"
    ],
    [
      "sum",
      "som"
    ],
    [
      "calculator",
      "planner"
    ],
    [
      "significantly",
      "voelbaar"
    ],
    [
      "chicken",
      "hen"
    ],
    [
      "attend",
      "volgen"
    ],
    [
      "shower",
      "douche"
    ],
    [
      "alan",
      "Alain"
    ],
    [
      "tonight",
      "vanavond"
    ],
    [
      "dear",
      "beste"
    ],
    [
      "shell",
      "schaal"
    ],
    [
      "catholic",
      "katholiek"
    ],
    [
      "oak",
      "eik"
    ],
    [
      "awareness",
      "besef"
    ],
    [
      "governor",
      "regelaar"
    ],
    [
      "beer",
      "bier"
    ],
    [
      "contribution",
      "bijdrage"
    ],
    [
      "swimming",
      "duizeling"
    ],
    [
      "formula",
      "kindervoeding"
    ],
    [
      "constitution",
      "constitutie"
    ],
    [
      "catch",
      "vangen"
    ],
    [
      "reliable",
      "zeker"
    ],
    [
      "consultation",
      "samenspraak"
    ],
    [
      "sir",
      "meneer"
    ],
    [
      "doubt",
      "twijfelen"
    ],
    [
      "unable",
      "niet in staat"
    ],
    [
      "classroom",
      "klas"
    ],
    [
      "wallpaper",
      "behangpapier"
    ],
    [
      "merchandise",
      "goederen"
    ],
    [
      "resistance",
      "verzet"
    ],
    [
      "visitor",
      "gast"
    ],
    [
      "twin",
      "tweepersoonskamer"
    ],
    [
      "forth",
      "voort"
    ],
    [
      "drawing",
      "tekenen"
    ],
    [
      "biological",
      "biologische"
    ],
    [
      "preferences",
      "voorkeuren"
    ],
    [
      "spy",
      "spionne"
    ],
    [
      "instrument",
      "instrument"
    ],
    [
      "split",
      "splitsen"
    ],
    [
      "heaven",
      "hemel"
    ],
    [
      "pregnant",
      "drachtig"
    ],
    [
      "twice",
      "tweemaal"
    ],
    [
      "physician",
      "arts"
    ],
    [
      "cellular",
      "cel"
    ],
    [
      "normally",
      "normaal"
    ],
    [
      "spiritual",
      "spiritueel"
    ],
    [
      "diabetes",
      "suikerziekte"
    ],
    [
      "suit",
      "pak"
    ],
    [
      "shift",
      "ploegendienst"
    ],
    [
      "chip",
      "fiche"
    ],
    [
      "cutting",
      "stek"
    ],
    [
      "flexible",
      "buigzaam"
    ],
    [
      "numerous",
      "numereus"
    ],
    [
      "satisfaction",
      "bevrediging"
    ],
    [
      "char",
      "werkster"
    ],
    [
      "superior",
      "meerdere"
    ],
    [
      "carbon",
      "koolstof"
    ],
    [
      "comfortable",
      "comfortabel"
    ],
    [
      "interaction",
      "interactie"
    ],
    [
      "crisis",
      "crisis"
    ],
    [
      "bright",
      "fel"
    ],
    [
      "treat",
      "behandelen"
    ],
    [
      "header",
      "kopbal"
    ],
    [
      "echo",
      "nadoen"
    ],
    [
      "grid",
      "net"
    ],
    [
      "revolution",
      "omwenteling"
    ],
    [
      "mystery",
      "geheimenis"
    ],
    [
      "landscape",
      "liggend"
    ],
    [
      "journey",
      "trip"
    ],
    [
      "banner",
      "banier"
    ],
    [
      "applicant",
      "eiser"
    ],
    [
      "charter",
      "charter"
    ],
    [
      "fig",
      "vijg"
    ],
    [
      "cooperation",
      "coöperatie"
    ],
    [
      "acquisition",
      "verworvenheid"
    ],
    [
      "teach",
      "aanleren"
    ],
    [
      "rapid",
      "snelle"
    ],
    [
      "hairy",
      "harig"
    ],
    [
      "diversity",
      "diversiteit"
    ],
    [
      "reverse",
      "achteruit"
    ],
    [
      "deposit",
      "borg"
    ],
    [
      "dutch",
      "Nederlandse"
    ],
    [
      "sensitive",
      "prikkelbaar"
    ],
    [
      "router",
      "frees"
    ],
    [
      "concrete",
      "beton"
    ],
    [
      "folder",
      "map"
    ],
    [
      "completion",
      "afwerking"
    ],
    [
      "pulse",
      "peulen"
    ],
    [
      "calculate",
      "uitwerken"
    ],
    [
      "broadcast",
      "omroepen"
    ],
    [
      "anniversary",
      "jaardag"
    ],
    [
      "strip",
      "strook"
    ],
    [
      "pearl",
      "parel"
    ],
    [
      "accident",
      "ongeluk"
    ],
    [
      "accessory",
      "aanhangsel"
    ],
    [
      "plot",
      "beramen"
    ],
    [
      "representation",
      "vertegenwoordiging"
    ],
    [
      "regard",
      "respect"
    ],
    [
      "smooth",
      "glad"
    ],
    [
      "strike",
      "slaan"
    ],
    [
      "consumption",
      "wegteren"
    ],
    [
      "narrow",
      "smal"
    ],
    [
      "afternoon",
      "middag"
    ],
    [
      "ownership",
      "verantwoordelijkheid nemen"
    ],
    [
      "penis",
      "lid"
    ],
    [
      "trailer",
      "aanhanger"
    ],
    [
      "castle",
      "fort"
    ],
    [
      "unsubscribe",
      "afmelden"
    ],
    [
      "heads",
      "kop"
    ],
    [
      "residence",
      "residentie"
    ],
    [
      "strange",
      "vreemd"
    ],
    [
      "sustainable",
      "duurzaam"
    ],
    [
      "mention",
      "noemen"
    ],
    [
      "innovation",
      "nieuwigheid"
    ],
    [
      "parallel",
      "parallel"
    ],
    [
      "operate",
      "opereren"
    ],
    [
      "bold",
      "vet"
    ],
    [
      "stable",
      "paardenstal"
    ],
    [
      "cinema",
      "filmindustrie"
    ],
    [
      "asset",
      "goed"
    ],
    [
      "scan",
      "scannen"
    ],
    [
      "blank",
      "losse flodder"
    ],
    [
      "enhanced",
      "versterkt"
    ],
    [
      "entitled",
      "gerechtigd"
    ],
    [
      "duration",
      "tijdsduur"
    ],
    [
      "fabric",
      "stof"
    ],
    [
      "tight",
      "strak"
    ],
    [
      "recommendation",
      "aanrader"
    ],
    [
      "cute",
      "knap"
    ],
    [
      "buffalo",
      "karbouw"
    ],
    [
      "plane",
      "vlak"
    ],
    [
      "seed",
      "zaad"
    ],
    [
      "desire",
      "verlangen"
    ],
    [
      "peer",
      "edele"
    ],
    [
      "bottle",
      "de fles geven"
    ],
    [
      "considering",
      "aangezien"
    ],
    [
      "massage",
      "vervalsen"
    ],
    [
      "rubber",
      "rubber"
    ],
    [
      "conclusion",
      "conclusie"
    ],
    [
      "thousand",
      "eenduizend"
    ],
    [
      "meat",
      "vlees"
    ],
    [
      "legend",
      "legenda"
    ],
    [
      "grace",
      "genade"
    ],
    [
      "ing",
      "end"
    ],
    [
      "monster",
      "monster"
    ],
    [
      "bang",
      "klap"
    ],
    [
      "villa",
      "buitenhuis"
    ],
    [
      "bone",
      "bot"
    ],
    [
      "collaboration",
      "samenwerken"
    ],
    [
      "inner",
      "binnen-"
    ],
    [
      "formation",
      "vorming"
    ],
    [
      "tutorial",
      "snelcursus"
    ],
    [
      "gate",
      "poort"
    ],
    [
      "roman",
      "Latijn"
    ],
    [
      "tone",
      "noot"
    ],
    [
      "ethics",
      "zedenkunde"
    ],
    [
      "forever",
      "altijd"
    ],
    [
      "dragon",
      "draak"
    ],
    [
      "busy",
      "druk"
    ],
    [
      "captain",
      "kapitein"
    ],
    [
      "fantastic",
      "grandioos"
    ],
    [
      "imagine",
      "voorstellen"
    ],
    [
      "leg",
      "poot"
    ],
    [
      "neck",
      "hals"
    ],
    [
      "wing",
      "wiek"
    ],
    [
      "taste",
      "smaken"
    ],
    [
      "commit",
      "toewijzen"
    ],
    [
      "tiny",
      "minuscuul"
    ],
    [
      "rail",
      "ral"
    ],
    [
      "liberal",
      "open"
    ],
    [
      "jay",
      "gaai"
    ],
    [
      "gap",
      "spleet"
    ],
    [
      "tube",
      "buis"
    ],
    [
      "corresponding",
      "overeenkomstig"
    ],
    [
      "belt",
      "omzomen"
    ],
    [
      "jacket",
      "jas"
    ],
    [
      "er",
      "se"
    ],
    [
      "matthew",
      "Thijs"
    ],
    [
      "lease",
      "pachten"
    ],
    [
      "proud",
      "fier"
    ],
    [
      "excess",
      "teveel"
    ],
    [
      "disaster",
      "ramp"
    ],
    [
      "console",
      "vertroosten"
    ],
    [
      "instructor",
      "leermeester"
    ],
    [
      "giant",
      "reus"
    ],
    [
      "approaches",
      "benadering"
    ],
    [
      "alarm",
      "alarmeren"
    ],
    [
      "anthony",
      "Antoon"
    ],
    [
      "usual",
      "alledaags"
    ],
    [
      "angle",
      "standpunt"
    ],
    [
      "rob",
      "beroven"
    ],
    [
      "ongoing",
      "lopend"
    ],
    [
      "worst",
      "slechtst"
    ],
    [
      "blackjack",
      "piratenvlag"
    ],
    [
      "era",
      "periode"
    ],
    [
      "convert",
      "bekeren"
    ],
    [
      "analyst",
      "analiste"
    ],
    [
      "commissioner",
      "gevolmachtigde"
    ],
    [
      "dangerous",
      "gevaarlijk"
    ],
    [
      "garage",
      "autogarage"
    ],
    [
      "unfortunately",
      "jammer genoeg"
    ],
    [
      "attachment",
      "bijlage"
    ],
    [
      "ringtone",
      "ringtone"
    ],
    [
      "pleasure",
      "genot"
    ],
    [
      "honor",
      "huldigen"
    ],
    [
      "asp",
      "roofblei"
    ],
    [
      "eagle",
      "arend"
    ],
    [
      "pants",
      "onderbroek"
    ],
    [
      "nurse",
      "min"
    ],
    [
      "prayer",
      "gebed"
    ],
    [
      "appointment",
      "afspraak"
    ],
    [
      "quiet",
      "rustig"
    ],
    [
      "producer",
      "vervaardiger"
    ],
    [
      "dial",
      "kiesschijf"
    ],
    [
      "comic",
      "komiek"
    ],
    [
      "jet",
      "git"
    ],
    [
      "productivity",
      "vruchtbaar"
    ],
    [
      "crown",
      "bol"
    ],
    [
      "underground",
      "underground"
    ],
    [
      "crack",
      "krak"
    ],
    [
      "principle",
      "beginsel"
    ],
    [
      "gang",
      "gang"
    ],
    [
      "appearance",
      "aanblik"
    ],
    [
      "smoke",
      "rook"
    ],
    [
      "craft",
      "vak"
    ],
    [
      "cake",
      "blok"
    ],
    [
      "blind",
      "blenden"
    ],
    [
      "mad",
      "zot"
    ],
    [
      "gross",
      "bruto"
    ],
    [
      "valentine",
      "Valentinus"
    ],
    [
      "familiar",
      "vertrouwd"
    ],
    [
      "till",
      "totdat"
    ],
    [
      "pen",
      "kraal"
    ],
    [
      "christopher",
      "Kristof"
    ],
    [
      "shoe",
      "schoen"
    ],
    [
      "victory",
      "zege"
    ],
    [
      "sand",
      "lef"
    ],
    [
      "ethnic",
      "vreemd"
    ],
    [
      "actor",
      "doener"
    ],
    [
      "seal",
      "zegel"
    ],
    [
      "fifth",
      "kwint"
    ],
    [
      "citizen",
      "burger"
    ],
    [
      "prize",
      "prijs"
    ],
    [
      "absolute",
      "absoluut"
    ],
    [
      "anytime",
      "op elk moment"
    ],
    [
      "pipe",
      "pijp"
    ],
    [
      "guardian",
      "voogd"
    ],
    [
      "lecture",
      "college"
    ],
    [
      "layout",
      "plan"
    ],
    [
      "ill",
      "krank"
    ],
    [
      "lay",
      "leggen"
    ],
    [
      "interpretation",
      "tolken"
    ],
    [
      "lol",
      "lol"
    ],
    [
      "dirty",
      "vuil"
    ],
    [
      "deck",
      "terras"
    ],
    [
      "bankruptcy",
      "faling"
    ],
    [
      "worker",
      "arbeidster"
    ],
    [
      "alive",
      "levendig"
    ],
    [
      "temple",
      "poot"
    ],
    [
      "prove",
      "blijken"
    ],
    [
      "genetic",
      "erfelijk"
    ],
    [
      "promise",
      "belofte"
    ],
    [
      "thin",
      "dun"
    ],
    [
      "prefer",
      "verkiezen"
    ],
    [
      "ridge",
      "zeerug"
    ],
    [
      "sick",
      "zieken"
    ],
    [
      "collect",
      "opmaken"
    ],
    [
      "bet",
      "gokken"
    ],
    [
      "composition",
      "compositie"
    ],
    [
      "vector",
      "vector"
    ],
    [
      "definitely",
      "zeker weten"
    ],
    [
      "buffer",
      "buffermengsel"
    ],
    [
      "purple",
      "paars"
    ],
    [
      "existence",
      "voorkomen"
    ],
    [
      "commentary",
      "voice-over"
    ],
    [
      "immigration",
      "inwijking"
    ],
    [
      "pipeline",
      "pijplijn"
    ],
    [
      "necessarily",
      "noodzakelijk"
    ],
    [
      "syntax",
      "syntaxis"
    ],
    [
      "attribute",
      "kenmerk"
    ],
    [
      "prison",
      "kerker"
    ],
    [
      "skill",
      "vaardigheid"
    ],
    [
      "apparently",
      "blijkbaar"
    ],
    [
      "surrounding",
      "naburig"
    ],
    [
      "popularity",
      "geliefdheid"
    ],
    [
      "inquiry",
      "onderzoek"
    ],
    [
      "exhibit",
      "tonen"
    ],
    [
      "throw",
      "gooi"
    ],
    [
      "trend",
      "trend"
    ],
    [
      "visible",
      "zichtbare"
    ],
    [
      "desert",
      "verlaten"
    ],
    [
      "obviously",
      "overduidelijk"
    ],
    [
      "mercury",
      "kwik"
    ],
    [
      "navigate",
      "varen"
    ],
    [
      "worse",
      "erger"
    ],
    [
      "summit",
      "piek"
    ],
    [
      "escape",
      "ontgaan"
    ],
    [
      "somewhat",
      "ietwat"
    ],
    [
      "receiver",
      "hoorn"
    ],
    [
      "arcade",
      "speelhal"
    ],
    [
      "obvious",
      "voordehandliggend"
    ],
    [
      "graph",
      "graaf"
    ],
    [
      "platinum",
      "platinum"
    ],
    [
      "judgment",
      "vonnis"
    ],
    [
      "filing",
      "vijlsel"
    ],
    [
      "foster",
      "kweken"
    ],
    [
      "passing",
      "pass"
    ],
    [
      "tissue",
      "zakdoek"
    ],
    [
      "cartridge",
      "patroon"
    ],
    [
      "explanation",
      "uitleg"
    ],
    [
      "commons",
      "gemene"
    ],
    [
      "fraud",
      "bedrog"
    ],
    [
      "electricity",
      "stroom"
    ],
    [
      "arrival",
      "komst"
    ],
    [
      "pottery",
      "keramiek"
    ],
    [
      "emphasis",
      "klemtoon"
    ],
    [
      "roger",
      "Rutger"
    ],
    [
      "aspect",
      "aanblik"
    ],
    [
      "workplace",
      "arbeidsplaats"
    ],
    [
      "awesome",
      "beangstigend"
    ],
    [
      "mexican",
      "Mexicaan"
    ],
    [
      "crash",
      "crash"
    ],
    [
      "lift",
      "heffen"
    ],
    [
      "inter",
      "ter aarde bestellen"
    ],
    [
      "infection",
      "infectie"
    ],
    [
      "grove",
      "loo"
    ],
    [
      "venture",
      "wagen"
    ],
    [
      "korean",
      "Koreaan"
    ],
    [
      "healing",
      "heling"
    ],
    [
      "princess",
      "koningin"
    ],
    [
      "packet",
      "pak"
    ],
    [
      "extend",
      "uitbreiden"
    ],
    [
      "subsequent",
      "daaropvolgend"
    ],
    [
      "motorcycle",
      "motor"
    ],
    [
      "yard",
      "ra"
    ],
    [
      "disclosure",
      "vrijgave"
    ],
    [
      "establishment",
      "bestel"
    ],
    [
      "tourist",
      "toeriste"
    ],
    [
      "murder",
      "vermoorden"
    ],
    [
      "adequate",
      "voldoende"
    ],
    [
      "yield",
      "afstaan"
    ],
    [
      "pour",
      "gutsen"
    ],
    [
      "digest",
      "verteren"
    ],
    [
      "lodging",
      "kost"
    ],
    [
      "tion",
      "tie"
    ],
    [
      "hence",
      "dus"
    ],
    [
      "entirely",
      "geheel"
    ],
    [
      "rescue",
      "bevrijden"
    ],
    [
      "combat",
      "kamp"
    ],
    [
      "occupation",
      "bezetting"
    ],
    [
      "butt",
      "kont"
    ],
    [
      "ear",
      "oor"
    ],
    [
      "baker",
      "bakster"
    ],
    [
      "pollution",
      "pollutie"
    ],
    [
      "shock",
      "schok"
    ],
    [
      "abroad",
      "uit-"
    ],
    [
      "ebony",
      "ebben"
    ],
    [
      "tie",
      "boog"
    ],
    [
      "ward",
      "bewaking"
    ],
    [
      "ian",
      "iant"
    ],
    [
      "roof",
      "dak"
    ],
    [
      "atmosphere",
      "sfeer"
    ],
    [
      "kiss",
      "zoen"
    ],
    [
      "beast",
      "dier"
    ],
    [
      "experiment",
      "proef"
    ],
    [
      "dodge",
      "ontduiken"
    ],
    [
      "federation",
      "federatie"
    ],
    [
      "assignment",
      "taak"
    ],
    [
      "chemicals",
      "chemische industrie"
    ],
    [
      "absence",
      "afwezigheid"
    ],
    [
      "whereas",
      "vermits"
    ],
    [
      "surprise",
      "verrassen"
    ],
    [
      "lamp",
      "olielamp"
    ],
    [
      "partial",
      "partijdig"
    ],
    [
      "everybody",
      "allen"
    ],
    [
      "ranking",
      "rang"
    ],
    [
      "ceo",
      "bestuursvoorzitter"
    ],
    [
      "acceptable",
      "acceptabel"
    ],
    [
      "satisfied",
      "voldaan"
    ],
    [
      "glad",
      "gevallig"
    ],
    [
      "globe",
      "wereldbol"
    ],
    [
      "copper",
      "koperrood"
    ],
    [
      "rack",
      "rek"
    ],
    [
      "warehouse",
      "opslagplaats"
    ],
    [
      "receipt",
      "reçu"
    ],
    [
      "ordinary",
      "alledaags"
    ],
    [
      "nobody",
      "nul"
    ],
    [
      "ghost",
      "geest"
    ],
    [
      "violation",
      "overtreding"
    ],
    [
      "southwest",
      "zuidwest"
    ],
    [
      "boss",
      "baas"
    ],
    [
      "pride",
      "trots"
    ],
    [
      "independence",
      "zelfstandigheid"
    ],
    [
      "reporter",
      "verslaggever"
    ],
    [
      "metabolism",
      "metabolisme"
    ],
    [
      "champion",
      "kampioene"
    ],
    [
      "solo",
      "solo"
    ],
    [
      "sentence",
      "zin"
    ],
    [
      "throat",
      "hals"
    ],
    [
      "uniform",
      "uniform"
    ],
    [
      "excellence",
      "uitmuntendheid"
    ],
    [
      "wealth",
      "weelde"
    ],
    [
      "tall",
      "hoog"
    ],
    [
      "somewhere",
      "ergens heen"
    ],
    [
      "recognize",
      "erkennen"
    ],
    [
      "brass",
      "lef"
    ],
    [
      "survival",
      "overleving"
    ],
    [
      "quest",
      "zoektocht"
    ],
    [
      "publish",
      "uitgeven"
    ],
    [
      "toe",
      "neus"
    ],
    [
      "pioneer",
      "pioneer"
    ],
    [
      "booty",
      "plunder"
    ],
    [
      "acrobat",
      "acrobate"
    ],
    [
      "vital",
      "leven"
    ],
    [
      "charity",
      "liefdadigheid"
    ],
    [
      "intelligent",
      "doordacht"
    ],
    [
      "obligation",
      "plicht"
    ],
    [
      "wake",
      "ontwaken"
    ],
    [
      "stupid",
      "stom"
    ],
    [
      "harbor",
      "ree"
    ],
    [
      "realize",
      "inzien"
    ],
    [
      "regardless",
      "niettemin"
    ],
    [
      "enemy",
      "vijandelijk"
    ],
    [
      "puzzle",
      "raadsel"
    ],
    [
      "sms",
      "sms-bericht"
    ],
    [
      "shit",
      "kak"
    ],
    [
      "republican",
      "republikeinse"
    ],
    [
      "lucky",
      "boffend"
    ],
    [
      "latter",
      "laatste"
    ],
    [
      "thick",
      "dicht"
    ],
    [
      "repeat",
      "herdoen"
    ],
    [
      "drum",
      "vat"
    ],
    [
      "iraqi",
      "Iraki"
    ],
    [
      "builder",
      "bouwster"
    ],
    [
      "flood",
      "vloed"
    ],
    [
      "orgy",
      "drinkgelag"
    ],
    [
      "announcement",
      "aankondiging"
    ],
    [
      "outcome",
      "uitkomst"
    ],
    [
      "appreciate",
      "waarderen"
    ],
    [
      "polish",
      "oppoetsen"
    ],
    [
      "lovely",
      "schat"
    ],
    [
      "clause",
      "bijzin"
    ],
    [
      "smile",
      "lach"
    ],
    [
      "broker",
      "beursmakelaar"
    ],
    [
      "pine",
      "treuren"
    ],
    [
      "divorce",
      "scheiding"
    ],
    [
      "tokyo",
      "Tokyo"
    ],
    [
      "partly",
      "deels"
    ],
    [
      "tradition",
      "overlevering"
    ],
    [
      "hunt",
      "jagen"
    ],
    [
      "deputy",
      "vertegenwoordigster"
    ],
    [
      "thai",
      "Thais"
    ],
    [
      "loaded",
      "schatrijk"
    ],
    [
      "complaint",
      "beklag"
    ],
    [
      "balls",
      "kloten"
    ],
    [
      "boost",
      "zetje"
    ],
    [
      "spanking",
      "pak voor de broek"
    ],
    [
      "scholarship",
      "kennis"
    ],
    [
      "mill",
      "fabriek"
    ],
    [
      "moral",
      "moreel"
    ],
    [
      "den",
      "hol"
    ],
    [
      "finger",
      "porren"
    ],
    [
      "pound",
      "pond"
    ],
    [
      "camcorder",
      "videocamera"
    ],
    [
      "burn",
      "branden"
    ],
    [
      "bread",
      "poen"
    ],
    [
      "tobacco",
      "tabak"
    ],
    [
      "wooden",
      "houten"
    ],
    [
      "tough",
      "taai"
    ],
    [
      "incident",
      "episode"
    ],
    [
      "dynamics",
      "stromingsleer"
    ],
    [
      "lie",
      "leugen"
    ],
    [
      "conversation",
      "conversatie"
    ],
    [
      "decrease",
      "verminderen"
    ],
    [
      "chest",
      "romp"
    ],
    [
      "pension",
      "pensioen"
    ],
    [
      "emerging",
      "blijken"
    ],
    [
      "worship",
      "vereren"
    ],
    [
      "shorts",
      "short"
    ],
    [
      "reproduction",
      "reproductie"
    ],
    [
      "minority",
      "minoriteit"
    ],
    [
      "sole",
      "tong"
    ],
    [
      "franchise",
      "concessie"
    ],
    [
      "passion",
      "passie"
    ],
    [
      "sight",
      "vizier"
    ],
    [
      "weak",
      "slap"
    ],
    [
      "reception",
      "receptie"
    ],
    [
      "correctly",
      "goed"
    ],
    [
      "insider",
      "insider"
    ],
    [
      "hearts",
      "harten"
    ],
    [
      "geography",
      "aardrijkskunde"
    ],
    [
      "worry",
      "zorgen maken"
    ],
    [
      "discrimination",
      "onderscheid"
    ],
    [
      "eve",
      "vigilie"
    ],
    [
      "legacy",
      "erfenis"
    ],
    [
      "danger",
      "gevaar"
    ],
    [
      "phrase",
      "frase"
    ],
    [
      "genuine",
      "origineel"
    ],
    [
      "paradise",
      "hemel"
    ],
    [
      "hybrid",
      "hybride"
    ],
    [
      "emotional",
      "emotioneel"
    ],
    [
      "leaf",
      "blad"
    ],
    [
      "glory",
      "glorie"
    ],
    [
      "combine",
      "verenigen"
    ],
    [
      "overnight",
      "overnachts"
    ],
    [
      "geographic",
      "geografisch"
    ],
    [
      "exceed",
      "overstijgen"
    ],
    [
      "rod",
      "roede"
    ],
    [
      "fault",
      "breuk"
    ],
    [
      "introduce",
      "introduceren"
    ],
    [
      "silk",
      "zijdedoek"
    ],
    [
      "examine",
      "examineren"
    ],
    [
      "suspension",
      "schorsing"
    ],
    [
      "margaret",
      "Margreet"
    ],
    [
      "sad",
      "rouwig"
    ],
    [
      "correction",
      "correctie"
    ],
    [
      "slowly",
      "traag"
    ],
    [
      "authentication",
      "authentificatie"
    ],
    [
      "communicate",
      "communiceren"
    ],
    [
      "supplement",
      "supplement"
    ],
    [
      "samuel",
      "Samuël"
    ],
    [
      "fluid",
      "vloeistof"
    ],
    [
      "grounds",
      "terrein"
    ],
    [
      "kick",
      "trap"
    ],
    [
      "regards",
      "groetjes"
    ],
    [
      "meal",
      "maal"
    ],
    [
      "hurt",
      "pijn doen"
    ],
    [
      "machinery",
      "machinerie"
    ],
    [
      "unlike",
      "ongewoon voor"
    ],
    [
      "pot",
      "potten"
    ],
    [
      "dimension",
      "dimensie"
    ],
    [
      "wright",
      "maker"
    ],
    [
      "warren",
      "konijnenheuvel"
    ],
    [
      "slip",
      "falen"
    ],
    [
      "quarterly",
      "gevierendeeld"
    ],
    [
      "devil",
      "duivel"
    ],
    [
      "grass",
      "gras"
    ],
    [
      "florist",
      "bloemenverkoper"
    ],
    [
      "cherry",
      "kers"
    ],
    [
      "achievement",
      "prestatie"
    ],
    [
      "kenya",
      "Kenya"
    ],
    [
      "webcam",
      "cam"
    ],
    [
      "passenger",
      "reiziger"
    ],
    [
      "convenient",
      "handig"
    ],
    [
      "francis",
      "Franciscus"
    ],
    [
      "socket",
      "kas"
    ],
    [
      "silent",
      "zwijgend"
    ],
    [
      "orientation",
      "oriëntatie"
    ],
    [
      "theft",
      "dieverij"
    ],
    [
      "childhood",
      "kinderjaren"
    ],
    [
      "swing",
      "swingen"
    ],
    [
      "talent",
      "gave"
    ],
    [
      "shoot",
      "spruit"
    ],
    [
      "boundary",
      "rand"
    ],
    [
      "mint",
      "mint"
    ],
    [
      "offset",
      "begin"
    ],
    [
      "philip",
      "Filip"
    ],
    [
      "elite",
      "top-"
    ],
    [
      "spin",
      "draaien"
    ],
    [
      "swedish",
      "Zweeds"
    ],
    [
      "deadline",
      "deadline"
    ],
    [
      "witness",
      "getuige"
    ],
    [
      "powder",
      "malen"
    ],
    [
      "assess",
      "belasten"
    ],
    [
      "wash",
      "spoelen"
    ],
    [
      "entrance",
      "ingang"
    ],
    [
      "gnome",
      "dwerg"
    ],
    [
      "declaration",
      "verklaring"
    ],
    [
      "noble",
      "edele"
    ],
    [
      "shore",
      "kust"
    ],
    [
      "knight",
      "paard"
    ],
    [
      "loose",
      "los"
    ],
    [
      "recipient",
      "ontvangster"
    ],
    [
      "illness",
      "aandoening"
    ],
    [
      "triple",
      "drievoudig"
    ],
    [
      "jam",
      "confituur"
    ],
    [
      "unusual",
      "ongebruikelijk"
    ],
    [
      "migration",
      "trek"
    ],
    [
      "disorder",
      "stoornis"
    ],
    [
      "toolbar",
      "werkbalk"
    ],
    [
      "axis",
      "draaier"
    ],
    [
      "habitat",
      "leefgebied"
    ],
    [
      "firewall",
      "vuurmuur"
    ],
    [
      "herein",
      "hierin"
    ],
    [
      "horny",
      "geil"
    ],
    [
      "adjustment",
      "aanpassing"
    ],
    [
      "hero",
      "heldin"
    ],
    [
      "bachelor",
      "vrijgezel"
    ],
    [
      "attitude",
      "houding"
    ],
    [
      "engaged",
      "bezet"
    ],
    [
      "carpet",
      "tapijt"
    ],
    [
      "binary",
      "binaire"
    ],
    [
      "genetics",
      "erfelijkheidsleer"
    ],
    [
      "difficulty",
      "hindernis"
    ],
    [
      "punk",
      "punk"
    ],
    [
      "collective",
      "collectief"
    ],
    [
      "ai",
      "ki"
    ],
    [
      "besides",
      "daarnaast"
    ],
    [
      "wage",
      "leiden"
    ],
    [
      "dawn",
      "zonsopgang"
    ],
    [
      "observation",
      "waarneming"
    ],
    [
      "torture",
      "folteren"
    ],
    [
      "coat",
      "laag"
    ],
    [
      "mrs",
      "mw."
    ],
    [
      "restoration",
      "herstel"
    ],
    [
      "container",
      "vrachtcontainer"
    ],
    [
      "defendant",
      "verdachte"
    ],
    [
      "confirmation",
      "vormsel"
    ],
    [
      "app",
      "applicatie"
    ],
    [
      "embedded",
      "verankerd"
    ],
    [
      "supervisor",
      "toezichthouder"
    ],
    [
      "wizard",
      "eunjer"
    ],
    [
      "liver",
      "lever"
    ],
    [
      "liable",
      "verantwoordelijk"
    ],
    [
      "petition",
      "smeekschrift"
    ],
    [
      "recall",
      "terughaalactie"
    ],
    [
      "antenna",
      "antenne"
    ],
    [
      "departure",
      "vertrek"
    ],
    [
      "diameter",
      "doorsnede"
    ],
    [
      "tit",
      "tet"
    ],
    [
      "singer",
      "zangeres"
    ],
    [
      "herald",
      "inluiden"
    ],
    [
      "literacy",
      "alfabetisering"
    ],
    [
      "intervention",
      "ingreep"
    ],
    [
      "attraction",
      "attractie"
    ],
    [
      "invite",
      "laden"
    ],
    [
      "alice",
      "Alice"
    ],
    [
      "suppose",
      "veronderstellen"
    ],
    [
      "reed",
      "rietstengel"
    ],
    [
      "moderate",
      "matig"
    ],
    [
      "terror",
      "terreur"
    ],
    [
      "opposite",
      "tegengesteld"
    ],
    [
      "understood",
      "verstaan"
    ],
    [
      "clerk",
      "klerk"
    ],
    [
      "jeans",
      "jeansbroek"
    ],
    [
      "verification",
      "verificatie"
    ],
    [
      "odd",
      "oneven"
    ],
    [
      "wrap",
      "omhullen"
    ],
    [
      "mood",
      "bui"
    ],
    [
      "favor",
      "gunst"
    ],
    [
      "quiz",
      "kwis"
    ],
    [
      "attractive",
      "aantrekkelijk"
    ],
    [
      "occasion",
      "gebeurtenis"
    ],
    [
      "victim",
      "gedupeerde"
    ],
    [
      "careful",
      "grondig"
    ],
    [
      "beam",
      "balk"
    ],
    [
      "gardening",
      "tuinbouw"
    ],
    [
      "arrive",
      "bereiken"
    ],
    [
      "orchestra",
      "orkest"
    ],
    [
      "moreover",
      "verder"
    ],
    [
      "minimal",
      "minimalistisch"
    ],
    [
      "lottery",
      "loting"
    ],
    [
      "tops",
      "maximum"
    ],
    [
      "adjustable",
      "regelbaar"
    ],
    [
      "allocation",
      "toewijzing"
    ],
    [
      "essay",
      "essai"
    ],
    [
      "discipline",
      "discipline"
    ],
    [
      "dialogue",
      "dialoog"
    ],
    [
      "trace",
      "spoor"
    ],
    [
      "shut",
      "dichtklappen"
    ],
    [
      "thou",
      "gij"
    ],
    [
      "cycling",
      "fietsen"
    ],
    [
      "inform",
      "informeren"
    ],
    [
      "coal",
      "kool"
    ],
    [
      "cry",
      "roepen"
    ],
    [
      "quantum",
      "kwantum"
    ],
    [
      "zoo",
      "zoo"
    ],
    [
      "pleasant",
      "fijn"
    ],
    [
      "announce",
      "declareren"
    ],
    [
      "rough",
      "ruig"
    ],
    [
      "weird",
      "raar"
    ],
    [
      "lion",
      "coryfee"
    ],
    [
      "blade",
      "blad"
    ],
    [
      "suddenly",
      "plots"
    ],
    [
      "oxygen",
      "zuurstof"
    ],
    [
      "merely",
      "louter"
    ],
    [
      "arrangement",
      "regeling"
    ],
    [
      "compatibility",
      "overeenstemming"
    ],
    [
      "stretch",
      "strekken"
    ],
    [
      "furthermore",
      "daarenboven"
    ],
    [
      "cooperative",
      "coöperatieve vennootschap"
    ],
    [
      "muslim",
      "moslima"
    ],
    [
      "sleeve",
      "hoes"
    ],
    [
      "cleaner",
      "reiniger"
    ],
    [
      "cricket",
      "fair-play"
    ],
    [
      "beef",
      "bief"
    ],
    [
      "stroke",
      "slag"
    ],
    [
      "township",
      "kanton"
    ],
    [
      "cad",
      "controleur"
    ],
    [
      "headquarters",
      "hoofdkantoor"
    ],
    [
      "crowd",
      "massa"
    ],
    [
      "olympic",
      "Olympisch"
    ],
    [
      "transformation",
      "omvorming"
    ],
    [
      "customs",
      "douane"
    ],
    [
      "personality",
      "persoonlijkheid"
    ],
    [
      "rainbow",
      "gamma"
    ],
    [
      "hook",
      "haken"
    ],
    [
      "decline",
      "afname"
    ],
    [
      "israeli",
      "Israëliër"
    ],
    [
      "cord",
      "touw"
    ],
    [
      "cloud",
      "wolk"
    ],
    [
      "facilitate",
      "faciliteren"
    ],
    [
      "valve",
      "ventiel"
    ],
    [
      "proceed",
      "doorgaan"
    ],
    [
      "knife",
      "mes"
    ],
    [
      "shelf",
      "rek"
    ],
    [
      "adopt",
      "aannemen"
    ],
    [
      "crop",
      "bros"
    ],
    [
      "lite",
      "light"
    ],
    [
      "hub",
      "centrum"
    ],
    [
      "founder",
      "vergaan"
    ],
    [
      "decade",
      "tiental"
    ],
    [
      "portuguese",
      "Portugese"
    ],
    [
      "tired",
      "vermoeid"
    ],
    [
      "excerpt",
      "passage"
    ],
    [
      "steam",
      "kwalm"
    ],
    [
      "discharge",
      "ontladen"
    ],
    [
      "acute",
      "acuut"
    ],
    [
      "halloween",
      "allerheiligenavond"
    ]
  ],
  "pt": [
    [
      "the",
      "o"
    ],
    [
      "of",
      "de"
    ],
    [
      "to",
      "a"
    ],
    [
      "a",
      "uma"
    ],
    [
      "in",
      "em"
    ],
    [
      "for",
      "por"
    ],
    [
      "on",
      "na"
    ],
    [
      "that",
      "que"
    ],
    [
      "by",
      "por"
    ],
    [
      "this",
      "este"
    ],
    [
      "with",
      "com"
    ],
    [
      "you",
      "você"
    ],
    [
      "it",
      "a"
    ],
    [
      "be",
      "estar"
    ],
    [
      "at",
      "a"
    ],
    [
      "as",
      "enquanto"
    ],
    [
      "your",
      "seu"
    ],
    [
      "all",
      "toda"
    ],
    [
      "have",
      "ter"
    ],
    [
      "an",
      "o"
    ],
    [
      "we",
      "a gente"
    ],
    [
      "will",
      "vontade"
    ],
    [
      "home",
      "lar"
    ],
    [
      "can",
      "lata"
    ],
    [
      "about",
      "sobre"
    ],
    [
      "if",
      "se"
    ],
    [
      "page",
      "página"
    ],
    [
      "my",
      "meus"
    ],
    [
      "search",
      "procurar"
    ],
    [
      "free",
      "livre"
    ],
    [
      "but",
      "embora"
    ],
    [
      "one",
      "um"
    ],
    [
      "other",
      "outra"
    ],
    [
      "do",
      "fazer"
    ],
    [
      "no",
      "é proibido"
    ],
    [
      "time",
      "tempo"
    ],
    [
      "they",
      "se"
    ],
    [
      "site",
      "sítio"
    ],
    [
      "up",
      "em cima"
    ],
    [
      "may",
      "que"
    ],
    [
      "what",
      "que"
    ],
    [
      "which",
      "que"
    ],
    [
      "their",
      "seus"
    ],
    [
      "news",
      "noticiário"
    ],
    [
      "out",
      "fora"
    ],
    [
      "use",
      "uso"
    ],
    [
      "any",
      "nenhum"
    ],
    [
      "there",
      "aí"
    ],
    [
      "see",
      "ver"
    ],
    [
      "only",
      "mas"
    ],
    [
      "so",
      "assim"
    ],
    [
      "when",
      "quando"
    ],
    [
      "contact",
      "contato"
    ],
    [
      "here",
      "cá"
    ],
    [
      "business",
      "negócio"
    ],
    [
      "who",
      "que"
    ],
    [
      "web",
      "rede"
    ],
    [
      "now",
      "já"
    ],
    [
      "help",
      "ajudar"
    ],
    [
      "get",
      "ficar"
    ],
    [
      "view",
      "visão"
    ],
    [
      "online",
      "online"
    ],
    [
      "how",
      "como"
    ],
    [
      "me",
      "mim"
    ],
    [
      "s",
      "is"
    ],
    [
      "some",
      "um"
    ],
    [
      "these",
      "esses"
    ],
    [
      "click",
      "encaixar"
    ],
    [
      "its",
      "seu"
    ],
    [
      "like",
      "tipo"
    ],
    [
      "service",
      "jogo"
    ],
    [
      "than",
      "do que"
    ],
    [
      "find",
      "achar"
    ],
    [
      "price",
      "orçar"
    ],
    [
      "date",
      "data"
    ],
    [
      "back",
      "dorso"
    ],
    [
      "top",
      "top"
    ],
    [
      "people",
      "povoar-se"
    ],
    [
      "list",
      "lista"
    ],
    [
      "name",
      "reputação"
    ],
    [
      "just",
      "só"
    ],
    [
      "over",
      "por"
    ],
    [
      "state",
      "indicar"
    ],
    [
      "year",
      "ano"
    ],
    [
      "into",
      "em"
    ],
    [
      "email",
      "e-mail"
    ],
    [
      "two",
      "duas"
    ],
    [
      "health",
      "vida"
    ],
    [
      "next",
      "próximo"
    ],
    [
      "used",
      "usado"
    ],
    [
      "go",
      "ir"
    ],
    [
      "work",
      "obra"
    ],
    [
      "last",
      "último"
    ],
    [
      "most",
      "mais"
    ],
    [
      "music",
      "partitura"
    ],
    [
      "buy",
      "comprar"
    ],
    [
      "make",
      "deixar"
    ],
    [
      "them",
      "as"
    ],
    [
      "should",
      "se"
    ],
    [
      "product",
      "produtos"
    ],
    [
      "post",
      "posto"
    ],
    [
      "her",
      "dela"
    ],
    [
      "city",
      "urbe"
    ],
    [
      "add",
      "adicionar"
    ],
    [
      "policy",
      "apólice"
    ],
    [
      "number",
      "número"
    ],
    [
      "such",
      "assim"
    ],
    [
      "please",
      "por favor"
    ],
    [
      "available",
      "livre"
    ],
    [
      "copyright",
      "direito autoral"
    ],
    [
      "support",
      "apoio"
    ],
    [
      "message",
      "moral"
    ],
    [
      "after",
      "após"
    ],
    [
      "software",
      "programa"
    ],
    [
      "then",
      "então"
    ],
    [
      "good",
      "bom"
    ],
    [
      "video",
      "fita"
    ],
    [
      "well",
      "bem"
    ],
    [
      "where",
      "onde"
    ],
    [
      "public",
      "estatal"
    ],
    [
      "high",
      "alto"
    ],
    [
      "school",
      "escola"
    ],
    [
      "through",
      "por"
    ],
    [
      "review",
      "crítica"
    ],
    [
      "order",
      "pedir"
    ],
    [
      "very",
      "mero"
    ],
    [
      "privacy",
      "intimidade"
    ],
    [
      "book",
      "livro"
    ],
    [
      "company",
      "visita"
    ],
    [
      "read",
      "ler"
    ],
    [
      "group",
      "tribo"
    ],
    [
      "sex",
      "sexo"
    ],
    [
      "need",
      "precisar"
    ],
    [
      "many",
      "muitas"
    ],
    [
      "user",
      "drogado"
    ],
    [
      "set",
      "conjunto"
    ],
    [
      "under",
      "sob"
    ],
    [
      "general",
      "geral"
    ],
    [
      "research",
      "pesquisa"
    ],
    [
      "january",
      "Janeiro"
    ],
    [
      "mail",
      "correio"
    ],
    [
      "full",
      "cheio"
    ],
    [
      "map",
      "carta"
    ],
    [
      "program",
      "planear"
    ],
    [
      "life",
      "vida"
    ],
    [
      "know",
      "conhecer"
    ],
    [
      "way",
      "jeito"
    ],
    [
      "days",
      "vida"
    ],
    [
      "management",
      "gerência"
    ],
    [
      "part",
      "parte"
    ],
    [
      "great",
      "ótimo"
    ],
    [
      "real",
      "vero"
    ],
    [
      "center",
      "pivô"
    ],
    [
      "must",
      "mosto"
    ],
    [
      "store",
      "estoque"
    ],
    [
      "report",
      "relatar"
    ],
    [
      "off",
      "desligar"
    ],
    [
      "member",
      "sócio"
    ],
    [
      "line",
      "linha"
    ],
    [
      "before",
      "ante"
    ],
    [
      "send",
      "emitir"
    ],
    [
      "right",
      "certo"
    ],
    [
      "type",
      "tipo"
    ],
    [
      "because",
      "que"
    ],
    [
      "local",
      "morador local"
    ],
    [
      "office",
      "cargo"
    ],
    [
      "education",
      "ensino"
    ],
    [
      "car",
      "viatura"
    ],
    [
      "design",
      "desenho"
    ],
    [
      "take",
      "tomar"
    ],
    [
      "address",
      "endereço"
    ],
    [
      "area",
      "área"
    ],
    [
      "want",
      "falta"
    ],
    [
      "phone",
      "fono"
    ],
    [
      "dvd",
      "devedê"
    ],
    [
      "shipping",
      "frota"
    ],
    [
      "subject",
      "matéria"
    ],
    [
      "family",
      "familiar"
    ],
    [
      "long",
      "quanto tempo"
    ],
    [
      "based",
      "baseado"
    ],
    [
      "code",
      "codificar"
    ],
    [
      "show",
      "mostra"
    ],
    [
      "even",
      "mesmo"
    ],
    [
      "black",
      "negro"
    ],
    [
      "check",
      "checar"
    ],
    [
      "website",
      "site"
    ],
    [
      "index",
      "expoente"
    ],
    [
      "being",
      "criatura"
    ],
    [
      "much",
      "um monte de"
    ],
    [
      "sign",
      "sinal"
    ],
    [
      "file",
      "fila"
    ],
    [
      "link",
      "relacionar"
    ],
    [
      "open",
      "abrir"
    ],
    [
      "today",
      "hoje"
    ],
    [
      "technology",
      "técnica"
    ],
    [
      "south",
      "sulista"
    ],
    [
      "case",
      "caso"
    ],
    [
      "same",
      "mesmo"
    ],
    [
      "version",
      "versão"
    ],
    [
      "section",
      "seção"
    ],
    [
      "house",
      "casa"
    ],
    [
      "related",
      "relatado"
    ],
    [
      "security",
      "garantia"
    ],
    [
      "american",
      "americano"
    ],
    [
      "game",
      "caça"
    ],
    [
      "power",
      "força"
    ],
    [
      "while",
      "embora"
    ],
    [
      "care",
      "ligar"
    ],
    [
      "down",
      "por"
    ],
    [
      "computer",
      "computador"
    ],
    [
      "total",
      "soma"
    ],
    [
      "place",
      "lugar"
    ],
    [
      "end",
      "fim"
    ],
    [
      "download",
      "sacar"
    ],
    [
      "him",
      "o"
    ],
    [
      "access",
      "aceder"
    ],
    [
      "think",
      "achar"
    ],
    [
      "north",
      "norte"
    ],
    [
      "current",
      "corrente"
    ],
    [
      "big",
      "maior"
    ],
    [
      "media",
      "média"
    ],
    [
      "law",
      "lei"
    ],
    [
      "control",
      "controlo"
    ],
    [
      "water",
      "água"
    ],
    [
      "history",
      "histórico"
    ],
    [
      "art",
      "arte"
    ],
    [
      "since",
      "como"
    ],
    [
      "guide",
      "indicação"
    ],
    [
      "shop",
      "bazar"
    ],
    [
      "directory",
      "diretoria"
    ],
    [
      "board",
      "taco"
    ],
    [
      "location",
      "local"
    ],
    [
      "change",
      "mudar"
    ],
    [
      "white",
      "pó"
    ],
    [
      "text",
      "texto"
    ],
    [
      "small",
      "jovem"
    ],
    [
      "rating",
      "patente"
    ],
    [
      "rate",
      "taxa"
    ],
    [
      "government",
      "controle"
    ],
    [
      "return",
      "retornar"
    ],
    [
      "account",
      "conta"
    ],
    [
      "level",
      "nivelado"
    ],
    [
      "form",
      "formulário"
    ],
    [
      "love",
      "amar"
    ],
    [
      "old",
      "velho"
    ],
    [
      "john",
      "João"
    ],
    [
      "call",
      "chamada"
    ],
    [
      "image",
      "imagem"
    ],
    [
      "department",
      "setor"
    ],
    [
      "y",
      "ia"
    ],
    [
      "why",
      "por que"
    ],
    [
      "shall",
      "precisar"
    ],
    [
      "property",
      "propriedade"
    ],
    [
      "class",
      "aula"
    ],
    [
      "still",
      "imóvel"
    ],
    [
      "money",
      "dinheiro"
    ],
    [
      "quality",
      "alta classe"
    ],
    [
      "every",
      "toda"
    ],
    [
      "content",
      "teor"
    ],
    [
      "country",
      "nação"
    ],
    [
      "private",
      "pessoal"
    ],
    [
      "little",
      "pequeno"
    ],
    [
      "visit",
      "consulta"
    ],
    [
      "save",
      "guardar"
    ],
    [
      "low",
      "vil"
    ],
    [
      "reply",
      "repetir"
    ],
    [
      "customer",
      "freguês"
    ],
    [
      "december",
      "Dezembro"
    ],
    [
      "college",
      "faculdade"
    ],
    [
      "value",
      "valor"
    ],
    [
      "man",
      "mane"
    ],
    [
      "card",
      "carta"
    ],
    [
      "food",
      "alimento"
    ],
    [
      "source",
      "fonte"
    ],
    [
      "author",
      "autora"
    ],
    [
      "press",
      "prensar"
    ],
    [
      "learn",
      "estudar"
    ],
    [
      "sale",
      "leilão"
    ],
    [
      "around",
      "em torno de"
    ],
    [
      "course",
      "curso"
    ],
    [
      "job",
      "tarefa"
    ],
    [
      "process",
      "digerir"
    ],
    [
      "room",
      "quarto"
    ],
    [
      "stock",
      "ação"
    ],
    [
      "too",
      "demais"
    ],
    [
      "credit",
      "creditar"
    ],
    [
      "point",
      "ponto"
    ],
    [
      "join",
      "juntar-se a"
    ],
    [
      "west",
      "poente"
    ],
    [
      "look",
      "mirada"
    ],
    [
      "english",
      "inglês"
    ],
    [
      "left",
      "liberal"
    ],
    [
      "team",
      "time"
    ],
    [
      "estate",
      "bens"
    ],
    [
      "box",
      "buxo"
    ],
    [
      "select",
      "seleto"
    ],
    [
      "gay",
      "guei"
    ],
    [
      "thread",
      "fio"
    ],
    [
      "note",
      "denotar"
    ],
    [
      "live",
      "ativo"
    ],
    [
      "gallery",
      "galeria"
    ],
    [
      "table",
      "mesa"
    ],
    [
      "register",
      "inscrever"
    ],
    [
      "however",
      "no entanto"
    ],
    [
      "june",
      "Junho"
    ],
    [
      "october",
      "Outubro"
    ],
    [
      "november",
      "Novembro"
    ],
    [
      "market",
      "mercado"
    ],
    [
      "library",
      "biblioteca"
    ],
    [
      "really",
      "realmente"
    ],
    [
      "start",
      "abrir"
    ],
    [
      "series",
      "série"
    ],
    [
      "model",
      "modelar"
    ],
    [
      "air",
      "ar"
    ],
    [
      "industry",
      "indústria"
    ],
    [
      "plan",
      "plano"
    ],
    [
      "human",
      "humano"
    ],
    [
      "yes",
      "é!"
    ],
    [
      "second",
      "segunda"
    ],
    [
      "hot",
      "quente"
    ],
    [
      "march",
      "marcha"
    ],
    [
      "september",
      "Setembro"
    ],
    [
      "say",
      "dizer"
    ],
    [
      "test",
      "prova"
    ],
    [
      "friend",
      "amiga"
    ],
    [
      "come",
      "vir"
    ],
    [
      "server",
      "servidor"
    ],
    [
      "study",
      "estudar"
    ],
    [
      "application",
      "aplicação"
    ],
    [
      "cart",
      "kart"
    ],
    [
      "staff",
      "estafe"
    ],
    [
      "feedback",
      "feedback"
    ],
    [
      "again",
      "mesmo"
    ],
    [
      "play",
      "jogo"
    ],
    [
      "april",
      "Abril"
    ],
    [
      "never",
      "jamais"
    ],
    [
      "complete",
      "completo"
    ],
    [
      "topic",
      "assunto"
    ],
    [
      "comment",
      "comentar"
    ],
    [
      "working",
      "funcionamento"
    ],
    [
      "against",
      "contra"
    ],
    [
      "standard",
      "estandarte"
    ],
    [
      "tax",
      "taxar"
    ],
    [
      "below",
      "abaixo"
    ],
    [
      "mobile",
      "movediço"
    ],
    [
      "less",
      "menos"
    ],
    [
      "blog",
      "blogue"
    ],
    [
      "party",
      "partido"
    ],
    [
      "equipment",
      "equipagem"
    ],
    [
      "student",
      "aluno"
    ],
    [
      "let",
      "ir"
    ],
    [
      "legal",
      "legal"
    ],
    [
      "above",
      "acima de"
    ],
    [
      "side",
      "lado"
    ],
    [
      "act",
      "ato"
    ],
    [
      "problem",
      "problema"
    ],
    [
      "red",
      "vermelho"
    ],
    [
      "give",
      "dar"
    ],
    [
      "memory",
      "lembrança"
    ],
    [
      "performance",
      "desempenho"
    ],
    [
      "august",
      "nobre"
    ],
    [
      "quote",
      "aspa"
    ],
    [
      "language",
      "língua"
    ],
    [
      "story",
      "conto"
    ],
    [
      "experience",
      "vivenciar"
    ],
    [
      "key",
      "chave"
    ],
    [
      "body",
      "maiô"
    ],
    [
      "young",
      "jovem"
    ],
    [
      "field",
      "campo"
    ],
    [
      "few",
      "poucos"
    ],
    [
      "east",
      "oriente"
    ],
    [
      "paper",
      "papel"
    ],
    [
      "single",
      "solteiro"
    ],
    [
      "age",
      "era"
    ],
    [
      "club",
      "taco"
    ],
    [
      "password",
      "palavra-passe"
    ],
    [
      "latest",
      "último"
    ],
    [
      "something",
      "algo mais"
    ],
    [
      "road",
      "caminho"
    ],
    [
      "gift",
      "dom"
    ],
    [
      "question",
      "questão"
    ],
    [
      "night",
      "noite"
    ],
    [
      "hard",
      "difícil"
    ],
    [
      "pay",
      "pagar"
    ],
    [
      "poker",
      "póquer"
    ],
    [
      "status",
      "estado"
    ],
    [
      "browse",
      "navegar"
    ],
    [
      "issue",
      "emissão"
    ],
    [
      "range",
      "gama"
    ],
    [
      "building",
      "prédio"
    ],
    [
      "seller",
      "vendedora"
    ],
    [
      "court",
      "corte"
    ],
    [
      "february",
      "Fevereiro"
    ],
    [
      "always",
      "sempre"
    ],
    [
      "light",
      "leve"
    ],
    [
      "write",
      "redigir"
    ],
    [
      "offer",
      "proposta"
    ],
    [
      "blue",
      "azul"
    ],
    [
      "event",
      "acidente"
    ],
    [
      "release",
      "liberar"
    ],
    [
      "request",
      "requisição"
    ],
    [
      "picture",
      "foto"
    ],
    [
      "might",
      "força"
    ],
    [
      "yet",
      "porém"
    ],
    [
      "major",
      "maior"
    ],
    [
      "star",
      "estrela"
    ],
    [
      "future",
      "vindouro"
    ],
    [
      "committee",
      "comitê"
    ],
    [
      "hand",
      "mão"
    ],
    [
      "sun",
      "sol"
    ],
    [
      "london",
      "Londres"
    ],
    [
      "meeting",
      "reunião"
    ],
    [
      "become",
      "devir"
    ],
    [
      "interest",
      "interesse"
    ],
    [
      "child",
      "filho"
    ],
    [
      "keep",
      "manter"
    ],
    [
      "enter",
      "inserir"
    ],
    [
      "share",
      "partilhar"
    ],
    [
      "similar",
      "semelhante"
    ],
    [
      "garden",
      "jardim"
    ],
    [
      "reference",
      "referenciar"
    ],
    [
      "baby",
      "bebê"
    ],
    [
      "learning",
      "aprendizado"
    ],
    [
      "run",
      "correr"
    ],
    [
      "delivery",
      "parto"
    ],
    [
      "net",
      "rede"
    ],
    [
      "term",
      "prazo"
    ],
    [
      "film",
      "película"
    ],
    [
      "put",
      "pôr"
    ],
    [
      "journal",
      "registro"
    ],
    [
      "try",
      "autuar"
    ],
    [
      "welcome",
      "boas-vindas"
    ],
    [
      "president",
      "presidenta"
    ],
    [
      "notice",
      "ver"
    ],
    [
      "god",
      "deus"
    ],
    [
      "original",
      "originário"
    ],
    [
      "head",
      "chefe"
    ],
    [
      "radio",
      "rádio"
    ],
    [
      "until",
      "até que"
    ],
    [
      "cell",
      "célula"
    ],
    [
      "color",
      "corar"
    ],
    [
      "away",
      "a"
    ],
    [
      "track",
      "trilha"
    ],
    [
      "once",
      "outrora"
    ],
    [
      "entertainment",
      "divertimento"
    ],
    [
      "agreement",
      "acordo"
    ],
    [
      "society",
      "grupo"
    ],
    [
      "log",
      "cepo"
    ],
    [
      "safety",
      "dispositivo de segurança"
    ],
    [
      "sure",
      "certo"
    ],
    [
      "trade",
      "troca"
    ],
    [
      "edition",
      "edição"
    ],
    [
      "marketing",
      "mercadologia"
    ],
    [
      "tell",
      "dizer"
    ],
    [
      "further",
      "adiante"
    ],
    [
      "association",
      "associação"
    ],
    [
      "able",
      "ível"
    ],
    [
      "david",
      "David"
    ],
    [
      "fun",
      "divertimento"
    ],
    [
      "already",
      "de uma vez"
    ],
    [
      "green",
      "verde de inveja"
    ],
    [
      "close",
      "perto"
    ],
    [
      "drive",
      "conduzir"
    ],
    [
      "several",
      "alguns"
    ],
    [
      "gold",
      "dourado"
    ],
    [
      "living",
      "vivo"
    ],
    [
      "collection",
      "coleção"
    ],
    [
      "short",
      "curto"
    ],
    [
      "lot",
      "Ló"
    ],
    [
      "ask",
      "pedir"
    ],
    [
      "display",
      "ecrã"
    ],
    [
      "director",
      "diretora"
    ],
    [
      "daily",
      "diário"
    ],
    [
      "beach",
      "abicar"
    ],
    [
      "past",
      "passado"
    ],
    [
      "natural",
      "normal"
    ],
    [
      "whether",
      "se"
    ],
    [
      "due",
      "quota"
    ],
    [
      "electronics",
      "eletrónica"
    ],
    [
      "five",
      "cincão"
    ],
    [
      "upon",
      "sobre"
    ],
    [
      "period",
      "período"
    ],
    [
      "planning",
      "planejamento"
    ],
    [
      "database",
      "base de dados"
    ],
    [
      "official",
      "oficial"
    ],
    [
      "weather",
      "clima"
    ],
    [
      "land",
      "terra"
    ],
    [
      "average",
      "médio"
    ],
    [
      "done",
      "pronto"
    ],
    [
      "window",
      "janela"
    ],
    [
      "pro",
      "perito"
    ],
    [
      "island",
      "isolar"
    ],
    [
      "record",
      "registro"
    ],
    [
      "direct",
      "direto"
    ],
    [
      "environment",
      "ambiente"
    ],
    [
      "st",
      "Sta."
    ],
    [
      "district",
      "zona"
    ],
    [
      "calendar",
      "agenda"
    ],
    [
      "style",
      "estilo"
    ],
    [
      "front",
      "frente"
    ],
    [
      "statement",
      "declaração"
    ],
    [
      "update",
      "pôr ao corrente"
    ],
    [
      "ever",
      "de sempre"
    ],
    [
      "early",
      "inicial"
    ],
    [
      "sound",
      "soar"
    ],
    [
      "resource",
      "expediente"
    ],
    [
      "present",
      "atual"
    ],
    [
      "either",
      "ou"
    ],
    [
      "ago",
      "há"
    ],
    [
      "word",
      "palavra"
    ],
    [
      "material",
      "matéria"
    ],
    [
      "bill",
      "declaração"
    ],
    [
      "talk",
      "assunto"
    ],
    [
      "federal",
      "federativo"
    ],
    [
      "hosting",
      "alojamento"
    ],
    [
      "final",
      "último"
    ],
    [
      "adult",
      "adulta"
    ],
    [
      "cheap",
      "vil"
    ],
    [
      "nude",
      "pelado"
    ],
    [
      "true",
      "legítimo"
    ],
    [
      "else",
      "senão"
    ],
    [
      "mark",
      "marcar"
    ],
    [
      "third",
      "terça"
    ],
    [
      "rock",
      "rocha"
    ],
    [
      "bad",
      "ruim"
    ],
    [
      "plus",
      "positivo"
    ],
    [
      "cover",
      "cobrir"
    ],
    [
      "fast",
      "rápido"
    ],
    [
      "fact",
      "facto"
    ],
    [
      "global",
      "global"
    ],
    [
      "meet",
      "reunir"
    ],
    [
      "far",
      "distante"
    ],
    [
      "economic",
      "económico"
    ],
    [
      "en",
      "escer"
    ],
    [
      "player",
      "jogador"
    ],
    [
      "often",
      "amiúde"
    ],
    [
      "subscribe",
      "aderir apoiar concordar"
    ],
    [
      "submit",
      "submeter"
    ],
    [
      "amount",
      "quantia"
    ],
    [
      "watch",
      "vigia"
    ],
    [
      "feel",
      "sentir"
    ],
    [
      "though",
      "apesar"
    ],
    [
      "bank",
      "banco"
    ],
    [
      "risk",
      "pôr em risco"
    ],
    [
      "thanks",
      "valeu"
    ],
    [
      "commercial",
      "comercial"
    ],
    [
      "james",
      "Iago"
    ],
    [
      "weight",
      "peso"
    ],
    [
      "town",
      "cidade"
    ],
    [
      "heart",
      "coração"
    ],
    [
      "advertising",
      "propaganda"
    ],
    [
      "newsletter",
      "boletim informativo"
    ],
    [
      "knowledge",
      "conhecimento"
    ],
    [
      "magazine",
      "paiol"
    ],
    [
      "camera",
      "câmara fotográfica"
    ],
    [
      "girl",
      "menina"
    ],
    [
      "construction",
      "construção"
    ],
    [
      "registered",
      "cadastrado"
    ],
    [
      "clear",
      "limpo"
    ],
    [
      "receive",
      "ganhar"
    ],
    [
      "chapter",
      "divisão"
    ],
    [
      "protection",
      "protecção"
    ],
    [
      "wide",
      "amplo"
    ],
    [
      "beauty",
      "beleza"
    ],
    [
      "manager",
      "chefe"
    ],
    [
      "position",
      "cargo"
    ],
    [
      "sort",
      "coar"
    ],
    [
      "michael",
      "Maicon"
    ],
    [
      "half",
      "metade"
    ],
    [
      "step",
      "passo"
    ],
    [
      "quick",
      "ligeiro"
    ],
    [
      "none",
      "nenhuma"
    ],
    [
      "wireless",
      "tecnologia wireless"
    ],
    [
      "license",
      "alvará"
    ],
    [
      "friday",
      "sexta"
    ],
    [
      "lake",
      "lago"
    ],
    [
      "whole",
      "integral"
    ],
    [
      "annual",
      "anuário"
    ],
    [
      "later",
      "mais tarde"
    ],
    [
      "google",
      "guglar"
    ],
    [
      "church",
      "culto"
    ],
    [
      "purchase",
      "aquisição"
    ],
    [
      "active",
      "ativo"
    ],
    [
      "practice",
      "praxe"
    ],
    [
      "hardware",
      "ferragens"
    ],
    [
      "figure",
      "cifra"
    ],
    [
      "fire",
      "fogo"
    ],
    [
      "holiday",
      "férias"
    ],
    [
      "chat",
      "conversar"
    ],
    [
      "enough",
      "chega!"
    ],
    [
      "along",
      "por"
    ],
    [
      "death",
      "morte"
    ],
    [
      "writing",
      "obra"
    ],
    [
      "speed",
      "meta"
    ],
    [
      "loss",
      "perda"
    ],
    [
      "face",
      "face"
    ],
    [
      "brand",
      "marca"
    ],
    [
      "discount",
      "abatimento"
    ],
    [
      "remember",
      "decorar"
    ],
    [
      "oil",
      "óleo"
    ],
    [
      "bit",
      "bocado"
    ],
    [
      "yellow",
      "amarela"
    ],
    [
      "increase",
      "subir"
    ],
    [
      "advertise",
      "anunciar"
    ],
    [
      "base",
      "ruim"
    ],
    [
      "near",
      "perto"
    ],
    [
      "thought",
      "ideia"
    ],
    [
      "stuff",
      "socar"
    ],
    [
      "french",
      "francês"
    ],
    [
      "storage",
      "armazém"
    ],
    [
      "oh",
      "ah"
    ],
    [
      "entry",
      "acesso"
    ],
    [
      "stay",
      "permanecer"
    ],
    [
      "summary",
      "sumário"
    ],
    [
      "turn",
      "virar"
    ],
    [
      "mean",
      "mau"
    ],
    [
      "growth",
      "acréscimo"
    ],
    [
      "king",
      "dama"
    ],
    [
      "monday",
      "segunda"
    ],
    [
      "european",
      "europeia"
    ],
    [
      "activity",
      "atividade"
    ],
    [
      "copy",
      "cópia"
    ],
    [
      "although",
      "apesar de"
    ],
    [
      "drug",
      "narcótico"
    ],
    [
      "western",
      "faroeste"
    ],
    [
      "income",
      "rendimento"
    ],
    [
      "force",
      "obrigar"
    ],
    [
      "cash",
      "caixa"
    ],
    [
      "employment",
      "emprego"
    ],
    [
      "overall",
      "geral"
    ],
    [
      "bay",
      "vão"
    ],
    [
      "river",
      "rio"
    ],
    [
      "commission",
      "encargo"
    ],
    [
      "package",
      "embalamento"
    ],
    [
      "port",
      "porta"
    ],
    [
      "stop",
      "parar"
    ],
    [
      "administration",
      "aplicação"
    ],
    [
      "bar",
      "bar"
    ],
    [
      "double",
      "duplo"
    ],
    [
      "dog",
      "cão"
    ],
    [
      "build",
      "compilar"
    ],
    [
      "screen",
      "ecrã"
    ],
    [
      "exchange",
      "bolsa"
    ],
    [
      "soon",
      "em breve"
    ],
    [
      "electronic",
      "eletrónico"
    ],
    [
      "continue",
      "seguir"
    ],
    [
      "across",
      "através"
    ],
    [
      "season",
      "temporada"
    ],
    [
      "apply",
      "aplicar-se"
    ],
    [
      "printer",
      "gráfico"
    ],
    [
      "condition",
      "condicionar"
    ],
    [
      "effective",
      "efetivo"
    ],
    [
      "believe",
      "acreditar"
    ],
    [
      "effect",
      "efeito"
    ],
    [
      "mind",
      "tomar conta"
    ],
    [
      "casino",
      "cassino"
    ],
    [
      "lost",
      "perdido"
    ],
    [
      "tour",
      "turnê"
    ],
    [
      "menu",
      "menu"
    ],
    [
      "volume",
      "tomo"
    ],
    [
      "cross",
      "cruz"
    ],
    [
      "anyone",
      "alguma"
    ],
    [
      "silver",
      "prata"
    ],
    [
      "corporation",
      "corporação"
    ],
    [
      "wish",
      "pedido"
    ],
    [
      "inside",
      "adentro"
    ],
    [
      "solution",
      "pagamento"
    ],
    [
      "mature",
      "madurar"
    ],
    [
      "role",
      "papel"
    ],
    [
      "rather",
      "bem"
    ],
    [
      "addition",
      "adição"
    ],
    [
      "supply",
      "suprir"
    ],
    [
      "nothing",
      "nenhuma coisa"
    ],
    [
      "lower",
      "diminuir"
    ],
    [
      "union",
      "sexo"
    ],
    [
      "clothing",
      "traje"
    ],
    [
      "mon",
      "mons"
    ],
    [
      "particular",
      "particular"
    ],
    [
      "fine",
      "fino"
    ],
    [
      "gas",
      "gás"
    ],
    [
      "six",
      "meia"
    ],
    [
      "bush",
      "mato"
    ],
    [
      "military",
      "militar"
    ],
    [
      "rental",
      "locadora"
    ],
    [
      "decision",
      "decisão"
    ],
    [
      "leave",
      "sair"
    ],
    [
      "british",
      "bretões"
    ],
    [
      "huge",
      "gigante"
    ],
    [
      "zip",
      "zipar"
    ],
    [
      "bid",
      "mandar"
    ],
    [
      "kind",
      "raça"
    ],
    [
      "middle",
      "meio"
    ],
    [
      "move",
      "mover"
    ],
    [
      "cable",
      "cabo"
    ],
    [
      "division",
      "parte"
    ],
    [
      "coming",
      "vindouro"
    ],
    [
      "tuesday",
      "terça"
    ],
    [
      "object",
      "objeto"
    ],
    [
      "lesbian",
      "lésbica"
    ],
    [
      "appropriate",
      "designar"
    ],
    [
      "machine",
      "automóvel"
    ],
    [
      "length",
      "extensão"
    ],
    [
      "actually",
      "na realidade"
    ],
    [
      "nice",
      "agradável"
    ],
    [
      "score",
      "resultado"
    ],
    [
      "statistics",
      "estatística"
    ],
    [
      "client",
      "cliente"
    ],
    [
      "ok",
      "tá"
    ],
    [
      "capital",
      "excelente"
    ],
    [
      "follow",
      "captar"
    ],
    [
      "sample",
      "amostrar"
    ],
    [
      "investment",
      "aposta"
    ],
    [
      "band",
      "banda"
    ],
    [
      "flash",
      "piscar"
    ],
    [
      "lead",
      "liderar"
    ],
    [
      "registration",
      "receção"
    ],
    [
      "hi",
      "oi"
    ],
    [
      "foreign",
      "estranho"
    ],
    [
      "outside",
      "fora"
    ],
    [
      "channel",
      "canal"
    ],
    [
      "letter",
      "carta"
    ],
    [
      "mode",
      "modo"
    ],
    [
      "wednesday",
      "quarta"
    ],
    [
      "structure",
      "registro"
    ],
    [
      "fund",
      "fundo"
    ],
    [
      "summer",
      "estio"
    ],
    [
      "allow",
      "deixar"
    ],
    [
      "degree",
      "grau"
    ],
    [
      "contract",
      "contrair"
    ],
    [
      "button",
      "botão"
    ],
    [
      "wed",
      "casar"
    ],
    [
      "male",
      "macho"
    ],
    [
      "matter",
      "questão"
    ],
    [
      "custom",
      "hábito"
    ],
    [
      "asian",
      "asiática"
    ],
    [
      "distribution",
      "parte"
    ],
    [
      "editor",
      "editor"
    ],
    [
      "inn",
      "albergue"
    ],
    [
      "cause",
      "fazer"
    ],
    [
      "song",
      "música"
    ],
    [
      "focus",
      "foco"
    ],
    [
      "late",
      "tardio"
    ],
    [
      "fall",
      "tombar"
    ],
    [
      "idea",
      "ideia"
    ],
    [
      "female",
      "fêmeo"
    ],
    [
      "win",
      "ganho"
    ],
    [
      "thomas",
      "Tomás"
    ],
    [
      "primary",
      "primária"
    ],
    [
      "cancer",
      "cancro"
    ],
    [
      "reason",
      "razão"
    ],
    [
      "tool",
      "equipar"
    ],
    [
      "spring",
      "mola"
    ],
    [
      "foundation",
      "base"
    ],
    [
      "answer",
      "responder"
    ],
    [
      "voice",
      "voz"
    ],
    [
      "friendly",
      "amigo"
    ],
    [
      "schedule",
      "cronograma"
    ],
    [
      "communication",
      "comunicação"
    ],
    [
      "purpose",
      "intenção"
    ],
    [
      "feature",
      "caraterística"
    ],
    [
      "bed",
      "leito"
    ],
    [
      "everyone",
      "todos"
    ],
    [
      "independent",
      "independente"
    ],
    [
      "approach",
      "acesso"
    ],
    [
      "brown",
      "castanho"
    ],
    [
      "physical",
      "braçal"
    ],
    [
      "hill",
      "morro"
    ],
    [
      "medicine",
      "medicina"
    ],
    [
      "deal",
      "porção"
    ],
    [
      "hold",
      "conter"
    ],
    [
      "glass",
      "copo"
    ],
    [
      "happy",
      "feliz"
    ],
    [
      "smith",
      "Ferreira"
    ],
    [
      "safe",
      "seguro"
    ],
    [
      "survey",
      "levantamento"
    ],
    [
      "prior",
      "priora"
    ],
    [
      "telephone",
      "ligar"
    ],
    [
      "sport",
      "zombar"
    ],
    [
      "ready",
      "pronto"
    ],
    [
      "feed",
      "comer"
    ],
    [
      "animal",
      "bicho"
    ],
    [
      "pa",
      "papá"
    ],
    [
      "secure",
      "seguro"
    ],
    [
      "navigation",
      "náutica"
    ],
    [
      "therefore",
      "logo"
    ],
    [
      "ass",
      "besta"
    ],
    [
      "evidence",
      "prova"
    ],
    [
      "christian",
      "cristã"
    ],
    [
      "round",
      "redondo"
    ],
    [
      "understand",
      "compreender"
    ],
    [
      "master",
      "mestre"
    ],
    [
      "valley",
      "entremontes"
    ],
    [
      "recently",
      "ultimamente"
    ],
    [
      "blood",
      "sangue"
    ],
    [
      "cut",
      "cortar"
    ],
    [
      "connection",
      "ligação"
    ],
    [
      "publisher",
      "editora"
    ],
    [
      "hall",
      "salão"
    ],
    [
      "earth",
      "terra"
    ],
    [
      "impact",
      "impacte"
    ],
    [
      "strong",
      "forte"
    ],
    [
      "wedding",
      "casório"
    ],
    [
      "ground",
      "terra"
    ],
    [
      "overview",
      "apanhado"
    ],
    [
      "ship",
      "enviar"
    ],
    [
      "accommodation",
      "acomodação"
    ],
    [
      "hair",
      "cabelo"
    ],
    [
      "kit",
      "kit"
    ],
    [
      "basis",
      "fundamento"
    ],
    [
      "command",
      "ordem"
    ],
    [
      "express",
      "extrair"
    ],
    [
      "award",
      "prémio"
    ],
    [
      "distance",
      "distanciar-se"
    ],
    [
      "assessment",
      "avaliação"
    ],
    [
      "ensure",
      "garantir"
    ],
    [
      "thus",
      "logo"
    ],
    [
      "wall",
      "muro"
    ],
    [
      "especially",
      "sobretudo"
    ],
    [
      "pussy",
      "cona"
    ],
    [
      "budget",
      "financiar"
    ],
    [
      "success",
      "êxito"
    ],
    [
      "ma",
      "mamãe"
    ],
    [
      "operation",
      "cirurgia"
    ],
    [
      "quite",
      "completamente"
    ],
    [
      "selected",
      "seleto"
    ],
    [
      "boy",
      "menino"
    ],
    [
      "beautiful",
      "bela"
    ],
    [
      "horse",
      "cavalo"
    ],
    [
      "vote",
      "voto"
    ],
    [
      "forward",
      "para frente"
    ],
    [
      "owner",
      "dono"
    ],
    [
      "retail",
      "varejo"
    ],
    [
      "est",
      "as"
    ],
    [
      "rule",
      "lei"
    ],
    [
      "mother",
      "mãe"
    ],
    [
      "traffic",
      "trata"
    ],
    [
      "input",
      "input"
    ],
    [
      "bin",
      "latão"
    ],
    [
      "senior",
      "sênior"
    ],
    [
      "sexy",
      "sexy"
    ],
    [
      "teaching",
      "ensino"
    ],
    [
      "trial",
      "prova"
    ],
    [
      "charge",
      "carregar"
    ],
    [
      "instead",
      "antes"
    ],
    [
      "canadian",
      "canadiano"
    ],
    [
      "cool",
      "bacana"
    ],
    [
      "enterprise",
      "empreitada"
    ],
    [
      "entire",
      "todo"
    ],
    [
      "educational",
      "educativo"
    ],
    [
      "leading",
      "espaçamento entre linhas"
    ],
    [
      "chinese",
      "sino"
    ],
    [
      "opinion",
      "conclusão"
    ],
    [
      "football",
      "futebol"
    ],
    [
      "abstract",
      "retirar"
    ],
    [
      "output",
      "saída"
    ],
    [
      "likely",
      "verossímel"
    ],
    [
      "develop",
      "revelar"
    ],
    [
      "resolution",
      "firmeza"
    ],
    [
      "guest",
      "convidado"
    ],
    [
      "pass",
      "passar"
    ],
    [
      "trust",
      "crédito"
    ],
    [
      "van",
      "vagão"
    ],
    [
      "vacation",
      "vacação"
    ],
    [
      "century",
      "centúria"
    ],
    [
      "academic",
      "acadêmico"
    ],
    [
      "skin",
      "pele"
    ],
    [
      "indian",
      "hindu"
    ],
    [
      "ring",
      "anel"
    ],
    [
      "grade",
      "grau"
    ],
    [
      "pacific",
      "tranqüilo"
    ],
    [
      "mountain",
      "monte"
    ],
    [
      "pop",
      "estouro"
    ],
    [
      "filter",
      "crivo"
    ],
    [
      "vehicle",
      "meio"
    ],
    [
      "consider",
      "considerar"
    ],
    [
      "northern",
      "norte"
    ],
    [
      "behind",
      "depois"
    ],
    [
      "panel",
      "quadro"
    ],
    [
      "floor",
      "piso"
    ],
    [
      "german",
      "alemã"
    ],
    [
      "match",
      "luta"
    ],
    [
      "default",
      "default"
    ],
    [
      "require",
      "requerer"
    ],
    [
      "outdoor",
      "a céu aberto"
    ],
    [
      "deep",
      "profundo"
    ],
    [
      "morning",
      "manhã"
    ],
    [
      "otherwise",
      "senão"
    ],
    [
      "rest",
      "descanso"
    ],
    [
      "plant",
      "aparelhagem"
    ],
    [
      "hit",
      "bater"
    ],
    [
      "pool",
      "fundo"
    ],
    [
      "partner",
      "parceiro"
    ],
    [
      "faculty",
      "faculdade"
    ],
    [
      "fish",
      "peixe"
    ],
    [
      "membership",
      "adesão"
    ],
    [
      "eye",
      "olho"
    ],
    [
      "string",
      "corda"
    ],
    [
      "sense",
      "sentido"
    ],
    [
      "pack",
      "baralho"
    ],
    [
      "stage",
      "fase"
    ],
    [
      "goods",
      "produtos"
    ],
    [
      "born",
      "nado"
    ],
    [
      "unless",
      "a não ser que"
    ],
    [
      "detailed",
      "minucioso"
    ],
    [
      "japanese",
      "japonesa"
    ],
    [
      "race",
      "raça"
    ],
    [
      "background",
      "fundo"
    ],
    [
      "target",
      "alvo"
    ],
    [
      "except",
      "fora"
    ],
    [
      "character",
      "caráter"
    ],
    [
      "maintenance",
      "mantimento"
    ],
    [
      "ability",
      "mestria"
    ],
    [
      "maybe",
      "quiçá"
    ],
    [
      "moving",
      "comovente"
    ],
    [
      "pretty",
      "bem"
    ],
    [
      "southern",
      "sulista"
    ],
    [
      "yourself",
      "se"
    ],
    [
      "rape",
      "violar"
    ],
    [
      "battery",
      "bateria"
    ],
    [
      "youth",
      "moço"
    ],
    [
      "debt",
      "débito"
    ],
    [
      "medium",
      "médio"
    ],
    [
      "television",
      "televisor"
    ],
    [
      "core",
      "cerne"
    ],
    [
      "break",
      "quebrar"
    ],
    [
      "throughout",
      "todo"
    ],
    [
      "dance",
      "baile"
    ],
    [
      "wood",
      "tusa"
    ],
    [
      "itself",
      "se"
    ],
    [
      "fee",
      "honorário"
    ],
    [
      "reader",
      "leitor"
    ],
    [
      "device",
      "aparato"
    ],
    [
      "rent",
      "renda"
    ],
    [
      "remote",
      "isolado"
    ],
    [
      "dark",
      "maligno"
    ],
    [
      "regarding",
      "sobre"
    ],
    [
      "enjoy",
      "gozar"
    ],
    [
      "remove",
      "remover"
    ],
    [
      "aid",
      "auxílio"
    ],
    [
      "host",
      "anfitrião"
    ],
    [
      "martin",
      "Martinho"
    ],
    [
      "manual",
      "manual de instruções"
    ],
    [
      "block",
      "bloquear"
    ],
    [
      "repair",
      "reparo"
    ],
    [
      "fair",
      "claro"
    ],
    [
      "civil",
      "civilizado"
    ],
    [
      "understanding",
      "entendimento"
    ],
    [
      "fixed",
      "fixo"
    ],
    [
      "wrong",
      "errado"
    ],
    [
      "beginning",
      "princípio"
    ],
    [
      "finally",
      "por fim"
    ],
    [
      "desktop",
      "desktop"
    ],
    [
      "paris",
      "Páris"
    ],
    [
      "jersey",
      "malha"
    ],
    [
      "fat",
      "gordo"
    ],
    [
      "father",
      "pai"
    ],
    [
      "electric",
      "elétrico"
    ],
    [
      "saw",
      "serrote"
    ],
    [
      "officer",
      "agente"
    ],
    [
      "driver",
      "pilota"
    ],
    [
      "dead",
      "dormente"
    ],
    [
      "respect",
      "respeito"
    ],
    [
      "unknown",
      "desconhecido"
    ],
    [
      "trip",
      "tropeço"
    ],
    [
      "worth",
      "valer a pena"
    ],
    [
      "poor",
      "pobre"
    ],
    [
      "teacher",
      "docente"
    ],
    [
      "relationship",
      "relação"
    ],
    [
      "farm",
      "cultivar"
    ],
    [
      "fucking",
      "puta"
    ],
    [
      "traditional",
      "tradicionalista"
    ],
    [
      "tom",
      "macho"
    ],
    [
      "creative",
      "criador"
    ],
    [
      "coast",
      "beira"
    ],
    [
      "benefit",
      "subsídio"
    ],
    [
      "progress",
      "progredir"
    ],
    [
      "lord",
      "senhor"
    ],
    [
      "grant",
      "concessão"
    ],
    [
      "agree",
      "concordar"
    ],
    [
      "fiction",
      "invenção"
    ],
    [
      "hear",
      "escutar"
    ],
    [
      "sometimes",
      "por vezes"
    ],
    [
      "themselves",
      "se"
    ],
    [
      "fan",
      "abano"
    ],
    [
      "transport",
      "exilar"
    ],
    [
      "wife",
      "mulher"
    ],
    [
      "former",
      "aquele"
    ],
    [
      "complex",
      "complexo"
    ],
    [
      "th",
      "to"
    ],
    [
      "cat",
      "gato"
    ],
    [
      "die",
      "molde"
    ],
    [
      "jack",
      "jaque"
    ],
    [
      "flat",
      "bemol"
    ],
    [
      "flow",
      "fluxo"
    ],
    [
      "respective",
      "respetivo"
    ],
    [
      "parent",
      "pai"
    ],
    [
      "spanish",
      "castelhano"
    ],
    [
      "setting",
      "ambiente"
    ],
    [
      "scale",
      "escala"
    ],
    [
      "stand",
      "aguentar"
    ],
    [
      "economy",
      "economia"
    ],
    [
      "helpful",
      "prestável"
    ],
    [
      "monthly",
      "mensal"
    ],
    [
      "frame",
      "armar"
    ],
    [
      "musical",
      "melódico"
    ],
    [
      "definition",
      "definição"
    ],
    [
      "secretary",
      "secretária"
    ],
    [
      "path",
      "caminho"
    ],
    [
      "employee",
      "empregada"
    ],
    [
      "chief",
      "chefe"
    ],
    [
      "bottom",
      "cu"
    ],
    [
      "detail",
      "detalhe"
    ],
    [
      "pet",
      "acariciar"
    ],
    [
      "begin",
      "iniciar"
    ],
    [
      "clean",
      "puro"
    ],
    [
      "switch",
      "switch"
    ],
    [
      "russian",
      "russa"
    ],
    [
      "african",
      "africana"
    ],
    [
      "guy",
      "bicho"
    ],
    [
      "relevant",
      "relevante"
    ],
    [
      "justice",
      "justeza"
    ],
    [
      "cup",
      "taça"
    ],
    [
      "basket",
      "cesta"
    ],
    [
      "weekly",
      "semanal"
    ],
    [
      "demand",
      "demanda"
    ],
    [
      "suite",
      "grupo"
    ],
    [
      "square",
      "quadrado"
    ],
    [
      "attention",
      "atenção"
    ],
    [
      "advance",
      "avançar"
    ],
    [
      "skip",
      "matar"
    ],
    [
      "diet",
      "dieta"
    ],
    [
      "army",
      "exército"
    ],
    [
      "gear",
      "marcha"
    ],
    [
      "difference",
      "resto"
    ],
    [
      "correct",
      "certo"
    ],
    [
      "nation",
      "estado"
    ],
    [
      "piece",
      "peça"
    ],
    [
      "sheet",
      "capa"
    ],
    [
      "jump",
      "salto"
    ],
    [
      "resort",
      "refúgio"
    ],
    [
      "facility",
      "instalação"
    ],
    [
      "random",
      "aleatório"
    ],
    [
      "minister",
      "ministra"
    ],
    [
      "motion",
      "moção"
    ],
    [
      "fashion",
      "modo"
    ],
    [
      "monitor",
      "tela"
    ],
    [
      "forest",
      "mata"
    ],
    [
      "whose",
      "cuja"
    ],
    [
      "couple",
      "par"
    ],
    [
      "chance",
      "acaso"
    ],
    [
      "vision",
      "joia"
    ],
    [
      "ball",
      "bola"
    ],
    [
      "ending",
      "fim"
    ],
    [
      "listen",
      "ouvir"
    ],
    [
      "naked",
      "nu"
    ],
    [
      "goal",
      "gol"
    ],
    [
      "successful",
      "próspero"
    ],
    [
      "wind",
      "vento"
    ],
    [
      "situation",
      "situação"
    ],
    [
      "appear",
      "surgir"
    ],
    [
      "emergency",
      "urgência"
    ],
    [
      "temperature",
      "febre"
    ],
    [
      "palm",
      "palmar"
    ],
    [
      "actual",
      "real"
    ],
    [
      "stone",
      "pedra"
    ],
    [
      "bob",
      "Bob"
    ],
    [
      "fit",
      "crise"
    ],
    [
      "village",
      "vila"
    ],
    [
      "amateur",
      "amador"
    ],
    [
      "ex",
      "ex"
    ],
    [
      "pain",
      "mala"
    ],
    [
      "coffee",
      "cafezeiro"
    ],
    [
      "cum",
      "gozo"
    ],
    [
      "buyer",
      "compradora"
    ],
    [
      "easily",
      "facilmente"
    ],
    [
      "poster",
      "cartaz"
    ],
    [
      "edge",
      "fio"
    ],
    [
      "root",
      "raiz"
    ],
    [
      "closed",
      "cerrado"
    ],
    [
      "ice",
      "gelo"
    ],
    [
      "pink",
      "cor-de-rosa"
    ],
    [
      "balance",
      "balanço"
    ],
    [
      "graduate",
      "graduar"
    ],
    [
      "shot",
      "foto"
    ],
    [
      "architecture",
      "arquitectura"
    ],
    [
      "label",
      "rótulo"
    ],
    [
      "canon",
      "cânone"
    ],
    [
      "hardcore",
      "punk"
    ],
    [
      "league",
      "liga"
    ],
    [
      "waste",
      "ermo"
    ],
    [
      "minute",
      "ata"
    ],
    [
      "bus",
      "ônibus"
    ],
    [
      "optional",
      "opcional"
    ],
    [
      "cold",
      "frio"
    ],
    [
      "manufacturing",
      "manufatura"
    ],
    [
      "chair",
      "cátedra"
    ],
    [
      "fishing",
      "pesca"
    ],
    [
      "bag",
      "sacola"
    ],
    [
      "professor",
      "professora"
    ],
    [
      "generally",
      "em geral"
    ],
    [
      "foot",
      "pé"
    ],
    [
      "mass",
      "missa"
    ],
    [
      "crime",
      "delinquir"
    ],
    [
      "count",
      "conde"
    ],
    [
      "breast",
      "peito"
    ],
    [
      "quickly",
      "rápido"
    ],
    [
      "claim",
      "alegar"
    ],
    [
      "driving",
      "direção"
    ],
    [
      "surgery",
      "consultório"
    ],
    [
      "patch",
      "correção"
    ],
    [
      "heat",
      "cio"
    ],
    [
      "wild",
      "bravio"
    ],
    [
      "generation",
      "linhagem"
    ],
    [
      "kansas",
      "Kansas"
    ],
    [
      "miss",
      "não perceber"
    ],
    [
      "chemical",
      "química"
    ],
    [
      "doctor",
      "doutora"
    ],
    [
      "task",
      "incumbência"
    ],
    [
      "reduce",
      "reduzir"
    ],
    [
      "himself",
      "se"
    ],
    [
      "enable",
      "ativar"
    ],
    [
      "exercise",
      "agir"
    ],
    [
      "bug",
      "bichinho"
    ],
    [
      "guarantee",
      "fiar"
    ],
    [
      "leader",
      "chefe"
    ],
    [
      "diamond",
      "ouros"
    ],
    [
      "soft",
      "mole"
    ],
    [
      "alone",
      "só"
    ],
    [
      "flight",
      "vôo"
    ],
    [
      "fuel",
      "atiçar"
    ],
    [
      "username",
      "usuário"
    ],
    [
      "walk",
      "andar"
    ],
    [
      "fuck",
      "foder"
    ],
    [
      "italian",
      "italiana"
    ],
    [
      "wait",
      "servir"
    ],
    [
      "pocket",
      "bolso"
    ],
    [
      "saint",
      "São"
    ],
    [
      "rose",
      "rosa"
    ],
    [
      "argument",
      "argumento"
    ],
    [
      "competition",
      "concurso"
    ],
    [
      "joint",
      "junta"
    ],
    [
      "premium",
      "ágio"
    ],
    [
      "fresh",
      "doce"
    ],
    [
      "attorney",
      "advogada"
    ],
    [
      "factor",
      "factor"
    ],
    [
      "growing",
      "crescimento"
    ],
    [
      "stream",
      "fluxo"
    ],
    [
      "pick",
      "pegar"
    ],
    [
      "hearing",
      "ouvido"
    ],
    [
      "eastern",
      "leste"
    ],
    [
      "upper",
      "acima"
    ],
    [
      "prime",
      "primo"
    ],
    [
      "limit",
      "restringir"
    ],
    [
      "louis",
      "Luiz"
    ],
    [
      "creek",
      "riacho"
    ],
    [
      "essential",
      "essencial"
    ],
    [
      "myself",
      "me"
    ],
    [
      "platform",
      "salto plataforma"
    ],
    [
      "load",
      "carga"
    ],
    [
      "affiliate",
      "filiar"
    ],
    [
      "defense",
      "defesa"
    ],
    [
      "heavy",
      "pesado"
    ],
    [
      "cock",
      "boi"
    ],
    [
      "merchant",
      "mercador"
    ],
    [
      "expert",
      "especialista"
    ],
    [
      "drop",
      "cair"
    ],
    [
      "solid",
      "junto"
    ],
    [
      "orange",
      "laranja"
    ],
    [
      "compliance",
      "aderência"
    ],
    [
      "prevent",
      "impedir"
    ],
    [
      "rich",
      "rica"
    ],
    [
      "marine",
      "marítimo"
    ],
    [
      "improvement",
      "melhora"
    ],
    [
      "guitar",
      "violão"
    ],
    [
      "saying",
      "ditado"
    ],
    [
      "spirit",
      "jeito"
    ],
    [
      "porno",
      "porno"
    ],
    [
      "challenge",
      "desafio"
    ],
    [
      "acceptance",
      "aceite"
    ],
    [
      "touch",
      "toque"
    ],
    [
      "hire",
      "alugar"
    ],
    [
      "suggest",
      "propor"
    ],
    [
      "branch",
      "ramo"
    ],
    [
      "serve",
      "servir"
    ],
    [
      "magic",
      "mágica"
    ],
    [
      "mount",
      "subir"
    ],
    [
      "smart",
      "elegante"
    ],
    [
      "latin",
      "latino"
    ],
    [
      "multimedia",
      "multimédia"
    ],
    [
      "manage",
      "manejar"
    ],
    [
      "corner",
      "quina"
    ],
    [
      "rank",
      "fileira"
    ],
    [
      "computing",
      "computação"
    ],
    [
      "oregon",
      "Oregão"
    ],
    [
      "element",
      "elemento"
    ],
    [
      "birth",
      "nascimento"
    ],
    [
      "virus",
      "vírus"
    ],
    [
      "abuse",
      "ofender"
    ],
    [
      "separate",
      "separar-se"
    ],
    [
      "quarter",
      "trimestre"
    ],
    [
      "breakfast",
      "desjejum"
    ],
    [
      "chain",
      "corrente"
    ],
    [
      "developer",
      "revelador"
    ],
    [
      "identify",
      "identificar-se"
    ],
    [
      "missing",
      "sumido"
    ],
    [
      "domestic",
      "doméstico"
    ],
    [
      "reach",
      "chegar"
    ],
    [
      "moment",
      "momento"
    ],
    [
      "sequence",
      "sucessão"
    ],
    [
      "attack",
      "ataque"
    ],
    [
      "sorry",
      "perdão"
    ],
    [
      "opening",
      "vaga"
    ],
    [
      "damage",
      "estrago"
    ],
    [
      "produce",
      "produção"
    ],
    [
      "snow",
      "neve"
    ],
    [
      "truth",
      "verdade"
    ],
    [
      "counter",
      "balcão"
    ],
    [
      "failure",
      "falha"
    ],
    [
      "weekend",
      "final de semana"
    ],
    [
      "camp",
      "acampamento"
    ],
    [
      "bridge",
      "ponte"
    ],
    [
      "native",
      "nativo"
    ],
    [
      "fill",
      "restaurar"
    ],
    [
      "movement",
      "andamento"
    ],
    [
      "printing",
      "impressão"
    ],
    [
      "baseball",
      "beisebol"
    ],
    [
      "draft",
      "fino"
    ],
    [
      "chart",
      "gráfico"
    ],
    [
      "equal",
      "par"
    ],
    [
      "adventure",
      "acaso"
    ],
    [
      "matching",
      "mapeamento"
    ],
    [
      "offering",
      "oferta"
    ],
    [
      "profit",
      "lucro"
    ],
    [
      "assistant",
      "ajudante"
    ],
    [
      "advertisement",
      "edital"
    ],
    [
      "expect",
      "prever"
    ],
    [
      "determined",
      "resoluto"
    ],
    [
      "workshop",
      "seminário"
    ],
    [
      "golden",
      "áureo"
    ],
    [
      "completely",
      "totalmente"
    ],
    [
      "funny",
      "estranho"
    ],
    [
      "brother",
      "frade"
    ],
    [
      "portable",
      "portável"
    ],
    [
      "pattern",
      "molde"
    ],
    [
      "boat",
      "bote"
    ],
    [
      "laser",
      "lêiser"
    ],
    [
      "earlier",
      "precedente"
    ],
    [
      "icon",
      "ícone"
    ],
    [
      "basketball",
      "basquete"
    ],
    [
      "delete",
      "deletar"
    ],
    [
      "evening",
      "noitinha"
    ],
    [
      "assembly",
      "produto"
    ],
    [
      "mouse",
      "rato"
    ],
    [
      "signal",
      "rede"
    ],
    [
      "criminal",
      "culpado"
    ],
    [
      "brain",
      "cérebro"
    ],
    [
      "sexual",
      "sexuado"
    ],
    [
      "powerful",
      "potente"
    ],
    [
      "dream",
      "sonho"
    ],
    [
      "false",
      "falso"
    ],
    [
      "cast",
      "gesso"
    ],
    [
      "flower",
      "florir"
    ],
    [
      "soul",
      "alma"
    ],
    [
      "aids",
      "SIDA"
    ],
    [
      "hawaii",
      "Havai"
    ],
    [
      "carry",
      "levar"
    ],
    [
      "flag",
      "bandeira"
    ],
    [
      "advantage",
      "vantagem"
    ],
    [
      "hello",
      "alô"
    ],
    [
      "maintain",
      "afirmar"
    ],
    [
      "priority",
      "prioridades"
    ],
    [
      "graphic",
      "gráfico"
    ],
    [
      "binding",
      "lombo"
    ],
    [
      "brief",
      "resumir"
    ],
    [
      "anonymous",
      "anónimo"
    ],
    [
      "iron",
      "férreo"
    ],
    [
      "straight",
      "careta"
    ],
    [
      "script",
      "script"
    ],
    [
      "miscellaneous",
      "diverso"
    ],
    [
      "void",
      "nulo"
    ],
    [
      "alert",
      "alarme"
    ],
    [
      "tag",
      "apanhada"
    ],
    [
      "mix",
      "mixar"
    ],
    [
      "framework",
      "regime"
    ],
    [
      "disk",
      "disco"
    ],
    [
      "queen",
      "dama"
    ],
    [
      "clearly",
      "claro"
    ],
    [
      "fix",
      "fixar"
    ],
    [
      "handle",
      "manejar"
    ],
    [
      "sweet",
      "doce"
    ],
    [
      "desk",
      "carteira"
    ],
    [
      "vice",
      "mania"
    ],
    [
      "associate",
      "colega"
    ],
    [
      "truck",
      "camião"
    ],
    [
      "behavior",
      "conduta"
    ],
    [
      "enlarge",
      "aumentar"
    ],
    [
      "ray",
      "raia"
    ],
    [
      "frequently",
      "amiúde"
    ],
    [
      "revenue",
      "renda"
    ],
    [
      "measure",
      "medida"
    ],
    [
      "duty",
      "taxa"
    ],
    [
      "bear",
      "aguentar"
    ],
    [
      "lack",
      "faltar"
    ],
    [
      "depth",
      "fundura"
    ],
    [
      "whatever",
      "foda-se"
    ],
    [
      "laptop",
      "notebook"
    ],
    [
      "train",
      "trem"
    ],
    [
      "dry",
      "enxugar"
    ],
    [
      "explore",
      "examinar"
    ],
    [
      "maryland",
      "Maryland"
    ],
    [
      "handling",
      "manuseio"
    ],
    [
      "origin",
      "origem"
    ],
    [
      "billion",
      "bilião"
    ],
    [
      "faster",
      "jejuadora"
    ],
    [
      "route",
      "caminho"
    ],
    [
      "broken",
      "quebrado"
    ],
    [
      "frank",
      "Frank"
    ],
    [
      "zoom",
      "dar zoom"
    ],
    [
      "blow",
      "assoprar"
    ],
    [
      "battle",
      "luta"
    ],
    [
      "anime",
      "animé"
    ],
    [
      "speak",
      "jargão"
    ],
    [
      "query",
      "perguntar"
    ],
    [
      "clip",
      "clipe"
    ],
    [
      "partnership",
      "sociedade"
    ],
    [
      "editorial",
      "comentário"
    ],
    [
      "equity",
      "equidade"
    ],
    [
      "speech",
      "fala"
    ],
    [
      "wire",
      "fio"
    ],
    [
      "replacement",
      "reposição"
    ],
    [
      "judge",
      "juíza"
    ],
    [
      "spam",
      "spammar"
    ],
    [
      "acid",
      "azedo"
    ],
    [
      "cent",
      "centavo"
    ],
    [
      "fight",
      "luta"
    ],
    [
      "apartment",
      "flate"
    ],
    [
      "height",
      "auge"
    ],
    [
      "zero",
      "zero"
    ],
    [
      "speaker",
      "orador"
    ],
    [
      "netherlands",
      "Holanda"
    ],
    [
      "obtain",
      "ter"
    ],
    [
      "designer",
      "desenhista"
    ],
    [
      "remain",
      "ficar"
    ],
    [
      "marriage",
      "casamento"
    ],
    [
      "roll",
      "rolo"
    ],
    [
      "korea",
      "Coréia"
    ],
    [
      "secret",
      "secreto"
    ],
    [
      "bath",
      "banho"
    ],
    [
      "negative",
      "negativo"
    ],
    [
      "andrew",
      "André"
    ],
    [
      "perform",
      "realizar"
    ],
    [
      "healthy",
      "são"
    ],
    [
      "translation",
      "translação"
    ],
    [
      "font",
      "fonte"
    ],
    [
      "assets",
      "ativo"
    ],
    [
      "injury",
      "lesão"
    ],
    [
      "joseph",
      "José de Arimateia"
    ],
    [
      "ministry",
      "gabinete"
    ],
    [
      "lawyer",
      "advogada"
    ],
    [
      "married",
      "casada"
    ],
    [
      "portal",
      "porta"
    ],
    [
      "birthday",
      "aniversário"
    ],
    [
      "fail",
      "deixar de"
    ],
    [
      "toward",
      "a"
    ],
    [
      "slightly",
      "ligeiramente"
    ],
    [
      "assist",
      "ajudar"
    ],
    [
      "conduct",
      "condução"
    ],
    [
      "lingerie",
      "lingerie"
    ],
    [
      "jazz",
      "besteira"
    ],
    [
      "comics",
      "BD"
    ],
    [
      "wear",
      "usar"
    ],
    [
      "ultimate",
      "última"
    ],
    [
      "wales",
      "Gales"
    ],
    [
      "finish",
      "final"
    ],
    [
      "rare",
      "rarefeito"
    ],
    [
      "extreme",
      "último"
    ],
    [
      "row",
      "eito"
    ],
    [
      "forecast",
      "prognosticar"
    ],
    [
      "administrator",
      "administrador"
    ],
    [
      "accuracy",
      "correção"
    ],
    [
      "dual",
      "dual"
    ],
    [
      "rise",
      "subir"
    ],
    [
      "sleep",
      "sono"
    ],
    [
      "bird",
      "pássaro"
    ],
    [
      "pharmacy",
      "drogaria"
    ],
    [
      "static",
      "estática"
    ],
    [
      "scene",
      "escândalo"
    ],
    [
      "hunter",
      "sabujo"
    ],
    [
      "lady",
      "dama"
    ],
    [
      "famous",
      "afamado"
    ],
    [
      "writer",
      "escritora"
    ],
    [
      "violence",
      "injustiça"
    ],
    [
      "drink",
      "bebida"
    ],
    [
      "academy",
      "seminário"
    ],
    [
      "gender",
      "género"
    ],
    [
      "portfolio",
      "portefólio"
    ],
    [
      "seat",
      "assento"
    ],
    [
      "vendor",
      "vendedora"
    ],
    [
      "regulation",
      "regulação"
    ],
    [
      "reduction",
      "redução"
    ],
    [
      "aim",
      "apontar"
    ],
    [
      "toll",
      "perda"
    ],
    [
      "cape",
      "capa"
    ],
    [
      "meaning",
      "sentido"
    ],
    [
      "tip",
      "dica"
    ],
    [
      "mine",
      "minerar"
    ],
    [
      "ticket",
      "bilhete"
    ],
    [
      "guess",
      "achar"
    ],
    [
      "agreed",
      "de acordo"
    ],
    [
      "whom",
      "quem"
    ],
    [
      "import",
      "importação"
    ],
    [
      "instant",
      "momento"
    ],
    [
      "majority",
      "maioria"
    ],
    [
      "ahead",
      "adiantado"
    ],
    [
      "moon",
      "lua"
    ],
    [
      "scheme",
      "esquema"
    ],
    [
      "preview",
      "prévia"
    ],
    [
      "fly",
      "voo"
    ],
    [
      "manner",
      "modo"
    ],
    [
      "matrix",
      "matriz mitocondrial"
    ],
    [
      "despite",
      "apesar de"
    ],
    [
      "strength",
      "forte"
    ],
    [
      "proper",
      "próprio"
    ],
    [
      "singapore",
      "Cingapura"
    ],
    [
      "fear",
      "recear"
    ],
    [
      "phoenix",
      "Fênix"
    ],
    [
      "convention",
      "tratado"
    ],
    [
      "principal",
      "diretor"
    ],
    [
      "comfort",
      "consolo"
    ],
    [
      "appeal",
      "apelar"
    ],
    [
      "bonus",
      "bônus"
    ],
    [
      "previously",
      "antes"
    ],
    [
      "hey",
      "epa"
    ],
    [
      "bookmark",
      "marcador"
    ],
    [
      "beat",
      "batido"
    ],
    [
      "household",
      "família"
    ],
    [
      "smoking",
      "tabagismo"
    ],
    [
      "bbc",
      "CBR"
    ],
    [
      "alabama",
      "alabama"
    ],
    [
      "tea",
      "chá"
    ],
    [
      "achieve",
      "ganhar"
    ],
    [
      "dress",
      "vestir-se"
    ],
    [
      "subscription",
      "subscrição"
    ],
    [
      "dealer",
      "distribuidor"
    ],
    [
      "contemporary",
      "moderno"
    ],
    [
      "sky",
      "céu"
    ],
    [
      "nearby",
      "por perto"
    ],
    [
      "rom",
      "cigana"
    ],
    [
      "happen",
      "ocorrer"
    ],
    [
      "hide",
      "pele"
    ],
    [
      "signature",
      "firma"
    ],
    [
      "refer",
      "remeter"
    ],
    [
      "miller",
      "moleira"
    ],
    [
      "provision",
      "provisão"
    ],
    [
      "outdoors",
      "ao ar livre"
    ],
    [
      "clothes",
      "vestuário"
    ],
    [
      "certainly",
      "certamente"
    ],
    [
      "indeed",
      "realmente"
    ],
    [
      "newspaper",
      "gazeta"
    ],
    [
      "circuit",
      "circuito"
    ],
    [
      "layer",
      "botadeira"
    ],
    [
      "slow",
      "lerdo"
    ],
    [
      "removal",
      "eliminação"
    ],
    [
      "liability",
      "dívida"
    ],
    [
      "trademark",
      "marca"
    ],
    [
      "hip",
      "anca"
    ],
    [
      "nine",
      "novena"
    ],
    [
      "mostly",
      "sobretudo"
    ],
    [
      "spot",
      "local"
    ],
    [
      "spend",
      "jato"
    ],
    [
      "factory",
      "usina"
    ],
    [
      "grow",
      "crescer"
    ],
    [
      "promotion",
      "promoção"
    ],
    [
      "relative",
      "parenta"
    ],
    [
      "clock",
      "cronometrar"
    ],
    [
      "dot",
      "pingo"
    ],
    [
      "hiv",
      "SIDA"
    ],
    [
      "feeling",
      "idéia"
    ],
    [
      "hidden",
      "obscuro"
    ],
    [
      "reasonable",
      "razoável"
    ],
    [
      "victoria",
      "Vitória"
    ],
    [
      "serial",
      "série"
    ],
    [
      "relief",
      "relevo"
    ],
    [
      "influence",
      "influir"
    ],
    [
      "ratio",
      "razão"
    ],
    [
      "importance",
      "status"
    ],
    [
      "rain",
      "chover"
    ],
    [
      "onto",
      "na"
    ],
    [
      "permit",
      "aval"
    ],
    [
      "proof",
      "provado"
    ],
    [
      "tennis",
      "ténis"
    ],
    [
      "bass",
      "grave"
    ],
    [
      "prescription",
      "prescrição extintiva"
    ],
    [
      "bedroom",
      "quarto"
    ],
    [
      "instance",
      "ocasião"
    ],
    [
      "hole",
      "buraco"
    ],
    [
      "ride",
      "andar de"
    ],
    [
      "bureau",
      "birô"
    ],
    [
      "represent",
      "representar"
    ],
    [
      "finished",
      "finalizado"
    ],
    [
      "dinner",
      "ceia"
    ],
    [
      "sydney",
      "Sidney"
    ],
    [
      "stress",
      "enfatizar"
    ],
    [
      "cream",
      "nata"
    ],
    [
      "yeah",
      "é"
    ],
    [
      "louisiana",
      "Luisiana"
    ],
    [
      "javascript",
      "Javascript"
    ],
    [
      "fourth",
      "quarta"
    ],
    [
      "evil",
      "malvado"
    ],
    [
      "aware",
      "ciente"
    ],
    [
      "shape",
      "estado"
    ],
    [
      "irish",
      "gaélico"
    ],
    [
      "remains",
      "ruína"
    ],
    [
      "operator",
      "operador"
    ],
    [
      "usage",
      "emprego"
    ],
    [
      "cap",
      "boné"
    ],
    [
      "ink",
      "firmar"
    ],
    [
      "mixed",
      "mestiço"
    ],
    [
      "census",
      "recenseamento"
    ],
    [
      "peak",
      "pico"
    ],
    [
      "wheel",
      "timão"
    ],
    [
      "transit",
      "trânsito"
    ],
    [
      "dick",
      "pau"
    ],
    [
      "salt",
      "sal"
    ],
    [
      "compact",
      "pacto"
    ],
    [
      "poetry",
      "poesia"
    ],
    [
      "bell",
      "campainha"
    ],
    [
      "attempt",
      "provar"
    ],
    [
      "noise",
      "ruído"
    ],
    [
      "array",
      "arranjo"
    ],
    [
      "accurate",
      "justo"
    ],
    [
      "stephen",
      "Estêvão"
    ],
    [
      "elizabeth",
      "Isabel"
    ],
    [
      "pin",
      "pino"
    ],
    [
      "greek",
      "grega"
    ],
    [
      "annotation",
      "anotação"
    ],
    [
      "sister",
      "irmã"
    ],
    [
      "raw",
      "crua"
    ],
    [
      "walking",
      "humano"
    ],
    [
      "explain",
      "explanar"
    ],
    [
      "establish",
      "estabelecer"
    ],
    [
      "sharp",
      "agudo"
    ],
    [
      "lane",
      "raia"
    ],
    [
      "kill",
      "presa"
    ],
    [
      "export",
      "exportar"
    ],
    [
      "conflict",
      "coincidir"
    ],
    [
      "employer",
      "empregadora"
    ],
    [
      "occur",
      "ocorrer"
    ],
    [
      "percentage",
      "porcentagem"
    ],
    [
      "mississippi",
      "Mississípi"
    ],
    [
      "concern",
      "negócio"
    ],
    [
      "backup",
      "becape"
    ],
    [
      "trouble",
      "treta"
    ],
    [
      "spread",
      "espalhar"
    ],
    [
      "coach",
      "ônibus"
    ],
    [
      "audience",
      "audiência"
    ],
    [
      "jordan",
      "Jordão"
    ],
    [
      "plug",
      "ficha"
    ],
    [
      "specialist",
      "expert"
    ],
    [
      "cook",
      "cozer"
    ],
    [
      "affect",
      "fingir"
    ],
    [
      "virgin",
      "virgem"
    ],
    [
      "sporting",
      "esportivo"
    ],
    [
      "bike",
      "puta"
    ],
    [
      "plate",
      "placa"
    ],
    [
      "favourite",
      "preferido"
    ],
    [
      "transmission",
      "caixa de câmbio"
    ],
    [
      "lose",
      "perder"
    ],
    [
      "seek",
      "procurar"
    ],
    [
      "neighborhood",
      "vizinhança"
    ],
    [
      "agenda",
      "pauta"
    ],
    [
      "anyway",
      "de qualquer forma"
    ],
    [
      "cam",
      "camo"
    ],
    [
      "template",
      "molde"
    ],
    [
      "prince",
      "príncipe"
    ],
    [
      "circle",
      "disco"
    ],
    [
      "soil",
      "solo"
    ],
    [
      "wet",
      "chuvoso"
    ],
    [
      "edward",
      "Duarte"
    ],
    [
      "identification",
      "RG"
    ],
    [
      "ram",
      "aríete"
    ],
    [
      "wildlife",
      "vida selvagem"
    ],
    [
      "elementary",
      "fundamental"
    ],
    [
      "cooking",
      "cozinha"
    ],
    [
      "fox",
      "raposa"
    ],
    [
      "plain",
      "natural"
    ],
    [
      "exit",
      "deixar"
    ],
    [
      "iran",
      "Irã"
    ],
    [
      "arm",
      "arma"
    ],
    [
      "launch",
      "lançar"
    ],
    [
      "wave",
      "onda"
    ],
    [
      "holy",
      "sacro"
    ],
    [
      "guidance",
      "navegação"
    ],
    [
      "trail",
      "rastro"
    ],
    [
      "enforcement",
      "coerção"
    ],
    [
      "highway",
      "autoestrada"
    ],
    [
      "buddy",
      "parceiro"
    ],
    [
      "dean",
      "deão"
    ],
    [
      "poll",
      "urna"
    ],
    [
      "booking",
      "reserva"
    ],
    [
      "celebrity",
      "colunável"
    ],
    [
      "bond",
      "vínculo"
    ],
    [
      "notify",
      "notificar"
    ],
    [
      "blues",
      "blues"
    ],
    [
      "pub",
      "boteco"
    ],
    [
      "scope",
      "âmbito"
    ],
    [
      "supplier",
      "fornecedora"
    ],
    [
      "requirement",
      "requisito"
    ],
    [
      "dental",
      "dental"
    ],
    [
      "border",
      "orla"
    ],
    [
      "debate",
      "discussão"
    ],
    [
      "pregnancy",
      "prenhez"
    ],
    [
      "arkansas",
      "Arkansas"
    ],
    [
      "leisure",
      "lazer"
    ],
    [
      "learned",
      "douto"
    ],
    [
      "notebook",
      "laptop"
    ],
    [
      "explorer",
      "explorador"
    ],
    [
      "attached",
      "apegado"
    ],
    [
      "husband",
      "esposo"
    ],
    [
      "disabled",
      "inválido"
    ],
    [
      "crazy",
      "doido"
    ],
    [
      "upcoming",
      "próximo"
    ],
    [
      "concert",
      "show"
    ],
    [
      "retirement",
      "reforma"
    ],
    [
      "efficient",
      "eficaz"
    ],
    [
      "commitment",
      "compromisso"
    ],
    [
      "hop",
      "salto"
    ],
    [
      "carrier",
      "portador"
    ],
    [
      "mouth",
      "foz"
    ],
    [
      "jewish",
      "judeu"
    ],
    [
      "gun",
      "fuzil"
    ],
    [
      "deliver",
      "parir"
    ],
    [
      "wonder",
      "genial"
    ],
    [
      "fruit",
      "fruto"
    ],
    [
      "reform",
      "inovação"
    ],
    [
      "lens",
      "lente"
    ],
    [
      "discovery",
      "descoberta"
    ],
    [
      "draw",
      "sacar"
    ],
    [
      "assume",
      "assumir"
    ],
    [
      "confidence",
      "convicção"
    ],
    [
      "alliance",
      "aliados"
    ],
    [
      "confirm",
      "firmar"
    ],
    [
      "warm",
      "morno"
    ],
    [
      "neither",
      "tampouco"
    ],
    [
      "offline",
      "offline"
    ],
    [
      "engineer",
      "engenheira"
    ],
    [
      "clearance",
      "folga"
    ],
    [
      "inventory",
      "inventário"
    ],
    [
      "suck",
      "mame"
    ],
    [
      "becoming",
      "decente"
    ],
    [
      "blowjob",
      "bico"
    ],
    [
      "objective",
      "objetiva"
    ],
    [
      "sugar",
      "doce"
    ],
    [
      "crew",
      "gangue"
    ],
    [
      "stick",
      "stique"
    ],
    [
      "relation",
      "parente"
    ],
    [
      "genre",
      "gênero"
    ],
    [
      "slide",
      "escorregar"
    ],
    [
      "rear",
      "traseiro"
    ],
    [
      "enhance",
      "melhorar"
    ],
    [
      "exact",
      "obter"
    ],
    [
      "bound",
      "limite"
    ],
    [
      "node",
      "nó"
    ],
    [
      "lock",
      "eclusa"
    ],
    [
      "storm",
      "assalto"
    ],
    [
      "bowl",
      "bocha"
    ],
    [
      "tank",
      "tanque"
    ],
    [
      "submission",
      "submissão"
    ],
    [
      "estimate",
      "estimativa"
    ],
    [
      "encourage",
      "incentivar"
    ],
    [
      "navy",
      "azul-marinho"
    ],
    [
      "kid",
      "piá"
    ],
    [
      "cancel",
      "cancelar"
    ],
    [
      "paint",
      "pintura"
    ],
    [
      "delay",
      "mora"
    ],
    [
      "pilot",
      "piloto"
    ],
    [
      "outlet",
      "outlet"
    ],
    [
      "czech",
      "tcheco"
    ],
    [
      "cambridge",
      "Cantabrígia"
    ],
    [
      "initiative",
      "iniciativo"
    ],
    [
      "novel",
      "nova"
    ],
    [
      "pan",
      "bateia"
    ],
    [
      "winner",
      "vencedor"
    ],
    [
      "contractor",
      "autônomo"
    ],
    [
      "potter",
      "oleira"
    ],
    [
      "dish",
      "louça"
    ],
    [
      "bulletin",
      "nota"
    ],
    [
      "oxford",
      "Oxónia"
    ],
    [
      "truly",
      "realmente"
    ],
    [
      "painting",
      "quadro"
    ],
    [
      "candidate",
      "candidata"
    ],
    [
      "slot",
      "ranhura"
    ],
    [
      "outstanding",
      "pendente"
    ],
    [
      "ha",
      "ah"
    ],
    [
      "eating",
      "consumível"
    ],
    [
      "perspective",
      "perspetiva"
    ],
    [
      "planned",
      "planejado"
    ],
    [
      "lodge",
      "loja"
    ],
    [
      "mirror",
      "cópia"
    ],
    [
      "consideration",
      "contraprestação"
    ],
    [
      "kernel",
      "miolo"
    ],
    [
      "gray",
      "gris"
    ],
    [
      "catalogue",
      "programa"
    ],
    [
      "taiwan",
      "Formosa"
    ],
    [
      "chosen",
      "eleito"
    ],
    [
      "demo",
      "demo"
    ],
    [
      "swiss",
      "suíça"
    ],
    [
      "labour",
      "parto"
    ],
    [
      "caribbean",
      "Caribe"
    ],
    [
      "liquid",
      "líqüido"
    ],
    [
      "nebraska",
      "Nebraska"
    ],
    [
      "loop",
      "loop"
    ],
    [
      "reservation",
      "reserva"
    ],
    [
      "gourmet",
      "gastrónomo"
    ],
    [
      "guard",
      "defender"
    ],
    [
      "orleans",
      "Orleães"
    ],
    [
      "saving",
      "poupança"
    ],
    [
      "resume",
      "retomar"
    ],
    [
      "raise",
      "alçar"
    ],
    [
      "prepare",
      "preparar"
    ],
    [
      "avatar",
      "personificação"
    ],
    [
      "illegal",
      "ilegal"
    ],
    [
      "milk",
      "mungir"
    ],
    [
      "consent",
      "deixar"
    ],
    [
      "downtown",
      "baixa"
    ],
    [
      "contest",
      "concurso"
    ],
    [
      "nw",
      "NW"
    ],
    [
      "boot",
      "arrancar"
    ],
    [
      "suitable",
      "favorável"
    ],
    [
      "lunch",
      "grande-almoço"
    ],
    [
      "dildo",
      "consolo"
    ],
    [
      "push",
      "forçar"
    ],
    [
      "chamber",
      "câmara"
    ],
    [
      "muscle",
      "força"
    ],
    [
      "implement",
      "implemento"
    ],
    [
      "tower",
      "torre"
    ],
    [
      "yours",
      "(o) teu"
    ],
    [
      "sum",
      "soma"
    ],
    [
      "calculator",
      "calculista"
    ],
    [
      "significantly",
      "significativamente"
    ],
    [
      "chicken",
      "cagão"
    ],
    [
      "attend",
      "cuidar"
    ],
    [
      "shower",
      "banho"
    ],
    [
      "jason",
      "Jasão"
    ],
    [
      "tonight",
      "esta/essa noite"
    ],
    [
      "dear",
      "caro"
    ],
    [
      "shell",
      "casca"
    ],
    [
      "vat",
      "tonel"
    ],
    [
      "awareness",
      "percepção"
    ],
    [
      "governor",
      "regulador"
    ],
    [
      "contribution",
      "doação"
    ],
    [
      "measurement",
      "medida"
    ],
    [
      "catch",
      "capturar"
    ],
    [
      "doubt",
      "dúvida"
    ],
    [
      "earn",
      "receber"
    ],
    [
      "wallpaper",
      "fundo de ecrã"
    ],
    [
      "visitor",
      "turista"
    ],
    [
      "twin",
      "gémea"
    ],
    [
      "insert",
      "enxertar"
    ],
    [
      "drawing",
      "sorteio"
    ],
    [
      "spy",
      "espionar"
    ],
    [
      "instrument",
      "aparelho"
    ],
    [
      "split",
      "racha"
    ],
    [
      "heaven",
      "céu"
    ],
    [
      "pregnant",
      "prenha"
    ],
    [
      "twice",
      "duplamente"
    ],
    [
      "egypt",
      "Egipto"
    ],
    [
      "physician",
      "médica"
    ],
    [
      "bargain",
      "barganha"
    ],
    [
      "lo",
      "ó"
    ],
    [
      "diabetes",
      "diabete"
    ],
    [
      "suit",
      "fato"
    ],
    [
      "shift",
      "mover"
    ],
    [
      "chip",
      "lasca"
    ],
    [
      "cutting",
      "estaca"
    ],
    [
      "wow",
      "uia"
    ],
    [
      "satisfaction",
      "satisfação"
    ],
    [
      "char",
      "chamuscar"
    ],
    [
      "cartoon",
      "charge"
    ],
    [
      "carbon",
      "carvão"
    ],
    [
      "effectively",
      "eficazmente"
    ],
    [
      "crisis",
      "crise"
    ],
    [
      "outlook",
      "ponto de vista"
    ],
    [
      "employed",
      "empregue"
    ],
    [
      "bright",
      "claro"
    ],
    [
      "treat",
      "tratar"
    ],
    [
      "header",
      "cabeçada"
    ],
    [
      "grid",
      "grade"
    ],
    [
      "revolution",
      "rotação"
    ],
    [
      "landscape",
      "vista"
    ],
    [
      "journey",
      "jornada"
    ],
    [
      "banner",
      "estandarte"
    ],
    [
      "applicant",
      "candidato"
    ],
    [
      "charter",
      "carta"
    ],
    [
      "fig",
      "figo"
    ],
    [
      "blogger",
      "blogueira"
    ],
    [
      "notification",
      "aviso"
    ],
    [
      "teach",
      "ensinar"
    ],
    [
      "rapid",
      "rápido"
    ],
    [
      "pull",
      "dar"
    ],
    [
      "reverse",
      "inverso"
    ],
    [
      "deposit",
      "empenho"
    ],
    [
      "dutch",
      "batavo"
    ],
    [
      "sensitive",
      "sensível"
    ],
    [
      "tab",
      "aba"
    ],
    [
      "router",
      "router"
    ],
    [
      "concrete",
      "betão"
    ],
    [
      "poland",
      "Polônia"
    ],
    [
      "folder",
      "pasta"
    ],
    [
      "completion",
      "conclusão"
    ],
    [
      "upload",
      "enviar"
    ],
    [
      "broadcast",
      "semear"
    ],
    [
      "anniversary",
      "bodas"
    ],
    [
      "strip",
      "tirar"
    ],
    [
      "accident",
      "acidente"
    ],
    [
      "accessory",
      "cúmplice"
    ],
    [
      "resident",
      "residente"
    ],
    [
      "plot",
      "lote"
    ],
    [
      "airline",
      "companhia aérea"
    ],
    [
      "regard",
      "notar"
    ],
    [
      "pump",
      "bombear"
    ],
    [
      "smooth",
      "suave"
    ],
    [
      "strike",
      "ataque"
    ],
    [
      "narrow",
      "estreita"
    ],
    [
      "threat",
      "ameaça"
    ],
    [
      "controller",
      "controle"
    ],
    [
      "penis",
      "pênis"
    ],
    [
      "vietnam",
      "Vietnã"
    ],
    [
      "trailer",
      "trailer"
    ],
    [
      "unsubscribe",
      "dessubscrever"
    ],
    [
      "antique",
      "antiquado"
    ],
    [
      "acting",
      "encenação"
    ],
    [
      "residence",
      "moradia"
    ],
    [
      "hundred",
      "cento"
    ],
    [
      "strange",
      "gozado"
    ],
    [
      "parallel",
      "paralela"
    ],
    [
      "operate",
      "obrar"
    ],
    [
      "bold",
      "bravo"
    ],
    [
      "bathroom",
      "casa de banho"
    ],
    [
      "stable",
      "cocheira"
    ],
    [
      "lesson",
      "lição"
    ],
    [
      "cinema",
      "cinematografia"
    ],
    [
      "asset",
      "bem"
    ],
    [
      "scan",
      "escandir"
    ],
    [
      "blank",
      "lacuna"
    ],
    [
      "enhanced",
      "ampliado"
    ],
    [
      "entitled",
      "intitulado"
    ],
    [
      "severe",
      "severo"
    ],
    [
      "generate",
      "procriar"
    ],
    [
      "exception",
      "exceção"
    ],
    [
      "bulk",
      "granel"
    ],
    [
      "fabric",
      "pano"
    ],
    [
      "tight",
      "justo"
    ],
    [
      "recommendation",
      "recomendaçõe"
    ],
    [
      "flying",
      "voante"
    ],
    [
      "sin",
      "pecado"
    ],
    [
      "berlin",
      "berlinês"
    ],
    [
      "cute",
      "giro"
    ],
    [
      "organized",
      "organizado"
    ],
    [
      "adoption",
      "adoção"
    ],
    [
      "buffalo",
      "Buffalo"
    ],
    [
      "plane",
      "avião"
    ],
    [
      "seed",
      "sémen"
    ],
    [
      "expertise",
      "especialidade"
    ],
    [
      "camping",
      "camping"
    ],
    [
      "jewellery",
      "joias"
    ],
    [
      "welfare",
      "segurança social"
    ],
    [
      "eventually",
      "enfim"
    ],
    [
      "bottle",
      "broxar"
    ],
    [
      "considering",
      "tendo em conta que"
    ],
    [
      "innovative",
      "inovador"
    ],
    [
      "massage",
      "massajar"
    ],
    [
      "rubber",
      "camisinha"
    ],
    [
      "legend",
      "legenda"
    ],
    [
      "grace",
      "graça"
    ],
    [
      "ing",
      "endo"
    ],
    [
      "bang",
      "cabum"
    ],
    [
      "villa",
      "casa de praia"
    ],
    [
      "bone",
      "osso"
    ],
    [
      "collaboration",
      "conspiração"
    ],
    [
      "detection",
      "deteção"
    ],
    [
      "inner",
      "interno"
    ],
    [
      "gate",
      "porta"
    ],
    [
      "moderator",
      "moderadora"
    ],
    [
      "sw",
      "SW"
    ],
    [
      "settlement",
      "povoação"
    ],
    [
      "roman",
      "latino"
    ],
    [
      "tone",
      "tom"
    ],
    [
      "captain",
      "capitã"
    ],
    [
      "imagine",
      "crer"
    ],
    [
      "heating",
      "aquecimento"
    ],
    [
      "leg",
      "calça"
    ],
    [
      "neck",
      "pescoço"
    ],
    [
      "wing",
      "ala"
    ],
    [
      "abc",
      "á-bê-cê"
    ],
    [
      "stereo",
      "estéreo"
    ],
    [
      "taste",
      "paladar"
    ],
    [
      "commit",
      "internar"
    ],
    [
      "tiny",
      "pequeno"
    ],
    [
      "rail",
      "carril"
    ],
    [
      "jay",
      "gaio"
    ],
    [
      "gap",
      "vão"
    ],
    [
      "tube",
      "lata"
    ],
    [
      "cache",
      "esconderijo"
    ],
    [
      "belt",
      "cingir"
    ],
    [
      "jacket",
      "paletó"
    ],
    [
      "er",
      "eiro"
    ],
    [
      "proud",
      "orgulhante"
    ],
    [
      "excess",
      "excedente"
    ],
    [
      "console",
      "consola"
    ],
    [
      "instructor",
      "instrutora"
    ],
    [
      "giant",
      "gigantesco"
    ],
    [
      "bestiality",
      "zoofilia"
    ],
    [
      "alarm",
      "despertador"
    ],
    [
      "voltage",
      "tensão"
    ],
    [
      "anthony",
      "Antão"
    ],
    [
      "angle",
      "anglo"
    ],
    [
      "rob",
      "roubar"
    ],
    [
      "vinyl",
      "vinil"
    ],
    [
      "ongoing",
      "em curso"
    ],
    [
      "blackjack",
      "vinte-e-um"
    ],
    [
      "era",
      "era"
    ],
    [
      "convert",
      "converter"
    ],
    [
      "analyst",
      "psicanalista"
    ],
    [
      "commissioner",
      "comissionário"
    ],
    [
      "dangerous",
      "nocivo"
    ],
    [
      "garage",
      "oficina"
    ],
    [
      "exciting",
      "excitante"
    ],
    [
      "reliability",
      "fiabilidade"
    ],
    [
      "respectively",
      "respetivamente"
    ],
    [
      "attachment",
      "anexo"
    ],
    [
      "ringtone",
      "toque"
    ],
    [
      "pleasure",
      "voluptuosidade"
    ],
    [
      "pants",
      "cueca"
    ],
    [
      "nurse",
      "babá"
    ],
    [
      "prayer",
      "reza"
    ],
    [
      "appointment",
      "nomeação"
    ],
    [
      "quiet",
      "silencioso"
    ],
    [
      "producer",
      "produtora"
    ],
    [
      "cheese",
      "xis"
    ],
    [
      "comic",
      "gibi"
    ],
    [
      "carefully",
      "cuidadosamente"
    ],
    [
      "jet",
      "jato"
    ],
    [
      "crown",
      "topo"
    ],
    [
      "underground",
      "alternativo"
    ],
    [
      "diagnosis",
      "diagnose"
    ],
    [
      "crack",
      "rego"
    ],
    [
      "gang",
      "gangue"
    ],
    [
      "fetish",
      "feitiço"
    ],
    [
      "appearance",
      "aparecimento"
    ],
    [
      "smoke",
      "fumar"
    ],
    [
      "apache",
      "apache"
    ],
    [
      "craft",
      "arte"
    ],
    [
      "cake",
      "sabonete"
    ],
    [
      "apart",
      "à parte"
    ],
    [
      "fellow",
      "colega"
    ],
    [
      "blind",
      "estore"
    ],
    [
      "lounge",
      "sala de espera"
    ],
    [
      "mad",
      "bravo"
    ],
    [
      "gross",
      "bruto"
    ],
    [
      "valentine",
      "Valentino"
    ],
    [
      "familiar",
      "próximo"
    ],
    [
      "pen",
      "pena"
    ],
    [
      "admission",
      "joia"
    ],
    [
      "shoe",
      "calçar"
    ],
    [
      "sand",
      "arear"
    ],
    [
      "cpu",
      "UCP"
    ],
    [
      "actor",
      "atriz"
    ],
    [
      "seal",
      "selo"
    ],
    [
      "fifth",
      "quinta"
    ],
    [
      "citizen",
      "civil"
    ],
    [
      "prize",
      "prémio"
    ],
    [
      "absolute",
      "certo"
    ],
    [
      "substance",
      "riqueza"
    ],
    [
      "pipe",
      "tubo"
    ],
    [
      "guardian",
      "guardião"
    ],
    [
      "lecture",
      "palestra"
    ],
    [
      "simulation",
      "simulação"
    ],
    [
      "layout",
      "leiaute"
    ],
    [
      "lay",
      "pôr"
    ],
    [
      "lol",
      "kkk"
    ],
    [
      "dirty",
      "sujar"
    ],
    [
      "deck",
      "deque"
    ],
    [
      "bankruptcy",
      "bancarrota"
    ],
    [
      "worker",
      "operário"
    ],
    [
      "optimization",
      "otimização"
    ],
    [
      "temple",
      "perna"
    ],
    [
      "prove",
      "provar"
    ],
    [
      "thin",
      "tênue"
    ],
    [
      "exhibition",
      "exibição"
    ],
    [
      "ridge",
      "serra"
    ],
    [
      "cabinet",
      "gabinete"
    ],
    [
      "sick",
      "irado"
    ],
    [
      "collect",
      "recolher"
    ],
    [
      "vector",
      "vetor"
    ],
    [
      "buffer",
      "solução tampão"
    ],
    [
      "purple",
      "roxo"
    ],
    [
      "mutual",
      "recíproco"
    ],
    [
      "pipeline",
      "duto"
    ],
    [
      "prison",
      "cárcere"
    ],
    [
      "skill",
      "talento"
    ],
    [
      "everyday",
      "comum"
    ],
    [
      "apparently",
      "pelos vistos"
    ],
    [
      "inquiry",
      "inquérito"
    ],
    [
      "exhibit",
      "exposição"
    ],
    [
      "throw",
      "lançar"
    ],
    [
      "trend",
      "moda"
    ],
    [
      "desert",
      "abandonar"
    ],
    [
      "mercury",
      "azougue"
    ],
    [
      "summit",
      "sumo"
    ],
    [
      "escape",
      "fugir"
    ],
    [
      "somewhat",
      "meio"
    ],
    [
      "receiver",
      "receptor"
    ],
    [
      "substantial",
      "substancial"
    ],
    [
      "progressive",
      "progressista"
    ],
    [
      "glance",
      "relance"
    ],
    [
      "arcade",
      "arcada"
    ],
    [
      "impossible",
      "impossível"
    ],
    [
      "depression",
      "crise"
    ],
    [
      "graph",
      "grafo"
    ],
    [
      "platinum",
      "platinado"
    ],
    [
      "judgment",
      "juízo"
    ],
    [
      "filing",
      "arquivamento"
    ],
    [
      "foster",
      "cuidar"
    ],
    [
      "passing",
      "vago"
    ],
    [
      "tissue",
      "papel absorvente"
    ],
    [
      "cartridge",
      "cartucho"
    ],
    [
      "explanation",
      "explanação"
    ],
    [
      "cincinnati",
      "Cincinnati"
    ],
    [
      "fraud",
      "logro"
    ],
    [
      "electricity",
      "eletricidade"
    ],
    [
      "spectrum",
      "espetro"
    ],
    [
      "arrival",
      "vinda"
    ],
    [
      "pottery",
      "olaria"
    ],
    [
      "aspect",
      "aspeto"
    ],
    [
      "awesome",
      "incrível"
    ],
    [
      "mexican",
      "mexicana"
    ],
    [
      "crash",
      "invadir"
    ],
    [
      "lift",
      "alçar"
    ],
    [
      "shadow",
      "sombras"
    ],
    [
      "infection",
      "infecção"
    ],
    [
      "grove",
      "bosque"
    ],
    [
      "venture",
      "arriscar"
    ],
    [
      "korean",
      "coreana"
    ],
    [
      "princess",
      "rainha"
    ],
    [
      "mall",
      "shopping"
    ],
    [
      "packet",
      "packet"
    ],
    [
      "spray",
      "esprei"
    ],
    [
      "dad",
      "papá"
    ],
    [
      "placement",
      "posicionamento"
    ],
    [
      "extend",
      "estender"
    ],
    [
      "subsequent",
      "subsequente"
    ],
    [
      "pat",
      "estalo"
    ],
    [
      "dublin",
      "Dublim"
    ],
    [
      "fell",
      "abater"
    ],
    [
      "motorcycle",
      "moto"
    ],
    [
      "yard",
      "jarda"
    ],
    [
      "disclosure",
      "exposição"
    ],
    [
      "establishment",
      "sistema"
    ],
    [
      "mayor",
      "presidente da câmara"
    ],
    [
      "murder",
      "bando"
    ],
    [
      "senator",
      "senadora"
    ],
    [
      "yield",
      "ceder"
    ],
    [
      "pour",
      "afluir"
    ],
    [
      "digest",
      "resumo"
    ],
    [
      "dust",
      "empoar"
    ],
    [
      "hence",
      "daqui"
    ],
    [
      "rescue",
      "salvar"
    ],
    [
      "undergraduate",
      "graduando"
    ],
    [
      "combat",
      "luta"
    ],
    [
      "occupation",
      "ocupação"
    ],
    [
      "butt",
      "cu"
    ],
    [
      "closely",
      "de perto"
    ],
    [
      "radiation",
      "radiação"
    ],
    [
      "seriously",
      "a sério"
    ],
    [
      "shooting",
      "tiro"
    ],
    [
      "ear",
      "orelha"
    ],
    [
      "baker",
      "pasteleiro"
    ],
    [
      "pollution",
      "polução"
    ],
    [
      "conservative",
      "conservador"
    ],
    [
      "shock",
      "choque"
    ],
    [
      "abroad",
      "exterior"
    ],
    [
      "ebony",
      "ébano"
    ],
    [
      "tie",
      "amarrar"
    ],
    [
      "ward",
      "guarda"
    ],
    [
      "roof",
      "teto"
    ],
    [
      "walker",
      "andador"
    ],
    [
      "atmosphere",
      "ambiente"
    ],
    [
      "kiss",
      "beijar"
    ],
    [
      "beast",
      "fera"
    ],
    [
      "ra",
      "Rá"
    ],
    [
      "experiment",
      "experiência"
    ],
    [
      "overseas",
      "ultramar"
    ],
    [
      "dodge",
      "subexpor"
    ],
    [
      "counsel",
      "advogado"
    ],
    [
      "pizza",
      "piza"
    ],
    [
      "assignment",
      "atribuição"
    ],
    [
      "mod",
      "modificador"
    ],
    [
      "rush",
      "pressa"
    ],
    [
      "absence",
      "ausência"
    ],
    [
      "cluster",
      "conjunto"
    ],
    [
      "whereas",
      "dado que"
    ],
    [
      "lamp",
      "candeia"
    ],
    [
      "everybody",
      "todas"
    ],
    [
      "ranking",
      "superior"
    ],
    [
      "ceo",
      "diretor executivo"
    ],
    [
      "satisfied",
      "saciado"
    ],
    [
      "glad",
      "feliz"
    ],
    [
      "verify",
      "constatar"
    ],
    [
      "globe",
      "globo"
    ],
    [
      "copper",
      "cobre"
    ],
    [
      "rack",
      "ecúleo"
    ],
    [
      "medication",
      "remédio"
    ],
    [
      "shareware",
      "programa de utilização limitada"
    ],
    [
      "receipt",
      "talão"
    ],
    [
      "ordinary",
      "normal"
    ],
    [
      "nobody",
      "nulidade"
    ],
    [
      "ghost",
      "alma"
    ],
    [
      "boss",
      "chefe"
    ],
    [
      "pride",
      "Parada"
    ],
    [
      "reporter",
      "jornalista"
    ],
    [
      "champion",
      "campeã"
    ],
    [
      "cloudy",
      "turvo"
    ],
    [
      "sentence",
      "sentença"
    ],
    [
      "throat",
      "gargalo"
    ],
    [
      "uniform",
      "farda"
    ],
    [
      "wealth",
      "poder"
    ],
    [
      "tall",
      "exagerado"
    ],
    [
      "somewhere",
      "a algum lugar"
    ],
    [
      "brass",
      "bronze"
    ],
    [
      "publish",
      "anunciar"
    ],
    [
      "toe",
      "pododáctilo"
    ],
    [
      "thumbnail",
      "esboço"
    ],
    [
      "jonathan",
      "Jônatas"
    ],
    [
      "whenever",
      "sempre que"
    ],
    [
      "booty",
      "bunda"
    ],
    [
      "venue",
      "sala de eventos"
    ],
    [
      "thermal",
      "térmico"
    ],
    [
      "fairly",
      "bastante"
    ],
    [
      "charity",
      "caridade"
    ],
    [
      "excel",
      "superar"
    ],
    [
      "obligation",
      "obrigação"
    ],
    [
      "wake",
      "sulco"
    ],
    [
      "stupid",
      "estupendo"
    ],
    [
      "harbor",
      "cais"
    ],
    [
      "segment",
      "secção"
    ],
    [
      "realize",
      "notar"
    ],
    [
      "enemy",
      "inimiga"
    ],
    [
      "puzzle",
      "enigma"
    ],
    [
      "insight",
      "dedução"
    ],
    [
      "sms",
      "mensagem de texto"
    ],
    [
      "shit",
      "bosta"
    ],
    [
      "restricted",
      "restrito"
    ],
    [
      "republican",
      "republicano"
    ],
    [
      "latter",
      "último"
    ],
    [
      "thick",
      "espesso"
    ],
    [
      "syndrome",
      "síndroma"
    ],
    [
      "attendance",
      "assiduidade"
    ],
    [
      "penalty",
      "penalidade"
    ],
    [
      "drum",
      "barril"
    ],
    [
      "builder",
      "construtora"
    ],
    [
      "flood",
      "cheia"
    ],
    [
      "ease",
      "conforto"
    ],
    [
      "amsterdam",
      "Amsterdã"
    ],
    [
      "announcement",
      "anúncio"
    ],
    [
      "appreciate",
      "valorizar"
    ],
    [
      "casual",
      "fortuito"
    ],
    [
      "polish",
      "polonês"
    ],
    [
      "lovely",
      "amável"
    ],
    [
      "clause",
      "artigo"
    ],
    [
      "broker",
      "intermediário"
    ],
    [
      "charger",
      "salva"
    ],
    [
      "regularly",
      "normalmente"
    ],
    [
      "pine",
      "ter [[saudade|saudade(s)]]"
    ],
    [
      "cooling",
      "refrigeração"
    ],
    [
      "tend",
      "cuidar de"
    ],
    [
      "divorce",
      "separação"
    ],
    [
      "customize",
      "personalizar"
    ],
    [
      "candy",
      "bala"
    ],
    [
      "hunt",
      "vear"
    ],
    [
      "deputy",
      "representante"
    ],
    [
      "thai",
      "tailandês"
    ],
    [
      "complaint",
      "queixa"
    ],
    [
      "balls",
      "saco"
    ],
    [
      "spanking",
      "coça"
    ],
    [
      "scholarship",
      "sabedoria"
    ],
    [
      "mill",
      "fábrica"
    ],
    [
      "chronic",
      "crónico"
    ],
    [
      "moral",
      "moralidade"
    ],
    [
      "den",
      "cova"
    ],
    [
      "finger",
      "cutucar"
    ],
    [
      "pound",
      "libra"
    ],
    [
      "burn",
      "queimar"
    ],
    [
      "ourselves",
      "nós"
    ],
    [
      "bread",
      "grana"
    ],
    [
      "wooden",
      "lenhoso"
    ],
    [
      "tough",
      "durão"
    ],
    [
      "lie",
      "ficar"
    ],
    [
      "conversation",
      "conversa"
    ],
    [
      "decrease",
      "diminuir"
    ],
    [
      "chest",
      "tórax"
    ],
    [
      "pension",
      "aposentar"
    ],
    [
      "worship",
      "culto"
    ],
    [
      "herself",
      "se"
    ],
    [
      "solve",
      "solucionar"
    ],
    [
      "shorts",
      "short"
    ],
    [
      "minority",
      "minoria"
    ],
    [
      "diverse",
      "diverso"
    ],
    [
      "sole",
      "sola"
    ],
    [
      "franchise",
      "franquia"
    ],
    [
      "recorder",
      "flauta doce"
    ],
    [
      "passion",
      "ardor"
    ],
    [
      "sight",
      "ver"
    ],
    [
      "clay",
      "argila"
    ],
    [
      "weak",
      "débil"
    ],
    [
      "wise",
      "sensato"
    ],
    [
      "worry",
      "preocupar"
    ],
    [
      "pleased",
      "satisfeito"
    ],
    [
      "widely",
      "amplamente"
    ],
    [
      "phrase",
      "frase"
    ],
    [
      "genuine",
      "genuíno"
    ],
    [
      "intermediate",
      "intermédio"
    ],
    [
      "emotional",
      "emotivo"
    ],
    [
      "leaf",
      "aba"
    ],
    [
      "diesel",
      "óleo diesel"
    ],
    [
      "versus",
      "contra"
    ],
    [
      "overnight",
      "pernoite"
    ],
    [
      "exceed",
      "superar"
    ],
    [
      "rod",
      "vara"
    ],
    [
      "fault",
      "falha"
    ],
    [
      "introduce",
      "introduzir"
    ],
    [
      "bi",
      "gilete"
    ],
    [
      "examine",
      "examinar"
    ],
    [
      "margaret",
      "Margarete"
    ],
    [
      "correction",
      "correcção"
    ],
    [
      "wolf",
      "loba"
    ],
    [
      "slowly",
      "lentamente"
    ],
    [
      "communicate",
      "comungar"
    ],
    [
      "rugby",
      "rúgbi"
    ],
    [
      "supplement",
      "suplemento"
    ],
    [
      "infant",
      "menor"
    ],
    [
      "fluid",
      "líquido"
    ],
    [
      "kick",
      "coice"
    ],
    [
      "regards",
      "com"
    ],
    [
      "meal",
      "comida"
    ],
    [
      "hurt",
      "doer"
    ],
    [
      "machinery",
      "maquinário"
    ],
    [
      "unlike",
      "descurtir"
    ],
    [
      "pot",
      "pote"
    ],
    [
      "warren",
      "toca"
    ],
    [
      "slip",
      "derrapar"
    ],
    [
      "quarterly",
      "esquartelado"
    ],
    [
      "rpm",
      "rotações por minuto"
    ],
    [
      "devil",
      "Satã"
    ],
    [
      "grass",
      "erva"
    ],
    [
      "comply",
      "cumprir"
    ],
    [
      "florist",
      "floreiro"
    ],
    [
      "cherry",
      "cereja"
    ],
    [
      "alternate",
      "alternante"
    ],
    [
      "achievement",
      "conquista"
    ],
    [
      "kenya",
      "Quênia"
    ],
    [
      "webcam",
      "webcam"
    ],
    [
      "pee",
      "pê"
    ],
    [
      "quebec",
      "Quebeque"
    ],
    [
      "passenger",
      "passageira"
    ],
    [
      "convenient",
      "cômodo"
    ],
    [
      "dennis",
      "Diniz"
    ],
    [
      "manga",
      "manga"
    ],
    [
      "socket",
      "soquete"
    ],
    [
      "silent",
      "mudo"
    ],
    [
      "egg",
      "ovo"
    ],
    [
      "pill",
      "pílula"
    ],
    [
      "theft",
      "roubo"
    ],
    [
      "swing",
      "baloiço"
    ],
    [
      "dated",
      "datado"
    ],
    [
      "wisdom",
      "sabedoria"
    ],
    [
      "shoot",
      "atirar"
    ],
    [
      "mint",
      "menta"
    ],
    [
      "offset",
      "início"
    ],
    [
      "philip",
      "Felipe"
    ],
    [
      "elite",
      "escol"
    ],
    [
      "spin",
      "volta"
    ],
    [
      "swedish",
      "língua sueca"
    ],
    [
      "jurisdiction",
      "jurisdição"
    ],
    [
      "robot",
      "robô"
    ],
    [
      "witness",
      "testemunha"
    ],
    [
      "assess",
      "estimar"
    ],
    [
      "wash",
      "lavar-se"
    ],
    [
      "entrance",
      "acesso"
    ],
    [
      "glasgow",
      "Glásgua"
    ],
    [
      "automation",
      "automação"
    ],
    [
      "shore",
      "orla"
    ],
    [
      "knight",
      "cavalo"
    ],
    [
      "loose",
      "solto"
    ],
    [
      "recipient",
      "receptor"
    ],
    [
      "illness",
      "enfermidade"
    ],
    [
      "islamic",
      "muçulmano"
    ],
    [
      "ho",
      "puta"
    ],
    [
      "soap",
      "sabonete"
    ],
    [
      "jam",
      "aperto"
    ],
    [
      "unusual",
      "inesperado"
    ],
    [
      "disorder",
      "distúrbio"
    ],
    [
      "routine",
      "rotineiro"
    ],
    [
      "axis",
      "áxis"
    ],
    [
      "firewall",
      "firewall"
    ],
    [
      "median",
      "mediana"
    ],
    [
      "scanner",
      "scâner"
    ],
    [
      "horny",
      "caloso"
    ],
    [
      "adjustment",
      "ajuste"
    ],
    [
      "hero",
      "heroína"
    ],
    [
      "bachelor",
      "bacharel"
    ],
    [
      "attitude",
      "atitude"
    ],
    [
      "engaged",
      "ocupado"
    ],
    [
      "montreal",
      "Montréal"
    ],
    [
      "carpet",
      "carpete"
    ],
    [
      "punk",
      "putinha"
    ],
    [
      "coalition",
      "coalizão"
    ],
    [
      "enrollment",
      "inscrição"
    ],
    [
      "duke",
      "grão-duque"
    ],
    [
      "walter",
      "Válter"
    ],
    [
      "pace",
      "passo"
    ],
    [
      "besides",
      "fora isso"
    ],
    [
      "wage",
      "travar"
    ],
    [
      "collector",
      "coletor"
    ],
    [
      "arc",
      "arco"
    ],
    [
      "dawn",
      "alvorada"
    ],
    [
      "observation",
      "observação"
    ],
    [
      "torture",
      "suplício"
    ],
    [
      "coat",
      "mão"
    ],
    [
      "convenience",
      "conveniência"
    ],
    [
      "container",
      "contentor"
    ],
    [
      "defendant",
      "ré"
    ],
    [
      "confirmation",
      "crisma"
    ],
    [
      "app",
      "aplicação"
    ],
    [
      "embedded",
      "incrustado"
    ],
    [
      "wizard",
      "mago"
    ],
    [
      "liver",
      "fígado"
    ],
    [
      "liable",
      "passível"
    ],
    [
      "brochure",
      "folheto"
    ],
    [
      "petition",
      "petição"
    ],
    [
      "recall",
      "convocar"
    ],
    [
      "departure",
      "partida"
    ],
    [
      "killing",
      "de matar"
    ],
    [
      "shoulder",
      "pá"
    ],
    [
      "ion",
      "ião"
    ],
    [
      "ottawa",
      "Otava"
    ],
    [
      "doll",
      "boneco"
    ],
    [
      "tit",
      "mama"
    ],
    [
      "refine",
      "purificar"
    ],
    [
      "bidder",
      "licitante"
    ],
    [
      "singer",
      "cantora"
    ],
    [
      "herald",
      "arauto"
    ],
    [
      "literacy",
      "literacia"
    ],
    [
      "reed",
      "cana"
    ],
    [
      "involve",
      "elevar"
    ],
    [
      "opposite",
      "oposto"
    ],
    [
      "understood",
      "entendido"
    ],
    [
      "ban",
      "banir"
    ],
    [
      "assurance",
      "garantia"
    ],
    [
      "clerk",
      "clérigo"
    ],
    [
      "outline",
      "resumo"
    ],
    [
      "jeans",
      "jeans"
    ],
    [
      "compilation",
      "coletânea"
    ],
    [
      "odd",
      "raro"
    ],
    [
      "wrap",
      "embrulhar"
    ],
    [
      "mood",
      "clima"
    ],
    [
      "attractive",
      "atrator"
    ],
    [
      "victim",
      "vítima"
    ],
    [
      "sleeping",
      "sono"
    ],
    [
      "careful",
      "cauteloso"
    ],
    [
      "beam",
      "viga"
    ],
    [
      "arrive",
      "vencer"
    ],
    [
      "sunset",
      "crepúsculo"
    ],
    [
      "moreover",
      "demais"
    ],
    [
      "minimal",
      "mínima"
    ],
    [
      "lottery",
      "lotaria"
    ],
    [
      "aside",
      "comentário"
    ],
    [
      "outsourcing",
      "externalização"
    ],
    [
      "essay",
      "ensaio"
    ],
    [
      "discipline",
      "disciplina"
    ],
    [
      "dialogue",
      "diálogo"
    ],
    [
      "trace",
      "rasto"
    ],
    [
      "disposal",
      "controle"
    ],
    [
      "romania",
      "Romênia"
    ],
    [
      "thou",
      "vós"
    ],
    [
      "mask",
      "mascarada"
    ],
    [
      "photographer",
      "fotógrafa"
    ],
    [
      "coal",
      "brasa"
    ],
    [
      "cry",
      "berrar"
    ],
    [
      "quantum",
      "quantidade"
    ],
    [
      "zoo",
      "zoológico"
    ],
    [
      "announce",
      "pronunciar"
    ],
    [
      "arrow",
      "seta"
    ],
    [
      "engagement",
      "combate"
    ],
    [
      "rough",
      "duro"
    ],
    [
      "weird",
      "bizarro"
    ],
    [
      "blade",
      "pá"
    ],
    [
      "suddenly",
      "subitamente"
    ],
    [
      "oxygen",
      "oxigênio"
    ],
    [
      "cookie",
      "bolacha"
    ],
    [
      "canyon",
      "cânion"
    ],
    [
      "merely",
      "meramente"
    ],
    [
      "arrangement",
      "acordo"
    ],
    [
      "pointer",
      "dica"
    ],
    [
      "stretch",
      "trecho"
    ],
    [
      "cooperative",
      "cooperativo"
    ],
    [
      "muslim",
      "muçulmano"
    ],
    [
      "cleaner",
      "lavanderia"
    ],
    [
      "cricket",
      "críquete"
    ],
    [
      "beef",
      "carne"
    ],
    [
      "stroke",
      "traço"
    ],
    [
      "township",
      "township"
    ],
    [
      "measuring",
      "medida"
    ],
    [
      "robin",
      "tordo"
    ],
    [
      "strap",
      "faixa"
    ],
    [
      "headquarters",
      "sede"
    ],
    [
      "crowd",
      "povo"
    ],
    [
      "surf",
      "navegar"
    ],
    [
      "customs",
      "alfândega"
    ],
    [
      "rainbow",
      "multicor"
    ],
    [
      "hook",
      "volta"
    ],
    [
      "decline",
      "declive"
    ],
    [
      "israeli",
      "israelita"
    ],
    [
      "cord",
      "cabo"
    ],
    [
      "skiing",
      "esquiação"
    ],
    [
      "cloud",
      "nuvem"
    ],
    [
      "subscriber",
      "inscrita"
    ],
    [
      "valve",
      "valva"
    ],
    [
      "proceed",
      "seguir"
    ],
    [
      "knife",
      "cortar"
    ],
    [
      "shelf",
      "estante"
    ],
    [
      "incredible",
      "incrível"
    ],
    [
      "freeware",
      "programa grátis"
    ],
    [
      "fucked",
      "mamado"
    ],
    [
      "crop",
      "papo"
    ],
    [
      "islam",
      "islão"
    ],
    [
      "hub",
      "poste"
    ],
    [
      "founder",
      "falhar"
    ],
    [
      "decade",
      "dezena"
    ],
    [
      "portuguese",
      "luso"
    ],
    [
      "adverse",
      "adverso"
    ],
    [
      "everywhere",
      "por todo lado"
    ],
    [
      "excerpt",
      "trecho"
    ],
    [
      "discharge",
      "descarga"
    ],
    [
      "ace",
      "ás"
    ],
    [
      "acute",
      "urgente"
    ],
    [
      "halloween",
      "Raloim"
    ],
    [
      "perfume",
      "cheiro"
    ],
    [
      "honest",
      "sincero"
    ],
    [
      "restore",
      "recuperar"
    ],
    [
      "sue",
      "demandar"
    ],
    [
      "reputation",
      "fama"
    ],
    [
      "hang",
      "pendurar"
    ],
    [
      "curve",
      "curvar"
    ],
    [
      "creator",
      "criador"
    ],
    [
      "amber",
      "âmbar"
    ],
    [
      "coding",
      "programação"
    ],
    [
      "tracker",
      "rastreadora"
    ],
    [
      "variation",
      "variante"
    ],
    [
      "passage",
      "passagem"
    ],
    [
      "trunk",
      "baú"
    ],
    [
      "hiking",
      "pedestrianismo"
    ],
    [
      "damn",
      "amaldiçoar"
    ],
    [
      "photograph",
      "foto"
    ],
    [
      "camel",
      "camela"
    ],
    [
      "underlying",
      "implícito"
    ],
    [
      "hood",
      "idão"
    ],
    [
      "suicide",
      "suicida"
    ],
    [
      "chi",
      "qi"
    ],
    [
      "gathering",
      "caderno"
    ],
    [
      "juice",
      "suco"
    ],
    [
      "chase",
      "perseguir"
    ],
    [
      "courtesy",
      "grátis"
    ],
    [
      "criticism",
      "criticismo"
    ],
    [
      "automobile",
      "auto"
    ],
    [
      "confidential",
      "secreto"
    ],
    [
      "retired",
      "reformado"
    ],
    [
      "isp",
      "provedor de acesso à Internet"
    ],
    [
      "bracelet",
      "bracelete"
    ],
    [
      "injection",
      "injeção"
    ],
    [
      "protective",
      "protetor"
    ],
    [
      "afraid",
      "temer"
    ],
    [
      "railway",
      "ferrovia"
    ],
    [
      "indicator",
      "seta"
    ],
    [
      "pointed",
      "apontado"
    ],
    [
      "mistake",
      "errar"
    ],
    [
      "fusion",
      "fusão"
    ],
    [
      "sunglasses",
      "óculos escuros"
    ],
    [
      "fortune",
      "fortuna"
    ],
    [
      "canvas",
      "tela"
    ],
    [
      "threshold",
      "limiar"
    ],
    [
      "parish",
      "paróquia"
    ],
    [
      "coupon",
      "cupão"
    ],
    [
      "stem",
      "ramo"
    ],
    [
      "proxy",
      "laranja"
    ],
    [
      "translate",
      "verter"
    ],
    [
      "costume",
      "traje"
    ],
    [
      "tagged",
      "marcado"
    ],
    [
      "killer",
      "homicida"
    ],
    [
      "tune",
      "ajustar"
    ]
  ],
  "ru": [
    [
      "of",
      "о"
    ],
    [
      "and",
      "а"
    ],
    [
      "to",
      "в"
    ],
    [
      "a",
      "эй"
    ],
    [
      "in",
      "в"
    ],
    [
      "for",
      "для"
    ],
    [
      "on",
      "в"
    ],
    [
      "that",
      "что"
    ],
    [
      "by",
      "во [[и́мя]]"
    ],
    [
      "this",
      "э́тот"
    ],
    [
      "i",
      "и"
    ],
    [
      "you",
      "ты"
    ],
    [
      "it",
      "э́то"
    ],
    [
      "not",
      "а не"
    ],
    [
      "or",
      "чи"
    ],
    [
      "be",
      "быть"
    ],
    [
      "from",
      "с"
    ],
    [
      "at",
      "в"
    ],
    [
      "as",
      "ас"
    ],
    [
      "your",
      "ваш"
    ],
    [
      "all",
      "це́лый"
    ],
    [
      "have",
      "иметь"
    ],
    [
      "new",
      "новый"
    ],
    [
      "more",
      "ещё"
    ],
    [
      "will",
      "воля"
    ],
    [
      "home",
      "до́ма"
    ],
    [
      "can",
      "жбан"
    ],
    [
      "us",
      "нас"
    ],
    [
      "about",
      "о"
    ],
    [
      "if",
      "е́сли"
    ],
    [
      "page",
      "паж"
    ],
    [
      "my",
      "моё"
    ],
    [
      "search",
      "искать"
    ],
    [
      "free",
      "свободный"
    ],
    [
      "but",
      "то́лько"
    ],
    [
      "one",
      "оди́н"
    ],
    [
      "other",
      "ино́й"
    ],
    [
      "do",
      "де́лать"
    ],
    [
      "no",
      "не"
    ],
    [
      "information",
      "инфа́"
    ],
    [
      "time",
      "вре́мя"
    ],
    [
      "they",
      "они"
    ],
    [
      "site",
      "сайт"
    ],
    [
      "up",
      "вы́ше"
    ],
    [
      "may",
      "да"
    ],
    [
      "what",
      "что"
    ],
    [
      "which",
      "кото́рый"
    ],
    [
      "news",
      "но́вости"
    ],
    [
      "out",
      "из"
    ],
    [
      "use",
      "употреби́ть"
    ],
    [
      "any",
      "любо́й"
    ],
    [
      "there",
      "там"
    ],
    [
      "see",
      "видеть"
    ],
    [
      "only",
      "но"
    ],
    [
      "so",
      "так"
    ],
    [
      "his",
      "его"
    ],
    [
      "when",
      "когда"
    ],
    [
      "contact",
      "конта́кт"
    ],
    [
      "here",
      "тут"
    ],
    [
      "business",
      "де́ло"
    ],
    [
      "who",
      "что"
    ],
    [
      "web",
      "сеть"
    ],
    [
      "also",
      "та́кже"
    ],
    [
      "now",
      "ну"
    ],
    [
      "help",
      "помо́щник"
    ],
    [
      "get",
      "добра́ться"
    ],
    [
      "view",
      "вид"
    ],
    [
      "online",
      "онла́йн"
    ],
    [
      "c",
      "Си"
    ],
    [
      "e",
      "и"
    ],
    [
      "first",
      "первый"
    ],
    [
      "how",
      "как"
    ],
    [
      "me",
      "мне"
    ],
    [
      "some",
      "немно́го"
    ],
    [
      "these",
      "эти"
    ],
    [
      "click",
      "кли́кать"
    ],
    [
      "its",
      "его́"
    ],
    [
      "like",
      "лойс"
    ],
    [
      "service",
      "слу́жба"
    ],
    [
      "x",
      "икс"
    ],
    [
      "than",
      "не́же"
    ],
    [
      "find",
      "найти́"
    ],
    [
      "price",
      "цена"
    ],
    [
      "date",
      "дата"
    ],
    [
      "back",
      "зад"
    ],
    [
      "top",
      "верх"
    ],
    [
      "people",
      "люд"
    ],
    [
      "list",
      "список"
    ],
    [
      "name",
      "назна́чить"
    ],
    [
      "just",
      "то́лько"
    ],
    [
      "over",
      "за"
    ],
    [
      "state",
      "штат"
    ],
    [
      "year",
      "год"
    ],
    [
      "day",
      "день"
    ],
    [
      "into",
      "в"
    ],
    [
      "email",
      "име́йл"
    ],
    [
      "two",
      "два"
    ],
    [
      "health",
      "здоровье"
    ],
    [
      "n",
      "сущ."
    ],
    [
      "world",
      "свет"
    ],
    [
      "next",
      "во́зле"
    ],
    [
      "used",
      "б/у"
    ],
    [
      "go",
      "встреча́ться"
    ],
    [
      "work",
      "труд"
    ],
    [
      "last",
      "после́дний"
    ],
    [
      "most",
      "са́мый"
    ],
    [
      "music",
      "му́зыка"
    ],
    [
      "buy",
      "ве́рить"
    ],
    [
      "data",
      "данные"
    ],
    [
      "make",
      "заста́вить"
    ],
    [
      "them",
      "их"
    ],
    [
      "should",
      "е́сли"
    ],
    [
      "product",
      "проду́кт"
    ],
    [
      "system",
      "система"
    ],
    [
      "post",
      "пост"
    ],
    [
      "her",
      "ей"
    ],
    [
      "city",
      "град"
    ],
    [
      "add",
      "доба́вить"
    ],
    [
      "policy",
      "ли́ния"
    ],
    [
      "number",
      "число"
    ],
    [
      "such",
      "тако́й"
    ],
    [
      "please",
      "плиз"
    ],
    [
      "available",
      "наличие"
    ],
    [
      "copyright",
      "авторское право"
    ],
    [
      "support",
      "поддержка"
    ],
    [
      "message",
      "ме́сседж"
    ],
    [
      "after",
      "за"
    ],
    [
      "best",
      "лу́чший"
    ],
    [
      "software",
      "софт"
    ],
    [
      "then",
      "зате́м"
    ],
    [
      "good",
      "хоро́ший"
    ],
    [
      "video",
      "клип"
    ],
    [
      "well",
      "хорошо"
    ],
    [
      "where",
      "где"
    ],
    [
      "public",
      "обще́ственный"
    ],
    [
      "high",
      "кайф"
    ],
    [
      "school",
      "шко́ла"
    ],
    [
      "through",
      "сквозь"
    ],
    [
      "m",
      "млн"
    ],
    [
      "each",
      "каждый"
    ],
    [
      "she",
      "она"
    ],
    [
      "review",
      "реви́зия"
    ],
    [
      "order",
      "порядок"
    ],
    [
      "very",
      "дю́же"
    ],
    [
      "privacy",
      "пра́йвеси"
    ],
    [
      "book",
      "кни́га"
    ],
    [
      "company",
      "компа́ния"
    ],
    [
      "read",
      "чита́ть"
    ],
    [
      "group",
      "группа"
    ],
    [
      "sex",
      "секс"
    ],
    [
      "need",
      "потре́ба"
    ],
    [
      "many",
      "мно́го"
    ],
    [
      "user",
      "клие́нт"
    ],
    [
      "said",
      "упомя́нутый"
    ],
    [
      "set",
      "набо́р"
    ],
    [
      "under",
      "под"
    ],
    [
      "general",
      "о́бщий"
    ],
    [
      "research",
      "иссле́довать"
    ],
    [
      "university",
      "университе́т"
    ],
    [
      "january",
      "янва́рь"
    ],
    [
      "mail",
      "по́чта"
    ],
    [
      "full",
      "по́лный"
    ],
    [
      "map",
      "план"
    ],
    [
      "program",
      "програ́мма"
    ],
    [
      "life",
      "житие́"
    ],
    [
      "know",
      "знать"
    ],
    [
      "way",
      "путь"
    ],
    [
      "management",
      "ме́неджмент"
    ],
    [
      "part",
      "расста́ться"
    ],
    [
      "great",
      "вели́кий"
    ],
    [
      "united",
      "о́бщий"
    ],
    [
      "hotel",
      "отель"
    ],
    [
      "real",
      "реа́л"
    ],
    [
      "item",
      "пара"
    ],
    [
      "international",
      "международный"
    ],
    [
      "center",
      "центр"
    ],
    [
      "ebay",
      "ибэ́й"
    ],
    [
      "must",
      "должна́"
    ],
    [
      "store",
      "храни́ть"
    ],
    [
      "travel",
      "путеше́ствие"
    ],
    [
      "development",
      "развитие"
    ],
    [
      "report",
      "сообща́ть"
    ],
    [
      "off",
      "с"
    ],
    [
      "member",
      "член"
    ],
    [
      "line",
      "ли́ния"
    ],
    [
      "before",
      "пе́ред"
    ],
    [
      "send",
      "слать"
    ],
    [
      "right",
      "пра́вый"
    ],
    [
      "type",
      "обра́зчик"
    ],
    [
      "because",
      "потому́ что"
    ],
    [
      "local",
      "лока́льный"
    ],
    [
      "office",
      "бюро́"
    ],
    [
      "education",
      "обуче́ние"
    ],
    [
      "national",
      "наро́дный"
    ],
    [
      "car",
      "та́чка"
    ],
    [
      "design",
      "диза́йн"
    ],
    [
      "take",
      "взять"
    ],
    [
      "internet",
      "сеть"
    ],
    [
      "address",
      "адрес"
    ],
    [
      "community",
      "комму́на"
    ],
    [
      "area",
      "край"
    ],
    [
      "want",
      "нужда́"
    ],
    [
      "phone",
      "фоне́ма"
    ],
    [
      "dvd",
      "двд"
    ],
    [
      "shipping",
      "отпра́вка"
    ],
    [
      "reserved",
      "скры́тный"
    ],
    [
      "subject",
      "те́ма"
    ],
    [
      "between",
      "ме́жду"
    ],
    [
      "forum",
      "форум"
    ],
    [
      "family",
      "семья"
    ],
    [
      "long",
      "длинный"
    ],
    [
      "code",
      "код"
    ],
    [
      "show",
      "показа́ть"
    ],
    [
      "o",
      "о́у"
    ],
    [
      "even",
      "да́же"
    ],
    [
      "black",
      "чёрный"
    ],
    [
      "check",
      "шах"
    ],
    [
      "special",
      "видово́й"
    ],
    [
      "website",
      "веб-са́йт"
    ],
    [
      "index",
      "и́ндекс"
    ],
    [
      "being",
      "тварь"
    ],
    [
      "much",
      "о́чень"
    ],
    [
      "sign",
      "знак"
    ],
    [
      "file",
      "[[подава́ть]] [[заявле́ние]]"
    ],
    [
      "link",
      "звено́"
    ],
    [
      "open",
      "откры́ть"
    ],
    [
      "today",
      "сего́дня"
    ],
    [
      "technology",
      "технология"
    ],
    [
      "south",
      "юг"
    ],
    [
      "case",
      "кейс"
    ],
    [
      "project",
      "проект"
    ],
    [
      "same",
      "то́т же"
    ],
    [
      "version",
      "ве́рсия"
    ],
    [
      "section",
      "разде́л"
    ],
    [
      "own",
      "име́ть"
    ],
    [
      "found",
      "основа́ть"
    ],
    [
      "house",
      "дом"
    ],
    [
      "related",
      "ро́дственный"
    ],
    [
      "security",
      "гара́нтия"
    ],
    [
      "both",
      "оба"
    ],
    [
      "county",
      "уе́зд"
    ],
    [
      "american",
      "американец"
    ],
    [
      "game",
      "дичь"
    ],
    [
      "power",
      "си́ла"
    ],
    [
      "while",
      "хотя́"
    ],
    [
      "care",
      "ухо́д"
    ],
    [
      "network",
      "сеть"
    ],
    [
      "down",
      "вниз"
    ],
    [
      "computer",
      "ЭВМ"
    ],
    [
      "three",
      "тро́йка"
    ],
    [
      "total",
      "су́мма"
    ],
    [
      "place",
      "ме́сто"
    ],
    [
      "end",
      "конец"
    ],
    [
      "following",
      "попу́тный"
    ],
    [
      "download",
      "ска́чка"
    ],
    [
      "him",
      "ему́"
    ],
    [
      "per",
      "по"
    ],
    [
      "access",
      "подхо́д"
    ],
    [
      "think",
      "ду́мать"
    ],
    [
      "north",
      "север"
    ],
    [
      "current",
      "теку́щий"
    ],
    [
      "big",
      "большо́й"
    ],
    [
      "media",
      "СМИ"
    ],
    [
      "law",
      "закон"
    ],
    [
      "control",
      "контро́ль"
    ],
    [
      "water",
      "вода"
    ],
    [
      "history",
      "история"
    ],
    [
      "size",
      "разме́р"
    ],
    [
      "art",
      "искусство"
    ],
    [
      "personal",
      "личный"
    ],
    [
      "since",
      "поско́льку"
    ],
    [
      "including",
      "в том числе́"
    ],
    [
      "guide",
      "знак"
    ],
    [
      "shop",
      "цех"
    ],
    [
      "directory",
      "па́пка"
    ],
    [
      "board",
      "борт"
    ],
    [
      "location",
      "пози́ция"
    ],
    [
      "change",
      "замени́ть"
    ],
    [
      "white",
      "бе́лый"
    ],
    [
      "text",
      "СМС"
    ],
    [
      "small",
      "ма́лый"
    ],
    [
      "rate",
      "ста́вка"
    ],
    [
      "government",
      "правительство"
    ],
    [
      "during",
      "при"
    ],
    [
      "return",
      "возвра́т"
    ],
    [
      "shopping",
      "поку́пки"
    ],
    [
      "account",
      "счёт"
    ],
    [
      "level",
      "у́ровень"
    ],
    [
      "digital",
      "цифровой"
    ],
    [
      "profile",
      "профиль"
    ],
    [
      "previous",
      "про́шлый"
    ],
    [
      "form",
      "фо́рма"
    ],
    [
      "love",
      "люби́ть"
    ],
    [
      "old",
      "ста́рый"
    ],
    [
      "john",
      "Иван"
    ],
    [
      "main",
      "основно́й"
    ],
    [
      "call",
      "крик"
    ],
    [
      "image",
      "о́браз"
    ],
    [
      "department",
      "отде́л"
    ],
    [
      "title",
      "ти́тул"
    ],
    [
      "description",
      "описание"
    ],
    [
      "y",
      "ек"
    ],
    [
      "insurance",
      "страховка"
    ],
    [
      "another",
      "друго́й"
    ],
    [
      "why",
      "о"
    ],
    [
      "shall",
      "должна́"
    ],
    [
      "property",
      "сво́йство"
    ],
    [
      "class",
      "класс"
    ],
    [
      "still",
      "ещё"
    ],
    [
      "money",
      "деньги"
    ],
    [
      "quality",
      "качество"
    ],
    [
      "every",
      "вся́кий"
    ],
    [
      "content",
      "содержание"
    ],
    [
      "country",
      "земля́"
    ],
    [
      "private",
      "ча́стный"
    ],
    [
      "little",
      "ма́лый"
    ],
    [
      "visit",
      "визи́т"
    ],
    [
      "save",
      "эконо́мить"
    ],
    [
      "low",
      "ни́зкий"
    ],
    [
      "reply",
      "отвеча́ть"
    ],
    [
      "customer",
      "клие́нт"
    ],
    [
      "december",
      "дека́брь"
    ],
    [
      "compare",
      "сравнить"
    ],
    [
      "include",
      "включи́ть"
    ],
    [
      "college",
      "ко́лледж"
    ],
    [
      "value",
      "цени́ть"
    ],
    [
      "article",
      "член"
    ],
    [
      "man",
      "чёрт"
    ],
    [
      "card",
      "план"
    ],
    [
      "provide",
      "обеспе́чить"
    ],
    [
      "food",
      "еда́"
    ],
    [
      "source",
      "исто́чник"
    ],
    [
      "author",
      "творе́ц"
    ],
    [
      "different",
      "ино́й"
    ],
    [
      "press",
      "жать"
    ],
    [
      "u",
      "ю"
    ],
    [
      "learn",
      "учи́ть"
    ],
    [
      "sale",
      "сейл"
    ],
    [
      "around",
      "вокру́г"
    ],
    [
      "print",
      "шрифт"
    ],
    [
      "course",
      "курс"
    ],
    [
      "job",
      "рабо́та"
    ],
    [
      "canada",
      "Кана́да"
    ],
    [
      "process",
      "ход"
    ],
    [
      "teen",
      "го́ре"
    ],
    [
      "room",
      "ме́сто"
    ],
    [
      "stock",
      "инвента́рь"
    ],
    [
      "training",
      "обуче́ние"
    ],
    [
      "too",
      "то́же"
    ],
    [
      "credit",
      "креди́т"
    ],
    [
      "point",
      "пункт"
    ],
    [
      "join",
      "вступа́ть"
    ],
    [
      "science",
      "наука"
    ],
    [
      "advanced",
      "продви́нутый"
    ],
    [
      "west",
      "За́пад"
    ],
    [
      "look",
      "вид"
    ],
    [
      "english",
      "английский"
    ],
    [
      "left",
      "левый"
    ],
    [
      "team",
      "арте́ль"
    ],
    [
      "estate",
      "уса́дьба"
    ],
    [
      "box",
      "я́щик"
    ],
    [
      "windows",
      "Виндоус"
    ],
    [
      "gay",
      "голубо́й"
    ],
    [
      "thread",
      "нить"
    ],
    [
      "week",
      "неде́ля"
    ],
    [
      "category",
      "категория"
    ],
    [
      "note",
      "но́та"
    ],
    [
      "live",
      "жить"
    ],
    [
      "large",
      "кру́пный"
    ],
    [
      "gallery",
      "галерея"
    ],
    [
      "table",
      "табли́ца"
    ],
    [
      "register",
      "реги́стр"
    ],
    [
      "however",
      "тем не ме́нее"
    ],
    [
      "june",
      "ию́нь"
    ],
    [
      "october",
      "октя́брь"
    ],
    [
      "november",
      "ноя́брь"
    ],
    [
      "market",
      "ры́нок"
    ],
    [
      "library",
      "библиотека"
    ],
    [
      "really",
      "действительно"
    ],
    [
      "action",
      "акт"
    ],
    [
      "start",
      "старт"
    ],
    [
      "series",
      "се́рия"
    ],
    [
      "model",
      "моде́ль"
    ],
    [
      "air",
      "во́здух"
    ],
    [
      "industry",
      "индустри́я"
    ],
    [
      "plan",
      "план"
    ],
    [
      "human",
      "лю́ди"
    ],
    [
      "yes",
      "так"
    ],
    [
      "second",
      "секунда"
    ],
    [
      "hot",
      "горячий"
    ],
    [
      "cost",
      "цена́"
    ],
    [
      "movie",
      "карти́на"
    ],
    [
      "march",
      "ход"
    ],
    [
      "september",
      "сентя́брь"
    ],
    [
      "better",
      "лучше"
    ],
    [
      "say",
      "сказа́ть"
    ],
    [
      "july",
      "ию́ль"
    ],
    [
      "medical",
      "медицинский"
    ],
    [
      "test",
      "тест"
    ],
    [
      "friend",
      "подру́га"
    ],
    [
      "come",
      "оказа́ться"
    ],
    [
      "server",
      "сервер"
    ],
    [
      "study",
      "изуча́ть"
    ],
    [
      "application",
      "примене́ние"
    ],
    [
      "cart",
      "арба́"
    ],
    [
      "staff",
      "кадр"
    ],
    [
      "feedback",
      "фидбэ́к"
    ],
    [
      "again",
      "опять"
    ],
    [
      "play",
      "играть"
    ],
    [
      "april",
      "апре́ль"
    ],
    [
      "never",
      "никогда"
    ],
    [
      "complete",
      "су́щий"
    ],
    [
      "street",
      "у́лица"
    ],
    [
      "topic",
      "те́ма"
    ],
    [
      "comment",
      "комментарий"
    ],
    [
      "financial",
      "финансовый"
    ],
    [
      "working",
      "работоспособный"
    ],
    [
      "against",
      "про́тив"
    ],
    [
      "standard",
      "станда́рт"
    ],
    [
      "tax",
      "сбор"
    ],
    [
      "person",
      "лицо"
    ],
    [
      "below",
      "ни́же"
    ],
    [
      "mobile",
      "подвижной"
    ],
    [
      "less",
      "ме́ньше"
    ],
    [
      "party",
      "гру́ппа"
    ],
    [
      "payment",
      "пла́та"
    ],
    [
      "equipment",
      "снаряже́ние"
    ],
    [
      "login",
      "вход"
    ],
    [
      "student",
      "студе́нтка"
    ],
    [
      "let",
      "пусть"
    ],
    [
      "legal",
      "зако́нный"
    ],
    [
      "above",
      "вы́ше"
    ],
    [
      "park",
      "паркова́ться"
    ],
    [
      "side",
      "сторона́"
    ],
    [
      "act",
      "акт"
    ],
    [
      "problem",
      "зада́ча"
    ],
    [
      "red",
      "красный"
    ],
    [
      "give",
      "дава́ть"
    ],
    [
      "memory",
      "память"
    ],
    [
      "performance",
      "де́йствие"
    ],
    [
      "social",
      "социальный"
    ],
    [
      "august",
      "а́вгуст"
    ],
    [
      "quote",
      "котиро́вка"
    ],
    [
      "language",
      "язык"
    ],
    [
      "story",
      "исто́рия"
    ],
    [
      "sell",
      "прода́ть"
    ],
    [
      "experience",
      "опыт"
    ],
    [
      "create",
      "созда́ть"
    ],
    [
      "key",
      "ключ"
    ],
    [
      "body",
      "тело"
    ],
    [
      "young",
      "ю́ный"
    ],
    [
      "important",
      "важный"
    ],
    [
      "field",
      "поле"
    ],
    [
      "few",
      "немно́гий"
    ],
    [
      "east",
      "ост"
    ],
    [
      "paper",
      "бума́га"
    ],
    [
      "single",
      "оди́н"
    ],
    [
      "age",
      "век"
    ],
    [
      "club",
      "клуб"
    ],
    [
      "example",
      "пример"
    ],
    [
      "password",
      "пароль"
    ],
    [
      "something",
      "не́что"
    ],
    [
      "road",
      "путь"
    ],
    [
      "gift",
      "пода́рок"
    ],
    [
      "question",
      "вопрос"
    ],
    [
      "night",
      "ночь"
    ],
    [
      "hard",
      "твёрдый"
    ],
    [
      "texas",
      "Техас"
    ],
    [
      "pay",
      "удели́ть"
    ],
    [
      "four",
      "четыре"
    ],
    [
      "poker",
      "покер"
    ],
    [
      "status",
      "состоя́ние"
    ],
    [
      "browse",
      "пасти́сь"
    ],
    [
      "issue",
      "пункт"
    ],
    [
      "range",
      "полиго́н"
    ],
    [
      "building",
      "дом"
    ],
    [
      "seller",
      "ве́ндор"
    ],
    [
      "court",
      "суд"
    ],
    [
      "february",
      "февра́ль"
    ],
    [
      "always",
      "ве́чно"
    ],
    [
      "result",
      "плод"
    ],
    [
      "audio",
      "звуково́й"
    ],
    [
      "light",
      "свет"
    ],
    [
      "write",
      "писать"
    ],
    [
      "war",
      "война́"
    ],
    [
      "offer",
      "предложи́ть"
    ],
    [
      "blue",
      "синий"
    ],
    [
      "easy",
      "лёгкий"
    ],
    [
      "given",
      "да́нный"
    ],
    [
      "event",
      "собы́тие"
    ],
    [
      "release",
      "рели́з"
    ],
    [
      "analysis",
      "анализ"
    ],
    [
      "request",
      "проси́ть"
    ],
    [
      "fax",
      "телефа́кс"
    ],
    [
      "china",
      "Кита́й"
    ],
    [
      "picture",
      "карти́на"
    ],
    [
      "possible",
      "возможный"
    ],
    [
      "might",
      "си́ла"
    ],
    [
      "professional",
      "профессиона́лка"
    ],
    [
      "yet",
      "ещё"
    ],
    [
      "month",
      "ме́сяц"
    ],
    [
      "major",
      "майор"
    ],
    [
      "star",
      "звезда"
    ],
    [
      "future",
      "будущее"
    ],
    [
      "space",
      "простра́нство"
    ],
    [
      "committee",
      "комитет"
    ],
    [
      "hand",
      "рука"
    ],
    [
      "sun",
      "со́лнце"
    ],
    [
      "london",
      "Ло́ндон"
    ],
    [
      "washington",
      "Вашингтон"
    ],
    [
      "meeting",
      "встре́ча"
    ],
    [
      "become",
      "идти́"
    ],
    [
      "interest",
      "интере́с"
    ],
    [
      "id",
      "ид"
    ],
    [
      "child",
      "дитя́"
    ],
    [
      "keep",
      "держа́ть"
    ],
    [
      "enter",
      "войти́"
    ],
    [
      "california",
      "Калифорния"
    ],
    [
      "porn",
      "порну́ха"
    ],
    [
      "share",
      "дели́ться"
    ],
    [
      "similar",
      "схо́жий"
    ],
    [
      "garden",
      "сад"
    ],
    [
      "million",
      "миллион"
    ],
    [
      "reference",
      "ссы́лка"
    ],
    [
      "baby",
      "бе́би"
    ],
    [
      "learning",
      "уче́ние"
    ],
    [
      "energy",
      "энергия"
    ],
    [
      "run",
      "бег"
    ],
    [
      "delivery",
      "ро́ды"
    ],
    [
      "net",
      "сеть"
    ],
    [
      "popular",
      "популярный"
    ],
    [
      "term",
      "срок"
    ],
    [
      "film",
      "снять"
    ],
    [
      "put",
      "ста́вить"
    ],
    [
      "journal",
      "журна́л"
    ],
    [
      "try",
      "про́бовать"
    ],
    [
      "welcome",
      "добро пожаловать"
    ],
    [
      "central",
      "центральный"
    ],
    [
      "president",
      "президент"
    ],
    [
      "notice",
      "уведомле́ние"
    ],
    [
      "god",
      "бог"
    ],
    [
      "original",
      "све́жий"
    ],
    [
      "head",
      "голова"
    ],
    [
      "radio",
      "радио"
    ],
    [
      "until",
      "до"
    ],
    [
      "cell",
      "клетка"
    ],
    [
      "color",
      "цвет"
    ],
    [
      "self",
      "себе́"
    ],
    [
      "council",
      "совет"
    ],
    [
      "away",
      "вон"
    ],
    [
      "track",
      "трек"
    ],
    [
      "australia",
      "Австралия"
    ],
    [
      "discussion",
      "обсужде́ние"
    ],
    [
      "archive",
      "архив"
    ],
    [
      "once",
      "ра́нее"
    ],
    [
      "others",
      "други́е"
    ],
    [
      "entertainment",
      "уте́ха"
    ],
    [
      "agreement",
      "до́говор"
    ],
    [
      "format",
      "форма́т"
    ],
    [
      "society",
      "общество"
    ],
    [
      "log",
      "коло́да"
    ],
    [
      "safety",
      "сохра́нность"
    ],
    [
      "sure",
      "ве́рный"
    ],
    [
      "faq",
      "ЧаВо́"
    ],
    [
      "trade",
      "торго́вля"
    ],
    [
      "edition",
      "тира́ж"
    ],
    [
      "marketing",
      "маркетинг"
    ],
    [
      "tell",
      "сказа́ть"
    ],
    [
      "further",
      "да́лее"
    ],
    [
      "association",
      "соедине́ние"
    ],
    [
      "able",
      "спосо́бный"
    ],
    [
      "david",
      "Давид"
    ],
    [
      "fun",
      "заба́ва"
    ],
    [
      "already",
      "уже"
    ],
    [
      "green",
      "зелёный"
    ],
    [
      "studies",
      "иссле́дование"
    ],
    [
      "close",
      "закрыва́ть"
    ],
    [
      "common",
      "обы́чный"
    ],
    [
      "drive",
      "драйв"
    ],
    [
      "specific",
      "удельный"
    ],
    [
      "several",
      "не́сколько"
    ],
    [
      "gold",
      "золото́й"
    ],
    [
      "living",
      "жить"
    ],
    [
      "collection",
      "колле́кция"
    ],
    [
      "short",
      "ни́зкий"
    ],
    [
      "lot",
      "жре́бий"
    ],
    [
      "ask",
      "зада́ть"
    ],
    [
      "display",
      "шо́у"
    ],
    [
      "limited",
      "ограниченный"
    ],
    [
      "means",
      "сре́дства"
    ],
    [
      "director",
      "дирижёр"
    ],
    [
      "daily",
      "подёнщица"
    ],
    [
      "beach",
      "взмо́рье"
    ],
    [
      "past",
      "прошлое"
    ],
    [
      "natural",
      "есте́ственный"
    ],
    [
      "whether",
      "ли"
    ],
    [
      "due",
      "ожида́емый"
    ],
    [
      "electronics",
      "электроника"
    ],
    [
      "five",
      "пять"
    ],
    [
      "upon",
      "в"
    ],
    [
      "period",
      "пери́од"
    ],
    [
      "database",
      "база данных"
    ],
    [
      "official",
      "официа́льный"
    ],
    [
      "weather",
      "погода"
    ],
    [
      "mar",
      "по́ртить"
    ],
    [
      "land",
      "земля́"
    ],
    [
      "average",
      "обы́чный"
    ],
    [
      "done",
      "гото́вый"
    ],
    [
      "technical",
      "тача́нка"
    ],
    [
      "window",
      "окно́"
    ],
    [
      "france",
      "Франс"
    ],
    [
      "pro",
      "про́фи"
    ],
    [
      "region",
      "край"
    ],
    [
      "island",
      "остров"
    ],
    [
      "record",
      "диск"
    ],
    [
      "direct",
      "наце́лить"
    ],
    [
      "microsoft",
      "Майкросо́фт"
    ],
    [
      "conference",
      "съезд"
    ],
    [
      "environment",
      "среда́"
    ],
    [
      "st",
      "св."
    ],
    [
      "district",
      "райо́н"
    ],
    [
      "calendar",
      "реги́стр"
    ],
    [
      "style",
      "слог"
    ],
    [
      "front",
      "фронт"
    ],
    [
      "statement",
      "отчёт"
    ],
    [
      "update",
      "апде́йт"
    ],
    [
      "ever",
      "когда́-либо"
    ],
    [
      "early",
      "рано"
    ],
    [
      "sound",
      "звуча́ть"
    ],
    [
      "resource",
      "ресу́рс"
    ],
    [
      "present",
      "дари́ть"
    ],
    [
      "either",
      "любо́й"
    ],
    [
      "ago",
      "тому́ наза́д"
    ],
    [
      "document",
      "документ"
    ],
    [
      "word",
      "сло́во"
    ],
    [
      "material",
      "материал"
    ],
    [
      "bill",
      "счёт"
    ],
    [
      "written",
      "письменный"
    ],
    [
      "talk",
      "разгово́р"
    ],
    [
      "federal",
      "федеральный"
    ],
    [
      "final",
      "фина́ль"
    ],
    [
      "adult",
      "взрослый"
    ],
    [
      "thing",
      "не́что"
    ],
    [
      "via",
      "че́рез"
    ],
    [
      "cheap",
      "дешёвый"
    ],
    [
      "nude",
      "го́лый"
    ],
    [
      "finance",
      "финансы"
    ],
    [
      "true",
      "и́стинный"
    ],
    [
      "mark",
      "отме́тка"
    ],
    [
      "third",
      "третий"
    ],
    [
      "rock",
      "скала"
    ],
    [
      "europe",
      "Евро́па"
    ],
    [
      "reading",
      "чте́ние"
    ],
    [
      "bad",
      "злой"
    ],
    [
      "individual",
      "ча́стный"
    ],
    [
      "plus",
      "положи́тельный"
    ],
    [
      "cover",
      "укры́тие"
    ],
    [
      "edit",
      "пра́вить"
    ],
    [
      "together",
      "вместе"
    ],
    [
      "percent",
      "процент"
    ],
    [
      "fast",
      "про́чный"
    ],
    [
      "function",
      "функция"
    ],
    [
      "unit",
      "едини́ца"
    ],
    [
      "global",
      "глоба́льный"
    ],
    [
      "meet",
      "встре́тить"
    ],
    [
      "far",
      "далеко"
    ],
    [
      "economic",
      "экономический"
    ],
    [
      "player",
      "игро́к"
    ],
    [
      "lyrics",
      "слова́"
    ],
    [
      "often",
      "часто"
    ],
    [
      "subscribe",
      "подписа́ть"
    ],
    [
      "submit",
      "пода́ть"
    ],
    [
      "germany",
      "Герма́ния"
    ],
    [
      "amount",
      "су́мма"
    ],
    [
      "watch",
      "карау́л"
    ],
    [
      "feel",
      "чу́вствовать"
    ],
    [
      "though",
      "хотя́"
    ],
    [
      "bank",
      "банк"
    ],
    [
      "risk",
      "опа́сность"
    ],
    [
      "thanks",
      "спасибо"
    ],
    [
      "various",
      "разли́чный"
    ],
    [
      "words",
      "слова"
    ],
    [
      "linux",
      "Линукс"
    ],
    [
      "production",
      "добы́ча"
    ],
    [
      "commercial",
      "реклама"
    ],
    [
      "james",
      "Я́ков"
    ],
    [
      "weight",
      "вес"
    ],
    [
      "town",
      "го́род"
    ],
    [
      "heart",
      "се́рдце"
    ],
    [
      "choose",
      "взять"
    ],
    [
      "treatment",
      "лече́ние"
    ],
    [
      "newsletter",
      "ве́стник"
    ],
    [
      "knowledge",
      "знание"
    ],
    [
      "magazine",
      "журнал"
    ],
    [
      "error",
      "ошибка"
    ],
    [
      "camera",
      "фотоаппарат"
    ],
    [
      "girl",
      "де́вушка"
    ],
    [
      "currently",
      "сейча́с"
    ],
    [
      "construction",
      "строе́ние"
    ],
    [
      "registered",
      "заказно́й"
    ],
    [
      "clear",
      "я́сный"
    ],
    [
      "receive",
      "получи́ть"
    ],
    [
      "domain",
      "доме́н"
    ],
    [
      "chapter",
      "филиа́л"
    ],
    [
      "protection",
      "охра́на"
    ],
    [
      "loan",
      "заём"
    ],
    [
      "wide",
      "широкий"
    ],
    [
      "beauty",
      "красота"
    ],
    [
      "manager",
      "ме́неджер"
    ],
    [
      "india",
      "И́ндия"
    ],
    [
      "position",
      "положе́ние"
    ],
    [
      "sort",
      "тип"
    ],
    [
      "michael",
      "Майкл"
    ],
    [
      "half",
      "половина"
    ],
    [
      "step",
      "шага́ть"
    ],
    [
      "engineering",
      "инжини́ринг"
    ],
    [
      "florida",
      "Флори́да"
    ],
    [
      "simple",
      "лёгкий"
    ],
    [
      "quick",
      "жи́во"
    ],
    [
      "none",
      "никто́"
    ],
    [
      "wireless",
      "радио"
    ],
    [
      "license",
      "лице́нзия"
    ],
    [
      "paul",
      "Павел"
    ],
    [
      "friday",
      "пя́тница"
    ],
    [
      "lake",
      "озеро"
    ],
    [
      "whole",
      "це́льный"
    ],
    [
      "annual",
      "годово́й"
    ],
    [
      "later",
      "по́зже"
    ],
    [
      "basic",
      "элемента́рный"
    ],
    [
      "corporate",
      "о́бщий"
    ],
    [
      "google",
      "Гугль"
    ],
    [
      "church",
      "це́рковь"
    ],
    [
      "method",
      "приём"
    ],
    [
      "purchase",
      "приобрете́ние"
    ],
    [
      "active",
      "акти́вный"
    ],
    [
      "response",
      "о́тзвук"
    ],
    [
      "practice",
      "практика"
    ],
    [
      "hardware",
      "хардве́р"
    ],
    [
      "figure",
      "фигу́ра"
    ],
    [
      "fire",
      "ого́нь"
    ],
    [
      "holiday",
      "пра́здник"
    ],
    [
      "chat",
      "разгово́р"
    ],
    [
      "enough",
      "доста́точно"
    ],
    [
      "along",
      "по"
    ],
    [
      "among",
      "средь"
    ],
    [
      "death",
      "смерть"
    ],
    [
      "writing",
      "писа́ние"
    ],
    [
      "speed",
      "нести́сь"
    ],
    [
      "html",
      "аш-тэ-эм-э́ль"
    ],
    [
      "loss",
      "поте́ря"
    ],
    [
      "face",
      "лик"
    ],
    [
      "brand",
      "ма́рка"
    ],
    [
      "discount",
      "скидка"
    ],
    [
      "remember",
      "не [[забы́ть]]"
    ],
    [
      "oil",
      "масло"
    ],
    [
      "bit",
      "бит"
    ],
    [
      "yellow",
      "пожелте́ть"
    ],
    [
      "political",
      "политический"
    ],
    [
      "increase",
      "приро́ст"
    ],
    [
      "advertise",
      "реклами́ровать"
    ],
    [
      "kingdom",
      "ца́рство"
    ],
    [
      "base",
      "ба́за"
    ],
    [
      "near",
      "у"
    ],
    [
      "environmental",
      "экологи́ческий"
    ],
    [
      "thought",
      "ду́ма"
    ],
    [
      "stuff",
      "наби́ть"
    ],
    [
      "french",
      "французский"
    ],
    [
      "storage",
      "ЗУ"
    ],
    [
      "oh",
      "а"
    ],
    [
      "japan",
      "Япония"
    ],
    [
      "doing",
      "де́ло"
    ],
    [
      "entry",
      "за́пись"
    ],
    [
      "stay",
      "оста́ться"
    ],
    [
      "nature",
      "природа"
    ],
    [
      "africa",
      "А́фрика"
    ],
    [
      "summary",
      "резюме́"
    ],
    [
      "turn",
      "ход"
    ],
    [
      "mean",
      "зна́чить"
    ],
    [
      "growth",
      "рост"
    ],
    [
      "agency",
      "аге́нтство"
    ],
    [
      "king",
      "коро́ль"
    ],
    [
      "monday",
      "понедельник"
    ],
    [
      "european",
      "европеец"
    ],
    [
      "activity",
      "де́ло"
    ],
    [
      "copy",
      "ко́пия"
    ],
    [
      "although",
      "хотя́"
    ],
    [
      "drug",
      "дурь"
    ],
    [
      "western",
      "вестерн"
    ],
    [
      "income",
      "прихо́д"
    ],
    [
      "force",
      "сила"
    ],
    [
      "cash",
      "кэш"
    ],
    [
      "employment",
      "за́нятость"
    ],
    [
      "overall",
      "о́бщий"
    ],
    [
      "bay",
      "ни́ша"
    ],
    [
      "river",
      "река"
    ],
    [
      "commission",
      "коми́ссия"
    ],
    [
      "ad",
      "на́шей э́ры"
    ],
    [
      "package",
      "паке́т"
    ],
    [
      "contents",
      "содержи́мое"
    ],
    [
      "engine",
      "дви́гатель"
    ],
    [
      "port",
      "[[ле́вый]] борт"
    ],
    [
      "album",
      "альбом"
    ],
    [
      "stop",
      "останови́ться"
    ],
    [
      "administration",
      "примене́ние"
    ],
    [
      "bar",
      "бар"
    ],
    [
      "institute",
      "институ́т"
    ],
    [
      "double",
      "двойно́й"
    ],
    [
      "dog",
      "соба́ка"
    ],
    [
      "build",
      "сборка"
    ],
    [
      "screen",
      "экран"
    ],
    [
      "exchange",
      "обмен"
    ],
    [
      "soon",
      "скоро"
    ],
    [
      "electronic",
      "электронный"
    ],
    [
      "continue",
      "продо́лжить"
    ],
    [
      "across",
      "поперёк"
    ],
    [
      "season",
      "сезон"
    ],
    [
      "apply",
      "заявля́ть"
    ],
    [
      "someone",
      "не́кто"
    ],
    [
      "anything",
      "что́-нибудь"
    ],
    [
      "printer",
      "типо́граф"
    ],
    [
      "condition",
      "усло́вие"
    ],
    [
      "effective",
      "эффективный"
    ],
    [
      "believe",
      "пове́рить"
    ],
    [
      "organization",
      "организация"
    ],
    [
      "effect",
      "эффект"
    ],
    [
      "mind",
      "ра́зум"
    ],
    [
      "sunday",
      "неде́ля"
    ],
    [
      "selection",
      "вы́бор"
    ],
    [
      "casino",
      "казино́"
    ],
    [
      "lost",
      "падший"
    ],
    [
      "tour",
      "тур"
    ],
    [
      "menu",
      "меню"
    ],
    [
      "volume",
      "том"
    ],
    [
      "cross",
      "пересе́чь"
    ],
    [
      "anyone",
      "любо́й"
    ],
    [
      "mortgage",
      "ипотека"
    ],
    [
      "hope",
      "надежда"
    ],
    [
      "silver",
      "серебро"
    ],
    [
      "corporation",
      "корпора́ция"
    ],
    [
      "wish",
      "желать"
    ],
    [
      "inside",
      "внутрь"
    ],
    [
      "solution",
      "раствор"
    ],
    [
      "mature",
      "зре́лый"
    ],
    [
      "role",
      "роль"
    ],
    [
      "rather",
      "скоре́е"
    ],
    [
      "addition",
      "сложе́ние"
    ],
    [
      "supply",
      "снабди́ть"
    ],
    [
      "nothing",
      "ничто"
    ],
    [
      "certain",
      "не́кий"
    ],
    [
      "executive",
      "администра́тор"
    ],
    [
      "running",
      "бег"
    ],
    [
      "lower",
      "сни́зить"
    ],
    [
      "necessary",
      "ну́жный"
    ],
    [
      "union",
      "объедине́ние"
    ],
    [
      "clothing",
      "одежда"
    ],
    [
      "mon",
      "мон"
    ],
    [
      "particular",
      "осо́бый"
    ],
    [
      "fine",
      "то́нкий"
    ],
    [
      "robert",
      "Роберт"
    ],
    [
      "hour",
      "час"
    ],
    [
      "gas",
      "газ"
    ],
    [
      "six",
      "шесть"
    ],
    [
      "bush",
      "волосня́"
    ],
    [
      "advice",
      "изве́стие"
    ],
    [
      "career",
      "карье́р"
    ],
    [
      "military",
      "вое́нный"
    ],
    [
      "decision",
      "решение"
    ],
    [
      "leave",
      "оста́вить"
    ],
    [
      "british",
      "бритт"
    ],
    [
      "huge",
      "огро́мный"
    ],
    [
      "woman",
      "ба́ба"
    ],
    [
      "zip",
      "жи́вость"
    ],
    [
      "bid",
      "ста́вка"
    ],
    [
      "kind",
      "вид"
    ],
    [
      "middle",
      "среди́на"
    ],
    [
      "move",
      "переселе́ние"
    ],
    [
      "cable",
      "трос"
    ],
    [
      "division",
      "отде́л"
    ],
    [
      "coming",
      "прихо́д"
    ],
    [
      "tuesday",
      "вторник"
    ],
    [
      "object",
      "объе́кт"
    ],
    [
      "lesbian",
      "лесба"
    ],
    [
      "appropriate",
      "вы́делить"
    ],
    [
      "machine",
      "маши́на"
    ],
    [
      "logo",
      "логоти́п"
    ],
    [
      "length",
      "длина"
    ],
    [
      "actually",
      "вообще́-то"
    ],
    [
      "nice",
      "Ницца"
    ],
    [
      "score",
      "балл"
    ],
    [
      "client",
      "клие́нт"
    ],
    [
      "ok",
      "оке́й"
    ],
    [
      "capital",
      "большо́й"
    ],
    [
      "follow",
      "следи́ть"
    ],
    [
      "sample",
      "образе́ц"
    ],
    [
      "investment",
      "вклад"
    ],
    [
      "saturday",
      "суббо́та"
    ],
    [
      "christmas",
      "Кри́стмас"
    ],
    [
      "england",
      "А́нглия"
    ],
    [
      "culture",
      "культура"
    ],
    [
      "band",
      "ба́нда"
    ],
    [
      "flash",
      "вспы́хнуть"
    ],
    [
      "ms",
      "госпожа́"
    ],
    [
      "lead",
      "вести́"
    ],
    [
      "george",
      "Его́р"
    ],
    [
      "registration",
      "ресе́пшен"
    ],
    [
      "thursday",
      "четве́рг"
    ],
    [
      "consumer",
      "потребитель"
    ],
    [
      "hi",
      "приве́т"
    ],
    [
      "airport",
      "аэропорт"
    ],
    [
      "foreign",
      "инозе́мный"
    ],
    [
      "artist",
      "арти́ст"
    ],
    [
      "outside",
      "нару́жу"
    ],
    [
      "furniture",
      "мебель"
    ],
    [
      "channel",
      "кана́л"
    ],
    [
      "letter",
      "буква"
    ],
    [
      "mode",
      "мо́да"
    ],
    [
      "wednesday",
      "среда́"
    ],
    [
      "structure",
      "структура"
    ],
    [
      "fund",
      "фонд"
    ],
    [
      "summer",
      "брус"
    ],
    [
      "allow",
      "позво́лить"
    ],
    [
      "degree",
      "градус"
    ],
    [
      "contract",
      "сжать"
    ],
    [
      "button",
      "кнопка"
    ],
    [
      "wed",
      "жени́ться"
    ],
    [
      "super",
      "потря́сный"
    ],
    [
      "male",
      "самец"
    ],
    [
      "matter",
      "де́ло"
    ],
    [
      "custom",
      "сбор"
    ],
    [
      "virginia",
      "Вирджиния"
    ],
    [
      "almost",
      "словно"
    ],
    [
      "multiple",
      "мно́го"
    ],
    [
      "asian",
      "азиат"
    ],
    [
      "distribution",
      "распределе́ние"
    ],
    [
      "editor",
      "реда́ктор"
    ],
    [
      "inn",
      "корчма́"
    ],
    [
      "industrial",
      "промышленный"
    ],
    [
      "cause",
      "де́ло"
    ],
    [
      "potential",
      "потенциа́л"
    ],
    [
      "song",
      "песня"
    ],
    [
      "focus",
      "фокус"
    ],
    [
      "late",
      "поздно"
    ],
    [
      "fall",
      "упа́сть"
    ],
    [
      "idea",
      "иде́я"
    ],
    [
      "female",
      "самка"
    ],
    [
      "win",
      "выи́грывать"
    ],
    [
      "thomas",
      "Фома"
    ],
    [
      "cancer",
      "[[злокачественный|злока́чественная]] [[о́пухоль]]"
    ],
    [
      "numbers",
      "Чи́сла"
    ],
    [
      "reason",
      "причи́на"
    ],
    [
      "tool",
      "сре́дство"
    ],
    [
      "spring",
      "весна́"
    ],
    [
      "foundation",
      "фонд"
    ],
    [
      "answer",
      "отвеча́ть"
    ],
    [
      "voice",
      "голос"
    ],
    [
      "friendly",
      "прия́тельский"
    ],
    [
      "schedule",
      "програ́мма"
    ],
    [
      "communication",
      "сообще́ние"
    ],
    [
      "purpose",
      "цель"
    ],
    [
      "feature",
      "черта́"
    ],
    [
      "bed",
      "посте́ль"
    ],
    [
      "police",
      "полиция"
    ],
    [
      "everyone",
      "вся́кий"
    ],
    [
      "independent",
      "свобо́дный"
    ],
    [
      "approach",
      "подхо́д"
    ],
    [
      "brown",
      "бу́рый"
    ],
    [
      "physical",
      "физи́ческий"
    ],
    [
      "hill",
      "спуск"
    ],
    [
      "medicine",
      "медицина"
    ],
    [
      "deal",
      "раздава́ть"
    ],
    [
      "hold",
      "задержа́ть"
    ],
    [
      "chicago",
      "Чикаго"
    ],
    [
      "glass",
      "стака́н"
    ],
    [
      "happy",
      "счастливый"
    ],
    [
      "smith",
      "Ковалёв"
    ],
    [
      "wanted",
      "ну́жный"
    ],
    [
      "developed",
      "зре́лый"
    ],
    [
      "thank",
      "благодарить"
    ],
    [
      "safe",
      "безопа́сный"
    ],
    [
      "unique",
      "уника́льный"
    ],
    [
      "survey",
      "обсле́довать"
    ],
    [
      "prior",
      "прио́р"
    ],
    [
      "telephone",
      "телефон"
    ],
    [
      "sport",
      "спортсме́н"
    ],
    [
      "ready",
      "готовый"
    ],
    [
      "feed",
      "корми́ть"
    ],
    [
      "animal",
      "скоти́на"
    ],
    [
      "mexico",
      "Ме́ксика"
    ],
    [
      "population",
      "население"
    ],
    [
      "pa",
      "де́душка"
    ],
    [
      "regular",
      "регулярный"
    ],
    [
      "navigation",
      "навигация"
    ],
    [
      "therefore",
      "посему́"
    ],
    [
      "ass",
      "зад"
    ],
    [
      "simply",
      "просто"
    ],
    [
      "evidence",
      "ули́ка"
    ],
    [
      "station",
      "ста́нция"
    ],
    [
      "christian",
      "Христиа́н"
    ],
    [
      "round",
      "круглый"
    ],
    [
      "understand",
      "поня́ть"
    ],
    [
      "option",
      "вы́бор"
    ],
    [
      "master",
      "ма́стер"
    ],
    [
      "valley",
      "дол"
    ],
    [
      "recently",
      "неда́вно"
    ],
    [
      "probably",
      "наве́рно"
    ],
    [
      "sea",
      "мо́ре"
    ],
    [
      "blood",
      "кровь"
    ],
    [
      "cut",
      "кроить"
    ],
    [
      "worldwide",
      "мирово́й"
    ],
    [
      "improve",
      "улу́чшить"
    ],
    [
      "connection",
      "связь"
    ],
    [
      "publisher",
      "изда́тель"
    ],
    [
      "hall",
      "зал"
    ],
    [
      "earth",
      "земля́"
    ],
    [
      "impact",
      "уда́р"
    ],
    [
      "transfer",
      "перехо́д"
    ],
    [
      "introduction",
      "введение"
    ],
    [
      "kitchen",
      "кухня"
    ],
    [
      "strong",
      "сильный"
    ],
    [
      "wedding",
      "свадьба"
    ],
    [
      "hospital",
      "больница"
    ],
    [
      "ground",
      "земля́"
    ],
    [
      "ship",
      "су́дно"
    ],
    [
      "accommodation",
      "жили́ще"
    ],
    [
      "disease",
      "хворь"
    ],
    [
      "excellent",
      "отме́нный"
    ],
    [
      "italy",
      "Ита́лия"
    ],
    [
      "perfect",
      "безупре́чный"
    ],
    [
      "hair",
      "волоси́нка"
    ],
    [
      "opportunity",
      "шанс"
    ],
    [
      "kit",
      "набо́р"
    ],
    [
      "classic",
      "кла́ссика"
    ],
    [
      "basis",
      "ба́зис"
    ],
    [
      "command",
      "кома́нда"
    ],
    [
      "william",
      "Вилья́м"
    ],
    [
      "express",
      "ско́рый"
    ],
    [
      "anal",
      "анальный"
    ],
    [
      "award",
      "приз"
    ],
    [
      "distance",
      "диста́нция"
    ],
    [
      "tree",
      "де́рево"
    ],
    [
      "peter",
      "Пётр"
    ],
    [
      "assessment",
      "оце́нка"
    ],
    [
      "ensure",
      "удостове́риться"
    ],
    [
      "thus",
      "таки́м о́бразом"
    ],
    [
      "wall",
      "стена́"
    ],
    [
      "involved",
      "прича́стный"
    ],
    [
      "el",
      "эль"
    ],
    [
      "extra",
      "осо́бо"
    ],
    [
      "especially",
      "особенно"
    ],
    [
      "pussy",
      "ки́са"
    ],
    [
      "budget",
      "бюджет"
    ],
    [
      "success",
      "успе́х"
    ],
    [
      "maximum",
      "максимум"
    ],
    [
      "operation",
      "опера́ция"
    ],
    [
      "quite",
      "во́все"
    ],
    [
      "boy",
      "лаке́й"
    ],
    [
      "amazon",
      "Амазонка"
    ],
    [
      "beautiful",
      "прекра́сный"
    ],
    [
      "warning",
      "предупреждение"
    ],
    [
      "wine",
      "вино́"
    ],
    [
      "horse",
      "конь"
    ],
    [
      "vote",
      "голос"
    ],
    [
      "forward",
      "вперёд"
    ],
    [
      "significant",
      "значи́тельный"
    ],
    [
      "owner",
      "владе́лец"
    ],
    [
      "retail",
      "ро́зница"
    ],
    [
      "useful",
      "поле́зный"
    ],
    [
      "directly",
      "пря́мо"
    ],
    [
      "manufacturer",
      "производи́тельница"
    ],
    [
      "est",
      "аи-"
    ],
    [
      "son",
      "сын"
    ],
    [
      "rule",
      "правило"
    ],
    [
      "housing",
      "ко́жух"
    ],
    [
      "bring",
      "привести́"
    ],
    [
      "mother",
      "ма́ма"
    ],
    [
      "authority",
      "авторитет"
    ],
    [
      "traffic",
      "тра́фик"
    ],
    [
      "input",
      "ввод"
    ],
    [
      "strategy",
      "стратегия"
    ],
    [
      "agent",
      "аге́нт"
    ],
    [
      "valid",
      "действительный"
    ],
    [
      "bin",
      "бак"
    ],
    [
      "modern",
      "современный"
    ],
    [
      "senior",
      "старшеку́рсник"
    ],
    [
      "ireland",
      "Э́йре"
    ],
    [
      "sexy",
      "сексапи́льный"
    ],
    [
      "teaching",
      "уче́ние"
    ],
    [
      "door",
      "две́ри"
    ],
    [
      "grand",
      "пра-"
    ],
    [
      "trial",
      "испыта́ние"
    ],
    [
      "charge",
      "заря́д"
    ],
    [
      "canadian",
      "канадец"
    ],
    [
      "cool",
      "клёвый"
    ],
    [
      "normal",
      "нормальный"
    ],
    [
      "enterprise",
      "зате́я"
    ],
    [
      "entire",
      "це́лый"
    ],
    [
      "educational",
      "уче́бный"
    ],
    [
      "leading",
      "веду́щий"
    ],
    [
      "metal",
      "мета́лл"
    ],
    [
      "positive",
      "положи́тельный"
    ],
    [
      "fitness",
      "фи́тнес"
    ],
    [
      "chinese",
      "кита́йцы"
    ],
    [
      "opinion",
      "мнение"
    ],
    [
      "asia",
      "А́зия"
    ],
    [
      "football",
      "ногомя́ч"
    ],
    [
      "abstract",
      "рефера́т"
    ],
    [
      "output",
      "вы́работка"
    ],
    [
      "funds",
      "фонд"
    ],
    [
      "likely",
      "перспекти́вный"
    ],
    [
      "develop",
      "разви́ть"
    ],
    [
      "alternative",
      "альтернатива"
    ],
    [
      "responsibility",
      "обя́занность"
    ],
    [
      "resolution",
      "разреше́ние"
    ],
    [
      "java",
      "Ява"
    ],
    [
      "guest",
      "го́стья"
    ],
    [
      "publication",
      "публика́ция"
    ],
    [
      "pass",
      "пройти́"
    ],
    [
      "trust",
      "ве́ра"
    ],
    [
      "van",
      "фу́ра"
    ],
    [
      "session",
      "се́ссия"
    ],
    [
      "photography",
      "фотография"
    ],
    [
      "republic",
      "респу́блика"
    ],
    [
      "vacation",
      "отгу́л"
    ],
    [
      "century",
      "столетие"
    ],
    [
      "academic",
      "академический"
    ],
    [
      "assistance",
      "подде́ржка"
    ],
    [
      "completed",
      "законченный"
    ],
    [
      "skin",
      "шку́ра"
    ],
    [
      "graphics",
      "гра́фика"
    ],
    [
      "indian",
      "индиа́нка"
    ],
    [
      "mary",
      "Мария"
    ],
    [
      "ring",
      "кольцо́"
    ],
    [
      "grade",
      "оце́нка"
    ],
    [
      "dating",
      "уха́живание"
    ],
    [
      "mountain",
      "гора"
    ],
    [
      "pop",
      "поп"
    ],
    [
      "filter",
      "просочи́ться"
    ],
    [
      "vehicle",
      "тра́нспортное сре́дство"
    ],
    [
      "consider",
      "обду́мать"
    ],
    [
      "northern",
      "северный"
    ],
    [
      "behind",
      "позади́"
    ],
    [
      "panel",
      "щит"
    ],
    [
      "floor",
      "дно"
    ],
    [
      "german",
      "не́мец"
    ],
    [
      "match",
      "па́ра"
    ],
    [
      "default",
      "неплатёж"
    ],
    [
      "require",
      "нужда́ться"
    ],
    [
      "iraq",
      "Ирак"
    ],
    [
      "outdoor",
      "нару́жный"
    ],
    [
      "deep",
      "глубокий"
    ],
    [
      "morning",
      "утро"
    ],
    [
      "otherwise",
      "и́наче"
    ],
    [
      "rest",
      "отдыха́ть"
    ],
    [
      "protein",
      "белок"
    ],
    [
      "plant",
      "крот"
    ],
    [
      "hit",
      "хит"
    ],
    [
      "transportation",
      "ссы́лка"
    ],
    [
      "pool",
      "пул"
    ],
    [
      "politics",
      "политика"
    ],
    [
      "partner",
      "партнёрша"
    ],
    [
      "faculty",
      "дар"
    ],
    [
      "fish",
      "ры́ба"
    ],
    [
      "membership",
      "членство"
    ],
    [
      "mission",
      "ми́ссия"
    ],
    [
      "eye",
      "глаз"
    ],
    [
      "string",
      "струна́"
    ],
    [
      "sense",
      "смысл"
    ],
    [
      "pack",
      "упакова́ть"
    ],
    [
      "stage",
      "эта́п"
    ],
    [
      "goods",
      "добро́"
    ],
    [
      "born",
      "рождённый"
    ],
    [
      "unless",
      "ра́зве что"
    ],
    [
      "richard",
      "Риша́р"
    ],
    [
      "detailed",
      "дета́льный"
    ],
    [
      "japanese",
      "японский"
    ],
    [
      "race",
      "гонка"
    ],
    [
      "background",
      "бэкгра́унд"
    ],
    [
      "target",
      "цель"
    ],
    [
      "except",
      "кро́ме"
    ],
    [
      "character",
      "хара́ктер"
    ],
    [
      "maintenance",
      "подде́ржка"
    ],
    [
      "ability",
      "спосо́бность"
    ],
    [
      "maybe",
      "наве́рное"
    ],
    [
      "ed",
      "ла"
    ],
    [
      "moving",
      "волну́ющий"
    ],
    [
      "pretty",
      "ми́лый"
    ],
    [
      "spain",
      "Испа́ния"
    ],
    [
      "yourself",
      "себя́"
    ],
    [
      "winter",
      "зима́"
    ],
    [
      "rape",
      "наси́ловать"
    ],
    [
      "battery",
      "батаре́я"
    ],
    [
      "youth",
      "молодо́й челове́к"
    ],
    [
      "pressure",
      "давление"
    ],
    [
      "boston",
      "Бостон"
    ],
    [
      "incest",
      "инцест"
    ],
    [
      "debt",
      "задо́лженность"
    ],
    [
      "medium",
      "медиум"
    ],
    [
      "television",
      "ТВ"
    ],
    [
      "core",
      "ядро́"
    ],
    [
      "break",
      "лома́ть"
    ],
    [
      "throughout",
      "повсю́ду"
    ],
    [
      "dance",
      "танец"
    ],
    [
      "wood",
      "лес"
    ],
    [
      "itself",
      "себя́"
    ],
    [
      "fee",
      "взнос"
    ],
    [
      "studio",
      "сту́дия"
    ],
    [
      "reader",
      "чтец"
    ],
    [
      "virtual",
      "сло́вно"
    ],
    [
      "device",
      "эмбле́ма"
    ],
    [
      "rent",
      "ре́нта"
    ],
    [
      "remote",
      "ПДТ"
    ],
    [
      "dark",
      "темнота́"
    ],
    [
      "programming",
      "программирование"
    ],
    [
      "external",
      "нару́жный"
    ],
    [
      "apple",
      "я́блоко"
    ],
    [
      "regarding",
      "о"
    ],
    [
      "theory",
      "теория"
    ],
    [
      "enjoy",
      "наслади́ться"
    ],
    [
      "remove",
      "устраня́ть"
    ],
    [
      "aid",
      "помо́щник"
    ],
    [
      "surface",
      "поверхность"
    ],
    [
      "minimum",
      "минимум"
    ],
    [
      "visual",
      "зри́тельный"
    ],
    [
      "host",
      "веду́щий"
    ],
    [
      "variety",
      "разнообра́зие"
    ],
    [
      "martin",
      "стриж"
    ],
    [
      "manual",
      "ручной"
    ],
    [
      "block",
      "препя́тствовать"
    ],
    [
      "repair",
      "ремо́нт"
    ],
    [
      "fair",
      "база́р"
    ],
    [
      "civil",
      "ве́жливый"
    ],
    [
      "steel",
      "стальной"
    ],
    [
      "understanding",
      "согла́сие"
    ],
    [
      "fixed",
      "фикси́рованный"
    ],
    [
      "wrong",
      "непра́вильный"
    ],
    [
      "beginning",
      "нача́ло"
    ],
    [
      "finally",
      "наконе́ц"
    ],
    [
      "desktop",
      "рабо́чий стол"
    ],
    [
      "paris",
      "Париж"
    ],
    [
      "ohio",
      "Огайо"
    ],
    [
      "sector",
      "се́ктор"
    ],
    [
      "capacity",
      "ёмкость"
    ],
    [
      "jersey",
      "футбо́лка"
    ],
    [
      "fat",
      "жир"
    ],
    [
      "father",
      "ба́тюшка"
    ],
    [
      "electric",
      "электро-"
    ],
    [
      "saw",
      "пила"
    ],
    [
      "officer",
      "чино́вник"
    ],
    [
      "driver",
      "води́тельница"
    ],
    [
      "dead",
      "мёртвый"
    ],
    [
      "respect",
      "почте́ние"
    ],
    [
      "unknown",
      "незнако́мый"
    ],
    [
      "restaurant",
      "рестора́н"
    ],
    [
      "trip",
      "кайф"
    ],
    [
      "worth",
      "сто́ящий"
    ],
    [
      "poor",
      "жа́лкий"
    ],
    [
      "teacher",
      "учи́тель"
    ],
    [
      "relationship",
      "отноше́ние"
    ],
    [
      "farm",
      "ферма"
    ],
    [
      "fucking",
      "сра́ный"
    ],
    [
      "georgia",
      "Грузия"
    ],
    [
      "peace",
      "мир"
    ],
    [
      "traditional",
      "традиционный"
    ],
    [
      "campus",
      "кампус"
    ],
    [
      "tom",
      "саме́ц"
    ],
    [
      "creative",
      "тво́рческий"
    ],
    [
      "coast",
      "бе́рег"
    ],
    [
      "benefit",
      "вы́года"
    ],
    [
      "progress",
      "прогре́сс"
    ],
    [
      "lord",
      "лорд"
    ],
    [
      "grant",
      "грант"
    ],
    [
      "agree",
      "подойти́"
    ],
    [
      "fiction",
      "фикшн"
    ],
    [
      "hear",
      "слышать"
    ],
    [
      "sometimes",
      "поро́й"
    ],
    [
      "beyond",
      "за"
    ],
    [
      "led",
      "СИД"
    ],
    [
      "museum",
      "музе́й"
    ],
    [
      "themselves",
      "себя́"
    ],
    [
      "fan",
      "веер"
    ],
    [
      "transport",
      "охватить"
    ],
    [
      "interesting",
      "заня́тный"
    ],
    [
      "wife",
      "жена"
    ],
    [
      "evaluation",
      "оце́нка"
    ],
    [
      "accepted",
      "принятый"
    ],
    [
      "former",
      "пе́рвый"
    ],
    [
      "implementation",
      "внедре́ние"
    ],
    [
      "ten",
      "десять"
    ],
    [
      "zone",
      "зо́на"
    ],
    [
      "complex",
      "комплекс"
    ],
    [
      "th",
      "ый"
    ],
    [
      "cat",
      "кот"
    ],
    [
      "die",
      "штамп"
    ],
    [
      "jack",
      "мама"
    ],
    [
      "flat",
      "ро́вно"
    ],
    [
      "flow",
      "прили́в"
    ],
    [
      "literature",
      "литература"
    ],
    [
      "parent",
      "пре́док"
    ],
    [
      "spanish",
      "испанский"
    ],
    [
      "michigan",
      "Мичиган"
    ],
    [
      "setting",
      "опра́ва"
    ],
    [
      "scale",
      "чешу́йка"
    ],
    [
      "stand",
      "стенд"
    ],
    [
      "economy",
      "экономика"
    ],
    [
      "helpful",
      "любе́зный"
    ],
    [
      "monthly",
      "ме́сячно"
    ],
    [
      "critical",
      "крити́ческий"
    ],
    [
      "frame",
      "ра́ма"
    ],
    [
      "musical",
      "мюзикл"
    ],
    [
      "definition",
      "определение"
    ],
    [
      "secretary",
      "секретарь"
    ],
    [
      "path",
      "путь"
    ],
    [
      "australian",
      "австралиец"
    ],
    [
      "employee",
      "слу́жащая"
    ],
    [
      "chief",
      "глава́"
    ],
    [
      "bottom",
      "зад"
    ],
    [
      "detail",
      "деталь"
    ],
    [
      "pet",
      "ласка́ть"
    ],
    [
      "begin",
      "нача́ть"
    ],
    [
      "colorado",
      "Колорадо"
    ],
    [
      "royal",
      "ца́рский"
    ],
    [
      "clean",
      "чи́стый"
    ],
    [
      "switch",
      "хлыст"
    ],
    [
      "russian",
      "ру́сский"
    ],
    [
      "african",
      "африканец"
    ],
    [
      "guy",
      "лю́ди"
    ],
    [
      "relevant",
      "уме́стный"
    ],
    [
      "justice",
      "справедливость"
    ],
    [
      "connect",
      "подключи́ть"
    ],
    [
      "bible",
      "Би́блия"
    ],
    [
      "cup",
      "ку́бок"
    ],
    [
      "basket",
      "корзи́на"
    ],
    [
      "applied",
      "прикладно́й"
    ],
    [
      "weekly",
      "еженедельный"
    ],
    [
      "installation",
      "монта́ж"
    ],
    [
      "demand",
      "тре́бование"
    ],
    [
      "suite",
      "сюита"
    ],
    [
      "square",
      "квадрат"
    ],
    [
      "attention",
      "внима́ние"
    ],
    [
      "advance",
      "заём"
    ],
    [
      "skip",
      "смы́ться"
    ],
    [
      "diet",
      "дие́та"
    ],
    [
      "army",
      "армия"
    ],
    [
      "auction",
      "аукцион"
    ],
    [
      "gear",
      "переда́ча"
    ],
    [
      "difference",
      "разница"
    ],
    [
      "allowed",
      "разрешённо"
    ],
    [
      "correct",
      "корре́ктный"
    ],
    [
      "charles",
      "Шарль"
    ],
    [
      "nation",
      "нация"
    ],
    [
      "piece",
      "часть"
    ],
    [
      "sheet",
      "лист"
    ],
    [
      "firm",
      "твёрдый"
    ],
    [
      "seven",
      "семёрка"
    ],
    [
      "illinois",
      "Иллинойс"
    ],
    [
      "jump",
      "пры́гнуть"
    ],
    [
      "module",
      "модуль"
    ],
    [
      "resort",
      "куро́рт"
    ],
    [
      "facility",
      "здание"
    ],
    [
      "random",
      "случа́йный"
    ],
    [
      "certificate",
      "сертифика́т"
    ],
    [
      "minister",
      "министр"
    ],
    [
      "motion",
      "предложе́ние"
    ],
    [
      "looks",
      "нару́жность"
    ],
    [
      "fashion",
      "мода"
    ],
    [
      "documentation",
      "документация"
    ],
    [
      "monitor",
      "экра́н"
    ],
    [
      "whose",
      "чей"
    ],
    [
      "coverage",
      "охва́т"
    ],
    [
      "couple",
      "па́ра"
    ],
    [
      "chance",
      "возмо́жность"
    ],
    [
      "vision",
      "видение"
    ],
    [
      "ball",
      "мяч"
    ],
    [
      "ending",
      "коне́ц"
    ],
    [
      "listen",
      "слушать"
    ],
    [
      "discuss",
      "обсуди́ть"
    ],
    [
      "accept",
      "приня́ть"
    ],
    [
      "automotive",
      "авто-"
    ],
    [
      "naked",
      "го́лый"
    ],
    [
      "goal",
      "гол"
    ],
    [
      "successful",
      "уда́чный"
    ],
    [
      "wind",
      "дух"
    ],
    [
      "clinical",
      "бесстра́стный"
    ],
    [
      "situation",
      "положе́ние"
    ],
    [
      "appear",
      "яви́ться"
    ],
    [
      "emergency",
      "реанима́ция"
    ],
    [
      "currency",
      "валюта"
    ],
    [
      "leather",
      "кожа"
    ],
    [
      "determine",
      "определя́ть"
    ],
    [
      "milf",
      "ми́лфа"
    ],
    [
      "temperature",
      "жар"
    ],
    [
      "palm",
      "ладонь"
    ],
    [
      "patient",
      "пациенс"
    ],
    [
      "actual",
      "настоя́щий"
    ],
    [
      "historical",
      "исторический"
    ],
    [
      "stone",
      "ка́мень"
    ],
    [
      "bob",
      "карэ́"
    ],
    [
      "commerce",
      "сноше́ние"
    ],
    [
      "perhaps",
      "мочь"
    ],
    [
      "difficult",
      "тя́жкий"
    ],
    [
      "scientific",
      "научный"
    ],
    [
      "satellite",
      "сателли́т"
    ],
    [
      "fit",
      "подходи́ть"
    ],
    [
      "village",
      "село́"
    ],
    [
      "amateur",
      "любитель"
    ],
    [
      "ex",
      "экс"
    ],
    [
      "pain",
      "боль"
    ],
    [
      "particularly",
      "осо́бенно"
    ],
    [
      "coffee",
      "кофе"
    ],
    [
      "cum",
      "се́мя"
    ],
    [
      "buyer",
      "покупа́тельница"
    ],
    [
      "cultural",
      "культурный"
    ],
    [
      "easily",
      "легко́"
    ],
    [
      "oral",
      "устный"
    ],
    [
      "ford",
      "перепра́ва"
    ],
    [
      "poster",
      "по́стер"
    ],
    [
      "edge",
      "грань"
    ],
    [
      "functional",
      "рабо́чий"
    ],
    [
      "root",
      "ко́рни"
    ],
    [
      "closed",
      "закры́тый"
    ],
    [
      "ice",
      "лёд"
    ],
    [
      "pink",
      "розовый"
    ],
    [
      "zealand",
      "Зеландия"
    ],
    [
      "balance",
      "бала́нс"
    ],
    [
      "monitoring",
      "надзо́р"
    ],
    [
      "graduate",
      "выпускни́ца"
    ],
    [
      "shot",
      "кадр"
    ],
    [
      "architecture",
      "зо́дчество"
    ],
    [
      "initial",
      "инициа́л"
    ],
    [
      "label",
      "лейбл"
    ],
    [
      "recommend",
      "сове́товать"
    ],
    [
      "canon",
      "кано́н"
    ],
    [
      "league",
      "ли́га"
    ],
    [
      "waste",
      "тра́та"
    ],
    [
      "minute",
      "минута"
    ],
    [
      "bus",
      "автобус"
    ],
    [
      "provider",
      "прова́йдер"
    ],
    [
      "optional",
      "опциона́льный"
    ],
    [
      "dictionary",
      "слова́рь"
    ],
    [
      "cold",
      "холодный"
    ],
    [
      "accounting",
      "счетово́дство"
    ],
    [
      "manufacturing",
      "произво́дство"
    ],
    [
      "fishing",
      "[[рыбный|ры́бная]] [[ло́вля]]"
    ],
    [
      "effort",
      "поту́га"
    ],
    [
      "phase",
      "фа́за"
    ],
    [
      "bag",
      "те́ма"
    ],
    [
      "fantasy",
      "вы́мысел"
    ],
    [
      "motor",
      "мото́р"
    ],
    [
      "professor",
      "профессор"
    ],
    [
      "context",
      "контекст"
    ],
    [
      "install",
      "помеща́ть"
    ],
    [
      "shirt",
      "рубашка"
    ],
    [
      "apparel",
      "оде́ть"
    ],
    [
      "generally",
      "вообще́"
    ],
    [
      "foot",
      "нога́"
    ],
    [
      "mass",
      "масса"
    ],
    [
      "crime",
      "кримина́л"
    ],
    [
      "count",
      "граф"
    ],
    [
      "breast",
      "се́рдце"
    ],
    [
      "johnson",
      "Ивано́в"
    ],
    [
      "quickly",
      "ско́ро"
    ],
    [
      "religion",
      "ве́ра"
    ],
    [
      "claim",
      "прете́нзия"
    ],
    [
      "driving",
      "езда́"
    ],
    [
      "permission",
      "разрешение"
    ],
    [
      "surgery",
      "хирургия"
    ],
    [
      "patch",
      "запла́тка"
    ],
    [
      "heat",
      "жара́"
    ],
    [
      "wild",
      "дикий"
    ],
    [
      "generation",
      "созда́ние"
    ],
    [
      "kansas",
      "Канза́с"
    ],
    [
      "miss",
      "мисс"
    ],
    [
      "chemical",
      "хими́ческое соедине́ние"
    ],
    [
      "doctor",
      "доктор"
    ],
    [
      "task",
      "зада́ча"
    ],
    [
      "reduce",
      "худе́ть"
    ],
    [
      "himself",
      "себе́"
    ],
    [
      "component",
      "составна́я часть"
    ],
    [
      "enable",
      "включа́ть"
    ],
    [
      "exercise",
      "трениро́вка"
    ],
    [
      "bug",
      "баг"
    ],
    [
      "guarantee",
      "гара́нт"
    ],
    [
      "leader",
      "шеф"
    ],
    [
      "diamond",
      "алмаз"
    ],
    [
      "israel",
      "Израи́л"
    ],
    [
      "soft",
      "мягкий"
    ],
    [
      "alone",
      "то́лько"
    ],
    [
      "jones",
      "жела́ть"
    ],
    [
      "arizona",
      "Аризона"
    ],
    [
      "keyword",
      "ключевое слово"
    ],
    [
      "flight",
      "полёт"
    ],
    [
      "congress",
      "конгре́сс"
    ],
    [
      "fuel",
      "топливо"
    ],
    [
      "username",
      "логи́н"
    ],
    [
      "walk",
      "идти́"
    ],
    [
      "fuck",
      "еба́ть"
    ],
    [
      "italian",
      "итальянский"
    ],
    [
      "wait",
      "чека́ть"
    ],
    [
      "pocket",
      "котёл"
    ],
    [
      "saint",
      "свята́я"
    ],
    [
      "rose",
      "роза"
    ],
    [
      "freedom",
      "во́ля"
    ],
    [
      "argument",
      "аргуме́нт"
    ],
    [
      "competition",
      "состяза́ние"
    ],
    [
      "joint",
      "стык"
    ],
    [
      "premium",
      "приз"
    ],
    [
      "fresh",
      "свежий"
    ],
    [
      "attorney",
      "юри́ст"
    ],
    [
      "upgrade",
      "обновить"
    ],
    [
      "factor",
      "дви́жущая си́ла"
    ],
    [
      "stream",
      "пото́к"
    ],
    [
      "pick",
      "кирка́"
    ],
    [
      "hearing",
      "разбира́тельство"
    ],
    [
      "therapy",
      "лече́ние"
    ],
    [
      "signed",
      "со знаком"
    ],
    [
      "upper",
      "по́здний"
    ],
    [
      "administrative",
      "административный"
    ],
    [
      "prime",
      "зени́т"
    ],
    [
      "limit",
      "лими́т"
    ],
    [
      "louis",
      "Людо́вик"
    ],
    [
      "bondage",
      "бонда́ж"
    ],
    [
      "creek",
      "зали́в"
    ],
    [
      "quantity",
      "количество"
    ],
    [
      "urban",
      "городской"
    ],
    [
      "essential",
      "ва́жный"
    ],
    [
      "myself",
      "-ся"
    ],
    [
      "platform",
      "платфо́рма"
    ],
    [
      "load",
      "загружа́ть"
    ],
    [
      "affiliate",
      "присоединя́ться"
    ],
    [
      "immediately",
      "то́тчас"
    ],
    [
      "nursing",
      "ухо́д"
    ],
    [
      "defense",
      "оборо́на"
    ],
    [
      "heavy",
      "тя́жкий"
    ],
    [
      "covered",
      "покры́тый"
    ],
    [
      "recovery",
      "восстановле́ние"
    ],
    [
      "joe",
      "Джо"
    ],
    [
      "integrated",
      "комплексный"
    ],
    [
      "cock",
      "куро́к"
    ],
    [
      "merchant",
      "торго́вец"
    ],
    [
      "comprehensive",
      "по́лный"
    ],
    [
      "expert",
      "экспе́рт"
    ],
    [
      "universal",
      "всео́бщий"
    ],
    [
      "protect",
      "бере́чь"
    ],
    [
      "drop",
      "капля"
    ],
    [
      "solid",
      "це́льный"
    ],
    [
      "presentation",
      "представле́ние"
    ],
    [
      "orange",
      "оранжевый"
    ],
    [
      "compliance",
      "пода́тливость"
    ],
    [
      "prevent",
      "помеша́ть"
    ],
    [
      "rich",
      "иму́щий"
    ],
    [
      "campaign",
      "похо́д"
    ],
    [
      "marine",
      "морпе́х"
    ],
    [
      "improvement",
      "улучше́ние"
    ],
    [
      "guitar",
      "гита́ра"
    ],
    [
      "pennsylvania",
      "Пенсильвания"
    ],
    [
      "saying",
      "посло́вица"
    ],
    [
      "spirit",
      "дух"
    ],
    [
      "ar",
      "эр"
    ],
    [
      "porno",
      "порну́ха"
    ],
    [
      "challenge",
      "вы́зов"
    ],
    [
      "acceptance",
      "одобре́ние"
    ],
    [
      "seem",
      "сдава́ться"
    ],
    [
      "touch",
      "штрих"
    ],
    [
      "hire",
      "наня́ть"
    ],
    [
      "election",
      "вы́бор"
    ],
    [
      "suggest",
      "намекну́ть"
    ],
    [
      "branch",
      "ве́тка"
    ],
    [
      "serve",
      "послужи́ть"
    ],
    [
      "magic",
      "ма́гия"
    ],
    [
      "mount",
      "взобра́ться"
    ],
    [
      "smart",
      "умный"
    ],
    [
      "latin",
      "лати́нский"
    ],
    [
      "avoid",
      "избежа́ть"
    ],
    [
      "manage",
      "управля́ть"
    ],
    [
      "corner",
      "у́гол"
    ],
    [
      "rank",
      "ранг"
    ],
    [
      "oregon",
      "Орегон"
    ],
    [
      "element",
      "элеме́нт"
    ],
    [
      "birth",
      "рожде́ние"
    ],
    [
      "virus",
      "вирус"
    ],
    [
      "abuse",
      "матери́ть"
    ],
    [
      "interactive",
      "взаимоде́йствующий"
    ],
    [
      "separate",
      "отдельный"
    ],
    [
      "quarter",
      "кварта́л"
    ],
    [
      "procedure",
      "процеду́ра"
    ],
    [
      "leadership",
      "лидерство"
    ],
    [
      "define",
      "описа́ть"
    ],
    [
      "religious",
      "религио́зный"
    ],
    [
      "breakfast",
      "завтрак"
    ],
    [
      "column",
      "разде́л"
    ],
    [
      "faith",
      "вера"
    ],
    [
      "chain",
      "цепь"
    ],
    [
      "developer",
      "разрабо́тчица"
    ],
    [
      "identify",
      "опозна́ть"
    ],
    [
      "avenue",
      "проспе́кт"
    ],
    [
      "missing",
      "потерянный"
    ],
    [
      "approximately",
      "гру́бо"
    ],
    [
      "domestic",
      "домашний"
    ],
    [
      "reach",
      "доста́ть"
    ],
    [
      "comparison",
      "сравнение"
    ],
    [
      "moment",
      "моме́нт"
    ],
    [
      "extended",
      "затяжно́й"
    ],
    [
      "sequence",
      "после́довательность"
    ],
    [
      "attack",
      "ата́ка"
    ],
    [
      "sorry",
      "что?"
    ],
    [
      "opening",
      "дебю́т"
    ],
    [
      "damage",
      "уще́рб"
    ],
    [
      "reserve",
      "запасно́й"
    ],
    [
      "gamma",
      "гамма"
    ],
    [
      "plastic",
      "ги́бкий"
    ],
    [
      "produce",
      "производи́ть"
    ],
    [
      "snow",
      "снег"
    ],
    [
      "truth",
      "правда"
    ],
    [
      "counter",
      "противове́с"
    ],
    [
      "failure",
      "крах"
    ],
    [
      "weekend",
      "уик-э́нд"
    ],
    [
      "dollar",
      "доллар"
    ],
    [
      "camp",
      "ла́герь"
    ],
    [
      "ontario",
      "Онтарио"
    ],
    [
      "minnesota",
      "Миннесота"
    ],
    [
      "bridge",
      "мост"
    ],
    [
      "native",
      "ме́стный"
    ],
    [
      "fill",
      "заполня́ть"
    ],
    [
      "movement",
      "часть"
    ],
    [
      "printing",
      "печа́ть"
    ],
    [
      "baseball",
      "бейсбол"
    ],
    [
      "approval",
      "согла́сие"
    ],
    [
      "draft",
      "тя́га"
    ],
    [
      "chart",
      "чертёж"
    ],
    [
      "jesus",
      "Иисус"
    ],
    [
      "clubs",
      "тре́фа"
    ],
    [
      "lcd",
      "ЖКД"
    ],
    [
      "equal",
      "ро́вня"
    ],
    [
      "adventure",
      "приключение"
    ],
    [
      "profit",
      "дохо́д"
    ],
    [
      "assistant",
      "помо́щник"
    ],
    [
      "variable",
      "переме́нная"
    ],
    [
      "advertisement",
      "ано́нс"
    ],
    [
      "expect",
      "ожидать"
    ],
    [
      "parking",
      "стоя́нка"
    ],
    [
      "yesterday",
      "вчера"
    ],
    [
      "workshop",
      "семина́р"
    ],
    [
      "russia",
      "Русь"
    ],
    [
      "extension",
      "расшире́ние"
    ],
    [
      "seattle",
      "Сиэтл"
    ],
    [
      "golden",
      "золото́й"
    ],
    [
      "completely",
      "совсе́м"
    ],
    [
      "lighting",
      "свет"
    ],
    [
      "senate",
      "сенат"
    ],
    [
      "funny",
      "прико́льный"
    ],
    [
      "brother",
      "брат"
    ],
    [
      "portable",
      "портативный"
    ],
    [
      "applicable",
      "приго́дный"
    ],
    [
      "pattern",
      "моде́ль"
    ],
    [
      "hentai",
      "хентай"
    ],
    [
      "boat",
      "бот"
    ],
    [
      "laser",
      "лазер"
    ],
    [
      "sponsor",
      "мецена́т"
    ],
    [
      "classical",
      "классический"
    ],
    [
      "icon",
      "икона"
    ],
    [
      "warranty",
      "руча́тельство"
    ],
    [
      "dedicated",
      "специализированный"
    ],
    [
      "indiana",
      "Индиана"
    ],
    [
      "direction",
      "режиссу́ра"
    ],
    [
      "harry",
      "Ха́рри"
    ],
    [
      "basketball",
      "баскетбол"
    ],
    [
      "delete",
      "удаля́ть"
    ],
    [
      "evening",
      "вечер"
    ],
    [
      "assembly",
      "собра́ние"
    ],
    [
      "nuclear",
      "ядерный"
    ],
    [
      "mouse",
      "мы́шка"
    ],
    [
      "signal",
      "сигна́л"
    ],
    [
      "criminal",
      "уголо́вный"
    ],
    [
      "brain",
      "мозги́"
    ],
    [
      "sexual",
      "сексуальный"
    ],
    [
      "wisconsin",
      "Висконсин"
    ],
    [
      "powerful",
      "мо́щный"
    ],
    [
      "dream",
      "грёза"
    ],
    [
      "false",
      "ложь"
    ],
    [
      "cast",
      "бро́сить"
    ],
    [
      "flower",
      "цветок"
    ],
    [
      "felt",
      "во́йлок"
    ],
    [
      "personnel",
      "персона́л"
    ],
    [
      "soul",
      "душа"
    ],
    [
      "promote",
      "продви́нуть"
    ],
    [
      "hawaii",
      "Гавайи"
    ],
    [
      "carry",
      "везти́"
    ],
    [
      "flag",
      "флаг"
    ],
    [
      "advantage",
      "вы́года"
    ],
    [
      "hello",
      "алё"
    ],
    [
      "maintain",
      "поддержа́ть"
    ],
    [
      "tourism",
      "туризм"
    ],
    [
      "graphic",
      "чертёж"
    ],
    [
      "atom",
      "а́том"
    ],
    [
      "brief",
      "кра́ткий"
    ],
    [
      "winning",
      "побе́дный"
    ],
    [
      "eight",
      "восемь"
    ],
    [
      "anonymous",
      "безымя́нный"
    ],
    [
      "iron",
      "железо"
    ],
    [
      "straight",
      "стрейт"
    ],
    [
      "script",
      "скрипт"
    ],
    [
      "miscellaneous",
      "разли́чный"
    ],
    [
      "prepared",
      "подгото́вленный"
    ],
    [
      "void",
      "вакантный"
    ],
    [
      "alert",
      "трево́га"
    ],
    [
      "integration",
      "интеграция"
    ],
    [
      "atlanta",
      "Атланта"
    ],
    [
      "tag",
      "тег"
    ],
    [
      "interview",
      "интервью"
    ],
    [
      "mix",
      "меша́ть"
    ],
    [
      "framework",
      "ра́ма"
    ],
    [
      "disk",
      "диск"
    ],
    [
      "queen",
      "королева"
    ],
    [
      "clearly",
      "явно"
    ],
    [
      "fix",
      "зафикси́ровать"
    ],
    [
      "handle",
      "ру́чка"
    ],
    [
      "sweet",
      "сладкий"
    ],
    [
      "desk",
      "стол"
    ],
    [
      "massachusetts",
      "Массачусетс"
    ],
    [
      "vice",
      "порок"
    ],
    [
      "associate",
      "партнёр"
    ],
    [
      "truck",
      "фу́ра"
    ],
    [
      "enlarge",
      "расширя́ть"
    ],
    [
      "ray",
      "луч"
    ],
    [
      "revenue",
      "дохо́д"
    ],
    [
      "measure",
      "ме́ра"
    ],
    [
      "duty",
      "сбор"
    ],
    [
      "bear",
      "медве́дь"
    ],
    [
      "gain",
      "вы́года"
    ],
    [
      "festival",
      "пра́здник"
    ],
    [
      "laboratory",
      "лаборатория"
    ],
    [
      "ocean",
      "океа́н"
    ],
    [
      "lack",
      "нужда́"
    ],
    [
      "depth",
      "глубина"
    ],
    [
      "iowa",
      "Айова"
    ],
    [
      "whatever",
      "фи"
    ],
    [
      "laptop",
      "но́утбук"
    ],
    [
      "vintage",
      "год"
    ],
    [
      "train",
      "поезд"
    ],
    [
      "exactly",
      "точно"
    ],
    [
      "dry",
      "сухой"
    ],
    [
      "explore",
      "изуча́ть"
    ],
    [
      "maryland",
      "Мэриленд"
    ],
    [
      "spa",
      "спа"
    ],
    [
      "concept",
      "поня́тие"
    ],
    [
      "nearly",
      "о́коло"
    ],
    [
      "eligible",
      "приго́дный"
    ],
    [
      "reality",
      "действи́тельность"
    ],
    [
      "handling",
      "обрабо́тка"
    ],
    [
      "origin",
      "исто́чник"
    ],
    [
      "billion",
      "миллиа́рд"
    ],
    [
      "destination",
      "назначе́ние"
    ],
    [
      "scotland",
      "Шотла́ндия"
    ],
    [
      "intelligence",
      "ум"
    ],
    [
      "con",
      "зэк"
    ],
    [
      "route",
      "курс"
    ],
    [
      "broken",
      "сломанный"
    ],
    [
      "frank",
      "Фрэнк"
    ],
    [
      "alaska",
      "Аляска"
    ],
    [
      "zoom",
      "гул"
    ],
    [
      "blow",
      "сдуть"
    ],
    [
      "battle",
      "би́тва"
    ],
    [
      "residential",
      "жило́й"
    ],
    [
      "anime",
      "аниме́"
    ],
    [
      "speak",
      "говорить"
    ],
    [
      "protocol",
      "протокол"
    ],
    [
      "query",
      "спра́шивать"
    ],
    [
      "clip",
      "закрепи́ть"
    ],
    [
      "partnership",
      "партнёрство"
    ],
    [
      "editorial",
      "передова́я"
    ],
    [
      "expression",
      "выражение"
    ],
    [
      "equity",
      "а́кция"
    ],
    [
      "speech",
      "речь"
    ],
    [
      "wire",
      "про́вод"
    ],
    [
      "rural",
      "дереве́нский"
    ],
    [
      "shared",
      "совме́стный"
    ],
    [
      "replacement",
      "замеще́ние"
    ],
    [
      "tape",
      "лента"
    ],
    [
      "strategic",
      "стратегический"
    ],
    [
      "judge",
      "судья́"
    ],
    [
      "spam",
      "тушёнка"
    ],
    [
      "economics",
      "экономика"
    ],
    [
      "acid",
      "кислота"
    ],
    [
      "forced",
      "наси́льственный"
    ],
    [
      "compatible",
      "сочета́емый"
    ],
    [
      "fight",
      "сража́ться"
    ],
    [
      "apartment",
      "кварти́ра"
    ],
    [
      "height",
      "рост"
    ],
    [
      "null",
      "нулл"
    ],
    [
      "zero",
      "нуль"
    ],
    [
      "speaker",
      "спи́кер"
    ],
    [
      "netherlands",
      "Нидерланды"
    ],
    [
      "obtain",
      "добы́ть"
    ],
    [
      "bc",
      "до на́шей э́ры"
    ],
    [
      "recreation",
      "развлече́ние"
    ],
    [
      "remain",
      "остава́ться"
    ],
    [
      "marriage",
      "брак"
    ],
    [
      "roll",
      "кати́ть"
    ],
    [
      "korea",
      "Корея"
    ],
    [
      "secret",
      "секрет"
    ],
    [
      "bath",
      "ба́ня"
    ],
    [
      "negative",
      "отрица́тельный"
    ],
    [
      "toronto",
      "Торонто"
    ],
    [
      "theater",
      "театр"
    ],
    [
      "missouri",
      "Миссури"
    ],
    [
      "andrew",
      "Андрей"
    ],
    [
      "perform",
      "выполня́ть"
    ],
    [
      "healthy",
      "здоровый"
    ],
    [
      "translation",
      "перевод"
    ],
    [
      "font",
      "фонт"
    ],
    [
      "injury",
      "тра́вма"
    ],
    [
      "joseph",
      "Иосиф"
    ],
    [
      "ministry",
      "министерство"
    ],
    [
      "lawyer",
      "юри́ст"
    ],
    [
      "married",
      "женатый"
    ],
    [
      "protected",
      "защищённый"
    ],
    [
      "sharing",
      "разделение"
    ],
    [
      "birthday",
      "день рожде́ния"
    ],
    [
      "fail",
      "пренебре́чь"
    ],
    [
      "banking",
      "крен"
    ],
    [
      "toward",
      "о"
    ],
    [
      "slightly",
      "слегка́"
    ],
    [
      "assist",
      "помо́чь"
    ],
    [
      "conduct",
      "проводи́ть"
    ],
    [
      "lingerie",
      "же́нское ни́жнее бельё"
    ],
    [
      "shemale",
      "шмель"
    ],
    [
      "legislation",
      "зако́н"
    ],
    [
      "serving",
      "по́рция"
    ],
    [
      "miami",
      "Майами"
    ],
    [
      "postal",
      "почтовый"
    ],
    [
      "tennessee",
      "Теннесси"
    ],
    [
      "wear",
      "наде́ть"
    ],
    [
      "combined",
      "объединённый"
    ],
    [
      "ultimate",
      "оконча́тельный"
    ],
    [
      "wales",
      "Уэльс"
    ],
    [
      "representative",
      "делега́тка"
    ],
    [
      "frequency",
      "частота"
    ],
    [
      "minor",
      "ма́лый"
    ],
    [
      "finish",
      "лак"
    ],
    [
      "physics",
      "фи́зика"
    ],
    [
      "rare",
      "редкий"
    ],
    [
      "extreme",
      "экстрема́льный"
    ],
    [
      "daniel",
      "Даниил"
    ],
    [
      "bars",
      "решётка"
    ],
    [
      "row",
      "грести"
    ],
    [
      "forecast",
      "прогно́з"
    ],
    [
      "administrator",
      "опеку́н"
    ],
    [
      "cycle",
      "цикл"
    ],
    [
      "contain",
      "содержа́ть"
    ],
    [
      "accuracy",
      "точность"
    ],
    [
      "dual",
      "дво́йственный"
    ],
    [
      "rise",
      "поднима́ться"
    ],
    [
      "sleep",
      "поспа́ть"
    ],
    [
      "bird",
      "фак"
    ],
    [
      "pharmacy",
      "аптека"
    ],
    [
      "brazil",
      "Брази́лия"
    ],
    [
      "creation",
      "творе́ние"
    ],
    [
      "static",
      "стати́ческий"
    ],
    [
      "scene",
      "сцена"
    ],
    [
      "hunter",
      "лове́ц"
    ],
    [
      "lady",
      "да́ма"
    ],
    [
      "crystal",
      "кристалл"
    ],
    [
      "famous",
      "знаменитый"
    ],
    [
      "writer",
      "а́втор"
    ],
    [
      "chairman",
      "председатель"
    ],
    [
      "violence",
      "наси́лие"
    ],
    [
      "oklahoma",
      "Оклахома"
    ],
    [
      "drink",
      "напиток"
    ],
    [
      "academy",
      "акаде́мия"
    ],
    [
      "dynamic",
      "динами́чный"
    ],
    [
      "gender",
      "пол"
    ],
    [
      "eat",
      "ку́шать"
    ],
    [
      "permanent",
      "пермане́нтный"
    ],
    [
      "agriculture",
      "земле́делие"
    ],
    [
      "portfolio",
      "портфо́лио"
    ],
    [
      "practical",
      "практи́чный"
    ],
    [
      "infrastructure",
      "инфраструктура"
    ],
    [
      "exclusive",
      "эксклюзи́вный"
    ],
    [
      "seat",
      "ме́сто"
    ],
    [
      "vendor",
      "продаве́ц"
    ],
    [
      "originally",
      "оригина́льно"
    ],
    [
      "philosophy",
      "философия"
    ],
    [
      "regulation",
      "уста́в"
    ],
    [
      "reduction",
      "сведе́ние"
    ],
    [
      "aim",
      "цель"
    ],
    [
      "nutrition",
      "питание"
    ],
    [
      "recording",
      "запись"
    ],
    [
      "toll",
      "звон"
    ],
    [
      "cape",
      "нос"
    ],
    [
      "ann",
      "Энн"
    ],
    [
      "meaning",
      "значе́ние"
    ],
    [
      "tip",
      "наво́дка"
    ],
    [
      "wonderful",
      "чуде́сный"
    ],
    [
      "mine",
      "добыва́ть"
    ],
    [
      "henry",
      "генри"
    ],
    [
      "ticket",
      "билет"
    ],
    [
      "guess",
      "отгада́ть"
    ],
    [
      "agreed",
      "соглашаться"
    ],
    [
      "prevention",
      "профила́ктика"
    ],
    [
      "whom",
      "кто"
    ],
    [
      "ski",
      "лыжа"
    ],
    [
      "soccer",
      "со́ккер"
    ],
    [
      "import",
      "ввоз"
    ],
    [
      "presence",
      "сосе́дство"
    ],
    [
      "instant",
      "неме́дленный"
    ],
    [
      "automatic",
      "нево́льный"
    ],
    [
      "majority",
      "большинство"
    ],
    [
      "christ",
      "Христос"
    ],
    [
      "austria",
      "А́встрия"
    ],
    [
      "ahead",
      "впереди́"
    ],
    [
      "moon",
      "ме́сяц"
    ],
    [
      "participation",
      "участие"
    ],
    [
      "scheme",
      "план"
    ],
    [
      "utility",
      "утили́та"
    ],
    [
      "preview",
      "предосмо́тр"
    ],
    [
      "fly",
      "муха"
    ],
    [
      "manner",
      "нрав"
    ],
    [
      "matrix",
      "матрица"
    ],
    [
      "combination",
      "комбина́ция"
    ],
    [
      "amendment",
      "доба́вка"
    ],
    [
      "despite",
      "невзирая"
    ],
    [
      "strength",
      "си́ла"
    ],
    [
      "turkey",
      "индю́к"
    ],
    [
      "proper",
      "по́лный"
    ],
    [
      "singapore",
      "Сингапур"
    ],
    [
      "delta",
      "дельта"
    ],
    [
      "fear",
      "боя́знь"
    ],
    [
      "phoenix",
      "Феникс"
    ],
    [
      "convention",
      "конве́нция"
    ],
    [
      "principal",
      "ре́ктор"
    ],
    [
      "daughter",
      "дщерь"
    ],
    [
      "voyeur",
      "вуайёр"
    ],
    [
      "comfort",
      "утеше́ние"
    ],
    [
      "alpha",
      "альфа"
    ],
    [
      "appeal",
      "призы́в"
    ],
    [
      "cruise",
      "плыть"
    ],
    [
      "bonus",
      "пре́мия"
    ],
    [
      "previously",
      "ра́нее"
    ],
    [
      "hey",
      "о"
    ],
    [
      "bookmark",
      "закла́дка"
    ],
    [
      "beat",
      "ритм"
    ],
    [
      "disney",
      "Ди́сней"
    ],
    [
      "household",
      "семья́"
    ],
    [
      "smoking",
      "чадящий"
    ],
    [
      "alabama",
      "Алабама"
    ],
    [
      "tea",
      "чай"
    ],
    [
      "improved",
      "усоверше́нствованный"
    ],
    [
      "achieve",
      "дости́чь"
    ],
    [
      "dress",
      "оде́ться"
    ],
    [
      "subscription",
      "подпи́ска"
    ],
    [
      "dealer",
      "ди́лер"
    ],
    [
      "contemporary",
      "современник"
    ],
    [
      "sky",
      "небо"
    ],
    [
      "nearby",
      "ря́дом"
    ],
    [
      "rom",
      "ро́ма"
    ],
    [
      "happen",
      "произойти́"
    ],
    [
      "exposure",
      "вы́держка"
    ],
    [
      "hide",
      "скрыть"
    ],
    [
      "signature",
      "подпись"
    ],
    [
      "gambling",
      "гэ́мблинг"
    ],
    [
      "refer",
      "относи́ть"
    ],
    [
      "miller",
      "мельник"
    ],
    [
      "provision",
      "снабже́ние"
    ],
    [
      "outdoors",
      "снару́жи"
    ],
    [
      "clothes",
      "одёжа"
    ],
    [
      "luxury",
      "ро́скошь"
    ],
    [
      "certainly",
      "безусло́вно"
    ],
    [
      "indeed",
      "то́чно"
    ],
    [
      "newspaper",
      "газета"
    ],
    [
      "toy",
      "ца́цка"
    ],
    [
      "circuit",
      "круг"
    ],
    [
      "layer",
      "пласт"
    ],
    [
      "slow",
      "медленный"
    ],
    [
      "removal",
      "увольнение"
    ],
    [
      "liability",
      "пасси́в"
    ],
    [
      "hip",
      "бедро"
    ],
    [
      "nine",
      "девять"
    ],
    [
      "kentucky",
      "Кентукки"
    ],
    [
      "mostly",
      "ча́ще всего́"
    ],
    [
      "spot",
      "пятно"
    ],
    [
      "taylor",
      "Кравцов"
    ],
    [
      "spend",
      "тра́тить"
    ],
    [
      "factory",
      "фа́брика"
    ],
    [
      "interior",
      "интерье́р"
    ],
    [
      "grow",
      "вы́расти"
    ],
    [
      "optical",
      "оптический"
    ],
    [
      "promotion",
      "продвиже́ние"
    ],
    [
      "relative",
      "ро́дич"
    ],
    [
      "amazing",
      "изуми́тельный"
    ],
    [
      "clock",
      "часы"
    ],
    [
      "dot",
      "то́чка"
    ],
    [
      "identity",
      "ли́чность"
    ],
    [
      "conversion",
      "обраще́ние"
    ],
    [
      "feeling",
      "чу́вство"
    ],
    [
      "hidden",
      "скры́тый"
    ],
    [
      "reasonable",
      "недорого́й"
    ],
    [
      "victoria",
      "Виктория"
    ],
    [
      "relief",
      "релье́ф"
    ],
    [
      "revision",
      "реви́зия"
    ],
    [
      "broadband",
      "широкополо́сная переда́ча"
    ],
    [
      "influence",
      "возде́йствие"
    ],
    [
      "ratio",
      "коэффицие́нт"
    ],
    [
      "pda",
      "карма́нный персона́льный компью́тер"
    ],
    [
      "importance",
      "важность"
    ],
    [
      "rain",
      "град"
    ],
    [
      "planet",
      "плане́та"
    ],
    [
      "recipe",
      "рецепт"
    ],
    [
      "permit",
      "позволя́ть"
    ],
    [
      "seeing",
      "зре́ние"
    ],
    [
      "proof",
      "пруф"
    ],
    [
      "tennis",
      "теннис"
    ],
    [
      "bass",
      "ба́совый ключ"
    ],
    [
      "prescription",
      "предписа́ние"
    ],
    [
      "bedroom",
      "спальня"
    ],
    [
      "empty",
      "вынуть"
    ],
    [
      "instance",
      "экземпля́р"
    ],
    [
      "hole",
      "дыра́"
    ],
    [
      "ride",
      "е́здить"
    ],
    [
      "specifically",
      "именно"
    ],
    [
      "bureau",
      "бюро́"
    ],
    [
      "maine",
      "Мен"
    ],
    [
      "conservation",
      "сохране́ние"
    ],
    [
      "pair",
      "па́ра"
    ],
    [
      "ideal",
      "идеа́льный"
    ],
    [
      "recorded",
      "зарегистрированный"
    ],
    [
      "don",
      "па́хан"
    ],
    [
      "finished",
      "зако́нченный"
    ],
    [
      "dinner",
      "обе́д"
    ],
    [
      "sydney",
      "Си́дни"
    ],
    [
      "stress",
      "напряже́ние"
    ],
    [
      "cream",
      "крем"
    ],
    [
      "yeah",
      "е!"
    ],
    [
      "discover",
      "обнару́жить"
    ],
    [
      "louisiana",
      "Луизиана"
    ],
    [
      "advisor",
      "сове́тник"
    ],
    [
      "marketplace",
      "ры́нок"
    ],
    [
      "evil",
      "ли́хо"
    ],
    [
      "aware",
      "знать"
    ],
    [
      "shape",
      "фо́рма"
    ],
    [
      "evolution",
      "разви́тие"
    ],
    [
      "irish",
      "ирландский"
    ],
    [
      "remains",
      "руина"
    ],
    [
      "concerned",
      "озабоченный"
    ],
    [
      "euro",
      "евро"
    ],
    [
      "operator",
      "опера́тор"
    ],
    [
      "generic",
      "о́бщий"
    ],
    [
      "encyclopedia",
      "энциклопедия"
    ],
    [
      "usage",
      "у́зус"
    ],
    [
      "cap",
      "кэп"
    ],
    [
      "ink",
      "чернила"
    ],
    [
      "census",
      "пе́репись населе́ния"
    ],
    [
      "peak",
      "пик"
    ],
    [
      "competitive",
      "конкурентоспосо́бный"
    ],
    [
      "exist",
      "существовать"
    ],
    [
      "wheel",
      "колесо"
    ],
    [
      "transit",
      "транзи́т"
    ],
    [
      "dick",
      "хер"
    ],
    [
      "salt",
      "соль"
    ],
    [
      "compact",
      "пакт"
    ],
    [
      "poetry",
      "поэзия"
    ],
    [
      "angel",
      "а́нгел"
    ],
    [
      "bell",
      "звонок"
    ],
    [
      "preparation",
      "препара́т"
    ],
    [
      "attempt",
      "о́пыт"
    ],
    [
      "accordance",
      "соотве́тствие"
    ],
    [
      "width",
      "ширина́"
    ],
    [
      "forget",
      "забы́ть"
    ],
    [
      "array",
      "убо́р"
    ],
    [
      "accurate",
      "аккура́тный"
    ],
    [
      "stephen",
      "Степа́н"
    ],
    [
      "elizabeth",
      "Эли́забет"
    ],
    [
      "climate",
      "климат"
    ],
    [
      "pin",
      "ПИН"
    ],
    [
      "playstation",
      "плэйстэ́йшн"
    ],
    [
      "alcohol",
      "алкого́ль"
    ],
    [
      "greek",
      "греческий"
    ],
    [
      "instruction",
      "обуче́ние"
    ],
    [
      "annotation",
      "поясне́ние"
    ],
    [
      "sister",
      "сестра"
    ],
    [
      "raw",
      "сыро́й"
    ],
    [
      "walking",
      "шага́ние"
    ],
    [
      "explain",
      "объясни́ть"
    ],
    [
      "establish",
      "показать"
    ],
    [
      "gnu",
      "антило́па-гну"
    ],
    [
      "extent",
      "объём"
    ],
    [
      "sharp",
      "диез"
    ],
    [
      "ben",
      "мориндо́вое ма́сло"
    ],
    [
      "lane",
      "доро́жка"
    ],
    [
      "paragraph",
      "абза́ц"
    ],
    [
      "kill",
      "убо́й"
    ],
    [
      "mathematics",
      "математика"
    ],
    [
      "compensation",
      "компенса́ция"
    ],
    [
      "ce",
      "на́шей э́ры"
    ],
    [
      "export",
      "экспорт"
    ],
    [
      "aircraft",
      "возду́шное су́дно"
    ],
    [
      "sweden",
      "Швеция"
    ],
    [
      "conflict",
      "конфли́кт"
    ],
    [
      "employer",
      "работода́тель"
    ],
    [
      "occur",
      "произойти́"
    ],
    [
      "percentage",
      "проце́нт"
    ],
    [
      "mississippi",
      "Миссисипи"
    ],
    [
      "describe",
      "описа́ть"
    ],
    [
      "concern",
      "забо́та"
    ],
    [
      "backup",
      "бэка́п"
    ],
    [
      "connecticut",
      "Коннектикут"
    ],
    [
      "heritage",
      "наследие"
    ],
    [
      "immediate",
      "бли́зкий"
    ],
    [
      "holding",
      "хо́лдинг"
    ],
    [
      "trouble",
      "хло́поты"
    ],
    [
      "spread",
      "раздви́нуть"
    ],
    [
      "coach",
      "ваго́н"
    ],
    [
      "agricultural",
      "земледе́льческий"
    ],
    [
      "expand",
      "расширя́ть"
    ],
    [
      "audience",
      "аудито́рия"
    ],
    [
      "jordan",
      "Ярде́на"
    ],
    [
      "participate",
      "уча́ствовать"
    ],
    [
      "plug",
      "про́бка"
    ],
    [
      "specialist",
      "экспе́рт"
    ],
    [
      "cook",
      "печь"
    ],
    [
      "affect",
      "люби́ть"
    ],
    [
      "virgin",
      "це́лка"
    ],
    [
      "experienced",
      "о́пытный"
    ],
    [
      "investigation",
      "сле́дствие"
    ],
    [
      "hat",
      "шляпа"
    ],
    [
      "institution",
      "институ́ция"
    ],
    [
      "affected",
      "ло́жный"
    ],
    [
      "bike",
      "мотоци́кл"
    ],
    [
      "plate",
      "блю́до"
    ],
    [
      "indicate",
      "показать"
    ],
    [
      "favourite",
      "фавори́т"
    ],
    [
      "transmission",
      "перено́с"
    ],
    [
      "lose",
      "теря́ть"
    ],
    [
      "organic",
      "органи́ческий"
    ],
    [
      "seek",
      "разы́скивать"
    ],
    [
      "extremely",
      "чрезвыча́йно"
    ],
    [
      "concerning",
      "насчёт"
    ],
    [
      "equivalent",
      "эквивалент"
    ],
    [
      "chemistry",
      "химия"
    ],
    [
      "neighborhood",
      "сосе́дство"
    ],
    [
      "nevada",
      "Невада"
    ],
    [
      "thailand",
      "Таиланд"
    ],
    [
      "agenda",
      "аге́нда"
    ],
    [
      "anyway",
      "в любо́м слу́чае"
    ],
    [
      "cam",
      "эксце́нтрик"
    ],
    [
      "curriculum",
      "уче́бный план"
    ],
    [
      "logic",
      "логика"
    ],
    [
      "prince",
      "принц"
    ],
    [
      "circle",
      "круг"
    ],
    [
      "soil",
      "земля́"
    ],
    [
      "anywhere",
      "где-ли́бо"
    ],
    [
      "psychology",
      "психоло́гия"
    ],
    [
      "atlantic",
      "атлантический"
    ],
    [
      "wet",
      "мочи́ться"
    ],
    [
      "edward",
      "Эдуард"
    ],
    [
      "investor",
      "инве́стор"
    ],
    [
      "identification",
      "опозна́ние"
    ],
    [
      "ram",
      "баран"
    ],
    [
      "wildlife",
      "фа́уна"
    ],
    [
      "elementary",
      "нача́льный"
    ],
    [
      "cooking",
      "кулинари́я"
    ],
    [
      "speaking",
      "разгово́р"
    ],
    [
      "fox",
      "лиса́"
    ],
    [
      "unlimited",
      "неограни́ченный"
    ],
    [
      "respond",
      "отвеча́ть"
    ],
    [
      "plain",
      "равнина"
    ],
    [
      "exit",
      "выход"
    ],
    [
      "iran",
      "Ира́н"
    ],
    [
      "arm",
      "ору́жие"
    ],
    [
      "launch",
      "барка́с"
    ],
    [
      "wave",
      "волна"
    ],
    [
      "belgium",
      "Бе́льгия"
    ],
    [
      "holy",
      "свято́й"
    ],
    [
      "mesh",
      "сеть"
    ],
    [
      "trail",
      "стёжка"
    ],
    [
      "enforcement",
      "исполне́ние"
    ],
    [
      "symbol",
      "си́мвол"
    ],
    [
      "highway",
      "шоссе́"
    ],
    [
      "buddy",
      "дружо́к"
    ],
    [
      "dean",
      "декан"
    ],
    [
      "setup",
      "подста́ва"
    ],
    [
      "poll",
      "опро́с"
    ],
    [
      "booking",
      "зака́з"
    ],
    [
      "glossary",
      "слова́рь"
    ],
    [
      "celebrity",
      "сла́ва"
    ],
    [
      "filled",
      "по́лный"
    ],
    [
      "bond",
      "у́зы"
    ],
    [
      "appendix",
      "приложе́ние"
    ],
    [
      "notify",
      "сообща́ть"
    ],
    [
      "chocolate",
      "шоколад"
    ],
    [
      "pub",
      "бар"
    ],
    [
      "portion",
      "пай"
    ],
    [
      "scope",
      "рамка"
    ],
    [
      "supplier",
      "поставщи́ца"
    ],
    [
      "cotton",
      "хлопчатая бумага"
    ],
    [
      "bluetooth",
      "блюту́з"
    ],
    [
      "requirement",
      "тре́бование"
    ],
    [
      "biology",
      "биоло́гия"
    ],
    [
      "dental",
      "зубной"
    ],
    [
      "border",
      "грани́ца"
    ],
    [
      "ancient",
      "дре́вний"
    ],
    [
      "debate",
      "диску́ссия"
    ],
    [
      "pregnancy",
      "беременность"
    ],
    [
      "arkansas",
      "Арканзас"
    ],
    [
      "biography",
      "биография"
    ],
    [
      "leisure",
      "досу́г"
    ],
    [
      "learned",
      "эруди́рованный"
    ],
    [
      "notebook",
      "лэпто́п"
    ],
    [
      "explorer",
      "зонд"
    ],
    [
      "husband",
      "супру́г"
    ],
    [
      "disabled",
      "инвали́д"
    ],
    [
      "crazy",
      "безу́мный"
    ],
    [
      "upcoming",
      "предстоя́щий"
    ],
    [
      "concert",
      "концерт"
    ],
    [
      "retirement",
      "пе́нсия"
    ],
    [
      "efficiency",
      "эффективность"
    ],
    [
      "comedy",
      "комедия"
    ],
    [
      "efficient",
      "эффективный"
    ],
    [
      "linear",
      "линейный"
    ],
    [
      "commitment",
      "обяза́тельство"
    ],
    [
      "specialty",
      "специализа́ция"
    ],
    [
      "hop",
      "хмель"
    ],
    [
      "carrier",
      "носи́тель"
    ],
    [
      "constant",
      "постоя́нная"
    ],
    [
      "visa",
      "виза"
    ],
    [
      "mouth",
      "у́стье"
    ],
    [
      "jewish",
      "жидо́вский"
    ],
    [
      "meter",
      "метр"
    ],
    [
      "gun",
      "пу́шка"
    ],
    [
      "reflect",
      "отрази́ть"
    ],
    [
      "pure",
      "чистый"
    ],
    [
      "deliver",
      "доставля́ть"
    ],
    [
      "wonder",
      "чу́до"
    ],
    [
      "hell",
      "пе́кло"
    ],
    [
      "fruit",
      "плод"
    ],
    [
      "reform",
      "реформа"
    ],
    [
      "lens",
      "линза"
    ],
    [
      "discovery",
      "откры́тие"
    ],
    [
      "draw",
      "черти́ть"
    ],
    [
      "assume",
      "заня́ть"
    ],
    [
      "confidence",
      "уве́ренность"
    ],
    [
      "alliance",
      "алья́нс"
    ],
    [
      "confirm",
      "подтверди́ть"
    ],
    [
      "warm",
      "серде́чный"
    ],
    [
      "neither",
      "никто́"
    ],
    [
      "howard",
      "Ха́уард"
    ],
    [
      "engineer",
      "инженер"
    ],
    [
      "lifestyle",
      "стиль жи́зни"
    ],
    [
      "consistent",
      "совмести́мый"
    ],
    [
      "replace",
      "заменя́ть"
    ],
    [
      "clearance",
      "виза"
    ],
    [
      "inventory",
      "о́пись"
    ],
    [
      "suck",
      "сосать"
    ],
    [
      "babe",
      "мила́шка"
    ],
    [
      "blowjob",
      "омле́т"
    ],
    [
      "safari",
      "сафари"
    ],
    [
      "objective",
      "цель"
    ],
    [
      "sugar",
      "са́хар"
    ],
    [
      "crew",
      "кома́нда"
    ],
    [
      "stick",
      "палка"
    ],
    [
      "relation",
      "расска́з"
    ],
    [
      "slide",
      "слайд"
    ],
    [
      "montana",
      "Монтана"
    ],
    [
      "volunteer",
      "доброво́лец"
    ],
    [
      "rear",
      "встать на [[дыбы́]]"
    ],
    [
      "democratic",
      "демократический"
    ],
    [
      "enhance",
      "уси́лить"
    ],
    [
      "switzerland",
      "Швейца́рия"
    ],
    [
      "exact",
      "ве́рный"
    ],
    [
      "bound",
      "обяза́нный"
    ],
    [
      "parameter",
      "параметр"
    ],
    [
      "adapter",
      "переходни́к"
    ],
    [
      "processor",
      "процессор"
    ],
    [
      "node",
      "узел"
    ],
    [
      "formal",
      "формальный"
    ],
    [
      "contribute",
      "[[де́лать]] [[взнос|взно́сы]]"
    ],
    [
      "lock",
      "шлюз"
    ],
    [
      "hockey",
      "хоккей"
    ],
    [
      "storm",
      "бу́ря"
    ],
    [
      "mile",
      "миля"
    ],
    [
      "threads",
      "тряпка"
    ],
    [
      "bowl",
      "ча́ша"
    ],
    [
      "supreme",
      "вы́сший"
    ],
    [
      "recognition",
      "призна́ние"
    ],
    [
      "tank",
      "цисте́рна"
    ],
    [
      "submission",
      "захва́т"
    ],
    [
      "estimate",
      "расчёт"
    ],
    [
      "encourage",
      "поощри́ть"
    ],
    [
      "navy",
      "ВМС"
    ],
    [
      "kid",
      "паца́н"
    ],
    [
      "inspection",
      "прове́рка"
    ],
    [
      "cancel",
      "отсе́чь"
    ],
    [
      "territory",
      "террито́рия"
    ],
    [
      "transaction",
      "транза́кция"
    ],
    [
      "manchester",
      "Манчестер"
    ],
    [
      "paint",
      "писать"
    ],
    [
      "delay",
      "отложи́ть"
    ],
    [
      "pilot",
      "пило́т"
    ],
    [
      "outlet",
      "сток"
    ],
    [
      "continuous",
      "длительны́й"
    ],
    [
      "czech",
      "чешский"
    ],
    [
      "cambridge",
      "Ке́мбриджский университе́т"
    ],
    [
      "initiative",
      "почи́н"
    ],
    [
      "novel",
      "роман"
    ],
    [
      "pan",
      "сковорода́"
    ],
    [
      "execution",
      "выполне́ние"
    ],
    [
      "disability",
      "посо́бие по инвали́дности"
    ],
    [
      "winner",
      "победитель"
    ],
    [
      "idaho",
      "Айдахо"
    ],
    [
      "contractor",
      "подря́дчик"
    ],
    [
      "episode",
      "се́рия"
    ],
    [
      "examination",
      "осмо́тр"
    ],
    [
      "potter",
      "гонча́рка"
    ],
    [
      "dish",
      "блю́до"
    ],
    [
      "bulletin",
      "бюллетень"
    ],
    [
      "modify",
      "изменя́ться"
    ],
    [
      "oxford",
      "Оксфорд"
    ],
    [
      "adam",
      "Адам"
    ],
    [
      "truly",
      "че́стно"
    ],
    [
      "painting",
      "живопись"
    ],
    [
      "extensive",
      "обши́рный"
    ],
    [
      "universe",
      "вселенная"
    ],
    [
      "candidate",
      "кандидат"
    ],
    [
      "patent",
      "патент"
    ],
    [
      "slot",
      "слот"
    ],
    [
      "outstanding",
      "торча́щий"
    ],
    [
      "eating",
      "приём [[пища|пи́щи]]"
    ],
    [
      "perspective",
      "перспекти́ва"
    ],
    [
      "planned",
      "штатный"
    ],
    [
      "lodge",
      "ложа"
    ],
    [
      "messenger",
      "гоне́ц"
    ],
    [
      "mirror",
      "ко́пия"
    ],
    [
      "tournament",
      "турнир"
    ],
    [
      "consideration",
      "моти́в"
    ],
    [
      "sterling",
      "фунт"
    ],
    [
      "kernel",
      "ядро́"
    ],
    [
      "gray",
      "грей"
    ],
    [
      "catalogue",
      "спи́сок"
    ],
    [
      "broad",
      "де́вка"
    ],
    [
      "taiwan",
      "Формо́за"
    ],
    [
      "demo",
      "демо"
    ],
    [
      "greece",
      "Гре́ция"
    ],
    [
      "swiss",
      "швейцарец"
    ],
    [
      "sarah",
      "Са́ра"
    ],
    [
      "labour",
      "труд"
    ],
    [
      "hate",
      "ненавидеть"
    ],
    [
      "terminal",
      "термина́л"
    ],
    [
      "caribbean",
      "Карибы"
    ],
    [
      "liquid",
      "жидкий"
    ],
    [
      "nebraska",
      "Небраска"
    ],
    [
      "loop",
      "цепь"
    ],
    [
      "salary",
      "окла́д"
    ],
    [
      "reservation",
      "сомнение"
    ],
    [
      "gourmet",
      "гурма́н"
    ],
    [
      "guard",
      "кожу́х"
    ],
    [
      "properly",
      "пра́вильно"
    ],
    [
      "saving",
      "эконо́мия"
    ],
    [
      "empire",
      "империя"
    ],
    [
      "resume",
      "продо́лжить"
    ],
    [
      "twenty",
      "два́дцать"
    ],
    [
      "newly",
      "за́ново"
    ],
    [
      "raise",
      "подня́ть"
    ],
    [
      "prepare",
      "пригото́вить"
    ],
    [
      "avatar",
      "авата́ра"
    ],
    [
      "illegal",
      "неве́рный"
    ],
    [
      "expansion",
      "экспа́нсия"
    ],
    [
      "arab",
      "ара́бка"
    ],
    [
      "lincoln",
      "[[линкольнский|линко́льнская]] [[поро́да]] [[овца|ове́ц]]"
    ],
    [
      "premier",
      "пе́рвый"
    ],
    [
      "tomorrow",
      "завтра"
    ],
    [
      "milk",
      "дои́ть"
    ],
    [
      "decide",
      "реши́ть"
    ],
    [
      "consent",
      "согла́сие"
    ],
    [
      "drama",
      "драма"
    ],
    [
      "downtown",
      "си́ти"
    ],
    [
      "keyboard",
      "клавиатура"
    ],
    [
      "contest",
      "ди́спут"
    ],
    [
      "boot",
      "бутса"
    ],
    [
      "suitable",
      "приго́дный"
    ],
    [
      "absolutely",
      "то́чно"
    ],
    [
      "lunch",
      "ланч"
    ],
    [
      "dildo",
      "самоты́к"
    ],
    [
      "audit",
      "реви́зия"
    ],
    [
      "push",
      "продвига́ть"
    ],
    [
      "chamber",
      "пала́та"
    ],
    [
      "guinea",
      "Гвинея"
    ],
    [
      "muscle",
      "му́скул"
    ],
    [
      "implement",
      "ору́дие"
    ],
    [
      "typical",
      "типичный"
    ],
    [
      "tower",
      "ба́шня"
    ],
    [
      "yours",
      "ваш"
    ],
    [
      "sum",
      "суть"
    ],
    [
      "calculator",
      "счётчик"
    ],
    [
      "chicken",
      "пету́х"
    ],
    [
      "temporary",
      "временный"
    ],
    [
      "attend",
      "ходи́ть"
    ],
    [
      "shower",
      "душ"
    ],
    [
      "jason",
      "Язо́н"
    ],
    [
      "tonight",
      "се́ночь"
    ],
    [
      "dear",
      "дорого́й"
    ],
    [
      "sufficient",
      "достаточно"
    ],
    [
      "shell",
      "па́нцирь"
    ],
    [
      "province",
      "штат"
    ],
    [
      "catholic",
      "католик"
    ],
    [
      "vat",
      "чан"
    ],
    [
      "awareness",
      "созна́ние"
    ],
    [
      "vancouver",
      "Ванкувер"
    ],
    [
      "governor",
      "губернатор"
    ],
    [
      "beer",
      "пи́во"
    ],
    [
      "contribution",
      "дань"
    ],
    [
      "measurement",
      "ме́ра"
    ],
    [
      "swimming",
      "плавание"
    ],
    [
      "spyware",
      "[[шпио́нский|шпио́нское]] ПО"
    ],
    [
      "formula",
      "реце́пт"
    ],
    [
      "constitution",
      "конституция"
    ],
    [
      "packaging",
      "упако́вка"
    ],
    [
      "solar",
      "солнечный"
    ],
    [
      "catch",
      "уло́в"
    ],
    [
      "jane",
      "Джен"
    ],
    [
      "pakistan",
      "Пакиста́н"
    ],
    [
      "northwest",
      "се́веро-за́пад"
    ],
    [
      "sir",
      "сэр"
    ],
    [
      "doubt",
      "вопро́с"
    ],
    [
      "earn",
      "зарабо́тать"
    ],
    [
      "classroom",
      "кла́ссная"
    ],
    [
      "democracy",
      "демокра́тия"
    ],
    [
      "wallpaper",
      "обои"
    ],
    [
      "resistance",
      "сопротивле́ние"
    ],
    [
      "memorial",
      "па́мятник"
    ],
    [
      "visitor",
      "посети́тель"
    ],
    [
      "twin",
      "дво́йня"
    ],
    [
      "forth",
      "впредь"
    ],
    [
      "insert",
      "вкле́йка"
    ],
    [
      "gateway",
      "шлюз"
    ],
    [
      "drawing",
      "рисова́ние"
    ],
    [
      "biological",
      "родно́й"
    ],
    [
      "fighting",
      "вою́ющий"
    ],
    [
      "transition",
      "перехо́д"
    ],
    [
      "spy",
      "шпик"
    ],
    [
      "romance",
      "рома́нс"
    ],
    [
      "instrument",
      "прибо́р"
    ],
    [
      "bruce",
      "Брюс"
    ],
    [
      "split",
      "шпагат"
    ],
    [
      "heaven",
      "небо"
    ],
    [
      "pregnant",
      "брюха́тый"
    ],
    [
      "twice",
      "два́жды"
    ],
    [
      "classification",
      "классифици́рование"
    ],
    [
      "focused",
      "узкоспециализированный"
    ],
    [
      "egypt",
      "Еги́пет"
    ],
    [
      "physician",
      "ме́дик"
    ],
    [
      "hollywood",
      "Голливуд"
    ],
    [
      "bargain",
      "сде́лка"
    ],
    [
      "wikipedia",
      "Википедия"
    ],
    [
      "cellular",
      "клеточный"
    ],
    [
      "norway",
      "Норве́гия"
    ],
    [
      "vermont",
      "Вермонт"
    ],
    [
      "normally",
      "как обычно"
    ],
    [
      "lo",
      "глядеть"
    ],
    [
      "spiritual",
      "духовный"
    ],
    [
      "hunting",
      "поиск"
    ],
    [
      "diabetes",
      "диабет"
    ],
    [
      "suit",
      "костю́м"
    ],
    [
      "shift",
      "дви́гаться"
    ],
    [
      "chip",
      "чип"
    ],
    [
      "sit",
      "сидеть"
    ],
    [
      "cutting",
      "вы́резка"
    ],
    [
      "wow",
      "ба"
    ],
    [
      "simon",
      "Симо́н"
    ],
    [
      "flexible",
      "пода́тливый"
    ],
    [
      "numerous",
      "многочисленный"
    ],
    [
      "relatively",
      "сравни́тельно"
    ],
    [
      "satisfaction",
      "удово́льствие"
    ],
    [
      "char",
      "чар"
    ],
    [
      "superior",
      "вы́сший"
    ],
    [
      "cartoon",
      "шарж"
    ],
    [
      "intellectual",
      "у́мственный"
    ],
    [
      "granted",
      "пра́вда"
    ],
    [
      "carbon",
      "у́голь"
    ],
    [
      "comfortable",
      "ую́тный"
    ],
    [
      "magnetic",
      "магнитный"
    ],
    [
      "interaction",
      "обще́ние"
    ],
    [
      "listening",
      "слу́шание"
    ],
    [
      "registry",
      "рее́стр"
    ],
    [
      "crisis",
      "кризис"
    ],
    [
      "outlook",
      "вид"
    ],
    [
      "denmark",
      "Да́ния"
    ],
    [
      "bright",
      "у́мный"
    ],
    [
      "treat",
      "лечи́ть"
    ],
    [
      "header",
      "хе́дер"
    ],
    [
      "poverty",
      "нехва́тка"
    ],
    [
      "piano",
      "пианино"
    ],
    [
      "echo",
      "эхо"
    ],
    [
      "grid",
      "сеть"
    ],
    [
      "patrick",
      "Патрике́й"
    ],
    [
      "experimental",
      "о́пытный"
    ],
    [
      "revolution",
      "революция"
    ],
    [
      "plasma",
      "плазма"
    ],
    [
      "earnings",
      "при́быль"
    ],
    [
      "mystery",
      "зага́дка"
    ],
    [
      "landscape",
      "пейза́ж"
    ],
    [
      "dependent",
      "зави́симый"
    ]
  ],
  "tr": [
    [
      "of",
      "-un"
    ],
    [
      "and",
      "ile"
    ],
    [
      "to",
      "-e"
    ],
    [
      "a",
      "bi"
    ],
    [
      "in",
      "-da"
    ],
    [
      "that",
      "o"
    ],
    [
      "by",
      "tarafından"
    ],
    [
      "this",
      "bunlar"
    ],
    [
      "with",
      "ile"
    ],
    [
      "you",
      "sen"
    ],
    [
      "it",
      "İT"
    ],
    [
      "not",
      "-ma"
    ],
    [
      "or",
      "ya da"
    ],
    [
      "be",
      "olmak"
    ],
    [
      "from",
      "-den"
    ],
    [
      "at",
      "-de"
    ],
    [
      "as",
      "gibi"
    ],
    [
      "your",
      "sizin"
    ],
    [
      "all",
      "bütün"
    ],
    [
      "more",
      "daha"
    ],
    [
      "an",
      "bi"
    ],
    [
      "we",
      "ikimiz"
    ],
    [
      "home",
      "ev"
    ],
    [
      "can",
      "teneke kutu"
    ],
    [
      "about",
      "hakkında"
    ],
    [
      "if",
      "-sa"
    ],
    [
      "page",
      "bet"
    ],
    [
      "free",
      "özgür"
    ],
    [
      "but",
      "ancak"
    ],
    [
      "one",
      "birini"
    ],
    [
      "other",
      "öbür"
    ],
    [
      "do",
      "acaba"
    ],
    [
      "no",
      "yok"
    ],
    [
      "information",
      "malumat"
    ],
    [
      "time",
      "saat"
    ],
    [
      "they",
      "o"
    ],
    [
      "site",
      "Web sitesi"
    ],
    [
      "up",
      "yukarıya"
    ],
    [
      "what",
      "ne kadar"
    ],
    [
      "news",
      "salık"
    ],
    [
      "use",
      "fayda"
    ],
    [
      "there",
      "ora"
    ],
    [
      "see",
      "görmek"
    ],
    [
      "only",
      "tek"
    ],
    [
      "so",
      "kadar"
    ],
    [
      "here",
      "burası"
    ],
    [
      "business",
      "işletme"
    ],
    [
      "also",
      "da"
    ],
    [
      "now",
      "-den"
    ],
    [
      "help",
      "yardım"
    ],
    [
      "get",
      "elde etmek"
    ],
    [
      "view",
      "görünüm menüsü"
    ],
    [
      "online",
      "çevrim içi"
    ],
    [
      "first",
      "ilk"
    ],
    [
      "how",
      "nice"
    ],
    [
      "me",
      "bana"
    ],
    [
      "s",
      "ler"
    ],
    [
      "some",
      "bir"
    ],
    [
      "these",
      "bunlar"
    ],
    [
      "like",
      "sevmek"
    ],
    [
      "service",
      "servis"
    ],
    [
      "than",
      "-den"
    ],
    [
      "price",
      "paha"
    ],
    [
      "date",
      "tarih"
    ],
    [
      "back",
      "arka"
    ],
    [
      "top",
      "aktif"
    ],
    [
      "people",
      "halk"
    ],
    [
      "list",
      "dilemek"
    ],
    [
      "name",
      "isim"
    ],
    [
      "just",
      "demin"
    ],
    [
      "over",
      "üstünde"
    ],
    [
      "state",
      "il"
    ],
    [
      "year",
      "sene"
    ],
    [
      "day",
      "gün"
    ],
    [
      "into",
      "karşı"
    ],
    [
      "email",
      "elektronik posta"
    ],
    [
      "health",
      "afiyet"
    ],
    [
      "world",
      "dünya"
    ],
    [
      "next",
      "ertesi"
    ],
    [
      "work",
      "çalışmak"
    ],
    [
      "last",
      "sonuncu"
    ],
    [
      "music",
      "ezgi"
    ],
    [
      "buy",
      "yemek"
    ],
    [
      "data",
      "bilgi"
    ],
    [
      "make",
      "yaratmak"
    ],
    [
      "product",
      "ürün"
    ],
    [
      "system",
      "usul"
    ],
    [
      "post",
      "kazık"
    ],
    [
      "city",
      "kent"
    ],
    [
      "number",
      "sayı"
    ],
    [
      "such",
      "böylesine"
    ],
    [
      "please",
      "iltimas"
    ],
    [
      "available",
      "var"
    ],
    [
      "support",
      "desteklemek"
    ],
    [
      "message",
      "ileti"
    ],
    [
      "after",
      "arkasında"
    ],
    [
      "best",
      "geçmek"
    ],
    [
      "then",
      "o zaman"
    ],
    [
      "good",
      "iyi"
    ],
    [
      "video",
      "görüntü"
    ],
    [
      "well",
      "bak"
    ],
    [
      "where",
      "hani"
    ],
    [
      "public",
      "halk"
    ],
    [
      "high",
      "yüksek"
    ],
    [
      "school",
      "okul"
    ],
    [
      "through",
      "boyunca"
    ],
    [
      "each",
      "her biri"
    ],
    [
      "review",
      "teftiş"
    ],
    [
      "order",
      "düzen"
    ],
    [
      "very",
      "pek"
    ],
    [
      "privacy",
      "gizlilik"
    ],
    [
      "book",
      "cilt"
    ],
    [
      "company",
      "işletme"
    ],
    [
      "group",
      "küme"
    ],
    [
      "sex",
      "cins"
    ],
    [
      "need",
      "gerekmek"
    ],
    [
      "many",
      "çok"
    ],
    [
      "user",
      "sömürücü"
    ],
    [
      "set",
      "küme"
    ],
    [
      "general",
      "paşa"
    ],
    [
      "research",
      "tahkik etmek"
    ],
    [
      "university",
      "darülfünun"
    ],
    [
      "january",
      "kânunusani"
    ],
    [
      "full",
      "tok"
    ],
    [
      "program",
      "izlence"
    ],
    [
      "life",
      "hayat"
    ],
    [
      "know",
      "bilmek"
    ],
    [
      "way",
      "imkan"
    ],
    [
      "days",
      "sabahları"
    ],
    [
      "management",
      "idarecilik"
    ],
    [
      "part",
      "kısım"
    ],
    [
      "great",
      "çok büyük"
    ],
    [
      "hotel",
      "konakçı"
    ],
    [
      "real",
      "gerçek"
    ],
    [
      "international",
      "enternasyonal"
    ],
    [
      "center",
      "özek"
    ],
    [
      "must",
      "şıra"
    ],
    [
      "travel",
      "seyahat"
    ],
    [
      "development",
      "gelişim"
    ],
    [
      "report",
      "röpörtaj"
    ],
    [
      "member",
      "aza"
    ],
    [
      "line",
      "hat"
    ],
    [
      "before",
      "evvel"
    ],
    [
      "send",
      "yollamak"
    ],
    [
      "right",
      "sağ"
    ],
    [
      "type",
      "tür"
    ],
    [
      "because",
      "işte"
    ],
    [
      "local",
      "lokal"
    ],
    [
      "those",
      "onlar"
    ],
    [
      "office",
      "büro"
    ],
    [
      "education",
      "talim"
    ],
    [
      "national",
      "millî"
    ],
    [
      "car",
      "kabin"
    ],
    [
      "design",
      "dizayn"
    ],
    [
      "take",
      "almak"
    ],
    [
      "internet",
      "genel ağ"
    ],
    [
      "address",
      "tarz"
    ],
    [
      "community",
      "toplum"
    ],
    [
      "area",
      "alan"
    ],
    [
      "phone",
      "telefonlamak"
    ],
    [
      "subject",
      "dal"
    ],
    [
      "forum",
      "münteda"
    ],
    [
      "family",
      "aile"
    ],
    [
      "based",
      "bazlı"
    ],
    [
      "code",
      "kural"
    ],
    [
      "show",
      "şov"
    ],
    [
      "o",
      "ya"
    ],
    [
      "even",
      "da"
    ],
    [
      "black",
      "siyah"
    ],
    [
      "check",
      "şah"
    ],
    [
      "special",
      "has"
    ],
    [
      "index",
      "endeks"
    ],
    [
      "being",
      "varlık"
    ],
    [
      "sign",
      "alamet"
    ],
    [
      "file",
      "müracaat etmek"
    ],
    [
      "link",
      "bağ"
    ],
    [
      "today",
      "bugün"
    ],
    [
      "south",
      "cenup"
    ],
    [
      "same",
      "aynı"
    ],
    [
      "version",
      "sürüm"
    ],
    [
      "found",
      "kurmak"
    ],
    [
      "house",
      "ev"
    ],
    [
      "related",
      "akraba"
    ],
    [
      "security",
      "emniyet"
    ],
    [
      "both",
      "ikisi (de)"
    ],
    [
      "county",
      "ilçe"
    ],
    [
      "american",
      "Amerikan"
    ],
    [
      "game",
      "av hayvanı"
    ],
    [
      "power",
      "kuvvet"
    ],
    [
      "while",
      "-ken"
    ],
    [
      "care",
      "tasa"
    ],
    [
      "network",
      "şebeke"
    ],
    [
      "down",
      "tüy"
    ],
    [
      "computer",
      "kompüter"
    ],
    [
      "total",
      "tüm"
    ],
    [
      "place",
      "yer"
    ],
    [
      "end",
      "son"
    ],
    [
      "following",
      "sonraki"
    ],
    [
      "him",
      "onu"
    ],
    [
      "without",
      "-siz"
    ],
    [
      "per",
      "-de"
    ],
    [
      "think",
      "sanmak"
    ],
    [
      "north",
      "şimal"
    ],
    [
      "current",
      "akım"
    ],
    [
      "big",
      "ulu"
    ],
    [
      "law",
      "kanun"
    ],
    [
      "control",
      "kumanda etmek"
    ],
    [
      "water",
      "su"
    ],
    [
      "history",
      "tarih"
    ],
    [
      "size",
      "boy"
    ],
    [
      "art",
      "sanat"
    ],
    [
      "personal",
      "zatî"
    ],
    [
      "since",
      "-den"
    ],
    [
      "shop",
      "dükkan"
    ],
    [
      "directory",
      "dizin"
    ],
    [
      "board",
      "borda"
    ],
    [
      "location",
      "yer"
    ],
    [
      "change",
      "değişim"
    ],
    [
      "white",
      "ak"
    ],
    [
      "text",
      "yazmak"
    ],
    [
      "small",
      "ufak"
    ],
    [
      "rate",
      "ücret"
    ],
    [
      "during",
      "sırasında"
    ],
    [
      "return",
      "kayıtmak"
    ],
    [
      "level",
      "düzey"
    ],
    [
      "profile",
      "yanay"
    ],
    [
      "form",
      "form"
    ],
    [
      "love",
      "sevmek"
    ],
    [
      "old",
      "eski"
    ],
    [
      "john",
      "Con"
    ],
    [
      "call",
      "aramak"
    ],
    [
      "image",
      "görüntü"
    ],
    [
      "department",
      "şube"
    ],
    [
      "title",
      "ad"
    ],
    [
      "description",
      "vasif"
    ],
    [
      "y",
      "cik"
    ],
    [
      "insurance",
      "sigortacılık"
    ],
    [
      "another",
      "başka"
    ],
    [
      "why",
      "niye"
    ],
    [
      "property",
      "emlak"
    ],
    [
      "still",
      "hâlâ"
    ],
    [
      "money",
      "akçe"
    ],
    [
      "quality",
      "nitelik"
    ],
    [
      "content",
      "içerik"
    ],
    [
      "country",
      "eyalet"
    ],
    [
      "little",
      "küçük"
    ],
    [
      "save",
      "tasarruf etmek"
    ],
    [
      "reply",
      "yanıt"
    ],
    [
      "customer",
      "alıcı"
    ],
    [
      "december",
      "yeldoksan"
    ],
    [
      "include",
      "içermek"
    ],
    [
      "value",
      "değer"
    ],
    [
      "article",
      "betke"
    ],
    [
      "man",
      "er"
    ],
    [
      "card",
      "iskambil"
    ],
    [
      "food",
      "aş"
    ],
    [
      "source",
      "memba"
    ],
    [
      "author",
      "müellif"
    ],
    [
      "different",
      "ayrı"
    ],
    [
      "press",
      "basın"
    ],
    [
      "print",
      "basmak"
    ],
    [
      "job",
      "iş"
    ],
    [
      "process",
      "işlem"
    ],
    [
      "room",
      "oda"
    ],
    [
      "stock",
      "kundak"
    ],
    [
      "training",
      "idman"
    ],
    [
      "too",
      "da"
    ],
    [
      "point",
      "puan"
    ],
    [
      "join",
      "katılmak"
    ],
    [
      "science",
      "ilim"
    ],
    [
      "west",
      "garp"
    ],
    [
      "look",
      "bakma"
    ],
    [
      "english",
      "İngiliz"
    ],
    [
      "team",
      "ekip"
    ],
    [
      "box",
      "sandık"
    ],
    [
      "gay",
      "ibne"
    ],
    [
      "thread",
      "iplik"
    ],
    [
      "week",
      "yedil"
    ],
    [
      "note",
      "not"
    ],
    [
      "live",
      "oturmak"
    ],
    [
      "table",
      "tablo"
    ],
    [
      "register",
      "yazılmak"
    ],
    [
      "however",
      "fakat"
    ],
    [
      "june",
      "bozay"
    ],
    [
      "october",
      "teşrinievvel"
    ],
    [
      "november",
      "teşrinisani"
    ],
    [
      "market",
      "pazar"
    ],
    [
      "really",
      "cidden"
    ],
    [
      "action",
      "amel"
    ],
    [
      "start",
      "başlangıç"
    ],
    [
      "series",
      "dizi"
    ],
    [
      "model",
      "maketler"
    ],
    [
      "air",
      "hava"
    ],
    [
      "industry",
      "sanayi"
    ],
    [
      "human",
      "adam"
    ],
    [
      "provided",
      "şartıyla"
    ],
    [
      "yes",
      "ha"
    ],
    [
      "second",
      "saniye"
    ],
    [
      "hot",
      "acı"
    ],
    [
      "cost",
      "mal olmak"
    ],
    [
      "march",
      "yürüyüş"
    ],
    [
      "september",
      "öğrüm"
    ],
    [
      "better",
      "yakşırak"
    ],
    [
      "say",
      "demek"
    ],
    [
      "july",
      "orakayı"
    ],
    [
      "test",
      "sınav"
    ],
    [
      "friend",
      "dost"
    ],
    [
      "come",
      "olmak"
    ],
    [
      "server",
      "hizmetçi"
    ],
    [
      "study",
      "okuma"
    ],
    [
      "application",
      "dilekçe"
    ],
    [
      "cart",
      "kağnı"
    ],
    [
      "staff",
      "çomak"
    ],
    [
      "feedback",
      "geri besleme"
    ],
    [
      "again",
      "gene"
    ],
    [
      "play",
      "çalmak"
    ],
    [
      "april",
      "açaray"
    ],
    [
      "never",
      "hiç"
    ],
    [
      "complete",
      "eksiksiz"
    ],
    [
      "street",
      "cadde"
    ],
    [
      "topic",
      "tema"
    ],
    [
      "comment",
      "yorum"
    ],
    [
      "financial",
      "mali"
    ],
    [
      "standard",
      "flama"
    ],
    [
      "tax",
      "salma"
    ],
    [
      "person",
      "kişi"
    ],
    [
      "less",
      "suz"
    ],
    [
      "blog",
      "ağ günlüğü"
    ],
    [
      "party",
      "parti"
    ],
    [
      "equipment",
      "donatma"
    ],
    [
      "student",
      "öğrenci"
    ],
    [
      "legal",
      "yasal"
    ],
    [
      "above",
      "daha"
    ],
    [
      "side",
      "yan"
    ],
    [
      "act",
      "perde"
    ],
    [
      "problem",
      "soru"
    ],
    [
      "red",
      "al"
    ],
    [
      "memory",
      "anı"
    ],
    [
      "social",
      "sosyal"
    ],
    [
      "august",
      "cırcır"
    ],
    [
      "quote",
      "söz"
    ],
    [
      "language",
      "dil"
    ],
    [
      "story",
      "hikâye"
    ],
    [
      "experience",
      "tecrübe"
    ],
    [
      "create",
      "oluşturmak"
    ],
    [
      "key",
      "tuş"
    ],
    [
      "body",
      "beden"
    ],
    [
      "young",
      "gençlik"
    ],
    [
      "important",
      "mühim"
    ],
    [
      "field",
      "tarla"
    ],
    [
      "east",
      "şark"
    ],
    [
      "paper",
      "kâğıt"
    ],
    [
      "single",
      "bekar"
    ],
    [
      "age",
      "çağ"
    ],
    [
      "club",
      "kulüp"
    ],
    [
      "example",
      "ibret"
    ],
    [
      "password",
      "şifre"
    ],
    [
      "gift",
      "armağan"
    ],
    [
      "question",
      "soru"
    ],
    [
      "hard",
      "zor"
    ],
    [
      "poker",
      "poker"
    ],
    [
      "status",
      "durum"
    ],
    [
      "browse",
      "otlamak"
    ],
    [
      "range",
      "menzil"
    ],
    [
      "building",
      "bina"
    ],
    [
      "seller",
      "bayi"
    ],
    [
      "court",
      "kort"
    ],
    [
      "february",
      "gücük"
    ],
    [
      "always",
      "hep"
    ],
    [
      "result",
      "netice"
    ],
    [
      "light",
      "hafif"
    ],
    [
      "war",
      "cenk"
    ],
    [
      "offer",
      "teklif"
    ],
    [
      "blue",
      "mavi"
    ],
    [
      "easy",
      "kolay"
    ],
    [
      "event",
      "olay"
    ],
    [
      "release",
      "neşretmek"
    ],
    [
      "analysis",
      "analiz"
    ],
    [
      "request",
      "istek"
    ],
    [
      "making",
      "yapma"
    ],
    [
      "picture",
      "çizim"
    ],
    [
      "possible",
      "olası"
    ],
    [
      "might",
      "kuvvet"
    ],
    [
      "yet",
      "henüz"
    ],
    [
      "major",
      "bölüm"
    ],
    [
      "star",
      "yıldız"
    ],
    [
      "space",
      "feza"
    ],
    [
      "committee",
      "kurul"
    ],
    [
      "hand",
      "el"
    ],
    [
      "sun",
      "gün"
    ],
    [
      "london",
      "Londra"
    ],
    [
      "washington",
      "Washington"
    ],
    [
      "meeting",
      "dernek"
    ],
    [
      "become",
      "olmak"
    ],
    [
      "interest",
      "ilgi"
    ],
    [
      "id",
      "id"
    ],
    [
      "child",
      "evlat"
    ],
    [
      "keep",
      "tutmak"
    ],
    [
      "enter",
      "işlemek"
    ],
    [
      "porn",
      "porno"
    ],
    [
      "share",
      "hisse"
    ],
    [
      "garden",
      "bahçe"
    ],
    [
      "reference",
      "kaynak"
    ],
    [
      "baby",
      "yavru"
    ],
    [
      "energy",
      "erke"
    ],
    [
      "run",
      "koşma"
    ],
    [
      "net",
      "ağ"
    ],
    [
      "film",
      "yanka"
    ],
    [
      "journal",
      "jurnal"
    ],
    [
      "try",
      "denemek"
    ],
    [
      "welcome",
      "hoş geldin"
    ],
    [
      "central",
      "orta"
    ],
    [
      "president",
      "başkan"
    ],
    [
      "notice",
      "farketmek"
    ],
    [
      "god",
      "Tanrı"
    ],
    [
      "head",
      "kafa"
    ],
    [
      "until",
      "dek"
    ],
    [
      "cell",
      "hücre"
    ],
    [
      "color",
      "ıl"
    ],
    [
      "self",
      "öz"
    ],
    [
      "council",
      "meclis"
    ],
    [
      "track",
      "parça"
    ],
    [
      "discussion",
      "bahıs"
    ],
    [
      "archive",
      "belgeliklemek"
    ],
    [
      "once",
      "bir kez"
    ],
    [
      "agreement",
      "mukavele"
    ],
    [
      "society",
      "cemiyet"
    ],
    [
      "log",
      "kütük"
    ],
    [
      "safety",
      "emniyet"
    ],
    [
      "trade",
      "takas"
    ],
    [
      "marketing",
      "marketing"
    ],
    [
      "tell",
      "demek"
    ],
    [
      "association",
      "dernek"
    ],
    [
      "fun",
      "neşeli"
    ],
    [
      "already",
      "artık"
    ],
    [
      "green",
      "yeşil"
    ],
    [
      "close",
      "örtmek"
    ],
    [
      "common",
      "yaygın"
    ],
    [
      "drive",
      "yol"
    ],
    [
      "several",
      "çeşitli"
    ],
    [
      "collection",
      "toplama"
    ],
    [
      "ask",
      "dilemek"
    ],
    [
      "display",
      "ekran"
    ],
    [
      "limited",
      "tahdit edilmiş"
    ],
    [
      "powered",
      "tahrik edilen"
    ],
    [
      "director",
      "müdür"
    ],
    [
      "daily",
      "gündelik"
    ],
    [
      "beach",
      "plaj"
    ],
    [
      "past",
      "mazi"
    ],
    [
      "natural",
      "tabii"
    ],
    [
      "period",
      "devir"
    ],
    [
      "database",
      "veritabanı"
    ],
    [
      "land",
      "stan"
    ],
    [
      "average",
      "averaj"
    ],
    [
      "technical",
      "fennî"
    ],
    [
      "window",
      "cam"
    ],
    [
      "pro",
      "lehine"
    ],
    [
      "region",
      "nahiye"
    ],
    [
      "island",
      "ada"
    ],
    [
      "record",
      "plak"
    ],
    [
      "conference",
      "toplantı"
    ],
    [
      "environment",
      "çevre"
    ],
    [
      "style",
      "biçem"
    ],
    [
      "url",
      "BKB"
    ],
    [
      "front",
      "cephe"
    ],
    [
      "statement",
      "açıklama"
    ],
    [
      "ever",
      "hiç"
    ],
    [
      "sound",
      "iyi"
    ],
    [
      "present",
      "halihazırda"
    ],
    [
      "document",
      "doküman"
    ],
    [
      "word",
      "söz"
    ],
    [
      "material",
      "madde"
    ],
    [
      "bill",
      "fatura"
    ],
    [
      "adult",
      "ergin"
    ],
    [
      "thing",
      "mal"
    ],
    [
      "cheap",
      "ucuz"
    ],
    [
      "nude",
      "çıplaklık"
    ],
    [
      "finance",
      "maliye"
    ],
    [
      "true",
      "doğru"
    ],
    [
      "mark",
      "mark"
    ],
    [
      "rock",
      "sallanmak"
    ],
    [
      "reading",
      "okuma"
    ],
    [
      "bad",
      "fena"
    ],
    [
      "plus",
      "artı"
    ],
    [
      "cover",
      "örtü"
    ],
    [
      "usually",
      "genellikle"
    ],
    [
      "together",
      "birlikte"
    ],
    [
      "fast",
      "hızlı"
    ],
    [
      "function",
      "işlev"
    ],
    [
      "fact",
      "gerçek"
    ],
    [
      "global",
      "küresel"
    ],
    [
      "meet",
      "kesişmek"
    ],
    [
      "far",
      "uzak"
    ],
    [
      "economic",
      "iktisadi"
    ],
    [
      "player",
      "oyuncu"
    ],
    [
      "lyrics",
      "söz"
    ],
    [
      "often",
      "sık sık"
    ],
    [
      "watch",
      "dikkat etmek"
    ],
    [
      "feel",
      "duymak"
    ],
    [
      "risk",
      "riziko"
    ],
    [
      "thanks",
      "teşekkürler"
    ],
    [
      "everything",
      "herşey"
    ],
    [
      "linux",
      "Linux"
    ],
    [
      "james",
      "Yakup"
    ],
    [
      "weight",
      "dambıl"
    ],
    [
      "town",
      "ilçe"
    ],
    [
      "heart",
      "kalp"
    ],
    [
      "knowledge",
      "bilim"
    ],
    [
      "magazine",
      "şarjör"
    ],
    [
      "error",
      "yanlış"
    ],
    [
      "camera",
      "kamera"
    ],
    [
      "currently",
      "şu anda"
    ],
    [
      "construction",
      "konstrüksiyon"
    ],
    [
      "clear",
      "net"
    ],
    [
      "protection",
      "muhafaza"
    ],
    [
      "loan",
      "ikraz"
    ],
    [
      "wide",
      "vasi"
    ],
    [
      "manager",
      "müdür"
    ],
    [
      "india",
      "Hint"
    ],
    [
      "sort",
      "soy"
    ],
    [
      "half",
      "buçuk"
    ],
    [
      "step",
      "adım"
    ],
    [
      "simple",
      "sade"
    ],
    [
      "quick",
      "hızlıca"
    ],
    [
      "none",
      "hiçbir"
    ],
    [
      "license",
      "lisans"
    ],
    [
      "whole",
      "tam"
    ],
    [
      "corporate",
      "tüzel"
    ],
    [
      "church",
      "cemaat"
    ],
    [
      "method",
      "tarz"
    ],
    [
      "active",
      "faal"
    ],
    [
      "practice",
      "pratik"
    ],
    [
      "hardware",
      "donanım"
    ],
    [
      "fire",
      "ateş"
    ],
    [
      "holiday",
      "tatil"
    ],
    [
      "chat",
      "çet"
    ],
    [
      "enough",
      "yeterli"
    ],
    [
      "along",
      "ileri"
    ],
    [
      "death",
      "ölüm"
    ],
    [
      "speed",
      "sürat"
    ],
    [
      "face",
      "vecih"
    ],
    [
      "brand",
      "damgalamak"
    ],
    [
      "discount",
      "iskonto"
    ],
    [
      "remember",
      "bellemek"
    ],
    [
      "oil",
      "yağ"
    ],
    [
      "bit",
      "biraz"
    ],
    [
      "yellow",
      "korkak"
    ],
    [
      "political",
      "siyasi"
    ],
    [
      "increase",
      "kâr"
    ],
    [
      "advertise",
      "reklâm yapmak"
    ],
    [
      "kingdom",
      "alem"
    ],
    [
      "base",
      "üs"
    ],
    [
      "near",
      "yakınında"
    ],
    [
      "thought",
      "fikir"
    ],
    [
      "stuff",
      "şeyler"
    ],
    [
      "french",
      "Fransız"
    ],
    [
      "entry",
      "kapı"
    ],
    [
      "stay",
      "durmak"
    ],
    [
      "nature",
      "doğa"
    ],
    [
      "summary",
      "özet"
    ],
    [
      "turn",
      "dönmek"
    ],
    [
      "mean",
      "kastetmek"
    ],
    [
      "agency",
      "acente"
    ],
    [
      "king",
      "kral"
    ],
    [
      "monday",
      "Pazartesi"
    ],
    [
      "activity",
      "etkinlik"
    ],
    [
      "copy",
      "nüsha"
    ],
    [
      "although",
      "gerçi"
    ],
    [
      "drug",
      "narkotik"
    ],
    [
      "western",
      "batısal"
    ],
    [
      "force",
      "zorlamak"
    ],
    [
      "cash",
      "para"
    ],
    [
      "bay",
      "doru"
    ],
    [
      "river",
      "ırmak"
    ],
    [
      "port",
      "iskele"
    ],
    [
      "stop",
      "durmak"
    ],
    [
      "administration",
      "idare"
    ],
    [
      "bar",
      "bar"
    ],
    [
      "double",
      "çift"
    ],
    [
      "dog",
      "it"
    ],
    [
      "build",
      "kurmak"
    ],
    [
      "screen",
      "ekran"
    ],
    [
      "exchange",
      "borsa"
    ],
    [
      "soon",
      "erken"
    ],
    [
      "continue",
      "devam etmek"
    ],
    [
      "season",
      "sezon"
    ],
    [
      "printer",
      "yazıcı"
    ],
    [
      "condition",
      "hâl"
    ],
    [
      "believe",
      "inanmak"
    ],
    [
      "effect",
      "efekt"
    ],
    [
      "mind",
      "us"
    ],
    [
      "sunday",
      "Pazar"
    ],
    [
      "selection",
      "seçilen"
    ],
    [
      "casino",
      "gazino"
    ],
    [
      "lost",
      "yitik"
    ],
    [
      "tour",
      "tur"
    ],
    [
      "volume",
      "hacim"
    ],
    [
      "cross",
      "haç"
    ],
    [
      "mortgage",
      "tutu"
    ],
    [
      "hope",
      "ümit"
    ],
    [
      "silver",
      "gümüş"
    ],
    [
      "wish",
      "dilek"
    ],
    [
      "inside",
      "içeri"
    ],
    [
      "solution",
      "çözüm"
    ],
    [
      "mature",
      "ergin"
    ],
    [
      "role",
      "rol"
    ],
    [
      "rather",
      "bayağı"
    ],
    [
      "nothing",
      "önemsiz"
    ],
    [
      "certain",
      "malum"
    ],
    [
      "executive",
      "yürütme"
    ],
    [
      "necessary",
      "elzem"
    ],
    [
      "clothing",
      "giyim kuşam"
    ],
    [
      "particular",
      "tikel"
    ],
    [
      "fine",
      "ceza"
    ],
    [
      "hour",
      "sögen"
    ],
    [
      "advice",
      "öneri"
    ],
    [
      "military",
      "harbî"
    ],
    [
      "decision",
      "hüküm"
    ],
    [
      "leave",
      "çıkmak"
    ],
    [
      "woman",
      "gacı"
    ],
    [
      "middle",
      "orta"
    ],
    [
      "move",
      "devinmek"
    ],
    [
      "division",
      "bölme"
    ],
    [
      "object",
      "nesne"
    ],
    [
      "lesbian",
      "ablacı"
    ],
    [
      "appropriate",
      "lâyık"
    ],
    [
      "machine",
      "makina"
    ],
    [
      "logo",
      "logolar"
    ],
    [
      "length",
      "boy"
    ],
    [
      "nice",
      "iyi"
    ],
    [
      "client",
      "istemci"
    ],
    [
      "ok",
      "tamam"
    ],
    [
      "capital",
      "anamal"
    ],
    [
      "follow",
      "takip etmek"
    ],
    [
      "sample",
      "numune"
    ],
    [
      "investment",
      "envestisman"
    ],
    [
      "saturday",
      "Cumartesi"
    ],
    [
      "culture",
      "hars"
    ],
    [
      "band",
      "bando"
    ],
    [
      "registration",
      "tescil"
    ],
    [
      "thursday",
      "cuma akşamı"
    ],
    [
      "consumer",
      "konsomatör"
    ],
    [
      "hi",
      "selam"
    ],
    [
      "airport",
      "havaalanı"
    ],
    [
      "artist",
      "ressam"
    ],
    [
      "outside",
      "harici"
    ],
    [
      "furniture",
      "möble"
    ],
    [
      "channel",
      "kanal"
    ],
    [
      "letter",
      "name"
    ],
    [
      "mode",
      "mod"
    ],
    [
      "wednesday",
      "Çarşamba"
    ],
    [
      "structure",
      "yapı"
    ],
    [
      "contract",
      "kontrat"
    ],
    [
      "button",
      "tuş"
    ],
    [
      "male",
      "eril"
    ],
    [
      "custom",
      "görenek"
    ],
    [
      "editor",
      "editör"
    ],
    [
      "inn",
      "konak"
    ],
    [
      "cause",
      "neden"
    ],
    [
      "potential",
      "potansiyel"
    ],
    [
      "song",
      "türkü"
    ],
    [
      "late",
      "merhum"
    ],
    [
      "featured",
      "vasıflı"
    ],
    [
      "idea",
      "fikir"
    ],
    [
      "female",
      "bayan"
    ],
    [
      "responsible",
      "mesul"
    ],
    [
      "win",
      "yenmek"
    ],
    [
      "reason",
      "neden"
    ],
    [
      "tool",
      "alet"
    ],
    [
      "spring",
      "yay"
    ],
    [
      "foundation",
      "temel"
    ],
    [
      "answer",
      "yanıt"
    ],
    [
      "voice",
      "ses"
    ],
    [
      "friendly",
      "dost"
    ],
    [
      "schedule",
      "cetvel"
    ],
    [
      "communication",
      "komünikasyon"
    ],
    [
      "purpose",
      "maksat"
    ],
    [
      "feature",
      "özellik"
    ],
    [
      "bed",
      "döşek"
    ],
    [
      "police",
      "sakçı"
    ],
    [
      "brown",
      "konur"
    ],
    [
      "physical",
      "fiziki"
    ],
    [
      "hill",
      "yokuş"
    ],
    [
      "medicine",
      "em"
    ],
    [
      "deal",
      "atmak"
    ],
    [
      "chicago",
      "Şikago"
    ],
    [
      "glass",
      "cam"
    ],
    [
      "happy",
      "kutlu"
    ],
    [
      "developed",
      "inkişaf etmiş"
    ],
    [
      "safe",
      "emin"
    ],
    [
      "unique",
      "ünik"
    ],
    [
      "survey",
      "tetkik"
    ],
    [
      "telephone",
      "alısün"
    ],
    [
      "sport",
      "yöndün"
    ],
    [
      "ready",
      "anık"
    ],
    [
      "feed",
      "beslemek"
    ],
    [
      "animal",
      "hayvan"
    ],
    [
      "population",
      "nüfus"
    ],
    [
      "regular",
      "normal"
    ],
    [
      "secure",
      "sağlam"
    ],
    [
      "navigation",
      "yolbul"
    ],
    [
      "therefore",
      "dolayısıyla"
    ],
    [
      "ass",
      "göt"
    ],
    [
      "simply",
      "sadece"
    ],
    [
      "evidence",
      "ispat"
    ],
    [
      "station",
      "gar"
    ],
    [
      "christian",
      "Hıristiyan"
    ],
    [
      "round",
      "yuvarlak"
    ],
    [
      "master",
      "usta"
    ],
    [
      "probably",
      "her halde"
    ],
    [
      "sea",
      "derya"
    ],
    [
      "blood",
      "kan"
    ],
    [
      "cut",
      "kesim"
    ],
    [
      "improve",
      "iyileştirmek"
    ],
    [
      "connection",
      "bağ"
    ],
    [
      "publisher",
      "yayıncı"
    ],
    [
      "hall",
      "hol"
    ],
    [
      "earth",
      "Arz"
    ],
    [
      "impact",
      "etki"
    ],
    [
      "transfer",
      "yollamak"
    ],
    [
      "kitchen",
      "kan"
    ],
    [
      "strong",
      "gür"
    ],
    [
      "wedding",
      "nikâh"
    ],
    [
      "hospital",
      "emlerge"
    ],
    [
      "overview",
      "kısaca gözden geçirme"
    ],
    [
      "ship",
      "luk"
    ],
    [
      "disease",
      "sayrılık"
    ],
    [
      "hair",
      "kıl"
    ],
    [
      "basis",
      "temel"
    ],
    [
      "command",
      "komut"
    ],
    [
      "award",
      "mükafat"
    ],
    [
      "distance",
      "ara"
    ],
    [
      "peter",
      "Petros"
    ],
    [
      "ensure",
      "sağlamak"
    ],
    [
      "wall",
      "duvar"
    ],
    [
      "pussy",
      "am"
    ],
    [
      "success",
      "sükse"
    ],
    [
      "operation",
      "işlem"
    ],
    [
      "existing",
      "varolan"
    ],
    [
      "quite",
      "oldukça"
    ],
    [
      "amazon",
      "Amazon Nehri"
    ],
    [
      "warning",
      "uyarı"
    ],
    [
      "wine",
      "içki"
    ],
    [
      "horse",
      "at"
    ],
    [
      "vote",
      "rey"
    ],
    [
      "forward",
      "ön"
    ],
    [
      "significant",
      "manalı"
    ],
    [
      "owner",
      "iye"
    ],
    [
      "useful",
      "yararlı"
    ],
    [
      "directly",
      "doğrudan"
    ],
    [
      "son",
      "oğlan"
    ],
    [
      "rule",
      "kaide"
    ],
    [
      "mother",
      "ana"
    ],
    [
      "authority",
      "uzman"
    ],
    [
      "xml",
      "XML"
    ],
    [
      "traffic",
      "seyrüsefer"
    ],
    [
      "strategy",
      "izlem"
    ],
    [
      "agent",
      "vekil"
    ],
    [
      "modern",
      "muasır"
    ],
    [
      "senior",
      "kıdemli"
    ],
    [
      "sexy",
      "dehşet"
    ],
    [
      "door",
      "gümrük kapısı"
    ],
    [
      "trial",
      "deney"
    ],
    [
      "canadian",
      "Kanadaca"
    ],
    [
      "cool",
      "sakin"
    ],
    [
      "normal",
      "olağan"
    ],
    [
      "entire",
      "tam"
    ],
    [
      "positive",
      "emin"
    ],
    [
      "chinese",
      "Çince"
    ],
    [
      "opinion",
      "fikir"
    ],
    [
      "football",
      "tepik"
    ],
    [
      "abstract",
      "soyut"
    ],
    [
      "develop",
      "geliştirmek"
    ],
    [
      "alternative",
      "farklı"
    ],
    [
      "responsibility",
      "mesuliyet"
    ],
    [
      "resolution",
      "çözünürlük"
    ],
    [
      "java",
      "Java"
    ],
    [
      "guest",
      "konuk"
    ],
    [
      "pass",
      "geçiş izni"
    ],
    [
      "trust",
      "tröst"
    ],
    [
      "van",
      "furgon"
    ],
    [
      "session",
      "oturum"
    ],
    [
      "photography",
      "fotoğraf"
    ],
    [
      "century",
      "asır"
    ],
    [
      "academic",
      "bilim işçisi"
    ],
    [
      "assistance",
      "medet"
    ],
    [
      "skin",
      "deri"
    ],
    [
      "indian",
      "Hintli"
    ],
    [
      "expected",
      "beklenen"
    ],
    [
      "ring",
      "yüzük"
    ],
    [
      "grade",
      "derece"
    ],
    [
      "dating",
      "tarih atma"
    ],
    [
      "mountain",
      "dağ"
    ],
    [
      "vehicle",
      "vasıta"
    ],
    [
      "behind",
      "arkasında"
    ],
    [
      "panel",
      "açık oturum"
    ],
    [
      "floor",
      "kat"
    ],
    [
      "german",
      "Alman"
    ],
    [
      "match",
      "çalma"
    ],
    [
      "default",
      "gıyap"
    ],
    [
      "require",
      "gerektirmek"
    ],
    [
      "deep",
      "koyu"
    ],
    [
      "otherwise",
      "yoksa"
    ],
    [
      "rest",
      "mola"
    ],
    [
      "plant",
      "nebat"
    ],
    [
      "transportation",
      "nakliye"
    ],
    [
      "pool",
      "gölet"
    ],
    [
      "politics",
      "siyaset"
    ],
    [
      "partner",
      "eş"
    ],
    [
      "disclaimer",
      "sorumluluk reddi"
    ],
    [
      "faculty",
      "yeti"
    ],
    [
      "fish",
      "balık"
    ],
    [
      "string",
      "ip"
    ],
    [
      "sense",
      "anlam"
    ],
    [
      "stage",
      "staj"
    ],
    [
      "detailed",
      "detaylı"
    ],
    [
      "japanese",
      "Japonca"
    ],
    [
      "race",
      "ırk"
    ],
    [
      "background",
      "fon"
    ],
    [
      "target",
      "hedef"
    ],
    [
      "except",
      "başka"
    ],
    [
      "character",
      "karakter"
    ],
    [
      "ability",
      "bilirlik"
    ],
    [
      "maybe",
      "olabilir"
    ],
    [
      "southern",
      "güneyli"
    ],
    [
      "rape",
      "göğen"
    ],
    [
      "battery",
      "akü"
    ],
    [
      "youth",
      "genç"
    ],
    [
      "pressure",
      "baskı"
    ],
    [
      "television",
      "televizyon"
    ],
    [
      "core",
      "öz"
    ],
    [
      "break",
      "kırmak"
    ],
    [
      "dance",
      "bar"
    ],
    [
      "wood",
      "ağaç"
    ],
    [
      "defined",
      "tanımlanan"
    ],
    [
      "fee",
      "harç"
    ],
    [
      "studio",
      "stüdyo"
    ],
    [
      "virtual",
      "neredeyse"
    ],
    [
      "device",
      "alet"
    ],
    [
      "remote",
      "uzaktan kontrol"
    ],
    [
      "dark",
      "koyu"
    ],
    [
      "apple",
      "tüffah"
    ],
    [
      "theory",
      "teori"
    ],
    [
      "enjoy",
      "eylenmek"
    ],
    [
      "remove",
      "çıkarmak"
    ],
    [
      "aid",
      "medet"
    ],
    [
      "surface",
      "satıh"
    ],
    [
      "minimum",
      "en düşük"
    ],
    [
      "block",
      "kadastro adası"
    ],
    [
      "repair",
      "tamir etmek"
    ],
    [
      "fair",
      "açık"
    ],
    [
      "fixed",
      "sabit"
    ],
    [
      "wrong",
      "hatalı"
    ],
    [
      "beginning",
      "iptida"
    ],
    [
      "desktop",
      "masaüstü bilgisayar"
    ],
    [
      "capacity",
      "yetki"
    ],
    [
      "father",
      "ata"
    ],
    [
      "electric",
      "elektrik"
    ],
    [
      "saw",
      "bıçkı"
    ],
    [
      "officer",
      "subay"
    ],
    [
      "driver",
      "sürücü"
    ],
    [
      "dead",
      "ölmüş"
    ],
    [
      "respect",
      "hürmet"
    ],
    [
      "unknown",
      "meçhul"
    ],
    [
      "restaurant",
      "restoran"
    ],
    [
      "trip",
      "gezi"
    ],
    [
      "worth",
      "layık"
    ],
    [
      "poor",
      "rezil"
    ],
    [
      "teacher",
      "hoca"
    ],
    [
      "relationship",
      "ilişki"
    ],
    [
      "fucking",
      "pis"
    ],
    [
      "georgia",
      "Gürcistan"
    ],
    [
      "peace",
      "sulh"
    ],
    [
      "traditional",
      "gelenekçi"
    ],
    [
      "campus",
      "yerleşke"
    ],
    [
      "coast",
      "kıyı"
    ],
    [
      "benefit",
      "fayda"
    ],
    [
      "progress",
      "terakki"
    ],
    [
      "lord",
      "efendi"
    ],
    [
      "grant",
      "vermek"
    ],
    [
      "agree",
      "anlaşmak"
    ],
    [
      "hear",
      "işitmek"
    ],
    [
      "sometimes",
      "ara sıra"
    ],
    [
      "fan",
      "hayran"
    ],
    [
      "interesting",
      "ilginç"
    ],
    [
      "wife",
      "avrat"
    ],
    [
      "former",
      "ilk"
    ],
    [
      "implementation",
      "uygulama"
    ],
    [
      "th",
      "nci"
    ],
    [
      "cat",
      "enik"
    ],
    [
      "die",
      "vefat etmek"
    ],
    [
      "jack",
      "Yakub"
    ],
    [
      "flow",
      "met"
    ],
    [
      "literature",
      "yazın"
    ],
    [
      "parent",
      "ebeveyn"
    ],
    [
      "spanish",
      "İspanyol"
    ],
    [
      "michigan",
      "Mişigan"
    ],
    [
      "scale",
      "tırmanmak"
    ],
    [
      "stand",
      "dayanmak"
    ],
    [
      "economy",
      "iktisat"
    ],
    [
      "frame",
      "çerçeve"
    ],
    [
      "definition",
      "tarif"
    ],
    [
      "secretary",
      "katip"
    ],
    [
      "networking",
      "ağ kurma"
    ],
    [
      "path",
      "yol"
    ],
    [
      "australian",
      "Avustralyalı"
    ],
    [
      "employee",
      "personel"
    ],
    [
      "bottom",
      "dip"
    ],
    [
      "detail",
      "teferruat"
    ],
    [
      "clean",
      "arı"
    ],
    [
      "switch",
      "nokta"
    ],
    [
      "russian",
      "Rusça"
    ],
    [
      "african",
      "Afrika"
    ],
    [
      "relevant",
      "ilgili"
    ],
    [
      "bible",
      "İncil"
    ],
    [
      "cup",
      "tas"
    ],
    [
      "basket",
      "sepet"
    ],
    [
      "weekly",
      "her hafta"
    ],
    [
      "installation",
      "kurulum"
    ],
    [
      "demand",
      "istek"
    ],
    [
      "square",
      "meydan"
    ],
    [
      "attention",
      "özen"
    ],
    [
      "advance",
      "ilerlemek"
    ],
    [
      "skip",
      "geçmek"
    ],
    [
      "diet",
      "perhiz"
    ],
    [
      "army",
      "leşker"
    ],
    [
      "auction",
      "mezat"
    ],
    [
      "lee",
      "boca"
    ],
    [
      "difference",
      "fark"
    ],
    [
      "nation",
      "ulus"
    ],
    [
      "piece",
      "parça"
    ],
    [
      "sheet",
      "varak"
    ],
    [
      "firm",
      "firma"
    ],
    [
      "jump",
      "sekmek"
    ],
    [
      "random",
      "rastgele"
    ],
    [
      "pricing",
      "ücretlendirme"
    ],
    [
      "minister",
      "vezir"
    ],
    [
      "fashion",
      "tarz"
    ],
    [
      "forest",
      "ormanlaştırmak"
    ],
    [
      "coverage",
      "kapsama alanı"
    ],
    [
      "chance",
      "şans"
    ],
    [
      "ball",
      "top"
    ],
    [
      "listen",
      "duymak"
    ],
    [
      "goal",
      "gol"
    ],
    [
      "successful",
      "muvaffak"
    ],
    [
      "wind",
      "yel"
    ],
    [
      "situation",
      "hal"
    ],
    [
      "publishing",
      "yayıncılık"
    ],
    [
      "currency",
      "para"
    ],
    [
      "temperature",
      "ateş"
    ],
    [
      "palm",
      "kefne"
    ],
    [
      "patient",
      "sabırlı"
    ],
    [
      "actual",
      "esas"
    ],
    [
      "historical",
      "tarihî"
    ],
    [
      "difficult",
      "güç"
    ],
    [
      "scientific",
      "ilmî"
    ],
    [
      "satellite",
      "uydu"
    ],
    [
      "fit",
      "uydurmak"
    ],
    [
      "village",
      "nahiye"
    ],
    [
      "amateur",
      "amatör"
    ],
    [
      "pain",
      "acı"
    ],
    [
      "coffee",
      "kahve"
    ],
    [
      "cum",
      "döl"
    ],
    [
      "buyer",
      "müşteri"
    ],
    [
      "easily",
      "kolaylıkla"
    ],
    [
      "edge",
      "avantaj"
    ],
    [
      "functional",
      "fonksiyonel"
    ],
    [
      "root",
      "kök"
    ],
    [
      "ice",
      "soğutmak"
    ],
    [
      "pink",
      "pembe"
    ],
    [
      "initial",
      "başlak"
    ],
    [
      "league",
      "fersah"
    ],
    [
      "waste",
      "kayıp"
    ],
    [
      "optional",
      "istemli"
    ],
    [
      "dictionary",
      "lügat"
    ],
    [
      "cold",
      "ingin"
    ],
    [
      "chair",
      "koltuk"
    ],
    [
      "fishing",
      "balık tutma"
    ],
    [
      "effort",
      "ceht"
    ],
    [
      "phase",
      "evre"
    ],
    [
      "bag",
      "torba"
    ],
    [
      "fantasy",
      "fantazi"
    ],
    [
      "professor",
      "hoca"
    ],
    [
      "context",
      "kontekst"
    ],
    [
      "shirt",
      "pirahen"
    ],
    [
      "generally",
      "çoğunlukla"
    ],
    [
      "foot",
      "fit"
    ],
    [
      "mass",
      "kitle"
    ],
    [
      "count",
      "saymak"
    ],
    [
      "breast",
      "meme"
    ],
    [
      "quickly",
      "tez"
    ],
    [
      "religion",
      "inanç"
    ],
    [
      "claim",
      "öne sürmek"
    ],
    [
      "permission",
      "müsaade"
    ],
    [
      "surgery",
      "cerrahi"
    ],
    [
      "wild",
      "yabani"
    ],
    [
      "generation",
      "kuşak"
    ],
    [
      "miss",
      "kaçırmak"
    ],
    [
      "chemical",
      "kimyevî"
    ],
    [
      "task",
      "ödev"
    ],
    [
      "component",
      "parça"
    ],
    [
      "exercise",
      "temrin"
    ],
    [
      "guarantee",
      "güvence"
    ],
    [
      "leader",
      "öncü"
    ],
    [
      "diamond",
      "pırlanta"
    ],
    [
      "alone",
      "tek"
    ],
    [
      "keyword",
      "anahtar söz"
    ],
    [
      "flight",
      "uçma"
    ],
    [
      "congress",
      "kongre"
    ],
    [
      "username",
      "kullanıcı ismi"
    ],
    [
      "walk",
      "gezinti"
    ],
    [
      "fuck",
      "göt"
    ],
    [
      "italian",
      "İtalyanca"
    ],
    [
      "supported",
      "destekli"
    ],
    [
      "pocket",
      "cep"
    ],
    [
      "rose",
      "gül"
    ],
    [
      "freedom",
      "azatlık"
    ],
    [
      "argument",
      "sav"
    ],
    [
      "competition",
      "yarış"
    ],
    [
      "joint",
      "dal"
    ],
    [
      "upgrade",
      "yükseltmek"
    ],
    [
      "factor",
      "faktör"
    ],
    [
      "stream",
      "akım"
    ],
    [
      "pick",
      "ajine"
    ],
    [
      "hearing",
      "duyma"
    ],
    [
      "therapy",
      "tedavi"
    ],
    [
      "serious",
      "salmaklı"
    ],
    [
      "prime",
      "asal"
    ],
    [
      "limit",
      "kısıtlamak"
    ],
    [
      "bondage",
      "görev"
    ],
    [
      "creek",
      "dere"
    ],
    [
      "myself",
      "kendim"
    ],
    [
      "platform",
      "platform"
    ],
    [
      "affiliate",
      "katmak"
    ],
    [
      "immediately",
      "anında"
    ],
    [
      "defense",
      "koruma"
    ],
    [
      "integrated",
      "entegre"
    ],
    [
      "merchant",
      "tacir"
    ],
    [
      "comprehensive",
      "şamil"
    ],
    [
      "expert",
      "usta"
    ],
    [
      "universal",
      "evrensel"
    ],
    [
      "drop",
      "meyan"
    ],
    [
      "presentation",
      "sunum"
    ],
    [
      "orange",
      "turuncu"
    ],
    [
      "theme",
      "ana konu"
    ],
    [
      "rich",
      "varsıl"
    ],
    [
      "spirit",
      "tin"
    ],
    [
      "acceptance",
      "akseptans"
    ],
    [
      "seem",
      "gözükmek"
    ],
    [
      "touch",
      "değmek"
    ],
    [
      "hire",
      "işe almak"
    ],
    [
      "election",
      "saylav"
    ],
    [
      "suggest",
      "önermek"
    ],
    [
      "branch",
      "dal"
    ],
    [
      "serve",
      "servis yapmak"
    ],
    [
      "magic",
      "sihir"
    ],
    [
      "smart",
      "zeki"
    ],
    [
      "latin",
      "Latin Amerikalı"
    ],
    [
      "multimedia",
      "çoklu ortam"
    ],
    [
      "avoid",
      "savuşturmak"
    ],
    [
      "corner",
      "köşe"
    ],
    [
      "rank",
      "paye"
    ],
    [
      "element",
      "unsur"
    ],
    [
      "virus",
      "virüs"
    ],
    [
      "abuse",
      "suistimal"
    ],
    [
      "separate",
      "bölmek"
    ],
    [
      "quarter",
      "çeyrekyıl"
    ],
    [
      "procedure",
      "işlem"
    ],
    [
      "religious",
      "dini"
    ],
    [
      "breakfast",
      "kahvaltı yapmak"
    ],
    [
      "column",
      "kolon"
    ],
    [
      "faith",
      "iman"
    ],
    [
      "developer",
      "geliştirici"
    ],
    [
      "reach",
      "erişmek"
    ],
    [
      "comparison",
      "mukayese"
    ],
    [
      "mental",
      "zihinsel"
    ],
    [
      "moment",
      "an"
    ],
    [
      "sequence",
      "sekans"
    ],
    [
      "attack",
      "hamle"
    ],
    [
      "sorry",
      "pardon"
    ],
    [
      "damage",
      "hasar"
    ],
    [
      "snow",
      "kar"
    ],
    [
      "truth",
      "gerçek"
    ],
    [
      "counter",
      "tezgah"
    ],
    [
      "failure",
      "arıza"
    ],
    [
      "automatically",
      "otomatikman"
    ],
    [
      "bridge",
      "briç"
    ],
    [
      "baseball",
      "beyzbol topu"
    ],
    [
      "approval",
      "onay"
    ],
    [
      "clubs",
      "ispati"
    ],
    [
      "equal",
      "eşleşmek"
    ],
    [
      "adventure",
      "macera"
    ],
    [
      "profit",
      "fayda"
    ],
    [
      "assistant",
      "muavin"
    ],
    [
      "advertisement",
      "ilan"
    ],
    [
      "workshop",
      "çalıştay"
    ],
    [
      "fort",
      "korugan"
    ],
    [
      "lighting",
      "ışıklandırma"
    ],
    [
      "funny",
      "komik"
    ],
    [
      "brother",
      "ağabey"
    ],
    [
      "portable",
      "seyyar"
    ],
    [
      "pattern",
      "örüntü"
    ],
    [
      "boat",
      "gemi"
    ],
    [
      "named",
      "isimli"
    ],
    [
      "icon",
      "ikon"
    ],
    [
      "direction",
      "istikamet"
    ],
    [
      "basketball",
      "basket"
    ],
    [
      "evening",
      "suare"
    ],
    [
      "assembly",
      "dernek"
    ],
    [
      "mouse",
      "sıçan"
    ],
    [
      "signal",
      "işaret"
    ],
    [
      "criminal",
      "kriminel"
    ],
    [
      "brain",
      "beyin"
    ],
    [
      "dream",
      "düş"
    ],
    [
      "false",
      "sahte"
    ],
    [
      "felt",
      "aba"
    ],
    [
      "personnel",
      "kadro"
    ],
    [
      "soul",
      "can"
    ],
    [
      "flag",
      "liva"
    ],
    [
      "hr",
      "sa."
    ],
    [
      "hello",
      "alo"
    ],
    [
      "anonymous",
      "isimsiz"
    ],
    [
      "straight",
      "doğru"
    ],
    [
      "script",
      "hat"
    ],
    [
      "tag",
      "elim sende"
    ],
    [
      "interview",
      "röportaj"
    ],
    [
      "framework",
      "karkas"
    ],
    [
      "disk",
      "plak"
    ],
    [
      "queen",
      "vezir"
    ],
    [
      "fix",
      "tamir etmek"
    ],
    [
      "handle",
      "kol"
    ],
    [
      "sweet",
      "tatlı"
    ],
    [
      "desk",
      "büro"
    ],
    [
      "vice",
      "fuhuş"
    ],
    [
      "associate",
      "ortak"
    ],
    [
      "behavior",
      "tutum"
    ],
    [
      "ray",
      "ışın"
    ],
    [
      "revenue",
      "varidat"
    ],
    [
      "duty",
      "gümrük"
    ],
    [
      "bear",
      "götürmek"
    ],
    [
      "gain",
      "kazanç"
    ],
    [
      "festival",
      "bayram"
    ],
    [
      "ocean",
      "ana deniz"
    ],
    [
      "lack",
      "noksan"
    ],
    [
      "whatever",
      "her neyse"
    ],
    [
      "laptop",
      "dizüstü"
    ],
    [
      "train",
      "katar"
    ],
    [
      "exactly",
      "kesinlikle"
    ],
    [
      "dry",
      "sek"
    ],
    [
      "explore",
      "incelemek"
    ],
    [
      "spa",
      "ılıca"
    ],
    [
      "concept",
      "fikir"
    ],
    [
      "nearly",
      "hemen hemen"
    ],
    [
      "reality",
      "realite"
    ],
    [
      "origin",
      "kaynak"
    ],
    [
      "billion",
      "trilyon"
    ],
    [
      "intelligence",
      "akıl"
    ],
    [
      "con",
      "üçkâğıt"
    ],
    [
      "route",
      "yol"
    ],
    [
      "broken",
      "kırık"
    ],
    [
      "zoom",
      "zoomlamak"
    ],
    [
      "blow",
      "esmek"
    ],
    [
      "battle",
      "cenk"
    ],
    [
      "speak",
      "yazışma"
    ],
    [
      "query",
      "sorgu"
    ],
    [
      "expression",
      "ibare"
    ],
    [
      "speech",
      "söz"
    ],
    [
      "strategic",
      "stratejik"
    ],
    [
      "judge",
      "yargıç"
    ],
    [
      "spam",
      "çöp ileti"
    ],
    [
      "economics",
      "iktisat"
    ],
    [
      "compatible",
      "bağdaşan"
    ],
    [
      "fight",
      "dövüş"
    ],
    [
      "apartment",
      "apartman dairesi"
    ],
    [
      "height",
      "yükseklik"
    ],
    [
      "speaker",
      "spiker"
    ],
    [
      "obtain",
      "almak"
    ],
    [
      "recreation",
      "rekreasyon"
    ],
    [
      "designer",
      "dizayncı"
    ],
    [
      "remain",
      "kalmak"
    ],
    [
      "marriage",
      "evlilik"
    ],
    [
      "roll",
      "yuvarlamak"
    ],
    [
      "secret",
      "giz"
    ],
    [
      "bath",
      "banyo"
    ],
    [
      "negative",
      "olumsuz"
    ],
    [
      "theater",
      "kökçan"
    ],
    [
      "translation",
      "çeviri"
    ],
    [
      "font",
      "yazıtipi"
    ],
    [
      "joseph",
      "Yusuf"
    ],
    [
      "protected",
      "korunmuş"
    ],
    [
      "proposal",
      "öneri"
    ],
    [
      "birthday",
      "yaş günü"
    ],
    [
      "fail",
      "sınıfta kalmak"
    ],
    [
      "slightly",
      "biraz"
    ],
    [
      "legislation",
      "kanun"
    ],
    [
      "wear",
      "takmak"
    ],
    [
      "representative",
      "vekil"
    ],
    [
      "frequency",
      "sıklık"
    ],
    [
      "minor",
      "tâlî"
    ],
    [
      "finish",
      "bitmek"
    ],
    [
      "reduced",
      "ucuzlatılmış"
    ],
    [
      "physics",
      "doğam"
    ],
    [
      "rare",
      "ender"
    ],
    [
      "row",
      "satır"
    ],
    [
      "administrator",
      "yönetici"
    ],
    [
      "cycle",
      "program"
    ],
    [
      "dual",
      "ikil"
    ],
    [
      "sleep",
      "uyku"
    ],
    [
      "pharmacy",
      "eczacılık"
    ],
    [
      "creation",
      "yaratı"
    ],
    [
      "hunter",
      "av köpeği"
    ],
    [
      "lady",
      "bayan"
    ],
    [
      "crystal",
      "billur"
    ],
    [
      "famous",
      "ünlü"
    ],
    [
      "writer",
      "yazıcı"
    ],
    [
      "chairman",
      "reis"
    ],
    [
      "drink",
      "meşrubat"
    ],
    [
      "academy",
      "akademi"
    ],
    [
      "gender",
      "cins"
    ],
    [
      "agriculture",
      "ziraat"
    ],
    [
      "cleaning",
      "temizlik"
    ],
    [
      "portfolio",
      "portföy"
    ],
    [
      "infrastructure",
      "enfrastrüktür"
    ],
    [
      "regulation",
      "düzenleme"
    ],
    [
      "reduction",
      "redüksiyon"
    ],
    [
      "aim",
      "maksat"
    ],
    [
      "cape",
      "pelerin"
    ],
    [
      "meaning",
      "mana"
    ],
    [
      "tip",
      "tüyo"
    ],
    [
      "mine",
      "lağım"
    ],
    [
      "soccer",
      "ayak topu"
    ],
    [
      "import",
      "ithalat"
    ],
    [
      "instant",
      "hazır"
    ],
    [
      "majority",
      "ekseriyet"
    ],
    [
      "christ",
      "İsa"
    ],
    [
      "moon",
      "kamer"
    ],
    [
      "participation",
      "iştirak"
    ],
    [
      "fly",
      "uçmak"
    ],
    [
      "combination",
      "kombinasyon"
    ],
    [
      "amendment",
      "ıslah"
    ],
    [
      "despite",
      "karşın"
    ],
    [
      "strength",
      "güç"
    ],
    [
      "turkey",
      "culuk"
    ],
    [
      "fear",
      "ürkmek"
    ],
    [
      "phoenix",
      "Simurg"
    ],
    [
      "convention",
      "âdet"
    ],
    [
      "principal",
      "müdür"
    ],
    [
      "daughter",
      "kız evlat"
    ],
    [
      "comfort",
      "konfor"
    ],
    [
      "cruise",
      "gemi seyahati"
    ],
    [
      "bonus",
      "ek"
    ],
    [
      "bookmark",
      "yer imi"
    ],
    [
      "beat",
      "yenmek"
    ],
    [
      "household",
      "hanehalkı"
    ],
    [
      "tea",
      "çay"
    ],
    [
      "dress",
      "giysi"
    ],
    [
      "contemporary",
      "çağdaş"
    ],
    [
      "sky",
      "gökyüzü"
    ],
    [
      "rom",
      "Çingene"
    ],
    [
      "happen",
      "olmak"
    ],
    [
      "hide",
      "gizlemek"
    ],
    [
      "gambling",
      "meysir"
    ],
    [
      "clothes",
      "giyim"
    ],
    [
      "luxury",
      "bolluk"
    ],
    [
      "newspaper",
      "gaste"
    ],
    [
      "layer",
      "tabaka"
    ],
    [
      "slow",
      "ağır"
    ],
    [
      "nine",
      "dokuzlu"
    ],
    [
      "spot",
      "leke"
    ],
    [
      "taylor",
      "Terzioğlu"
    ],
    [
      "spend",
      "geçirmek"
    ],
    [
      "factory",
      "tesis"
    ],
    [
      "interior",
      "içteki"
    ],
    [
      "promotion",
      "promosyon"
    ],
    [
      "relative",
      "izafi"
    ],
    [
      "dot",
      "nokta"
    ],
    [
      "identity",
      "kimlik"
    ],
    [
      "conversion",
      "tahvil"
    ],
    [
      "feeling",
      "his"
    ],
    [
      "hidden",
      "saklı"
    ],
    [
      "relief",
      "rölyef"
    ],
    [
      "influence",
      "tesir"
    ],
    [
      "importance",
      "ehemmiyet"
    ],
    [
      "rain",
      "yağış"
    ],
    [
      "onto",
      "üstüne"
    ],
    [
      "planet",
      "planet"
    ],
    [
      "recipe",
      "tarif"
    ],
    [
      "permit",
      "imkan yaratmak"
    ],
    [
      "proof",
      "delil"
    ],
    [
      "hole",
      "delik"
    ],
    [
      "ride",
      "binmek"
    ],
    [
      "bureau",
      "şifonyer"
    ],
    [
      "stress",
      "feşer"
    ],
    [
      "cream",
      "krem"
    ],
    [
      "advisor",
      "müşavir"
    ],
    [
      "aware",
      "uyanık"
    ],
    [
      "shape",
      "form"
    ],
    [
      "irish",
      "İrlandaca"
    ],
    [
      "euro",
      "euro"
    ],
    [
      "generic",
      "eşdeğer"
    ],
    [
      "peak",
      "tepe"
    ],
    [
      "exist",
      "varoluş"
    ],
    [
      "wheel",
      "jant"
    ],
    [
      "transit",
      "transit"
    ],
    [
      "dick",
      "kuş"
    ],
    [
      "compact",
      "tıkız"
    ],
    [
      "poetry",
      "şiir"
    ],
    [
      "angel",
      "melek"
    ],
    [
      "bell",
      "zil"
    ],
    [
      "attempt",
      "suikast"
    ],
    [
      "accordance",
      "uyum"
    ],
    [
      "noise",
      "şıltak"
    ],
    [
      "array",
      "adet"
    ],
    [
      "accurate",
      "dakik"
    ],
    [
      "climate",
      "abuhava"
    ],
    [
      "pin",
      "labut"
    ],
    [
      "alcohol",
      "ruh"
    ],
    [
      "greek",
      "Yunan"
    ],
    [
      "annotation",
      "dipnot"
    ],
    [
      "sister",
      "abla"
    ],
    [
      "raw",
      "ham"
    ],
    [
      "explain",
      "izah etmek"
    ],
    [
      "establish",
      "yapmak"
    ],
    [
      "sharp",
      "tiz"
    ],
    [
      "lane",
      "kulvar"
    ],
    [
      "paragraph",
      "fıkra"
    ],
    [
      "compensation",
      "ödence"
    ],
    [
      "export",
      "ihraç"
    ],
    [
      "aircraft",
      "hava aracı"
    ],
    [
      "conflict",
      "anlaşmazlık"
    ],
    [
      "occur",
      "hatırlamak"
    ],
    [
      "mississippi",
      "Mississippi Nehri"
    ],
    [
      "concern",
      "özen"
    ],
    [
      "heritage",
      "adet"
    ],
    [
      "trouble",
      "efor"
    ],
    [
      "spread",
      "sürmek"
    ],
    [
      "coach",
      "koç"
    ],
    [
      "audience",
      "okuyucu"
    ],
    [
      "participate",
      "iştirak etmek"
    ],
    [
      "plug",
      "tıkaç"
    ],
    [
      "specialist",
      "uzman"
    ],
    [
      "cook",
      "pişmek"
    ],
    [
      "virgin",
      "erden"
    ],
    [
      "investigation",
      "tahkikat"
    ],
    [
      "hat",
      "başlık"
    ],
    [
      "institution",
      "kuruluş"
    ],
    [
      "affected",
      "etkilenen"
    ],
    [
      "bike",
      "derrace"
    ],
    [
      "plate",
      "plaka"
    ],
    [
      "indicate",
      "göstermek"
    ],
    [
      "favourite",
      "favori"
    ],
    [
      "lose",
      "kaybetmek"
    ],
    [
      "organic",
      "organik"
    ],
    [
      "equivalent",
      "muadil"
    ],
    [
      "neighborhood",
      "semt"
    ],
    [
      "agenda",
      "andaç"
    ],
    [
      "anyway",
      "neyse"
    ],
    [
      "logic",
      "eseme"
    ],
    [
      "prince",
      "şehzade"
    ],
    [
      "circle",
      "çember"
    ],
    [
      "psychology",
      "psikoloji"
    ],
    [
      "investor",
      "sermayedar"
    ],
    [
      "ram",
      "koyun"
    ],
    [
      "wildlife",
      "vahşi hayat"
    ],
    [
      "unlimited",
      "süresiz"
    ],
    [
      "plain",
      "ova"
    ],
    [
      "exit",
      "çıkış"
    ],
    [
      "arm",
      "silah"
    ],
    [
      "launch",
      "açmak"
    ],
    [
      "holy",
      "kutsal"
    ],
    [
      "guidance",
      "güdüm"
    ],
    [
      "symbol",
      "simge"
    ],
    [
      "highway",
      "anayol"
    ],
    [
      "chocolate",
      "çikolata"
    ],
    [
      "pub",
      "birahane"
    ],
    [
      "portion",
      "hisse"
    ],
    [
      "biology",
      "canlı bilimi"
    ],
    [
      "border",
      "süs"
    ],
    [
      "ancient",
      "antik"
    ],
    [
      "debate",
      "tartışma"
    ],
    [
      "biography",
      "tercümeihâl"
    ],
    [
      "notebook",
      "betlek"
    ],
    [
      "historic",
      "tarihsel"
    ],
    [
      "husband",
      "eş"
    ],
    [
      "disabled",
      "çolak"
    ],
    [
      "crazy",
      "aptal"
    ],
    [
      "upcoming",
      "gelen"
    ],
    [
      "linear",
      "doğrusal"
    ],
    [
      "hop",
      "şerbetçi otu"
    ],
    [
      "constant",
      "sabit"
    ],
    [
      "jewish",
      "Musevi"
    ],
    [
      "gun",
      "top"
    ],
    [
      "reflect",
      "yansımak"
    ],
    [
      "pure",
      "arı"
    ],
    [
      "wonder",
      "dahi"
    ],
    [
      "hell",
      "tamu"
    ],
    [
      "fruit",
      "yemiş"
    ],
    [
      "qualified",
      "sınırlı"
    ],
    [
      "reform",
      "devrim"
    ],
    [
      "lens",
      "adese"
    ],
    [
      "draw",
      "çizmek"
    ],
    [
      "assume",
      "farz etmek"
    ],
    [
      "confidence",
      "güven"
    ],
    [
      "alliance",
      "alyans"
    ],
    [
      "confirm",
      "tasdik etmek"
    ],
    [
      "warm",
      "sıcak"
    ],
    [
      "engineer",
      "kıvcı"
    ],
    [
      "lifestyle",
      "yaşam tarzı"
    ],
    [
      "suck",
      "berbat olmak"
    ],
    [
      "objective",
      "objektif"
    ],
    [
      "crew",
      "ekip"
    ],
    [
      "stick",
      "baston"
    ],
    [
      "slide",
      "kaymak"
    ],
    [
      "enhance",
      "geliştirmek"
    ],
    [
      "adapter",
      "priz adaptörü"
    ],
    [
      "formal",
      "resmî"
    ],
    [
      "storm",
      "fırtına"
    ],
    [
      "bowl",
      "piyale"
    ],
    [
      "supreme",
      "yüce"
    ],
    [
      "recognition",
      "kabul"
    ],
    [
      "tank",
      "depo"
    ],
    [
      "encourage",
      "teşvik etmek"
    ],
    [
      "navy",
      "bahriye"
    ],
    [
      "kid",
      "oğlak"
    ],
    [
      "paint",
      "resim yapmak"
    ],
    [
      "delay",
      "rötar"
    ],
    [
      "pilot",
      "uçman"
    ],
    [
      "continuous",
      "devamlı"
    ],
    [
      "czech",
      "Çekçe"
    ],
    [
      "initiative",
      "girişim"
    ],
    [
      "execution",
      "idam"
    ],
    [
      "disability",
      "sakatlık"
    ],
    [
      "winner",
      "kazanan"
    ],
    [
      "contractor",
      "müteahhit"
    ],
    [
      "episode",
      "bölüm"
    ],
    [
      "examination",
      "muayene"
    ],
    [
      "potter",
      "çömlekçi"
    ],
    [
      "dish",
      "aş"
    ],
    [
      "modify",
      "değişmek"
    ],
    [
      "adam",
      "Âdem"
    ],
    [
      "painting",
      "boyama"
    ],
    [
      "universe",
      "uzay"
    ],
    [
      "candidate",
      "namzet"
    ],
    [
      "patent",
      "buluş belgesi"
    ],
    [
      "messenger",
      "elçi"
    ],
    [
      "mirror",
      "gözgü"
    ],
    [
      "sterling",
      "sterlin"
    ],
    [
      "kernel",
      "tane"
    ],
    [
      "gray",
      "boz"
    ],
    [
      "taiwan",
      "Formoza"
    ],
    [
      "sarah",
      "Sara"
    ],
    [
      "labour",
      "emek"
    ],
    [
      "hate",
      "iğrenmek"
    ],
    [
      "terminal",
      "uçbirim"
    ],
    [
      "caribbean",
      "Karayipler"
    ],
    [
      "liquid",
      "likit"
    ],
    [
      "rice",
      "düğü"
    ],
    [
      "loop",
      "döngü"
    ],
    [
      "salary",
      "maaş"
    ],
    [
      "reservation",
      "yer ayırtma"
    ],
    [
      "gourmet",
      "tatbilir"
    ],
    [
      "raise",
      "kabartmak"
    ],
    [
      "prepare",
      "hazırlamak"
    ],
    [
      "illegal",
      "yasa dışı"
    ],
    [
      "arab",
      "Arap"
    ],
    [
      "consent",
      "rıza"
    ],
    [
      "drama",
      "dram"
    ],
    [
      "downtown",
      "merkezi"
    ],
    [
      "contest",
      "yarış"
    ],
    [
      "suitable",
      "yerinde"
    ],
    [
      "dildo",
      "dildo"
    ],
    [
      "push",
      "itelemek"
    ],
    [
      "muscle",
      "adale"
    ],
    [
      "implement",
      "tatbik etmek"
    ],
    [
      "yours",
      "sizinki"
    ],
    [
      "sum",
      "yekûn"
    ],
    [
      "chicken",
      "piliç"
    ],
    [
      "shower",
      "yağmura tutmak"
    ],
    [
      "dear",
      "sevgili"
    ],
    [
      "shell",
      "kovan"
    ],
    [
      "province",
      "il"
    ],
    [
      "oak",
      "saplı meşe"
    ],
    [
      "awareness",
      "şuur"
    ],
    [
      "governor",
      "ilbay"
    ],
    [
      "contribution",
      "katılım payı"
    ],
    [
      "measurement",
      "ölçme"
    ],
    [
      "formula",
      "bebek formülü"
    ],
    [
      "constitution",
      "anayasa"
    ],
    [
      "catch",
      "tutmak"
    ],
    [
      "consultation",
      "meşveret"
    ],
    [
      "sir",
      "ağa"
    ],
    [
      "doubt",
      "şek"
    ],
    [
      "earn",
      "para kazanmak"
    ],
    [
      "classroom",
      "derslik"
    ],
    [
      "democracy",
      "demokrasi"
    ],
    [
      "wallpaper",
      "duvar kağıdı"
    ],
    [
      "merchandise",
      "mal"
    ],
    [
      "resistance",
      "mukavemet"
    ],
    [
      "memorial",
      "anıt"
    ],
    [
      "visitor",
      "ziyaretçi"
    ],
    [
      "gateway",
      "giriş"
    ],
    [
      "drawing",
      "resim"
    ],
    [
      "biological",
      "biyolojik"
    ],
    [
      "spy",
      "casus"
    ],
    [
      "instrument",
      "enstrüman"
    ],
    [
      "split",
      "çatlak"
    ],
    [
      "heaven",
      "cennet"
    ],
    [
      "pregnant",
      "gebe"
    ],
    [
      "classification",
      "tasnif"
    ],
    [
      "physician",
      "hekim"
    ],
    [
      "bargain",
      "okazyon"
    ],
    [
      "normally",
      "normal bir şekilde"
    ],
    [
      "spiritual",
      "manevi"
    ],
    [
      "diabetes",
      "şeker hastalığı"
    ],
    [
      "suit",
      "simge"
    ],
    [
      "shift",
      "vites"
    ],
    [
      "chip",
      "çip"
    ],
    [
      "cutting",
      "kesme"
    ],
    [
      "wow",
      "vay canına"
    ],
    [
      "flexible",
      "elastik"
    ],
    [
      "numerous",
      "sayısız"
    ],
    [
      "intellectual",
      "zeki"
    ],
    [
      "carbon",
      "kömür"
    ],
    [
      "comfortable",
      "konforlu"
    ],
    [
      "crisis",
      "kriz"
    ],
    [
      "bright",
      "aydınlık"
    ],
    [
      "header",
      "antet"
    ],
    [
      "poverty",
      "fakirlik"
    ],
    [
      "revolution",
      "devrim"
    ],
    [
      "mystery",
      "sır"
    ],
    [
      "landscape",
      "yatay"
    ],
    [
      "dependent",
      "bağlı"
    ],
    [
      "journey",
      "gezi"
    ],
    [
      "banner",
      "sancak"
    ],
    [
      "cooperation",
      "işbirliği"
    ],
    [
      "blogger",
      "blogçu"
    ],
    [
      "notification",
      "notifikasyon"
    ],
    [
      "teach",
      "ders vermek"
    ],
    [
      "hairy",
      "kürklü"
    ],
    [
      "dutch",
      "Felemenkçe"
    ],
    [
      "sensitive",
      "ince"
    ],
    [
      "concrete",
      "dongu"
    ],
    [
      "poland",
      "Lehistan"
    ],
    [
      "folder",
      "katlamacı"
    ],
    [
      "broadcast",
      "yayınlanan"
    ],
    [
      "anniversary",
      "yıl dönümü"
    ],
    [
      "accessible",
      "kolay anlaşılan"
    ],
    [
      "resident",
      "durgun"
    ],
    [
      "plot",
      "komplo"
    ],
    [
      "airline",
      "havayolu"
    ],
    [
      "pump",
      "tulumba"
    ],
    [
      "smooth",
      "düz"
    ],
    [
      "consumption",
      "tüketim"
    ],
    [
      "narrow",
      "darlaşmak"
    ],
    [
      "afternoon",
      "ikindi"
    ],
    [
      "consultant",
      "müşavir"
    ],
    [
      "ownership",
      "malik"
    ],
    [
      "penis",
      "sik"
    ],
    [
      "trailer",
      "fragman"
    ],
    [
      "castle",
      "şato"
    ],
    [
      "logos",
      "logos"
    ],
    [
      "residence",
      "konut"
    ],
    [
      "strange",
      "tuhaf"
    ],
    [
      "mention",
      "değinmek"
    ],
    [
      "innovation",
      "yenileşim"
    ],
    [
      "parallel",
      "koşut"
    ],
    [
      "bold",
      "kalın"
    ],
    [
      "lesson",
      "ders"
    ],
    [
      "cinema",
      "sinematografi"
    ],
    [
      "scan",
      "taratmak"
    ],
    [
      "reaction",
      "tepki"
    ],
    [
      "enhanced",
      "artan"
    ],
    [
      "aged",
      "yaşında"
    ],
    [
      "exception",
      "istisna"
    ],
    [
      "bulk",
      "yığın"
    ],
    [
      "pursuant",
      "uyarınca"
    ],
    [
      "sin",
      "suç"
    ],
    [
      "berlin",
      "Berlinli"
    ],
    [
      "adoption",
      "benimseme"
    ],
    [
      "capture",
      "yemek"
    ],
    [
      "buffalo",
      "manda"
    ],
    [
      "plane",
      "uçak"
    ],
    [
      "seed",
      "tane"
    ],
    [
      "desire",
      "arzu"
    ],
    [
      "mechanism",
      "düzenek"
    ],
    [
      "jewellery",
      "ziynet"
    ],
    [
      "welfare",
      "yardım"
    ],
    [
      "peer",
      "yaşıt"
    ],
    [
      "massage",
      "masaj"
    ],
    [
      "rubber",
      "şapka"
    ],
    [
      "legend",
      "efsane"
    ],
    [
      "grace",
      "görgü"
    ],
    [
      "ing",
      "en"
    ],
    [
      "monster",
      "dev"
    ],
    [
      "bone",
      "kemik"
    ],
    [
      "collaboration",
      "emektaşlık"
    ],
    [
      "settlement",
      "tediye"
    ],
    [
      "erotic",
      "erosal"
    ],
    [
      "ethics",
      "etik"
    ],
    [
      "forever",
      "daima"
    ],
    [
      "dragon",
      "büke"
    ],
    [
      "captain",
      "yüzbaşı"
    ],
    [
      "leg",
      "ayak"
    ],
    [
      "neck",
      "yaka"
    ],
    [
      "taste",
      "tat"
    ],
    [
      "tiny",
      "küçük"
    ],
    [
      "liberal",
      "eli açık"
    ],
    [
      "jay",
      "alakarga"
    ],
    [
      "belt",
      "kayış"
    ],
    [
      "oracle",
      "arkıl"
    ],
    [
      "er",
      "ci"
    ],
    [
      "matthew",
      "Matta İncili"
    ],
    [
      "disaster",
      "afet"
    ],
    [
      "giant",
      "dev"
    ],
    [
      "angle",
      "açı"
    ],
    [
      "liberty",
      "hürriyet"
    ],
    [
      "era",
      "asır"
    ],
    [
      "convert",
      "çevirmek"
    ],
    [
      "possibility",
      "imkan"
    ],
    [
      "garage",
      "kaylık"
    ],
    [
      "unfortunately",
      "maatteessüf"
    ],
    [
      "attachment",
      "ek"
    ],
    [
      "pleasure",
      "keyif"
    ],
    [
      "honor",
      "şeref"
    ],
    [
      "eagle",
      "baz"
    ],
    [
      "pants",
      "don"
    ],
    [
      "nurse",
      "dadı"
    ],
    [
      "prayer",
      "dua"
    ],
    [
      "appointment",
      "tayin"
    ],
    [
      "hurricane",
      "urağan"
    ],
    [
      "quiet",
      "suskun"
    ],
    [
      "luck",
      "şans"
    ],
    [
      "producer",
      "yapımcı"
    ],
    [
      "carefully",
      "özenle"
    ],
    [
      "jet",
      "jet motoru"
    ],
    [
      "underground",
      "yer altı"
    ],
    [
      "diagnosis",
      "tanı"
    ],
    [
      "maker",
      "yapıcı"
    ],
    [
      "principle",
      "ilke"
    ],
    [
      "semester",
      "yarıyıl"
    ],
    [
      "smoke",
      "sis"
    ],
    [
      "craft",
      "beceri"
    ],
    [
      "cake",
      "pasta"
    ],
    [
      "blind",
      "kör"
    ],
    [
      "mad",
      "beç"
    ],
    [
      "gross",
      "iğrenç"
    ],
    [
      "horror",
      "korku"
    ],
    [
      "capable",
      "kapasiteli"
    ],
    [
      "pen",
      "kalem"
    ],
    [
      "shoe",
      "kundura"
    ],
    [
      "victory",
      "utku"
    ],
    [
      "terrorism",
      "yıldırıcılık"
    ],
    [
      "joy",
      "haz"
    ],
    [
      "parliament",
      "meclis"
    ],
    [
      "actor",
      "aktör"
    ],
    [
      "seal",
      "mühür"
    ],
    [
      "citizen",
      "halk"
    ],
    [
      "prize",
      "ödül"
    ],
    [
      "absolute",
      "mutlak"
    ],
    [
      "pipe",
      "biye"
    ],
    [
      "guardian",
      "koruma"
    ],
    [
      "lecture",
      "haşlamak"
    ],
    [
      "simulation",
      "simülasyon"
    ],
    [
      "layout",
      "plan"
    ],
    [
      "ill",
      "sayrı"
    ],
    [
      "concentration",
      "derişim"
    ],
    [
      "lay",
      "yatırmak"
    ],
    [
      "dirty",
      "pis"
    ],
    [
      "deck",
      "deste"
    ],
    [
      "worker",
      "amele"
    ],
    [
      "alive",
      "diri"
    ],
    [
      "temple",
      "dulun"
    ],
    [
      "prove",
      "ispatlamak"
    ],
    [
      "promise",
      "vaat"
    ],
    [
      "ridge",
      "doruk"
    ],
    [
      "collect",
      "katılmak"
    ],
    [
      "bet",
      "iddiaya girmek"
    ],
    [
      "composition",
      "terkip"
    ],
    [
      "vector",
      "yöney"
    ],
    [
      "purple",
      "erguvani"
    ],
    [
      "existence",
      "varlık"
    ],
    [
      "immigration",
      "hicret"
    ],
    [
      "syntax",
      "sözdizimi"
    ],
    [
      "prison",
      "hapis"
    ],
    [
      "skill",
      "maharet"
    ],
    [
      "apparently",
      "besbelli"
    ],
    [
      "exhibit",
      "göstermek"
    ],
    [
      "throw",
      "atmak"
    ],
    [
      "trend",
      "akım"
    ],
    [
      "obviously",
      "ortada"
    ],
    [
      "mercury",
      "Merkür"
    ],
    [
      "fundamental",
      "ana"
    ],
    [
      "escape",
      "kaçış"
    ],
    [
      "somewhat",
      "biraz"
    ],
    [
      "progressive",
      "ilerleyen"
    ],
    [
      "championship",
      "şampiyonluk"
    ],
    [
      "arcade",
      "pasaj"
    ],
    [
      "impossible",
      "olanaksız"
    ],
    [
      "obvious",
      "net"
    ],
    [
      "depression",
      "bunalım"
    ],
    [
      "judgment",
      "hüküm"
    ],
    [
      "foster",
      "beslemek"
    ],
    [
      "cartridge",
      "fişek"
    ],
    [
      "explanation",
      "açıklama"
    ],
    [
      "folk",
      "ulus"
    ],
    [
      "subsection",
      "alt kesim"
    ],
    [
      "electricity",
      "cereyan"
    ],
    [
      "pottery",
      "çömlekçilik"
    ],
    [
      "aspect",
      "görünüm"
    ],
    [
      "awesome",
      "süper"
    ],
    [
      "crash",
      "sabahlamak"
    ],
    [
      "lift",
      "çalmak"
    ],
    [
      "inter",
      "defnetmek"
    ],
    [
      "eligibility",
      "uygunluk"
    ],
    [
      "venture",
      "teşebbüs"
    ],
    [
      "korean",
      "Koreli"
    ],
    [
      "mall",
      "AVM"
    ],
    [
      "spray",
      "filiz"
    ],
    [
      "placement",
      "iş bulma"
    ],
    [
      "extend",
      "uzatmak"
    ],
    [
      "yard",
      "seren"
    ],
    [
      "tourist",
      "gezgin"
    ],
    [
      "mayor",
      "belediye reisi"
    ],
    [
      "murder",
      "öldürmek"
    ],
    [
      "adequate",
      "uygun"
    ],
    [
      "yield",
      "kâr"
    ],
    [
      "digest",
      "hazmetmek"
    ],
    [
      "tion",
      "syon"
    ],
    [
      "undergraduate",
      "üniversite öğrencisi"
    ],
    [
      "combat",
      "boğuşmak"
    ],
    [
      "occupation",
      "işgal"
    ],
    [
      "butt",
      "kalça"
    ],
    [
      "radiation",
      "ışınım"
    ],
    [
      "diary",
      "jurnal"
    ],
    [
      "ear",
      "kulak"
    ],
    [
      "pollution",
      "kirletme"
    ],
    [
      "ward",
      "koğuş"
    ],
    [
      "ian",
      "ce"
    ],
    [
      "roof",
      "dam"
    ],
    [
      "atmosphere",
      "atmosfer"
    ],
    [
      "kiss",
      "buse"
    ],
    [
      "experiment",
      "deneme"
    ],
    [
      "counsel",
      "avukat"
    ],
    [
      "federation",
      "ittifak"
    ],
    [
      "rush",
      "telaş"
    ],
    [
      "absence",
      "gıyap"
    ],
    [
      "surprise",
      "şaşırtmak"
    ],
    [
      "lamp",
      "yağ lambası"
    ],
    [
      "palace",
      "palas"
    ],
    [
      "acceptable",
      "uygun"
    ],
    [
      "satisfied",
      "hoşnut"
    ],
    [
      "globe",
      "küre"
    ],
    [
      "copper",
      "aynasız"
    ],
    [
      "warehouse",
      "depo"
    ],
    [
      "receipt",
      "fiş"
    ],
    [
      "ordinary",
      "olağan"
    ],
    [
      "ghost",
      "ruh"
    ],
    [
      "stability",
      "direnç"
    ],
    [
      "boss",
      "şef"
    ],
    [
      "pride",
      "kibir"
    ],
    [
      "independence",
      "istiklal"
    ],
    [
      "knowing",
      "bilir"
    ],
    [
      "reporter",
      "bildirmen"
    ],
    [
      "metabolism",
      "özgeriş"
    ],
    [
      "cloudy",
      "kapalı"
    ],
    [
      "sentence",
      "hüküm"
    ],
    [
      "uniform",
      "homojen"
    ],
    [
      "wealth",
      "bolluk"
    ],
    [
      "tall",
      "uzun"
    ],
    [
      "vacuum",
      "boşluk"
    ],
    [
      "publish",
      "yayımlamak"
    ],
    [
      "lifetime",
      "yaşam"
    ],
    [
      "booty",
      "olca"
    ],
    [
      "acrobat",
      "cambaz"
    ],
    [
      "vital",
      "hayati"
    ],
    [
      "coastal",
      "sahilsel"
    ],
    [
      "obligation",
      "yükümlülük"
    ],
    [
      "wake",
      "uyanmak"
    ],
    [
      "stupid",
      "bön"
    ],
    [
      "realize",
      "kavramak"
    ],
    [
      "enemy",
      "yağı"
    ],
    [
      "puzzle",
      "muamma"
    ],
    [
      "sms",
      "mesaj"
    ],
    [
      "shit",
      "bok"
    ],
    [
      "republican",
      "cumhuriyet"
    ],
    [
      "lucky",
      "ballı"
    ],
    [
      "thick",
      "yoğun"
    ],
    [
      "repeat",
      "yinelemek"
    ],
    [
      "builder",
      "kurucu"
    ],
    [
      "flood",
      "taşkın"
    ],
    [
      "orgy",
      "seks partisi"
    ],
    [
      "announcement",
      "ilan"
    ],
    [
      "appreciate",
      "anlamak"
    ],
    [
      "casual",
      "rahat"
    ],
    [
      "polish",
      "Leh"
    ],
    [
      "smile",
      "gülme"
    ],
    [
      "broker",
      "tellal"
    ],
    [
      "charger",
      "şarjör"
    ],
    [
      "divorce",
      "boşanmak"
    ],
    [
      "tradition",
      "töre"
    ],
    [
      "candy",
      "tatlı"
    ],
    [
      "sensor",
      "duyarga"
    ],
    [
      "deputy",
      "muavin"
    ],
    [
      "thai",
      "Tayca"
    ],
    [
      "complaint",
      "şikayet"
    ],
    [
      "scholarship",
      "öğrenimlik"
    ],
    [
      "mill",
      "bina"
    ],
    [
      "moral",
      "ahlak"
    ],
    [
      "den",
      "in"
    ],
    [
      "finger",
      "parmaklamak"
    ],
    [
      "burn",
      "yakmak"
    ],
    [
      "bread",
      "banak"
    ],
    [
      "wooden",
      "odun"
    ],
    [
      "incident",
      "olay"
    ],
    [
      "lie",
      "palavra"
    ],
    [
      "conversation",
      "diyalog"
    ],
    [
      "decrease",
      "düşmek"
    ],
    [
      "chest",
      "kasa"
    ],
    [
      "pension",
      "emeklilik"
    ],
    [
      "worship",
      "tapınmak"
    ],
    [
      "solve",
      "halletmek"
    ],
    [
      "sole",
      "taban"
    ],
    [
      "franchise",
      "imtiyaz"
    ],
    [
      "passion",
      "ihtiras"
    ],
    [
      "weak",
      "açık"
    ],
    [
      "wise",
      "akıllı"
    ],
    [
      "hearts",
      "yürek"
    ],
    [
      "worry",
      "dert"
    ],
    [
      "eve",
      "arefe"
    ],
    [
      "phrase",
      "öbek"
    ],
    [
      "genuine",
      "hakiki"
    ],
    [
      "glory",
      "şan"
    ],
    [
      "diesel",
      "dizel"
    ],
    [
      "overnight",
      "aniden"
    ],
    [
      "rod",
      "sopa"
    ],
    [
      "saudi",
      "Suudi Arabistanlı"
    ],
    [
      "fault",
      "hata"
    ],
    [
      "preliminary",
      "ön"
    ],
    [
      "introduce",
      "uygulamaya koymak"
    ],
    [
      "generator",
      "üreteç"
    ],
    [
      "suspension",
      "süspansiyon"
    ],
    [
      "sad",
      "gamlı"
    ],
    [
      "wolf",
      "börü"
    ],
    [
      "slowly",
      "yavaşça"
    ],
    [
      "authentication",
      "tevsik"
    ],
    [
      "infant",
      "minör"
    ],
    [
      "kick",
      "atmak"
    ],
    [
      "meal",
      "aş"
    ],
    [
      "hurt",
      "acımak"
    ],
    [
      "pot",
      "pot"
    ],
    [
      "dimension",
      "boyut"
    ],
    [
      "quarterly",
      "üçaylık"
    ],
    [
      "devil",
      "İblis"
    ],
    [
      "grass",
      "ot"
    ],
    [
      "comply",
      "uymak"
    ],
    [
      "cherry",
      "kiraz"
    ],
    [
      "alternate",
      "başka"
    ],
    [
      "webcam",
      "Webcam"
    ],
    [
      "funeral",
      "yuğ"
    ],
    [
      "pee",
      "pe"
    ],
    [
      "convenient",
      "rahat"
    ],
    [
      "mars",
      "Merih"
    ],
    [
      "silent",
      "lal"
    ],
    [
      "egg",
      "tohum"
    ],
    [
      "pill",
      "tablet"
    ],
    [
      "theft",
      "çalma"
    ],
    [
      "swing",
      "yellencek"
    ],
    [
      "flexibility",
      "elastikiyet"
    ],
    [
      "wisdom",
      "hikmet"
    ],
    [
      "shoot",
      "etmek"
    ],
    [
      "mint",
      "nane"
    ],
    [
      "offset",
      "öteleme"
    ],
    [
      "spin",
      "dönmek"
    ],
    [
      "swedish",
      "İsveç"
    ],
    [
      "deadline",
      "mühlet"
    ],
    [
      "witness",
      "tanık"
    ],
    [
      "powder",
      "pudra"
    ],
    [
      "wash",
      "yumak"
    ],
    [
      "entrance",
      "giriş"
    ],
    [
      "declaration",
      "bildirge"
    ],
    [
      "noble",
      "soylu"
    ],
    [
      "shore",
      "kenar"
    ],
    [
      "knight",
      "at"
    ],
    [
      "loose",
      "bol"
    ],
    [
      "illness",
      "maraz"
    ],
    [
      "ho",
      "orospu"
    ],
    [
      "pending",
      "yakın"
    ],
    [
      "jam",
      "murabba"
    ],
    [
      "unusual",
      "olağandışı"
    ],
    [
      "destruction",
      "yıkma"
    ],
    [
      "routine",
      "tekdüze"
    ],
    [
      "firewall",
      "ateş duvarı"
    ],
    [
      "horny",
      "azgın"
    ],
    [
      "adjustment",
      "ayarlama"
    ],
    [
      "hero",
      "alp"
    ],
    [
      "integer",
      "adedimürettep"
    ],
    [
      "engaged",
      "sözlü"
    ],
    [
      "carpet",
      "kilim"
    ],
    [
      "binary",
      "ikilik"
    ],
    [
      "pi",
      "pi sayısı"
    ],
    [
      "duke",
      "dük"
    ],
    [
      "wage",
      "maaş"
    ],
    [
      "arc",
      "kavis"
    ],
    [
      "dawn",
      "tan"
    ],
    [
      "torture",
      "eziyet"
    ],
    [
      "coat",
      "kaplamak"
    ],
    [
      "opposition",
      "karşıt"
    ],
    [
      "container",
      "konteyner"
    ],
    [
      "app",
      "app"
    ],
    [
      "embedded",
      "gömülü"
    ],
    [
      "wizard",
      "büyücü"
    ],
    [
      "brochure",
      "risale"
    ],
    [
      "killing",
      "öldürülme"
    ],
    [
      "shoulder",
      "çiyin"
    ],
    [
      "doll",
      "kukla"
    ],
    [
      "singer",
      "şantör"
    ],
    [
      "herald",
      "güve"
    ],
    [
      "literacy",
      "okuryazarlık"
    ],
    [
      "attraction",
      "çekim"
    ],
    [
      "invite",
      "çağırmak"
    ],
    [
      "modification",
      "değiştirme"
    ],
    [
      "reed",
      "kamış"
    ],
    [
      "terror",
      "dehşet"
    ],
    [
      "opposite",
      "zıt"
    ],
    [
      "assurance",
      "garanti"
    ],
    [
      "clerk",
      "yazman"
    ],
    [
      "vast",
      "engin"
    ],
    [
      "jeans",
      "blucin"
    ],
    [
      "compilation",
      "derleme eser"
    ],
    [
      "attractive",
      "cazip"
    ],
    [
      "beam",
      "ışın"
    ],
    [
      "moreover",
      "buna ilaveten"
    ],
    [
      "minimal",
      "en az"
    ],
    [
      "essay",
      "kompozisyon"
    ],
    [
      "discipline",
      "disiplin"
    ],
    [
      "dialogue",
      "sohbet"
    ],
    [
      "alphabetical",
      "abecesel"
    ],
    [
      "aaron",
      "Arun"
    ],
    [
      "trace",
      "iz"
    ],
    [
      "cycling",
      "bisiklet sporu"
    ],
    [
      "commonly",
      "sıkça"
    ],
    [
      "inform",
      "haber vermek"
    ],
    [
      "turkish",
      "Türki"
    ],
    [
      "quantum",
      "kuvantum"
    ],
    [
      "intent",
      "niyet"
    ],
    [
      "pleasant",
      "güzel"
    ],
    [
      "spoke",
      "tel"
    ],
    [
      "weird",
      "acaip"
    ],
    [
      "suddenly",
      "birden"
    ],
    [
      "oxygen",
      "müvellidülhumuza"
    ],
    [
      "merely",
      "sadece"
    ],
    [
      "arrangement",
      "düzenleme"
    ],
    [
      "pointer",
      "işaret çubuğu"
    ],
    [
      "stretch",
      "uzamak"
    ],
    [
      "sleeve",
      "yen"
    ],
    [
      "cleaner",
      "hademe"
    ],
    [
      "beef",
      "dana eti"
    ],
    [
      "stroke",
      "sıvazlamak"
    ],
    [
      "crowd",
      "avam"
    ],
    [
      "transformation",
      "başkalaşım"
    ],
    [
      "personality",
      "şahsiyet"
    ],
    [
      "rainbow",
      "peygamber kuşağı"
    ],
    [
      "hook",
      "kanca"
    ],
    [
      "israeli",
      "israilli"
    ],
    [
      "skiing",
      "kayakçılık"
    ],
    [
      "valve",
      "valf"
    ],
    [
      "proceed",
      "ilerlemek"
    ],
    [
      "shelf",
      "sergen"
    ],
    [
      "incredible",
      "fevkalade"
    ],
    [
      "donation",
      "bağişlama"
    ],
    [
      "founder",
      "arpalama"
    ],
    [
      "decade",
      "onlu"
    ],
    [
      "portuguese",
      "Portekiz"
    ],
    [
      "everywhere",
      "her yer"
    ],
    [
      "steam",
      "buğu"
    ],
    [
      "discharge",
      "debi"
    ],
    [
      "acute",
      "dar"
    ],
    [
      "sing",
      "ırlamak"
    ],
    [
      "perfume",
      "ıtır"
    ],
    [
      "reputation",
      "ün"
    ],
    [
      "hang",
      "asmak"
    ],
    [
      "curve",
      "eğri"
    ],
    [
      "creator",
      "Yaradan"
    ],
    [
      "amber",
      "sarı"
    ],
    [
      "tracker",
      "takipçi"
    ],
    [
      "trunk",
      "bagaj"
    ],
    [
      "photograph",
      "kılık"
    ],
    [
      "camel",
      "hecin"
    ],
    [
      "hood",
      "başlık"
    ],
    [
      "suicide",
      "intihar"
    ],
    [
      "chi",
      "çi"
    ],
    [
      "projection",
      "yansıtma"
    ],
    [
      "juice",
      "suyu"
    ],
    [
      "chase",
      "kovalama"
    ],
    [
      "sauce",
      "salça"
    ],
    [
      "fame",
      "şan"
    ],
    [
      "diagnostic",
      "tanısal"
    ],
    [
      "criticism",
      "tenkit"
    ],
    [
      "automobile",
      "otomobil"
    ],
    [
      "railway",
      "şimendifer"
    ],
    [
      "mistake",
      "galat"
    ],
    [
      "locked",
      "kitli"
    ],
    [
      "mineral",
      "maden"
    ],
    [
      "ruby",
      "yakut"
    ],
    [
      "canvas",
      "tuval"
    ],
    [
      "planner",
      "andaç"
    ],
    [
      "stadium",
      "stat"
    ],
    [
      "proxy",
      "vekil"
    ],
    [
      "astronomy",
      "gök bilimi"
    ],
    [
      "translate",
      "terceme"
    ],
    [
      "tune",
      "akortlamak"
    ],
    [
      "bishop",
      "fil"
    ],
    [
      "corn",
      "nasır"
    ],
    [
      "compression",
      "sıkıştırma"
    ],
    [
      "farmer",
      "ekinci"
    ],
    [
      "slave",
      "kul"
    ],
    [
      "instantly",
      "hemen"
    ],
    [
      "broadcasting",
      "yayım"
    ],
    [
      "portrait",
      "portre"
    ],
    [
      "terrorist",
      "yıldırıcı"
    ],
    [
      "ethical",
      "töre bilimsel"
    ],
    [
      "mobility",
      "hareketlilik"
    ],
    [
      "struggle",
      "vuruşma"
    ],
    [
      "neutral",
      "yansız"
    ],
    [
      "fisher",
      "balıkçı sansar"
    ],
    [
      "rat",
      "fare"
    ],
    [
      "prospective",
      "olası"
    ],
    [
      "ultimately",
      "sonunda"
    ],
    [
      "artificial",
      "yapay"
    ],
    [
      "affiliated",
      "üye"
    ],
    [
      "tail",
      "yazı"
    ],
    [
      "violent",
      "şiddetli"
    ],
    [
      "basin",
      "koy"
    ],
    [
      "drunk",
      "esrik"
    ],
    [
      "toner",
      "tonik"
    ],
    [
      "latex",
      "lateks"
    ],
    [
      "alien",
      "el"
    ],
    [
      "zimbabwe",
      "Zimbabwe"
    ],
    [
      "complexity",
      "karmaşık"
    ],
    [
      "documentary",
      "belgesel film"
    ],
    [
      "thesis",
      "sav"
    ],
    [
      "rocky",
      "dimdik"
    ],
    [
      "trim",
      "doğru"
    ],
    [
      "hospitality",
      "mihmandarlık"
    ],
    [
      "gen",
      "suffixA producer of something, or an agent in the production of something.jen"
    ],
    [
      "procurement",
      "tedarik etme"
    ],
    [
      "fleet",
      "donanma"
    ],
    [
      "bunch",
      "demet"
    ],
    [
      "theoretical",
      "kuramsal"
    ],
    [
      "surveillance",
      "gözaltı"
    ],
    [
      "quit",
      "istifa etmek"
    ],
    [
      "substitute",
      "yedek oyuncu"
    ],
    [
      "hopefully",
      "ümitle"
    ],
    [
      "gel",
      "jel"
    ],
    [
      "termination",
      "bitiş"
    ],
    [
      "grill",
      "gril"
    ],
    [
      "redeem",
      "aklamak"
    ],
    [
      "grain",
      "tara"
    ],
    [
      "authentic",
      "gerçek"
    ],
    [
      "bull",
      "boğa"
    ],
    [
      "breath",
      "nefes"
    ],
    [
      "authorization",
      "otorizasyon"
    ],
    [
      "projector",
      "gösterici"
    ],
    [
      "comparative",
      "mukayeseli"
    ],
    [
      "elegant",
      "şık"
    ],
    [
      "genealogy",
      "jenealoji"
    ],
    [
      "hacker",
      "çökertici"
    ],
    [
      "margin",
      "kar"
    ],
    [
      "coin",
      "jeton"
    ],
    [
      "fake",
      "feyk"
    ],
    [
      "salon",
      "odalak"
    ],
    [
      "cure",
      "kür"
    ],
    [
      "commander",
      "kumandan"
    ],
    [
      "arch",
      "suffixleading, leaderark"
    ],
    [
      "suggestion",
      "teklif"
    ],
    [
      "soldier",
      "sü"
    ],
    [
      "harm",
      "hasar"
    ],
    [
      "interval",
      "aralık"
    ],
    [
      "tongue",
      "dil"
    ],
    [
      "danish",
      "Danca"
    ],
    [
      "filename",
      "dosya ismi"
    ],
    [
      "honey",
      "bal"
    ],
    [
      "significance",
      "mana"
    ],
    [
      "symposium",
      "sempozyum"
    ],
    [
      "arabic",
      "Arap"
    ],
    [
      "mat",
      "hasır"
    ],
    [
      "oven",
      "ocak"
    ],
    [
      "noon",
      "günorta"
    ],
    [
      "correspondence",
      "yazışma"
    ],
    [
      "cheat",
      "dolandırmak"
    ],
    [
      "bronze",
      "bronz"
    ],
    [
      "sender",
      "gönderici"
    ],
    [
      "celebration",
      "bayram"
    ],
    [
      "viewer",
      "izleyici"
    ],
    [
      "receptor",
      "reseptör"
    ],
    [
      "piss",
      "çiş"
    ],
    [
      "destroy",
      "mahvetmek"
    ],
    [
      "citation",
      "tadat"
    ],
    [
      "pitch",
      "perde"
    ],
    [
      "offensive",
      "hamle"
    ],
    [
      "benjamin",
      "Bünyamin"
    ],
    [
      "deployment",
      "teslimat"
    ],
    [
      "salmon",
      "som"
    ],
    [
      "tan",
      "yanmak"
    ],
    [
      "mate",
      "çift"
    ],
    [
      "starter",
      "antre"
    ],
    [
      "butter",
      "yağ"
    ],
    [
      "pepper",
      "biber"
    ],
    [
      "weapon",
      "savut"
    ],
    [
      "luggage",
      "yük"
    ],
    [
      "burden",
      "zahmet"
    ],
    [
      "maple",
      "isfendan"
    ],
    [
      "autumn",
      "güz"
    ],
    [
      "traveling",
      "step"
    ],
    [
      "probe",
      "prob"
    ],
    [
      "toilet",
      "hela"
    ],
    [
      "excited",
      "heyecanlı"
    ],
    [
      "debug",
      "hatasızlaştırmak"
    ],
    [
      "calculation",
      "hesap"
    ],
    [
      "boob",
      "meme"
    ],
    [
      "anxiety",
      "endişe"
    ],
    [
      "bingo",
      "tombala"
    ],
    [
      "spatial",
      "uzamsal"
    ],
    [
      "unto",
      "kadar"
    ],
    [
      "precious",
      "kıymetli"
    ],
    [
      "atm",
      "ATM"
    ],
    [
      "necklace",
      "gerdanlık"
    ],
    [
      "stud",
      "çivi"
    ],
    [
      "fold",
      "kat"
    ],
    [
      "fingering",
      "parmaklama"
    ],
    [
      "mason",
      "taş ustası"
    ],
    [
      "diagram",
      "diyagram"
    ],
    [
      "slut",
      "kahpe"
    ],
    [
      "ejaculation",
      "ejakülasyon"
    ],
    [
      "beijing",
      "Hanbalık"
    ],
    [
      "spider",
      "ankebut"
    ],
    [
      "divine",
      "lahuti"
    ],
    [
      "compound",
      "bileşim"
    ],
    [
      "pole",
      "sırık"
    ],
    [
      "harvest",
      "hasıla"
    ],
    [
      "prague",
      "Praglı"
    ],
    [
      "constitute",
      "atamak"
    ],
    [
      "demonstration",
      "protesto"
    ],
    [
      "graduation",
      "mezuniyet"
    ],
    [
      "sacred",
      "mukaddes"
    ],
    [
      "addiction",
      "tutku"
    ],
    [
      "brake",
      "eğleç"
    ],
    [
      "greeting",
      "tebrik"
    ],
    [
      "ecology",
      "çevre bilimi"
    ],
    [
      "clone",
      "klon"
    ],
    [
      "oasis",
      "vaha"
    ],
    [
      "angry",
      "asabi"
    ],
    [
      "identical",
      "eşit"
    ],
    [
      "compete",
      "yarışmak"
    ],
    [
      "norwegian",
      "Norveççe"
    ],
    [
      "lover",
      "aşık"
    ],
    [
      "ferry",
      "feribot"
    ],
    [
      "rabbit",
      "kuyan"
    ],
    [
      "dam",
      "set"
    ],
    [
      "tire",
      "yormak"
    ],
    [
      "participant",
      "iştirakçı"
    ],
    [
      "friendship",
      "dostluk"
    ],
    [
      "passport",
      "buyruldu"
    ],
    [
      "warrant",
      "güvence vermek"
    ],
    [
      "frozen",
      "donuk"
    ],
    [
      "occupied",
      "meşgul"
    ],
    [
      "scales",
      "mizan"
    ],
    [
      "rally",
      "miting"
    ],
    [
      "sunshine",
      "güneş"
    ],
    [
      "drag",
      "çekmek"
    ],
    [
      "ceremony",
      "tören"
    ],
    [
      "hebrew",
      "İbranca"
    ],
    [
      "laundry",
      "yıkama"
    ],
    [
      "homework",
      "ev ödevi"
    ],
    [
      "filling",
      "dolgu"
    ],
    [
      "sophisticated",
      "şık"
    ],
    [
      "silence",
      "sükut"
    ],
    [
      "treaty",
      "akit"
    ],
    [
      "trainer",
      "koç"
    ],
    [
      "organ",
      "organ"
    ],
    [
      "lemon",
      "limoni"
    ],
    [
      "nail",
      "mıh"
    ],
    [
      "vienna",
      "Beç"
    ],
    [
      "joke",
      "şaka"
    ],
    [
      "satisfy",
      "yetmek"
    ],
    [
      "shelter",
      "barınak"
    ],
    [
      "chapel",
      "musalla"
    ],
    [
      "celebrate",
      "kutlamak"
    ],
    [
      "appliance",
      "cihaz"
    ],
    [
      "mixture",
      "karışım"
    ],
    [
      "ash",
      "kül"
    ],
    [
      "tender",
      "kıtır"
    ],
    [
      "paste",
      "çiriş"
    ],
    [
      "preserve",
      "muhafaza etmek"
    ],
    [
      "poem",
      "nazım"
    ],
    [
      "vibrator",
      "vibratör"
    ],
    [
      "easter",
      "Paskalya"
    ],
    [
      "praise",
      "hamt"
    ],
    [
      "christianity",
      "Nasranîlik"
    ],
    [
      "landing",
      "sahanlık"
    ],
    [
      "showcase",
      "vitrin"
    ],
    [
      "composer",
      "besteci"
    ],
    [
      "bean",
      "eleman"
    ],
    [
      "ecuador",
      "Ekvator"
    ],
    [
      "float",
      "mantar"
    ],
    [
      "acquire",
      "kazanmak"
    ],
    [
      "millennium",
      "milenyum"
    ],
    [
      "vessel",
      "kap"
    ],
    [
      "dairy",
      "süt ürünleri"
    ],
    [
      "tap",
      "musluk takmak"
    ],
    [
      "suffer",
      "çekmek"
    ],
    [
      "invalid",
      "yatalak"
    ],
    [
      "martial",
      "askerî"
    ],
    [
      "retain",
      "tutmak"
    ],
    [
      "beaver",
      "kastor"
    ],
    [
      "distribute",
      "dağıtmak"
    ],
    [
      "decorative",
      "tezyinî"
    ],
    [
      "accused",
      "zanlı"
    ],
    [
      "bee",
      "arı"
    ],
    [
      "conjunction",
      "rabıt"
    ],
    [
      "anchor",
      "demir"
    ],
    [
      "parade",
      "alay"
    ],
    [
      "corruption",
      "yolsuzluk"
    ],
    [
      "stat",
      "hemen"
    ],
    [
      "trigger",
      "tetikleme"
    ],
    [
      "terrible",
      "korkunç"
    ],
    [
      "pendant",
      "pandantif"
    ],
    [
      "scientist",
      "âlim"
    ],
    [
      "arthritis",
      "eklem iltihabı"
    ],
    [
      "nevertheless",
      "buna karşın"
    ],
    [
      "fever",
      "humma"
    ],
    [
      "inflation",
      "enflasyon"
    ],
    [
      "pray",
      "dua etmek"
    ],
    [
      "structured",
      "yapısal"
    ],
    [
      "cattle",
      "öküz"
    ],
    [
      "treasure",
      "define"
    ],
    [
      "flame",
      "yalın"
    ],
    [
      "pit",
      "çukur"
    ],
    [
      "extraordinary",
      "fevkalade"
    ],
    [
      "tile",
      "fayans"
    ],
    [
      "spell",
      "tılsım"
    ],
    [
      "illustration",
      "çizim"
    ],
    [
      "annex",
      "katmak"
    ],
    [
      "rebate",
      "para iadesi"
    ],
    [
      "aggregate",
      "kütle"
    ],
    [
      "knee",
      "paraçol"
    ],
    [
      "shakespeare",
      "Şekspir"
    ],
    [
      "collapse",
      "yıkılmak"
    ],
    [
      "beverage",
      "meşrubat"
    ],
    [
      "genesis",
      "ülkü"
    ],
    [
      "argue",
      "tartışmak"
    ],
    [
      "bicycle",
      "derrace"
    ],
    [
      "particle",
      "edat"
    ],
    [
      "boxing",
      "kunt"
    ],
    [
      "bra",
      "sutyen"
    ],
    [
      "bitch",
      "orospu"
    ],
    [
      "canal",
      "ark"
    ],
    [
      "cow",
      "inek"
    ],
    [
      "circulation",
      "kan dolaşımı"
    ],
    [
      "protest",
      "protesto"
    ],
    [
      "jerusalem",
      "Yeruşalim"
    ],
    [
      "hobby",
      "merak"
    ],
    [
      "invention",
      "icat"
    ],
    [
      "nickname",
      "san"
    ],
    [
      "trick",
      "numara"
    ],
    [
      "timber",
      "orman"
    ],
    [
      "playlist",
      "çalma listesi"
    ],
    [
      "dirt",
      "kir"
    ],
    [
      "screw",
      "sikmek"
    ],
    [
      "publicly",
      "açıkça"
    ],
    [
      "blame",
      "suçlamak"
    ],
    [
      "informal",
      "teklifsiz"
    ],
    [
      "incentive",
      "teşvik primi"
    ],
    [
      "numerical",
      "sayıca"
    ],
    [
      "uncle",
      "dayı"
    ],
    [
      "counting",
      "sayma"
    ],
    [
      "assure",
      "temin etmek"
    ],
    [
      "invitation",
      "çağrı"
    ],
    [
      "jacob",
      "Yakub"
    ],
    [
      "decent",
      "onat"
    ],
    [
      "warrior",
      "asker"
    ],
    [
      "cabin",
      "kabin"
    ],
    [
      "innocent",
      "masum"
    ],
    [
      "ide",
      "it"
    ],
    [
      "consensus",
      "oybirliği"
    ],
    [
      "polo",
      "polo"
    ],
    [
      "horn",
      "korna"
    ],
    [
      "grammar",
      "dil bilgisi"
    ],
    [
      "hazard",
      "mani"
    ],
    [
      "leo",
      "Leo"
    ],
    [
      "boolean",
      "Boole'sal"
    ],
    [
      "anger",
      "öfke"
    ],
    [
      "snap",
      "çıt"
    ],
    [
      "happiness",
      "saadet"
    ],
    [
      "substantially",
      "çok"
    ],
    [
      "bizarre",
      "garip"
    ],
    [
      "identifier",
      "birincil anahtar"
    ],
    [
      "ribbon",
      "şerit"
    ],
    [
      "swap",
      "takas etmek"
    ],
    [
      "impression",
      "tesir"
    ],
    [
      "gorgeous",
      "görkemli"
    ],
    [
      "nervous",
      "gergin"
    ],
    [
      "fragrance",
      "rayiha"
    ],
    [
      "replica",
      "replika"
    ],
    [
      "tribe",
      "boy"
    ],
    [
      "buzz",
      "cızırtı"
    ],
    [
      "transparent",
      "şeffaf"
    ],
    [
      "trinity",
      "üçleme"
    ],
    [
      "calm",
      "dingin"
    ],
    [
      "exhaust",
      "bitmek"
    ],
    [
      "vocational",
      "meslek"
    ],
    [
      "fork",
      "çatal"
    ],
    [
      "troy",
      "Truva"
    ],
    [
      "harmony",
      "uyum"
    ],
    [
      "asthma",
      "yelpik"
    ],
    [
      "triangle",
      "üçbucak"
    ],
    [
      "amend",
      "düzelmek"
    ],
    [
      "oriental",
      "şarki"
    ],
    [
      "reward",
      "mükafat"
    ],
    [
      "hydrogen",
      "müvellidülma"
    ],
    [
      "chick",
      "hatun"
    ],
    [
      "tray",
      "sini"
    ],
    [
      "sage",
      "ada çayı"
    ],
    [
      "arrange",
      "düzenlemek"
    ],
    [
      "artistic",
      "dörütsel"
    ],
    [
      "booth",
      "kabin"
    ],
    [
      "precise",
      "kesin"
    ],
    [
      "respiratory",
      "solunumsal"
    ],
    [
      "gather",
      "toplamak"
    ],
    [
      "embassy",
      "elçilik"
    ],
    [
      "cave",
      "in"
    ],
    [
      "arrest",
      "tutuklamak"
    ],
    [
      "volleyball",
      "voleybol"
    ],
    [
      "horizon",
      "ufuk çizgisi"
    ],
    [
      "tolerance",
      "tolerans"
    ],
    [
      "pursue",
      "hedeflemek"
    ],
    [
      "lightning",
      "yıldırım"
    ],
    [
      "overcome",
      "atlatmak"
    ],
    [
      "grab",
      "yakalamak"
    ],
    [
      "oops",
      "ay"
    ],
    [
      "reminder",
      "andiç"
    ],
    [
      "nipple",
      "emzik"
    ],
    [
      "trap",
      "gaga"
    ],
    [
      "lonely",
      "garip"
    ],
    [
      "fool",
      "ahmak"
    ],
    [
      "berry",
      "yemiş"
    ],
    [
      "collar",
      "yaka"
    ],
    [
      "screenshot",
      "ekran yakalama görüntüsü"
    ],
    [
      "consortium",
      "birliktelik"
    ],
    [
      "terrace",
      "seki"
    ],
    [
      "seafood",
      "deniz ürünü"
    ],
    [
      "playboy",
      "çapkın"
    ],
    [
      "delicious",
      "tatlı"
    ],
    [
      "jail",
      "hapis"
    ],
    [
      "moisture",
      "rutubet"
    ],
    [
      "hungarian",
      "Macarca"
    ],
    [
      "vegetable",
      "sebze"
    ],
    [
      "custody",
      "inam"
    ],
    [
      "scratch",
      "çizmek"
    ],
    [
      "rocket",
      "füze"
    ],
    [
      "bullet",
      "kurşun"
    ],
    [
      "nasty",
      "edepsiz"
    ],
    [
      "consciousness",
      "şuur"
    ],
    [
      "tumor",
      "ur"
    ],
    [
      "priest",
      "keşiş"
    ],
    [
      "queue",
      "sıra"
    ],
    [
      "invasion",
      "işgal"
    ],
    [
      "notion",
      "fikir"
    ],
    [
      "spelling",
      "imla"
    ],
    [
      "arctic",
      "Kuzey Kutbu"
    ],
    [
      "strengthen",
      "güçlenmek"
    ],
    [
      "defend",
      "korumak"
    ],
    [
      "infrared",
      "kızılaltı"
    ],
    [
      "welsh",
      "Galliler"
    ],
    [
      "belly",
      "göbek"
    ],
    [
      "aggressive",
      "agresif"
    ],
    [
      "stolen",
      "çalınmış"
    ],
    [
      "sculpture",
      "yontuculuk"
    ],
    [
      "motivation",
      "güdü"
    ],
    [
      "pharmacology",
      "eczabilim"
    ],
    [
      "consistently",
      "devamlı"
    ],
    [
      "elder",
      "yaşlı"
    ],
    [
      "cheers",
      "teşekkürler"
    ],
    [
      "subsequently",
      "arkadan"
    ],
    [
      "belarus",
      "Belarus"
    ],
    [
      "gravity",
      "ciddiyet"
    ],
    [
      "incorporate",
      "katmak"
    ],
    [
      "essence",
      "esans"
    ],
    [
      "ethiopia",
      "Etyopya"
    ],
    [
      "humanity",
      "insani"
    ],
    [
      "transcription",
      "transkripsiyon"
    ],
    [
      "galaxy",
      "gök ada"
    ],
    [
      "worn",
      "yalama"
    ],
    [
      "testament",
      "kalıtyazı"
    ],
    [
      "stomach",
      "karın"
    ],
    [
      "buried",
      "metfun"
    ],
    [
      "newbie",
      "çömez"
    ],
    [
      "minimize",
      "küçült"
    ],
    [
      "wilderness",
      "kır"
    ],
    [
      "anatomy",
      "yapıbilim"
    ],
    [
      "fraction",
      "kesir"
    ],
    [
      "cube",
      "küp"
    ],
    [
      "volkswagen",
      "Vosvos"
    ],
    [
      "subsidiary",
      "yan"
    ],
    [
      "monaco",
      "Monako Prensliği"
    ],
    [
      "fate",
      "kısmet"
    ],
    [
      "ivory",
      "fil dişi"
    ],
    [
      "remix",
      "bindirim"
    ],
    [
      "thesaurus",
      "tesarus"
    ],
    [
      "battlefield",
      "savaş meydanı"
    ],
    [
      "literally",
      "resmen"
    ],
    [
      "overhead",
      "genel giderlerle ilgili"
    ],
    [
      "shipment",
      "taşınma"
    ],
    [
      "donor",
      "verici"
    ],
    [
      "manor",
      "yurtluk"
    ],
    [
      "homeland",
      "yurt"
    ],
    [
      "disco",
      "diskotek"
    ],
    [
      "bulgarian",
      "Bulgarca"
    ],
    [
      "eternal",
      "bengi"
    ],
    [
      "remarkable",
      "fevkalade"
    ],
    [
      "rotation",
      "devir"
    ],
    [
      "gdp",
      "GSYİH"
    ],
    [
      "pig",
      "obur"
    ],
    [
      "compliant",
      "uyan"
    ],
    [
      "imagination",
      "hayal"
    ],
    [
      "accommodate",
      "uydurmak"
    ],
    [
      "rhythm",
      "ritm"
    ],
    [
      "digit",
      "parmak"
    ],
    [
      "precipitation",
      "acele"
    ],
    [
      "isolation",
      "izolasyon"
    ],
    [
      "chronicle",
      "vakayiname"
    ],
    [
      "fountain",
      "şadırvan"
    ],
    [
      "grave",
      "vahim"
    ],
    [
      "legitimate",
      "gerçek"
    ],
    [
      "investigator",
      "araştırıcı"
    ],
    [
      "plaintiff",
      "iddiacı"
    ],
    [
      "finnish",
      "Fin"
    ],
    [
      "gentle",
      "nazik"
    ],
    [
      "entrepreneur",
      "atılımcı"
    ],
    [
      "unexpected",
      "umulmadık"
    ],
    [
      "cigarette",
      "çilim"
    ],
    [
      "lobby",
      "dalan"
    ],
    [
      "egyptian",
      "Mısır"
    ],
    [
      "headline",
      "manşet"
    ],
    [
      "punch",
      "delmek"
    ],
    [
      "karma",
      "kader"
    ],
    [
      "quantitative",
      "kantitatif"
    ],
    [
      "defeat",
      "hezimet"
    ],
    [
      "distinction",
      "fark"
    ],
    [
      "naughty",
      "haylaz"
    ],
    [
      "livestock",
      "mal"
    ],
    [
      "exemption",
      "vergi muafiyeti"
    ],
    [
      "tenant",
      "sahip"
    ],
    [
      "sustainability",
      "sürdürebilirlik"
    ],
    [
      "silly",
      "saf"
    ],
    [
      "sunrise",
      "güneş doğuşu"
    ],
    [
      "fur",
      "kürk"
    ],
    [
      "tar",
      "tar"
    ],
    [
      "fence",
      "duvar"
    ],
    [
      "infinite",
      "sonsuz"
    ],
    [
      "clan",
      "kabile"
    ],
    [
      "shame",
      "ayıp"
    ],
    [
      "revolutionary",
      "inkilapçı"
    ],
    [
      "breathing",
      "solumak"
    ],
    [
      "genius",
      "deha"
    ],
    [
      "fighter",
      "savaşçı"
    ],
    [
      "meaningful",
      "manalı"
    ],
    [
      "marble",
      "bilye"
    ],
    [
      "briefing",
      "brifingler"
    ],
    [
      "accreditation",
      "onay"
    ],
    [
      "instrumental",
      "aletsel"
    ],
    [
      "shed",
      "baraka"
    ],
    [
      "kazakhstan",
      "Kazakeli"
    ],
    [
      "magnet",
      "çaşak"
    ],
    [
      "commodity",
      "mal"
    ],
    [
      "bind",
      "bağlamak"
    ],
    [
      "urgent",
      "ivedi"
    ],
    [
      "cylinder",
      "itenek"
    ],
    [
      "witch",
      "cadı"
    ],
    [
      "congratulations",
      "tebrikler"
    ],
    [
      "puppy",
      "enik"
    ],
    [
      "revenge",
      "öç"
    ],
    [
      "smell",
      "kokmak"
    ],
    [
      "sticker",
      "sticker"
    ],
    [
      "satin",
      "atlas"
    ],
    [
      "garbage",
      "süprüntü"
    ],
    [
      "prefix",
      "ön ek"
    ],
    [
      "barrel",
      "fıçı"
    ],
    [
      "myanmar",
      "Birmanya"
    ],
    [
      "thunder",
      "yıldırım"
    ],
    [
      "tent",
      "otağ"
    ],
    [
      "questionnaire",
      "formu"
    ],
    [
      "hawk",
      "doğan"
    ],
    [
      "consequence",
      "netice"
    ],
    [
      "magnitude",
      "şiddet"
    ],
    [
      "vocabulary",
      "vokabüler"
    ],
    [
      "earthquake",
      "zelzele"
    ],
    [
      "lasting",
      "kalıcı"
    ],
    [
      "wicked",
      "uğursuz"
    ],
    [
      "roommate",
      "ev arkadaşı"
    ]
  ],
  "zh": [
    [
      "the",
      "该"
    ],
    [
      "of",
      "之"
    ],
    [
      "and",
      "以及"
    ],
    [
      "in",
      "内"
    ],
    [
      "for",
      "以前"
    ],
    [
      "on",
      "上"
    ],
    [
      "that",
      "什么"
    ],
    [
      "by",
      "上"
    ],
    [
      "this",
      "這"
    ],
    [
      "with",
      "和"
    ],
    [
      "you",
      "你"
    ],
    [
      "or",
      "或"
    ],
    [
      "be",
      "在"
    ],
    [
      "are",
      "公畝"
    ],
    [
      "at",
      "上"
    ],
    [
      "as",
      "当"
    ],
    [
      "your",
      "你们的"
    ],
    [
      "we",
      "我們"
    ],
    [
      "home",
      "家"
    ],
    [
      "can",
      "能"
    ],
    [
      "about",
      "多"
    ],
    [
      "if",
      "要是"
    ],
    [
      "page",
      "頁"
    ],
    [
      "free",
      "免費"
    ],
    [
      "but",
      "可是"
    ],
    [
      "no",
      "不"
    ],
    [
      "time",
      "時間"
    ],
    [
      "they",
      "她们"
    ],
    [
      "site",
      "地"
    ],
    [
      "may",
      "什么"
    ],
    [
      "what",
      "啥"
    ],
    [
      "which",
      "什么"
    ],
    [
      "out",
      "的"
    ],
    [
      "use",
      "使用"
    ],
    [
      "any",
      "什么"
    ],
    [
      "so",
      "所以"
    ],
    [
      "contact",
      "聯繫"
    ],
    [
      "here",
      "这儿"
    ],
    [
      "business",
      "事"
    ],
    [
      "web",
      "灵魂"
    ],
    [
      "help",
      "帮"
    ],
    [
      "get",
      "在"
    ],
    [
      "view",
      "出发"
    ],
    [
      "would",
      "要"
    ],
    [
      "how",
      "怎么"
    ],
    [
      "some",
      "一下"
    ],
    [
      "these",
      "這些"
    ],
    [
      "date",
      "日期"
    ],
    [
      "top",
      "主動"
    ],
    [
      "list",
      "听"
    ],
    [
      "name",
      "名"
    ],
    [
      "just",
      "但是"
    ],
    [
      "over",
      "酸"
    ],
    [
      "state",
      "国"
    ],
    [
      "day",
      "日"
    ],
    [
      "into",
      "到"
    ],
    [
      "email",
      "电子函件"
    ],
    [
      "two",
      "两"
    ],
    [
      "go",
      "圍棋"
    ],
    [
      "most",
      "很"
    ],
    [
      "music",
      "音樂"
    ],
    [
      "buy",
      "買"
    ],
    [
      "them",
      "他们"
    ],
    [
      "should",
      "该"
    ],
    [
      "product",
      "物質"
    ],
    [
      "post",
      "出版"
    ],
    [
      "policy",
      "政策"
    ],
    [
      "support",
      "加油"
    ],
    [
      "message",
      "信息"
    ],
    [
      "after",
      "后"
    ],
    [
      "software",
      "軟體"
    ],
    [
      "then",
      "那时"
    ],
    [
      "video",
      "视频"
    ],
    [
      "where",
      "哪里"
    ],
    [
      "review",
      "检查"
    ],
    [
      "order",
      "目"
    ],
    [
      "very",
      "非常"
    ],
    [
      "book",
      "书"
    ],
    [
      "read",
      "看"
    ],
    [
      "group",
      "聯隊"
    ],
    [
      "sex",
      "性交"
    ],
    [
      "user",
      "使用者"
    ],
    [
      "set",
      "集"
    ],
    [
      "university",
      "大学"
    ],
    [
      "january",
      "元月"
    ],
    [
      "map",
      "地圖"
    ],
    [
      "life",
      "生活"
    ],
    [
      "know",
      "知道"
    ],
    [
      "management",
      "行政"
    ],
    [
      "part",
      "角"
    ],
    [
      "great",
      "大"
    ],
    [
      "united",
      "联合"
    ],
    [
      "hotel",
      "宾馆"
    ],
    [
      "real",
      "真"
    ],
    [
      "item",
      "分数"
    ],
    [
      "travel",
      "旅游"
    ],
    [
      "report",
      "爆炸 [bàozhà]"
    ],
    [
      "off",
      "出"
    ],
    [
      "member",
      "肢"
    ],
    [
      "before",
      "先"
    ],
    [
      "type",
      "门"
    ],
    [
      "because",
      "由于"
    ],
    [
      "car",
      "汽車"
    ],
    [
      "design",
      "意图"
    ],
    [
      "community",
      "共同体"
    ],
    [
      "within",
      "前"
    ],
    [
      "area",
      "角"
    ],
    [
      "want",
      "要"
    ],
    [
      "shipping",
      "海军舰队"
    ],
    [
      "family",
      "家"
    ],
    [
      "code",
      "代码"
    ],
    [
      "show",
      "表演"
    ],
    [
      "even",
      "也"
    ],
    [
      "black",
      "黑"
    ],
    [
      "check",
      "帐"
    ],
    [
      "special",
      "特別的"
    ],
    [
      "website",
      "網站"
    ],
    [
      "being",
      "在"
    ],
    [
      "file",
      "柱"
    ],
    [
      "today",
      "现在"
    ],
    [
      "case",
      "箱"
    ],
    [
      "project",
      "项目"
    ],
    [
      "section",
      "科"
    ],
    [
      "house",
      "房子"
    ],
    [
      "security",
      "證券"
    ],
    [
      "care",
      "关心"
    ],
    [
      "network",
      "互联网"
    ],
    [
      "down",
      "南"
    ],
    [
      "computer",
      "電腦"
    ],
    [
      "three",
      "叁"
    ],
    [
      "total",
      "完全"
    ],
    [
      "place",
      "做"
    ],
    [
      "download",
      "下载"
    ],
    [
      "access",
      "爆炸"
    ],
    [
      "history",
      "歷史"
    ],
    [
      "art",
      "艺术"
    ],
    [
      "personal",
      "亲自"
    ],
    [
      "since",
      "既然"
    ],
    [
      "board",
      "碟"
    ],
    [
      "white",
      "白色"
    ],
    [
      "text",
      "课文"
    ],
    [
      "rating",
      "专利"
    ],
    [
      "rate",
      "利息率"
    ],
    [
      "return",
      "呆"
    ],
    [
      "level",
      "安"
    ],
    [
      "form",
      "表"
    ],
    [
      "love",
      "愛"
    ],
    [
      "old",
      "過時"
    ],
    [
      "john",
      "卫生间"
    ],
    [
      "image",
      "画"
    ],
    [
      "department",
      "扇形"
    ],
    [
      "another",
      "别的"
    ],
    [
      "why",
      "什么"
    ],
    [
      "class",
      "类"
    ],
    [
      "still",
      "還"
    ],
    [
      "money",
      "錢"
    ],
    [
      "quality",
      "品质"
    ],
    [
      "content",
      "多少"
    ],
    [
      "country",
      "国"
    ],
    [
      "private",
      "私立"
    ],
    [
      "save",
      "保持"
    ],
    [
      "include",
      "介绍"
    ],
    [
      "college",
      "扇形"
    ],
    [
      "value",
      "價值"
    ],
    [
      "article",
      "冠詞"
    ],
    [
      "man",
      "人"
    ],
    [
      "different",
      "不一樣的"
    ],
    [
      "press",
      "打印機"
    ],
    [
      "learn",
      "學習"
    ],
    [
      "sale",
      "销售"
    ],
    [
      "around",
      "大約"
    ],
    [
      "print",
      "印刷"
    ],
    [
      "stock",
      "汤"
    ],
    [
      "credit",
      "單位"
    ],
    [
      "join",
      "接"
    ],
    [
      "science",
      "科学"
    ],
    [
      "west",
      "西洋"
    ],
    [
      "english",
      "英文"
    ],
    [
      "team",
      "團隊"
    ],
    [
      "estate",
      "所有權"
    ],
    [
      "gay",
      "快乐"
    ],
    [
      "week",
      "周"
    ],
    [
      "category",
      "類別"
    ],
    [
      "june",
      "6月"
    ],
    [
      "library",
      "图书馆"
    ],
    [
      "action",
      "行動"
    ],
    [
      "air",
      "空氣"
    ],
    [
      "industry",
      "工业"
    ],
    [
      "yes",
      "对"
    ],
    [
      "march",
      "边塞"
    ],
    [
      "say",
      "說"
    ],
    [
      "july",
      "7月"
    ],
    [
      "come",
      "來"
    ],
    [
      "staff",
      "全体职员"
    ],
    [
      "play",
      "打"
    ],
    [
      "street",
      "路"
    ],
    [
      "comment",
      "評論"
    ],
    [
      "against",
      "以前"
    ],
    [
      "standard",
      "旗子"
    ],
    [
      "below",
      "下"
    ],
    [
      "party",
      "聚會"
    ],
    [
      "student",
      "大学生"
    ],
    [
      "let",
      "出租"
    ],
    [
      "above",
      "多"
    ],
    [
      "park",
      "停車"
    ],
    [
      "side",
      "犁"
    ],
    [
      "act",
      "奏"
    ],
    [
      "red",
      "红"
    ],
    [
      "give",
      "給"
    ],
    [
      "august",
      "8月"
    ],
    [
      "quote",
      "價錢"
    ],
    [
      "language",
      "語言"
    ],
    [
      "sell",
      "傳遞"
    ],
    [
      "experience",
      "经验"
    ],
    [
      "key",
      "钥匙"
    ],
    [
      "body",
      "身体"
    ],
    [
      "young",
      "年輕"
    ],
    [
      "east",
      "东"
    ],
    [
      "paper",
      "纸"
    ],
    [
      "single",
      "一"
    ],
    [
      "age",
      "小时"
    ],
    [
      "club",
      "夜店"
    ],
    [
      "password",
      "密碼"
    ],
    [
      "road",
      "道路"
    ],
    [
      "question",
      "問題"
    ],
    [
      "night",
      "夜"
    ],
    [
      "hard",
      "硬"
    ],
    [
      "pay",
      "艌"
    ],
    [
      "browse",
      "看"
    ],
    [
      "issue",
      "做"
    ],
    [
      "range",
      "田"
    ],
    [
      "result",
      "答案"
    ],
    [
      "write",
      "写"
    ],
    [
      "war",
      "戰爭"
    ],
    [
      "blue",
      "蓝色"
    ],
    [
      "event",
      "事件"
    ],
    [
      "release",
      "出"
    ],
    [
      "request",
      "申请"
    ],
    [
      "china",
      "中國"
    ],
    [
      "picture",
      "图像"
    ],
    [
      "might",
      "力"
    ],
    [
      "yet",
      "还"
    ],
    [
      "month",
      "月份"
    ],
    [
      "major",
      "中指"
    ],
    [
      "star",
      "星"
    ],
    [
      "sun",
      "日"
    ],
    [
      "london",
      "伦敦"
    ],
    [
      "meeting",
      "會議"
    ],
    [
      "become",
      "成为"
    ],
    [
      "child",
      "小孩"
    ],
    [
      "share",
      "股票"
    ],
    [
      "garden",
      "花园"
    ],
    [
      "million",
      "百万"
    ],
    [
      "baby",
      "婴儿"
    ],
    [
      "learning",
      "知识"
    ],
    [
      "energy",
      "能源"
    ],
    [
      "delivery",
      "起源"
    ],
    [
      "popular",
      "通俗"
    ],
    [
      "term",
      "脚"
    ],
    [
      "put",
      "带来"
    ],
    [
      "journal",
      "历史"
    ],
    [
      "try",
      "考试"
    ],
    [
      "welcome",
      "欢迎"
    ],
    [
      "central",
      "中心"
    ],
    [
      "notice",
      "辭職"
    ],
    [
      "god",
      "天主"
    ],
    [
      "head",
      "頭"
    ],
    [
      "until",
      "前"
    ],
    [
      "cell",
      "細胞"
    ],
    [
      "away",
      "远"
    ],
    [
      "track",
      "块"
    ],
    [
      "australia",
      "澳大利亞"
    ],
    [
      "agreement",
      "協議"
    ],
    [
      "log",
      "击落"
    ],
    [
      "trade",
      "交易"
    ],
    [
      "tell",
      "告訴"
    ],
    [
      "further",
      "接着"
    ],
    [
      "association",
      "协会"
    ],
    [
      "able",
      "干"
    ],
    [
      "green",
      "绿"
    ],
    [
      "close",
      "关"
    ],
    [
      "drive",
      "作"
    ],
    [
      "gold",
      "黄金"
    ],
    [
      "short",
      "矮"
    ],
    [
      "lot",
      "命运"
    ],
    [
      "display",
      "屏幕"
    ],
    [
      "natural",
      "自然"
    ],
    [
      "whether",
      "假如"
    ],
    [
      "electronics",
      "電子學"
    ],
    [
      "period",
      "時間"
    ],
    [
      "official",
      "官方"
    ],
    [
      "land",
      "国家"
    ],
    [
      "done",
      "死了"
    ],
    [
      "window",
      "窗"
    ],
    [
      "france",
      "法兰西"
    ],
    [
      "pro",
      "专业"
    ],
    [
      "island",
      "岛"
    ],
    [
      "record",
      "唱片"
    ],
    [
      "direct",
      "令"
    ],
    [
      "environment",
      "環境"
    ],
    [
      "district",
      "地区"
    ],
    [
      "calendar",
      "日曆"
    ],
    [
      "style",
      "风格"
    ],
    [
      "front",
      "屏幕"
    ],
    [
      "statement",
      "判刑"
    ],
    [
      "ever",
      "从不"
    ],
    [
      "sound",
      "好"
    ],
    [
      "resource",
      "力气"
    ],
    [
      "present",
      "提出"
    ],
    [
      "word",
      "詞"
    ],
    [
      "material",
      "料"
    ],
    [
      "bill",
      "喙"
    ],
    [
      "talk",
      "廢話"
    ],
    [
      "final",
      "最后"
    ],
    [
      "adult",
      "成年人"
    ],
    [
      "thing",
      "東西"
    ],
    [
      "via",
      "用"
    ],
    [
      "cheap",
      "便宜的"
    ],
    [
      "true",
      "真"
    ],
    [
      "mark",
      "的"
    ],
    [
      "third",
      "第三"
    ],
    [
      "europe",
      "歐洲"
    ],
    [
      "bad",
      "壞"
    ],
    [
      "individual",
      "个人 的"
    ],
    [
      "cover",
      "書皮"
    ],
    [
      "fast",
      "面前"
    ],
    [
      "fact",
      "数据"
    ],
    [
      "unit",
      "單位"
    ],
    [
      "global",
      "圆球"
    ],
    [
      "meet",
      "会"
    ],
    [
      "economic",
      "便宜"
    ],
    [
      "player",
      "惰"
    ],
    [
      "subscribe",
      "签名"
    ],
    [
      "germany",
      "德意志"
    ],
    [
      "watch",
      "军衔"
    ],
    [
      "feel",
      "了解"
    ],
    [
      "bank",
      "银行"
    ],
    [
      "words",
      "課文"
    ],
    [
      "heart",
      "心"
    ],
    [
      "choose",
      "决定"
    ],
    [
      "error",
      "失誤"
    ],
    [
      "camera",
      "照相機"
    ],
    [
      "girl",
      "女儿"
    ],
    [
      "construction",
      "啟迪"
    ],
    [
      "clear",
      "免費"
    ],
    [
      "position",
      "地"
    ],
    [
      "michael",
      "麥可"
    ],
    [
      "step",
      "不"
    ],
    [
      "license",
      "营 业 执 照"
    ],
    [
      "paul",
      "保罗"
    ],
    [
      "lake",
      "湖泊"
    ],
    [
      "later",
      "后"
    ],
    [
      "church",
      "&"
    ],
    [
      "active",
      "活动"
    ],
    [
      "hardware",
      "硬件"
    ],
    [
      "figure",
      "人"
    ],
    [
      "fire",
      "火"
    ],
    [
      "holiday",
      "假日"
    ],
    [
      "chat",
      "说语"
    ],
    [
      "loss",
      "估量"
    ],
    [
      "face",
      "面"
    ],
    [
      "brand",
      "门"
    ],
    [
      "bit",
      "份"
    ],
    [
      "yellow",
      "黄"
    ],
    [
      "stuff",
      "事物"
    ],
    [
      "french",
      "法语"
    ],
    [
      "entry",
      "介绍"
    ],
    [
      "nature",
      "大自然"
    ],
    [
      "turn",
      "圈"
    ],
    [
      "mean",
      "卑鄙"
    ],
    [
      "growth",
      "植物"
    ],
    [
      "agency",
      "办公室"
    ],
    [
      "king",
      "国王"
    ],
    [
      "copy",
      "接"
    ],
    [
      "although",
      "不过"
    ],
    [
      "drug",
      "毒品"
    ],
    [
      "force",
      "原力"
    ],
    [
      "bay",
      "叫声"
    ],
    [
      "river",
      "川"
    ],
    [
      "commission",
      "佣金"
    ],
    [
      "stop",
      "停"
    ],
    [
      "bar",
      "巴"
    ],
    [
      "dog",
      "犬"
    ],
    [
      "build",
      "编纂"
    ],
    [
      "screen",
      "網"
    ],
    [
      "exchange",
      "獎學金"
    ],
    [
      "continue",
      "繼續"
    ],
    [
      "across",
      "经过"
    ],
    [
      "season",
      "季节"
    ],
    [
      "printer",
      "打印機"
    ],
    [
      "condition",
      "条件"
    ],
    [
      "organization",
      "组织"
    ],
    [
      "mind",
      "意志"
    ],
    [
      "sunday",
      "星期天"
    ],
    [
      "tour",
      "圈"
    ],
    [
      "menu",
      "选单"
    ],
    [
      "silver",
      "銀"
    ],
    [
      "solution",
      "解"
    ],
    [
      "role",
      "函数"
    ],
    [
      "rather",
      "力氣"
    ],
    [
      "certain",
      "一些"
    ],
    [
      "lower",
      "下載"
    ],
    [
      "particular",
      "专门"
    ],
    [
      "fine",
      "小"
    ],
    [
      "hour",
      "小時"
    ],
    [
      "gas",
      "气体"
    ],
    [
      "bush",
      "欧芹"
    ],
    [
      "career",
      "職業生涯"
    ],
    [
      "military",
      "軍事"
    ],
    [
      "woman",
      "妇女"
    ],
    [
      "bid",
      "请"
    ],
    [
      "kind",
      "等級"
    ],
    [
      "middle",
      "腰"
    ],
    [
      "cable",
      "索"
    ],
    [
      "object",
      "什物"
    ],
    [
      "length",
      "长度"
    ],
    [
      "nice",
      "美"
    ],
    [
      "score",
      "二十"
    ],
    [
      "ok",
      "好"
    ],
    [
      "capital",
      "首都"
    ],
    [
      "investment",
      "投資"
    ],
    [
      "saturday",
      "周六"
    ],
    [
      "christmas",
      "聖誕節"
    ],
    [
      "england",
      "英国"
    ],
    [
      "band",
      "背"
    ],
    [
      "lead",
      "鉛"
    ],
    [
      "george",
      "喬治"
    ],
    [
      "registration",
      "接收效果"
    ],
    [
      "airport",
      "飞机场"
    ],
    [
      "foreign",
      "奇怪"
    ],
    [
      "channel",
      "运河"
    ],
    [
      "letter",
      "信"
    ],
    [
      "structure",
      "结构"
    ],
    [
      "summer",
      "夏季"
    ],
    [
      "allow",
      "放"
    ],
    [
      "degree",
      "度"
    ],
    [
      "button",
      "扣子"
    ],
    [
      "wed",
      "娶"
    ],
    [
      "custom",
      "習慣"
    ],
    [
      "song",
      "歌曲"
    ],
    [
      "focus",
      "焦点"
    ],
    [
      "fall",
      "亡"
    ],
    [
      "female",
      "雌"
    ],
    [
      "win",
      "弄"
    ],
    [
      "primary",
      "前"
    ],
    [
      "cancer",
      "癌癥"
    ],
    [
      "numbers",
      "民數記"
    ],
    [
      "reason",
      "理致"
    ],
    [
      "tool",
      "具"
    ],
    [
      "spring",
      "泉"
    ],
    [
      "foundation",
      "基础"
    ],
    [
      "answer",
      "回答"
    ],
    [
      "voice",
      "声"
    ],
    [
      "schedule",
      "编程"
    ],
    [
      "purpose",
      "主題"
    ],
    [
      "feature",
      "出現"
    ],
    [
      "approach",
      "入口"
    ],
    [
      "brown",
      "棕色"
    ],
    [
      "physical",
      "物理"
    ],
    [
      "medicine",
      "药"
    ],
    [
      "deal",
      "分"
    ],
    [
      "hold",
      "夹住"
    ],
    [
      "glass",
      "杯"
    ],
    [
      "survey",
      "询问"
    ],
    [
      "telephone",
      "電話"
    ],
    [
      "feed",
      "吃"
    ],
    [
      "animal",
      "動物"
    ],
    [
      "pa",
      "外公"
    ],
    [
      "regular",
      "共同"
    ],
    [
      "ass",
      "屁股"
    ],
    [
      "simply",
      "刚"
    ],
    [
      "round",
      "圈"
    ],
    [
      "master",
      "主人"
    ],
    [
      "sea",
      "大海"
    ],
    [
      "blood",
      "血"
    ],
    [
      "cut",
      "理发"
    ],
    [
      "connection",
      "聯絡"
    ],
    [
      "hall",
      "客厅"
    ],
    [
      "impact",
      "印刷"
    ],
    [
      "transfer",
      "带"
    ],
    [
      "introduction",
      "引子"
    ],
    [
      "strong",
      "好"
    ],
    [
      "hospital",
      "醫院"
    ],
    [
      "ground",
      "场"
    ],
    [
      "italy",
      "義大利"
    ],
    [
      "perfect",
      "完美"
    ],
    [
      "hair",
      "头发"
    ],
    [
      "opportunity",
      "机会"
    ],
    [
      "kit",
      "一起"
    ],
    [
      "basis",
      "什么"
    ],
    [
      "command",
      "介绍"
    ],
    [
      "award",
      "奖"
    ],
    [
      "tree",
      "樹"
    ],
    [
      "wall",
      "墙壁"
    ],
    [
      "pussy",
      "屄"
    ],
    [
      "operation",
      "手术"
    ],
    [
      "quite",
      "力氣"
    ],
    [
      "boy",
      "男孩"
    ],
    [
      "wine",
      "酒"
    ],
    [
      "horse",
      "馬"
    ],
    [
      "forward",
      "早"
    ],
    [
      "significant",
      "高"
    ],
    [
      "son",
      "儿子"
    ],
    [
      "housing",
      "房子"
    ],
    [
      "mother",
      "母親"
    ],
    [
      "input",
      "进入"
    ],
    [
      "bin",
      "垃圾桶"
    ],
    [
      "senior",
      "前"
    ],
    [
      "ireland",
      "爱尔兰共和国"
    ],
    [
      "door",
      "門"
    ],
    [
      "trial",
      "烦扰"
    ],
    [
      "charge",
      "击"
    ],
    [
      "cool",
      "安"
    ],
    [
      "metal",
      "金"
    ],
    [
      "chinese",
      "中国"
    ],
    [
      "asia",
      "亚洲"
    ],
    [
      "resolution",
      "决议"
    ],
    [
      "pass",
      "护照"
    ],
    [
      "trust",
      "信"
    ],
    [
      "republic",
      "共和國"
    ],
    [
      "vacation",
      "假期"
    ],
    [
      "century",
      "世紀"
    ],
    [
      "grade",
      "年"
    ],
    [
      "vehicle",
      "车辆"
    ],
    [
      "consider",
      "想"
    ],
    [
      "behind",
      "以后"
    ],
    [
      "floor",
      "层"
    ],
    [
      "german",
      "德語"
    ],
    [
      "require",
      "必要"
    ],
    [
      "deep",
      "低"
    ],
    [
      "morning",
      "早上"
    ],
    [
      "rest",
      "和平"
    ],
    [
      "protein",
      "蛋白质"
    ],
    [
      "hit",
      "契約"
    ],
    [
      "pool",
      "盆地"
    ],
    [
      "faculty",
      "系"
    ],
    [
      "fish",
      "魚"
    ],
    [
      "string",
      "弦"
    ],
    [
      "sense",
      "意义"
    ],
    [
      "pack",
      "群"
    ],
    [
      "stage",
      "铂"
    ],
    [
      "japanese",
      "日语"
    ],
    [
      "race",
      "發展"
    ],
    [
      "background",
      "历史"
    ],
    [
      "character",
      "性格"
    ],
    [
      "yourself",
      "一"
    ],
    [
      "winter",
      "冬"
    ],
    [
      "youth",
      "年輕"
    ],
    [
      "pressure",
      "壓力"
    ],
    [
      "television",
      "電視"
    ],
    [
      "core",
      "内核"
    ],
    [
      "break",
      "下线"
    ],
    [
      "rent",
      "出租"
    ],
    [
      "remote",
      "远"
    ],
    [
      "dark",
      "黑暗"
    ],
    [
      "apple",
      "蘋果"
    ],
    [
      "surface",
      "面"
    ],
    [
      "block",
      "令"
    ],
    [
      "fair",
      "公平"
    ],
    [
      "steel",
      "鋼"
    ],
    [
      "understanding",
      "约会"
    ],
    [
      "wrong",
      "虚假"
    ],
    [
      "father",
      "爸爸"
    ],
    [
      "electric",
      "电子"
    ],
    [
      "driver",
      "駕駛"
    ],
    [
      "dead",
      "鈍"
    ],
    [
      "restaurant",
      "饭馆"
    ],
    [
      "trip",
      "块"
    ],
    [
      "poor",
      "貧窮"
    ],
    [
      "teacher",
      "教师"
    ],
    [
      "relationship",
      "关系"
    ],
    [
      "farm",
      "农场"
    ],
    [
      "georgia",
      "乔治亚"
    ],
    [
      "tom",
      "男性的"
    ],
    [
      "benefit",
      "好处"
    ],
    [
      "lord",
      "先生"
    ],
    [
      "agree",
      "忖度"
    ],
    [
      "hear",
      "听"
    ],
    [
      "museum",
      "博物館"
    ],
    [
      "transport",
      "放逐"
    ],
    [
      "former",
      "前者"
    ],
    [
      "ten",
      "拾"
    ],
    [
      "complex",
      "綜合大樓"
    ],
    [
      "cat",
      "貓"
    ],
    [
      "die",
      "去世"
    ],
    [
      "jack",
      "妈妈"
    ],
    [
      "flat",
      "平"
    ],
    [
      "literature",
      "文学"
    ],
    [
      "parent",
      "亲"
    ],
    [
      "spanish",
      "西班牙語"
    ],
    [
      "scale",
      "鱗"
    ],
    [
      "stand",
      "好"
    ],
    [
      "frame",
      "框"
    ],
    [
      "musical",
      "音乐家"
    ],
    [
      "employee",
      "職員"
    ],
    [
      "chief",
      "老板"
    ],
    [
      "bottom",
      "受动"
    ],
    [
      "pet",
      "发圈"
    ],
    [
      "clean",
      "乾淨"
    ],
    [
      "switch",
      "轉轍器"
    ],
    [
      "russian",
      "俄語"
    ],
    [
      "relevant",
      "本"
    ],
    [
      "justice",
      "司法"
    ],
    [
      "connect",
      "接"
    ],
    [
      "bible",
      "圣经"
    ],
    [
      "cup",
      "杯"
    ],
    [
      "basket",
      "篮"
    ],
    [
      "square",
      "正方"
    ],
    [
      "diet",
      "国会"
    ],
    [
      "gear",
      "物質"
    ],
    [
      "piece",
      "石"
    ],
    [
      "sheet",
      "低"
    ],
    [
      "seven",
      "柒"
    ],
    [
      "species",
      "種類"
    ],
    [
      "facility",
      "中央"
    ],
    [
      "random",
      "随机"
    ],
    [
      "minister",
      "部长"
    ],
    [
      "fashion",
      "方式"
    ],
    [
      "couple",
      "对"
    ],
    [
      "chance",
      "好运"
    ],
    [
      "vision",
      "美"
    ],
    [
      "ball",
      "舞会"
    ],
    [
      "listen",
      "聽"
    ],
    [
      "automotive",
      "汽車"
    ],
    [
      "naked",
      "裸体"
    ],
    [
      "goal",
      "球門"
    ],
    [
      "wind",
      "风"
    ],
    [
      "situation",
      "情況"
    ],
    [
      "patient",
      "耐心"
    ],
    [
      "actual",
      "本"
    ],
    [
      "stone",
      "石头"
    ],
    [
      "fit",
      "卡农"
    ],
    [
      "pain",
      "痛"
    ],
    [
      "edge",
      "刀刃"
    ],
    [
      "functional",
      "具"
    ],
    [
      "closed",
      "太"
    ],
    [
      "pink",
      "粉紅色"
    ],
    [
      "shot",
      "冰雹"
    ],
    [
      "architecture",
      "建筑"
    ],
    [
      "canon",
      "卡农"
    ],
    [
      "hardcore",
      "淫秽"
    ],
    [
      "league",
      "里"
    ],
    [
      "minute",
      "分"
    ],
    [
      "bus",
      "总线"
    ],
    [
      "dictionary",
      "词典"
    ],
    [
      "phase",
      "階段"
    ],
    [
      "fantasy",
      "奇幻"
    ],
    [
      "shirt",
      "襯衫"
    ],
    [
      "generally",
      "主要"
    ],
    [
      "mass",
      "弥撒"
    ],
    [
      "count",
      "伯爵"
    ],
    [
      "patch",
      "苍蝇"
    ],
    [
      "generation",
      "一代"
    ],
    [
      "task",
      "家務"
    ],
    [
      "reduce",
      "減少"
    ],
    [
      "enable",
      "开"
    ],
    [
      "exercise",
      "练"
    ],
    [
      "bug",
      "蟲"
    ],
    [
      "diamond",
      "钻石"
    ],
    [
      "soft",
      "軟"
    ],
    [
      "alone",
      "一"
    ],
    [
      "flight",
      "走"
    ],
    [
      "fuel",
      "开车"
    ],
    [
      "fuck",
      "屁眼"
    ],
    [
      "italian",
      "意大利语"
    ],
    [
      "argument",
      "主題"
    ],
    [
      "competition",
      "比賽"
    ],
    [
      "joint",
      "巴"
    ],
    [
      "premium",
      "会费"
    ],
    [
      "fresh",
      "新鮮"
    ],
    [
      "stream",
      "花丝"
    ],
    [
      "pick",
      "屏幕"
    ],
    [
      "eastern",
      "东"
    ],
    [
      "prime",
      "天頂"
    ],
    [
      "creek",
      "水流"
    ],
    [
      "myself",
      "我自己"
    ],
    [
      "platform",
      "阳台"
    ],
    [
      "load",
      "功率"
    ],
    [
      "defense",
      "禁止"
    ],
    [
      "heavy",
      "重的"
    ],
    [
      "cock",
      "傻子"
    ],
    [
      "universal",
      "无限"
    ],
    [
      "solid",
      "满"
    ],
    [
      "orange",
      "橙"
    ],
    [
      "guitar",
      "六弦琴"
    ],
    [
      "spirit",
      "心灵"
    ],
    [
      "acceptance",
      "同意"
    ],
    [
      "touch",
      "摸"
    ],
    [
      "hire",
      "租"
    ],
    [
      "election",
      "選舉"
    ],
    [
      "branch",
      "枝"
    ],
    [
      "magic",
      "魔法"
    ],
    [
      "mount",
      "炒"
    ],
    [
      "smart",
      "智能"
    ],
    [
      "latin",
      "拉丁語"
    ],
    [
      "manage",
      "会"
    ],
    [
      "corner",
      "角落"
    ],
    [
      "rank",
      "级"
    ],
    [
      "separate",
      "分"
    ],
    [
      "quarter",
      "区"
    ],
    [
      "procedure",
      "函数"
    ],
    [
      "leadership",
      "遙控器"
    ],
    [
      "breakfast",
      "早饭"
    ],
    [
      "domestic",
      "国家"
    ],
    [
      "reach",
      "遇到"
    ],
    [
      "sequence",
      "数列"
    ],
    [
      "sorry",
      "可怜"
    ],
    [
      "opening",
      "初次的演出"
    ],
    [
      "failure",
      "萝卜"
    ],
    [
      "dollar",
      "美元"
    ],
    [
      "camp",
      "露营"
    ],
    [
      "bridge",
      "桥"
    ],
    [
      "native",
      "原生"
    ],
    [
      "approval",
      "共识"
    ],
    [
      "chart",
      "图解"
    ],
    [
      "jesus",
      "耶穌"
    ],
    [
      "profit",
      "贏利"
    ],
    [
      "parking",
      "停车场"
    ],
    [
      "yesterday",
      "昨日"
    ],
    [
      "workshop",
      "神學院"
    ],
    [
      "russia",
      "俄羅斯"
    ],
    [
      "golden",
      "金的"
    ],
    [
      "senate",
      "参议院"
    ],
    [
      "funny",
      "奇怪"
    ],
    [
      "brother",
      "兄弟"
    ],
    [
      "pattern",
      "图案"
    ],
    [
      "boat",
      "小船"
    ],
    [
      "icon",
      "圣像"
    ],
    [
      "basketball",
      "籃球"
    ],
    [
      "evening",
      "黄昏"
    ],
    [
      "assembly",
      "会"
    ],
    [
      "mouse",
      "老鼠"
    ],
    [
      "signal",
      "捕捉网"
    ],
    [
      "brain",
      "头脑"
    ],
    [
      "dream",
      "夢"
    ],
    [
      "false",
      "虚假"
    ],
    [
      "cast",
      "一"
    ],
    [
      "flower",
      "花儿"
    ],
    [
      "soul",
      "灵魂"
    ],
    [
      "flag",
      "旗"
    ],
    [
      "advantage",
      "好处"
    ],
    [
      "hello",
      "喂"
    ],
    [
      "iron",
      "铁"
    ],
    [
      "straight",
      "尺度"
    ],
    [
      "script",
      "字母"
    ],
    [
      "void",
      "徒劳的"
    ],
    [
      "tag",
      "日"
    ],
    [
      "framework",
      "构造"
    ],
    [
      "disk",
      "唱片"
    ],
    [
      "clearly",
      "一定"
    ],
    [
      "fix",
      "修理"
    ],
    [
      "handle",
      "具"
    ],
    [
      "associate",
      "同事"
    ],
    [
      "ray",
      "光线"
    ],
    [
      "measure",
      "措施"
    ],
    [
      "duty",
      "工作"
    ],
    [
      "bear",
      "魋"
    ],
    [
      "laboratory",
      "實驗室"
    ],
    [
      "ocean",
      "大海"
    ],
    [
      "train",
      "列车"
    ],
    [
      "dry",
      "干"
    ],
    [
      "scotland",
      "蘇格蘭"
    ],
    [
      "intelligence",
      "心智"
    ],
    [
      "battle",
      "戰役"
    ],
    [
      "speak",
      "说话"
    ],
    [
      "query",
      "询问"
    ],
    [
      "clip",
      "回形针"
    ],
    [
      "equity",
      "股"
    ],
    [
      "speech",
      "演說"
    ],
    [
      "fight",
      "打"
    ],
    [
      "height",
      "高"
    ],
    [
      "speaker",
      "总统"
    ],
    [
      "netherlands",
      "荷蘭"
    ],
    [
      "roll",
      "呵责"
    ],
    [
      "korea",
      "韩国"
    ],
    [
      "bath",
      "沐浴"
    ],
    [
      "negative",
      "否定"
    ],
    [
      "perform",
      "表演"
    ],
    [
      "translation",
      "翻譯"
    ],
    [
      "font",
      "本"
    ],
    [
      "lawyer",
      "律师"
    ],
    [
      "toward",
      "上"
    ],
    [
      "conduct",
      "举行"
    ],
    [
      "jazz",
      "爵士乐"
    ],
    [
      "ultimate",
      "极端"
    ],
    [
      "finish",
      "有限"
    ],
    [
      "physics",
      "物理學"
    ],
    [
      "rare",
      "红"
    ],
    [
      "extreme",
      "极端的"
    ],
    [
      "daniel",
      "但以理書"
    ],
    [
      "row",
      "噪音"
    ],
    [
      "forecast",
      "預報"
    ],
    [
      "sleep",
      "睡覺"
    ],
    [
      "bird",
      "鳥"
    ],
    [
      "scene",
      "球面"
    ],
    [
      "hunter",
      "猎狗"
    ],
    [
      "lady",
      "西洋跳棋"
    ],
    [
      "drink",
      "喝"
    ],
    [
      "academy",
      "神學院"
    ],
    [
      "gender",
      "性別"
    ],
    [
      "eat",
      "吃饭"
    ],
    [
      "tip",
      "小費"
    ],
    [
      "guess",
      "假設"
    ],
    [
      "whom",
      "谁"
    ],
    [
      "presence",
      "在场"
    ],
    [
      "instant",
      "现在"
    ],
    [
      "moon",
      "月"
    ],
    [
      "scheme",
      "画"
    ],
    [
      "utility",
      "發電廠"
    ],
    [
      "fly",
      "蝇"
    ],
    [
      "matrix",
      "矩陣"
    ],
    [
      "strength",
      "強"
    ],
    [
      "proper",
      "右"
    ],
    [
      "principal",
      "客人"
    ],
    [
      "hey",
      "你好"
    ],
    [
      "adobe",
      "黏土"
    ],
    [
      "tea",
      "茶"
    ],
    [
      "achieve",
      "獲得"
    ],
    [
      "dress",
      "yīfu"
    ],
    [
      "sky",
      "天空"
    ],
    [
      "signature",
      "簽名"
    ],
    [
      "indeed",
      "真的"
    ],
    [
      "newspaper",
      "報紙"
    ],
    [
      "circuit",
      "圆圈"
    ],
    [
      "layer",
      "层"
    ],
    [
      "liability",
      "責任"
    ],
    [
      "hip",
      "臀部"
    ],
    [
      "nine",
      "玖"
    ],
    [
      "spot",
      "灯"
    ],
    [
      "spend",
      "过"
    ],
    [
      "grow",
      "成"
    ],
    [
      "clock",
      "时钟"
    ],
    [
      "dot",
      "点"
    ],
    [
      "feeling",
      "感情"
    ],
    [
      "reasonable",
      "中度"
    ],
    [
      "relief",
      "救濟"
    ],
    [
      "bass",
      "男低音"
    ],
    [
      "bedroom",
      "寝室"
    ],
    [
      "instance",
      "机会"
    ],
    [
      "ride",
      "坐"
    ],
    [
      "pair",
      "对"
    ],
    [
      "finished",
      "准备"
    ],
    [
      "dinner",
      "吃"
    ],
    [
      "stress",
      "疲倦"
    ],
    [
      "evil",
      "邪恶"
    ],
    [
      "shape",
      "形狀"
    ],
    [
      "euro",
      "欧元"
    ],
    [
      "usage",
      "用途"
    ],
    [
      "cap",
      "头"
    ],
    [
      "ink",
      "墨"
    ],
    [
      "transit",
      "交通"
    ],
    [
      "dick",
      "屌"
    ],
    [
      "salt",
      "鹽"
    ],
    [
      "forget",
      "忘記"
    ],
    [
      "array",
      "扇子"
    ],
    [
      "climate",
      "气候"
    ],
    [
      "pin",
      "交"
    ],
    [
      "alcohol",
      "醇"
    ],
    [
      "greek",
      "希腊人"
    ],
    [
      "annotation",
      "评论"
    ],
    [
      "sister",
      "妹"
    ],
    [
      "raw",
      "湿"
    ],
    [
      "explain",
      "解釋"
    ],
    [
      "establish",
      "办"
    ],
    [
      "extent",
      "尺寸"
    ],
    [
      "sharp",
      "升"
    ],
    [
      "lane",
      "路"
    ],
    [
      "kill",
      "杀死"
    ],
    [
      "conflict",
      "冲突的"
    ],
    [
      "occur",
      "在"
    ],
    [
      "trouble",
      "成本"
    ],
    [
      "coach",
      "教练"
    ],
    [
      "jordan",
      "約旦"
    ],
    [
      "cook",
      "做菜"
    ],
    [
      "affect",
      "移动"
    ],
    [
      "institution",
      "单位"
    ],
    [
      "bike",
      "摩托"
    ],
    [
      "indicate",
      "出来"
    ],
    [
      "favourite",
      "颊髯"
    ],
    [
      "lose",
      "撤回"
    ],
    [
      "chemistry",
      "化学"
    ],
    [
      "neighborhood",
      "区"
    ],
    [
      "template",
      "印板"
    ],
    [
      "circle",
      "圆圈"
    ],
    [
      "soil",
      "土"
    ],
    [
      "fox",
      "狐"
    ],
    [
      "plain",
      "单色"
    ],
    [
      "arm",
      "手臂"
    ],
    [
      "launch",
      "執行"
    ],
    [
      "wave",
      "波浪"
    ],
    [
      "belgium",
      "比利時"
    ],
    [
      "guidance",
      "方向"
    ],
    [
      "trail",
      "狩猎"
    ],
    [
      "symbol",
      "符號"
    ],
    [
      "poll",
      "查讯"
    ],
    [
      "bond",
      "结合"
    ],
    [
      "cotton",
      "棉花"
    ],
    [
      "biology",
      "生物學"
    ],
    [
      "border",
      "兰特"
    ],
    [
      "pregnancy",
      "懷孕"
    ],
    [
      "leisure",
      "空閑"
    ],
    [
      "husband",
      "老公"
    ],
    [
      "commitment",
      "义务"
    ],
    [
      "hop",
      "跳房子"
    ],
    [
      "constant",
      "定数"
    ],
    [
      "mouth",
      "嘴"
    ],
    [
      "gun",
      "枪"
    ],
    [
      "pure",
      "白"
    ],
    [
      "deliver",
      "好"
    ],
    [
      "wonder",
      "思维"
    ],
    [
      "hell",
      "地獄"
    ],
    [
      "fruit",
      "果"
    ],
    [
      "lens",
      "鏡"
    ],
    [
      "draw",
      "买"
    ],
    [
      "assume",
      "擔任"
    ],
    [
      "confidence",
      "信心"
    ],
    [
      "engineer",
      "工程師"
    ],
    [
      "clearance",
      "休假"
    ],
    [
      "objective",
      "物镜"
    ],
    [
      "sugar",
      "食糖"
    ],
    [
      "crew",
      "犁"
    ],
    [
      "stick",
      "蕊"
    ],
    [
      "rear",
      "后来的"
    ],
    [
      "enhance",
      "改"
    ],
    [
      "exact",
      "仔細"
    ],
    [
      "bound",
      "跃迁"
    ],
    [
      "node",
      "节"
    ],
    [
      "formal",
      "官方"
    ],
    [
      "lock",
      "船閘"
    ],
    [
      "storm",
      "暴风"
    ],
    [
      "mile",
      "结"
    ],
    [
      "navy",
      "水手"
    ],
    [
      "cancel",
      "取消"
    ],
    [
      "territory",
      "領土"
    ],
    [
      "pilot",
      "飛行員"
    ],
    [
      "outlet",
      "太"
    ],
    [
      "czech",
      "捷克语"
    ],
    [
      "novel",
      "小说"
    ],
    [
      "pan",
      "骨盆"
    ],
    [
      "examination",
      "检查"
    ],
    [
      "dish",
      "卡农"
    ],
    [
      "bulletin",
      "小册子"
    ],
    [
      "adam",
      "亚当"
    ],
    [
      "truly",
      "很 hěn 非常"
    ],
    [
      "candidate",
      "候选人"
    ],
    [
      "perspective",
      "透视"
    ],
    [
      "lodge",
      "倒"
    ],
    [
      "mirror",
      "备份"
    ],
    [
      "consideration",
      "報酬"
    ],
    [
      "kernel",
      "扁桃"
    ],
    [
      "gray",
      "灰"
    ],
    [
      "taiwan",
      "中華民國"
    ],
    [
      "greece",
      "希臘"
    ],
    [
      "labour",
      "分娩"
    ],
    [
      "rice",
      "稻"
    ],
    [
      "loop",
      "循环"
    ],
    [
      "reservation",
      "預訂"
    ],
    [
      "guard",
      "保护"
    ],
    [
      "saving",
      "節約"
    ],
    [
      "rome",
      "羅馬"
    ],
    [
      "tomorrow",
      "明天见"
    ],
    [
      "milk",
      "奶"
    ],
    [
      "contest",
      "比赛"
    ],
    [
      "chamber",
      "房間"
    ],
    [
      "guinea",
      "幾內亞"
    ],
    [
      "calculator",
      "电脑"
    ],
    [
      "chicken",
      "雞"
    ],
    [
      "attend",
      "照顾"
    ],
    [
      "shower",
      "淋浴器"
    ],
    [
      "dear",
      "贵"
    ],
    [
      "shell",
      "貝"
    ],
    [
      "measurement",
      "尺寸"
    ],
    [
      "catch",
      "办"
    ],
    [
      "pakistan",
      "巴基斯坦伊斯兰共和国"
    ],
    [
      "doubt",
      "疑惑"
    ],
    [
      "insert",
      "倒扑"
    ],
    [
      "gateway",
      "船桥"
    ],
    [
      "drawing",
      "画"
    ],
    [
      "transition",
      "通過"
    ],
    [
      "spy",
      "間諜"
    ],
    [
      "instrument",
      "乐器"
    ],
    [
      "split",
      "块"
    ],
    [
      "heaven",
      "天堂"
    ],
    [
      "bargain",
      "机会"
    ],
    [
      "wikipedia",
      "維基百科"
    ],
    [
      "suit",
      "续作"
    ],
    [
      "shift",
      "电子回路"
    ],
    [
      "chip",
      "晶片"
    ],
    [
      "sit",
      "在"
    ],
    [
      "satisfaction",
      "滿意"
    ],
    [
      "cartoon",
      "笔记"
    ],
    [
      "comfortable",
      "舒服"
    ],
    [
      "registry",
      "套准"
    ],
    [
      "outlook",
      "看法"
    ],
    [
      "massive",
      "不錯"
    ],
    [
      "denmark",
      "丹麥"
    ],
    [
      "bright",
      "快乐"
    ],
    [
      "header",
      "结构楣"
    ],
    [
      "poverty",
      "贫穷"
    ],
    [
      "piano",
      "鋼琴"
    ],
    [
      "grid",
      "枷"
    ],
    [
      "mystery",
      "啞謎"
    ],
    [
      "landscape",
      "环境"
    ],
    [
      "journey",
      "道"
    ],
    [
      "banner",
      "优秀"
    ],
    [
      "cooperation",
      "協作"
    ],
    [
      "pull",
      "挑逗"
    ],
    [
      "sensitive",
      "愛哭鬼"
    ],
    [
      "folder",
      "目录"
    ],
    [
      "broadcast",
      "节目"
    ],
    [
      "strip",
      "漫画"
    ],
    [
      "plot",
      "地域"
    ],
    [
      "possibly",
      "可能"
    ],
    [
      "regard",
      "涉及"
    ],
    [
      "strike",
      "罷工"
    ],
    [
      "narrow",
      "穷"
    ],
    [
      "trailer",
      "电影"
    ],
    [
      "hundred",
      "一百"
    ],
    [
      "strange",
      "外国"
    ],
    [
      "philippines",
      "菲律賓"
    ],
    [
      "bold",
      "胖"
    ],
    [
      "bathroom",
      "洗手间"
    ],
    [
      "opera",
      "歌剧"
    ],
    [
      "blank",
      "干"
    ],
    [
      "generate",
      "办"
    ],
    [
      "bulk",
      "一起"
    ],
    [
      "indonesia",
      "印尼"
    ],
    [
      "fabric",
      "织物"
    ],
    [
      "tight",
      "紧张"
    ],
    [
      "expensive",
      "贵"
    ],
    [
      "seed",
      "種子"
    ],
    [
      "peer",
      "同事"
    ],
    [
      "bottle",
      "瓶"
    ],
    [
      "conclusion",
      "結論"
    ],
    [
      "legend",
      "传说"
    ],
    [
      "bang",
      "爆炸"
    ],
    [
      "bone",
      "骨头"
    ],
    [
      "collaboration",
      "阴谋"
    ],
    [
      "gate",
      "口"
    ],
    [
      "settlement",
      "縣"
    ],
    [
      "roman",
      "罗马"
    ],
    [
      "tone",
      "四声"
    ],
    [
      "forever",
      "老是"
    ],
    [
      "dragon",
      "龍"
    ],
    [
      "neck",
      "頸"
    ],
    [
      "operational",
      "活动"
    ],
    [
      "rail",
      "軌"
    ],
    [
      "liberal",
      "优厚"
    ],
    [
      "gap",
      "休息"
    ],
    [
      "tube",
      "听"
    ],
    [
      "jacket",
      "毯子"
    ],
    [
      "oracle",
      "神諭"
    ],
    [
      "proud",
      "吹嘘"
    ],
    [
      "alarm",
      "闹钟"
    ],
    [
      "possibility",
      "前景"
    ],
    [
      "attachment",
      "附件"
    ],
    [
      "finland",
      "芬蘭"
    ],
    [
      "pleasure",
      "意愿"
    ],
    [
      "honor",
      "荣誉"
    ],
    [
      "eagle",
      "老鹰"
    ],
    [
      "pants",
      "四角裤"
    ],
    [
      "nurse",
      "乳母"
    ],
    [
      "prayer",
      "渴"
    ],
    [
      "appointment",
      "妥協"
    ],
    [
      "hurricane",
      "颶風"
    ],
    [
      "quiet",
      "安"
    ],
    [
      "cheese",
      "芝士"
    ],
    [
      "comic",
      "漫畫"
    ],
    [
      "jet",
      "流"
    ],
    [
      "underground",
      "秘密"
    ],
    [
      "crack",
      "記"
    ],
    [
      "principle",
      "原则"
    ],
    [
      "gang",
      "伙"
    ],
    [
      "appearance",
      "外表"
    ],
    [
      "smoke",
      "煙"
    ],
    [
      "craft",
      "船"
    ],
    [
      "fellow",
      "同伴"
    ],
    [
      "mad",
      "恶"
    ],
    [
      "gross",
      "总的"
    ],
    [
      "strongly",
      "力氣"
    ],
    [
      "familiar",
      "朋友"
    ],
    [
      "shoe",
      "鞋子"
    ],
    [
      "victory",
      "勝利"
    ],
    [
      "actor",
      "演員"
    ],
    [
      "seal",
      "印章"
    ],
    [
      "prize",
      "獎品"
    ],
    [
      "pipe",
      "管"
    ],
    [
      "guardian",
      "头目"
    ],
    [
      "simulation",
      "游泳池"
    ],
    [
      "layout",
      "地图"
    ],
    [
      "ill",
      "不好"
    ],
    [
      "concentration",
      "浓度"
    ],
    [
      "lay",
      "睡觉"
    ],
    [
      "dirty",
      "猪"
    ],
    [
      "temple",
      "寺廟"
    ],
    [
      "ridge",
      "带"
    ],
    [
      "cabinet",
      "內閣"
    ],
    [
      "collect",
      "接"
    ],
    [
      "composition",
      "樂曲"
    ],
    [
      "vector",
      "矢量"
    ],
    [
      "mutual",
      "互"
    ],
    [
      "attribute",
      "决定性的"
    ],
    [
      "prison",
      "狱"
    ],
    [
      "apparently",
      "表面上"
    ],
    [
      "inquiry",
      "检查"
    ],
    [
      "exhibit",
      "发"
    ],
    [
      "trend",
      "時裝"
    ],
    [
      "mercury",
      "汞"
    ],
    [
      "summit",
      "峰"
    ],
    [
      "burning",
      "灼傷"
    ],
    [
      "substantial",
      "現實"
    ],
    [
      "glance",
      "烟煤"
    ],
    [
      "depression",
      "低氣壓"
    ],
    [
      "judgment",
      "裁判"
    ],
    [
      "foster",
      "生長"
    ],
    [
      "passing",
      "乐章"
    ],
    [
      "explanation",
      "说明"
    ],
    [
      "folk",
      "常见"
    ],
    [
      "electricity",
      "电"
    ],
    [
      "lift",
      "电梯"
    ],
    [
      "korean",
      "朝鮮語"
    ],
    [
      "subsequent",
      "次"
    ],
    [
      "yard",
      "码"
    ],
    [
      "establishment",
      "系統"
    ],
    [
      "murder",
      "出生"
    ],
    [
      "yield",
      "給"
    ],
    [
      "wiki",
      "维基"
    ],
    [
      "butt",
      "桶"
    ],
    [
      "ear",
      "耳"
    ],
    [
      "conservative",
      "古体"
    ],
    [
      "shock",
      "震动"
    ],
    [
      "abroad",
      "外面"
    ],
    [
      "ward",
      "堂区"
    ],
    [
      "roof",
      "屋頂"
    ],
    [
      "beast",
      "动物"
    ],
    [
      "counsel",
      "律师"
    ],
    [
      "pizza",
      "比萨"
    ],
    [
      "assignment",
      "作业"
    ],
    [
      "ukraine",
      "烏克蘭"
    ],
    [
      "absence",
      "请假"
    ],
    [
      "cluster",
      "星团"
    ],
    [
      "whereas",
      "当"
    ],
    [
      "lamp",
      "燈"
    ],
    [
      "palace",
      "宮殿"
    ],
    [
      "globe",
      "}}"
    ],
    [
      "copper",
      "铜"
    ],
    [
      "rack",
      "三角架"
    ],
    [
      "receipt",
      "收条"
    ],
    [
      "ordinary",
      "一般"
    ],
    [
      "boss",
      "头目"
    ],
    [
      "pride",
      "群"
    ],
    [
      "independence",
      "獨立"
    ],
    [
      "cloudy",
      "不透光"
    ],
    [
      "throat",
      "喉"
    ],
    [
      "wealth",
      "财富"
    ],
    [
      "brass",
      "妓女"
    ],
    [
      "booty",
      "屁股"
    ],
    [
      "harbor",
      "口"
    ],
    [
      "puzzle",
      "啞謎"
    ],
    [
      "thick",
      "粗"
    ],
    [
      "syndrome",
      "综合症"
    ],
    [
      "attendance",
      "出现"
    ],
    [
      "penalty",
      "刑罰"
    ],
    [
      "vista",
      "看法"
    ],
    [
      "flood",
      "洪灾"
    ],
    [
      "casual",
      "体操"
    ],
    [
      "polish",
      "波蘭語"
    ],
    [
      "lovely",
      "奇妙"
    ],
    [
      "charger",
      "充電器"
    ],
    [
      "pine",
      "怀念"
    ],
    [
      "divorce",
      "離婚"
    ],
    [
      "tokyo",
      "東京"
    ],
    [
      "tradition",
      "傳統"
    ],
    [
      "tiger",
      "虎"
    ],
    [
      "hunt",
      "狩獵"
    ],
    [
      "loaded",
      "蓝"
    ],
    [
      "complaint",
      "疾病"
    ],
    [
      "boost",
      "偷窃"
    ],
    [
      "scholarship",
      "[[#"
    ],
    [
      "mill",
      "厂"
    ],
    [
      "moral",
      "道德"
    ],
    [
      "den",
      "洞"
    ],
    [
      "burn",
      "涓"
    ],
    [
      "ourselves",
      "同一"
    ],
    [
      "bread",
      "面包"
    ],
    [
      "tobacco",
      "煙草"
    ],
    [
      "lie",
      "说谎"
    ],
    [
      "precision",
      "精度"
    ],
    [
      "diverse",
      "不一样"
    ],
    [
      "sole",
      "舌"
    ],
    [
      "sight",
      "对准"
    ],
    [
      "reception",
      "接待"
    ],
    [
      "danger",
      "危险"
    ],
    [
      "phrase",
      "句子"
    ],
    [
      "leaf",
      "葉"
    ],
    [
      "pad",
      "筆"
    ],
    [
      "rod",
      "尾"
    ],
    [
      "fault",
      "不足"
    ],
    [
      "introduce",
      "導入"
    ],
    [
      "silk",
      "丝"
    ],
    [
      "romantic",
      "爱情"
    ],
    [
      "infant",
      "男孩"
    ],
    [
      "samuel",
      "撒母耳记"
    ],
    [
      "fluid",
      "液体"
    ],
    [
      "grounds",
      "地域"
    ],
    [
      "meal",
      "麵粉"
    ],
    [
      "hurt",
      "疼"
    ],
    [
      "probability",
      "概率"
    ],
    [
      "pot",
      "脐"
    ],
    [
      "devil",
      "魔鬼"
    ],
    [
      "cherry",
      "櫻桃"
    ],
    [
      "alternate",
      "另外的美"
    ],
    [
      "achievement",
      "成功"
    ],
    [
      "funeral",
      "葬禮"
    ],
    [
      "mars",
      "戰神"
    ],
    [
      "manga",
      "漫畫"
    ],
    [
      "socket",
      "碗"
    ],
    [
      "silent",
      "无声音的"
    ],
    [
      "egg",
      "蛋"
    ],
    [
      "childhood",
      "儿童期"
    ],
    [
      "talent",
      "天資"
    ],
    [
      "shoot",
      "攝影"
    ],
    [
      "boundary",
      "兰特"
    ],
    [
      "mint",
      "胡椒薄荷"
    ],
    [
      "spin",
      "效果"
    ],
    [
      "swedish",
      "瑞典的"
    ],
    [
      "witness",
      "考试"
    ],
    [
      "declaration",
      "宣言"
    ],
    [
      "knight",
      "馬"
    ],
    [
      "loose",
      "松开"
    ],
    [
      "illness",
      "疾病"
    ],
    [
      "ho",
      "屄"
    ],
    [
      "disorder",
      "紊乱"
    ],
    [
      "habitat",
      "棲息地"
    ],
    [
      "bachelor",
      "学士"
    ],
    [
      "montreal",
      "蒙特利尔"
    ],
    [
      "difficulty",
      "难题"
    ],
    [
      "punk",
      "龐克文化"
    ],
    [
      "pace",
      "不"
    ],
    [
      "besides",
      "除了"
    ],
    [
      "atlas",
      "大地图"
    ],
    [
      "coat",
      "低"
    ],
    [
      "wizard",
      "巫师"
    ],
    [
      "liver",
      "肝脏"
    ],
    [
      "recall",
      "引"
    ],
    [
      "belief",
      "信仰"
    ],
    [
      "shoulder",
      "铁铲"
    ],
    [
      "ottawa",
      "渥太华"
    ],
    [
      "tit",
      "乳頭"
    ],
    [
      "peru",
      "秘魯"
    ],
    [
      "refine",
      "净化"
    ],
    [
      "aging",
      "衰老"
    ],
    [
      "intervention",
      "干預"
    ],
    [
      "invite",
      "邀請"
    ],
    [
      "reed",
      "梳子"
    ],
    [
      "assurance",
      "保險"
    ],
    [
      "clerk",
      "教士"
    ],
    [
      "outline",
      "提要"
    ],
    [
      "compilation",
      "翻译"
    ],
    [
      "odd",
      "罕见"
    ],
    [
      "wrap",
      "邐"
    ],
    [
      "mood",
      "大气"
    ],
    [
      "attractive",
      "吸引人的"
    ],
    [
      "occasion",
      "机会"
    ],
    [
      "beam",
      "臂"
    ],
    [
      "arrive",
      "创作"
    ],
    [
      "discipline",
      "枝"
    ],
    [
      "romania",
      "羅馬尼亞"
    ],
    [
      "turkish",
      "土耳其語"
    ],
    [
      "cry",
      "喊"
    ],
    [
      "zoo",
      "動物園"
    ],
    [
      "rough",
      "坚硬"
    ],
    [
      "lion",
      "狮子"
    ],
    [
      "oxygen",
      "氧"
    ],
    [
      "cookie",
      "屄"
    ],
    [
      "arrangement",
      "一致"
    ],
    [
      "pointer",
      "思想"
    ],
    [
      "stretch",
      "块"
    ],
    [
      "cricket",
      "板球"
    ],
    [
      "stroke",
      "笔"
    ],
    [
      "township",
      "州"
    ],
    [
      "headquarters",
      "总部"
    ],
    [
      "crowd",
      "民族"
    ],
    [
      "rainbow",
      "隮"
    ],
    [
      "decline",
      "变格"
    ],
    [
      "cord",
      "部"
    ],
    [
      "cloud",
      "云"
    ],
    [
      "jamaica",
      "牙買加"
    ],
    [
      "incredible",
      "奇妙"
    ],
    [
      "crop",
      "花"
    ],
    [
      "hub",
      "中心"
    ],
    [
      "portuguese",
      "葡萄牙語"
    ],
    [
      "steam",
      "忿怒"
    ],
    [
      "acute",
      "和"
    ],
    [
      "sing",
      "唱"
    ],
    [
      "stack",
      "电池"
    ],
    [
      "methodology",
      "如何"
    ],
    [
      "hang",
      "停"
    ],
    [
      "trunk",
      "树干"
    ],
    [
      "damn",
      "詛咒"
    ],
    [
      "colombia",
      "哥倫比亞"
    ],
    [
      "camel",
      "駱駝"
    ],
    [
      "hood",
      "風帽"
    ],
    [
      "suicide",
      "自殺"
    ],
    [
      "gathering",
      "会"
    ],
    [
      "juice",
      "汁"
    ],
    [
      "courtesy",
      "气量"
    ],
    [
      "judges",
      "士師記"
    ],
    [
      "juvenile",
      "年輕"
    ],
    [
      "afraid",
      "可惜"
    ],
    [
      "ruby",
      "紅寶石"
    ],
    [
      "fortune",
      "快乐"
    ],
    [
      "venezuela",
      "委內瑞拉"
    ],
    [
      "stem",
      "莖"
    ],
    [
      "translate",
      "翻譯"
    ],
    [
      "costume",
      "偽裝"
    ],
    [
      "bishop",
      "象"
    ],
    [
      "corn",
      "雞眼"
    ],
    [
      "tin",
      "锡"
    ],
    [
      "terrorist",
      "恐怖分子"
    ],
    [
      "rat",
      "鼠"
    ],
    [
      "heading",
      "海角"
    ],
    [
      "bearing",
      "秉性"
    ],
    [
      "haven",
      "棲身之地"
    ],
    [
      "charm",
      "魔法"
    ],
    [
      "violent",
      "亮"
    ],
    [
      "basin",
      "碗"
    ],
    [
      "soup",
      "湯"
    ],
    [
      "crossing",
      "巡洋艦"
    ],
    [
      "drunk",
      "醉态"
    ],
    [
      "nose",
      "鼻"
    ],
    [
      "alien",
      "外星人"
    ],
    [
      "nepal",
      "尼泊爾"
    ],
    [
      "zimbabwe",
      "津巴布韦"
    ],
    [
      "barcelona",
      "巴塞羅那"
    ],
    [
      "thesis",
      "论文"
    ],
    [
      "frequent",
      "常"
    ],
    [
      "trim",
      "盘子"
    ],
    [
      "nigeria",
      "奈及利亞"
    ],
    [
      "hospitality",
      "服务"
    ],
    [
      "bunch",
      "包"
    ],
    [
      "afford",
      "供給"
    ],
    [
      "substitute",
      "變為"
    ],
    [
      "brilliant",
      "明亮"
    ],
    [
      "termination",
      "堕胎"
    ],
    [
      "grill",
      "烤架"
    ],
    [
      "regime",
      "政权"
    ],
    [
      "bull",
      "牛"
    ],
    [
      "depend",
      "靠"
    ],
    [
      "candle",
      "蠟燭"
    ],
    [
      "strictly",
      "认真"
    ],
    [
      "coin",
      "硬幣"
    ],
    [
      "salon",
      "理发店"
    ],
    [
      "commander",
      "中校"
    ],
    [
      "arch",
      "拱"
    ],
    [
      "soldier",
      "兵"
    ],
    [
      "harm",
      "邪惡"
    ],
    [
      "brush",
      "刷子"
    ],
    [
      "spare",
      "苗條"
    ],
    [
      "tongue",
      "舌头"
    ],
    [
      "danish",
      "丹麦的"
    ],
    [
      "florence",
      "佛羅倫薩"
    ],
    [
      "invest",
      "授予"
    ],
    [
      "honey",
      "蜜"
    ],
    [
      "scenario",
      "劇本"
    ],
    [
      "arabic",
      "阿拉伯"
    ],
    [
      "gauge",
      "口徑"
    ],
    [
      "cheat",
      "偷"
    ],
    [
      "bronze",
      "青銅"
    ],
    [
      "testimony",
      "證據"
    ],
    [
      "tuition",
      "直线"
    ],
    [
      "luxembourg",
      "卢森堡"
    ],
    [
      "citation",
      "約會"
    ],
    [
      "pitch",
      "不"
    ],
    [
      "cloth",
      "奩"
    ],
    [
      "tan",
      "昏暗"
    ],
    [
      "mate",
      "朋友"
    ],
    [
      "starter",
      "入口"
    ],
    [
      "butter",
      "黃油"
    ],
    [
      "depot",
      "存款"
    ],
    [
      "pie",
      "糕"
    ],
    [
      "apparent",
      "明白"
    ],
    [
      "toilet",
      "厕所"
    ],
    [
      "explicit",
      "黄色"
    ],
    [
      "calculation",
      "計算"
    ],
    [
      "stud",
      "钉"
    ],
    [
      "fold",
      "上床"
    ],
    [
      "slut",
      "妓女"
    ],
    [
      "beijing",
      "北京市"
    ],
    [
      "approve",
      "赞成"
    ],
    [
      "compound",
      "化合物"
    ],
    [
      "abortion",
      "流产"
    ],
    [
      "calcium",
      "钙"
    ],
    [
      "harvest",
      "收穫"
    ],
    [
      "iceland",
      "冰島"
    ],
    [
      "demonstration",
      "示威"
    ],
    [
      "graduation",
      "畢業典禮"
    ],
    [
      "bend",
      "结"
    ],
    [
      "addiction",
      "中毒"
    ],
    [
      "ecology",
      "生态学"
    ],
    [
      "botswana",
      "波札那"
    ],
    [
      "olive",
      "橄欖"
    ],
    [
      "velocity",
      "頻率"
    ],
    [
      "relay",
      "继电器"
    ],
    [
      "silicon",
      "矽"
    ],
    [
      "norwegian",
      "挪威語"
    ],
    [
      "belong",
      "听"
    ],
    [
      "malta",
      "馬耳他"
    ],
    [
      "rabbit",
      "兔子"
    ],
    [
      "friendship",
      "友情"
    ],
    [
      "heather",
      "丁香紫"
    ],
    [
      "occupied",
      "忙"
    ],
    [
      "rally",
      "拉力赛"
    ],
    [
      "sunshine",
      "太阳"
    ],
    [
      "drag",
      "木鞋"
    ],
    [
      "ceremony",
      "仪式"
    ],
    [
      "hebrew",
      "希伯来文"
    ],
    [
      "laundry",
      "洗濯"
    ],
    [
      "solomon",
      "所罗门"
    ],
    [
      "filling",
      "鉛"
    ],
    [
      "possession",
      "所有權"
    ],
    [
      "vocal",
      "高声"
    ],
    [
      "trainer",
      "運動鞋"
    ],
    [
      "organ",
      "風琴"
    ],
    [
      "toxic",
      "刻毒"
    ],
    [
      "nuts",
      "尖"
    ],
    [
      "nail",
      "钉子"
    ],
    [
      "vienna",
      "维也纳"
    ],
    [
      "joke",
      "玩笑"
    ],
    [
      "appliance",
      "器官系統"
    ],
    [
      "bahamas",
      "巴哈馬"
    ],
    [
      "sheep",
      "羊"
    ],
    [
      "accordingly",
      "那"
    ],
    [
      "salad",
      "生菜"
    ],
    [
      "tender",
      "招标"
    ],
    [
      "easter",
      "复活节"
    ],
    [
      "praise",
      "赞扬"
    ],
    [
      "landing",
      "濕"
    ],
    [
      "integral",
      "整数"
    ],
    [
      "relax",
      "松开"
    ],
    [
      "namibia",
      "納米比亞"
    ],
    [
      "hardly",
      "坚硬"
    ],
    [
      "ecuador",
      "厄瓜多爾"
    ],
    [
      "bubble",
      "风"
    ],
    [
      "vessel",
      "容器"
    ],
    [
      "admit",
      "留"
    ],
    [
      "fancy",
      "想"
    ],
    [
      "tap",
      "雄"
    ],
    [
      "squad",
      "战队"
    ],
    [
      "scroll",
      "蛞蝓"
    ],
    [
      "suffer",
      "吃"
    ],
    [
      "distribute",
      "分配"
    ],
    [
      "compiler",
      "編譯器"
    ],
    [
      "bee",
      "蜂"
    ],
    [
      "conjunction",
      "连词"
    ],
    [
      "anchor",
      "锚"
    ],
    [
      "trigger",
      "使活动"
    ],
    [
      "transcript",
      "課文"
    ],
    [
      "ruth",
      "路得记"
    ],
    [
      "stylus",
      "蓝宝石"
    ],
    [
      "pope",
      "教宗"
    ],
    [
      "pit",
      "井"
    ],
    [
      "bolivia",
      "玻利維亞"
    ],
    [
      "spell",
      "病"
    ],
    [
      "construct",
      "建設"
    ],
    [
      "inspiration",
      "呼吸"
    ],
    [
      "sudan",
      "苏丹共和国"
    ],
    [
      "knee",
      "膝盖"
    ],
    [
      "ton",
      "吨"
    ],
    [
      "courier",
      "郵件"
    ],
    [
      "latvia",
      "拉脫維亞"
    ],
    [
      "cant",
      "隐语"
    ],
    [
      "genesis",
      "創世記"
    ],
    [
      "barrier",
      "国境"
    ],
    [
      "argue",
      "吵架"
    ],
    [
      "arise",
      "发生"
    ],
    [
      "guatemala",
      "危地馬拉"
    ],
    [
      "particle",
      "助词"
    ],
    [
      "advise",
      "通知"
    ],
    [
      "humidity",
      "湿度"
    ],
    [
      "bra",
      "奶罩"
    ],
    [
      "ordinance",
      "禁制令"
    ],
    [
      "chess",
      "國際象棋"
    ],
    [
      "survive",
      "大难不死"
    ],
    [
      "duck",
      "鴨"
    ],
    [
      "cow",
      "牛"
    ],
    [
      "dive",
      "燕子"
    ],
    [
      "drill",
      "吻"
    ],
    [
      "offense",
      "袭击"
    ],
    [
      "fiji",
      "斐濟"
    ],
    [
      "trick",
      "圈"
    ],
    [
      "steady",
      "固定的"
    ],
    [
      "dirt",
      "埃"
    ],
    [
      "screw",
      "螺釘"
    ],
    [
      "geneva",
      "日內瓦"
    ],
    [
      "informal",
      "使魔"
    ],
    [
      "incentive",
      "奖金"
    ],
    [
      "uncle",
      "舅父"
    ],
    [
      "reflection",
      "镜像"
    ],
    [
      "decent",
      "充實"
    ],
    [
      "shortly",
      "矮"
    ],
    [
      "horn",
      "法國號"
    ],
    [
      "frog",
      "蛙"
    ],
    [
      "grammar",
      "文法"
    ],
    [
      "hazard",
      "机会"
    ],
    [
      "snap",
      "曲奇"
    ],
    [
      "ribbon",
      "缎带"
    ],
    [
      "doe",
      "螺母"
    ],
    [
      "startup",
      "初创企业"
    ],
    [
      "handy",
      "容易获得的"
    ],
    [
      "geometry",
      "几何"
    ],
    [
      "refuse",
      "拒绝"
    ],
    [
      "replica",
      "縮小模型"
    ],
    [
      "plumbing",
      "水暖工"
    ],
    [
      "transparent",
      "透明"
    ],
    [
      "nuke",
      "核反应堆"
    ],
    [
      "boom",
      "矛"
    ],
    [
      "calm",
      "安静"
    ],
    [
      "distinguished",
      "高贵的"
    ],
    [
      "triangle",
      "三角"
    ],
    [
      "amend",
      "修改"
    ],
    [
      "zambia",
      "贊比亞"
    ],
    [
      "hydrogen",
      "氢"
    ],
    [
      "chick",
      "蛞蝓"
    ],
    [
      "confusion",
      "混亂"
    ],
    [
      "tray",
      "抽屉"
    ],
    [
      "medal",
      "獎章"
    ],
    [
      "sage",
      "鼠尾草"
    ],
    [
      "arrange",
      "办"
    ],
    [
      "booth",
      "細胞"
    ],
    [
      "breed",
      "栽培種"
    ],
    [
      "lip",
      "唇"
    ],
    [
      "gather",
      "接"
    ],
    [
      "embassy",
      "大使馆"
    ],
    [
      "slight",
      "不好"
    ],
    [
      "horizon",
      "地平线"
    ],
    [
      "pursue",
      "寻找"
    ],
    [
      "lightning",
      "閃電"
    ],
    [
      "grab",
      "抓住"
    ],
    [
      "attract",
      "拉"
    ],
    [
      "nipple",
      "乳头"
    ],
    [
      "trap",
      "虹吸"
    ],
    [
      "lonely",
      "偶见的"
    ],
    [
      "fool",
      "疯狂的"
    ],
    [
      "observe",
      "看见"
    ],
    [
      "berry",
      "浆果"
    ],
    [
      "collar",
      "領子"
    ],
    [
      "bermuda",
      "百慕大群岛"
    ],
    [
      "kidney",
      "肾脏"
    ],
    [
      "hungarian",
      "匈牙利语"
    ],
    [
      "vegetable",
      "菜"
    ],
    [
      "verse",
      "韻文"
    ],
    [
      "custody",
      "取保候审"
    ],
    [
      "nasty",
      "丑"
    ],
    [
      "ugly",
      "難看"
    ],
    [
      "ment",
      "suffix"
    ],
    [
      "queue",
      "尾"
    ],
    [
      "locale",
      "語言"
    ],
    [
      "bundle",
      "包"
    ],
    [
      "notion",
      "意图"
    ],
    [
      "welsh",
      "威爾士語"
    ],
    [
      "elder",
      "老龄"
    ],
    [
      "punishment",
      "刑罰"
    ],
    [
      "essence",
      "性格"
    ],
    [
      "ethiopia",
      "埃塞俄比亞"
    ],
    [
      "synthetic",
      "人造的"
    ],
    [
      "testament",
      "圣经"
    ],
    [
      "deny",
      "拒绝"
    ],
    [
      "anatomy",
      "解剖学"
    ],
    [
      "monaco",
      "摩納哥"
    ],
    [
      "belize",
      "貝里斯"
    ],
    [
      "crap",
      "屎"
    ],
    [
      "jungle",
      "丛林"
    ],
    [
      "prospect",
      "出发"
    ],
    [
      "shipment",
      "运输"
    ],
    [
      "trash",
      "垃圾桶"
    ],
    [
      "bulgarian",
      "保加利亚语"
    ],
    [
      "pig",
      "猪"
    ],
    [
      "minus",
      "减"
    ],
    [
      "armenia",
      "亞美尼亞"
    ],
    [
      "lit",
      "好玩"
    ],
    [
      "milan",
      "米蘭"
    ],
    [
      "shade",
      "四声"
    ],
    [
      "chorus",
      "副歌"
    ],
    [
      "rhythm",
      "節奏"
    ],
    [
      "digit",
      "手指"
    ],
    [
      "fountain",
      "泉"
    ],
    [
      "grave",
      "嚴重"
    ],
    [
      "burner",
      "光盘刻录器"
    ],
    [
      "finnish",
      "芬蘭語"
    ],
    [
      "gentle",
      "溫順"
    ],
    [
      "fog",
      "帆"
    ],
    [
      "characteristic",
      "特色"
    ],
    [
      "tunisia",
      "突尼斯"
    ],
    [
      "punch",
      "标"
    ],
    [
      "narrative",
      "故事"
    ],
    [
      "defeat",
      "无名指"
    ],
    [
      "tattoo",
      "纹身"
    ],
    [
      "shake",
      "滚音"
    ],
    [
      "algebra",
      "代数学"
    ],
    [
      "silly",
      "低能"
    ],
    [
      "nutritional",
      "营养"
    ],
    [
      "mild",
      "光"
    ],
    [
      "remedy",
      "治癒"
    ],
    [
      "thickness",
      "势"
    ],
    [
      "fighter",
      "战斗机"
    ],
    [
      "flesh",
      "皮肤"
    ],
    [
      "barely",
      "刚"
    ],
    [
      "wherever",
      "到处"
    ],
    [
      "rug",
      "毯子"
    ],
    [
      "marble",
      "大理石"
    ],
    [
      "microphone",
      "麦克风"
    ],
    [
      "shed",
      "倒"
    ],
    [
      "kazakhstan",
      "哈薩克斯坦"
    ],
    [
      "partition",
      "股"
    ],
    [
      "funk",
      "恐怖"
    ],
    [
      "magnet",
      "磁鐵"
    ],
    [
      "reel",
      "摇摇晃晃"
    ],
    [
      "sheer",
      "干净"
    ],
    [
      "commodity",
      "原料"
    ],
    [
      "cylinder",
      "圆柱"
    ],
    [
      "buck",
      "块"
    ],
    [
      "smell",
      "味道"
    ],
    [
      "sticker",
      "小棍"
    ],
    [
      "divide",
      "分水岭"
    ],
    [
      "peninsula",
      "半岛"
    ],
    [
      "nerve",
      "神經"
    ],
    [
      "floppy",
      "懶散"
    ],
    [
      "jar",
      "争吵"
    ],
    [
      "tent",
      "帐篷"
    ],
    [
      "caution",
      "謹慎"
    ],
    [
      "hawk",
      "猎鹰"
    ],
    [
      "lamb",
      "小羊"
    ],
    [
      "madagascar",
      "馬達加斯加"
    ],
    [
      "uzbekistan",
      "乌兹别克"
    ],
    [
      "albania",
      "阿爾巴尼亞"
    ],
    [
      "wicked",
      "合法的"
    ],
    [
      "junk",
      "物質"
    ],
    [
      "wax",
      "蠟"
    ],
    [
      "conspiracy",
      "阴谋"
    ],
    [
      "saturn",
      "土星"
    ],
    [
      "nut",
      "蛋"
    ],
    [
      "sake",
      "商品"
    ],
    [
      "arbitrary",
      "任性"
    ],
    [
      "retrieve",
      "记得"
    ],
    [
      "titanium",
      "鈦"
    ],
    [
      "shaft",
      "井"
    ],
    [
      "algeria",
      "阿爾及利亞"
    ],
    [
      "potato",
      "马铃薯"
    ],
    [
      "onion",
      "洋蔥"
    ],
    [
      "strand",
      "线"
    ],
    [
      "dash",
      "丟"
    ],
    [
      "lap",
      "圆圈"
    ],
    [
      "flux",
      "流"
    ],
    [
      "intersection",
      "交点"
    ],
    [
      "oman",
      "阿曼苏丹国"
    ],
    [
      "propose",
      "去"
    ],
    [
      "azerbaijan",
      "亚塞拜然"
    ],
    [
      "pavilion",
      "gânîmâ guo ren"
    ],
    [
      "pillow",
      "枕頭"
    ],
    [
      "steal",
      "偷窃"
    ],
    [
      "flavor",
      "味道"
    ],
    [
      "malawi",
      "馬拉維"
    ],
    [
      "marathon",
      "馬拉松"
    ],
    [
      "ant",
      "蚂蚁"
    ],
    [
      "proposition",
      "句"
    ],
    [
      "denial",
      "拒绝"
    ],
    [
      "gem",
      "珍珠"
    ],
    [
      "badge",
      "的"
    ],
    [
      "civilization",
      "文化"
    ],
    [
      "vietnamese",
      "越南語"
    ],
    [
      "elephant",
      "大象"
    ],
    [
      "yemen",
      "也門"
    ],
    [
      "tsunami",
      "海嘯"
    ],
    [
      "scholar",
      "书生"
    ],
    [
      "nickel",
      "镍"
    ],
    [
      "geology",
      "地質學"
    ],
    [
      "doom",
      "厄運"
    ],
    [
      "specially",
      "特意"
    ],
    [
      "bite",
      "买"
    ],
    [
      "reliance",
      "依赖性"
    ],
    [
      "myth",
      "神話"
    ],
    [
      "weed",
      "大麻"
    ],
    [
      "dock",
      "牛蒡"
    ],
    [
      "hint",
      "一点"
    ],
    [
      "remark",
      "看见"
    ],
    [
      "granny",
      "老女人"
    ],
    [
      "pork",
      "豬肉"
    ],
    [
      "aruba",
      "阿魯巴"
    ],
    [
      "fleece",
      "皮膚"
    ],
    [
      "fare",
      "走"
    ],
    [
      "dressing",
      "沙司"
    ],
    [
      "bald",
      "平滑"
    ],
    [
      "mold",
      "类型"
    ],
    [
      "whale",
      "鯨魚"
    ],
    [
      "idle",
      "惰"
    ],
    [
      "momentum",
      "衝力"
    ],
    [
      "io",
      "埃欧"
    ],
    [
      "mud",
      "泥巴"
    ],
    [
      "shark",
      "鲨鱼"
    ],
    [
      "emerald",
      "绿宝石"
    ],
    [
      "tract",
      "条约"
    ],
    [
      "garlic",
      "蒜"
    ],
    [
      "cove",
      "拱頂"
    ],
    [
      "vagina",
      "陰道"
    ],
    [
      "mongolia",
      "蒙古国"
    ],
    [
      "penguin",
      "企鵝"
    ],
    [
      "cubic",
      "常用"
    ],
    [
      "sapphire",
      "藍寶石"
    ],
    [
      "remainder",
      "找"
    ],
    [
      "elect",
      "選舉"
    ],
    [
      "intimate",
      "人的"
    ],
    [
      "flyer",
      "袋鼠"
    ],
    [
      "cameroon",
      "喀麥隆"
    ],
    [
      "token",
      "晶片"
    ],
    [
      "zinc",
      "鋅"
    ],
    [
      "anthropology",
      "人類學"
    ],
    [
      "tomato",
      "西红柿"
    ],
    [
      "declare",
      "報單"
    ],
    [
      "jewel",
      "石"
    ],
    [
      "nil",
      "零"
    ],
    [
      "stranger",
      "外国人"
    ],
    [
      "mattress",
      "床墊"
    ],
    [
      "likewise",
      "彼此"
    ],
    [
      "tooth",
      "牙齿"
    ],
    [
      "affair",
      "关系"
    ],
    [
      "washer",
      "墊片"
    ],
    [
      "ladder",
      "學"
    ],
    [
      "cork",
      "软木"
    ],
    [
      "mali",
      "馬里"
    ],
    [
      "likelihood",
      "相象"
    ],
    [
      "purse",
      "证券交易所"
    ],
    [
      "crest",
      "冠"
    ],
    [
      "heel",
      "跟"
    ],
    [
      "bloom",
      "帆"
    ],
    [
      "picnic",
      "小儿科"
    ],
    [
      "hollow",
      "耳聋"
    ],
    [
      "vault",
      "台"
    ],
    [
      "groove",
      "井"
    ],
    [
      "orbit",
      "带来"
    ],
    [
      "niger",
      "尼日尔河"
    ],
    [
      "cannon",
      "加农"
    ],
    [
      "spine",
      "刺"
    ],
    [
      "hunger",
      "渴望"
    ],
    [
      "surgeon",
      "外科醫生"
    ],
    [
      "aquarium",
      "[[#"
    ],
    [
      "bracket",
      "桌"
    ],
    [
      "absorption",
      "集中"
    ],
    [
      "persian",
      "波斯的"
    ],
    [
      "communist",
      "红色"
    ],
    [
      "grenada",
      "格林納達"
    ],
    [
      "scoop",
      "圆球"
    ],
    [
      "foul",
      "不好"
    ],
    [
      "mysterious",
      "不可思议的"
    ],
    [
      "librarian",
      "图书馆员"
    ],
    [
      "tamil",
      "泰米尔语"
    ],
    [
      "goat",
      "山羊"
    ],
    [
      "render",
      "交"
    ],
    [
      "dense",
      "粗"
    ],
    [
      "awful",
      "优秀"
    ],
    [
      "wu",
      "巫"
    ],
    [
      "bolt",
      "闩"
    ],
    [
      "urge",
      "坚持"
    ],
    [
      "replication",
      "复制"
    ],
    [
      "aluminium",
      "鋁"
    ],
    [
      "antarctica",
      "南極洲"
    ],
    [
      "lime",
      "萊檬"
    ],
    [
      "sympathy",
      "同情心"
    ],
    [
      "choir",
      "类"
    ],
    [
      "wit",
      "幽默"
    ],
    [
      "fibre",
      "纤维"
    ],
    [
      "prisoner",
      "犯人"
    ],
    [
      "crude",
      "明显"
    ],
    [
      "yarn",
      "索"
    ],
    [
      "mug",
      "梨"
    ],
    [
      "liechtenstein",
      "列支敦斯登"
    ],
    [
      "translator",
      "譯者"
    ],
    [
      "tractor",
      "拖拉機"
    ],
    [
      "continent",
      "洲"
    ],
    [
      "longitude",
      "经度"
    ],
    [
      "resist",
      "制止"
    ],
    [
      "pike",
      "狗鱼"
    ],
    [
      "stake",
      "参与"
    ],
    [
      "cocktail",
      "鸡尾酒"
    ],
    [
      "stitch",
      "绞痛"
    ],
    [
      "lesotho",
      "萊索托"
    ],
    [
      "racism",
      "種族主義"
    ],
    [
      "countryside",
      "國家"
    ],
    [
      "fatigue",
      "家務"
    ],
    [
      "owl",
      "鴞"
    ],
    [
      "coil",
      "线圈"
    ],
    [
      "bitter",
      "严格"
    ],
    [
      "burundi",
      "蒲隆地"
    ],
    [
      "twilight",
      "日落"
    ],
    [
      "linen",
      "服装"
    ],
    [
      "usher",
      "护卫"
    ],
    [
      "vanuatu",
      "瓦努阿圖"
    ],
    [
      "athlete",
      "运动员"
    ],
    [
      "bead",
      "帐"
    ],
    [
      "turnover",
      "换"
    ],
    [
      "ginger",
      "薑"
    ],
    [
      "chromosome",
      "染色體"
    ],
    [
      "rotten",
      "糟糕"
    ],
    [
      "habit",
      "制服"
    ],
    [
      "useless",
      "不中用的"
    ],
    [
      "bypass",
      "橋"
    ],
    [
      "shallow",
      "肤浅的"
    ],
    [
      "spike",
      "刺"
    ],
    [
      "drawer",
      "抽屜"
    ],
    [
      "pile",
      "楔子"
    ],
    [
      "humour",
      "汁"
    ],
    [
      "tonga",
      "東加"
    ],
    [
      "imprint",
      "印章"
    ],
    [
      "faithful",
      "仔細"
    ],
    [
      "libya",
      "利比亞"
    ],
    [
      "lithium",
      "鋰"
    ],
    [
      "caravan",
      "商队"
    ],
    [
      "liquor",
      "烈酒"
    ],
    [
      "kindergarten",
      "公园"
    ],
    [
      "derivative",
      "衍生性金融商品"
    ],
    [
      "prejudice",
      "损害"
    ],
    [
      "probable",
      "可能"
    ],
    [
      "adapt",
      "同化"
    ],
    [
      "carriage",
      "秉性"
    ],
    [
      "withdraw",
      "引退"
    ],
    [
      "landmark",
      "里程碑"
    ],
    [
      "neat",
      "乾淨"
    ],
    [
      "dentist",
      "牙科医生"
    ],
    [
      "raven",
      "烏鴉"
    ],
    [
      "venus",
      "维纳斯"
    ],
    [
      "bump",
      "球"
    ],
    [
      "demon",
      "惡魔"
    ],
    [
      "gabon",
      "加彭"
    ],
    [
      "aunt",
      "阿姨"
    ],
    [
      "crow",
      "烏鴉"
    ],
    [
      "caption",
      "字幕"
    ],
    [
      "rogue",
      "坏小孩"
    ],
    [
      "corridor",
      "走廊"
    ],
    [
      "vacant",
      "无表情"
    ],
    [
      "romanian",
      "罗马尼亚语"
    ],
    [
      "bust",
      "銷毀"
    ],
    [
      "breeze",
      "工作"
    ],
    [
      "gum",
      "橡皮"
    ],
    [
      "malaria",
      "瘧疾"
    ],
    [
      "dentistry",
      "牙科"
    ],
    [
      "embrace",
      "抱"
    ],
    [
      "foil",
      "花剑"
    ],
    [
      "skull",
      "顱骨"
    ],
    [
      "falcon",
      "獵鷹"
    ],
    [
      "tick",
      "秒"
    ],
    [
      "biochemistry",
      "生物化學"
    ],
    [
      "wheelchair",
      "轮椅"
    ],
    [
      "dominica",
      "多米尼加"
    ],
    [
      "cobra",
      "眼镜蛇"
    ],
    [
      "ao",
      "敖"
    ],
    [
      "marry",
      "打擊"
    ],
    [
      "drake",
      "母老虎"
    ],
    [
      "laurel",
      "月桂花环"
    ],
    [
      "cairo",
      "開羅"
    ],
    [
      "ukrainian",
      "乌克兰语"
    ],
    [
      "marginal",
      "平庸"
    ],
    [
      "pinnacle",
      "喙"
    ],
    [
      "palau",
      "帕劳"
    ],
    [
      "huh",
      "吗"
    ],
    [
      "accountant",
      "會計員"
    ],
    [
      "tome",
      "书"
    ],
    [
      "daylight",
      "一天"
    ],
    [
      "cousin",
      "親戚"
    ],
    [
      "torque",
      "丝绒饰环"
    ],
    [
      "prop",
      "螺旋"
    ],
    [
      "coupling",
      "依赖性"
    ],
    [
      "emerge",
      "出"
    ],
    [
      "shy",
      "小"
    ],
    [
      "rigid",
      "但是"
    ],
    [
      "baton",
      "小棍"
    ],
    [
      "umbrella",
      "伞"
    ],
    [
      "discourse",
      "会话"
    ],
    [
      "hex",
      "女巫"
    ],
    [
      "deed",
      "成绩"
    ],
    [
      "beacon",
      "燈塔"
    ],
    [
      "forensic",
      "修辞"
    ],
    [
      "pupil",
      "瞳"
    ],
    [
      "painter",
      "画家"
    ],
    [
      "banker",
      "河床"
    ],
    [
      "bamboo",
      "竹"
    ],
    [
      "blunt",
      "二百五"
    ],
    [
      "sketch",
      "勾划"
    ],
    [
      "mosaic",
      "馬賽克"
    ],
    [
      "hindi",
      "印地語"
    ],
    [
      "harsh",
      "严格"
    ],
    [
      "outfit",
      "队"
    ],
    [
      "paradigm",
      "例子"
    ],
    [
      "dignity",
      "行列"
    ],
    [
      "europa",
      "木卫二"
    ],
    [
      "homo",
      "均脂牛奶"
    ],
    [
      "pier",
      "牛"
    ],
    [
      "leverage",
      "利益"
    ],
    [
      "fender",
      "防御"
    ],
    [
      "rue",
      "同情"
    ],
    [
      "inheritance",
      "遺產"
    ],
    [
      "curry",
      "咖哩"
    ],
    [
      "pouch",
      "獎學金"
    ],
    [
      "pyramid",
      "棱锥"
    ],
    [
      "stripe",
      "加仑"
    ],
    [
      "fortunately",
      "僥倖"
    ],
    [
      "conductor",
      "导体"
    ],
    [
      "grandfather",
      "外公"
    ],
    [
      "potassium",
      "钾"
    ],
    [
      "shout",
      "叫"
    ],
    [
      "rationale",
      "道理"
    ],
    [
      "presidency",
      "任期"
    ],
    [
      "delicate",
      "容易"
    ],
    [
      "subway",
      "地铁"
    ],
    [
      "mankind",
      "男子"
    ],
    [
      "paramount",
      "首都"
    ],
    [
      "upright",
      "直腸"
    ],
    [
      "orchid",
      "兰"
    ],
    [
      "comoros",
      "科摩羅"
    ],
    [
      "peach",
      "桃"
    ],
    [
      "calculus",
      "石"
    ],
    [
      "duplex",
      "火焰"
    ],
    [
      "stove",
      "火炉"
    ],
    [
      "freak",
      "疯狂的"
    ],
    [
      "hatch",
      "孵化"
    ],
    [
      "goodness",
      "该死的，见鬼"
    ],
    [
      "autism",
      "自闭症"
    ],
    [
      "etiquette",
      "标签"
    ],
    [
      "pulp",
      "生麵團"
    ],
    [
      "onset",
      "攻击"
    ],
    [
      "plaque",
      "斑块"
    ],
    [
      "crib",
      "槽"
    ],
    [
      "autonomous",
      "獨立"
    ],
    [
      "noun",
      "名词"
    ],
    [
      "swallow",
      "燕科"
    ],
    [
      "lighthouse",
      "燈塔"
    ],
    [
      "technically",
      "法律上"
    ],
    [
      "correspond",
      "写"
    ],
    [
      "straightforward",
      "直接"
    ],
    [
      "peel",
      "铁铲"
    ],
    [
      "debris",
      "墟"
    ],
    [
      "han",
      "汉族"
    ],
    [
      "peg",
      "主題"
    ],
    [
      "sovereign",
      "国主"
    ],
    [
      "drought",
      "干旱"
    ],
    [
      "vicinity",
      "周围"
    ],
    [
      "heal",
      "(使)愈合, 治愈"
    ],
    [
      "tote",
      "加"
    ],
    [
      "charcoal",
      "石炭"
    ],
    [
      "goose",
      "鵝"
    ],
    [
      "cascade",
      "人工​阶梯形​瀑布"
    ],
    [
      "hen",
      "母雞"
    ],
    [
      "verb",
      "動詞"
    ],
    [
      "vest",
      "恤衫"
    ],
    [
      "litter",
      "垃圾"
    ],
    [
      "rugged",
      "难"
    ],
    [
      "jelly",
      "果酱"
    ],
    [
      "accelerator",
      "催化剂"
    ],
    [
      "fringe",
      "剧场"
    ],
    [
      "tungsten",
      "鎢"
    ],
    [
      "rude",
      "黄色"
    ],
    [
      "hassle",
      "争吵"
    ],
    [
      "unemployed",
      "失业"
    ],
    [
      "curl",
      "词形变化"
    ],
    [
      "albanian",
      "阿尔巴尼亚人"
    ],
    [
      "implicit",
      "內含"
    ],
    [
      "congregation",
      "共同体"
    ],
    [
      "inequality",
      "不等式"
    ],
    [
      "rust",
      "锈"
    ],
    [
      "wardrobe",
      "行頭"
    ],
    [
      "guilt",
      "內疚"
    ],
    [
      "sweep",
      "三角鋼琴"
    ],
    [
      "bladder",
      "氣囊"
    ],
    [
      "revival",
      "闹钟"
    ],
    [
      "bark",
      "壳"
    ],
    [
      "cocoa",
      "巧克力"
    ],
    [
      "cushion",
      "桌"
    ],
    [
      "stain",
      "颜料"
    ],
    [
      "transient",
      "矮"
    ],
    [
      "trivial",
      "平凡"
    ],
    [
      "sensible",
      "导音"
    ],
    [
      "thrust",
      "印刷"
    ],
    [
      "prod",
      "戳"
    ],
    [
      "cane",
      "手杖"
    ],
    [
      "stiff",
      "刻板的"
    ],
    [
      "sushi",
      "寿司"
    ],
    [
      "stark",
      "急"
    ],
    [
      "uranium",
      "铀"
    ],
    [
      "homosexual",
      "同性戀的"
    ],
    [
      "cerebral",
      "知识"
    ],
    [
      "montserrat",
      "蒙特塞拉"
    ],
    [
      "plea",
      "防御"
    ],
    [
      "esther",
      "以斯帖记"
    ],
    [
      "zodiac",
      "黃道帶"
    ],
    [
      "artery",
      "动脉"
    ],
    [
      "lick",
      "打败"
    ],
    [
      "canopy",
      "侯爵"
    ],
    [
      "panda",
      "熊猫"
    ],
    [
      "interchange",
      "路口"
    ],
    [
      "tuvalu",
      "图瓦卢"
    ],
    [
      "dynasty",
      "王朝"
    ],
    [
      "volatile",
      "一触即发 一觸卽發"
    ],
    [
      "throne",
      "宝座"
    ],
    [
      "magnesium",
      "镁"
    ],
    [
      "tibetan",
      "藏語"
    ],
    [
      "bout",
      "打"
    ],
    [
      "sensation",
      "感觉"
    ],
    [
      "shortcut",
      "縮寫"
    ],
    [
      "sunlight",
      "光"
    ],
    [
      "convey",
      "交"
    ],
    [
      "feather",
      "羽"
    ],
    [
      "fiat",
      "批准"
    ],
    [
      "successor",
      "繼承人"
    ],
    [
      "underneath",
      "武士"
    ],
    [
      "prosecutor",
      "公诉人"
    ],
    [
      "notch",
      "块"
    ],
    [
      "seoul",
      "首爾"
    ],
    [
      "casualty",
      "受害人"
    ],
    [
      "scent",
      "嗅覺"
    ],
    [
      "knob",
      "结"
    ],
    [
      "grasp",
      "了解"
    ],
    [
      "happily",
      "乐意"
    ],
    [
      "stance",
      "态度"
    ],
    [
      "exodus",
      "出埃及记"
    ],
    [
      "dove",
      "鸽子"
    ],
    [
      "derive",
      "使分流"
    ],
    [
      "flint",
      "石"
    ],
    [
      "dummy",
      "死了"
    ],
    [
      "croatian",
      "克羅地亞語"
    ],
    [
      "proton",
      "质子"
    ],
    [
      "studs",
      "轮胎"
    ],
    [
      "incubus",
      "十字"
    ],
    [
      "roast",
      "火"
    ],
    [
      "reciprocal",
      "倒"
    ],
    [
      "behave",
      "留"
    ],
    [
      "shiny",
      "明"
    ],
    [
      "smash",
      "犁"
    ],
    [
      "obscure",
      "无形"
    ],
    [
      "beard",
      "鬍子"
    ],
    [
      "wedge",
      "出生"
    ],
    [
      "gamer",
      "球员"
    ],
    [
      "fortunate",
      "快乐"
    ],
    [
      "cinnamon",
      "桂皮"
    ],
    [
      "underworld",
      "无底洞"
    ],
    [
      "lattice",
      "网"
    ],
    [
      "dong",
      "屌"
    ],
    [
      "chord",
      "弦"
    ],
    [
      "turf",
      "泥炭"
    ],
    [
      "asphalt",
      "柏油"
    ],
    [
      "lust",
      "意志"
    ],
    [
      "amplitude",
      "振幅"
    ],
    [
      "singular",
      "单数"
    ],
    [
      "outbreak",
      "爆炸"
    ],
    [
      "consume",
      "吃"
    ],
    [
      "skeleton",
      "骨骼系統"
    ],
    [
      "candid",
      "真心"
    ],
    [
      "microscope",
      "顯微鏡"
    ],
    [
      "kitten",
      "小狐狸"
    ],
    [
      "cavity",
      "龋齿"
    ],
    [
      "dough",
      "意大利麵"
    ],
    [
      "stool",
      "几"
    ],
    [
      "millionaire",
      "百萬富翁"
    ],
    [
      "glacier",
      "冰河"
    ],
    [
      "lame",
      "差"
    ],
    [
      "feng",
      "灃水"
    ],
    [
      "farewell",
      "告别"
    ],
    [
      "locus",
      "地方"
    ],
    [
      "cellar",
      "尾巴"
    ],
    [
      "fuse",
      "繩子"
    ],
    [
      "furnace",
      "汽锅"
    ],
    [
      "gut",
      "肚子"
    ],
    [
      "evolve",
      "进步"
    ],
    [
      "lump",
      "块"
    ],
    [
      "halt",
      "停住"
    ],
    [
      "substantive",
      "料"
    ],
    [
      "spear",
      "魚叉"
    ],
    [
      "birch",
      "樺樹"
    ],
    [
      "slash",
      "斜线"
    ],
    [
      "isaiah",
      "以赛亚书"
    ],
    [
      "sausage",
      "香腸"
    ],
    [
      "zebra",
      "斑馬"
    ],
    [
      "fetch",
      "创作"
    ],
    [
      "diagonal",
      "對角線"
    ],
    [
      "mortal",
      "不共戴天"
    ],
    [
      "sovereignty",
      "主權"
    ],
    [
      "gown",
      "连衣裙"
    ],
    [
      "archery",
      "射技"
    ],
    [
      "sabbath",
      "主麻"
    ],
    [
      "tow",
      "索"
    ],
    [
      "deliberately",
      "认真"
    ],
    [
      "crawl",
      "爬行"
    ],
    [
      "serbian",
      "塞尔维亚人"
    ],
    [
      "alteration",
      "换"
    ],
    [
      "tuna",
      "鮪"
    ],
    [
      "depths",
      "勇气"
    ],
    [
      "squadron",
      "聯隊"
    ],
    [
      "intercourse",
      "性"
    ],
    [
      "kite",
      "鸢"
    ],
    [
      "heap",
      "电池"
    ],
    [
      "lao",
      "老挝语"
    ],
    [
      "disturbance",
      "阻礙"
    ],
    [
      "jaw",
      "嚼子"
    ],
    [
      "hail",
      "雹"
    ],
    [
      "genocide",
      "種族滅絕"
    ],
    [
      "snoop",
      "貂"
    ],
    [
      "contingency",
      "中立國"
    ],
    [
      "herd",
      "牧师"
    ],
    [
      "abandon",
      "出去"
    ],
    [
      "jerk",
      "笨蛋"
    ],
    [
      "hitch",
      "問題"
    ],
    [
      "nexus",
      "中心"
    ],
    [
      "tango",
      "探戈舞"
    ],
    [
      "buster",
      "伴侶"
    ],
    [
      "flap",
      "帽邊"
    ],
    [
      "sorrow",
      "疼痛"
    ],
    [
      "ferdinand",
      "費迪南"
    ],
    [
      "pigeon",
      "鸽子"
    ],
    [
      "parrot",
      "鸚鵡"
    ],
    [
      "cheek",
      "臂"
    ],
    [
      "solicitor",
      "律师"
    ],
    [
      "nib",
      "吹口"
    ],
    [
      "riot",
      "暴动"
    ],
    [
      "susceptible",
      "敏锐的"
    ],
    [
      "perimeter",
      "周长"
    ],
    [
      "grim",
      "悲伤"
    ],
    [
      "toss",
      "丟"
    ],
    [
      "cobalt",
      "钴"
    ],
    [
      "pity",
      "可惜"
    ],
    [
      "woke",
      "政治正确"
    ],
    [
      "lithuanian",
      "立陶宛語"
    ],
    [
      "imperative",
      "祈使語氣"
    ],
    [
      "beg",
      "请"
    ],
    [
      "whistle",
      "吹口哨"
    ],
    [
      "disruption",
      "混亂"
    ],
    [
      "bro",
      "哥"
    ],
    [
      "faint",
      "酸软"
    ],
    [
      "collaborate",
      "协作"
    ],
    [
      "fraternity",
      "共同体"
    ],
    [
      "tapestry",
      "马赛克"
    ],
    [
      "harp",
      "豎琴"
    ],
    [
      "anthem",
      "圣歌"
    ],
    [
      "tack",
      "瓶頸"
    ],
    [
      "sack",
      "床"
    ],
    [
      "sudoku",
      "數獨"
    ],
    [
      "paradox",
      "悖论"
    ],
    [
      "jackpot",
      "胖"
    ],
    [
      "georgian",
      "格鲁吉亚人"
    ],
    [
      "estonian",
      "愛沙尼亞語"
    ],
    [
      "fraudulent",
      "假"
    ],
    [
      "forgiveness",
      "气量"
    ],
    [
      "almond",
      "杏仁"
    ],
    [
      "puppet",
      "懸絲傀儡"
    ],
    [
      "pillar",
      "本"
    ],
    [
      "mirage",
      "海市蜃樓"
    ],
    [
      "precinct",
      "区"
    ],
    [
      "negro",
      "黑"
    ],
    [
      "righteous",
      "正义"
    ],
    [
      "scissors",
      "剪子"
    ],
    [
      "pluto",
      "普路托"
    ],
    [
      "wreck",
      "残骸"
    ],
    [
      "dismiss",
      "撤回"
    ],
    [
      "stag",
      "牛"
    ],
    [
      "chimney",
      "烟囱"
    ],
    [
      "sherry",
      "杯子"
    ],
    [
      "tulip",
      "鬱金香"
    ],
    [
      "remuneration",
      "补偿"
    ],
    [
      "homosexuality",
      "同性戀"
    ],
    [
      "carbohydrate",
      "糖类"
    ],
    [
      "rag",
      "日报"
    ],
    [
      "absorb",
      "吸入"
    ],
    [
      "ditch",
      "翘课"
    ],
    [
      "chunk",
      "破片"
    ],
    [
      "scrub",
      "取消"
    ],
    [
      "limb",
      "枝"
    ],
    [
      "authoritative",
      "中指"
    ],
    [
      "celestial",
      "天蓝色"
    ],
    [
      "immense",
      "精彩"
    ],
    [
      "seizure",
      "袭击"
    ],
    [
      "stuttgart",
      "斯圖加特"
    ],
    [
      "dart",
      "钳子"
    ],
    [
      "multitude",
      "人民"
    ],
    [
      "bootstrap",
      "引导程序"
    ],
    [
      "affection",
      "病"
    ],
    [
      "vicious",
      "刻毒"
    ],
    [
      "paddle",
      "活门"
    ],
    [
      "foolish",
      "傻子"
    ],
    [
      "nausea",
      "子囊"
    ],
    [
      "dire",
      "可怕"
    ],
    [
      "grinder",
      "磨子"
    ],
    [
      "sneak",
      "掩藏"
    ],
    [
      "crust",
      "地殼"
    ],
    [
      "pissed",
      "酸"
    ],
    [
      "constituent",
      "件"
    ],
    [
      "aura",
      "气场"
    ],
    [
      "sponge",
      "海綿"
    ],
    [
      "buff",
      "吸引人的"
    ],
    [
      "psalms",
      "诗篇"
    ],
    [
      "orb",
      "球"
    ],
    [
      "scion",
      "米"
    ],
    [
      "cabbage",
      "包心菜"
    ],
    [
      "cub",
      "小狐狸"
    ],
    [
      "jealous",
      "妒忌"
    ],
    [
      "squirrel",
      "栗鼠"
    ],
    [
      "pronunciation",
      "發音"
    ],
    [
      "pelican",
      "鵜鶘"
    ],
    [
      "spindle",
      "蜘蛛"
    ],
    [
      "flare",
      "兰特"
    ],
    [
      "nod",
      "打瞌睡"
    ],
    [
      "crank",
      "原始的"
    ],
    [
      "stub",
      "草稿"
    ],
    [
      "brace",
      "部"
    ],
    [
      "perennial",
      "多年生"
    ],
    [
      "lipstick",
      "口紅"
    ],
    [
      "steer",
      "硬"
    ],
    [
      "spaghetti",
      "迷宮"
    ],
    [
      "confession",
      "自白"
    ],
    [
      "communism",
      "共產主義"
    ],
    [
      "bounty",
      "奖金"
    ],
    [
      "motive",
      "動機"
    ],
    [
      "fingerprint",
      "指印"
    ],
    [
      "audition",
      "听觉"
    ],
    [
      "rye",
      "黑麦"
    ],
    [
      "bodybuilding",
      "車體風格"
    ],
    [
      "stall",
      "摊位"
    ],
    [
      "lad",
      "仔"
    ],
    [
      "hostage",
      "人質"
    ],
    [
      "contention",
      "位置"
    ],
    [
      "haze",
      "帆"
    ],
    [
      "pinch",
      "偷"
    ],
    [
      "chopper",
      "屌"
    ],
    [
      "latvian",
      "拉脫維亞語"
    ],
    [
      "hem",
      "兰特"
    ],
    [
      "shady",
      "鬼祟"
    ],
    [
      "blizzard",
      "山"
    ],
    [
      "valet",
      "杰克"
    ],
    [
      "mortar",
      "研缽"
    ],
    [
      "posture",
      "姿勢"
    ],
    [
      "jonah",
      "约拿书"
    ],
    [
      "scar",
      "伤痕"
    ],
    [
      "emu",
      "鸸鹋"
    ],
    [
      "tease",
      "戏弄"
    ],
    [
      "rowan",
      "花楸属"
    ],
    [
      "awkward",
      "不愉快"
    ],
    [
      "stair",
      "楼梯"
    ],
    [
      "prescribe",
      "听写"
    ],
    [
      "bleed",
      "血液"
    ],
    [
      "caucasian",
      "白人"
    ],
    [
      "ancestor",
      "字源"
    ],
    [
      "dab",
      "滴"
    ],
    [
      "custodian",
      "守门人"
    ],
    [
      "helm",
      "舵工"
    ],
    [
      "kennel",
      "狗窝"
    ],
    [
      "differentiate",
      "使分流"
    ],
    [
      "gorge",
      "咽喉"
    ],
    [
      "opaque",
      "鈍"
    ],
    [
      "stout",
      "稳定"
    ],
    [
      "concierge",
      "守门人"
    ],
    [
      "endure",
      "制止"
    ],
    [
      "repetition",
      "重複"
    ],
    [
      "flair",
      "风格"
    ],
    [
      "aisle",
      "甬道"
    ],
    [
      "cucumber",
      "黃瓜"
    ],
    [
      "seize",
      "没收"
    ],
    [
      "spawn",
      "出版"
    ],
    [
      "bogus",
      "丑"
    ],
    [
      "diode",
      "二極管"
    ],
    [
      "magician",
      "巫師"
    ],
    [
      "indulgence",
      "兴趣"
    ],
    [
      "puff",
      "大麻"
    ],
    [
      "staple",
      "原料"
    ],
    [
      "conservatory",
      "音乐学校"
    ],
    [
      "claw",
      "爪"
    ],
    [
      "writ",
      "字"
    ],
    [
      "ether",
      "醚"
    ],
    [
      "rumble",
      "住"
    ],
    [
      "lore",
      "传说"
    ],
    [
      "pointless",
      "无关的"
    ],
    [
      "anemia",
      "貧血"
    ],
    [
      "nuisance",
      "烦扰"
    ],
    [
      "nephew",
      "外甥"
    ],
    [
      "drip",
      "獎學金"
    ],
    [
      "outright",
      "一定"
    ],
    [
      "conduit",
      "运河"
    ],
    [
      "lexicon",
      "词典"
    ],
    [
      "mop",
      "鬼脸"
    ],
    [
      "maltese",
      "馬爾他語"
    ],
    [
      "acorn",
      "栓皮櫟"
    ],
    [
      "ply",
      "交通"
    ],
    [
      "plaster",
      "粉筆"
    ],
    [
      "kiosk",
      "便利商店"
    ],
    [
      "poppy",
      "罌粟"
    ],
    [
      "jargon",
      "行话"
    ],
    [
      "basque",
      "巴斯克語"
    ],
    [
      "daring",
      "勇敢"
    ],
    [
      "reap",
      "汤匙"
    ],
    [
      "hanoi",
      "河內"
    ],
    [
      "caliber",
      "价值"
    ],
    [
      "icelandic",
      "冰島語"
    ],
    [
      "kurdish",
      "庫爾德語"
    ],
    [
      "latch",
      "触发器"
    ],
    [
      "chatter",
      "呼噜"
    ],
    [
      "tidy",
      "好"
    ],
    [
      "sweetheart",
      "爱人"
    ],
    [
      "cultivated",
      "被耕种的"
    ],
    [
      "stuffing",
      "餡料"
    ],
    [
      "casserole",
      "鍋"
    ],
    [
      "corsair",
      "私掠"
    ],
    [
      "hinge",
      "铰链"
    ],
    [
      "micah",
      "彌迦書"
    ],
    [
      "homicide",
      "兇手"
    ],
    [
      "pandemic",
      "大流行病"
    ],
    [
      "crooked",
      "不誠實"
    ],
    [
      "forehead",
      "前额"
    ],
    [
      "nationalism",
      "民族主義"
    ],
    [
      "digestion",
      "腐朽"
    ],
    [
      "biscuit",
      "饼干"
    ],
    [
      "cheerful",
      "明"
    ],
    [
      "blush",
      "胭脂"
    ],
    [
      "favourable",
      "便宜"
    ],
    [
      "malay",
      "馬來語"
    ],
    [
      "temper",
      "回火"
    ],
    [
      "trench",
      "壕"
    ],
    [
      "practise",
      "練習"
    ],
    [
      "mammalian",
      "哺乳动物的"
    ],
    [
      "meteorology",
      "氣象學"
    ],
    [
      "pristine",
      "原始的"
    ],
    [
      "catalan",
      "加泰罗尼亚语"
    ],
    [
      "augustus",
      "八月"
    ],
    [
      "obscene",
      "黄色"
    ],
    [
      "tummy",
      "骗子"
    ],
    [
      "epoch",
      "稀有"
    ],
    [
      "resistor",
      "电阻器"
    ],
    [
      "batter",
      "击球员"
    ],
    [
      "tread",
      "圖畫"
    ],
    [
      "burr",
      "刺猬"
    ],
    [
      "recess",
      "全休止符"
    ],
    [
      "crocodile",
      "鳄鱼"
    ],
    [
      "dresser",
      "多屉柜 多屜櫃"
    ],
    [
      "rake",
      "顱骨"
    ],
    [
      "resign",
      "辞职"
    ],
    [
      "intervene",
      "发生"
    ],
    [
      "handwriting",
      "字"
    ],
    [
      "flamingo",
      "火烈鸟"
    ],
    [
      "weary",
      "困"
    ],
    [
      "solitary",
      "一"
    ],
    [
      "guts",
      "胆"
    ],
    [
      "bullock",
      "牛"
    ],
    [
      "sire",
      "公马"
    ],
    [
      "bland",
      "淡"
    ],
    [
      "hummingbird",
      "蜂鳥"
    ],
    [
      "loaf",
      "面包(Simplificado)"
    ],
    [
      "enigma",
      "谜"
    ],
    [
      "inferno",
      "地獄"
    ],
    [
      "kudos",
      "声望"
    ],
    [
      "outrage",
      "义愤"
    ],
    [
      "artifact",
      "干涉"
    ],
    [
      "elusive",
      "难"
    ],
    [
      "curt",
      "短"
    ],
    [
      "demise",
      "死"
    ],
    [
      "ado",
      "乾草"
    ],
    [
      "graft",
      "股"
    ],
    [
      "mash",
      "坠毁"
    ],
    [
      "abort",
      "中止"
    ],
    [
      "pip",
      "色"
    ],
    [
      "paisley",
      "變形蟲花布"
    ],
    [
      "flange",
      "兰特"
    ],
    [
      "wrinkle",
      "問題"
    ],
    [
      "hearth",
      "一月"
    ],
    [
      "catastrophe",
      "灾害"
    ],
    [
      "acknowledgment",
      "谢谢"
    ],
    [
      "labyrinth",
      "迷宮"
    ],
    [
      "presumption",
      "推斷"
    ],
    [
      "incubation",
      "潜伏"
    ],
    [
      "defiance",
      "挑战"
    ],
    [
      "bum",
      "流浪汉"
    ],
    [
      "typewriter",
      "打字機"
    ],
    [
      "bosnian",
      "波斯尼亚语"
    ],
    [
      "sucker",
      "白痴"
    ],
    [
      "dope",
      "物質"
    ],
    [
      "unification",
      "合并"
    ],
    [
      "slough",
      "痂"
    ],
    [
      "prodigy",
      "前兆"
    ],
    [
      "cantonese",
      "粵語"
    ],
    [
      "bookseller",
      "书局"
    ],
    [
      "fuss",
      "剧场"
    ],
    [
      "platter",
      "托盘"
    ],
    [
      "disguise",
      "掩藏"
    ],
    [
      "incidentally",
      "对了"
    ],
    [
      "choke",
      "鶇"
    ],
    [
      "roar",
      "笑"
    ],
    [
      "gall",
      "扣子"
    ],
    [
      "inherit",
      "继承"
    ],
    [
      "translucent",
      "亮"
    ],
    [
      "glaze",
      "雾凇"
    ],
    [
      "scorpion",
      "蝎子"
    ],
    [
      "verge",
      "路肩"
    ],
    [
      "turntable",
      "铂"
    ],
    [
      "deuteronomy",
      "申命记"
    ],
    [
      "sissy",
      "老婆当家的"
    ],
    [
      "prosperous",
      "便宜"
    ],
    [
      "trough",
      "比"
    ],
    [
      "jig",
      "模型"
    ],
    [
      "reckless",
      "鲁莽"
    ],
    [
      "peasant",
      "农民"
    ],
    [
      "typhoon",
      "台风"
    ],
    [
      "mongolian",
      "蒙古語"
    ],
    [
      "screwdriver",
      "螺絲刀"
    ],
    [
      "apricot",
      "杏"
    ],
    [
      "sakura",
      "櫻桃樹"
    ],
    [
      "hedgehog",
      "蝟"
    ],
    [
      "folly",
      "疯狂"
    ],
    [
      "wager",
      "单位"
    ],
    [
      "tundra",
      "苔原"
    ],
    [
      "deem",
      "找到"
    ],
    [
      "cavern",
      "洞穴"
    ],
    [
      "tart",
      "尖"
    ],
    [
      "stump",
      "擦笔"
    ],
    [
      "melon",
      "香瓜"
    ],
    [
      "manganese",
      "锰"
    ],
    [
      "siren",
      "塞壬"
    ],
    [
      "summons",
      "传票"
    ],
    [
      "thirst",
      "渴"
    ],
    [
      "yiddish",
      "意第緒語"
    ],
    [
      "baba",
      "父"
    ],
    [
      "grub",
      "幼虫"
    ],
    [
      "atrium",
      "海岬"
    ],
    [
      "wreath",
      "花冠"
    ],
    [
      "prussia",
      "普鲁士"
    ],
    [
      "grapefruit",
      "西柚"
    ],
    [
      "snare",
      "小鼓"
    ],
    [
      "shank",
      "腿"
    ],
    [
      "tong",
      "人字拖"
    ],
    [
      "dissolve",
      "解散"
    ],
    [
      "muck",
      "堆肥"
    ],
    [
      "cadmium",
      "镉"
    ],
    [
      "leviticus",
      "利未记"
    ],
    [
      "grapevine",
      "以訛傳訛"
    ],
    [
      "synagogue",
      "犹太教堂"
    ],
    [
      "breton",
      "布列塔尼語"
    ],
    [
      "grit",
      "勇氣"
    ],
    [
      "quail",
      "鵪鶉"
    ],
    [
      "conceive",
      "了解"
    ],
    [
      "plume",
      "云"
    ],
    [
      "enact",
      "陈述"
    ],
    [
      "manly",
      "男子氣"
    ],
    [
      "afrikaans",
      "南非语"
    ],
    [
      "offend",
      "冒犯"
    ],
    [
      "caviar",
      "鱼子酱"
    ],
    [
      "mammal",
      "哺乳类"
    ],
    [
      "chameleon",
      "變色龍"
    ],
    [
      "embarrassment",
      "丢脸的事"
    ],
    [
      "calligraphy",
      "书法"
    ],
    [
      "palladium",
      "鈀"
    ],
    [
      "hobo",
      "季节性的"
    ],
    [
      "tranquil",
      "安静"
    ],
    [
      "distraction",
      "疯狂"
    ],
    [
      "disturb",
      "扰乱"
    ],
    [
      "criticize",
      "衡量"
    ],
    [
      "jealousy",
      "嫉妒"
    ],
    [
      "sag",
      "沉下"
    ],
    [
      "twat",
      "傻子"
    ],
    [
      "filibuster",
      "冗長辯論"
    ],
    [
      "accordion",
      "手風琴"
    ],
    [
      "reindeer",
      "馴鹿"
    ],
    [
      "brute",
      "动物"
    ],
    [
      "diaphragm",
      "横膈膜"
    ],
    [
      "blackout",
      "白"
    ],
    [
      "esperanto",
      "世界語"
    ],
    [
      "withhold",
      "保持"
    ],
    [
      "salty",
      "恨"
    ],
    [
      "boon",
      "天才"
    ],
    [
      "pawn",
      "质权"
    ],
    [
      "spleen",
      "脾臟"
    ],
    [
      "abduction",
      "勒索"
    ],
    [
      "mimic",
      "学"
    ],
    [
      "fascism",
      "法西斯主義"
    ],
    [
      "setter",
      "二傳手 二传手"
    ],
    [
      "facade",
      "國境"
    ],
    [
      "adore",
      "爱"
    ],
    [
      "womb",
      "乳房"
    ],
    [
      "stomp",
      "扑灭"
    ],
    [
      "nehemiah",
      "尼希米记"
    ],
    [
      "rattle",
      "温和的责备"
    ],
    [
      "oatmeal",
      "燕麥"
    ],
    [
      "outsider",
      "初学者"
    ],
    [
      "hydrocarbon",
      "烴"
    ],
    [
      "ledge",
      "壁帶"
    ],
    [
      "abyss",
      "深淵"
    ],
    [
      "malachi",
      "瑪拉基書"
    ],
    [
      "flask",
      "小瓶"
    ],
    [
      "procession",
      "鎖鏈 [suǒliàn]"
    ],
    [
      "assimilation",
      "同化"
    ],
    [
      "conveyance",
      "交通方式"
    ],
    [
      "mundane",
      "一般"
    ],
    [
      "smut",
      "煤"
    ],
    [
      "barren",
      "荒芜"
    ],
    [
      "condensation",
      "脱水"
    ],
    [
      "roundabout",
      "旋轉木馬"
    ],
    [
      "archipelago",
      "群岛"
    ],
    [
      "kitchener",
      "基秦拿"
    ],
    [
      "argent",
      "银币"
    ]
  ]
};
export const WIKDICT_CHUNK_METADATA_BY_LANGUAGE = {
  "de": {
    "totalPairCount": 18464,
    "preloadedPairCount": 2500,
    "extraChunkCount": 7,
    "extraChunkPaths": [
      "/data/wikdict-chunks/de/chunk-1.json",
      "/data/wikdict-chunks/de/chunk-2.json",
      "/data/wikdict-chunks/de/chunk-3.json",
      "/data/wikdict-chunks/de/chunk-4.json",
      "/data/wikdict-chunks/de/chunk-5.json",
      "/data/wikdict-chunks/de/chunk-6.json",
      "/data/wikdict-chunks/de/chunk-7.json"
    ]
  },
  "es": {
    "totalPairCount": 14942,
    "preloadedPairCount": 2500,
    "extraChunkCount": 5,
    "extraChunkPaths": [
      "/data/wikdict-chunks/es/chunk-1.json",
      "/data/wikdict-chunks/es/chunk-2.json",
      "/data/wikdict-chunks/es/chunk-3.json",
      "/data/wikdict-chunks/es/chunk-4.json",
      "/data/wikdict-chunks/es/chunk-5.json"
    ]
  },
  "fr": {
    "totalPairCount": 12676,
    "preloadedPairCount": 2500,
    "extraChunkCount": 5,
    "extraChunkPaths": [
      "/data/wikdict-chunks/fr/chunk-1.json",
      "/data/wikdict-chunks/fr/chunk-2.json",
      "/data/wikdict-chunks/fr/chunk-3.json",
      "/data/wikdict-chunks/fr/chunk-4.json",
      "/data/wikdict-chunks/fr/chunk-5.json"
    ]
  },
  "it": {
    "totalPairCount": 10572,
    "preloadedPairCount": 2500,
    "extraChunkCount": 4,
    "extraChunkPaths": [
      "/data/wikdict-chunks/it/chunk-1.json",
      "/data/wikdict-chunks/it/chunk-2.json",
      "/data/wikdict-chunks/it/chunk-3.json",
      "/data/wikdict-chunks/it/chunk-4.json"
    ]
  },
  "ja": {
    "totalPairCount": 9920,
    "preloadedPairCount": 2500,
    "extraChunkCount": 3,
    "extraChunkPaths": [
      "/data/wikdict-chunks/ja/chunk-1.json",
      "/data/wikdict-chunks/ja/chunk-2.json",
      "/data/wikdict-chunks/ja/chunk-3.json"
    ]
  },
  "nl": {
    "totalPairCount": 10625,
    "preloadedPairCount": 2500,
    "extraChunkCount": 4,
    "extraChunkPaths": [
      "/data/wikdict-chunks/nl/chunk-1.json",
      "/data/wikdict-chunks/nl/chunk-2.json",
      "/data/wikdict-chunks/nl/chunk-3.json",
      "/data/wikdict-chunks/nl/chunk-4.json"
    ]
  },
  "pt": {
    "totalPairCount": 11388,
    "preloadedPairCount": 2500,
    "extraChunkCount": 4,
    "extraChunkPaths": [
      "/data/wikdict-chunks/pt/chunk-1.json",
      "/data/wikdict-chunks/pt/chunk-2.json",
      "/data/wikdict-chunks/pt/chunk-3.json",
      "/data/wikdict-chunks/pt/chunk-4.json"
    ]
  },
  "ru": {
    "totalPairCount": 20691,
    "preloadedPairCount": 2500,
    "extraChunkCount": 8,
    "extraChunkPaths": [
      "/data/wikdict-chunks/ru/chunk-1.json",
      "/data/wikdict-chunks/ru/chunk-2.json",
      "/data/wikdict-chunks/ru/chunk-3.json",
      "/data/wikdict-chunks/ru/chunk-4.json",
      "/data/wikdict-chunks/ru/chunk-5.json",
      "/data/wikdict-chunks/ru/chunk-6.json",
      "/data/wikdict-chunks/ru/chunk-7.json",
      "/data/wikdict-chunks/ru/chunk-8.json"
    ]
  },
  "tr": {
    "totalPairCount": 6766,
    "preloadedPairCount": 2500,
    "extraChunkCount": 2,
    "extraChunkPaths": [
      "/data/wikdict-chunks/tr/chunk-1.json",
      "/data/wikdict-chunks/tr/chunk-2.json"
    ]
  },
  "zh": {
    "totalPairCount": 3142,
    "preloadedPairCount": 2500,
    "extraChunkCount": 1,
    "extraChunkPaths": [
      "/data/wikdict-chunks/zh/chunk-1.json"
    ]
  }
};
